"use strict";

function _interopDefault(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var React = require("react"),
    React__default = _interopDefault(React),
    styled = require("styled-components"),
    styled__default = _interopDefault(styled),
    PropTypes = _interopDefault(require("prop-types")),
    ReactDOM = require("react-dom"),
    ReactDOM__default = _interopDefault(ReactDOM),
    _extends = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Add = function Add(e) {
  e.styles;

  var t = _objectWithoutProperties(e, ["styles"]);

  return React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.8 36.8"
  }, t), React__default.createElement("path", {
    d: "M18.4 36.8C8.2 36.8 0 28.5 0 18.4S8.2 0 18.4 0s18.4 8.2 18.4 18.4c-.1 10.1-8.3 18.3-18.4 18.4zm0-33.8C9.9 3 3 9.9 3 18.4s6.9 15.4 15.4 15.4 15.4-6.9 15.4-15.4C33.7 9.9 26.9 3 18.4 3z"
  }), React__default.createElement("path", {
    d: "M18.5 27.1c-.8 0-1.5-.7-1.5-1.5V11c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v14.6c0 .8-.7 1.5-1.5 1.5z"
  }), React__default.createElement("path", {
    d: "M25.8 19.8H11.1c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h14.6c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.4 1.5z"
  }));
},
    _extends$1 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$1(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var AlertIcon = function AlertIcon(e) {
  e.styles;

  var t = _objectWithoutProperties$1(e, ["styles"]);

  return React__default.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35"
  }, t), React__default.createElement("path", {
    d: "M17.5 35C7.8 35 0 27.2 0 17.5S7.8 0 17.5 0 35 7.8 35 17.5 27.2 35 17.5 35zm0-32C9.5 3 3 9.5 3 17.5S9.5 32 17.5 32 32 25.5 32 17.5 25.5 3 17.5 3z"
  }), React__default.createElement("path", {
    d: "M16 8.7h3v11.4h-3V8.7z"
  }), React__default.createElement("circle", {
    cx: "17.5",
    cy: "24.2",
    r: "2.1"
  }));
},
    _extends$2 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$2(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Anchor = function Anchor(e) {
  e.styles;

  var t = _objectWithoutProperties$2(e, ["styles"]);

  return React__default.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.9 33.2"
  }, t), React__default.createElement("path", {
    d: "M15 33c-.8 0-1.5-.7-1.5-1.5V8.3c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v23.3c0 .8-.7 1.4-1.5 1.4z"
  }), React__default.createElement("path", {
    d: "M15 33.2c-6.3 0-12-3.5-14.8-9.1-.4-.7-.1-1.6.7-2 .7-.4 1.6-.1 2 .7 3.4 6.7 11.6 9.3 18.3 5.9 2.5-1.3 4.6-3.4 5.9-5.9.4-.7 1.3-1 2-.6s1 1.3.6 2c-2.8 5.5-8.5 9-14.7 9zm.1-23.4c-2.7 0-4.9-2.2-4.9-4.9S12.4 0 15.1 0 20 2.2 20 4.9s-2.2 4.9-4.9 4.9zm0-6.8c-1 0-1.9.9-1.9 1.9s.9 1.9 1.9 1.9c1 0 1.9-.8 1.9-1.9 0-1.1-.9-1.9-1.9-1.9zM22 16.1H7.7c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5H22c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z"
  }));
},
    _extends$3 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$3(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var BarChart = function BarChart(e) {
  e.styles;

  var t = _objectWithoutProperties$3(e, ["styles"]);

  return React__default.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.4 27.4"
  }, t), React__default.createElement("path", {
    d: "M33.9 27.4H1.5c-.8 0-1.5-.7-1.5-1.5 0-.7.4-1.2 1-1.4V7.2c0-.8.7-1.5 1.5-1.5h7.2c.8 0 1.5.7 1.5 1.5v17.2h1.3V12.7c0-.8.7-1.5 1.5-1.5h7.1c.8 0 1.5.7 1.5 1.5v11.7H24V1.5c0-.8.7-1.5 1.5-1.5h7.1c.8 0 1.5.7 1.5 1.5v22.9c.7.1 1.3.7 1.3 1.5s-.7 1.5-1.5 1.5zm-6.9-3h4.1V3H27v21.4zm-11.5 0h4.1V14.2h-4.1v10.2zM4 24.4h4.2V8.7H4v15.7z"
  }));
},
    _extends$4 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$4(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Blurb = function Blurb(e) {
  e.styles;

  var t = _objectWithoutProperties$4(e, ["styles"]);

  return React__default.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 11"
  }, t), React__default.createElement("path", {
    d: "M2 0h12c1.1 0 2 .9 2 2s-.9 2-2 2H2C.9 4 0 3.1 0 2s.9-2 2-2zm0 7h7c1.1 0 2 .9 2 2s-.9 2-2 2H2c-1.1 0-2-.9-2-2s.9-2 2-2z"
  }));
},
    _extends$5 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$5(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var BoxPlot = function BoxPlot(e) {
  e.styles;

  var t = _objectWithoutProperties$5(e, ["styles"]);

  return React__default.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.1 45.7"
  }, t), React__default.createElement("path", {
    d: "M12.7 45.7H2.2c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h3.7v-7.5H1.5c-.8 0-1.5-.7-1.5-1.5V12c0-.8.7-1.5 1.5-1.5h4.4V3H2.2C1.4 3 .7 2.3.7 1.5S1.4 0 2.2 0h10.5c.8 0 1.5.7 1.5 1.5S13.5 3 12.7 3H8.9v7.5h4.5c.8 0 1.5.7 1.5 1.5v21.7c0 .8-.7 1.5-1.5 1.5H8.9v7.5h3.8c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zM3 32.2h8.9v-7.9H3v7.9zm0-10.9h8.9v-7.8H3v7.8zm32.9 22H25.4c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h3.7v-7.5h-4.4c-.8 0-1.5-.7-1.5-1.5V15.4c0-.8.7-1.5 1.5-1.5h4.4V6.4h-3.7c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h10.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5h-3.8v7.5h4.5c.8 0 1.5.7 1.5 1.5v15.9c0 .8-.7 1.5-1.5 1.5h-4.5v7.5h3.8c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zm-9.7-13.5h8.9v-5h-8.9v5zm0-8h8.9v-4.9h-8.9v4.9z"
  }));
},
    _extends$6 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$6(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Caret = function Caret(e) {
  e.styles;

  var t = _objectWithoutProperties$6(e, ["styles"]);

  return React__default.createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.6 9.3"
  }, t), React__default.createElement("path", {
    d: "M7.8 9.3c-.4 0-.8-.1-1-.4L.4 2.6C-.1 2-.1 1 .5.4c.6-.5 1.5-.5 2 0l5.3 5.3L13 .5c.6-.6 1.6-.5 2.1.1s.5 1.5 0 2L8.9 8.9c-.3.3-.7.4-1.1.4z"
  }));
},
    _extends$7 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$7(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Check = function Check(e) {
  e.styles;

  var t = _objectWithoutProperties$7(e, ["styles"]);

  return React__default.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, t), React__default.createElement("path", {
    d: "M15.5 29.6c-.5 0-1-.2-1.4-.6l-5.8-5.8c-.8-.8-.8-2 0-2.8s2-.8 2.8 0l4.4 4.4L28.2 12c.8-.8 2-.8 2.8 0s.8 2 0 2.8L16.9 29c-.4.4-.9.6-1.4.6z"
  }));
},
    _extends$8 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$8(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Delete = function Delete(e) {
  e.styles;

  var t = _objectWithoutProperties$8(e, ["styles"]);

  return React__default.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 35"
  }, t), React__default.createElement("path", {
    d: "M29 35H5c-.8 0-1.5-.7-1.5-1.5v-27C3.5 5.7 4.2 5 5 5h24c.8 0 1.5.7 1.5 1.5v27c0 .8-.7 1.5-1.5 1.5zM6.5 32h21V8h-21v24z"
  }), React__default.createElement("path", {
    d: "M32.5 8h-31C.7 8 0 7.3 0 6.5S.7 5 1.5 5h31c.8 0 1.5.7 1.5 1.5S33.3 8 32.5 8z"
  }), React__default.createElement("path", {
    d: "M24.5 8h-15C8.7 8 8 7.4 8 6.5v-5C8 .7 8.6 0 9.5 0h15c.8 0 1.5.7 1.5 1.5v5c0 .8-.7 1.5-1.5 1.5zM11 5h12V3H11v2zm.2 23.9c-.8 0-1.5-.7-1.5-1.5V13.1c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v14.4c.1.8-.6 1.4-1.5 1.4zm11.6 0c-.8 0-1.5-.7-1.5-1.5V13.1c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v14.4c-.1.8-.7 1.4-1.5 1.4zm-5.8 0c-.8 0-1.5-.7-1.5-1.5V13.1c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v14.4c0 .8-.7 1.4-1.5 1.4z"
  }));
},
    _extends$9 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$9(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var DisplayLogic = function DisplayLogic(e) {
  e.styles;

  var t = _objectWithoutProperties$9(e, ["styles"]);

  return React__default.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.7 33.7"
  }, t), React__default.createElement("path", {
    d: "M16.9 33.7C7.5 33.7 0 26.2 0 16.9S7.5 0 16.9 0s16.9 7.5 16.9 16.9c-.1 9.3-7.6 16.8-16.9 16.8zm0-30.7C9.2 3 3 9.2 3 16.9s6.2 13.9 13.9 13.9 13.9-6.2 13.9-13.9C30.7 9.2 24.5 3 16.9 3z"
  }), React__default.createElement("path", {
    d: "M19.5 23.7c-.8 0-1.5-.7-1.5-1.5V20c0-4.5-3.7-8.2-8.2-8.2-.8 0-1.5-.7-1.5-1.5S9 8.8 9.8 8.8C16 8.8 21 13.8 21 20v2.2c0 .8-.7 1.5-1.5 1.5z"
  }), React__default.createElement("path", {
    d: "M19.5 24.9c-.4 0-.8-.2-1.1-.4L14 20.1c-.6-.6-.6-1.5-.1-2.1.6-.6 1.5-.6 2.1-.1 0 0 .1 0 .1.1l3.4 3.4 3.4-3.4c.6-.6 1.6-.5 2.1.1s.5 1.5 0 2l-4.4 4.4c-.3.3-.7.4-1.1.4z"
  }));
},
    _extends$10 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$10(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Download = function Download(e) {
  e.styles;

  var t = _objectWithoutProperties$10(e, ["styles"]);

  return React__default.createElement("svg", _extends$10({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.2 24.5"
  }, t), React__default.createElement("path", {
    d: "M10.6 17.8c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1s1 .4 1 1v15.8c0 .5-.4 1-1 1z"
  }), React__default.createElement("path", {
    d: "M10.6 19.5c-.3 0-.5-.1-.7-.3l-4-4c-.4-.4-.3-1.1.1-1.4.4-.3.9-.3 1.3 0l3.3 3.3 3.3-3.3c.4-.4 1.1-.3 1.4.1.3.4.3.9 0 1.3l-4 4c-.2.2-.4.3-.7.3z"
  }), React__default.createElement("path", {
    d: "M20.2 24.5H1c-.6 0-1-.4-1-1V5.9c0-.6.4-1 1-1h5.3c.6 0 1 .4 1 1s-.4 1-1 1H2v15.6h17.2V6.9h-4.3c-.6 0-1-.4-1-1s.4-1 1-1h5.3c.6 0 1 .4 1 1v17.6c0 .6-.4 1-1 1z"
  }));
},
    _extends$11 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$11(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Dropdown = function Dropdown(e) {
  e.styles;

  var t = _objectWithoutProperties$11(e, ["styles"]);

  return React__default.createElement("svg", _extends$11({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, t), React__default.createElement("path", {
    d: "M13 17.3c-.4 0-.8-.2-1.1-.4l-3.7-3.7c-.6-.5-.7-1.5-.2-2.1.5-.6 1.5-.7 2.1-.2l.2.2 2.6 2.6 2.6-2.6c.6-.6 1.6-.5 2.1.1.6.6.6 1.5 0 2.1L14 16.9c-.2.3-.6.5-1 .4z"
  }), React__default.createElement("path", {
    d: "M21 26H5c-2.8 0-5-2.2-5-5V5c0-2.8 2.2-5 5-5h16c2.8 0 5 2.2 5 5v16c0 2.8-2.3 5-5 5zM5 2C3.3 2 2 3.3 2 5v16c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3V5c0-1.7-1.3-3-3-3H5z"
  }));
},
    _extends$12 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$12(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Duplicate = function Duplicate(e) {
  e.styles;

  var t = _objectWithoutProperties$12(e, ["styles"]);

  return React__default.createElement("svg", _extends$12({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 30.5"
  }, t), React__default.createElement("path", {
    d: "M25.9 23H1.5C.7 23 0 22.3 0 21.5v-20C0 .7.7 0 1.5 0h24.4c.8 0 1.5.7 1.5 1.5v20c0 .8-.7 1.5-1.5 1.5zM3 20h21.4V3H3v17z"
  }), React__default.createElement("path", {
    d: "M33.5 30.5H9.1c-.8 0-1.5-.7-1.5-1.5v-7.3c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v5.8H32v-17h-6.1c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h7.6c.8 0 1.5.7 1.5 1.5v20c0 .8-.6 1.5-1.5 1.5z"
  }), React__default.createElement("path", {
    d: "M18.5 13H8.9c-.8 0-1.5-.7-1.5-1.5S8.1 10 8.9 10h9.6c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z"
  }), React__default.createElement("path", {
    d: "M13.7 17.8c-.8 0-1.5-.7-1.5-1.5V6.7c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v9.6c0 .8-.7 1.5-1.5 1.5z"
  }));
},
    _extends$13 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$13(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var PencilIcon = function PencilIcon(e) {
  e.styles;

  var t = _objectWithoutProperties$13(e, ["styles"]);

  return React__default.createElement("svg", _extends$13({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.9 35"
  }, t), React__default.createElement("path", {
    d: "M10.6 31c-.4 0-.8-.2-1.1-.4l-5.3-5.2c-.6-.6-.6-1.5 0-2.1L27 .4c.6-.6 1.5-.6 2.1 0l5.3 5.3c.6.6.6 1.5 0 2.1L11.6 30.6c-.2.3-.6.4-1 .4zm-3.2-6.7l3.1 3.1L31.2 6.8l-3.1-3.1L7.4 24.3z"
  }), React__default.createElement("path", {
    d: "M28.3 13c-.4 0-.8-.2-1.1-.4l-4.4-4.4c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l4.4 4.4c.6.6.6 1.5.1 2.1-.3.2-.7.4-1.1.4zM1.5 35C.7 35 0 34.3 0 33.5c0-.2 0-.4.1-.6l3.8-9.2c.3-.8 1.2-1.1 2-.8.2.1.4.2.5.3l5.3 5.3c.6.6.6 1.5 0 2.1-.1.1-.3.2-.5.3l-9.1 4c-.2.1-.4.1-.6.1zm4.3-8.1l-1.5 3.7L8 29l-2.2-2.1z"
  }));
},
    _extends$14 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$14(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Ellipsis = function Ellipsis(e) {
  e.styles;

  var t = _objectWithoutProperties$14(e, ["styles"]);

  return React__default.createElement("svg", _extends$14({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.5 5.4"
  }, t), React__default.createElement("circle", {
    cx: "2.7",
    cy: "2.7",
    r: "2.7"
  }), React__default.createElement("circle", {
    cx: "11.7",
    cy: "2.7",
    r: "2.7"
  }), React__default.createElement("circle", {
    cx: "20.7",
    cy: "2.7",
    r: "2.7"
  }));
},
    _extends$15 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$15(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Export = function Export(e) {
  e.styles;

  var t = _objectWithoutProperties$15(e, ["styles"]);

  return React__default.createElement("svg", _extends$15({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, t), React__default.createElement("path", {
    d: "M8.5 12.5c-.6 0-1-.4-1-1 0-.3.1-.5.3-.7l9-9c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-9 9c-.2.2-.4.3-.7.3z"
  }), React__default.createElement("path", {
    d: "M19 8.9c-.6 0-1-.4-1-1V2h-5.9c-.6 0-1-.4-1-1s.4-1 1-1H19c.6 0 1 .4 1 1v6.9c0 .6-.4 1-1 1zM19 20H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1h5.5c.6 0 1 .4 1 1s-.4 1-1 1H2v16h16v-4.5c0-.6.4-1 1-1s1 .4 1 1V19c0 .6-.4 1-1 1z"
  }));
},
    _extends$16 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$16(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Grouping = function Grouping(e) {
  e.styles;

  var t = _objectWithoutProperties$16(e, ["styles"]);

  return React__default.createElement("svg", _extends$16({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.8 12.5"
  }, t), React__default.createElement("path", {
    d: "M10.7 5.9l-.5-.6C8.9 3.9 7.5 2.9 6 2.3S2.7 1.4.9 1.6l-.7.1L.1.2.8.1c2-.2 4 .1 5.7.8 1.8.7 3.4 1.8 4.8 3.4l.5.6-1.1 1zM2 12.5c-.4 0-.9 0-1.3-.1l-.7-.1.1-1.5.7.1c1.9.2 3.6-.1 5.1-.7 1.5-.6 3-1.6 4.2-3l.5-.6 1.1 1-.5.6c-1.4 1.6-3 2.7-4.8 3.4-1.2.6-2.8.9-4.4.9z"
  }), React__default.createElement("path", {
    d: "M10.6 5.6h9.5v1.5h-9.5V5.6z"
  }), React__default.createElement("path", {
    d: "M22.8 6.3l-6 3v-6l6 3z"
  }));
},
    _extends$17 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$17(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var HorizontalBarChart = function HorizontalBarChart(e) {
  e.styles;

  var t = _objectWithoutProperties$17(e, ["styles"]);

  return React__default.createElement("svg", _extends$17({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, t), React__default.createElement("path", {
    d: "M6.9 38.9c-.8 0-1.5-.7-1.5-1.5V2.6c0-.8.7-1.5 1.5-1.5.7 0 1.3.5 1.4 1.1h18.6c.8 0 1.5.7 1.5 1.5v7.7c0 .8-.7 1.5-1.5 1.5H8.4v1.6h12.7c.8 0 1.5.7 1.5 1.5v7.7c0 .8-.7 1.5-1.5 1.5H8.4v1.6h24.7c.8 0 1.5.7 1.5 1.5V36c0 .8-.7 1.5-1.5 1.5H8.4c-.1.8-.7 1.4-1.5 1.4zm1.5-4.4h23.2v-4.7H8.4v4.7zm0-12.3h11.2v-4.7H8.4v4.7zm0-12.3h17V5.2h-17v4.7z"
  }));
},
    _extends$18 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$18(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Interlock = function Interlock(e) {
  e.styles;

  var t = _objectWithoutProperties$18(e, ["styles"]);

  return React__default.createElement("svg", _extends$18({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, t), React__default.createElement("path", {
    d: "M10.3 18H2.8C1.3 18 .1 16.8 0 15.3V7.8C0 6.3 1.3 5 2.8 5h7.5c1.5.1 2.7 1.3 2.7 2.8v7.5c-.1 1.5-1.2 2.6-2.7 2.7zM2.8 6.5c-.7 0-1.3.6-1.3 1.3v7.5c0 .7.6 1.3 1.3 1.3h7.5c.7 0 1.2-.5 1.3-1.2V7.8c0-.6-.6-1.2-1.2-1.2l-7.6-.1z"
  }), React__default.createElement("path", {
    d: "M15.3 13H7.8c-1.5 0-2.7-1.2-2.8-2.7V2.8C5 1.3 6.3 0 7.8 0h7.5C16.8.1 18 1.3 18 2.8v7.5c-.1 1.5-1.2 2.6-2.7 2.7zM7.8 1.5c-.7 0-1.3.6-1.3 1.3v7.5c0 .7.6 1.3 1.3 1.3h7.5c.7 0 1.2-.5 1.3-1.2V2.8c0-.6-.6-1.2-1.2-1.2l-7.6-.1z"
  }), React__default.createElement("path", {
    d: "M5.5 6.5V11c0 .8.7 1.5 1.5 1.5h4.5V8c0-.8-.7-1.5-1.5-1.5H5.5z"
  }), React__default.createElement("path", {
    d: "M12 13H7c-1.1 0-2-.9-2-2V6h5c1.1 0 2 .9 2 2v5zM6 7v4c0 .6.4 1 1 1h4V8c0-.6-.4-1-1-1H6z"
  }));
},
    _extends$19 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$19(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Info = function Info(e) {
  e.styles;

  var t = _objectWithoutProperties$19(e, ["styles"]);

  return React__default.createElement("svg", _extends$19({
    width: "13",
    height: "12",
    viewBox: "0 0 13 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), React__default.createElement("title", null, "icon-info"), React__default.createElement("path", {
    d: "M6.37 11.213c-3.234 0-5.856-2.4-5.856-5.362C.514 2.89 3.136.49 6.37.49c3.235 0 5.857 2.4 5.857 5.362 0 2.961-2.622 5.362-5.857 5.362zm0-1.34c2.426 0 4.393-1.801 4.393-4.022 0-2.22-1.967-4.021-4.393-4.021-2.425 0-4.392 1.8-4.392 4.021S3.945 9.872 6.37 9.872zM6.26 5.18h.221c.444 0 .805.36.805.804v2.413c0 .444-.36.804-.805.804H6.26a.804.804 0 0 1-.805-.804V5.985c0-.444.36-.804.805-.804zM6.238 2.5h.265c.533 0 .966.432.966.965v.08a.965.965 0 0 1-.966.966h-.265a.965.965 0 0 1-.966-.965v-.08c0-.534.433-.966.966-.966z",
    fill: "#B0B3BC",
    fillRule: "nonzero"
  }));
},
    _extends$20 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$20(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var LineChart = function LineChart(e) {
  e.styles;

  var t = _objectWithoutProperties$20(e, ["styles"]);

  return React__default.createElement("svg", _extends$20({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.5 25.7"
  }, t), React__default.createElement("path", {
    d: "M4 23.2c-.4 0-.8-.2-1.1-.5-.6-.6-.6-1.5 0-2.1l11.3-11c.6-.6 1.5-.6 2.1 0l8.9 8.9L40.7 3c.6-.6 1.5-.6 2.1 0s.6 1.5 0 2.1L26.3 21.6c-.6.6-1.5.6-2.1 0l-8.9-8.9-10.2 10c-.3.3-.7.5-1.1.5z"
  }), React__default.createElement("circle", {
    cx: "15",
    cy: "11",
    r: "4"
  }), React__default.createElement("circle", {
    cx: "41.5",
    cy: "4",
    r: "4"
  }), React__default.createElement("circle", {
    cx: "4",
    cy: "21.7",
    r: "4"
  }));
},
    _extends$21 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$21(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Link = function Link(e) {
  e.styles;

  var t = _objectWithoutProperties$21(e, ["styles"]);

  return React__default.createElement("svg", _extends$21({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49 23.1"
  }, t), React__default.createElement("path", {
    d: "M37.2 13.1H11.8c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h25.4c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z"
  }), React__default.createElement("path", {
    d: "M17.3 23.1H6c-3.3 0-6-2.6-6-5.9V5.9C0 2.6 2.7 0 6 0h12.4c2.7 0 4.8 2.2 4.8 4.8v1.4c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5V4.8c0-1-.8-1.8-1.8-1.8H6C4.4 3 3 4.3 3 5.9v11.3c0 1.6 1.4 2.9 3 2.9h11.3c1.6 0 3-1.3 3-2.9v-.4c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v.4c0 3.3-2.7 6-6 5.9zm25.7 0H30.6c-2.7 0-4.8-2.2-4.8-4.8v-1.4c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v1.4c0 1 .8 1.8 1.8 1.8H43c1.6 0 3-1.3 3-2.9V5.9C46 4.3 44.6 3 43 3H31.7c-1.6 0-3 1.3-3 2.9v.4c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5v-.4c0-3.3 2.7-5.9 6-5.9H43c3.3 0 6 2.6 6 5.9v11.3c0 3.3-2.7 5.9-6 5.9z"
  }));
},
    _extends$22 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$22(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var LinkBreak = function LinkBreak(e) {
  e.styles;

  var t = _objectWithoutProperties$22(e, ["styles"]);

  return React__default.createElement("svg", _extends$22({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.2 48.3"
  }, t), React__default.createElement("path", {
    d: "M37.3 25.7H11.9c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h25.4c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z"
  }), React__default.createElement("path", {
    d: "M43.2 35.8H30.8c-2.7 0-4.8-2.1-4.9-4.8v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V31c0 1 .9 1.9 1.9 1.9h12.4c1.7 0 3-1.3 3-3V18.5c0-1.7-1.3-3-3-3H31.9c-1.7 0-3 1.3-3 3v.4c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5v-.4c0-3.3 2.7-6 6-6h11.3c3.3 0 6 2.7 6 6v11.3c0 3.3-2.7 6-6 6zm-25.9 0H6c-3.3 0-6-2.7-6-6V18.5c0-3.3 2.7-6 6-6h12.4c2.7 0 4.9 2.2 4.9 4.9v1.4c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5v-1.4c0-1-.9-1.9-1.9-1.9H6c-1.7 0-3 1.3-3 3v11.3c0 1.7 1.3 3 3 3h11.3c1.7 0 3-1.3 3-3v-.4c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v.4c0 3.3-2.7 6-6 6zm7.3 12.3c-.8 0-1.5-.7-1.5-1.5v-7c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v7c0 .8-.7 1.5-1.5 1.5zm-10-1c-.8 0-1.5-.7-1.5-1.5 0-.3.1-.6.3-.9l4.9-6c.6-.6 1.5-.6 2.1 0 .5.5.6 1.3.2 1.9l-4.9 6c-.3.3-.7.5-1.1.5zm20 1.2c-.5 0-.9-.2-1.2-.6L28.5 41c-.5-.7-.4-1.6.3-2.1s1.6-.4 2.1.3l4.9 6.8c.5.7.4 1.6-.3 2.1-.3.2-.6.3-.9.3v-.1zm-10-38.1c-.8 0-1.5-.7-1.5-1.5v-7c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v7c0 .8-.7 1.5-1.5 1.5zm-5.1 0c-.5 0-.9-.2-1.2-.6l-4.9-6c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0 .1.1.1.2.2.2l4.9 6c.5.7.4 1.6-.3 2.1-.3.2-.6.3-.9.3l.1.1zm10.2-.4c-.8 0-1.5-.7-1.5-1.5 0-.3.1-.6.3-.9L33.4.6c.5-.7 1.4-.8 2.1-.3.7.5.8 1.4.3 2.1l-4.9 6.7c-.3.4-.7.7-1.2.7z"
  }));
},
    _extends$23 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$23(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Lock = function Lock(e) {
  e.styles;

  var t = _objectWithoutProperties$23(e, ["styles"]);

  return React__default.createElement("svg", _extends$23({
    width: "15",
    height: "18",
    viewBox: "0 0 15 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), React__default.createElement("title", null, "icon-lock"), React__default.createElement("path", {
    d: "M3.6 8.4a1.2 1.2 0 0 0-1.2 1.2v4.8a1.2 1.2 0 0 0 1.2 1.2h7.8a1.2 1.2 0 0 0 1.2-1.2V9.6a1.2 1.2 0 0 0-1.2-1.2H3.6zm0-2.4h7.8A3.6 3.6 0 0 1 15 9.6v4.8a3.6 3.6 0 0 1-3.6 3.6H3.6A3.6 3.6 0 0 1 0 14.4V9.6A3.6 3.6 0 0 1 3.6 6zM6 11.333a1.5 1.5 0 0 1 3 0V13a1.5 1.5 0 0 1-3 0v-1.666zm-.6-5.34L3 6V4.5a4.5 4.5 0 0 1 9 0v1.492H9.6V4.5a2.1 2.1 0 0 0-4.2 0v1.492z",
    fill: "#B0B3BC",
    fillRule: "nonzero"
  }));
},
    _extends$24 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$24(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var LongText = function LongText(e) {
  e.styles;

  var t = _objectWithoutProperties$24(e, ["styles"]);

  return React__default.createElement("svg", _extends$24({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, t), React__default.createElement("path", {
    d: "M21 26H5c-2.8 0-5-2.2-5-5V5c0-2.8 2.2-5 5-5h16c2.8 0 5 2.2 5 5v16c0 2.7-2.2 5-5 5zM5 2C3.3 2 2 3.3 2 5v16c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3V5c0-1.7-1.3-3-3-3H5z"
  }), React__default.createElement("path", {
    d: "M16.9 9.2H8.1c-.6 0-1-.4-1-1s.4-1 1-1h8.8c.6 0 1 .4 1 1s-.5 1-1 1zm2 4.8H8.1c-.6 0-1-.4-1-1s.4-1 1-1h10.8c.6 0 1 .4 1 1s-.5 1-1 1zm-4 4.8H8.1c-.6 0-1-.4-1-1s.4-1 1-1h6.8c.6 0 1 .4 1 1s-.5 1-1 1z"
  }));
},
    _extends$25 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$25(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Merge = function Merge(e) {
  e.styles;

  var t = _objectWithoutProperties$25(e, ["styles"]);

  return React__default.createElement("svg", _extends$25({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.8 22.9"
  }, t), React__default.createElement("path", {
    d: "M29.2 11.6h-12c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h12c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z"
  }), React__default.createElement("path", {
    d: "M24.8 19.1c-.8 0-1.5-.7-1.5-1.5 0-.4.2-.8.4-1.1l6.4-6.4-6.4-6.4c-.6-.6-.5-1.6.1-2.1s1.5-.5 2 0L33.3 9c.6.6.6 1.5 0 2.1l-7.5 7.5c-.2.3-.6.5-1 .5zM5.3 22.9H1.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h3.8c4.7 0 8.4-3.8 8.4-8.4S10 3 5.3 3H1.5C.7 3 0 2.3 0 1.5S.7 0 1.5 0h3.8c6.3 0 11.4 5.1 11.4 11.4.1 6.3-5 11.5-11.4 11.5z"
  }));
},
    _extends$26 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$26(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Message = function Message(e) {
  e.styles;

  var t = _objectWithoutProperties$26(e, ["styles"]);

  return React__default.createElement("svg", _extends$26({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 19"
  }, t), React__default.createElement("path", {
    d: "M24.5 18.5v-9h-6c0-3.3 2.7-6 6-6v-3c-5 0-9 4-9 9v9h9z"
  }), React__default.createElement("path", {
    d: "M24.5 19h-9c-.3 0-.5-.2-.5-.5v-9C15 4.3 19.3 0 24.5 0c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5-2.9 0-5.2 2.2-5.5 5h5.5c.3 0 .5.2.5.5v9c0 .3-.2.5-.5.5zM16 18h8v-8h-5.5c-.3 0-.5-.2-.5-.5 0-3.4 2.6-6.2 6-6.5V1c-4.5.3-8 4-8 8.5V18zm-6.5.5v-9h-6c0-3.3 2.7-6 6-6v-3c-5 0-9 4-9 9v9h9z"
  }), React__default.createElement("path", {
    d: "M9.5 19h-9c-.3 0-.5-.2-.5-.5v-9C0 4.3 4.3 0 9.5 0c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5C6.6 4 4.3 6.2 4 9h5.5c.3 0 .5.2.5.5v9c0 .3-.2.5-.5.5zM1 18h8v-8H3.5c-.3 0-.5-.2-.5-.5C3 6.1 5.6 3.3 9 3V1c-4.5.3-8 4-8 8.5V18z"
  }));
},
    _extends$27 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$27(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Move = function Move(e) {
  e.styles;

  var t = _objectWithoutProperties$27(e, ["styles"]);

  return React__default.createElement("svg", _extends$27({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.7 32.7"
  }, t), React__default.createElement("path", {
    d: "M16.4 32.7c-.8 0-1.5-.7-1.5-1.5v-28c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v28c0 .8-.7 1.5-1.5 1.5z"
  }), React__default.createElement("path", {
    d: "M19.7 6.4c-.4 0-.8-.2-1.1-.4l-2.3-2.3L14 5.9c-.6.5-1.6.4-2.1-.2-.4-.6-.4-1.3 0-1.9L15.3.4c.6-.6 1.5-.6 2.1 0l3.4 3.4c.6.6.6 1.5 0 2.1-.3.3-.7.5-1.1.5zm-3.3 26.3c-.4 0-.8-.2-1.1-.4l-3.4-3.4c-.5-.6-.4-1.6.2-2.1.5-.5 1.3-.5 1.9 0l2.3 2.3 2.3-2.3c.6-.6 1.6-.5 2.1.1s.5 1.5 0 2l-3.4 3.4c-.2.2-.6.4-.9.4zm13.1-14.8h-28c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h28c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z"
  }), React__default.createElement("path", {
    d: "M27.8 21.2c-.8 0-1.5-.7-1.5-1.5 0-.4.2-.8.4-1.1l2.3-2.3-2.2-2.3c-.6-.6-.5-1.6.1-2.1s1.5-.5 2 0l3.4 3.4c.6.6.6 1.5 0 2.1l-3.4 3.4c-.3.3-.7.4-1.1.4zm-22.9 0c-.4 0-.8-.2-1.1-.4L.4 17.4c-.6-.6-.6-1.5 0-2.1l3.4-3.4c.6-.5 1.6-.4 2.1.2.5.5.5 1.3 0 1.9l-2.3 2.4 2.3 2.3c.6.6.6 1.5 0 2.1-.2.3-.6.4-1 .4z"
  }));
},
    _extends$28 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$28(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var MultipleSelect = function MultipleSelect(e) {
  e.styles;

  var t = _objectWithoutProperties$28(e, ["styles"]);

  return React__default.createElement("svg", _extends$28({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, t), React__default.createElement("path", {
    d: "M10.3 18.8c-.4 0-.8-.2-1.1-.4l-3.1-3.1c-.6-.6-.6-1.5-.1-2.1s1.5-.6 2.1-.1c0 0 .1 0 .1.1l2 2 7.4-7.4c.6-.6 1.6-.5 2.1.1s.5 1.5 0 2l-8.5 8.5c-.1.2-.5.3-.9.4z"
  }), React__default.createElement("path", {
    d: "M21 26H5c-2.8 0-5-2.2-5-5V5c0-2.8 2.2-5 5-5h16c2.8 0 5 2.2 5 5v16c0 2.8-2.2 5-5 5zM5 2C3.3 2 2 3.3 2 5v16c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3V5c0-1.7-1.3-3-3-3H5z"
  }));
},
    _extends$29 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$29(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var MultipleSelectGrid = function MultipleSelectGrid(e) {
  e.styles;

  var t = _objectWithoutProperties$29(e, ["styles"]);

  return React__default.createElement("svg", _extends$29({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 25.4"
  }, t), React__default.createElement("path", {
    d: "M2 1h7.5c.6 0 1 .4 1 1v7.5c0 .6-.4 1-1 1H2c-.6 0-1-.4-1-1V2c0-.6.4-1 1-1z"
  }), React__default.createElement("path", {
    d: "M9.5 11.5H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h7.5c1.1 0 2 .9 2 2v7.5c0 1.1-.9 2-2 2zM2 2v7.5h7.5V2H2zm14.5-1H24c.6 0 1 .4 1 1v7.5c0 .6-.4 1-1 1h-7.5c-.6 0-1-.4-1-1V2c0-.6.4-1 1-1z"
  }), React__default.createElement("path", {
    d: "M24 11.5h-7.5c-1.1 0-2-.9-2-2V2c0-1.1.9-2 2-2H24c1.1 0 2 .9 2 2v7.5c0 1.1-.9 2-2 2zM16.5 2v7.5H24V2h-7.5zm-7 23.4H2c-1.1 0-2-.9-2-2v-7.5c0-1.1.9-2 2-2h7.5c1.1 0 2 .9 2 2v7.5c0 1.1-.9 2-2 2zM2 15.8v7.5h7.5v-7.5H2zm14.5-1H24c.6 0 1 .4 1 1v7.5c0 .6-.4 1-1 1h-7.5c-.6 0-1-.4-1-1v-7.5c0-.5.4-1 1-1z"
  }), React__default.createElement("path", {
    d: "M24 25.4h-7.5c-1.1 0-2-.9-2-2v-7.5c0-1.1.9-2 2-2H24c1.1 0 2 .9 2 2v7.5c0 1.1-.9 2-2 2zm-7.5-9.6v7.5H24v-7.5h-7.5z"
  }));
},
    _extends$30 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$30(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var NoSymbol = function NoSymbol(e) {
  e.styles;

  var t = _objectWithoutProperties$30(e, ["styles"]);

  return React__default.createElement("svg", _extends$30({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.4 24.4"
  }, t), React__default.createElement("path", {
    d: "M12.2 24.4C5.5 24.4 0 19 0 12.2S5.4 0 12.2 0s12.2 5.5 12.2 12.2c0 6.7-5.5 12.2-12.2 12.2zm0-21.4C7.1 3 3 7.1 3 12.2s4.1 9.2 9.2 9.2 9.2-4.1 9.2-9.2S17.3 3 12.2 3z"
  }), React__default.createElement("path", {
    d: "M4.8 21.4c-.8 0-1.5-.7-1.5-1.5 0-.4.2-.8.4-1.1L18.3 4.2c.6-.6 1.6-.5 2.1.1s.5 1.5 0 2L5.8 21c-.2.3-.6.4-1 .4z"
  }));
},
    _extends$31 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$31(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Numeric = function Numeric(e) {
  e.styles;

  var t = _objectWithoutProperties$31(e, ["styles"]);

  return React__default.createElement("svg", _extends$31({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 21.7"
  }, t), React__default.createElement("path", {
    d: "M21.5 7.8H2.8c-.8 0-1.5-.6-1.5-1.5S2 4.8 2.8 4.8h18.6c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.4 1.5zm-1.3 9H1.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h18.7c.8 0 1.5.7 1.5 1.5 0 .9-.7 1.5-1.5 1.5z"
  }), React__default.createElement("path", {
    d: "M5 21.7h-.2c-.8-.1-1.4-.9-1.3-1.7L6.2 1.3C6.3.5 7.1-.1 7.9 0c.8.1 1.4.9 1.3 1.7L6.5 20.4c-.1.7-.7 1.3-1.5 1.3zm10.3 0h-.2c-.8-.1-1.4-.9-1.3-1.7l2.6-18.7c.1-.8.9-1.4 1.7-1.3.8.1 1.4.8 1.3 1.7l-2.6 18.7c-.1.7-.7 1.3-1.5 1.3z"
  }));
},
    _extends$32 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$32(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Padlock = function Padlock(e) {
  e.styles;

  var t = _objectWithoutProperties$32(e, ["styles"]);

  return React__default.createElement("svg", _extends$32({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.4 16"
  }, t), React__default.createElement("path", {
    d: "M10.6 5.9H9.5V3.3C9.5 1.5 8 0 6.2 0S2.9 1.5 2.9 3.3v2.6H1.8c-1 0-1.8.8-1.8 1.9v6.4c0 1 .8 1.9 1.8 1.9h8.8c1 0 1.8-.8 1.8-1.9V7.8c0-1.1-.8-1.9-1.8-1.9zM4.1 3.3c0-1.1.9-2.1 2.1-2.1s2.1.9 2.1 2.1v2.6H4.1V3.3zm7.1 10.8c0 .3-.3.6-.6.6H1.8c-.3 0-.6-.3-.6-.6V7.8c0-.3.3-.6.6-.6h8.8c.3 0 .6.3.6.6v6.3z"
  }));
},
    _extends$33 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$33(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Paper = function Paper(e) {
  e.styles;

  var t = _objectWithoutProperties$33(e, ["styles"]);

  return React__default.createElement("svg", _extends$33({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.1 16"
  }, t), React__default.createElement("path", {
    d: "M9.2 0H2.3C1.1.1.1 1.1 0 2.3V16h10.9c1.2-.1 2.2-1.1 2.3-2.3V4.6L9.2 0zM0 16V3.4c0-.6-.1.8.5.8L0 3.4v10.3c.1 1.2 1.1 2.2 2.3 2.3H0zm12-2.3c0 .6-.5 1.1-1.1 1.1H2.3c-.6 0-1.1-.5-1.1-1.1V2.3c0-.6.5-1.1 1.1-1.2H8v2.3c.1 1.2 1.1 2.2 2.3 2.3H12v8zm-1.7-9.1c-.6 0-1.1-1.1-1.1-1.7V1.2L12 4.6h-1.7zM9.2 8H4c-.3 0-.6.3-.6.6s.3.6.6.6h5.2c.3 0 .6-.3.6-.6S9.5 8 9.2 8zm0 2.9H4c-.3-.1-.7 0-.8.3s0 .7.3.8c.2.1.3.1.5 0h5.2c.3.1.7 0 .8-.3s0-.7-.3-.8c-.2-.1-.3-.1-.5 0z"
  }));
},
    _extends$34 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$34(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Pause = function Pause(e) {
  e.styles;

  var t = _objectWithoutProperties$34(e, ["styles"]);

  return React__default.createElement("svg", _extends$34({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.6 7.6"
  }, t), React__default.createElement("path", {
    d: "M.7 7.6c-.4 0-.7-.3-.7-.7V.7C0 .3.3 0 .7 0s.7.3.7.7v6.2c0 .4-.3.7-.7.7zm5.2 0c-.4 0-.7-.3-.7-.7V.7c-.1-.4.3-.7.7-.7s.7.3.7.7v6.2c0 .4-.3.7-.7.7z"
  }));
},
    _extends$35 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$35(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var PieChart = function PieChart(e) {
  e.styles;

  var t = _objectWithoutProperties$35(e, ["styles"]);

  return React__default.createElement("svg", _extends$35({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38"
  }, t), React__default.createElement("path", {
    d: "M19 38c-4.9 0-9.7-1.9-13.4-5.6C2 28.8 0 24.1 0 19S2 9.1 5.6 5.5C13-1.9 25-1.9 32.4 5.5c7.4 7.4 7.4 19.5 0 26.9C28.7 36.1 23.9 38 19 38zm0-35c-4.1 0-8.2 1.6-11.3 4.7-3 3-4.7 7-4.7 11.3 0 4.3 1.7 8.3 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6C27.2 4.6 23.1 3 19 3zM6.6 6.6z"
  }), React__default.createElement("path", {
    d: "M31.3 32.8c-.4 0-.8-.1-1.1-.4L17.9 20.1c-.3-.3-.4-.7-.4-1.1V1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v16h16c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5H22.6l9.7 9.7c.6.6.6 1.5 0 2.1-.2.4-.6.5-1 .5z"
  }));
},
    _extends$36 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$36(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Play = function Play(e) {
  e.styles;

  var t = _objectWithoutProperties$36(e, ["styles"]);

  return React__default.createElement("svg", _extends$36({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.4 9.4"
  }, t), React__default.createElement("path", {
    d: "M.7 9.4H.3C.1 9.2 0 9 0 8.7v-8C0 .3.3 0 .7 0c.1 0 .2 0 .3.1l8 4c.4.1.5.6.4.9-.1.2-.2.3-.4.4l-8 4H.7zm.7-7.6v5.7l5.7-2.8-5.7-2.9z"
  }));
},
    _extends$37 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$37(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var PlayFilled = function PlayFilled(e) {
  e.styles;

  var t = _objectWithoutProperties$37(e, ["styles"]);

  return React__default.createElement("svg", _extends$37({
    width: "13",
    height: "14",
    viewBox: "0 0 13 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), React__default.createElement("title", null, "Path 5"), React__default.createElement("path", {
    d: "M0 1.506v11.233a1.2 1.2 0 0 0 1.79 1.046l9.967-5.617a1.2 1.2 0 0 0 0-2.091L1.79.46A1.2 1.2 0 0 0 0 1.506z",
    fill: "#52C1A3",
    fillRule: "evenodd"
  }));
},
    _extends$38 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$38(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var RadarChart = function RadarChart(e) {
  e.styles;

  var t = _objectWithoutProperties$38(e, ["styles"]);

  return React__default.createElement("svg", _extends$38({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.3 44.9"
  }, t), React__default.createElement("path", {
    d: "M23.1 25.7c-.8 0-1.5-.7-1.5-1.5V1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v22.7c0 .8-.6 1.5-1.5 1.5z"
  }), React__default.createElement("path", {
    d: "M9.6 44.9c-.3 0-.6-.1-.9-.3-.7-.5-.8-1.4-.4-2.1L22 23.3c.5-.7 1.4-.8 2.1-.4.7.5.8 1.4.4 2.1L10.8 44.3c-.3.4-.7.6-1.2.6z"
  }), React__default.createElement("path", {
    d: "M36.6 44.9c-.5 0-.9-.2-1.2-.6L21.8 25.1c-.5-.7-.3-1.6.4-2.1s1.6-.3 2.1.4l13.6 19.2c.5.7.3 1.6-.4 2.1-.2.1-.6.2-.9.2z"
  }), React__default.createElement("path", {
    d: "M23.3 25.7c-.1 0-.3 0-.4-.1L1.1 18.9c-.8-.2-1.2-1.1-1-1.9s1.1-1.2 1.9-1l21.8 6.7c.8.2 1.2 1.1 1 1.9-.2.7-.8 1.1-1.5 1.1z"
  }), React__default.createElement("path", {
    d: "M22.9 25.7c-.6 0-1.2-.4-1.4-1.1-.2-.8.2-1.6 1-1.9L44.3 16c.8-.2 1.6.2 1.9 1 .2.8-.2 1.6-1 1.9l-21.8 6.7c-.2.1-.3.1-.5.1z"
  }), React__default.createElement("path", {
    d: "M31.6 37.8h-.2l-15.5-2.1c-.5-.1-1-.4-1.2-.9L9.4 20.9c-.2-.5-.1-1.2.3-1.6L22.3 6.1c.5-.5 1.3-.6 1.9-.2l17.7 11.5c.7.4.9 1.3.5 2L32.9 37c-.2.5-.7.8-1.3.8zm-14.4-5l13.6 1.8 8.3-15.5-15.5-10-11 11.6 4.6 12.1z"
  }));
},
    _extends$39 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$39(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Ranking = function Ranking(e) {
  e.styles;

  var t = _objectWithoutProperties$39(e, ["styles"]);

  return React__default.createElement("svg", _extends$39({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 17.2"
  }, t), React__default.createElement("path", {
    d: "M6.5 17.2c-.8 0-1.5-.7-1.5-1.5V3.6c0-.8.7-1.5 1.5-1.5S8 2.8 8 3.6v12.1c0 .8-.7 1.5-1.5 1.5z"
  }), React__default.createElement("path", {
    d: "M11.4 7.9c-.4 0-.8-.2-1.1-.4L6.5 3.6 2.6 7.5c-.6.6-1.6.6-2.1 0-.6-.6-.6-1.5 0-2.1L5.4.5C6-.1 6.9-.1 7.5.5l5 4.9c.6.6.6 1.5 0 2.1-.3.3-.7.5-1.1.4zm9.2 7.2c-.8 0-1.5-.7-1.5-1.5V1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v12.1c0 .8-.7 1.5-1.5 1.5z"
  }), React__default.createElement("path", {
    d: "M20.6 17.2c-.4 0-.8-.1-1.1-.4l-4.9-4.9c-.6-.6-.5-1.6.1-2.1s1.5-.5 2 0l3.9 3.9 3.9-3.9c.6-.6 1.6-.5 2.1.1s.5 1.5 0 2l-4.9 4.9c-.3.2-.7.4-1.1.4z"
  }));
},
    _extends$40 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$40(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Rating = function Rating(e) {
  e.styles;

  var t = _objectWithoutProperties$40(e, ["styles"]);

  return React__default.createElement("svg", _extends$40({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, t), React__default.createElement("path", {
    d: "M21.4 26c-.2 0-.3 0-.5-.1L13 21.4l-7.9 4.5c-.5.2-1.1.1-1.4-.4-.1-.2-.2-.5-.1-.7l2.3-9L.3 9.9c-.4-.4-.4-1 0-1.4.2-.2.4-.3.7-.3h7.5L12.1.6c.2-.5.8-.7 1.3-.5.2.1.4.3.5.5l3.6 7.6H25c.6 0 1 .5 1 1 0 .3-.1.5-.3.7l-5.6 5.9 2.3 9c.1.5-.2 1.1-.7 1.2h-.3zM3.3 10.2l4.4 4.6c.3.2.4.5.3.9L6.1 23l6.4-3.6c.3-.2.7-.2 1 0l6.4 3.6-1.9-7.3c-.1-.3 0-.7.2-.9l4.4-4.6h-5.8c-.4 0-.7-.2-.9-.6L13 3.4l-2.9 6.2c-.2.4-.5.6-.9.6H3.3z"
  }));
},
    _extends$41 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$41(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Redo = function Redo(e) {
  e.styles;

  var t = _objectWithoutProperties$41(e, ["styles"]);

  return React__default.createElement("svg", _extends$41({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.7 28.6"
  }, t), React__default.createElement("path", {
    d: "M14.3 28.6C6.4 28.6 0 22.2 0 14.3S6.4 0 14.3 0s14.3 6.4 14.3 14.3c0 1.3-.2 2.6-.5 3.8-.2.8-1.1 1.2-1.9 1-.8-.2-1.2-1-1-1.8 1.7-6-1.8-12.2-7.8-13.9S5.1 5.2 3.5 11.2s1.8 12.2 7.8 13.9c2.3.6 4.7.5 6.9-.3.8-.2 1.6.3 1.8 1.1.2.7-.2 1.4-.8 1.7-1.6.7-3.2 1-4.9 1z"
  }), React__default.createElement("path", {
    d: "M26.7 19.3c-.4 0-.8-.2-1.1-.4l-4.5-4.5c-.6-.6-.5-1.6.1-2.1s1.5-.5 2 0l3.4 3.4 3.4-3.4c.6-.6 1.6-.5 2.1.1s.5 1.5 0 2l-4.5 4.5c-.1.2-.5.4-.9.4z"
  }));
},
    _extends$42 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$42(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Respondent = function Respondent(e) {
  e.styles;

  var t = _objectWithoutProperties$42(e, ["styles"]);

  return React__default.createElement("svg", _extends$42({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.9 33"
  }, t), React__default.createElement("path", {
    d: "M15.5 19.3c-5.3 0-9.7-4.3-9.7-9.7S10.1 0 15.5 0s9.7 4.3 9.7 9.7c-.1 5.3-4.4 9.6-9.7 9.6zm0-16.3a6.7 6.7 0 1 0 6.7 6.7C22.1 6 19.1 3 15.5 3z"
  }), React__default.createElement("path", {
    d: "M29.4 33H1.5C.7 33 0 32.3 0 31.5c0-7.6 4.8-14.4 11.5-16.1l.8 2.9c-5 1.2-8.7 6.1-9.2 11.7h24.7c-.6-5.6-4.3-10.5-9.2-11.8l.8-2.9c6.7 1.8 11.5 8.6 11.5 16.1 0 .9-.7 1.6-1.5 1.6z"
  }));
},
    _extends$43 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$43(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Search = function Search(e) {
  e.styles;

  var t = _objectWithoutProperties$43(e, ["styles"]);

  return React__default.createElement("svg", _extends$43({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.5 16.5"
  }, t), React__default.createElement("path", {
    d: "M6.7 13.5c-3.8 0-6.8-3-6.8-6.8s3-6.8 6.8-6.8 6.8 3 6.8 6.8-3 6.8-6.8 6.8zm0-12c-2.9 0-5.3 2.4-5.3 5.3s2.4 5.3 5.3 5.3S12 9.7 12 6.8v-.1c-.1-2.9-2.4-5.2-5.3-5.2z"
  }), React__default.createElement("path", {
    d: "M15.7 16.5l-.5-.2-5-5c-.3-.3-.3-.8 0-1.1.3-.3.8-.3 1.1 0l5 5c.3.2.4.7.1 1l-.1.1-.6.2z"
  }));
},
    _extends$44 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$44(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Settings = function Settings(e) {
  e.styles;

  var t = _objectWithoutProperties$44(e, ["styles"]);

  return React__default.createElement("svg", _extends$44({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.7 15.7"
  }, t), React__default.createElement("path", {
    d: "M15.2 6.3h-.7a.7.7 0 0 1-.8-.4l-.3-.6a.8.8 0 0 1 .2-.9L14 4a.6.6 0 0 0 .1-.9l-1.3-1.5a.6.6 0 0 0-.8 0l-.6.6a.6.6 0 0 1-.6.1L10 2a.7.7 0 0 1-.6-.6V.8a.8.8 0 0 0-.8-.8H7.1a.8.8 0 0 0-.8.8v.7c0 .1-.1.3-.4.5l-.7.3a.8.8 0 0 1-.9-.2l-.4-.4a.6.6 0 0 0-.9-.1L1.6 3a.5.5 0 0 0 0 .8l.6.6a.8.8 0 0 1 .1.8l-.3.6a.7.7 0 0 1-.7.5H.5c-.2 0-.5.1-.5.4v2.2c0 .2.1.5.6.5h.7a.7.7 0 0 1 .7.4l.3.8a.7.7 0 0 1-.2.8l-.6.6a.4.4 0 0 0 0 .6l1.6 1.6s.3.3.7-.1l.6-.6a.7.7 0 0 1 .8-.1h.1l.5.2h.1a.6.6 0 0 1 .4.6v.8a.5.5 0 0 0 .4.5h2.1a.6.6 0 0 0 .6-.6v-.8a.7.7 0 0 1 .5-.6l.6-.2a.9.9 0 0 1 .9.1l.5.5a.6.6 0 0 0 .9 0l1.3-1.3c.3-.3.3-.6.1-.8l-.6-.6a.7.7 0 0 1-.2-.7v-.2l.3-.6a.8.8 0 0 1 .8-.5h.6c.1 0 .7-.1.7-.8V7.1c-.1-.7-.4-.8-.6-.8zm-7.3 5a3.5 3.5 0 1 1 3.5-3.5 3.5 3.5 0 0 1-3.5 3.5z"
  }));
},
    _extends$45 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$45(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var ShortText = function ShortText(e) {
  e.styles;

  var t = _objectWithoutProperties$45(e, ["styles"]);

  return React__default.createElement("svg", _extends$45({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, t), React__default.createElement("path", {
    d: "M21 26H5c-2.8 0-5-2.2-5-5V5c0-2.8 2.2-5 5-5h16c2.8 0 5 2.2 5 5v16c0 2.8-2.3 5-5 5zM5 2C3.3 2 2 3.3 2 5v16c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3V5c0-1.7-1.3-3-3-3H5z"
  }), React__default.createElement("path", {
    d: "M17.9 11.2c-.6 0-1-.4-1-1v-1H9.1v1c0 .6-.4 1-1 1s-1-.4-1-1v-2c0-.6.4-1 1-1h9.8c.6 0 1 .4 1 1v2c0 .6-.5 1-1 1z"
  }), React__default.createElement("path", {
    d: "M13 19.9c-.6 0-1-.4-1-1V8.2c0-.6.4-1 1-1s1 .4 1 1v10.6c0 .6-.5 1.1-1 1.1z"
  }), React__default.createElement("path", {
    d: "M15.2 19.9h-4.5c-.6 0-1-.4-1-1s.4-1 1-1h4.5c.6 0 1 .4 1 1s-.4 1-1 1z"
  }));
},
    _extends$46 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$46(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var SingleSelect = function SingleSelect(e) {
  e.styles;

  var t = _objectWithoutProperties$46(e, ["styles"]);

  return React__default.createElement("svg", _extends$46({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, t), React__default.createElement("path", {
    d: "M13 26C5.8 26 0 20.2 0 13S5.8 0 13 0s13 5.8 13 13-5.8 13-13 13zm0-24C6.9 2 2 6.9 2 13s4.9 11 11 11 11-4.9 11-11S19.1 2 13 2z"
  }), React__default.createElement("circle", {
    cx: "13",
    cy: "13",
    r: "7"
  }));
},
    _extends$47 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$47(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var SingleSelectGrid = function SingleSelectGrid(e) {
  e.styles;

  var t = _objectWithoutProperties$47(e, ["styles"]);

  return React__default.createElement("svg", _extends$47({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.9 26"
  }, t), React__default.createElement("circle", {
    cx: "6",
    cy: "6",
    r: "5"
  }), React__default.createElement("path", {
    d: "M6 12c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zM6 2C3.8 2 2 3.8 2 6s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm13.8 10c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zm0-10c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zM6 26c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zm0-10c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4z"
  }), React__default.createElement("circle", {
    cx: "19.8",
    cy: "20",
    r: "5"
  }), React__default.createElement("path", {
    d: "M19.8 26c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zm0-10c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4z"
  }));
},
    _extends$48 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$48(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var SkipLogic = function SkipLogic(e) {
  e.styles;

  var t = _objectWithoutProperties$48(e, ["styles"]);

  return React__default.createElement("svg", _extends$48({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.7 33.7"
  }, t), React__default.createElement("path", {
    d: "M16.9 33.7C7.5 33.7 0 26.2 0 16.9S7.5 0 16.9 0s16.9 7.5 16.9 16.9c-.1 9.3-7.6 16.8-16.9 16.8zm0-30.7C9.2 3 3 9.2 3 16.9s6.2 13.9 13.9 13.9 13.9-6.2 13.9-13.9C30.7 9.2 24.5 3 16.9 3z"
  }), React__default.createElement("path", {
    d: "M10.3 25.4c-.8 0-1.5-.7-1.5-1.5 0-6.2 5-11.2 11.2-11.2h2.2c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5H20c-4.5 0-8.2 3.7-8.2 8.2 0 .9-.7 1.5-1.5 1.5z"
  }), React__default.createElement("path", {
    d: "M19 20.2c-.8 0-1.5-.7-1.5-1.5 0-.4.2-.8.4-1.1l3.4-3.4-3.4-3.4c-.6-.6-.6-1.5-.1-2.1.6-.6 1.5-.6 2.1-.1 0 0 .1 0 .1.1l4.4 4.4c.6.6.6 1.5 0 2.1L20 19.6c-.2.4-.6.6-1 .6z"
  }));
},
    _extends$49 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$49(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Slider = function Slider(e) {
  e.styles;

  var t = _objectWithoutProperties$49(e, ["styles"]);

  return React__default.createElement("svg", _extends$49({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 19.3"
  }, t), React__default.createElement("path", {
    d: "M25 5.3H14.1c-.6 0-1-.4-1-1s.4-1 1-1H25c.6 0 1 .4 1 1s-.4 1-1 1zm-20.7 0H1c-.6 0-1-.4-1-1s.4-1 1-1h3.3c.6 0 1 .4 1 1s-.5 1-1 1zM25 16h-2.2c-.6 0-1-.4-1-1s.4-1 1-1H25c.6 0 1 .4 1 1s-.4 1-1 1zm-12 0H1c-.6 0-1-.4-1-1s.4-1 1-1h12c.6 0 1 .4 1 1s-.4 1-1 1z"
  }), React__default.createElement("path", {
    d: "M7.6 8.5c-2.4 0-4.3-1.9-4.3-4.3C3.3 1.9 5.2 0 7.5 0s4.3 1.9 4.3 4.3c0 2.3-1.9 4.2-4.2 4.2zm0-6.5C6.3 2 5.3 3 5.3 4.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3C9.8 3 8.8 2 7.6 2zm8.7 17.3c-2.4 0-4.3-1.9-4.3-4.3s1.9-4.3 4.3-4.3 4.3 1.9 4.3 4.3c-.1 2.4-2 4.3-4.3 4.3zm0-6.6c-1.3 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.2 0 2.3-1 2.3-2.3 0-1.3-1.1-2.3-2.3-2.3z"
  }));
},
    _extends$50 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$50(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var SortAsc = function SortAsc(e) {
  e.styles;

  var t = _objectWithoutProperties$50(e, ["styles"]);

  return React__default.createElement("svg", _extends$50({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.7 16"
  }, t), React__default.createElement("path", {
    d: "M8 6.9h4c.1 0 .2 0 .2-.1.1-.1.1-.1.1-.2V4.9c0-.1 0-.2-.1-.2-.1-.1-.1-.1-.2-.1H8c-.1 0-.2 0-.2.1-.1 0-.1.1-.1.2v1.7c0 .1 0 .2.1.2 0 0 .1.1.2.1zm0-4.6h2.3c.1 0 .2 0 .2-.1.1-.1.1-.1.1-.2V.3c0-.1 0-.2-.1-.2-.1-.1-.1-.1-.2-.1H8c-.1 0-.2 0-.2.1-.1 0-.1.1-.1.2V2c0 .1 0 .2.1.2 0 .1.1.1.2.1zM6 12.6H4.3V.3c0-.1 0-.2-.1-.2C4.2 0 4.1 0 4 0H2.3c-.1 0-.2 0-.2.1-.1 0-.1.1-.1.2v12.3H.3c-.1 0-.2.1-.3.2 0 .1 0 .2.1.3L3 16h.1c.1 0 .1 0 .2-.1l2.8-2.8c.1-.1.1-.1.1-.2s0-.2-.1-.2c.1-.1 0-.1-.1-.1zm9.6 1.2c-.1-.1-.1-.1-.2-.1H8c-.1 0-.2 0-.2.1-.1.1-.1.1-.1.2v1.7c0 .1 0 .2.1.2 0 .1.1.1.2.1h7.4c.1 0 .2 0 .2-.1.1-.1.1-.1.1-.2V14c0-.1 0-.2-.1-.2zM8 11.4h5.7c.1 0 .2 0 .2-.1.1-.1.1-.1.1-.2V9.4c0-.1 0-.2-.1-.2-.1-.1-.1-.1-.2-.1H8c-.1 0-.2 0-.2.1-.1.1-.1.1-.1.2v1.7c0 .1 0 .2.1.2 0 .1.1.1.2.1z"
  }));
},
    _extends$51 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$51(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var SortDesc = function SortDesc(e) {
  e.styles;

  var t = _objectWithoutProperties$51(e, ["styles"]);

  return React__default.createElement("svg", _extends$51({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.7 16"
  }, t), React__default.createElement("path", {
    d: "M10.3 13.7H8c-.1 0-.2 0-.2.1-.1.1-.1.1-.1.2v1.7c0 .1 0 .2.1.2 0 .1.1.1.2.1h2.3c.1 0 .2 0 .2-.1.1-.1.1-.1.1-.2V14c0-.1 0-.2-.1-.2-.1-.1-.1-.1-.2-.1zM6 12.6H4.3V.3c0-.1 0-.2-.1-.2C4.2 0 4.1 0 4 0H2.3c-.1 0-.2 0-.2.1-.1 0-.1.1-.1.2v12.3H.3c-.1 0-.2.1-.3.2 0 .1 0 .2.1.3L3 16h.1c.1 0 .1 0 .2-.1l2.8-2.8c.1-.1.1-.1.1-.2s0-.2-.1-.2c.1-.1 0-.1-.1-.1zm6-3.5H8c-.1 0-.2 0-.2.1-.1.1-.1.1-.1.2v1.7c0 .1 0 .2.1.2.1.1.1.1.2.1h4c.1 0 .2 0 .2-.1.1-.1.1-.1.1-.2V9.4c0-.1 0-.2-.1-.2s-.1-.1-.2-.1zm3.6-9c0-.1-.1-.1-.2-.1H8c-.1 0-.2 0-.2.1-.1 0-.1.1-.1.2V2c0 .1 0 .2.1.2 0 .1.1.1.2.1h7.4c.1 0 .2 0 .2-.1.1-.1.1-.1.1-.2V.3c0-.1 0-.2-.1-.2zm-1.9 4.5H8c-.1 0-.2 0-.2.1-.1 0-.1.1-.1.2v1.7c0 .1 0 .2.1.2h5.9c.1 0 .2 0 .2-.1.1 0 .1-.1.1-.1V4.9c0-.1 0-.2-.1-.2 0-.1-.1-.1-.2-.1z"
  }));
},
    _extends$52 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$52(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var SortRandomize = function SortRandomize(e) {
  e.styles;

  var t = _objectWithoutProperties$52(e, ["styles"]);

  return React__default.createElement("svg", _extends$52({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.5 26.5"
  }, t), React__default.createElement("path", {
    d: "M30.1 22.1h-9.3c-.5 0-.9-.2-1.2-.6L9.2 7.4H1.5C.7 7.4 0 6.7 0 5.9s.7-1.5 1.5-1.5H10c.5 0 .9.2 1.2.6l10.4 14.1h8.6c.8 0 1.5.7 1.5 1.5s-.8 1.5-1.6 1.5z"
  }), React__default.createElement("path", {
    d: "M10 22.1H1.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h7.7L19.6 5c.3-.4.7-.6 1.2-.6h9.3c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5h-8.6L11.2 21.5c-.3.4-.7.6-1.2.6z"
  }), React__default.createElement("path", {
    d: "M28.6 11.8c-.8 0-1.5-.7-1.5-1.5 0-.4.2-.8.4-1.1l3.3-3.3-3.3-3.3C27 2 27 1 27.6.4c.6-.5 1.5-.5 2 0L34 4.8c.6.6.6 1.5 0 2.1l-4.4 4.4c-.2.3-.6.5-1 .5zm0 14.7c-.8 0-1.5-.7-1.5-1.5 0-.4.2-.8.4-1.1l3.3-3.3-3.3-3.3c-.6-.6-.5-1.6.1-2.1s1.5-.5 2 0l4.4 4.4c.6.6.6 1.5 0 2.1l-4.4 4.4c-.2.3-.6.4-1 .4z"
  }));
},
    _extends$53 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$53(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var SortReverse = function SortReverse(e) {
  e.styles;

  var t = _objectWithoutProperties$53(e, ["styles"]);

  return React__default.createElement("svg", _extends$53({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.9 25.1"
  }, t), React__default.createElement("path", {
    d: "M18.7 25.1H2.1c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h16.6c3.9 0 7.1-3.2 7.1-7.1 0-3.9-3.2-7.1-7.1-7.1H3.4c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h15.3c5.6 0 10.1 4.5 10.1 10.1s-4.5 10.1-10.1 10.1z"
  }), React__default.createElement("path", {
    d: "M6.4 12.7c-.4 0-.8-.2-1.1-.4L.4 7.4c-.6-.6-.6-1.5 0-2.1L5.3.4c.6-.6 1.6-.5 2.1.1s.5 1.5 0 2L3.6 6.3l3.8 3.8c.6.6.6 1.5 0 2.1-.2.4-.6.5-1 .5z"
  }));
},
    _extends$54 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$54(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var SortSequential = function SortSequential(e) {
  e.styles;

  var t = _objectWithoutProperties$54(e, ["styles"]);

  return React__default.createElement("svg", _extends$54({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.1 22.5"
  }, t), React__default.createElement("path", {
    d: "M35.6 3.7H18.9c-.8 0-1.5-.7-1.5-1.5S18.1.7 18.9.7h16.7c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.5 1.5zm0 9.2H18.9c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h16.7c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.5 1.5zm0 9H18.9c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h16.7c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.5 1.5zM7.7 20.1c-.8 0-1.5-.7-1.5-1.5V1.5C6.2.7 6.8 0 7.7 0s1.5.7 1.5 1.5v17.1c0 .8-.7 1.5-1.5 1.5z"
  }), React__default.createElement("path", {
    d: "M7.7 22.5c-.4 0-.8-.2-1.1-.4L.5 15.9c-.6-.6-.6-1.5-.1-2.1s1.5-.6 2.1-.1c0 0 .1 0 .1.1l5.1 5.1 5.1-5.1c.5-.6 1.5-.7 2.1-.2.6.5.7 1.5.2 2.1-.1.1-.1.2-.2.2L8.7 22c-.3.3-.6.5-1 .5z"
  }));
},
    _extends$55 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$55(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Sum = function Sum(e) {
  e.styles;

  var t = _objectWithoutProperties$55(e, ["styles"]);

  return React__default.createElement("svg", _extends$55({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, t), React__default.createElement("path", {
    d: "M13 19.5c-.8 0-1.5-.7-1.5-1.5V7.9c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V18c0 .9-.7 1.5-1.5 1.5z"
  }), React__default.createElement("path", {
    d: "M18.1 14.5H7.9c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5H18c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.4 1.5z"
  }), React__default.createElement("path", {
    d: "M21 26H5c-2.8 0-5-2.2-5-5V5c0-2.8 2.2-5 5-5h16c2.8 0 5 2.2 5 5v16c0 2.8-2.2 5-5 5zM5 2C3.3 2 2 3.3 2 5v16c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3V5c0-1.7-1.3-3-3-3H5z"
  }));
},
    _extends$56 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$56(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Survey = function Survey(e) {
  e.styles;

  var t = _objectWithoutProperties$56(e, ["styles"]);

  return React__default.createElement("svg", _extends$56({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 32"
  }, t), React__default.createElement("path", {
    d: "M28.3 32c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5c1-.1 1.8-.9 1.7-1.9 0-.8.7-1.5 1.5-1.5s1.5.6 1.5 1.4c.1 2.7-2 4.9-4.7 5zM4.7 32c-2.6-.1-4.8-2.3-4.7-5v-7.1c0-.8.7-1.5 1.5-1.5h6.4c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5H3V27c-.1 1 .7 1.9 1.7 1.9 1-.1 1.8-.9 1.7-1.9 0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5c.1 2.7-2 4.9-4.7 5z"
  }), React__default.createElement("path", {
    d: "M28.3 32H4.7c-.8 0-1.5-.7-1.5-1.5S3.9 29 4.7 29c1-.1 1.8-.9 1.7-1.9V1.5C6.4.7 7.1 0 7.9 0h23.6c.8 0 1.5.7 1.5 1.5V27c0 .8-.7 1.5-1.5 1.5S30 27.9 30 27V3H9.4v24c0 .7-.1 1.3-.4 1.9h19.2c.8 0 1.5.7 1.5 1.5s-.6 1.6-1.4 1.6z"
  }), React__default.createElement("path", {
    d: "M25.6 10.8H13.8c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h11.9c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.6 1.5zm0 6.7H13.8c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h11.9c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.6 1.5zm0 6.6H13.8c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h11.9c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.6 1.5z"
  }));
},
    _extends$57 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$57(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var Undo = function Undo(e) {
  e.styles;

  var t = _objectWithoutProperties$57(e, ["styles"]);

  return React__default.createElement("svg", _extends$57({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.7 28.6"
  }, t), React__default.createElement("path", {
    d: "M18.4 28.6c-1.7 0-3.4-.3-5-.9-.8-.2-1.3-1-1.1-1.8s1-1.3 1.8-1.1c.1 0 .2.1.3.1 5.9 2.1 12.3-.9 14.5-6.7S28 5.8 22.2 3.7s-12.4.9-14.5 6.7c-.8 2.2-.9 4.6-.3 6.9.2.8-.3 1.6-1.1 1.8-.8.2-1.6-.3-1.8-1C2.4 10.5 6.9 2.7 14.5.5s15.5 2.3 17.6 10-2.3 15.5-9.9 17.6c-1.3.3-2.5.5-3.8.5z"
  }), React__default.createElement("path", {
    d: "M6 19.3c-.4 0-.8-.2-1.1-.4L.4 14.4c-.6-.6-.5-1.6.1-2.1s1.5-.5 2 0L6 15.6l3.4-3.4c.6-.6 1.6-.5 2.1.1s.5 1.5 0 2L7 18.8c-.2.3-.6.5-1 .5z"
  }));
},
    icons = Object.freeze({
  Add: Add,
  Alert: AlertIcon,
  Anchor: Anchor,
  BarChart: BarChart,
  Blurb: Blurb,
  BoxPlot: BoxPlot,
  Caret: Caret,
  Check: Check,
  Delete: Delete,
  DisplayLogic: DisplayLogic,
  Download: Download,
  Dropdown: Dropdown,
  Duplicate: Duplicate,
  Edit: PencilIcon,
  Ellipsis: Ellipsis,
  Export: Export,
  Grouping: Grouping,
  HorizontalBarChart: HorizontalBarChart,
  Interlock: Interlock,
  Info: Info,
  LineChart: LineChart,
  Link: Link,
  LinkBreak: LinkBreak,
  Lock: Lock,
  LongText: LongText,
  Merge: Merge,
  Message: Message,
  Move: Move,
  MultipleSelect: MultipleSelect,
  MultipleSelectGrid: MultipleSelectGrid,
  NoSymbol: NoSymbol,
  Numeric: Numeric,
  Padlock: Padlock,
  Paper: Paper,
  Pause: Pause,
  PieChart: PieChart,
  Play: Play,
  PlayFilled: PlayFilled,
  RadarChart: RadarChart,
  Ranking: Ranking,
  Rating: Rating,
  Redo: Redo,
  Respondent: Respondent,
  Search: Search,
  Settings: Settings,
  ShortText: ShortText,
  SingleSelect: SingleSelect,
  SingleSelectGrid: SingleSelectGrid,
  SkipLogic: SkipLogic,
  Slider: Slider,
  SortAsc: SortAsc,
  SortDesc: SortDesc,
  SortRandomize: SortRandomize,
  SortReverse: SortReverse,
  SortSequential: SortSequential,
  Sum: Sum,
  Survey: Survey,
  Undo: Undo
}),
    _extends$58 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$58(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var AE = function AE(e) {
  e.styles;

  var t = _objectWithoutProperties$58(e, ["styles"]);

  return React__default.createElement("svg", _extends$58({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 35"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#009D4A",
    d: "M.914 11.73h53.793V.626H.914z"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M.915 34.384h53.793V23.249H.915z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M.915 23.249h53.793V11.73H.915z"
  }), React__default.createElement("path", {
    fill: "#CD1225",
    d: "M.914 34.384h13.387V.626H.914z"
  })));
},
    _extends$59 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$59(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var AR = function AR(e) {
  e.styles;

  var t = _objectWithoutProperties$59(e, ["styles"]);

  return React__default.createElement("svg", _extends$59({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 33"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#74ACDF",
    d: "M.036.027H55v10.982H.036z"
  }), React__default.createElement("path", {
    fill: "#EEE",
    d: "M.036 11.009H55v10.982H.036z"
  }), React__default.createElement("path", {
    fill: "#74ACDF",
    d: "M.036 21.991H55v10.982H.036z"
  }), React__default.createElement("path", {
    d: "M27.31 16.586l1.879 4.087s.032.079.084.057c.053-.021.02-.1.02-.1l-1.566-4.216-.418.172zm-.046 1.59c-.023.622.36.964.31 1.52-.05.554.256.868.327 1.084.07.216-.077.345-.013.376.063.03.202-.14.157-.447-.045-.307-.279-.398-.224-1.076.055-.678-.278-.836-.197-1.454l-.36-.002z",
    fill: "#F6B40E"
  }), React__default.createElement("path", {
    d: "M27.343 16.571l.661 1.439.001-.009.073.01c-.007.047-.01.091-.012.134l1.156 2.513v.002s.019.044.037.036c.018-.007 0-.052 0-.052l-1.567-4.218.069-.025 1.567 4.217c.004.01.041.112-.04.146-.082.033-.128-.066-.133-.076l-1.081-2.351c.016.135.054.25.092.366.067.204.137.416.11.76-.036.439.051.626.127.789.041.088.08.17.096.279a.646.646 0 0 1-.042.372.293.293 0 0 1-.055.08.128.128 0 0 1-.07.04.075.075 0 0 1-.043-.007c-.056-.027-.041-.07-.02-.134a.379.379 0 0 0 .014-.263 1.193 1.193 0 0 0-.094-.193c-.115-.208-.271-.49-.234-.907.025-.27-.058-.49-.143-.72-.088-.235-.179-.48-.167-.796l.073.002c-.011.303.077.54.162.769.089.237.174.465.148.752-.035.394.115.665.225.865.043.077.08.143.1.205a.45.45 0 0 1-.014.31c-.01.027-.02.043-.018.044h.001c.007-.001.017-.008.028-.019a.22.22 0 0 0 .041-.06.574.574 0 0 0 .035-.33.85.85 0 0 0-.09-.258c-.08-.171-.171-.368-.134-.826a1.65 1.65 0 0 0-.105-.731 1.562 1.562 0 0 1-.105-.567l-.716-1.558.067-.03z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M27.292 16.5l.17 4.494s0 .084.056.085c.056 0 .056-.085.056-.085l.17-4.494h-.452zm-.651 1.452c-.26.565-.037 1.028-.296 1.521-.26.494-.097.9-.115 1.127-.017.227-.203.29-.156.342.047.053.241-.051.317-.352.076-.301-.105-.475.206-1.08.31-.605.063-.878.375-1.418l-.331-.14z",
    fill: "#F6B40E"
  }), React__default.createElement("path", {
    d: "M27.358 16.498l.06 1.59.063.036a1.414 1.414 0 0 0-.058.112l.095 2.503.16-4.241.132.005-.17 4.491s0 .15-.122.15c-.124 0-.123-.15-.123-.15l-.087-2.296a6.484 6.484 0 0 0-.007.087 1.75 1.75 0 0 1-.194.755c-.197.385-.188.587-.18.763.004.1.008.192-.02.303a.677.677 0 0 1-.19.342.325.325 0 0 1-.09.06.158.158 0 0 1-.098.01.103.103 0 0 1-.052-.031c-.059-.066-.023-.107.033-.17a.36.36 0 0 0 .106-.221 1.226 1.226 0 0 0-.013-.209c-.027-.24-.064-.565.135-.944.123-.234.131-.466.14-.707.01-.254.02-.517.154-.811l.12.055c-.124.27-.133.52-.142.76-.01.257-.018.503-.155.764-.18.342-.146.645-.12.869a1.3 1.3 0 0 1 .013.232.458.458 0 0 1-.023.114c.02-.04.04-.09.053-.145.024-.093.02-.176.016-.265-.008-.193-.018-.413.196-.829.148-.288.164-.5.18-.704.013-.18.026-.354.12-.566l-.064-1.708.132-.004zm.193 4.533c-.008.012-.011.022 0 .022.012 0 .008-.01 0-.022z",
    fill: "#85340A",
    fillRule: "nonzero"
  }), React__default.createElement("path", {
    d: "M27.31 16.414l-1.567 4.216s-.033.078.02.1c.052.021.084-.057.084-.057l1.88-4.087-.418-.172zm-1.16 1.092c-.456.424-.427.936-.856 1.293-.428.357-.435.794-.538.997-.103.203-.298.19-.275.257.023.066.242.044.428-.205.185-.25.085-.478.604-.919.519-.44.395-.787.891-1.167l-.253-.256z",
    fill: "#F6B40E"
  }), React__default.createElement("path", {
    d: "M27.372 16.437l-.555 1.492.045.058a1.424 1.424 0 0 0-.096.08l-.871 2.344 1.772-3.852.12.055-1.879 4.084s-.058.14-.17.093c-.108-.044-.063-.168-.057-.184l.801-2.157a6.834 6.834 0 0 0-.04.079c-.098.193-.2.395-.469.623-.33.28-.399.47-.46.636a.98.98 0 0 1-.134.272.678.678 0 0 1-.307.244.326.326 0 0 1-.105.02.158.158 0 0 1-.094-.028.103.103 0 0 1-.037-.049c-.029-.082.02-.107.096-.144a.363.363 0 0 0 .183-.164c.025-.05.045-.118.068-.197.067-.232.158-.547.486-.82.204-.17.3-.382.401-.6.106-.232.216-.471.453-.691l.09.096c-.218.203-.322.43-.423.649-.107.233-.21.458-.436.646-.298.248-.382.541-.445.756a1.188 1.188 0 0 1-.076.22.46.46 0 0 1-.066.099.699.699 0 0 0 .106-.116.876.876 0 0 0 .116-.238c.066-.181.142-.389.499-.691.247-.21.343-.4.436-.583.081-.16.16-.316.328-.477l.595-1.601.125.046zm-1.545 4.251c-.012.008-.018.016-.007.02.01.004.01-.007.007-.02z",
    fill: "#85340A",
    fillRule: "nonzero"
  }), React__default.createElement("path", {
    d: "M27.358 16.34l-3.064 3.298s-.06.06-.02.1c.04.04.1-.02.1-.02l3.304-3.058-.32-.32zm-1.49.568c-.583.217-.753.7-1.286.867-.533.166-.707.568-.88.716-.172.148-.348.061-.352.131-.005.07.207.134.473-.025.267-.16.262-.41.91-.618.65-.21.668-.577 1.271-.739l-.135-.332z",
    fill: "#F6B40E"
  }), React__default.createElement("path", {
    d: "M27.406 16.386l-1.084 1.166.02.071a1.414 1.414 0 0 0-.12.038l-1.705 1.834 3.115-2.884.09.097-3.301 3.056s-.107.106-.194.02c-.087-.086.02-.193.02-.193l1.566-1.685-.067.057c-.165.142-.337.29-.673.397-.411.133-.548.282-.667.412a.982.982 0 0 1-.229.2.679.679 0 0 1-.378.108.323.323 0 0 1-.105-.022.157.157 0 0 1-.076-.06v-.001a.103.103 0 0 1-.015-.06c.005-.087.06-.09.144-.096a.363.363 0 0 0 .232-.082c.042-.035.087-.091.138-.156.15-.189.356-.445.765-.572.252-.08.423-.237.6-.401.186-.173.38-.352.683-.465l.046.123c-.278.104-.462.274-.64.438-.187.175-.369.343-.65.43-.37.116-.56.354-.7.53a1.33 1.33 0 0 1-.156.174.462.462 0 0 1-.097.064.705.705 0 0 0 .34-.241c.13-.142.28-.305.725-.448.31-.1.471-.239.627-.372.137-.117.27-.231.486-.315l1.163-1.252.097.09zm-3.041 3.327c-.014.002-.023.006-.015.015.008.008.012-.002.015-.015z",
    fill: "#85340A",
    fillRule: "nonzero"
  }), React__default.createElement("path", {
    d: "M27.803 18.11c.03.596.369.86.302 1.404.146-.43-.206-.763-.186-1.399l-.116-.006zm-.506-1.567l1.288 2.807-1.079-2.893-.209.086z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M27.331 18.095c-.33.563.018.937-.427 1.414.494-.341.169-.784.6-1.363l-.173-.05zm.22-1.64l.186 3.085.186-3.085h-.372zm-.972 1.384c-.402.443-.349.87-.782 1.207.408-.201.396-.686.86-1.12l-.078-.087zm.753-1.464l-1.079 2.893 1.287-2.807-.208-.086z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M26.137 17.379c-.54.256-.656.67-1.185.816.454-.03.628-.482 1.224-.707l-.039-.11zm1.257-1.066l-2.106 2.261 2.265-2.102-.16-.159z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M27.431 16.292l-4.095 1.876s-.078.032-.057.084c.022.052.1.02.1.02l4.225-1.564-.173-.416zm-1.593-.045c-.623-.023-.965.36-1.522.31-.556-.05-.87.254-1.087.325-.216.07-.345-.076-.376-.013-.03.063.14.202.448.157.307-.045.398-.278 1.078-.223.679.054.837-.278 1.457-.197l.002-.36z",
    fill: "#F6B40E"
  }), React__default.createElement("path", {
    d: "M27.459 16.352l-1.45.663-.009.073a1.42 1.42 0 0 0-.125-.01l-2.28 1.043 3.986-1.475.046.124-4.225 1.564c-.015.006-.14.05-.183-.057-.047-.113.092-.17.093-.17l2.093-.96a7.072 7.072 0 0 0-.085.028 1.76 1.76 0 0 1-.773.11c-.432-.035-.616.05-.776.125a.987.987 0 0 1-.288.098.68.68 0 0 1-.39-.044.323.323 0 0 1-.088-.06.157.157 0 0 1-.047-.086.103.103 0 0 1 .009-.061c.038-.08.09-.062.17-.034.056.019.14.047.245.013a1.22 1.22 0 0 0 .188-.092c.212-.117.499-.275.925-.237.264.024.482-.057.709-.141.238-.089.486-.18.81-.169l-.005.132c-.298-.01-.533.076-.76.16-.24.09-.472.176-.765.15-.386-.035-.653.112-.85.22a1.287 1.287 0 0 1-.211.102.458.458 0 0 1-.115.023.707.707 0 0 0 .156-.007.868.868 0 0 0 .251-.087c.175-.08.376-.174.842-.137.325.027.527-.04.722-.103.171-.057.337-.111.57-.106l1.555-.712.055.12zm-4.098 1.881l-.013-.009c-.003.008-.006.012-.007.005l-.061.049-.062.048.143-.093zm.027.023c-.014-.003-.024-.003-.02.007l.02-.007zm-.076-.15l.05.062.038.044.014.017-.102-.123z",
    fill: "#85340A",
    fillRule: "nonzero"
  }), React__default.createElement("path", {
    d: "M27.518 16.274l-4.503.17s-.084 0-.085.056c0 .056.085.056.085.056l4.503.17v-.452zm-1.455-.65c-.566-.259-1.03-.036-1.524-.295-.495-.258-.902-.097-1.13-.114-.226-.017-.29-.203-.342-.156-.053.047.052.24.353.316.302.076.475-.104 1.082.206.606.31.88.063 1.421.375l.14-.332z",
    fill: "#F6B40E"
  }), React__default.createElement("path", {
    d: "M27.52 16.34l-1.593.06-.037.064a1.423 1.423 0 0 0-.111-.058l-2.507.094 4.248.16-.004.131-4.5-.169c-.001 0-.152 0-.152-.122 0-.123.15-.122.151-.122l2.301-.087-.088-.007a1.74 1.74 0 0 1-.756-.194c-.385-.196-.588-.188-.764-.18a.983.983 0 0 1-.304-.02.68.68 0 0 1-.343-.189.324.324 0 0 1-.059-.09.156.156 0 0 1-.01-.097.103.103 0 0 1 .03-.053h.001c.066-.058.107-.022.17.033.045.04.111.098.222.106.055.004.127-.004.209-.013.24-.027.566-.063.946.135.234.123.467.131.708.14.254.01.518.019.813.154l-.055.12c-.271-.124-.521-.134-.763-.142-.256-.01-.504-.019-.765-.155-.343-.18-.646-.146-.87-.12-.089.01-.166.018-.233.013a.462.462 0 0 1-.114-.023c.04.02.09.04.146.053.093.024.176.02.265.016.193-.008.414-.018.83.195.29.148.502.164.706.18.18.013.354.026.567.12l1.71-.064.005.131zm-4.475.193c-.012-.008-.022-.012-.022 0 0 .013.01.009.022 0z",
    fill: "#85340A",
    fillRule: "nonzero"
  }), React__default.createElement("path", {
    d: "M27.604 16.292l-4.224-1.564s-.079-.032-.1.02c-.022.052.057.084.057.084l4.095 1.876.172-.416zm-1.094-1.157c-.425-.455-.938-.426-1.296-.854-.357-.428-.796-.434-.999-.537-.203-.103-.19-.298-.257-.275-.066.023-.044.242.206.427.249.185.479.085.92.603.442.518.789.395 1.17.89l.256-.254z",
    fill: "#F6B40E"
  }), React__default.createElement("path", {
    d: "M27.581 16.354l-1.495-.553-.058.044a1.433 1.433 0 0 0-.08-.096l-2.35-.869 3.86 1.768-.054.12-4.092-1.874s-.14-.058-.094-.171c.045-.107.169-.063.184-.057l2.162.8a7.217 7.217 0 0 0-.079-.04 1.755 1.755 0 0 1-.624-.468c-.28-.329-.471-.398-.637-.458a.984.984 0 0 1-.273-.134.676.676 0 0 1-.245-.307.322.322 0 0 1-.02-.105.161.161 0 0 1 .028-.094.103.103 0 0 1 .05-.037c.082-.029.107.02.144.096a.363.363 0 0 0 .164.183c.05.025.118.045.198.067.232.067.548.158.822.486.17.203.382.3.601.4.232.106.472.216.692.452l-.097.09c-.203-.218-.43-.322-.65-.422-.233-.107-.459-.21-.648-.435-.248-.297-.541-.382-.757-.444-.086-.025-.161-.046-.22-.077a.46.46 0 0 1-.099-.066c.03.036.069.072.116.107a.88.88 0 0 0 .239.116c.181.065.389.141.692.497.21.247.401.343.584.435.161.082.317.16.478.328l1.604.594-.046.124zm-4.193-1.542c-.008-.011-.016-.018-.02-.007-.005.01.006.01.02.007z",
    fill: "#85340A",
    fillRule: "nonzero"
  }), React__default.createElement("path", {
    d: "M27.677 16.34l-3.303-3.058s-.06-.06-.1-.02c-.04.04.02.1.02.1l3.064 3.297.32-.319zm-.568-1.486c-.217-.583-.702-.753-.868-1.284-.167-.533-.57-.706-.718-.878-.148-.173-.061-.348-.132-.352-.07-.004-.134.206.026.473.16.266.41.26.62.908.209.648.577.666.739 1.269l.333-.136z",
    fill: "#F6B40E"
  }), React__default.createElement("path", {
    d: "M27.632 16.389l-1.168-1.082-.071.019a1.408 1.408 0 0 0-.038-.12l-1.838-1.701 2.89 3.11-.097.09-3.063-3.296s-.106-.106-.02-.193c.087-.087.193.02.194.02l1.688 1.562-.057-.067c-.142-.165-.29-.336-.398-.67-.133-.412-.282-.548-.412-.667-.074-.068-.142-.13-.201-.228a.675.675 0 0 1-.109-.378.321.321 0 0 1 .023-.104.157.157 0 0 1 .06-.076h.001a.103.103 0 0 1 .06-.015c.087.005.091.06.096.144.004.059.01.147.082.231.036.042.092.086.157.138.189.15.446.355.573.763.08.252.238.422.402.599.173.186.353.379.466.682l-.124.046c-.104-.278-.274-.462-.439-.638-.175-.188-.343-.37-.431-.65-.116-.37-.354-.56-.53-.699a1.302 1.302 0 0 1-.174-.155.461.461 0 0 1-.065-.097.702.702 0 0 0 .065.14c.05.083.11.14.177.2.142.13.305.279.449.723.1.309.239.47.372.625.118.137.232.27.316.486l1.255 1.16-.09.098zm-3.267-3.036c-.003-.013-.007-.022-.015-.015-.008.008.001.013.015.015z",
    fill: "#85340A",
    fillRule: "nonzero"
  }), React__default.createElement("path", {
    d: "M25.906 16.784c-.599.03-.863.369-1.408.302.43.146.765-.206 1.401-.186l.007-.116zm1.569-.504l-2.813 1.285 2.9-1.077-.087-.208z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M25.92 16.313c-.565-.33-.94.019-1.417-.425.342.492.785.168 1.366.598l.05-.173zm1.642.22l-3.09.186 3.09.185v-.37zm-1.386-.97c-.444-.4-.87-.348-1.21-.78.202.407.688.394 1.124.857l.086-.077zm1.467.751l-2.899-1.077 2.813 1.285.086-.208z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M26.638 15.122c-.257-.54-.671-.655-.818-1.183.03.453.483.627.708 1.221l.11-.038zm1.067 1.254l-2.266-2.102 2.107 2.261.159-.159z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M27.727 16.414l-1.88-4.088s-.032-.078-.084-.056c-.053.021-.02.1-.02.1l1.566 4.216.418-.172zm.045-1.59c.023-.622-.36-.964-.31-1.52.05-.554-.256-.868-.327-1.084-.07-.216.077-.345.013-.376-.063-.03-.203.14-.157.447.045.307.278.398.224 1.076-.055.678.278.836.197 1.454l.36.002z",
    fill: "#F6B40E"
  }), React__default.createElement("path", {
    d: "M27.666 16.441l-.665-1.446-.072-.01a.912.912 0 0 0 .01-.124l-1.046-2.275 1.478 3.977-.124.046-1.567-4.217c-.005-.015-.05-.139.057-.183.113-.047.171.093.171.093l.961 2.089-.028-.085a1.749 1.749 0 0 1-.11-.772c.035-.43-.05-.614-.125-.773a.987.987 0 0 1-.098-.288.675.675 0 0 1 .044-.389.323.323 0 0 1 .061-.088.158.158 0 0 1 .085-.047.104.104 0 0 1 .062.009c.079.038.061.09.034.17a.35.35 0 0 0-.013.244c.017.053.052.116.092.188.117.211.275.498.237.923-.024.264.057.481.141.707.09.238.181.485.17.808l-.133-.004c.011-.297-.076-.532-.16-.758-.09-.24-.176-.471-.15-.764.035-.385-.113-.652-.221-.848-.043-.079-.081-.147-.102-.21a.456.456 0 0 1-.023-.116.7.7 0 0 0 .007.156c.014.094.049.17.087.25.081.175.175.376.137.84-.026.325.04.527.104.721.057.172.111.337.106.57l.714 1.551-.12.055zm-1.836-4.09s.007-.007.01-.013c-.009-.003-.014-.005-.006-.007l-.097-.122.093.142zm-.005.027c.003-.014.003-.025-.007-.02l.007.02zm.083-.076l-.061.05-.044.038-.017.014.122-.102z",
    fill: "#85340A",
    fillRule: "nonzero"
  }), React__default.createElement("path", {
    d: "M27.744 16.5l-.17-4.494s0-.084-.056-.085c-.056 0-.056.085-.056.085l-.17 4.494h.452zm.651-1.452c.26-.565.037-1.028.296-1.521.259-.494.097-.9.114-1.127.018-.227.203-.29.157-.342-.048-.053-.241.051-.317.352-.076.301.105.475-.206 1.08-.31.605-.063.878-.376 1.418l.332.14z",
    fill: "#F6B40E"
  }), React__default.createElement("path", {
    d: "M27.678 16.502l-.06-1.59-.064-.036c.022-.039.042-.076.058-.112l-.094-2.502-.16 4.24-.132-.004.17-4.492h-.001s0-.151.123-.151c.123.001.123.15.123.151l.086 2.296.007-.087c.017-.217.034-.442.194-.755.197-.385.189-.587.181-.763-.004-.1-.008-.192.02-.303a.677.677 0 0 1 .19-.342.326.326 0 0 1 .09-.059.158.158 0 0 1 .097-.011.11.11 0 0 1 .053.031c.058.066.022.107-.033.17a.36.36 0 0 0-.107.222c-.004.055.004.126.013.208.027.24.064.566-.135.944-.122.234-.13.466-.14.707-.009.254-.019.517-.154.811l-.12-.055c.124-.27.133-.52.142-.76.01-.257.019-.503.155-.764.18-.342.146-.645.121-.868a1.31 1.31 0 0 1-.014-.233.462.462 0 0 1 .023-.114.706.706 0 0 0-.053.145.884.884 0 0 0-.016.265c.008.193.018.413-.195.829a1.638 1.638 0 0 0-.18.705c-.014.18-.027.353-.12.566l.064 1.706-.132.005zm-.127-4.467c.007-.011.011-.022 0-.022-.012 0-.008.01 0 .022z",
    fill: "#85340A",
    fillRule: "nonzero"
  }), React__default.createElement("path", {
    d: "M27.727 16.586l1.566-4.216s.033-.078-.02-.1c-.052-.021-.084.057-.084.057l-1.88 4.087.418.172zm1.158-1.092c.456-.424.428-.936.856-1.293.429-.357.436-.794.538-.997.103-.203.3-.19.276-.257-.023-.066-.243-.044-.428.205-.185.25-.085.478-.604.919-.519.44-.396.787-.891 1.167l.253.256z",
    fill: "#F6B40E"
  }), React__default.createElement("path", {
    d: "M27.664 16.563l.555-1.492-.045-.058c.035-.027.067-.053.096-.08l.871-2.345-1.772 3.853-.12-.055 1.878-4.084s.059-.14.171-.093c.107.044.063.168.057.184l-.801 2.157.04-.079c.098-.193.2-.395.469-.623.33-.28.399-.47.46-.636a.98.98 0 0 1 .133-.272.677.677 0 0 1 .308-.244.325.325 0 0 1 .105-.02c.038 0 .07.01.094.028.017.012.03.03.037.049.029.083-.02.107-.096.144a.362.362 0 0 0-.183.164 1.22 1.22 0 0 0-.068.197c-.067.232-.158.547-.487.82-.203.17-.3.382-.4.6-.107.232-.216.471-.453.691l-.09-.096c.218-.203.322-.43.422-.649.107-.233.21-.458.436-.646.298-.249.383-.541.445-.756a1.29 1.29 0 0 1 .077-.22.457.457 0 0 1 .066-.1.701.701 0 0 0-.106.117.877.877 0 0 0-.117.238c-.065.181-.141.389-.498.691-.247.21-.343.4-.436.583-.082.16-.16.316-.329.477l-.594 1.601-.125-.046zm1.611-4.185c.012-.008.018-.016.007-.02-.01-.004-.01.007-.007.02z",
    fill: "#85340A",
    fillRule: "nonzero"
  }), React__default.createElement("path", {
    d: "M27.678 16.66l3.064-3.298s.06-.06.02-.1c-.04-.04-.1.02-.1.02l-3.304 3.058.32.32zm1.49-.568c.583-.217.753-.7 1.286-.867.533-.166.707-.568.88-.716.172-.148.348-.061.352-.131.004-.07-.207-.134-.474.025-.266.16-.261.41-.91.618-.649.21-.667.577-1.27.739l.135.332z",
    fill: "#F6B40E"
  }), React__default.createElement("path", {
    d: "M27.63 16.614l1.084-1.166-.02-.071a1.13 1.13 0 0 0 .12-.038l1.705-1.834-3.116 2.884-.09-.097 3.302-3.056s.106-.106.193-.02c.088.086-.019.193-.02.193l-1.565 1.685.067-.057c.165-.142.337-.29.672-.397.412-.133.55-.282.668-.412a.982.982 0 0 1 .229-.2.678.678 0 0 1 .378-.108c.04.002.076.01.104.022a.157.157 0 0 1 .077.06v.001a.103.103 0 0 1 .015.06c-.006.087-.06.09-.144.096a.363.363 0 0 0-.232.082 1.225 1.225 0 0 0-.138.156c-.151.189-.356.445-.765.573-.253.078-.423.236-.6.4-.186.173-.38.352-.683.465l-.047-.123c.28-.104.463-.274.64-.438.188-.175.37-.343.65-.43.37-.116.561-.354.701-.53.056-.07.104-.13.156-.174a.46.46 0 0 1 .097-.064.704.704 0 0 0-.141.065.896.896 0 0 0-.2.176c-.13.142-.28.305-.724.449-.31.1-.472.238-.627.371-.137.118-.27.231-.486.315l-1.164 1.252-.096-.09zm3.107-3.26c.014-.003.023-.007.015-.016-.008-.008-.013.002-.015.015z",
    fill: "#85340A",
    fillRule: "nonzero"
  }), React__default.createElement("path", {
    d: "M27.233 14.89c-.03-.596-.369-.86-.302-1.404-.147.43.206.763.186 1.399l.116.006zm.505 1.567l-1.287-2.807 1.079 2.893.208-.086z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M28.104 14.905c.33-.563-.018-.937.427-1.414-.494.341-.168.784-.6 1.363l.173.05zm-.22 1.64l-.186-3.085-.186 3.085h.372z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M28.457 15.161c.401-.443.349-.87.781-1.207-.408.201-.395.686-.859 1.12l.078.087zm-.753 1.464l1.079-2.893-1.287 2.807.208.086z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M28.899 15.621c.54-.255.656-.67 1.185-.816-.454.03-.628.482-1.224.707l.039.11zm-1.257 1.066l2.106-2.261-2.265 2.102.16.159z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M27.604 16.708l4.096-1.876s.078-.032.056-.084c-.021-.052-.1-.02-.1-.02l-4.224 1.564.172.416zm1.594.045c.623.023.965-.36 1.521-.31.556.05.87-.254 1.087-.325.216-.07.346.076.377.013.03-.063-.14-.202-.448-.157-.307.045-.399.278-1.078.223-.68-.054-.838.278-1.457.197l-.002.36z",
    fill: "#F6B40E"
  }), React__default.createElement("path", {
    d: "M27.577 16.648l1.449-.663.01-.073c.043.006.085.01.124.01l2.28-1.043-3.986 1.475-.046-.124 4.225-1.564c.016-.006.14-.05.184.057.047.113-.093.17-.093.17l-2.093.96.085-.028c.207-.068.422-.138.773-.11.432.035.615-.05.775-.125a.987.987 0 0 1 .288-.098.68.68 0 0 1 .39.044c.037.018.067.04.089.06a.158.158 0 0 1 .047.086.103.103 0 0 1-.009.061c-.038.08-.09.062-.17.035a.363.363 0 0 0-.245-.014c-.053.017-.116.052-.188.092-.212.117-.5.275-.925.237-.264-.024-.483.057-.709.141-.239.089-.486.18-.81.169l.005-.132c.298.01.533-.076.759-.16.24-.09.473-.176.766-.15.386.035.653-.112.85-.22.078-.044.146-.081.21-.102a.461.461 0 0 1 .116-.023.707.707 0 0 0-.156.007c-.095.014-.17.049-.252.087-.174.08-.375.174-.841.137-.325-.027-.527.04-.722.104-.172.056-.338.11-.57.105l-1.555.712-.055-.12zm4.098-1.832l.013.009c.003-.008.005-.013.007-.005l.122-.097-.142.093zm.039-.006c.014.004.025.004.02-.007l-.02.007zm.063.084l-.051-.062-.037-.044-.014-.017.102.123z",
    fill: "#85340A",
    fillRule: "nonzero"
  }), React__default.createElement("path", {
    d: "M27.518 16.726l4.503-.17s.084 0 .085-.056c0-.056-.085-.056-.085-.056l-4.503-.17v.452zm1.455.65c.566.259 1.03.036 1.524.295.495.258.902.097 1.13.114.226.017.29.203.342.156.053-.047-.052-.24-.353-.316-.302-.076-.476.104-1.082-.206-.607-.31-.88-.063-1.421-.375l-.14.332z",
    fill: "#F6B40E"
  }), React__default.createElement("path", {
    d: "M27.516 16.66l1.593-.06.037-.064c.038.022.075.042.111.058l2.508-.094-4.25-.16.005-.131 4.5.169c.001 0 .152 0 .152.122 0 .123-.15.122-.151.122l-2.301.087.088.007c.217.016.443.033.756.194.385.196.588.188.764.18.1-.004.193-.008.304.02a.678.678 0 0 1 .343.189c.027.03.047.062.059.09a.157.157 0 0 1 .01.097.103.103 0 0 1-.03.053h-.001c-.066.058-.107.022-.17-.033a.362.362 0 0 0-.222-.106 1.238 1.238 0 0 0-.209.013c-.24.027-.566.063-.945-.135-.235-.122-.467-.131-.709-.14-.254-.01-.518-.019-.812-.154l.055-.12c.27.124.52.134.762.142.256.01.504.019.765.155.343.18.646.146.87.12.089-.01.166-.018.233-.013a.46.46 0 0 1 .115.023.705.705 0 0 0-.146-.053c-.094-.024-.176-.02-.266-.016-.193.008-.414.018-.83-.195a1.647 1.647 0 0 0-.706-.18 1.577 1.577 0 0 1-.567-.12l-1.71.064-.005-.131zm4.542-.127c.011.008.021.012.021 0 0-.013-.01-.008-.021 0z",
    fill: "#85340A",
    fillRule: "nonzero"
  }), React__default.createElement("path", {
    d: "M27.431 16.708l4.225 1.564s.078.032.1-.02c.022-.052-.057-.084-.057-.084l-4.095-1.876-.173.416zm1.095 1.157c.424.455.937.426 1.295.854.358.428.796.435 1 .537.202.103.19.298.256.275.067-.023.045-.242-.205-.427s-.479-.085-.92-.603c-.442-.518-.789-.395-1.17-.89l-.256.254z",
    fill: "#F6B40E"
  }), React__default.createElement("path", {
    d: "M27.455 16.646l1.495.553.058-.044c.026.035.053.067.08.096l2.349.869-3.86-1.768.055-.12 4.092 1.874s.14.058.093.171c-.044.107-.168.063-.184.057l-2.161-.8.078.04c.195.098.397.2.625.468.28.329.471.398.637.458a1 1 0 0 1 .273.134.676.676 0 0 1 .244.307c.014.039.02.075.02.105a.16.16 0 0 1-.027.094.103.103 0 0 1-.05.037c-.083.029-.107-.02-.144-.096a.363.363 0 0 0-.164-.183 1.227 1.227 0 0 0-.198-.067c-.232-.067-.548-.158-.822-.486-.17-.203-.382-.3-.601-.4-.232-.106-.472-.216-.692-.452l.097-.09c.202.218.43.322.65.422.233.107.458.21.647.435.249.298.542.382.758.444.086.025.161.047.22.077a.46.46 0 0 1 .098.065.703.703 0 0 0-.115-.106.88.88 0 0 0-.24-.116c-.18-.065-.388-.141-.692-.497a1.63 1.63 0 0 0-.583-.435 1.58 1.58 0 0 1-.478-.328l-1.605-.594.047-.124zm4.26 1.608c.007.011.015.018.02.007.003-.01-.008-.01-.02-.007z",
    fill: "#85340A",
    fillRule: "nonzero"
  }), React__default.createElement("path", {
    d: "M27.358 16.66l3.304 3.058s.06.06.1.02c.04-.04-.02-.1-.02-.1l-3.064-3.297-.32.319zm.569 1.486c.217.583.702.753.868 1.284.167.533.57.706.717.878.149.173.062.348.132.352.071.004.134-.206-.025-.473-.16-.266-.41-.26-.62-.908-.209-.648-.577-.666-.74-1.269l-.332.136z",
    fill: "#F6B40E"
  }), React__default.createElement("path", {
    d: "M27.403 16.611l1.17 1.082.07-.019c.012.043.024.083.038.12l1.838 1.701-2.89-3.11.097-.09 3.063 3.296s.106.106.02.193c-.087.087-.194-.02-.194-.02l-1.688-1.562.057.067c.142.165.29.336.398.67.133.412.282.548.412.667.074.068.142.13.2.228a.679.679 0 0 1 .11.378.323.323 0 0 1-.023.104.157.157 0 0 1-.061.076.103.103 0 0 1-.06.015c-.088-.005-.091-.06-.097-.143a.361.361 0 0 0-.081-.232c-.036-.042-.092-.086-.157-.138-.189-.15-.446-.355-.574-.763-.079-.252-.237-.422-.401-.599-.173-.186-.353-.379-.466-.682l.124-.046c.103.278.274.462.439.638.174.188.343.37.43.65.116.37.355.56.53.699.07.056.131.104.175.155a.46.46 0 0 1 .065.098.7.7 0 0 0-.066-.142.873.873 0 0 0-.176-.199c-.142-.13-.306-.279-.45-.723-.099-.309-.238-.47-.372-.626a1.573 1.573 0 0 1-.315-.485l-1.255-1.16.09-.098zm3.334 3.102c.003.013.007.022.015.015.008-.008-.001-.013-.015-.015z",
    fill: "#85340A",
    fillRule: "nonzero"
  }), React__default.createElement("path", {
    d: "M29.13 16.216c.598-.03.863-.369 1.408-.302-.43-.146-.765.206-1.402.186l-.006.116zm-1.569.504l2.813-1.285-2.9 1.077.087.208z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M29.116 17.085c.565.33.94-.018 1.417.426-.342-.493-.786-.168-1.366-.598l-.05.172zm-1.643-.22l3.091-.185-3.091-.185v.37z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M28.86 17.437c.444.4.87.348 1.209.78-.202-.407-.687-.394-1.123-.857l-.087.077zm-1.468-.751l2.9 1.077-2.813-1.285-.087.208z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M28.398 17.878c.257.54.671.655.818 1.183-.03-.453-.483-.627-.708-1.221l-.11.038zm-1.067-1.254l2.265 2.102-2.106-2.261-.159.159z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M29.353 16.5a1.833 1.833 0 0 1-1.835 1.831 1.833 1.833 0 0 1-1.835-1.831c0-1.011.822-1.831 1.835-1.831s1.835.82 1.835 1.831z",
    fill: "#F6B40E"
  }), React__default.createElement("path", {
    d: "M28.311 16.108c-.191 0-.375.209-.483.64.216.485.693.538 1.018-.055-.14-.378-.342-.585-.535-.585zm-.003.111c.187-.009.362.206.386.418-.216.594-.561.543-.778.11.095-.376.247-.522.392-.528z",
    fill: "#843511"
  }), React__default.createElement("path", {
    d: "M28.167 16.021c-.183 0-.226.043-.31.113-.085.07-.127.056-.141.07-.015.015 0 .057.027.043a.777.777 0 0 0 .17-.113c.085-.07.17-.07.254-.07.254 0 .395.211.424.197.028-.014-.142-.24-.424-.24z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M28.675 16.106c-.324-.282-.734-.324-.96-.113a.554.554 0 0 0-.105.235c-.028.161.022.334.148.512a.105.105 0 0 0-.057.028 1 1 0 0 1-.115-.643.93.93 0 0 1 .044-.16c.311-.254.735-.282 1.045.14z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M28.266 16.246a.127.127 0 1 1-.254 0 .127.127 0 0 1 .254 0z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M28.506 16.331c-.24.184-.48.17-.621.085-.141-.085-.141-.113-.113-.113.028 0 .057.028.17.085.112.056.282.056.564-.057zm-1.269.422a.127.127 0 0 0 .024.251c.042 0 .08-.02.104-.053a.27.27 0 0 0 .153.041h.016a.27.27 0 0 0 .153-.041.125.125 0 0 0 .103.053.127.127 0 0 0 .025-.251.085.085 0 0 1 .056.08.084.084 0 0 1-.085.085.085.085 0 0 1-.084-.08.21.21 0 0 1-.176.113.21.21 0 0 1-.175-.113.085.085 0 0 1-.085.08.084.084 0 0 1-.084-.085c0-.035.021-.068.055-.08zm.138.375c-.141 0-.197.128-.324.212.07-.028.126-.083.225-.14.099-.056.183.013.24.013h.001c.057 0 .141-.07.24-.013.099.057.156.112.227.14-.127-.084-.185-.212-.326-.212a.382.382 0 0 0-.14.043h-.003a.382.382 0 0 0-.14-.043z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M27.328 17.296a.752.752 0 0 0-.236.06c.255-.075.31.04.424.04h.002c.112 0 .169-.115.423-.04-.283-.113-.339-.038-.423-.038h-.002c-.054 0-.096-.028-.188-.022z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M27.105 17.339l-.054.001c.297.029.154.199.465.199h.002c.31 0 .17-.17.466-.199-.31-.028-.212.155-.466.155h-.002c-.238 0-.165-.16-.411-.156z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M27.772 17.796a.253.253 0 0 0-.508 0 .261.261 0 0 1 .508 0zm-1.395-1.69c.325-.282.734-.324.96-.113.055.074.09.153.105.235.029.161-.022.334-.148.512.015 0 .043.014.057.028.112-.214.152-.434.115-.643a.93.93 0 0 0-.044-.16c-.31-.254-.734-.282-1.045.14z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M26.885 16.021c.184 0 .226.043.31.113.086.07.128.056.142.07.014.015 0 .057-.028.043-.028-.014-.085-.042-.17-.113-.084-.07-.169-.07-.254-.07-.254 0-.395.211-.423.197-.028-.014.141-.24.423-.24z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M27.044 16.108c-.191 0-.375.209-.483.64.216.485.693.538 1.018-.055-.14-.378-.342-.585-.535-.585zm-.003.111c.187-.009.362.206.386.418-.216.594-.562.543-.778.11.095-.376.247-.522.392-.528z",
    fill: "#843511"
  }), React__default.createElement("path", {
    d: "M27.02 16.246a.127.127 0 1 1-.254 0 .127.127 0 0 1 .254 0z",
    fill: "#85340A"
  }), React__default.createElement("path", {
    d: "M26.546 16.331c.24.184.48.17.621.085.141-.085.141-.113.113-.113-.028 0-.056.028-.17.085-.112.056-.281.056-.564-.057z",
    fill: "#85340A"
  })));
},
    _extends$60 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$60(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var AT = function AT(e) {
  e.styles;

  var t = _objectWithoutProperties$60(e, ["styles"]);

  return React__default.createElement("svg", _extends$60({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 35"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#EC2938",
    d: "M.61 34.029h53.9V22.903H.61zm0-22.51h53.9V.316H.61z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M.61 22.903h53.9V11.518H.61z"
  })));
},
    _extends$61 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$61(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var AU = function AU(e) {
  e.styles;

  var t = _objectWithoutProperties$61(e, ["styles"]);

  return React__default.createElement("svg", _extends$61({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#060489",
    d: "M.894 33.914h54.317V.62H.894z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M34.005 15.469l-.974.65 1.087.106-.068 1.329.798-.92.798.92-.125-1.315 1.121-.12-.973-.703.633-1.146-1.097.497-.375-1.304-.373 1.304-1.098-.51zm-21.368 9.604l-2.169 1.451 2.421.234-.152 2.961 1.778-2.048 1.778 2.048-.277-2.932 2.497-.263-2.169-1.567 1.412-2.555-2.446 1.103-.833-2.904-.832 2.904-2.446-1.13zm28.227 2.797l-.975.652 1.087.104-.068 1.328.799-.918.798.918-.126-1.314 1.12-.118-.973-.704.635-1.146-1.098.495-.375-1.303-.373 1.303-1.097-.508zm6.009-14.512l-.974.651 1.085.104-.067 1.33.798-.919.798.92-.124-1.317 1.12-.118-.974-.703.636-1.146-1.1.495-.373-1.303-.373 1.303-1.099-.508zm-6.078-6.331l-.974.651 1.086.104-.067 1.33.798-.919.798.918-.124-1.315 1.12-.118-.975-.704.635-1.145-1.097.495-.374-1.304-.373 1.304-1.099-.509zm2.501 11.155h.78l.24-.874.303.831h.8l-.562.688.136.894-.645-.5-.662.522.17-.895z"
  }), React__default.createElement("path", {
    fill: "#060489",
    d: "M.894 17.146h27.075V.62H.894z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M24.778.62L16.65 5.628.894 15.287v1.859H3.92L27.969 2.39V.62z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M.894.62v1.848l24.059 14.678h3.016v-1.838L4.097.62z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M.894 6.07v5.56h27.075V6.097z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M12.165.62l.003 16.526h4.518L16.662.62z"
  }), React__default.createElement("path", {
    fill: "#FF0302",
    d: "M.894 7.205v3.29l27.075.027V7.205zM25.815.62l-8.95 5.469h2.078l8.916-5.47z"
  }), React__default.createElement("path", {
    fill: "#FF0302",
    d: "M13.07.62l-.022 16.526h2.688L15.758.62zM.894.62v1.157l6.959 4.3 2.01.002L.969.619zm8.969 11.009l-8.97 5.498v.02h2.012l8.923-5.518zm9.148 0l8.958 5.518v-1.258l-6.992-4.26z"
  })));
},
    _extends$62 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$62(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var BE = function BE(e) {
  e.styles;

  var t = _objectWithoutProperties$62(e, ["styles"]);

  return React__default.createElement("svg", _extends$62({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#000",
    d: "M.73 33.54h17.877V.228H.73z"
  }), React__default.createElement("path", {
    fill: "#EC2938",
    d: "M36.606 33.54h18.118V.228H36.606z"
  }), React__default.createElement("path", {
    fill: "#F9DF47",
    d: "M18.607 33.54h17.999V.228H18.607z"
  })));
},
    _extends$63 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$63(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var BG = function BG(e) {
  e.styles;

  var t = _objectWithoutProperties$63(e, ["styles"]);

  return React__default.createElement("svg", _extends$63({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 33"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#D52612",
    d: "M.904 32.717h53.792V21.768H.904z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M.904 10.887h53.792V.074H.904z"
  }), React__default.createElement("path", {
    fill: "#00956E",
    d: "M.904 21.768h53.792V10.887H.904z"
  })));
},
    _extends$64 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$64(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var BH = function BH(e) {
  e.styles;

  var t = _objectWithoutProperties$64(e, ["styles"]);

  return React__default.createElement("svg", _extends$64({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#FFF",
    d: "M14.191 26.814l8.136-3.294-8.136-3.294 8.204-3.294-8.17-3.294 8.17-3.293L14.26 7.05l8.102-3.328-8.22-3.26H.913v32.939h13.274l8.14-3.294z"
  }), React__default.createElement("path", {
    fill: "#CD1225",
    d: "M54.708.463H14.14l8.221 3.26L14.26 7.05l8.136 3.294-8.17 3.294 8.17 3.294-8.204 3.294 8.136 3.294-8.136 3.294 8.136 3.294-8.14 3.293h40.52z"
  })));
},
    _extends$65 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$65(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var BR = function BR(e) {
  e.styles;

  var t = _objectWithoutProperties$65(e, ["styles"]);

  return React__default.createElement("svg", _extends$65({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 35"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#009B3A",
    d: "M.59 34.284h54.008V.238H.59z"
  }), React__default.createElement("path", {
    fill: "#FEDF00",
    d: "M5.494 17.676l22.403-12.74 22.406 12.828L27.897 30.5z"
  }), React__default.createElement("path", {
    d: "M29.221 16.338c-4.527-1.448-8.285-1.051-9.85-.77a8.367 8.367 0 0 0-.272 2.119c0 4.703 3.9 8.428 8.707 8.428 3.887 0 7.18-2.404 8.3-5.842-.864-.87-2.845-2.447-6.885-3.935",
    fill: "#002776"
  }), React__default.createElement("path", {
    d: "M28.852 14.958a23.038 23.038 0 0 1 7.588 3.84 8.5 8.5 0 0 0 .075-1.111c0-4.706-3.901-8.386-8.709-8.386-3.568 0-6.638 1.969-7.982 4.975 1.766-.207 5.218-.381 9.028.682",
    fill: "#002776"
  }), React__default.createElement("path", {
    d: "M28.852 14.958c-3.81-1.063-7.262-.89-9.028-.682a8.234 8.234 0 0 0-.452 1.292c1.564-.281 5.322-.678 9.849.77 4.04 1.488 6.022 3.065 6.885 3.934.153-.474.266-.966.334-1.473a23.038 23.038 0 0 0-7.588-3.841m-1.358 4.015h.218l.096-.21.089.21h.224l-.16.142.054.209-.207-.14-.193.13.062-.2zm-.814.773h.165l.073-.155.065.155h.168l-.118.105.04.158-.155-.104-.145.099.045-.153zm.52.61h.107l.049-.103.042.103h.112l-.081.071.027.103-.1-.069-.096.065.03-.099zm.272 1.051h.234l.104-.224.095.224h.238l-.167.152.056.223-.222-.148-.208.14.066-.215zm1.03-1.692h.22l.096-.208.088.208h.223l-.156.143.051.208-.206-.14-.194.13.061-.198zm3.384 3.38h.22l.097-.21.088.21h.223l-.156.142.051.209-.206-.14-.194.13.061-.2zm.077.875h.151l.073-.147.062.146h.155l-.11.102.038.145-.145-.097-.138.093.042-.14zm-1.853-.675h.22l.097-.208.089.208h.222l-.157.142.053.209-.207-.137-.195.128.062-.2zm-2.406.97h.073l.031-.069.03.069h.073l-.052.047.017.069-.068-.046-.063.041.02-.064zm4.246-1.97h.15l.069-.144.06.144h.153l-.11.097.037.142-.14-.093-.134.087.043-.136zm.907.161h.148l.069-.144.059.144h.154l-.11.098.038.14-.141-.092-.134.089.043-.137zm.65-.456h.19l.086-.182.078.182h.194l-.137.123.046.183-.18-.12-.17.113.051-.176zm.538-.665h.196l.087-.186.08.186h.2l-.14.127.045.186-.185-.123-.173.117.054-.18zm.849-.673h.194l.087-.187.08.187h.199l-.139.126.046.187-.186-.124-.173.117.055-.18zm-1.266-.088h.231l.106-.221.094.221h.234l-.165.151.055.222-.218-.147-.206.138.063-.213z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M29.944 17.23h.167l.075-.16.067.16h.17l-.12.11.039.16-.156-.106-.15.1.048-.154zm.221-2.222h.24l.11-.232.098.232h.245l-.172.156.058.233-.229-.155-.216.145.069-.223zm.805 7.57h.147l.07-.145.062.145h.151l-.109.098.036.142-.14-.095-.135.09.043-.137zm-1.469-.214h.16l.07-.152.066.152h.162l-.115.104.04.153-.154-.1-.14.094.045-.147zm-5.352-4.394h.218l.097-.21.09.21h.222l-.157.142.053.21-.208-.139-.192.128.06-.2zm-3.854-1.872h.243l.111-.234.097.233h.25l-.176.157.058.235-.229-.155-.218.146.067-.226zm2.618 4.376h.218l.098-.209.088.21h.221l-.154.143.05.208-.206-.139-.195.13.061-.199zm-2.891-.056h.216l.099-.211.09.21h.222l-.157.143.05.208-.205-.14-.193.132.062-.2zm3.935 1.676h.232l.11-.225.095.225h.239l-.17.152.056.225-.22-.148-.21.139.064-.216zm-1.213-.732h.162l.07-.154.067.154h.163l-.114.104.037.154-.153-.103-.142.096.046-.147zm-.634-2.174h.119l.055-.116.046.116h.122l-.085.076.029.114-.112-.076-.106.073.033-.11zm-1.033.436h.234l.107-.226.096.226h.24l-.17.154.058.226-.224-.15-.21.142.065-.218z"
  }), React__default.createElement("path", {
    d: "M21.131 14.727h.262c.037 0 .067-.004.094-.007a.277.277 0 0 0 .064-.024.107.107 0 0 0 .037-.043.186.186 0 0 0 .011-.066c0-.047-.015-.082-.047-.102-.029-.023-.078-.034-.14-.034h-.28v.276zm.62.44h-.128l-.08-.215c-.01-.019-.018-.037-.033-.053a.134.134 0 0 0-.042-.04.224.224 0 0 0-.056-.027.22.22 0 0 0-.064-.009h-.217v.344h-.117v-.806h.391l.068.002a.353.353 0 0 1 .06.007.34.34 0 0 1 .057.014.21.21 0 0 1 .11.109c.014.03.02.06.02.094a.219.219 0 0 1-.013.077.238.238 0 0 1-.039.063.267.267 0 0 1-.062.047.438.438 0 0 1-.082.027v.002c.06.017.107.066.14.145l.087.22zm.929-.454a.514.514 0 0 0-.014-.123.228.228 0 0 0-.054-.093.255.255 0 0 0-.103-.058.606.606 0 0 0-.162-.02h-.164v.597h.164a.544.544 0 0 0 .16-.021.242.242 0 0 0 .104-.058.237.237 0 0 0 .055-.096.545.545 0 0 0 .014-.128m.121 0c0 .264-.15.396-.453.396h-.283v-.783h.283c.303 0 .453.13.453.387m1.034.419h-.673v-.806h.654v.096h-.534v.243h.498v.097h-.498v.274h.553zm1.086.077l-.098-.006.044-.682-.262.67-.09-.004-.176-.7-.044.686-.097-.007.051-.803.154.008.164.684.253-.658.153.007zm1.617.204l-.619-.092.107-.668.602.088-.015.082-.49-.075-.033.204.46.068-.014.08-.459-.07-.037.228.512.076zm1.209-.128l.227.059a.458.458 0 0 0 .1.015.168.168 0 0 0 .073-.011.098.098 0 0 0 .05-.038.138.138 0 0 0 .03-.063.144.144 0 0 0 .005-.076.118.118 0 0 0-.037-.056.184.184 0 0 0-.061-.039.578.578 0 0 0-.08-.025l-.224-.059-.082.293zm-.009-.418l.335.085a.703.703 0 0 1 .128.044c.037.017.07.04.098.064a.24.24 0 0 1 .056.093.226.226 0 0 1-.005.123.234.234 0 0 1-.137.166.427.427 0 0 1-.268-.001l-.226-.059-.09.324-.117-.03.226-.809zm1.062.663l.255.082c.033.011.064.02.092.021a.183.183 0 0 0 .07 0 .1.1 0 0 0 .05-.03.153.153 0 0 0 .032-.058c.016-.044.012-.082-.01-.113a.258.258 0 0 0-.127-.075l-.268-.09-.095.262zm.45.611l-.122-.04-.008-.229a.15.15 0 0 0-.013-.06.136.136 0 0 0-.027-.052.219.219 0 0 0-.043-.043.404.404 0 0 0-.059-.029l-.209-.069-.117.326-.114-.036.272-.763.38.125a.305.305 0 0 1 .062.023c.022.006.04.016.057.025a.34.34 0 0 1 .05.031c.012.014.026.028.038.044a.23.23 0 0 1 .032.093.228.228 0 0 1-.052.165.182.182 0 0 1-.06.046.196.196 0 0 1-.075.026.458.458 0 0 1-.09-.002v.002c.054.036.083.096.087.183l.011.234zm1.587.545a.347.347 0 0 1-.18-.228.386.386 0 0 1 .06-.302.462.462 0 0 1 .11-.13.384.384 0 0 1 .134-.074.341.341 0 0 1 .147-.012.385.385 0 0 1 .146.05.378.378 0 0 1 .169.173.255.255 0 0 1 0 .208l-.097-.053a.125.125 0 0 0 .018-.069.141.141 0 0 0-.015-.066.237.237 0 0 0-.046-.062.329.329 0 0 0-.179-.088.237.237 0 0 0-.109.01.29.29 0 0 0-.097.058.386.386 0 0 0-.087.106.37.37 0 0 0-.052.125.242.242 0 0 0-.003.113c.005.032.02.065.04.094a.26.26 0 0 0 .086.07c.05.028.1.046.143.048a.253.253 0 0 0 .135-.02l.062-.103-.18-.102.05-.079.266.15-.206.341-.066-.034.021-.084c-.082.03-.17.015-.27-.04m.976-.023l.233.13c.032.016.06.03.085.039.027.008.05.01.069.01a.11.11 0 0 0 .056-.02.135.135 0 0 0 .044-.052c.025-.04.029-.076.014-.112a.293.293 0 0 0-.11-.098l-.246-.137-.145.24zm.319.686l-.112-.064.039-.226a.194.194 0 0 0 0-.06.186.186 0 0 0-.051-.107.217.217 0 0 0-.053-.04l-.192-.106-.18.299-.102-.06.419-.696.347.192.058.035a.316.316 0 0 1 .09.075.17.17 0 0 1 .03.05.21.21 0 0 1-.018.189.24.24 0 0 1-.052.06.195.195 0 0 1-.067.036.256.256 0 0 1-.166-.008v.002c.044.046.059.11.046.196l-.036.233zm.887.416l-.572-.325.426-.695.556.316-.051.082-.454-.256-.129.21.424.24-.05.084-.424-.241-.146.235.472.267zm.651.401a.436.436 0 0 1-.118-.1.316.316 0 0 1-.06-.106.28.28 0 0 1-.005-.108.32.32 0 0 1 .043-.104l.09.059a.186.186 0 0 0-.025.078.149.149 0 0 0 .012.075.212.212 0 0 0 .043.067c.02.02.043.039.07.057.026.018.053.028.076.038a.208.208 0 0 0 .071.014.125.125 0 0 0 .061-.015.122.122 0 0 0 .066-.093.097.097 0 0 0-.013-.057.554.554 0 0 0-.048-.07 5.07 5.07 0 0 0-.086-.09.912.912 0 0 1-.082-.092.307.307 0 0 1-.04-.084.17.17 0 0 1-.007-.077.181.181 0 0 1 .034-.074.213.213 0 0 1 .161-.089c.033 0 .07.002.107.012a.478.478 0 0 1 .208.136.33.33 0 0 1 .055.093.25.25 0 0 1 .01.098.219.219 0 0 1-.038.098l-.09-.058c.048-.087.018-.163-.087-.231a.27.27 0 0 0-.14-.052.115.115 0 0 0-.093.048.09.09 0 0 0-.019.043.08.08 0 0 0 .008.04.245.245 0 0 0 .035.055.73.73 0 0 0 .064.068l.055.055a.705.705 0 0 1 .051.058.315.315 0 0 1 .067.131.192.192 0 0 1-.003.07.206.206 0 0 1-.036.074.201.201 0 0 1-.075.07.242.242 0 0 1-.099.027.329.329 0 0 1-.224-.064m.903.583a.599.599 0 0 1-.134-.111.328.328 0 0 1-.072-.115c-.014-.038-.018-.075-.014-.112a.29.29 0 0 1 .042-.106l.1.065a.155.155 0 0 0-.022.08.18.18 0 0 0 .018.079c.012.027.03.05.053.073a.493.493 0 0 0 .164.108.214.214 0 0 0 .078.018.159.159 0 0 0 .065-.01c.02-.008.034-.023.048-.038a.096.096 0 0 0 .019-.055.138.138 0 0 0-.018-.062.626.626 0 0 0-.056-.074 2.583 2.583 0 0 0-.101-.097c-.037-.04-.07-.072-.094-.104a.402.402 0 0 1-.051-.09.172.172 0 0 1-.01-.08.182.182 0 0 1 .103-.136.245.245 0 0 1 .1-.021.421.421 0 0 1 .238.078c.046.028.082.06.112.093a.327.327 0 0 1 .066.1c.015.036.02.07.019.104a.213.213 0 0 1-.036.1l-.101-.065c.046-.09.009-.172-.11-.25a.332.332 0 0 0-.154-.06c-.045-.001-.078.013-.101.045a.097.097 0 0 0-.017.04c0 .015.002.03.012.048a.254.254 0 0 0 .04.056c.02.022.044.047.075.076l.06.059c.024.02.045.044.064.065a.531.531 0 0 1 .049.068.207.207 0 0 1 .028.072c.009.023.01.048.004.072a.225.225 0 0 1-.032.076.211.211 0 0 1-.08.068.316.316 0 0 1-.227.003.432.432 0 0 1-.127-.06m.922.5a.201.201 0 0 0 .174.035.27.27 0 0 0 .09-.041.394.394 0 0 0 .144-.185.265.265 0 0 0 .019-.095.214.214 0 0 0-.023-.083.193.193 0 0 0-.06-.065.196.196 0 0 0-.084-.038.2.2 0 0 0-.091 0 .38.38 0 0 0-.233.226.216.216 0 0 0-.02.097.186.186 0 0 0 .084.149m.42-.548a.335.335 0 0 1 .122.387.536.536 0 0 1-.206.264.426.426 0 0 1-.141.058.318.318 0 0 1-.144 0 .336.336 0 0 1-.136-.062.319.319 0 0 1-.143-.242.394.394 0 0 1 .02-.145.468.468 0 0 1 .083-.148.483.483 0 0 1 .266-.175.368.368 0 0 1 .28.063m-15.654-3.559a.215.215 0 0 0 .216-.147.39.39 0 0 0 .017-.23.334.334 0 0 0-.043-.089.187.187 0 0 0-.067-.057.186.186 0 0 0-.086-.022.216.216 0 0 0-.092.012.185.185 0 0 0-.073.05.288.288 0 0 0-.053.082.4.4 0 0 0-.016.23.242.242 0 0 0 .041.087c.017.025.04.045.068.06a.225.225 0 0 0 .088.024m.037-.679a.347.347 0 0 1 .323.26.47.47 0 0 1 .017.165.542.542 0 0 1-.038.162.369.369 0 0 1-.084.122.312.312 0 0 1-.12.075.384.384 0 0 1-.296-.015.406.406 0 0 1-.112-.09.414.414 0 0 1-.08-.299.403.403 0 0 1 .121-.287.331.331 0 0 1 .121-.073.333.333 0 0 1 .148-.02m9.675 1.782a.21.21 0 0 0 .093.005.236.236 0 0 0 .151-.109.393.393 0 0 0 .047-.11.355.355 0 0 0 .014-.118.233.233 0 0 0-.024-.095.166.166 0 0 0-.052-.071.223.223 0 0 0-.173-.042.214.214 0 0 0-.083.036.32.32 0 0 0-.07.072.477.477 0 0 0-.06.228.255.255 0 0 0 .022.097.212.212 0 0 0 .055.068.172.172 0 0 0 .08.039m.174-.667a.337.337 0 0 1 .265.311.525.525 0 0 1-.085.321.388.388 0 0 1-.106.104.332.332 0 0 1-.133.053.379.379 0 0 1-.287-.071.324.324 0 0 1-.093-.11.407.407 0 0 1-.039-.14.47.47 0 0 1 .017-.167.494.494 0 0 1 .07-.154.414.414 0 0 1 .108-.105.399.399 0 0 1 .133-.051.383.383 0 0 1 .15.009",
    fill: "#009B3A"
  })));
},
    _extends$66 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$66(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var CA = function CA(e) {
  e.styles;

  var t = _objectWithoutProperties$66(e, ["styles"]);

  return React__default.createElement("svg", _extends$66({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 35"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "red",
    d: "M40.506 34.293h13.501V.87H40.506zM0 34.293h13.434V.87H0z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M13.434 34.293h27.071V.87H13.434z"
  }), React__default.createElement("path", {
    d: "M27.251 23.418l.113 5.053h-.81l.202-5.053-.236-.3-5.233.636.405-1.175s.226-.481-.089-.774c-.316-.293-5.12-3.858-5.12-3.858l1.092-.492s.326-.063.201-.651c-.123-.587-.854-2.903-.854-2.903l2.824.555s.461.148.63-.345c.145-.422.322-1.005.37-1.163l.012-.042L23.1 15.39s.31.323.58.196c.315-.146.221-.568.221-.568-.202-1.048-1.038-5.13-1.038-5.13l1.497.765s.608.23.81-.178c.202-.41 1.823-3.218 1.823-3.218s1.635 2.855 1.838 3.265c.202.409.81.177.81.177l1.497-.765s-.836 4.082-1.038 5.13c0 0-.094.423.222.57.27.126.58-.196.58-.196l2.34-2.485.013.04c.047.16.224.744.37 1.166.17.492.63.345.63.345l2.823-.555s-.73 2.316-.855 2.903c-.123.587.203.65.203.65l1.091.493s-4.804 3.563-5.119 3.856c-.316.295-.09.776-.09.776l.405 1.174-5.164-.682-.297.299z",
    fill: "red"
  })));
},
    _extends$67 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$67(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var CH = function CH(e) {
  e.styles;

  var t = _objectWithoutProperties$67(e, ["styles"]);

  return React__default.createElement("svg", _extends$67({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#FF0302",
    d: "M.894 33.686h53.931V.247H.894z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M24.322 6.515h6.69v7.356h7.76v6.215h-7.79v7.302h-6.66v-7.302h-7.79v-6.243h7.79z"
  })));
},
    _extends$68 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$68(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var CL = function CL(e) {
  e.styles;

  var t = _objectWithoutProperties$68(e, ["styles"]);

  return React__default.createElement("svg", _extends$68({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#D52B1E",
    d: "M.915 33.758h53.946V17.013H.915z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M.915 17.013h53.946V.332H.915z"
  }), React__default.createElement("path", {
    fill: "#0039A6",
    d: "M.915 17.013h17.937V.332H.915z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M5.635 7.388h3.27l.979-2.853 1.045 2.853h3.27l-2.663 1.818 1.045 2.853-2.697-1.787-2.63 1.787 1.012-2.821z"
  })));
},
    _extends$69 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$69(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var CN = function CN(e) {
  e.styles;

  var t = _objectWithoutProperties$69(e, ["styles"]);

  return React__default.createElement("svg", _extends$69({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#DD2911",
    d: "M.894 33.912h54.239V.625H.894z"
  }), React__default.createElement("path", {
    fill: "#FEDD19",
    d: "M4.787 7.369h3.697l1.158-3.404L10.8 7.43h3.633l-2.958 2.093 1.222 3.372-3.021-2.06-3.024 2.184 1.094-3.465zm13.216-2.831l-1.2.249.846-.823-.654-1.133 1.072.5.836-.811-.128 1.08 1.18.48-1.2.29-.109 1.208zm1.994 2.977l1.073-.5-.172-1.228.88.853 1.094-.52-.538 1.041.837.896-1.244-.209-.558 1.061-.15-1.165zm.066 4.33h1.199l.322-1.25.45 1.146h1.18l-.88.665.365 1.146-1.03-.644-1.007.77.367-1.168zm-2.039 3.123l.816-.917v1.21l1.006.414-1.113.333v1.167l-.73-.958-1.18.292.73-.938-.6-.978z"
  })));
},
    _extends$70 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$70(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var CO = function CO(e) {
  e.styles;

  var t = _objectWithoutProperties$70(e, ["styles"]);

  return React__default.createElement("svg", _extends$70({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 35"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#FCD116",
    d: "M.56 17.678h54.314V.87H.56z"
  }), React__default.createElement("path", {
    fill: "#003893",
    d: "M.56 26.157h54.314v-8.479H.56z"
  }), React__default.createElement("path", {
    fill: "#CE1126",
    d: "M.56 34.351h54.314v-8.194H.56z"
  })));
},
    _extends$71 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$71(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var CZ = function CZ(e) {
  e.styles;

  var t = _objectWithoutProperties$71(e, ["styles"]);

  return React__default.createElement("svg", _extends$71({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#FFF",
    d: "M.84 17.075h54V.7h-54z"
  }), React__default.createElement("path", {
    fill: "#D61419",
    d: "M.84 33.635h54v-16.56h-54z"
  }), React__default.createElement("path", {
    fill: "#12457D",
    d: "M.84.7l26.932 16.375L.84 33.635z"
  })));
},
    _extends$72 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$72(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var DE = function DE(e) {
  e.styles;

  var t = _objectWithoutProperties$72(e, ["styles"]);

  return React__default.createElement("svg", _extends$72({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 35"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#000",
    d: "M.894 11.974h54.239V.849H.894z"
  }), React__default.createElement("path", {
    fill: "#FECD17",
    d: "M.894 34.296h54.239V23.081H.894z"
  }), React__default.createElement("path", {
    fill: "#DC0201",
    d: "M.894 23.081h54.239V11.973H.894z"
  })));
},
    _extends$73 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$73(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var DK = function DK(e) {
  e.styles;

  var t = _objectWithoutProperties$73(e, ["styles"]);

  return React__default.createElement("svg", _extends$73({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#C50D2F",
    d: "M23.933 14.666h30.791V.316H23.933zM.73 33.798h17.365V19.449H.73zm.001-19.132h17.365V.316H.731zm23.202 19.132h30.791V19.449H23.933z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M54.724 14.666v4.783h-30.79v14.349h-5.838v-14.35H.73v-4.782h17.366V.316h5.837v14.35z"
  })));
},
    _extends$74 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$74(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var ES = function ES(e) {
  e.styles;

  var t = _objectWithoutProperties$74(e, ["styles"]);

  return React__default.createElement("svg", _extends$74({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 33"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#FFC501",
    d: "M.036 8.259h54.857v16.482H.036z"
  }), React__default.createElement("path", {
    fill: "#C60B1E",
    d: "M.036 24.741h54.857v8.241H.036zm0-24.723h54.857v8.241H.036z"
  }), React__default.createElement("path", {
    d: "M11.063 14.707s-.033 0-.05-.01c-.019-.01-.074-.062-.074-.062l-.044-.032-.04-.055s-.047-.076-.025-.135a.167.167 0 0 1 .091-.097c.033-.017.102-.038.102-.038s.055-.024.073-.027l.084-.02.036-.018c.02-.007.044-.007.06-.01.013-.004.05-.016.072-.017.034-.002.088.006.106.006l.106.004c.025 0 .116-.008.142-.008.025 0 .044-.003.073 0 .029.004.08.021.095.028.015.007.102.038.135.049.033.01.113.024.15.04a.209.209 0 0 1 .077.072c.018.024.022.05.029.068a.122.122 0 0 1 0 .072.454.454 0 0 1-.033.052l-.04.066-.051.04s-.037.036-.066.032c-.03-.003-.325-.055-.515-.055s-.493.055-.493.055z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M11.556 15.042c.152 0 .373.064.468.09a.734.734 0 0 0 .051.014c.02 0 .047-.039.056-.054l.05-.076.04-.12c0-.002.025-.065.032-.094a.385.385 0 0 0 0-.122l-.006-.032c-.005-.028-.01-.06-.022-.09a.335.335 0 0 0-.074-.128.39.39 0 0 0-.1-.052c-.02-.01-.037-.017-.049-.024a1.606 1.606 0 0 1-.136-.09.319.319 0 0 0-.092-.05.16.16 0 0 0-.047-.002.338.338 0 0 1-.025.001c-.013 0-.042.004-.071.007a.71.71 0 0 1-.071.007.955.955 0 0 1-.062-.004l-.044-.003-.034-.004c-.022-.004-.05-.01-.071-.007a.23.23 0 0 0-.062.025l-.01.005a.12.12 0 0 1-.021.006.102.102 0 0 0-.037.013.418.418 0 0 0-.035.031l-.002.002a2.033 2.033 0 0 1-.084.038.43.43 0 0 0-.071.05c-.002 0-.07.04-.102.07-.03.029-.066.065-.088.172-.02.1.025.235.025.237l.04.099.042.057c.016.028.058.1.073.114.014.016.042.017.046.018.01-.004.305-.104.493-.104zm.52.135h-.006l-.049-.014c-.094-.026-.314-.09-.465-.09-.18 0-.462.093-.49.103h-.005a.078.078 0 0 1-.053-.02c-.019-.02-.072-.114-.075-.118l-.042-.058-.002-.003-.04-.102a.613.613 0 0 1-.027-.265c.024-.118.065-.159.095-.188.033-.032.1-.07.104-.072a.445.445 0 0 1 .074-.05l.082-.039a.355.355 0 0 1 .036-.032c.013-.009.028-.012.04-.015a.1.1 0 0 0 .02-.005l.01-.005a.222.222 0 0 1 .065-.026h.008a.4.4 0 0 1 .066.007l.032.004.045.003.06.004c.013 0 .042-.004.07-.007.03-.003.06-.007.073-.007l.024-.001a.196.196 0 0 1 .05.001.34.34 0 0 1 .097.053c.015.013.103.071.134.09l.049.022c.036.016.078.033.102.055a.357.357 0 0 1 .08.137.45.45 0 0 1 .025.1l.006.03a.438.438 0 0 1 0 .144 1.054 1.054 0 0 1-.034.1l-.04.122a.02.02 0 0 1-.002.004l-.05.076c-.002.002-.037.062-.068.062z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.47 14.283c0-.089.04-.16.089-.16.049 0 .089.071.089.16 0 .09-.04.162-.09.162-.048 0-.088-.073-.088-.162z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M11.96 14.163c-.224 0-.413.206-.413.45 0 .245.19.452.414.452.224 0 .414-.207.414-.452 0-.244-.19-.45-.414-.45zm0 .951a.5.5 0 1 1 .003-1.001.5.5 0 0 1-.002 1.001z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.52 14.283c0-.082.021-.148.049-.148s.05.066.05.148c0 .082-.022.148-.05.148-.028 0-.05-.066-.05-.148z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M12.007 14.18c-.11 0-.327.158-.327.447 0 .289.216.446.327.446.117 0 .334-.153.334-.446 0-.294-.217-.447-.334-.447zm0 .946c-.325 0-.496-.25-.496-.499s.17-.5.496-.5c.347 0 .504.26.504.5s-.157.5-.504.5z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.5 14.113c0-.031.026-.057.06-.057.032 0 .06.026.06.057 0 .031-.028.056-.06.056-.034 0-.06-.025-.06-.056z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M11.602 14.093v.038h-.092v-.038h.03v-.085h-.04v-.037h.04v-.037h.039v.037h.04v.037h-.04v.085z"
  }), React__default.createElement("path", {
    d: "M11.702 14.835h.526v-.084h-.168v-.485h.29v-.08h-.29v-.171h-.14v.17h-.29v.081h.29v.485h-.218v.084zm.666.09h-.807v-.264h.22v-.305h-.29v-.26h.29v-.171h.42v.17h.29v.261h-.29v.305h.167v.264z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M11.643 14.093v.038h-.164v-.038h.061v-.085h-.04v-.037h.04v-.037h.039v.037h.04v.037h-.04v.085z"
  }), React__default.createElement("path", {
    d: "M11.576 14.835h.787v-.084h-.348v-.485h.219v-.08h-.22v-.171h-.105v.17h-.22v.081h.22v.485h-.333v.084zm.893.09h-1v-.264h.334v-.305h-.22v-.26h.22v-.171h.318v.17h.219v.261h-.22v.305h.35v.264z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.56 14.177c-.038 0-.068-.028-.068-.064 0-.03.02-.055.05-.063l.005.017a.048.048 0 0 0-.039.046c0 .027.023.048.052.048.028 0 .051-.022.051-.048a.05.05 0 0 0-.036-.046l.004-.016a.066.066 0 0 1 .049.062c0 .036-.03.064-.068.064z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.56 14.697h-.31l-.008-.077-.015-.08-.015-.098c-.085-.113-.164-.187-.19-.171.006-.02.013-.036.03-.046.076-.045.233.064.351.242l.03.048h.256a.958.958 0 0 1 .03-.048c.117-.178.275-.287.35-.242.017.01.024.025.03.046-.026-.016-.104.058-.19.171l-.015.099-.015.08-.007.076h-.312z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M11.257 15.173h.608l.006-.138.015-.16.016-.206c.036-.093.11-.277.162-.335-.061-.007-.18.2-.276.49l-.014-.02c.112-.34.248-.553.312-.493a.114.114 0 0 0-.02-.053c-.071-.084-.227.135-.34.48a2.7 2.7 0 0 0-.03.096l-.002.008h-.266l-.002-.008a3.457 3.457 0 0 0-.023-.076l-.007-.02c-.115-.35-.268-.564-.34-.48a.123.123 0 0 0-.021.052c.065-.06.2.154.312.495l-.014.018c-.103-.314-.217-.49-.274-.489.052.06.125.242.16.335l.002.008.015.198.015.159.006.14zm.623.034h-.638l-.008-.169-.015-.158-.015-.194c-.104-.276-.165-.353-.178-.336l-.02.024.007-.043a.216.216 0 0 1 .034-.102c.081-.096.24.12.363.49l.007.02.02.07h.247l.028-.09c.12-.365.283-.585.362-.49a.217.217 0 0 1 .034.102l.006.041-.018-.022c-.014-.015-.073.06-.18.336l-.014.194-.015.16-.007.167z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.101 14.837a.305.305 0 0 0-.037-.07c.126-.037.301-.06.495-.06.195 0 .372.023.497.06l-.033.059a.431.431 0 0 0-.025.052 1.553 1.553 0 0 0-.44-.053c-.18 0-.352.023-.442.056a.322.322 0 0 0-.015-.044z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M11.113 15.467l.008.13a.53.53 0 0 1 .438-.277c.176.003.322.093.434.265.003-.047.01-.122.022-.24l.028-.26c-.127-.187-.302-.296-.484-.3-.182.004-.352.11-.482.3.009.066.023.19.032.324l.004.058zm.003.231v-.029l-.002-.015-.007.002c0-.018-.008-.124-.013-.209l-.005-.06c-.012-.162-.032-.3-.032-.302l-.007-.05.012-.018c.132-.202.308-.315.497-.319.191.004.368.117.5.319l.01.015-.006.049-.033.308c-.01.09-.023.242-.024.261l-.007-.01-.004.042c-.11-.179-.258-.27-.436-.274a.524.524 0 0 0-.439.284l-.001.006h-.003z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.56 14.997c.156 0 .33-.025.393-.04.043-.014.068-.032.064-.055a.042.042 0 0 0-.024-.025 1.607 1.607 0 0 0-.434-.051c-.17 0-.34.021-.434.051-.012.006-.021.015-.024.025-.004.023.021.041.064.054.064.016.238.04.394.04z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M11.593 14.907a.571.571 0 0 0-.463.271.295.295 0 0 0-.02.1.41.41 0 0 0 .062.235.65.65 0 0 0 .42.216.645.645 0 0 0 .42-.216.403.403 0 0 0 .062-.237.288.288 0 0 0-.02-.1.565.565 0 0 0-.461-.269zm0 .91a.653.653 0 0 1-.425-.217.597.597 0 0 1-.075-.341.482.482 0 0 1 .031-.164.572.572 0 0 1 .469-.277c.179 0 .362.108.467.275a.471.471 0 0 1 .032.164.592.592 0 0 1-.074.342.652.652 0 0 1-.425.219z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M12.064 14.697l-.038-.035s-.037.022-.083.016c-.045-.007-.06-.063-.06-.063s-.051.044-.093.04c-.042-.003-.07-.04-.07-.04s-.045.033-.085.03c-.04-.004-.078-.054-.078-.054s-.041.052-.081.056c-.04.003-.073-.035-.073-.035s-.018.038-.07.047c-.05.008-.094-.04-.094-.04s-.03.047-.064.06c-.035.01-.08-.019-.08-.019l-.013.028c-.005.01-.02.012-.02.012l.012.031c.124-.036.294-.059.486-.059s.366.023.492.06l.012-.035z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M11.56 15.101c.183 0 .356.125.486.352l.008-.133-.03-.166c-.012.038-.044.118-.082.086-.037-.037-.056-.24-.063-.35-.018.078-.055.23-.09.212-.035-.02-.06-.16-.07-.228-.014.056-.051.183-.085.164-.033-.019-.064-.207-.077-.298-.014.093-.047.29-.08.31a.014.014 0 0 1-.006.002c-.03 0-.054-.115-.066-.183-.01.08-.031.214-.07.251-.042.045-.08-.129-.095-.214-.01.09-.034.271-.062.332-.027.053-.063-.033-.08-.084l-.008.12a.311.311 0 0 1-.017.086l.006.09c.13-.225.3-.349.48-.349zm.497.477l-.008-.014c-.13-.232-.304-.36-.49-.36-.181 0-.353.126-.483.356l-.007.014-.019-.291.011-.009c.003-.001.011-.015.014-.047l.012-.166.004-.054.009.031c0 .002.03.116.057.116.006 0 .011-.004.015-.013.032-.068.06-.339.06-.342l.005-.058.008.05c0 .003.041.274.087.228.046-.044.063-.245.064-.253l.005-.07.009.058c0 .002.03.212.065.194.036-.02.075-.316.075-.319l.007-.051.006.051c0 .003.037.287.073.308h.005c.035 0 .074-.17.075-.172l.006-.03.005.041c0 .002.026.203.064.224h.003c.038 0 .083-.23.083-.232l.01-.052.004.078c0 .002.014.306.053.345.041.034.077-.09.077-.09l.006-.02.04.222h.009l-.004.07-.015.257z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.56 14.53l.019.003a.057.057 0 0 0-.004.024.07.07 0 0 0 .072.068c.032 0 .059-.02.069-.047 0 0 .007-.025.01-.025.001 0 .001.027.003.027.004.034.035.057.07.057a.07.07 0 0 0 .072-.068v-.008l.022-.023.013.029a.067.067 0 0 0-.007.03c0 .036.03.065.069.065a.069.069 0 0 0 .056-.03l.015-.018v.023c0 .022.01.043.032.046 0 0 .024.002.059-.025a.37.37 0 0 0 .051-.048l.002.027s-.033.055-.062.071c-.016.01-.042.02-.062.016-.02-.003-.035-.02-.043-.039a.099.099 0 0 1-.052.014.1.1 0 0 1-.092-.055.106.106 0 0 1-.156-.005.102.102 0 0 1-.07.027.105.105 0 0 1-.086-.044.106.106 0 0 1-.086.044.101.101 0 0 1-.07-.027.107.107 0 0 1-.082.037.1.1 0 0 1-.075-.032.1.1 0 0 1-.092.055.097.097 0 0 1-.051-.014c-.008.02-.022.036-.044.04-.02.003-.044-.007-.06-.017a.267.267 0 0 1-.066-.07l.004-.028s.019.022.052.048c.034.027.059.025.059.025.022-.003.032-.024.032-.046v-.023l.014.019a.068.068 0 0 0 .057.029.067.067 0 0 0 .062-.095l.012-.029.023.023v.008a.07.07 0 0 0 .07.068c.036 0 .067-.023.073-.057 0 0 0-.027.002-.027.003 0 .01.025.01.025a.071.071 0 0 0 .069.047.07.07 0 0 0 .071-.068c0-.009 0-.017-.003-.024l.019-.003z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M12.02 15.234l.004.043c.003.043.014.146.036.161a.01.01 0 0 0 .008.004c.017 0 .036-.038.048-.073.024-.065.052-.262.059-.31v-.026c-.01.043-.023.1-.04.166-.032.115-.056.124-.063.124h-.002c-.024-.016-.039-.112-.04-.251-.013.093-.037.15-.062.15-.043 0-.077-.155-.077-.345 0-.05.001-.098.005-.142l-.006-.064-.01.052v.021c0 .204-.036.364-.08.364-.04 0-.071-.116-.079-.28-.013.134-.042.222-.074.222-.044 0-.08-.161-.08-.36v-.084l-.007-.006-.008.007v.084c0 .198-.035.359-.08.359-.032 0-.061-.088-.073-.222-.008.164-.04.28-.08.28-.044 0-.08-.16-.08-.364v-.021l-.01-.052-.006.063c.005.05.006.102.006.143 0 .19-.035.345-.077.345-.026 0-.048-.054-.063-.146 0 .134-.016.23-.039.247h-.002c-.007 0-.032-.01-.063-.124a3.462 3.462 0 0 1-.041-.173l-.002.033c.008.051.037.245.062.309.014.042.037.088.054.071.024-.016.035-.118.038-.16l.004-.045.008.025c.014.04.03.06.047.06.037 0 .07-.095.084-.237l.005-.055.009.044c.018.09.042.138.07.138.028 0 .056-.06.074-.16l.006-.033.006.03c.017.075.04.12.064.12.032 0 .062-.073.08-.195l.007-.047.007.047c.017.12.048.194.079.194.024 0 .048-.044.064-.12l.007-.03.006.034c.017.1.046.16.075.16.027 0 .05-.047.068-.138l.009-.044.005.055c.013.142.047.237.084.237.017 0 .034-.02.047-.06l.009-.025zm.048.287a.016.016 0 0 1-.01-.005c-.019-.013-.035-.074-.046-.168-.014.033-.03.05-.048.05-.039 0-.075-.092-.094-.235-.02.081-.045.126-.072.126-.031 0-.061-.06-.082-.16-.02.074-.044.115-.07.115-.033 0-.065-.07-.086-.186-.022.118-.053.186-.087.186-.025 0-.05-.042-.07-.115-.02.1-.05.16-.08.16-.029 0-.054-.043-.074-.126-.018.143-.055.236-.094.236-.017 0-.033-.018-.047-.05-.01.094-.027.154-.047.168a.016.016 0 0 1-.01.004c-.024 0-.049-.065-.056-.085a2.535 2.535 0 0 1-.068-.346l-.002-.013.008-.227.011.065s.019.1.052.221c.027.103.048.108.052.108.018-.012.024-.099.024-.176v-.226l.03.18c.011.077.03.12.05.12.033 0 .06-.116.06-.265 0-.054-.002-.09-.005-.122l-.002-.017.018-.206.035.164-.001.022v.026c0 .16.027.285.063.285.032 0 .059-.1.063-.239v-.034c.001-.087.002-.124.011-.124.008 0 .01.035.015.099v-.001l.003.045c.008.115.033.195.06.195.036 0 .064-.125.064-.28 0-.04 0-.071-.002-.1l-.004-.045.032-.024.029.024-.005.047a1.07 1.07 0 0 0-.003.099c0 .154.029.28.064.28.027 0 .052-.082.06-.197l.003-.023v-.006c.005-.075.007-.113.015-.113.01 0 .01.037.01.11l.001.015.001.034c.004.138.03.238.063.238.035 0 .063-.125.063-.285v-.027l-.002-.021.035-.163.019.204-.002.016a1.198 1.198 0 0 0-.006.124c0 .147.027.266.06.266.02 0 .04-.045.05-.12l.03-.178v.223c0 .038.002.161.025.176.004 0 .024-.005.053-.108.032-.12.05-.22.05-.22l.013-.076.004.238-.001.01c-.002.012-.035.266-.066.349-.007.02-.032.084-.057.084z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.56 14.708c-.195 0-.37.025-.496.063-.008.003-.019-.004-.021-.011a.018.018 0 0 1 .011-.022c.126-.04.306-.066.505-.066.2 0 .38.026.506.066a.02.02 0 0 1 .012.022c-.003.007-.013.014-.022.011a1.791 1.791 0 0 0-.496-.063z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M11.56 14.97c.189.006.366.198.498.542l.001.001c.004 0 .009-.029.01-.055a.522.522 0 0 0-.006-.083c-.13-.357-.314-.562-.504-.562s-.372.205-.502.562a.536.536 0 0 0-.006.088c0 .021.005.05.009.05.134-.345.31-.537.5-.543zm.5.694c-.003 0-.005-.003-.007-.009-.13-.34-.306-.53-.494-.536-.187.006-.362.197-.493.536-.011.032-.027-.042-.031-.146a1.759 1.759 0 0 1 .002-.164.503.503 0 0 1 .015-.114c.131-.36.316-.567.507-.567s.377.207.509.567a.658.658 0 0 1 .015.117c.003.052.004.108.002.16-.004.09-.015.156-.026.156z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.37 14.799a.05.05 0 0 1 .05-.05.05.05 0 0 1 .05.05.05.05 0 0 1-.1 0z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M11.863 14.982c-.145 0-.273.12-.273.259 0 .143.122.26.273.26.15 0 .27-.117.27-.26a.272.272 0 0 0-.27-.26zm0 .759a.5.5 0 0 1-.5-.5c0-.272.228-.5.5-.5.27 0 .5.228.5.5a.5.5 0 0 1-.5.5z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.561 14.847H11.5c-.011 0-.021-.023-.021-.05 0-.028.009-.05.02-.05h.127c.012 0 .022.022.022.05 0 .027-.01.05-.022.05h-.064z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M11.627 15.034c-.037 0-.067.088-.067.202 0 .113.032.209.07.209h.679c.038 0 .07-.096.07-.209 0-.115-.03-.202-.07-.202h-.682zm.682.705h-.679c-.088 0-.16-.225-.16-.503 0-.279.069-.497.157-.497h.682c.09 0 .16.219.16.497s-.072.503-.16.503z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.248 14.849l-.044.013c-.012.003-.023-.011-.025-.031-.001-.021.006-.04.017-.043l.046-.012.045-.013c.012-.003.022.01.024.03.002.02-.006.04-.017.043l-.046.013z",
    fill: "#058E6E"
  }), React__default.createElement("path", {
    d: "M11.972 14.993l-.62.195c-.044.017-.074.098-.069.194.007.072.046.132.092.132h.011l.601-.203c.045-.01.076-.098.071-.191-.006-.07-.042-.127-.086-.127zm-.597.761c-.101 0-.187-.141-.203-.337-.012-.23.057-.427.162-.466l.611-.193a.117.117 0 0 1 .027-.004c.098 0 .18.14.197.33.013.235-.062.438-.167.465l-.601.202c-.011.003-.018.003-.026.003z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#AD1519",
    d: "M11.067 14.88l.032-.072.068.019-.04.08z"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M11.115 14.898l-.06-.027.032-.073.068.02z"
  }), React__default.createElement("path", {
    d: "M11.692 14.799a.05.05 0 1 1 .1 0 .05.05 0 0 1-.1 0z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M12.188 14.982c-.151 0-.275.116-.275.259 0 .147.119.26.275.26a.26.26 0 0 0 .266-.26c0-.14-.122-.26-.266-.26zm0 .759a.497.497 0 0 1-.505-.5c0-.276.226-.5.505-.5.272 0 .495.224.495.5 0 .28-.217.5-.495.5z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.871 14.849l.045.013c.012.003.022-.011.025-.031 0-.021-.006-.04-.018-.043l-.045-.012-.046-.013c-.012-.003-.023.01-.024.03-.002.02.006.04.017.043l.046.013z",
    fill: "#058E6E"
  }), React__default.createElement("path", {
    d: "M12.006 14.994c-.052 0-.089.055-.093.128a.32.32 0 0 0 .013.125c.013.037.032.059.054.064l.615.203c.045 0 .084-.06.092-.145.005-.085-.025-.164-.072-.182l-.608-.193h-.001zm.59.76c-.008 0-.016 0-.024-.002l-.607-.203c-.05-.013-.097-.068-.129-.158a.768.768 0 0 1-.034-.306c.012-.2.111-.353.22-.328l.61.193c.107.039.178.234.166.457-.02.206-.105.347-.203.347z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#AD1519",
    d: "M12.089 14.89l-.028-.082-.072.01.035.09z"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M12.01 14.899l-.035-.09.073-.01.027.082z"
  }), React__default.createElement("path", {
    d: "M11.559 14.973c-.157 0-.3-.016-.407-.048.108-.032.25-.051.407-.052.157 0 .3.02.409.052a1.5 1.5 0 0 1-.41.048z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M11.197 15.378c.121.213.274.325.445.325.172 0 .326-.112.448-.325-.13-.228-.287-.352-.448-.352-.163.004-.319.128-.445.352zm.445.487c-.193 0-.363-.142-.491-.41a.272.272 0 0 1-.008-.077c0-.038.004-.07.008-.08.134-.274.309-.428.491-.433.18 0 .356.154.494.434.004.01.007.04.007.079a.263.263 0 0 1-.007.077c-.13.268-.3.41-.494.41z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M12.116 14.652c.01-.026 0-.053-.024-.06-.025-.004-.054.013-.066.04-.012.025 0 .052.025.059.023.005.053-.012.065-.04z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M12.601 14.849c-.072.004-.19.08-.246.205a.242.242 0 0 0 .007.209.111.111 0 0 0 .061.05l.015.001c.07 0 .179-.077.234-.202.045-.12 0-.242-.07-.263zm-.163.734a.416.416 0 0 1-.364-.2.475.475 0 0 1-.024-.42c.117-.255.394-.417.643-.372.267.08.384.352.284.609-.1.228-.32.383-.539.383z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.805 14.589c.003-.028-.015-.052-.04-.055-.026-.003-.051.019-.055.046-.003.027.014.052.038.054.026.002.051-.018.057-.045z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M12.229 14.793c-.073 0-.18.085-.196.218a.268.268 0 0 0 .065.22c.01.01.028.024.05.026l.019.135v-.134c.075 0 .179-.092.202-.215.016-.14-.07-.241-.14-.25zm-.062.732l-.053-.002a.428.428 0 0 1-.27-.12.497.497 0 0 1-.14-.419.528.528 0 0 1 .518-.459l.052.003c.27.032.453.273.422.548a.55.55 0 0 1-.53.45z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.381 14.589c-.005-.028.013-.052.038-.055.025-.003.05.019.054.046.005.027-.012.052-.038.054a.053.053 0 0 1-.054-.045z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M11.844 14.792a.13.13 0 0 0-.084.044.234.234 0 0 0-.05.207c.016.134.121.215.185.215v.134l.01-.135a.108.108 0 0 0 .072-.033.234.234 0 0 0 .054-.206c-.017-.138-.124-.226-.187-.226zm.05.733a.527.527 0 0 1-.515-.448.456.456 0 0 1 .113-.4.472.472 0 0 1 .298-.149l.054-.003c.26 0 .486.201.517.46a.452.452 0 0 1-.422.538l-.044.002z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.068 14.652c-.01-.026 0-.053.024-.06.025-.004.055.013.067.04.01.025 0 .052-.026.059-.023.005-.052-.012-.065-.04z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M11.461 14.853c-.068.017-.112.14-.063.263.062.136.186.201.245.196a.098.098 0 0 0 .061-.048c.036-.055.039-.14.009-.218-.053-.119-.17-.193-.252-.193zm.17.73c-.216 0-.433-.15-.538-.377-.104-.263.014-.534.26-.61a.476.476 0 0 1 .108-.013c.23 0 .458.155.557.376a.487.487 0 0 1-.026.43.42.42 0 0 1-.36.194z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M11.559 14.378l-.056.034.041.089.015.009.014-.01.041-.088z"
  }), React__default.createElement("path", {
    d: "M11.935 15.204l.058.032.057-.032.28-.527-.337-.18-.339.18.281.527zm.058.164l-.157-.09-.344-.645.5-.265.5.265-.342.646-.157.09z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M11.437 14.525l.026.048.087-.035.009-.015-.01-.017-.086-.033z"
  }), React__default.createElement("path", {
    d: "M11.57 14.977l.134.282.549-.254.025-.047-.03-.058-.542-.234-.137.311zm.087.486l-.23-.482.228-.518.664.287.108.21-.103.195-.667.308z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M11.68 14.525l-.025.048-.086-.035-.01-.015.01-.017.086-.033z"
  }), React__default.createElement("path", {
    d: "M11.723 15.005l.552.254.132-.282-.134-.31-.549.233-.027.056.026.049zm.601.458l-.672-.308-.103-.193.102-.212.675-.287.223.518-.225.482z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M11.198 14.418l-.043.04.056.075.014.005.011-.011.02-.089z"
  }), React__default.createElement("path", {
    d: "M11.734 15.248l.06.02.046-.043.144-.562-.377-.118-.28.233.407.47zm.097.16l-.183-.061-.504-.583.43-.356.57.179-.177.697-.136.124z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M11.107 14.58l.033.041.079-.057.006-.018-.011-.014-.09-.011z"
  }), React__default.createElement("path", {
    d: "M11.24 15.049l.178.245.517-.408.018-.06-.034-.05-.591-.074-.088.347zm.158.463l-.3-.413.147-.587.73.094.123.179-.067.229-.633.498z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M11.345 14.529l-.016.054-.09-.011-.012-.014.006-.019.079-.056z"
  }), React__default.createElement("path", {
    d: "M11.4 15.2l.586.082.088-.318-.18-.27-.51.396-.02.063.036.047zm.664.273l-.715-.1-.133-.174.075-.24.626-.486.3.449-.153.551z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M11.02 14.584l-.007.054-.09.012-.014-.01.002-.019.069-.071z"
  }), React__default.createElement("path", {
    d: "M11.043 15.327l.047.036.63-.09.038-.315-.235-.206-.472.514-.008.061zm.019.213l-.162-.124.032-.243.583-.633.385.335-.068.554-.77.11z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.194 14.56a.05.05 0 1 1 .1 0 .05.05 0 0 1-.1 0z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M11.684 14.718a.287.287 0 0 0-.288.285c0 .155.129.28.288.28a.288.288 0 0 0 .293-.28.29.29 0 0 0-.293-.285zm0 .783a.499.499 0 1 1 .001-.998.499.499 0 0 1 0 .998z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M11.921 14.418l.043.04-.055.075-.015.005-.011-.011-.02-.089z"
  }), React__default.createElement("path", {
    d: "M12.156 15.225l.045.042.06-.02.409-.47-.28-.232-.375.118.141.562zm.009.183l-.136-.124-.175-.697.57-.18.43.357-.506.583-.183.06z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M12.012 14.58l-.033.041-.079-.057-.006-.018.012-.014.09-.011z"
  }), React__default.createElement("path", {
    d: "M12.052 14.884l.512.41.179-.245-.084-.347-.587.076-.039.05.02.056zm.53.628l-.622-.497-.076-.231.138-.179.72-.093.142.587-.301.413z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M11.774 14.529l.016.054.09-.011.013-.014-.007-.019-.078-.056z"
  }), React__default.createElement("path", {
    d: "M11.906 14.964l.088.318.588-.082.036-.048-.02-.063-.509-.396-.183.27zm.01.51l-.152-.552.303-.449.625.486.072.24-.131.175-.717.1z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M12.087 14.584l.007.054.09.012.014-.01-.003-.019-.068-.071z"
  }), React__default.createElement("path", {
    d: "M12.26 15.273l.626.09.044-.034-.011-.062-.468-.514-.232.204.041.316zm.654.267l-.765-.11-.071-.554.382-.336.575.63.043.243-.164.127z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.528 14.532a.05.05 0 0 1 .05-.051.05.05 0 0 1 .05.05.05.05 0 0 1-.1 0z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M12.016 14.69a.288.288 0 0 0-.287.287c0 .15.132.277.287.277.16 0 .294-.127.294-.277a.29.29 0 0 0-.294-.286zm0 .783a.497.497 0 0 1-.497-.496c0-.278.223-.504.497-.504a.499.499 0 1 1 0 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.862 14.56a.05.05 0 0 1 .05-.05.05.05 0 1 1-.05.05z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M12.354 14.718c-.16 0-.29.128-.29.285 0 .155.13.28.29.28.16 0 .29-.125.29-.28a.288.288 0 0 0-.29-.285zm0 .783a.5.5 0 1 1-.001-.999.5.5 0 0 1 .001.999z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M10.901 14.64c0 .001-.025-.036-.043-.054-.014-.014-.046-.025-.046-.025 0-.006.019-.02.039-.02.012 0 .023.005.03.014l.003-.015s.016.004.023.024c.008.022.004.054.004.054s-.004.015-.01.022z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M11.012 14.765c.095.04.227.102.304.177.105.104.232.27.31.37a.645.645 0 0 0 .02-.067s.033-.238-.027-.39a.262.262 0 0 0-.075-.11l-.036.186-.1-.131a.25.25 0 0 0-.2-.093.385.385 0 0 0-.196.058zm.625.765c-.038 0-.045-.008-.127-.115a3.888 3.888 0 0 0-.294-.356c-.084-.08-.288-.16-.36-.182l-.052-.018V14.8c0-.118.215-.253.404-.253.075 0 .149.02.21.057l.014-.074.074.018c.007.003.175.045.25.246.077.195.038.472.036.484a.669.669 0 0 1-.098.225l-.022.027h-.035z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M10.903 14.617c.016-.018.047-.013.069.008.023.02.03.053.015.07-.015.018-.046.014-.068-.009-.023-.021-.031-.053-.016-.07z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M11.267 14.86a.149.149 0 0 0-.107.04c-.015.016-.022.04-.022.074a.382.382 0 0 0 .131.241.348.348 0 0 0 .235.116c.03 0 .073-.008.1-.042a.097.097 0 0 0 .031-.082.372.372 0 0 0-.13-.24.372.372 0 0 0-.238-.107zm.237.738a.574.574 0 0 1-.4-.181.647.647 0 0 1-.217-.433.374.374 0 0 1 .095-.274c.161-.168.478-.145.686.054a.63.63 0 0 1 .219.436.374.374 0 0 1-.101.275.362.362 0 0 1-.282.123z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M12.21 14.64c0 .001.025-.036.044-.054a.142.142 0 0 1 .045-.025c0-.006-.019-.02-.04-.02a.037.037 0 0 0-.03.014l-.002-.015s-.016.004-.024.024c-.008.022-.002.054-.002.054s.002.015.009.022z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M12.45 14.743a.293.293 0 0 0-.084.114c-.054.148-.012.391-.012.393a.388.388 0 0 0 .017.061 3.4 3.4 0 0 1 .313-.37.984.984 0 0 1 .298-.175.394.394 0 0 0-.198-.06.246.246 0 0 0-.198.091l-.1.14-.036-.194zm-.093.787h-.033l-.022-.026a.56.56 0 0 1-.094-.223c-.002-.013-.05-.29.021-.486.086-.202.252-.244.26-.247l.075-.018.012.072a.409.409 0 0 1 .208-.055c.19 0 .406.135.406.253v.06l-.053.017c-.07.023-.273.101-.353.182-.105.1-.232.266-.308.366-.073.095-.08.105-.119.105z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M12.256 14.617c-.015-.018-.046-.013-.069.008-.023.02-.03.053-.016.07.016.018.047.014.07-.009.023-.021.03-.053.015-.07z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M12.781 14.86a.388.388 0 0 0-.244.107.376.376 0 0 0-.131.242c0 .033.006.059.021.075.034.04.079.047.11.047a.378.378 0 0 0 .242-.114.36.36 0 0 0 .127-.236c0-.036-.008-.063-.024-.08a.132.132 0 0 0-.1-.041zm-.244.738a.375.375 0 0 1-.381-.4.646.646 0 0 1 .221-.436c.22-.198.536-.22.684-.048a.379.379 0 0 1 .094.277.624.624 0 0 1-.214.43.609.609 0 0 1-.404.177z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M10.843 14.984h1.44v.377h-1.44z"
  }), React__default.createElement("path", {
    d: "M10.856 15.909h1.414v-.875h-1.414v.875zm1.44.062H10.83v-1h1.465v1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M10.994 15.612a.06.06 0 0 1 .027-.004h1.078c.01 0 .02.002.03.005a.09.09 0 0 1-.064-.085c0-.04.028-.074.066-.086a.117.117 0 0 1-.032.005h-1.078c-.011 0-.021 0-.03-.004l.005.002c.039.011.06.045.06.083a.09.09 0 0 1-.062.084z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M11.043 16.275h1.036a2.033 2.033 0 0 1-.027-.343c0-.129.01-.253.028-.347h-1.036c.016.09.026.212.026.347 0 .126-.01.25-.027.343zm1.085.154s-.002 0-.003-.003l-.002-.002c-.008-.014-.016-.02-.024-.02H11.02c-.008 0-.012.001-.016.007l-.007.012c-.007.011-.013-.007-.016-.04a.215.215 0 0 1 .007-.08.119.119 0 0 1 .008-.014c.028-.058.047-.205.047-.357 0-.168-.019-.309-.049-.358a.07.07 0 0 1-.009-.014.202.202 0 0 1-.008-.08c.002-.033.01-.051.016-.042l.005.008.002.003a.025.025 0 0 0 .02.007h1.078c.01 0 .02-.012.028-.024.007-.01.014.008.016.042a.193.193 0 0 1-.008.08c-.034.057-.058.212-.058.378 0 .167.021.312.054.37.007.012.01.049.009.082-.002.028-.007.045-.012.045z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.02 15.608h1.08c.036 0 .065.022.065.05 0 .029-.029.051-.065.051h-1.08c-.037 0-.066-.022-.066-.05 0-.029.03-.05.066-.05z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M11.02 15.795c-.028 0-.053.136-.053.296 0 .168.024.305.054.305h1.078c.03 0 .053-.134.053-.305 0-.163-.024-.296-.053-.296H11.02zm1.079.8H11.02c-.044 0-.079-.221-.079-.504 0-.273.035-.496.079-.496h1.078c.044 0 .078.219.078.496 0 .283-.034.504-.078.504z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.02 15.361h1.08c.036 0 .066.023.066.05 0 .027-.03.05-.067.05h-1.078c-.037 0-.066-.023-.066-.05 0-.027.03-.05.066-.05z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M11.02 15.575c-.03 0-.053.143-.053.272 0 .13.022.275.054.275h1.078c.032 0 .054-.145.054-.275 0-.13-.022-.272-.054-.272h-1.078zm1.08.774h-1.08c-.043 0-.078-.226-.078-.502 0-.275.035-.498.079-.498h1.078c.045 0 .08.219.08.498 0 .281-.035.502-.08.502z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M12.567 21.71a.55.55 0 0 1-.253-.055.561.561 0 0 0-.25-.053.578.578 0 0 0-.252.053.556.556 0 0 1-.253.056.547.547 0 0 1-.254-.058.568.568 0 0 0-.245-.051.549.549 0 0 0-.25.052.558.558 0 0 1-.254.057v.156a.572.572 0 0 0 .255-.057.545.545 0 0 1 .25-.053c.093 0 .18.02.244.051a.56.56 0 0 0 .254.059.56.56 0 0 0 .253-.056.564.564 0 0 1 .253-.054c.096 0 .184.02.249.053a.548.548 0 0 0 .252.057l.002-.156z",
    fill: "#005BBF"
  }), React__default.createElement("path", {
    d: "M11.06 22.124c.092 0 .181.064.25.182.07.126.159.196.249.196.092 0 .18-.066.247-.187.07-.123.161-.191.259-.191.095 0 .185.067.254.19.064.116.147.182.235.187v-.45c-.092-.005-.18-.075-.246-.198-.066-.114-.152-.177-.243-.177s-.181.065-.247.18c-.07.126-.162.196-.26.196-.095 0-.188-.073-.26-.205-.064-.11-.15-.171-.238-.171-.094 0-.18.062-.243.175-.068.124-.156.195-.249.2v.45c.086-.006.172-.074.237-.19.068-.123.156-.187.255-.187zm1.519.465h-.013c-.097 0-.187-.069-.258-.199-.066-.116-.152-.18-.243-.18-.094 0-.181.065-.247.183-.07.126-.163.196-.26.196-.093 0-.186-.073-.26-.205-.064-.112-.15-.174-.238-.174-.093 0-.18.064-.243.178-.073.13-.166.2-.261.2h-.013v-.623h.013c.093 0 .182-.068.25-.19.067-.122.155-.186.254-.186.093 0 .181.064.25.18.069.127.157.196.249.196.093 0 .18-.066.247-.186.07-.123.163-.19.259-.19.095 0 .185.066.254.187.067.122.155.189.248.189h.013l-.001.624z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M12.567 21.866a.553.553 0 0 1-.253-.056.557.557 0 0 0-.25-.053.564.564 0 0 0-.252.054.56.56 0 0 1-.253.055.56.56 0 0 1-.254-.058.561.561 0 0 0-.245-.051.545.545 0 0 0-.25.053.569.569 0 0 1-.254.056v.156a.572.572 0 0 0 .255-.057.55.55 0 0 1 .25-.053c.093 0 .18.02.244.052a.548.548 0 0 0 .254.058.565.565 0 0 0 .253-.056.569.569 0 0 1 .253-.054c.096 0 .184.02.249.054a.552.552 0 0 0 .252.056l.002-.156z",
    fill: "#CCC"
  }), React__default.createElement("path", {
    d: "M11.06 22.28c.092 0 .18.064.25.182.069.126.157.195.249.195s.18-.066.247-.186c.07-.123.162-.191.259-.191.095 0 .185.068.254.191.064.115.147.18.235.186v-.449c-.092-.006-.179-.075-.246-.198-.066-.115-.152-.18-.243-.18-.094 0-.181.066-.247.183-.07.126-.163.196-.26.196-.093 0-.186-.073-.26-.205-.064-.111-.15-.173-.238-.173-.093 0-.18.063-.243.177-.07.124-.157.194-.249.2v.449c.088-.006.172-.073.237-.19.068-.121.158-.187.255-.187zm1.519.464h-.013c-.097 0-.187-.068-.258-.196-.066-.117-.153-.182-.243-.182-.092 0-.182.067-.247.182-.071.126-.163.196-.26.196-.095 0-.188-.073-.26-.205-.065-.111-.15-.173-.238-.173-.093 0-.18.063-.243.178-.072.129-.165.2-.261.2h-.013v-.622h.013c.09 0 .181-.07.25-.19.067-.123.155-.188.254-.188.092 0 .181.065.25.183.07.126.159.195.249.195.092 0 .18-.066.247-.186.07-.124.161-.192.259-.192.095 0 .185.067.254.19.067.121.155.188.248.188h.013l-.001.622z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M12.567 22.022a.557.557 0 0 1-.253-.056.553.553 0 0 0-.25-.054.569.569 0 0 0-.252.054.565.565 0 0 1-.253.056.548.548 0 0 1-.254-.058.566.566 0 0 0-.245-.052.55.55 0 0 0-.25.053.564.564 0 0 1-.254.057v.155a.56.56 0 0 0 .255-.057.554.554 0 0 1 .25-.052c.093 0 .18.02.244.052a.551.551 0 0 0 .254.057c.098 0 .188-.02.253-.055a.565.565 0 0 1 .253-.054c.096 0 .184.02.249.054a.541.541 0 0 0 .252.055l.002-.155z",
    fill: "#005BBF"
  }), React__default.createElement("path", {
    d: "M11.06 22.438c.093 0 .182.065.25.181.069.125.157.194.249.194.093 0 .181-.066.247-.185.069-.122.16-.19.259-.19.095 0 .186.067.254.188.064.117.144.18.235.186v-.448c-.092-.006-.179-.075-.246-.196-.066-.117-.153-.182-.243-.182-.092 0-.182.067-.247.182-.071.127-.163.197-.26.197-.095 0-.188-.073-.26-.206-.065-.111-.15-.173-.238-.173-.093 0-.18.063-.243.178-.07.124-.157.194-.249.2v.448c.089-.006.172-.073.237-.19.068-.12.156-.184.255-.184zm1.519.461h-.013c-.1 0-.189-.068-.258-.196-.065-.115-.152-.177-.243-.177-.095 0-.182.063-.247.18-.07.124-.162.193-.26.193-.096 0-.188-.071-.26-.203-.064-.11-.149-.17-.238-.17-.095 0-.18.06-.243.173-.072.13-.164.2-.261.2h-.013v-.622h.013c.092 0 .18-.067.25-.19.067-.121.157-.188.254-.188.092 0 .18.065.25.183.069.127.157.195.249.195s.18-.065.247-.186c.07-.124.162-.192.259-.192.095 0 .185.068.254.192.067.12.155.186.248.186h.013l-.001.622z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M12.566 22.334a.545.545 0 0 1-.252-.057.561.561 0 0 0-.25-.053.57.57 0 0 0-.252.054.565.565 0 0 1-.253.056.555.555 0 0 1-.254-.059.559.559 0 0 0-.245-.05.55.55 0 0 0-.25.051.565.565 0 0 1-.254.058v-.156a.56.56 0 0 0 .255-.058.554.554 0 0 1 .25-.051c.093 0 .18.019.244.05a.551.551 0 0 0 .254.058c.098 0 .188-.02.253-.055a.565.565 0 0 1 .252-.053c.097 0 .185.02.25.053a.546.546 0 0 0 .253.055v.157z",
    fill: "#CCC"
  }), React__default.createElement("path", {
    d: "M11.06 22.592c.094 0 .183.064.25.18.07.127.158.197.249.197.09 0 .18-.068.247-.187.07-.123.161-.19.259-.19.095 0 .185.066.254.187.064.117.147.184.235.19v-.453c-.093-.005-.18-.074-.246-.196-.065-.114-.152-.177-.243-.177-.095 0-.182.064-.247.18-.07.125-.162.194-.26.194-.096 0-.188-.072-.26-.203-.064-.11-.149-.171-.238-.171-.095 0-.18.06-.243.173-.07.126-.158.199-.249.205v.448c.087-.007.172-.075.237-.192.068-.121.156-.185.255-.185zm1.519.464h-.013c-.098 0-.187-.07-.258-.2-.066-.114-.152-.177-.243-.177-.094 0-.182.064-.247.18-.072.127-.164.197-.26.197-.094 0-.186-.073-.26-.206-.063-.11-.148-.171-.238-.171-.094 0-.18.062-.243.175-.073.13-.165.202-.261.202h-.013v-.622h.013c.09 0 .18-.07.25-.195.067-.12.155-.183.254-.183.093 0 .182.064.25.18.069.125.157.194.249.194.093 0 .181-.065.247-.184.069-.123.16-.19.259-.19.095 0 .186.066.254.187.066.12.154.187.248.187h.013l-.001.626z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M12.566 22.489a.552.552 0 0 1-.252-.056.549.549 0 0 0-.25-.054.564.564 0 0 0-.252.054.57.57 0 0 1-.253.056.56.56 0 0 1-.254-.058.551.551 0 0 0-.245-.052.543.543 0 0 0-.25.053.57.57 0 0 1-.254.057v-.154a.558.558 0 0 0 .255-.059.55.55 0 0 1 .25-.052c.093 0 .18.02.244.051a.555.555 0 0 0 .254.058.565.565 0 0 0 .253-.055.57.57 0 0 1 .252-.054c.097 0 .185.02.25.053a.548.548 0 0 0 .253.056v.156z",
    fill: "#005BBF"
  }), React__default.createElement("path", {
    d: "M11.06 22.746c.094 0 .183.065.25.183.07.126.159.195.249.195s.18-.068.247-.186c.07-.124.161-.192.259-.192.095 0 .186.068.254.192.064.115.147.18.235.186v-.45c-.092-.005-.18-.075-.246-.198-.066-.115-.152-.178-.243-.178-.094 0-.182.064-.247.18-.072.127-.164.197-.26.197-.094 0-.186-.073-.26-.206-.064-.11-.15-.17-.238-.17-.094 0-.18.061-.243.175-.07.126-.159.199-.249.205v.445c.086-.006.172-.075.237-.19.068-.123.156-.188.255-.188zm1.519.465h-.013c-.097 0-.187-.068-.258-.196-.066-.117-.152-.182-.243-.182-.094 0-.181.065-.247.182-.072.127-.164.196-.26.196-.093 0-.186-.073-.26-.205-.063-.111-.148-.173-.238-.173-.093 0-.18.063-.243.177-.073.13-.166.201-.261.201h-.013v-.618h.013c.089 0 .18-.072.25-.196.067-.122.155-.186.254-.186.093 0 .181.064.25.18.07.128.158.197.249.197.09 0 .18-.068.247-.187.07-.122.161-.19.259-.19.095 0 .185.067.254.188.067.122.155.19.248.19h.013l-.001.622z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M10.994 21.071c.003.014.009.026.009.04 0 .095-.082.17-.182.17h1.482c-.1 0-.182-.075-.182-.17 0-.013.003-.026.006-.04a.084.084 0 0 1-.028.004H11.02a.096.096 0 0 1-.027-.004z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M10.92 21.952h1.284c-.057-.135-.095-.385-.095-.67 0-.035 0-.069.002-.102a.044.044 0 0 1-.012.002H11.02a.03.03 0 0 1-.01-.002c.003.032.004.066.004.103 0 .284-.038.534-.096.669zm1.383.107H10.82c-.007 0-.013-.024-.013-.054 0-.029.006-.053.013-.053.093 0 .17-.3.17-.67a1.463 1.463 0 0 0-.01-.158.185.185 0 0 1 .005-.05c.003-.014.008-.018.012-.013.006.008.015.014.023.014h1.078a.026.026 0 0 0 .023-.013c.005-.006.01-.003.013.01a.184.184 0 0 1 .004.052 2.844 2.844 0 0 0-.005.159c0 .369.076.669.169.669.006 0 .012.024.012.053 0 .03-.006.054-.012.054z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.02 20.974h1.08c.036 0 .065.022.065.05 0 .028-.029.051-.065.051h-1.08c-.037 0-.066-.023-.066-.05 0-.029.03-.051.066-.051z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M11.02 21.16c-.028 0-.053.137-.053.299 0 .164.025.303.054.303h1.078c.028 0 .053-.139.053-.303 0-.165-.024-.3-.053-.3H11.02zm1.079.8H11.02c-.044 0-.079-.224-.079-.501 0-.275.035-.498.079-.498h1.078c.044 0 .078.218.078.498 0 .277-.035.502-.078.502z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M10.823 21.281H12.3v.377h-1.477z"
  }), React__default.createElement("path", {
    d: "M10.836 22.206h1.451v-.875h-1.451v.875zm1.477.062H10.81v-1h1.503v1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M10.707 19.64c-.146.084-.245.17-.229.214.008.04.054.069.121.113.105.073.168.203.118.263a.372.372 0 0 0-.01-.59z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M11.06 19.674c-.383.148-.557.27-.531.316.016.057.121.103.267.167l.017.007c.182.084.32.216.343.327a.146.146 0 0 1 .002.046c.156-.11.244-.251.244-.4 0-.181-.125-.35-.342-.463zm.045.95l-.043-.028c.038-.03.038-.07.033-.1-.02-.098-.15-.221-.316-.298l-.017-.007c-.158-.07-.272-.12-.293-.19-.062-.11.383-.295.578-.37l.017-.006.017.008c.243.121.382.305.382.504 0 .189-.13.366-.358.488z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#CCC",
    d: "M11.035 15.77h1.05v5.143h-1.05z"
  }), React__default.createElement("path", {
    d: "M11.047 20.9h.723v-5.118h-.723V20.9zm.748 0h.1v-5.118h-.1V20.9zm.119 0h.158v-5.118h-.158V20.9zm.183.025h-1.075v-5.168h1.075v5.168z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M13.157 17.693c-.23-.094-.619-.165-1.065-.18a3.332 3.332 0 0 0-.504.046c-.627.105-1.106.355-1.068.56l.003.016s-.235-.53-.239-.55c-.042-.227.489-.505 1.186-.622a3.58 3.58 0 0 1 .617-.048c.446 0 .833.057 1.067.144l.003.634z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M12.054 16.927c-.19 0-.39.017-.582.049-.544.09-1.002.283-1.139.478-.032.045-.044.089-.036.129.004.016.12.28.21.486a.21.21 0 0 1 .037-.082c.126-.18.545-.358 1.042-.44a3.34 3.34 0 0 1 .505-.046c.42.014.811.078 1.053.173l-.003-.606c-.242-.088-.636-.14-1.054-.14h-.033zm-1.53 1.221a.013.013 0 0 1-.012-.007c-.04-.09-.236-.533-.24-.553a.157.157 0 0 1-.003-.03.21.21 0 0 1 .043-.118c.141-.2.605-.397 1.156-.489.203-.034.42-.05.619-.049.426 0 .827.054 1.071.145a.013.013 0 0 1 .009.012l.002.634a.012.012 0 0 1-.006.01.012.012 0 0 1-.011.002c-.237-.098-.634-.165-1.06-.18a3.3 3.3 0 0 0-.502.046c-.49.082-.903.255-1.025.43-.028.04-.04.08-.032.115l.001.01.002.007a.013.013 0 0 1-.013.015z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.033 18.339c-.291-.021-.49-.1-.513-.22-.018-.098.08-.206.257-.303.078.009.166.02.258.02l-.002.503z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M11.01 17.85c-.323.179-.484.364-.455.523.039.198.375.34.9.381l.004-.87a4.312 4.312 0 0 1-.439-.032l-.01-.001zm.492.953l-.025-.001c-.57-.04-.923-.194-.967-.42-.034-.181.138-.385.484-.575l.007-.004.025.003c.138.016.295.033.456.033h.023l-.003.964z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M12.086 17.945c.183.028.319.073.387.129l.006.01c.032.067-.127.209-.395.367l.002-.506z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M12.136 17.984l-.004.865c.72-.338.922-.547.875-.624l-.012-.015c-.152-.096-.456-.175-.86-.226zm-.064.946l.005-1 .034.004c.433.052.762.138.926.243l.006.006.016.02c.118.19-.62.557-.942.707l-.045.02z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M10.38 19.33c-.027-.082.257-.249.658-.396.183-.065.335-.134.523-.216.557-.247.968-.53.918-.633l-.006-.01c.03.024.077.532.077.532.05.094-.327.373-.84.618a8.55 8.55 0 0 1-.675.264c-.293.102-.583.294-.557.365l-.097-.523z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M12.482 18.15c-.082.15-.505.397-.916.58l-.059.025c-.16.071-.3.132-.465.191-.433.16-.67.318-.65.38l.001.004.088.47c.068-.1.328-.246.55-.322.186-.066.518-.19.673-.264.438-.209.796-.455.834-.572.004-.012.004-.022 0-.03a7.48 7.48 0 0 0-.057-.462zm-2.004 1.716a.013.013 0 0 1-.012-.008.038.038 0 0 1-.002-.012l-.096-.513c-.034-.102.31-.28.666-.41.164-.059.302-.12.463-.191l.059-.026c.586-.26.93-.517.914-.608a.19.19 0 0 0-.002-.007l-.006-.01a.012.012 0 0 1 .003-.016.013.013 0 0 1 .016 0 .038.038 0 0 1 .01.016 5.226 5.226 0 0 1 .07.522.062.062 0 0 1 .001.047c-.04.125-.397.372-.847.587-.156.075-.49.199-.675.264-.284.099-.55.276-.55.342v.008a.013.013 0 0 1-.012.015z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M11.082 17.342l.118-.034a.221.221 0 0 1 .257.11c.036.072.027.153-.086.21a.897.897 0 0 1-.12.046l-.17-.332zm.202.397c.34-.098.563-.215.455-.428-.07-.137-.244-.162-.508-.086l-.464.135.418.822c.046-.016.092-.032.138-.046.048-.014.098-.025.146-.036l-.185-.36v-.001z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M11.373 17.095a.69.69 0 0 1-.113.022l.091.406.283-.057c-.003-.008-.008-.016-.009-.024-.002-.01-.002-.018-.002-.027-.05.014-.104.03-.169.043l-.081-.363zm.567.35c.053-.148.117-.288.181-.431l-.035.005h-.034a3.757 3.757 0 0 1-.121.31c-.053-.098-.112-.194-.157-.292l-.067.008-.067.001c.081.133.16.266.235.403a.315.315 0 0 1 .032-.006l.033.002zm.591-.312a.83.83 0 0 1 .031-.058.23.23 0 0 0-.117-.04c-.115-.012-.18.04-.189.109-.017.146.214.134.203.23-.004.042-.049.058-.096.054-.052-.005-.09-.034-.097-.077l-.014-.001a.505.505 0 0 1-.031.074.28.28 0 0 0 .12.038c.117.012.207-.035.215-.112.015-.139-.217-.147-.208-.229.004-.034.03-.057.09-.051.044.005.07.028.082.062h.011z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M21.194 14.59s-.048.05-.082.057c-.035.006-.079-.032-.079-.032s-.03.033-.07.042c-.038.009-.09-.043-.09-.043s-.037.052-.07.064c-.032.011-.072-.016-.072-.016s-.015.026-.042.04c-.012.006-.032-.003-.032-.003l-.038-.025-.044-.046-.04-.016-.02-.069a1.402 1.402 0 0 0-.006-.037c-.008-.042.057-.09.15-.11a.267.267 0 0 1 .132-.002c.037-.031.115-.053.207-.053.083 0 .156.017.196.045a.366.366 0 0 1 .196-.045c.092 0 .169.022.206.053a.27.27 0 0 1 .134.001c.091.02.157.07.148.111l-.005.037-.02.07-.04.015-.045.046-.037.025s-.02.009-.031.003a.113.113 0 0 1-.043-.04s-.04.027-.073.016c-.033-.012-.069-.064-.069-.064s-.053.052-.092.043c-.038-.009-.069-.042-.069-.042s-.044.038-.078.032c-.035-.007-.082-.058-.082-.058z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M21.66 15.167l.005.022s.014.063.039.094c.007.01.023-.008.023-.008l.037-.063.045-.124.036-.037a7.85 7.85 0 0 0 .02-.168c0-.027.005-.096.005-.096a.311.311 0 0 0-.142-.267c-.05-.03-.095-.031-.13-.004l-.004.003-.004-.008a.222.222 0 0 0-.2-.133.217.217 0 0 0-.19.114l-.006.01-.005-.01a.216.216 0 0 0-.191-.114.223.223 0 0 0-.201.133l-.004.008-.004-.003c-.034-.027-.08-.026-.13.004a.312.312 0 0 0-.141.266l.006.098c0 .016.01.105.018.167l.04.042.043.122.037.061s.017.016.023.008a.316.316 0 0 0 .038-.095l.005-.022.007.014s.026.045.051.045a.02.02 0 0 0 .014-.006.593.593 0 0 0 .065-.16l.006-.022.008.02s.042.107.075.107c.003 0 .005 0 .008-.002.035-.02.065-.101.065-.102l.006-.016.006.014c0 .001.04.093.07.078.027-.014.066-.109.079-.144l.006-.018.006.018c.013.035.052.13.078.144.03.017.07-.077.07-.078l.007-.014.006.016s.03.082.064.102c.028.017.071-.073.084-.106l.007-.019.006.022c0 .002.035.13.065.16.004.004.01.006.015.006.025 0 .05-.044.05-.045l.008-.014zm.05.165a.016.016 0 0 1-.014-.007.297.297 0 0 1-.041-.094c-.011.016-.032.041-.053.041a.03.03 0 0 1-.02-.008.498.498 0 0 1-.068-.157c-.015.034-.05.104-.08.104a.024.024 0 0 1-.013-.003c-.03-.018-.056-.074-.067-.1-.014.028-.05.09-.08.074-.03-.015-.065-.103-.08-.14-.014.037-.051.125-.08.14-.031.015-.066-.047-.08-.075-.011.027-.037.083-.069.1a.022.022 0 0 1-.011.004c-.03 0-.065-.07-.08-.104a.51.51 0 0 1-.067.156c-.027.024-.06-.011-.074-.032a.321.321 0 0 1-.04.093c-.013.018-.037-.005-.04-.007l-.039-.067-.044-.121-.042-.043-.002-.01a8.961 8.961 0 0 1-.02-.185 13.05 13.05 0 0 0-.005-.098.357.357 0 0 1 .155-.318c.05-.03.097-.032.133-.007a.233.233 0 0 1 .209-.136.23.23 0 0 1 .196.114.226.226 0 0 1 .196-.114c.088 0 .166.052.208.136.037-.025.083-.023.134.007a.357.357 0 0 1 .155.32l-.005.095c-.002.028-.02.17-.021.185l-.002.01-.042.044-.042.118-.04.068c-.002.003-.014.017-.025.017z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.104 14.317c0-.07.039-.127.088-.127.05 0 .09.057.09.127s-.04.126-.09.126c-.049 0-.088-.056-.088-.126z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M21.593 14.244c-.227 0-.41.197-.41.438 0 .242.183.438.41.438.23 0 .417-.196.417-.438a.428.428 0 0 0-.417-.438zm0 .938a.493.493 0 0 1-.497-.5c0-.28.218-.5.497-.5.277 0 .503.224.503.5s-.226.5-.503.5z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.153 14.317c0-.065.023-.117.05-.117.028 0 .05.052.05.117s-.022.116-.05.116c-.027 0-.05-.051-.05-.116z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M21.645 14.258c-.134 0-.33.17-.33.435 0 .263.196.431.33.431.138 0 .33-.163.33-.43 0-.27-.192-.436-.33-.436zm0 .934a.484.484 0 0 1-.5-.499.49.49 0 0 1 .5-.501c.328 0 .5.252.5.501a.483.483 0 0 1-.5.499z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M20.736 14.837a.322.322 0 0 0-.039-.07 1.87 1.87 0 0 1 .496-.06c.195 0 .371.023.497.06l-.033.059a.434.434 0 0 0-.025.052 1.556 1.556 0 0 0-.44-.053c-.18 0-.352.023-.442.056a.289.289 0 0 0-.016-.044h.002z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M20.747 15.467l.009.13a.527.527 0 0 1 .437-.277c.178.003.32.09.434.265a79.152 79.152 0 0 1 .05-.5c-.129-.19-.3-.296-.484-.3-.182.004-.353.11-.482.3.008.066.023.189.032.323l.005.059h-.001zm.003.231v-.029l-.002-.015-.006.002-.015-.217-.005-.06h.001a5.68 5.68 0 0 0-.032-.294l-.007-.051.011-.017c.132-.202.31-.315.498-.319.19.004.368.117.5.319l.01.015-.006.049-.033.308c-.01.091-.023.242-.024.26l-.006-.01-.004.043c-.113-.181-.256-.27-.437-.274a.523.523 0 0 0-.439.284l-.001.006h-.003z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.193 14.997c.158 0 .33-.025.395-.04.042-.014.067-.032.062-.055-.002-.01-.01-.02-.024-.025a1.599 1.599 0 0 0-.433-.051c-.17 0-.34.021-.433.051-.013.006-.023.015-.024.025-.005.023.02.041.063.054.064.016.238.04.394.04z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M21.227 14.907a.564.564 0 0 0-.462.271.288.288 0 0 0-.02.098.41.41 0 0 0 .062.237.65.65 0 0 0 .42.216.648.648 0 0 0 .42-.216.4.4 0 0 0 .04-.336.562.562 0 0 0-.46-.27zm0 .91c-.166-.003-.353-.128-.425-.217a.596.596 0 0 1-.075-.341.464.464 0 0 1 .031-.164.573.573 0 0 1 .47-.277.57.57 0 0 1 .466.275c.018.037.03.097.032.167a.589.589 0 0 1-.073.34.663.663 0 0 1-.426.218z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.575 14.396a.05.05 0 0 1 .049-.05.05.05 0 0 1 .05.05.05.05 0 0 1-.05.05.05.05 0 0 1-.05-.05z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M21.667 14.205c-.036 0-.067.039-.067.084 0 .043.03.08.067.08.035 0 .064-.036.064-.08 0-.046-.029-.084-.064-.084zm0 .217c-.057 0-.106-.06-.106-.133 0-.074.049-.137.106-.137.057 0 .103.061.103.137 0 .074-.046.133-.103.133zm-.271-.202c-.035 0-.063.037-.063.082 0 .045.027.08.063.08.038 0 .067-.034.067-.08 0-.047-.03-.082-.067-.082zm0 .214c-.057 0-.102-.058-.102-.132 0-.075.045-.135.102-.135.06 0 .106.059.106.135 0 .076-.046.132-.106.132zm.534-.113c-.035 0-.064.037-.064.082 0 .045.029.082.064.082.036 0 .065-.037.065-.082 0-.045-.029-.082-.065-.082zm0 .217c-.057 0-.103-.06-.103-.135 0-.075.046-.135.103-.135.057 0 .104.06.104.135 0 .074-.047.135-.104.135zm.211.02c-.036 0-.064.037-.064.083 0 .043.028.08.064.08.036 0 .065-.037.065-.08 0-.046-.028-.082-.065-.082zm0 .215c-.057 0-.104-.06-.104-.132 0-.075.047-.135.104-.135.059 0 .104.059.104.135 0 .073-.047.132-.104.132zm.048.162c-.034 0-.063.039-.063.084 0 .043.029.08.063.08.036 0 .066-.036.066-.08 0-.046-.03-.084-.066-.084zm0 .217c-.057 0-.102-.06-.102-.133 0-.074.046-.137.102-.137.058 0 .105.062.105.137 0 .073-.047.133-.105.133z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.863 14.57a.01.01 0 0 1-.003 0 .008.008 0 0 1-.004-.011.176.176 0 0 0-.16-.244.168.168 0 0 0-.086.022.008.008 0 0 1-.012-.003.008.008 0 0 1 .003-.011.186.186 0 0 1 .094-.025.193.193 0 0 1 .176.267.008.008 0 0 1-.008.005zm-.318-.135l-.014-.009a.107.107 0 0 0 .015-.052c0-.07-.073-.126-.163-.126a.194.194 0 0 0-.101.028l-.009-.014a.21.21 0 0 1 .11-.03c.1 0 .18.064.18.142a.12.12 0 0 1-.018.06z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M22.017 14.268a.07.07 0 0 0-.069.07c0 .04.032.075.07.075.037 0 .067-.034.067-.075a.07.07 0 0 0-.068-.07zm0 .192c-.06 0-.11-.056-.11-.122 0-.063.05-.116.11-.116s.109.052.109.116c0 .067-.049.122-.109.122zm-.284-.18a.07.07 0 0 0-.068.071c0 .04.031.074.068.074.037 0 .07-.034.07-.074a.07.07 0 0 0-.07-.072zm0 .191c-.06 0-.109-.053-.109-.12 0-.065.05-.119.109-.119.06 0 .11.054.11.12 0 .065-.05.12-.11.12zm.549-.06c-.038 0-.068.032-.068.072 0 .039.03.07.068.07a.069.069 0 0 0 .067-.07c0-.04-.03-.072-.067-.072zm0 .189c-.06 0-.11-.052-.11-.117 0-.066.05-.12.11-.12s.108.053.108.12c0 .065-.049.117-.108.117zm.2.08a.07.07 0 0 0-.07.07c0 .04.031.073.07.073.037 0 .067-.033.067-.073 0-.039-.03-.07-.067-.07zm0 .19c-.061 0-.11-.054-.11-.12 0-.065.048-.116.11-.116.061 0 .109.05.109.116s-.05.12-.11.12zm.033.16c-.037 0-.067.033-.067.073 0 .04.03.072.067.072.038 0 .068-.032.068-.072 0-.04-.03-.073-.068-.073zm0 .192c-.06 0-.108-.054-.108-.12 0-.065.048-.118.108-.118s.11.053.11.119c0 .065-.05.119-.11.119z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.698 14.697l-.038-.035s-.037.022-.083.016c-.045-.007-.06-.063-.06-.063s-.051.044-.093.04c-.042-.003-.07-.04-.07-.04s-.045.033-.085.03c-.04-.004-.079-.054-.079-.054s-.04.052-.08.056c-.04.003-.073-.035-.073-.035s-.019.038-.07.047c-.05.008-.095-.04-.095-.04s-.028.047-.063.06c-.035.01-.08-.019-.08-.019l-.013.028c-.006.01-.02.012-.02.012l.011.031c.125-.036.295-.059.487-.059s.366.023.491.06l.013-.035z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M21.194 15.1c.184 0 .356.125.486.352l.008-.135-.03-.163c-.012.037-.044.116-.082.085-.037-.036-.056-.238-.063-.349-.017.078-.055.23-.09.211-.034-.019-.06-.158-.07-.227-.014.056-.051.182-.084.164-.034-.02-.065-.207-.079-.298-.013.093-.045.29-.079.31a.014.014 0 0 1-.006.001c-.03 0-.054-.115-.066-.182-.01.079-.032.213-.07.25-.042.045-.08-.127-.095-.213-.01.09-.034.27-.062.331-.027.054-.063-.033-.079-.084-.003.037-.006.085-.01.12a.32.32 0 0 1-.016.085l.005.09c.132-.224.302-.347.482-.347zm.496.478l-.007-.014c-.13-.233-.303-.361-.489-.361-.182 0-.354.127-.484.357l-.008.013-.017-.29.01-.01c.003-.001.01-.015.014-.048l.013-.165.004-.054.008.032c0 .001.03.115.058.115.005 0 .01-.004.015-.013.031-.068.058-.338.058-.34l.006-.06.008.051c0 .003.041.273.087.228.046-.045.064-.252.064-.255l.005-.068.009.058c0 .002.03.212.065.194.036-.02.074-.316.075-.319l.006-.051.007.051c0 .003.037.287.073.307l.005.001c.035 0 .075-.17.075-.172l.007-.03.005.041c0 .002.025.202.063.224h.004c.037 0 .082-.23.083-.232l.01-.052.003.077c0 .003.014.307.054.346.04.032.076-.09.077-.09l.005-.02.047.258-.018.29z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M20.75 14.396a.05.05 0 0 1 .05-.05.05.05 0 0 1 .05.05.05.05 0 0 1-.05.05.05.05 0 0 1-.05-.05z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M21.371 14.205c-.036 0-.066.039-.066.084 0 .043.03.08.066.08.036 0 .064-.036.064-.08 0-.046-.028-.084-.064-.084zm0 .217c-.057 0-.105-.06-.105-.133 0-.074.048-.137.105-.137.057 0 .104.061.104.137 0 .074-.047.133-.104.133zm.27-.202c-.036 0-.065.037-.065.082 0 .045.027.08.064.08.037 0 .064-.035.064-.08 0-.046-.028-.082-.064-.082zm0 .214c-.059 0-.104-.058-.104-.132 0-.075.046-.135.103-.135.057 0 .104.06.104.135 0 .074-.046.132-.104.132zm-.536-.113c-.036 0-.064.036-.064.082 0 .045.029.082.064.082.036 0 .066-.038.066-.082 0-.045-.03-.082-.066-.082zm0 .217c-.057 0-.103-.06-.103-.135 0-.075.046-.135.103-.135.059 0 .106.06.106.135 0 .074-.047.135-.106.135zm-.21.02c-.036 0-.065.037-.065.083 0 .043.03.08.065.08.036 0 .066-.037.066-.08 0-.045-.03-.082-.066-.082zm0 .215c-.057 0-.104-.06-.104-.132 0-.076.046-.135.104-.135.058 0 .105.06.105.135 0 .072-.048.132-.105.132zm-.048.162c-.035 0-.064.038-.064.084 0 .044.029.08.064.08.036 0 .066-.036.066-.08 0-.046-.03-.084-.066-.084zm0 .217c-.057 0-.103-.06-.103-.133 0-.075.046-.137.103-.137.058 0 .105.062.105.137 0 .073-.047.133-.105.133zm-.327-.582a.008.008 0 0 1-.008-.005.193.193 0 0 1 .177-.267.18.18 0 0 1 .092.025.008.008 0 0 1-.008.015.165.165 0 0 0-.084-.024.176.176 0 0 0-.161.245c.001.004 0 .009-.005.01l-.003.001z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M20.84 14.433a.119.119 0 0 1-.02-.059c0-.078.08-.142.18-.142.04 0 .079.01.11.03l-.009.014a.198.198 0 0 0-.102-.028c-.09 0-.162.057-.162.126 0 .018.009.035.018.05l-.015.009z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.038 14.268a.069.069 0 0 0-.068.07c0 .041.03.075.068.075.038 0 .067-.033.067-.075 0-.038-.03-.07-.067-.07zm0 .192c-.06 0-.109-.055-.109-.122 0-.064.049-.116.109-.116s.108.052.108.116c0 .067-.048.122-.108.122zm.282-.18c-.037 0-.067.032-.067.071 0 .04.03.074.067.074.037 0 .068-.034.068-.074 0-.04-.03-.072-.068-.072zm0 .191c-.06 0-.108-.053-.108-.12 0-.065.048-.119.108-.119s.11.054.11.12-.05.12-.11.12zm-.546-.06a.07.07 0 0 0-.07.072c0 .039.031.07.07.07.035 0 .067-.033.067-.07 0-.04-.03-.072-.067-.072zm0 .189a.114.114 0 0 1-.111-.117c0-.067.049-.12.11-.12.06 0 .11.055.11.12 0 .064-.05.117-.11.117zm-.2.08a.07.07 0 0 0-.07.07c0 .04.031.073.07.073.037 0 .067-.033.067-.073 0-.039-.03-.07-.068-.07zm0 .19c-.062 0-.111-.054-.111-.12 0-.065.048-.116.11-.116s.11.05.11.116-.05.12-.11.12zm-.034.16a.071.071 0 0 0-.07.073c0 .04.032.072.07.072.036 0 .067-.033.067-.072 0-.04-.03-.073-.067-.073zm0 .192c-.061 0-.11-.054-.11-.12 0-.065.049-.118.11-.118.059 0 .109.054.109.119s-.05.119-.11.119z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.194 14.53l.018.003a.069.069 0 0 0-.003.024.07.07 0 0 0 .072.068c.032 0 .06-.02.068-.047.002 0 .007-.025.01-.025s.003.027.003.027c.005.034.036.057.072.057a.07.07 0 0 0 .071-.068v-.008l.022-.023.013.029a.06.06 0 0 0-.007.03c0 .036.03.065.069.065a.069.069 0 0 0 .057-.03l.014-.018v.023c0 .022.01.043.031.046 0 0 .026.002.06-.025.033-.026.051-.048.051-.048l.003.027s-.034.055-.063.071c-.016.01-.041.02-.062.016-.02-.003-.035-.02-.043-.039a.097.097 0 0 1-.052.014.1.1 0 0 1-.091-.055.106.106 0 0 1-.156-.005.101.101 0 0 1-.07.027.106.106 0 0 1-.088-.044.103.103 0 0 1-.156.017.107.107 0 0 1-.081.037.1.1 0 0 1-.075-.032.1.1 0 0 1-.092.055.097.097 0 0 1-.05-.014c-.008.02-.023.036-.045.04-.019.003-.044-.007-.06-.017-.03-.016-.066-.07-.066-.07l.004-.028s.018.022.052.048c.033.027.06.025.06.025.021-.003.03-.024.03-.046v-.023l.015.019a.068.068 0 0 0 .057.029c.038 0 .07-.03.07-.065a.06.06 0 0 0-.008-.03l.012-.029.023.023v.008a.07.07 0 0 0 .07.068c.036 0 .067-.023.072-.057.001 0 0-.027.003-.027s.01.025.01.025c.01.027.037.047.069.047a.07.07 0 0 0 .072-.068.088.088 0 0 0-.003-.024l.018-.003z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M21.653 15.235l.004.042c.006.066.018.148.038.161a.01.01 0 0 0 .008.004c.016 0 .035-.038.047-.073.025-.065.052-.262.059-.31v-.026a3.18 3.18 0 0 1-.04.166c-.031.115-.056.124-.063.124h-.003c-.023-.016-.038-.113-.039-.248-.014.091-.037.147-.062.147-.043 0-.078-.155-.078-.345 0-.052.002-.099.006-.142l-.005-.063-.011.052v.02c0 .201-.036.364-.08.364-.04 0-.072-.116-.08-.279-.011.132-.04.22-.073.22-.044 0-.08-.16-.08-.357v-.085l-.007-.006-.008.007.001.084c0 .197-.036.358-.08.358-.033 0-.062-.088-.075-.221-.007.163-.04.279-.079.279-.044 0-.08-.163-.08-.363l.001-.021-.011-.052-.006.063c.005.041.007.088.007.142 0 .19-.035.345-.078.345-.026 0-.049-.055-.063-.15 0 .139-.015.235-.039.25l-.002.001c-.007 0-.032-.01-.063-.124a3.051 3.051 0 0 1-.041-.172l-.001.033c.007.05.036.244.06.307.016.043.038.089.056.072.023-.016.034-.118.037-.16l.004-.045.008.025c.014.04.03.06.047.06.037 0 .071-.095.084-.237l.005-.056.01.045c.017.09.04.139.068.139.029 0 .057-.06.075-.161l.006-.032.006.029c.017.076.04.12.065.12.032 0 .061-.073.079-.194l.006-.048.007.047c.018.12.049.194.08.194.024 0 .048-.043.065-.12l.006-.03.006.034c.018.1.045.16.074.16.028 0 .052-.047.07-.138l.009-.044.005.055c.013.142.046.237.083.237.017 0 .033-.02.047-.06l.008-.024zm.05.286a.016.016 0 0 1-.011-.005c-.019-.012-.035-.072-.046-.169-.015.034-.03.051-.048.051-.039 0-.075-.092-.093-.235-.02.083-.046.126-.074.126-.03 0-.06-.059-.081-.16-.02.074-.044.115-.07.115-.034 0-.065-.068-.087-.185-.02.117-.052.185-.085.185-.026 0-.05-.041-.07-.115-.021.1-.051.16-.082.16-.028 0-.053-.043-.073-.126-.018.143-.054.235-.094.235-.017 0-.033-.017-.047-.05-.01.094-.027.155-.046.169a.016.016 0 0 1-.01.004c-.025 0-.05-.065-.057-.085a2.533 2.533 0 0 1-.068-.346l-.002-.013.008-.228.012.067s.018.1.05.22c.027.103.049.108.053.108.022-.015.024-.138.024-.176v-.222l.03.176c.011.077.03.12.05.12.034 0 .06-.118.06-.265 0-.048-.001-.087-.005-.122l-.002-.017.018-.205.035.164-.001.02v.028c0 .156.028.284.062.284.033 0 .06-.1.064-.237v-.043c.001-.073.002-.116.011-.116s.011.04.016.115v.007l.002.02c.009.117.033.196.061.196.035 0 .063-.125.063-.28 0-.045 0-.075-.003-.102l-.003-.044.03-.024.03.024-.004.045c-.002.03-.003.062-.003.102 0 .154.03.279.064.279.027 0 .052-.08.06-.196l.004-.044c.004-.061.007-.098.015-.098.01 0 .01.046.01.13v.03c.004.137.031.237.064.237.035 0 .063-.128.063-.284v-.027l-.001-.021.034-.163.02.204-.003.017a1.05 1.05 0 0 0-.006.122c0 .147.027.266.06.266.021 0 .04-.045.05-.12l.031-.18v.226c0 .076.006.163.024.175.004 0 .025-.005.052-.107.033-.12.05-.22.05-.221l.014-.075.004.237-.001.011c-.002.01-.035.265-.066.347-.007.02-.031.085-.056.085z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.193 14.708c-.194 0-.369.025-.495.063-.008.003-.019-.004-.021-.011a.018.018 0 0 1 .012-.022 1.74 1.74 0 0 1 .504-.066c.2 0 .38.026.506.066.009.003.015.013.012.022-.003.007-.014.014-.021.011a1.79 1.79 0 0 0-.497-.063z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M21.193 14.97c.19.006.367.198.499.542l.001.001c.004 0 .01-.03.01-.055a.582.582 0 0 0-.006-.083c-.131-.357-.315-.562-.504-.562s-.372.205-.502.562a.55.55 0 0 0-.006.088c0 .021.005.05.01.05.133-.345.31-.537.498-.543zm.5.694c-.002 0-.004-.003-.006-.009-.13-.34-.306-.53-.494-.536-.187.006-.362.197-.493.536-.011.032-.027-.042-.031-.146a1.759 1.759 0 0 1 .002-.164.504.504 0 0 1 .015-.114c.132-.36.317-.567.507-.567.191 0 .376.207.509.567a.55.55 0 0 1 .015.116c.003.052.004.109.002.16-.004.09-.015.157-.026.157z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.005 14.799a.05.05 0 0 1 .05-.05.05.05 0 0 1 .05.05.05.05 0 0 1-.1 0z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M21.497 14.982c-.145 0-.273.12-.273.259 0 .143.122.26.273.26a.266.266 0 0 0 .271-.26c0-.138-.126-.26-.271-.26zm0 .759a.5.5 0 0 1-.5-.5c0-.272.229-.5.5-.5.27 0 .5.228.5.5a.5.5 0 0 1-.5.5z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.196 14.847h-.063c-.012 0-.021-.023-.021-.05 0-.028.01-.05.02-.05h.127c.012 0 .021.022.021.05 0 .027-.009.05-.02.05h-.064z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M21.264 15.034c-.038 0-.07.093-.07.202 0 .113.032.209.07.209h.682c.037 0 .067-.095.067-.209 0-.114-.03-.202-.067-.202h-.682zm.682.705h-.682c-.088 0-.161-.23-.161-.503 0-.274.072-.497.161-.497h.682c.088 0 .157.219.157.497s-.07.503-.157.503z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M20.882 14.849l-.045.013c-.012.003-.022-.011-.024-.031-.002-.021.006-.04.017-.043l.045-.012.047-.013c.01-.003.022.01.024.03 0 .02-.007.04-.019.043l-.045.013z",
    fill: "#058E6E"
  }), React__default.createElement("path", {
    d: "M21.605 14.993l-.618.195c-.024.008-.044.034-.057.071a.29.29 0 0 0-.012.116c.007.08.043.14.088.14l.011-.002.6-.202c.025-.005.045-.028.058-.065a.33.33 0 0 0 .018-.126c-.006-.066-.045-.127-.088-.127zm-.6.761c-.097 0-.182-.141-.198-.337a.774.774 0 0 1 .031-.297c.03-.09.077-.149.131-.17l.61-.192a.104.104 0 0 1 .026-.004c.097 0 .182.143.198.33a.791.791 0 0 1-.04.31c-.031.088-.079.143-.131.155l-.6.202c-.011.003-.019.003-.026.003z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#AD1519",
    d: "M20.702 14.88l.03-.072.07.019-.04.08z"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M20.749 14.898l-.06-.027.031-.073.069.02z"
  }), React__default.createElement("path", {
    d: "M21.326 14.799a.05.05 0 0 1 .05-.05.05.05 0 0 1 .05.05.05.05 0 0 1-.05.05.05.05 0 0 1-.05-.05z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M21.814 14.982a.266.266 0 0 0-.266.259c0 .146.115.26.266.26a.268.268 0 0 0 .274-.26c0-.138-.128-.26-.274-.26zm0 .759a.492.492 0 0 1-.496-.5c0-.276.22-.5.496-.5.272 0 .504.228.504.5 0 .275-.226.5-.504.5z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.505 14.849l.045.013c.012.003.022-.011.024-.031.002-.021-.006-.04-.017-.043l-.045-.012-.046-.013c-.011-.003-.022.01-.024.03-.002.02.006.04.018.043l.045.013z",
    fill: "#058E6E"
  }), React__default.createElement("path", {
    d: "M21.643 14.993c-.053 0-.091.058-.098.134-.004.077.022.171.072.182l.615.204c.045 0 .08-.057.089-.143.005-.087-.024-.166-.069-.184l-.608-.193zm.59.759c0 .005-.016 0-.023-.002l-.608-.202c-.105-.025-.179-.225-.168-.456.019-.214.112-.358.225-.336l.61.193c.108.041.179.244.161.464-.018.202-.1.339-.197.339z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#AD1519",
    d: "M21.722 14.89l-.027-.082-.073.01.036.09z"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M21.644 14.899l-.035-.09.072-.01.028.082z"
  }), React__default.createElement("path", {
    d: "M21.193 14.973a1.49 1.49 0 0 1-.408-.048c.109-.032.251-.051.408-.052.158 0 .3.02.408.052a1.49 1.49 0 0 1-.408.048z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M20.83 15.378c.122.213.275.325.446.325.173 0 .326-.112.447-.325-.128-.228-.285-.352-.447-.352-.162.004-.318.128-.445.352zm.446.487c-.192 0-.362-.142-.491-.41a.27.27 0 0 1-.008-.077c0-.038.003-.07.008-.08.135-.275.31-.428.491-.433.182 0 .357.154.493.434.005.01.008.04.008.079a.268.268 0 0 1-.008.077c-.128.268-.298.41-.493.41z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.75 14.652c.01-.026 0-.053-.026-.06-.023-.004-.052.013-.062.04-.014.025-.002.052.02.059.027.005.056-.012.068-.04z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M22.228 14.85c-.059.003-.177.073-.225.197-.046.096-.033.174-.01.219a.109.109 0 0 0 .053.049h.014c.077 0 .188-.076.244-.203.048-.12 0-.24-.076-.263zm-.168.733a.401.401 0 0 1-.361-.205.458.458 0 0 1-.002-.421c.092-.24.372-.414.619-.366.277.079.398.345.294.61a.615.615 0 0 1-.55.382z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.438 14.589a.045.045 0 0 0-.038-.055c-.026-.003-.051.019-.055.046-.005.027.013.052.038.054a.052.052 0 0 0 .055-.045z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M21.869 14.793c-.074 0-.183.085-.197.218a.242.242 0 0 0 .053.211c.022.02.043.033.062.035l.02.135v-.134c.068 0 .172-.08.19-.208.024-.148-.06-.248-.128-.257zm-.061.732h-.002l-.054-.002a.457.457 0 0 1-.409-.545.525.525 0 0 1 .519-.453l.053.003a.47.47 0 0 1 .412.554.531.531 0 0 1-.52.443z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.016 14.589c-.006-.028.01-.052.038-.055.024-.003.048.019.053.046.004.027-.012.052-.038.054a.052.052 0 0 1-.053-.045z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M21.48 14.792a.132.132 0 0 0-.087.041c-.047.05-.063.127-.047.21.015.132.123.215.185.215v.134l.01-.135a.085.085 0 0 0 .062-.028c.05-.046.076-.132.064-.218-.027-.131-.127-.22-.187-.22zm.051.733a.532.532 0 0 1-.518-.45.455.455 0 0 1 .111-.402.487.487 0 0 1 .303-.145l.053-.003c.248 0 .472.195.52.453a.5.5 0 0 1-.138.424.444.444 0 0 1-.287.12l-.044.003z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M20.703 14.652c-.013-.026 0-.053.023-.06.024-.004.055.013.066.04.012.025.002.052-.022.059-.025.005-.054-.012-.067-.04z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M20.748 14.683a.06.06 0 0 1-.054-.038.044.044 0 0 1 0-.04.043.043 0 0 1 .025-.02.047.047 0 0 1 .01-.002c.024 0 .048.017.056.038a.046.046 0 0 1-.001.042.04.04 0 0 1-.036.02z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M21.193 14.378l-.055.034.04.089.015.009.014-.01.041-.088z"
  }), React__default.createElement("path", {
    d: "M21.568 15.204l.057.032.057-.032.282-.527-.339-.179-.335.18.278.526zm.057.164l-.158-.09-.34-.644.498-.266.502.266-.344.645-.158.09z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M21.071 14.525l.026.048.086-.035.01-.015-.01-.017-.086-.033z"
  }), React__default.createElement("path", {
    d: "M21.204 14.977l.132.282.551-.254.027-.05-.028-.055-.548-.234-.134.311zm.083.486l-.226-.482.224-.518.675.287.101.212-.102.193-.672.308z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M21.315 14.525l-.025.048-.087-.035-.009-.015.01-.017.086-.033z"
  }), React__default.createElement("path", {
    d: "M21.358 15.005l.552.254.131-.282-.133-.31-.549.233-.028.056.027.049zm.6.458l-.671-.308-.103-.193.102-.212.675-.287.223.518-.225.482z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M20.832 14.418l-.043.04.056.075.015.005.01-.011.02-.089z"
  }), React__default.createElement("path", {
    d: "M21.368 15.248l.06.02.046-.043.144-.562-.377-.118-.28.233.407.47zm.097.16l-.182-.061-.505-.583.43-.356.57.179-.177.697-.136.124z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M20.742 14.58l.032.041.08-.057.005-.018-.011-.014-.09-.011z"
  }), React__default.createElement("path", {
    d: "M20.874 15.05l.174.244.52-.408.018-.059-.037-.05-.588-.075-.087.348zm.153.462l-.295-.414.147-.586.723.093.13.179-.067.23-.638.498z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M20.98 14.529l-.017.054-.09-.011-.012-.014.006-.019.08-.056z"
  }), React__default.createElement("path", {
    d: "M21.031 15.201l.59.08.087-.317-.182-.271-.514.395-.018.064.037.05zm.667.272l-.719-.1-.128-.173.065-.24.634-.487.301.449-.153.551z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M20.654 14.584l-.007.054-.09.012-.014-.01.003-.019.068-.071z"
  }), React__default.createElement("path", {
    d: "M20.681 15.328l.048.035.625-.09.04-.315-.234-.205-.467.514-.012.06zm.021.212l-.169-.126.045-.243.573-.631.382.336-.068.553-.763.11z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M20.829 14.56a.05.05 0 1 1 .1 0 .05.05 0 0 1-.1 0z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M21.318 14.718a.287.287 0 0 0-.288.285c0 .155.129.28.288.28a.287.287 0 0 0 .293-.28.29.29 0 0 0-.293-.285zm0 .783a.499.499 0 1 1 .002-.998.499.499 0 0 1-.002.998z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M21.555 14.418l.043.04-.055.075-.015.005-.011-.011-.02-.089z"
  }), React__default.createElement("path", {
    d: "M21.79 15.225l.045.042.061-.02.407-.47-.28-.232-.374.118.141.562zm.01.183l-.136-.124-.176-.697.569-.18.431.357-.506.583-.182.06z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M21.646 14.58l-.033.041-.078-.057-.007-.018.012-.014.09-.011z"
  }), React__default.createElement("path", {
    d: "M21.686 14.884l.512.41.178-.245-.086-.347-.588.076-.035.048.02.058zm.53.628l-.622-.497-.076-.23.132-.18.722-.093.146.587-.301.413z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M21.408 14.529l.017.054.09-.011.012-.014-.007-.019-.078-.056z"
  }), React__default.createElement("path", {
    d: "M21.54 14.964l.088.318.588-.082.036-.048-.02-.063-.509-.396-.183.27zm.01.51l-.152-.552.303-.449.625.486.072.24-.132.175-.716.1z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M21.721 14.584l.007.054.09.012.014-.01-.003-.019-.068-.071z"
  }), React__default.createElement("path", {
    d: "M21.894 15.273l.626.09.044-.034-.01-.062-.469-.514-.232.204.04.316zm.654.267l-.765-.11-.071-.554.382-.336.575.632.043.241-.164.127z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.162 14.532a.05.05 0 0 1 .05-.051.05.05 0 0 1 .05.05.05.05 0 1 1-.1 0z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M21.65 14.69a.288.288 0 0 0-.287.287c0 .15.131.277.288.277.16 0 .292-.127.292-.277a.29.29 0 0 0-.292-.286zm0 .783a.497.497 0 0 1-.497-.496c0-.278.224-.504.498-.504a.499.499 0 1 1 0 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.496 14.56a.05.05 0 0 1 .05-.05.05.05 0 1 1-.05.05z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M21.992 14.718a.296.296 0 0 0-.297.285c0 .151.137.28.297.28a.288.288 0 0 0 .288-.28.287.287 0 0 0-.288-.285zm0 .783a.508.508 0 0 1-.504-.498.5.5 0 1 1 .504.498z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.134 14.172c0-.031.027-.057.06-.057s.06.026.06.057c0 .031-.027.056-.06.056a.058.058 0 0 1-.06-.056z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M21.235 14.151v.038h-.091v-.038h.03v-.083h-.04v-.038h.04v-.037h.04v.037h.038v.038h-.038v.083z"
  }), React__default.createElement("path", {
    d: "M21.336 14.893h.524v-.084h-.159v-.479h.283v-.084H21.7v-.173h-.145v.173h-.29v.084h.29v.479h-.22v.084zm.665.09h-.806v-.264h.22v-.299h-.29v-.264h.29v-.173h.427v.173h.283v.264h-.283v.3h.159v.263z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M21.277 14.151v.038h-.164v-.038h.061v-.083h-.04v-.038h.04v-.037h.04v.037h.04v.038h-.04v.083z"
  }), React__default.createElement("path", {
    d: "M21.193 14.237a.066.066 0 0 1-.067-.065c0-.03.02-.055.05-.063l.004.016a.048.048 0 0 0-.037.047.05.05 0 0 0 .05.048c.03 0 .052-.021.052-.048a.049.049 0 0 0-.036-.046l.004-.016a.065.065 0 0 1 .05.062c0 .036-.031.065-.07.065z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M20.536 14.64c0 .001-.026-.036-.044-.054a.144.144 0 0 0-.046-.025c0-.006.02-.02.04-.02.011 0 .023.005.03.014l.002-.015s.017.004.024.024c.008.022.003.054.003.054s-.004.015-.009.022z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M20.647 14.765c.096.04.227.102.3.178.106.1.233.263.313.366l.019-.064s.033-.24-.02-.394a.257.257 0 0 0-.08-.106l-.026.196-.108-.141a.25.25 0 0 0-.201-.093.385.385 0 0 0-.197.059zm.628.765c-.038 0-.046-.01-.124-.11a3.422 3.422 0 0 0-.305-.359c-.08-.083-.284-.161-.355-.184l-.053-.018V14.8c0-.118.216-.253.406-.253a.42.42 0 0 1 .206.054l.01-.07.077.017a.398.398 0 0 1 .26.245c.07.197.03.473.028.485a.767.767 0 0 1-.09.22l-.022.032h-.038z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M20.538 14.617c.014-.018.045-.013.069.008.023.02.03.053.014.07-.014.018-.045.014-.069-.009-.023-.021-.03-.053-.014-.07z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M20.898 14.86c-.03 0-.072.006-.097.035a.117.117 0 0 0-.029.086.363.363 0 0 0 .126.234.382.382 0 0 0 .242.116c.03 0 .068-.008.091-.038.03-.03.04-.058.037-.093a.353.353 0 0 0-.124-.233.392.392 0 0 0-.246-.107zm.242.738a.614.614 0 0 1-.407-.18.627.627 0 0 1-.212-.424.393.393 0 0 1 .097-.284c.145-.166.467-.146.687.052.13.115.21.277.216.429a.395.395 0 0 1-.105.284.343.343 0 0 1-.276.123z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.844 14.64c0 .001.025-.036.043-.054a.15.15 0 0 1 .046-.025c0-.006-.019-.02-.04-.02a.036.036 0 0 0-.03.014l-.002-.015s-.016.004-.024.024c-.007.022-.003.054-.003.054s.004.015.01.022z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M22.085 14.74a.261.261 0 0 0-.083.114c-.053.152-.018.396-.018.398.003.014.01.038.02.061.076-.101.202-.268.308-.371a1.03 1.03 0 0 1 .303-.178.405.405 0 0 0-.202-.059.24.24 0 0 0-.192.091l-.1.141-.036-.197zm-.094.79h-.032l-.022-.025c-.064-.077-.095-.207-.099-.22-.002-.019-.042-.295.026-.49a.399.399 0 0 1 .26-.248l.074-.017.013.07a.4.4 0 0 1 .202-.054c.193 0 .412.134.412.253v.06l-.053.017c-.072.024-.276.102-.36.184-.098.096-.221.26-.296.357-.079.105-.085.113-.125.113z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.89 14.617c-.016-.018-.047-.013-.07.008-.023.02-.03.053-.014.07.014.018.045.014.068-.009.023-.021.031-.053.016-.07z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M22.41 14.86a.393.393 0 0 0-.246.107.365.365 0 0 0-.124.236c-.001.035.006.063.025.081a.12.12 0 0 0 .102.047.365.365 0 0 0 .238-.114.37.37 0 0 0 .133-.242c.002-.034-.004-.059-.02-.075a.153.153 0 0 0-.108-.04zm-.243.738a.354.354 0 0 1-.286-.133.38.38 0 0 1-.091-.275.635.635 0 0 1 .212-.428c.221-.196.533-.22.693-.052a.37.37 0 0 1 .094.276.64.64 0 0 1-.22.435.598.598 0 0 1-.402.177z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M20.475 14.984h1.44v.377h-1.44z"
  }), React__default.createElement("path", {
    d: "M20.487 15.909h1.415v-.875h-1.415v.875zm1.44.062h-1.465v-1h1.465v1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.763 15.612a.061.061 0 0 0-.026-.004h-1.078a.1.1 0 0 0-.03.005.09.09 0 0 0 .063-.085.093.093 0 0 0-.066-.086c.01.003.021.005.032.005h1.079c.01 0 .021 0 .03-.004l-.007.002a.085.085 0 0 0-.06.083.09.09 0 0 0 .063.084z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M20.679 16.276h1.035a2.072 2.072 0 0 1-.026-.344c0-.134.01-.256.026-.347h-1.037c.018.095.028.219.028.347 0 .13-.01.25-.026.344zm-.05.153c-.004 0-.01-.017-.011-.044a.21.21 0 0 1 .007-.08c.033-.058.055-.207.055-.373s-.024-.321-.057-.378a.195.195 0 0 1-.008-.08c.002-.033.009-.052.015-.042.01.015.02.024.028.024h1.079c.006 0 .012 0 .017-.005l.01-.014c.007-.008.013.011.015.044a.2.2 0 0 1-.007.079.055.055 0 0 1-.012.015c-.028.052-.047.192-.047.357 0 .154.02.3.048.358l.007.013a.21.21 0 0 1 .007.082c-.002.031-.009.05-.015.04a.143.143 0 0 1-.007-.013c-.005-.007-.01-.007-.016-.007h-1.078c-.009 0-.017.006-.025.02l-.004.004z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M20.659 15.608h1.078c.036 0 .065.022.065.05 0 .029-.03.051-.065.051h-1.078c-.037 0-.066-.022-.066-.05 0-.029.029-.05.066-.05z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M20.659 15.795c-.03 0-.053.133-.053.296 0 .171.023.305.053.305h1.078c.03 0 .053-.137.053-.305 0-.16-.024-.296-.053-.296h-1.078zm1.078.8h-1.078c-.044 0-.078-.221-.078-.504 0-.277.034-.496.078-.496h1.078c.043 0 .078.223.078.496 0 .283-.034.504-.078.504z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M20.658 15.361h1.079c.036 0 .065.023.065.05 0 .027-.03.05-.065.05h-1.079c-.037 0-.067-.023-.067-.05 0-.027.03-.05.067-.05z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M20.658 15.575c-.03 0-.054.144-.054.272 0 .13.022.275.054.275h1.079c.031 0 .053-.145.053-.275 0-.128-.023-.272-.053-.272h-1.079zm1.079.774h-1.079c-.044 0-.08-.226-.08-.502 0-.275.036-.498.08-.498h1.079c.043 0 .078.223.078.498 0 .276-.035.502-.078.502z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M20.19 21.71c.1 0 .188-.02.253-.055a.567.567 0 0 1 .25-.053.58.58 0 0 1 .253.053.553.553 0 0 0 .253.056.54.54 0 0 0 .253-.058.57.57 0 0 1 .245-.051c.099 0 .184.019.25.052a.555.555 0 0 0 .255.057v.156a.566.566 0 0 1-.255-.057.548.548 0 0 0-.25-.053.58.58 0 0 0-.245.051.557.557 0 0 1-.253.059.56.56 0 0 1-.253-.056.564.564 0 0 0-.253-.054.564.564 0 0 0-.25.053.54.54 0 0 1-.252.057l-.001-.156z",
    fill: "#005BBF"
  }), React__default.createElement("path", {
    d: "M20.693 22.124c.097 0 .189.068.258.191.067.12.155.187.248.187.09 0 .178-.07.248-.195.07-.119.158-.183.25-.183.098 0 .187.064.255.187.065.116.15.184.237.19v-.45c-.092-.006-.182-.078-.248-.2-.065-.115-.15-.175-.244-.175-.088 0-.173.06-.24.172-.07.13-.162.204-.258.204-.098 0-.19-.07-.26-.197-.065-.114-.155-.18-.246-.18s-.178.064-.244.179c-.066.122-.153.192-.246.197v.45c.089-.005.171-.071.234-.187.07-.123.16-.19.256-.19zm1.521.465h-.012c-.095 0-.19-.073-.261-.2-.065-.117-.15-.179-.244-.179-.088 0-.173.062-.24.174-.072.132-.164.205-.258.205-.097 0-.189-.07-.26-.196-.065-.118-.153-.183-.246-.183-.091 0-.178.064-.244.18-.07.128-.161.199-.258.199h-.012l-.002-.624h.013c.094 0 .182-.067.247-.188.07-.122.16-.188.256-.188s.188.067.258.19c.065.118.155.186.248.186.092 0 .18-.069.247-.195.07-.117.159-.181.251-.181.099 0 .187.064.255.185.066.122.157.19.25.19h.012v.625z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M20.19 21.866c.1 0 .188-.021.253-.056a.564.564 0 0 1 .25-.053c.097 0 .187.02.253.054a.558.558 0 0 0 .253.055c.1 0 .188-.024.253-.058a.564.564 0 0 1 .245-.051c.099 0 .184.019.25.053a.566.566 0 0 0 .255.056v.156a.562.562 0 0 1-.255-.057.552.552 0 0 0-.25-.053c-.094 0-.18.02-.245.052a.545.545 0 0 1-.253.058.564.564 0 0 1-.253-.056.569.569 0 0 0-.253-.054.56.56 0 0 0-.25.054.545.545 0 0 1-.252.056l-.001-.156z",
    fill: "#CCC"
  }), React__default.createElement("path", {
    d: "M20.693 22.28c.097 0 .188.068.258.191.068.12.156.186.248.186s.18-.069.247-.194c.07-.119.16-.183.251-.183.098 0 .186.064.255.187.064.115.15.184.237.19v-.449c-.09-.006-.18-.078-.248-.2-.065-.116-.15-.177-.244-.177-.088 0-.173.062-.24.173-.072.132-.164.205-.258.205-.097 0-.19-.07-.26-.196-.065-.117-.153-.182-.246-.182-.091 0-.178.064-.244.18-.067.122-.154.191-.246.197v.449c.089-.006.171-.071.234-.186.07-.123.161-.191.256-.191zm1.521.464h-.012c-.096 0-.191-.073-.261-.2-.066-.116-.15-.178-.244-.178-.087 0-.172.062-.24.174-.07.131-.162.204-.258.204s-.188-.07-.26-.196c-.065-.115-.155-.182-.246-.182s-.178.065-.244.182c-.07.126-.161.196-.258.196h-.012l-.002-.622h.013c.093 0 .181-.067.247-.188.07-.123.16-.19.256-.19.097 0 .189.068.258.192.066.118.156.186.248.186.09 0 .178-.07.248-.195.07-.118.158-.183.25-.183.098 0 .187.065.255.187.068.121.159.191.25.191h.012v.622z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M20.19 22.022a.55.55 0 0 0 .253-.056.56.56 0 0 1 .25-.054c.097 0 .187.02.253.054a.562.562 0 0 0 .253.056.54.54 0 0 0 .253-.058.569.569 0 0 1 .245-.052.56.56 0 0 1 .25.053.562.562 0 0 0 .255.057v.155a.558.558 0 0 1-.255-.057.556.556 0 0 0-.25-.052c-.094 0-.18.02-.245.052a.549.549 0 0 1-.253.057.562.562 0 0 1-.253-.055.565.565 0 0 0-.253-.054.564.564 0 0 0-.25.054.534.534 0 0 1-.252.055l-.001-.155z",
    fill: "#005BBF"
  }), React__default.createElement("path", {
    d: "M20.693 22.438c.098 0 .19.068.258.19.067.12.154.185.248.185.092 0 .18-.069.247-.193.07-.117.158-.182.251-.182.099 0 .187.064.255.184.064.115.15.184.237.19v-.448c-.091-.006-.181-.078-.248-.2-.066-.116-.15-.178-.244-.178-.087 0-.172.062-.24.174-.07.132-.162.205-.258.205-.095 0-.19-.072-.26-.197-.065-.115-.155-.182-.246-.182s-.178.065-.244.182c-.066.121-.154.19-.246.196v.448c.091-.005.172-.07.234-.185.07-.122.16-.189.256-.189zm1.521.461h-.012c-.097 0-.192-.073-.261-.2-.065-.113-.15-.173-.244-.173-.089 0-.174.06-.24.17-.07.131-.162.203-.258.203-.098 0-.19-.069-.26-.194-.064-.116-.152-.18-.246-.18-.092 0-.179.063-.244.178-.069.128-.158.196-.258.196h-.012l-.002-.622h.013c.093 0 .181-.065.247-.186.07-.124.161-.192.256-.192.097 0 .188.068.258.192.066.119.157.186.248.186.092 0 .18-.068.247-.194.07-.119.16-.184.251-.184.098 0 .186.065.255.188.067.121.158.19.25.19h.012v.622z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M20.191 22.334c.1 0 .187-.022.252-.057a.567.567 0 0 1 .25-.053.57.57 0 0 1 .253.054.562.562 0 0 0 .253.056.54.54 0 0 0 .253-.059.561.561 0 0 1 .245-.05c.099 0 .184.018.25.051a.563.563 0 0 0 .255.058v-.156a.558.558 0 0 1-.255-.058.556.556 0 0 0-.25-.051.58.58 0 0 0-.245.05.549.549 0 0 1-.253.058.562.562 0 0 1-.253-.055.565.565 0 0 0-.253-.053.564.564 0 0 0-.25.053.54.54 0 0 1-.253.055l.001.157z",
    fill: "#CCC"
  }), React__default.createElement("path", {
    d: "M20.693 22.592c.097 0 .19.067.258.19.067.119.157.187.248.187.09 0 .178-.07.248-.196.068-.117.157-.181.25-.181.099 0 .187.064.255.185.064.117.15.185.237.192v-.448c-.09-.006-.18-.08-.248-.205-.065-.113-.15-.173-.244-.173-.089 0-.174.06-.24.171-.07.13-.162.203-.258.203-.098 0-.19-.07-.26-.194-.064-.116-.152-.18-.246-.18-.092 0-.179.063-.244.178-.065.12-.152.19-.246.195v.453c.089-.006.171-.072.234-.19.07-.12.16-.187.256-.187zm1.521.464h-.012c-.096 0-.19-.074-.261-.202-.065-.115-.15-.175-.244-.175-.09 0-.174.06-.239.171-.073.133-.165.206-.26.206-.094 0-.188-.072-.258-.197-.066-.116-.154-.18-.247-.18-.091 0-.178.063-.244.178-.07.128-.16.199-.258.199h-.012l-.002-.626h.013c.095 0 .183-.066.247-.186.07-.122.16-.188.256-.188.098 0 .19.067.258.19.067.119.154.184.248.184.092 0 .18-.069.247-.193.07-.117.158-.181.251-.181.099 0 .187.063.255.183.068.124.159.195.25.195h.012v.622z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M20.191 22.489c.1 0 .187-.021.252-.056a.555.555 0 0 1 .25-.054c.097 0 .187.02.253.054a.566.566 0 0 0 .253.056c.1 0 .188-.024.253-.058a.554.554 0 0 1 .245-.052.56.56 0 0 1 .25.053.567.567 0 0 0 .255.057v-.154a.562.562 0 0 1-.255-.059.552.552 0 0 0-.25-.052.57.57 0 0 0-.245.051.552.552 0 0 1-.253.058.564.564 0 0 1-.253-.055.57.57 0 0 0-.253-.054.567.567 0 0 0-.25.053.544.544 0 0 1-.253.056l.001.156z",
    fill: "#005BBF"
  }), React__default.createElement("path", {
    d: "M20.693 22.746c.097 0 .189.068.258.192.067.118.157.186.248.186.09 0 .178-.069.248-.194.068-.12.157-.184.25-.184.098 0 .187.065.255.188.065.115.15.184.237.19v-.445c-.09-.006-.18-.08-.248-.206-.065-.114-.15-.175-.244-.175-.088 0-.173.061-.24.172-.072.132-.164.205-.258.205-.096 0-.188-.07-.26-.197-.065-.116-.153-.18-.246-.18-.091 0-.178.063-.244.178-.066.123-.153.193-.246.199v.449c.089-.006.171-.071.234-.186.07-.124.16-.192.256-.192zm1.521.465h-.012c-.095 0-.19-.073-.261-.2-.065-.117-.15-.178-.244-.178-.09 0-.174.062-.239.174-.073.131-.165.204-.26.204-.094 0-.188-.071-.258-.196-.066-.117-.154-.182-.247-.182-.092 0-.178.065-.244.182-.07.126-.161.196-.258.196h-.012l-.002-.623h.013c.093 0 .181-.067.247-.189.07-.121.16-.188.256-.188.097 0 .19.068.258.19.068.12.156.187.248.187.09 0 .178-.07.248-.196.07-.117.158-.18.25-.18.099 0 .187.063.255.185.07.124.16.196.25.196h.012v.618z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.763 21.071c-.004.014-.008.026-.008.04 0 .095.082.17.181.17h-1.481c.1 0 .181-.075.181-.17a.16.16 0 0 0-.006-.04.081.081 0 0 0 .029.004h1.077c.01 0 .02-.001.027-.004z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M20.553 21.952h1.285c-.057-.135-.096-.385-.096-.669 0-.036.002-.07.003-.102a.028.028 0 0 1-.009.001H20.66l-.012-.001.002.102c0 .284-.039.534-.096.669zm1.383.107h-1.481c-.007 0-.013-.024-.013-.054s.006-.053.013-.053c.093 0 .169-.3.169-.669 0-.057-.003-.111-.006-.157a.18.18 0 0 1 .004-.054c.004-.013.009-.017.013-.01.006.012.017.013.024.013h1.077a.029.029 0 0 0 .023-.013c.005-.007.01 0 .014.019a.207.207 0 0 1 .002.047l-.001.02c-.004.048-.007.09-.007.135 0 .369.076.668.17.668.006 0 .012.025.012.054 0 .03-.006.054-.013.054z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M20.659 20.974h1.078c.036 0 .065.022.065.05 0 .028-.03.051-.065.051h-1.078c-.037 0-.066-.023-.066-.05 0-.029.029-.051.066-.051z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M20.659 21.16c-.03 0-.053.134-.053.299 0 .164.024.303.053.303h1.078c.029 0 .053-.139.053-.303 0-.162-.024-.3-.053-.3h-1.078zm1.078.8h-1.078c-.043 0-.078-.224-.078-.501 0-.275.035-.498.078-.498h1.078c.043 0 .078.223.078.498 0 .277-.035.502-.078.502z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M20.457 21.281h1.477v.377h-1.477z"
  }), React__default.createElement("path", {
    d: "M20.47 22.206h1.452v-.875h-1.453v.875zm1.477.062h-1.503v-1h1.503v1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M22.05 19.64c.146.084.245.17.23.214-.009.04-.055.069-.121.113-.105.073-.169.203-.119.263a.371.371 0 0 1 .01-.59z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M22.29 19.674c-.217.113-.34.281-.34.463 0 .15.086.29.241.4a.148.148 0 0 1 .003-.045c.023-.112.16-.243.343-.327l.017-.008c.146-.064.251-.11.267-.164.027-.048-.147-.171-.53-.32zm-.046.95c-.227-.12-.357-.298-.357-.487 0-.2.14-.383.382-.504l.017-.008.018.007c.194.074.64.26.577.372-.02.068-.135.118-.293.188l-.016.006c-.166.077-.297.2-.317.3a.094.094 0 0 0 .033.098l-.044.029z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#CCC",
    d: "M20.673 15.77h1.05v5.143h-1.05z"
  }), React__default.createElement("path", {
    d: "M20.686 20.9h1.024v-5.118h-.145v5.117h-.025v-5.117h-.093v5.117h-.025v-5.117h-.736V20.9zm1.05.025H20.66v-5.168h1.074v5.168z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M19.6 17.693c.23-.094.619-.165 1.066-.18.154.001.325.017.503.046.628.105 1.106.355 1.068.56l-.003.016s.235-.53.239-.55c.042-.227-.488-.505-1.185-.622a3.585 3.585 0 0 0-.618-.048c-.446 0-.833.057-1.067.144l-.003.634z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M20.665 17.5c.159.002.329.017.506.046.497.083.915.26 1.042.44a.21.21 0 0 1 .037.083c.09-.205.206-.47.21-.487.008-.04-.004-.083-.036-.128-.137-.195-.594-.387-1.138-.478a3.592 3.592 0 0 0-.616-.049c-.419 0-.812.052-1.054.14l-.003.607c.242-.095.633-.16 1.052-.174zm1.57.648h-.004a.013.013 0 0 1-.01-.015l.013.002-.012-.004a.14.14 0 0 1 .003-.017c.006-.034-.004-.072-.033-.113-.123-.175-.535-.348-1.025-.43a3.287 3.287 0 0 0-.501-.045c-.426.014-.823.08-1.06.178a.012.012 0 0 1-.013 0 .012.012 0 0 1-.005-.011l.003-.635c0-.005.003-.01.008-.011.244-.091.644-.145 1.071-.145h.033c.191 0 .394.017.587.049.55.092 1.014.288 1.155.488.028.041.043.08.043.12v.001a.153.153 0 0 1-.003.027c-.004.02-.2.464-.24.553a.013.013 0 0 1-.01.008z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.725 18.339c.29-.021.49-.1.512-.22.018-.098-.08-.206-.256-.303-.079.009-.168.02-.258.02l.002.503z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M21.756 17.885l.004.869c.527-.041.863-.183.9-.381.03-.16-.131-.344-.455-.523l-.012.002c-.133.014-.283.031-.437.033zm-.042.918l-.004-.964h.023c.16 0 .316-.018.455-.033l.027-.003.006.004c.347.19.519.393.485.574-.043.227-.396.38-.968.42l-.024.002z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M20.671 17.945c-.182.028-.318.073-.387.129l-.006.01c-.032.067.128.209.394.367l-.001-.506z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M20.339 18.21l-.012.016c-.047.076.154.284.875.623l-.003-.864c-.402.05-.706.13-.86.225zm.922.72l-.045-.02c-.4-.186-1.055-.525-.941-.705l.022-.028c.165-.105.494-.19.927-.242l.034-.004.003 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M22.376 19.33c.028-.082-.256-.249-.657-.396-.183-.065-.335-.134-.522-.216-.558-.247-.97-.53-.919-.633l.006-.01c-.03.024-.075.532-.075.532-.051.094.326.373.838.618.165.079.511.207.675.264.293.102.584.294.557.365l.097-.523z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M20.276 18.15a7.342 7.342 0 0 0-.056.463c-.004.007-.004.017 0 .03.037.116.395.362.832.571.158.075.49.199.674.264.222.077.482.223.55.322l.088-.47c.021-.066-.216-.225-.65-.384-.169-.06-.313-.124-.48-.198l-.042-.019c-.412-.182-.835-.43-.916-.578zm2.003 1.716a.013.013 0 0 1-.012-.014l.001-.008c0-.067-.266-.244-.55-.342a9.056 9.056 0 0 1-.676-.265c-.45-.216-.806-.462-.846-.587a.063.063 0 0 1 0-.047 5.131 5.131 0 0 1 .07-.52.04.04 0 0 1 .01-.018.012.012 0 0 1 .016 0c.005.004.006.01.003.016l-.006.01v.001l-.002.006c-.019.09.325.347.915.608l.042.019c.167.074.31.137.48.197.355.131.699.31.664.413l-.095.511a.036.036 0 0 1-.002.012.012.012 0 0 1-.012.008z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M20.254 17.468c.04-.15.092-.296.142-.444a.209.209 0 0 1-.034.007.198.198 0 0 1-.035.003 3.532 3.532 0 0 1-.092.319c-.062-.093-.13-.183-.183-.277l-.065.012c-.022.004-.045.005-.068.007.094.126.184.252.272.382l.032-.008.031-.001zm.4-.441l-.057.002c-.02 0-.039-.003-.058-.004l-.007.414.29.005a.11.11 0 0 1-.004-.026c0-.009.002-.018.004-.026a1.96 1.96 0 0 1-.175.005l.007-.37zm.454.068c.047.003.092.012.136.02 0-.009-.002-.018-.001-.027 0-.008.004-.017.006-.025l-.392-.032c0 .009.002.017.001.026 0 .009-.004.017-.006.025.04 0 .088 0 .143.004l-.035.372c.019 0 .039 0 .057.002.02.001.038.005.057.007l.034-.372zm.642.116c.108.02.243.035.243.14a.288.288 0 0 1-.01.064c-.034.123-.143.165-.325.119l.092-.323zm-.48.712c.043.007.09.012.134.02.042.008.087.02.13.03l.11-.386h.012c.025.055.059.12.075.157l.139.292c.054.008.108.014.16.024.055.01.107.023.16.036l-.048-.087c-.074-.132-.152-.265-.216-.398.171.006.303-.047.337-.165.023-.081-.015-.146-.104-.2-.068-.042-.196-.062-.28-.08l-.374-.07-.236.827z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M22.147 17.714l.297-.179-.035.314-.262-.135zm.252.217c-.007.09-.025.179-.043.274.042.019.086.036.126.058.042.02.08.044.12.067l.084-.943-.058-.025a.468.468 0 0 1-.051-.032l-.891.53c.024.01.048.02.07.032.025.012.044.025.067.037.075-.059.153-.107.243-.17l.333.171v.001z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M15.257 13.177zm0 .988a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.337 12.155c.43 0 .812.064 1.06.162.142.064.334.111.543.14.16.021.31.025.442.015.176-.004.43.048.686.16.21.094.387.208.504.318l-.102.09-.029.256-.277.317-.14.119-.328.263-.168.013-.051.146-2.126-.25-2.132.25-.051-.146-.168-.013-.329-.263-.139-.119-.277-.317-.029-.256-.102-.09c.118-.11.293-.224.504-.317.255-.113.51-.165.686-.16.132.009.283.005.442-.016.21-.029.4-.076.543-.14.25-.098.61-.162 1.038-.162z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M14.003 13.986l.171.014.05.145 2.127-.25 2.12.25.05-.145.172-.014.327-.26.138-.119.275-.315.03-.256.096-.087a1.87 1.87 0 0 0-.495-.309 1.763 1.763 0 0 0-.682-.16 2.31 2.31 0 0 1-.444-.015 2.037 2.037 0 0 1-.544-.14c-.26-.103-.645-.162-1.057-.162-.403 0-.77.057-1.035.162a2.03 2.03 0 0 1-.544.14c-.103.014-.204.02-.303.02a1.952 1.952 0 0 1-.16-.004c-.189 0-.437.06-.664.16a1.874 1.874 0 0 0-.494.308l.097.087.029.256.276.316.138.117.326.261zm4.48.177l-.007-.001-2.125-.25-2.138.25-.051-.146-.166-.013-.33-.265-.139-.118-.28-.32v-.003l-.029-.253-.106-.094.007-.007c.123-.115.302-.228.506-.318a1.782 1.782 0 0 1 .69-.161c.138.01.29.005.44-.015a2.01 2.01 0 0 0 .54-.14c.267-.105.637-.163 1.042-.163.414 0 .801.06 1.063.163.136.061.323.11.54.14a2.219 2.219 0 0 0 .461.015c.191 0 .442.06.67.161.205.09.385.204.507.318l.006.007-.106.094-.029.255-.001.002-.278.318-.14.119-.33.265-.166.013-.051.147z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.37 14.962c-.792-.002-1.502-.095-2.008-.248a.078.078 0 0 1-.055-.08c0-.034.02-.065.055-.076.506-.153 1.216-.246 2.008-.248.792.002 1.501.095 2.008.248.035.01.054.042.053.075a.078.078 0 0 1-.053.081c-.507.153-1.216.246-2.008.248z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M16.37 14.335c-.768.002-1.48.132-2.005.365-.028.013-.046.05-.045.094-.002.048.016.088.045.101.525.234 1.237.364 2.005.366.768-.002 1.48-.132 2.004-.366.029-.013.046-.053.045-.1 0-.047-.017-.082-.045-.095-.525-.233-1.236-.363-2.004-.365zm0 .963c-.77-.002-1.485-.132-2.012-.367-.04-.019-.066-.075-.063-.138-.001-.059.024-.111.063-.129.527-.234 1.241-.364 2.012-.366.77.002 1.484.132 2.011.366.04.018.064.069.063.13.002.062-.023.118-.063.137-.527.235-1.24.365-2.011.367z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.368 14.858a7.642 7.642 0 0 1-1.853-.211c.492-.127 1.138-.205 1.853-.206.715.001 1.364.079 1.856.206a7.664 7.664 0 0 1-1.856.21z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M16.462 14.862h-.016v-.424h.016zm-.112 0h-.025v-.424h.026zm-.104 0h-.033v-.424h.033zm-.104 0h-.041v-.424h.041zm-.092 0H16v-.424h.05zm-.23.566l-.024-.956h.192l.024.956h-.191zm.976.012h-.19v-1h.19v1z"
  }), React__default.createElement("path", {
    d: "M15.847 15.425h-.218v-.938h.218v.938zm.564.028l-.023-1h.218l.023 1h-.218z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M15.553 15.43H15.4v-.916h.153v.917zm.416.015h-.153v-.962h.153v.962zm.431.03h-.152v-1h.152v1z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M15.408 14.799h-.083v-.303h.083z"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M15.338 14.783h-.092v-.282h.092z"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M15.262 14.776h-.1v-.262h.1z"
  }), React__default.createElement("path", {
    d: "M15.016 15.486l-.02-.89.311-.001.02.889-.31.002zm.98.043h-.311v-1h.31v1z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M15.014 14.735h-.1v-.183h.1z"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M14.936 14.72h-.1v-.152h.1z"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M14.85 14.7h-.1v-.12h.1z"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M14.764 14.701h-.1v-.1h.1z"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M14.669 14.726h-.1v-.1h.1zm2.871.669h-.009v-.926h.01v.926zm-.573.03h-.01l.008-.981h.01l-.008.982zm-.417.013h-.01v-1h.01v1z"
  }), React__default.createElement("path", {
    d: "M16.364 14.31c-.8.002-1.52.102-2.027.258.042-.02.038-.072-.014-.207-.063-.163-.161-.156-.161-.156.559-.165 1.338-.269 2.206-.27.868.001 1.653.105 2.213.27 0 0-.099-.007-.162.156-.052.135-.056.187-.014.207-.506-.156-1.239-.256-2.04-.258z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M14.21 14.35c.038.026.087.087.125.233.034.135.052.227.04.284.524-.236 1.246-.372 1.99-.375.751.003 1.478.14 2.003.375-.012-.058.005-.151.04-.284.037-.147.086-.208.124-.233-.58-.25-1.346-.387-2.164-.39-.816.002-1.579.14-2.157.39zm4.192.572c-.526-.246-1.268-.389-2.038-.391-.76.002-1.498.145-2.023.391l-.01-.035c.03-.02.035-.075-.02-.29-.056-.22-.138-.226-.148-.226l-.005-.037c.586-.264 1.37-.41 2.21-.412.843.002 1.63.148 2.217.412l-.005.037c-.01 0-.093.007-.15.226-.054.215-.048.27-.02.29l-.008.035z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.368 13.936c-.868.001-1.647.104-2.206.27-.038.01-.077-.003-.09-.039a.069.069 0 0 1 .045-.087c.563-.173 1.362-.281 2.25-.283.89.002 1.692.11 2.255.283a.068.068 0 0 1 .045.087c-.012.036-.052.05-.09.039-.56-.166-1.341-.269-2.21-.27z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M16.368 14.101c.842.004 1.628.224 2.214.619.031.021.064-.01.073-.07a.277.277 0 0 0-.003-.1c-.007-.03-.02-.053-.034-.063-.58-.406-1.4-.641-2.25-.645-.861.004-1.659.233-2.247.645-.014.01-.026.033-.033.064a.278.278 0 0 0-.004.099c.01.06.042.09.074.07.584-.395 1.37-.615 2.21-.619zm2.235.683a.052.052 0 0 1-.029-.009c-.583-.394-1.367-.613-2.206-.616-.838.003-1.62.222-2.203.616a.05.05 0 0 1-.028.01c-.036 0-.066-.045-.077-.117a.406.406 0 0 1 .005-.143c.01-.046.028-.079.049-.093.59-.414 1.39-.643 2.254-.648.853.005 1.676.24 2.258.648.02.014.038.047.048.092a.41.41 0 0 1 .005.144c-.01.072-.04.116-.076.116z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.567 14.923c.512.288 1.15.447 1.8.448.654-.001 1.293-.16 1.806-.448-.502-.28-1.14-.435-1.805-.438-.663.003-1.3.158-1.801.438zm1.8.505c-.673 0-1.332-.17-1.855-.477-.005-.004-.01-.015-.01-.028 0-.013.005-.024.01-.027.51-.299 1.17-.465 1.856-.468.689.003 1.35.169 1.86.468.005.003.009.014.009.027s-.004.024-.01.028c-.523.306-1.183.476-1.86.477z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M15.75 14.133c0-.038.03-.067.07-.067a.07.07 0 0 1 .071.067.069.069 0 0 1-.07.067.07.07 0 0 1-.072-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M16.237 14.21c-.196 0-.35.15-.35.343a.35.35 0 0 0 .699 0 .346.346 0 0 0-.35-.342zm0 .843a.5.5 0 1 1 .001-1.002.5.5 0 0 1-.001 1.002z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.37 14.185h-.213c-.039 0-.071-.03-.071-.066 0-.038.031-.068.07-.068h.43c.039 0 .07.03.07.068 0 .036-.032.066-.071.066h-.215z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M16.213 14.197c-.055 0-.098.151-.098.344 0 .187.045.34.1.34h.717c.054 0 .099-.153.099-.34 0-.193-.043-.344-.098-.344h-.72zm.719.842h-.718c-.078 0-.14-.223-.14-.498 0-.282.06-.502.14-.502h.719c.078 0 .14.22.14.502 0 .275-.063.498-.141.498z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M15.303 14.244l-.152.017a.07.07 0 0 1-.08-.058.067.067 0 0 1 .062-.074l.153-.018.156-.018a.07.07 0 0 1 .08.058.069.069 0 0 1-.063.075l-.156.018z",
    fill: "#058E6E"
  }), React__default.createElement("path", {
    d: "M15.883 14.209c-.005 0-.01 0-.015.002l-.65.186c-.034.008-.064.048-.084.11a.555.555 0 0 0-.023.197c.008.152.07.262.14.244l.646-.182c.033-.01.063-.05.083-.113a.577.577 0 0 0 .024-.201c-.007-.139-.06-.243-.121-.243zm-.648.87c-.09 0-.165-.153-.176-.358a.839.839 0 0 1 .033-.294c.03-.09.073-.147.121-.158l.649-.186c.097-.028.183.134.194.353a.855.855 0 0 1-.034.297c-.03.09-.071.148-.12.16l-.646.183a.084.084 0 0 1-.021.004z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.683 14.257c0-.037.031-.067.07-.067.04 0 .072.03.072.067a.07.07 0 0 1-.071.068.069.069 0 0 1-.071-.068z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M15.171 14.335a.347.347 0 0 0-.35.343c0 .188.157.342.35.342a.346.346 0 0 0 .349-.342.346.346 0 0 0-.349-.343zm0 .843z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#AD1519",
    d: "M14.21 14.379l.08-.103.217.028-.174.127z"
  }), React__default.createElement("path", {
    d: "M14.305 14.871l.29.234.406-.57-.512-.125-.184.461zm.299.392l-.413-.334.266-.666.734.18-.587.82z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.436 14.244l.152.017c.04.005.076-.021.08-.058a.067.067 0 0 0-.061-.074l-.154-.018-.156-.018a.069.069 0 0 0-.079.058c-.005.037.024.07.062.075l.156.018z",
    fill: "#058E6E"
  }), React__default.createElement("path", {
    d: "M17.38 14.209c-.062 0-.114.104-.12.243-.005.07.003.14.02.197.02.064.052.107.086.117l.646.182c.068.02.132-.094.14-.243a.567.567 0 0 0-.024-.2c-.02-.061-.05-.1-.083-.108l-.65-.186a.078.078 0 0 0-.015-.002zm.648.87a.08.08 0 0 1-.021-.003l-.647-.182c-.048-.014-.092-.074-.121-.166a.836.836 0 0 1-.032-.293c.01-.218.097-.379.194-.352l.65.186c.047.01.09.068.119.157.027.085.04.19.034.295-.01.204-.086.359-.176.359z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.848 14.133c0-.038.033-.067.071-.067.04 0 .071.03.071.067a.07.07 0 0 1-.07.067c-.04 0-.072-.03-.072-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M17.337 14.21a.347.347 0 0 0-.35.343c0 .186.16.342.35.342a.346.346 0 0 0 .348-.342.346.346 0 0 0-.348-.342zm0 .843z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.915 14.257c0-.037.031-.067.07-.067.04 0 .072.03.072.067a.07.07 0 0 1-.071.068.07.07 0 0 1-.071-.068z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M18.402 14.335a.346.346 0 0 0-.349.343c0 .188.157.342.35.342a.347.347 0 0 0 .349-.342.347.347 0 0 0-.35-.343zm0 .843a.501.501 0 1 1 .002-1.002.501.501 0 0 1-.002 1.002z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#AD1519",
    d: "M18.528 14.379l-.078-.103-.218.028.174.127z"
  }), React__default.createElement("path", {
    d: "M18.265 14.382l.143.247.1-.102-.064-.2-.179.055zm.14.315l-.206-.356.257-.078.092.29-.144.144zm-.1.566c-.518-.349-1.207-.542-1.937-.545-.728.003-1.415.196-1.934.545l-.007-.058c.521-.35 1.21-.544 1.94-.547.734.003 1.424.197 1.946.547l-.007.058z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.767 12.717l.09.071.134-.22a.498.498 0 0 1-.242-.479c.014-.28.356-.511.788-.511.225 0 .428.061.571.16a2.51 2.51 0 0 1 .014-.12 1.168 1.168 0 0 0-.585-.147c-.498 0-.887.283-.906.618a.596.596 0 0 0 .207.51l-.07.117z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M14.784 12.714l.069.055.12-.196a.507.507 0 0 1-.236-.485c.014-.293.365-.523.8-.523.21 0 .413.055.56.15l.01-.09a1.165 1.165 0 0 0-.57-.142c-.474 0-.875.272-.893.606a.586.586 0 0 0 .203.5l.008.008-.071.117zm.076.093l-.11-.088.072-.117a.61.61 0 0 1-.203-.515c.02-.352.423-.63.918-.63.217 0 .427.054.59.15l.008.004-.001.009c-.006.04-.01.078-.013.12l-.002.02-.018-.012c-.145-.1-.35-.158-.564-.158-.421 0-.762.22-.775.5a.483.483 0 0 0 .236.468l.01.007-.148.242z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.773 12.719c-.17-.127-.276-.3-.276-.49 0-.218.144-.413.36-.543a.572.572 0 0 0-.23.462c0 .178.082.34.211.451l-.065.12z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M15.158 11.784c-.39.126-.607.282-.607.446 0 .174.241.341.68.47l.14-.098c-.346-.117-.544-.282-.544-.454 0-.019.003-.038.01-.06.02-.11.13-.213.321-.304zm.095.954l-.03-.009c-.476-.135-.738-.313-.738-.5 0-.212.35-.414.962-.554l.038.021c-.352.108-.554.244-.583.394a.213.213 0 0 0-.009.058c0 .168.198.329.542.442l.02.007-.202.14z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M13.274 12.94a.59.59 0 0 1-.095-.65c.137-.283.57-.489 1.082-.489.14 0 .273.015.396.044-.027.03-.048.062-.07.095a1.722 1.722 0 0 0-.326-.03c-.47 0-.863.182-.977.429a.474.474 0 0 0-.047.206c0 .15.07.284.18.376l-.17.278-.09-.073.117-.186z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M13.173 13.124l.071.056.157-.256a.489.489 0 0 1-.128-.59c.119-.258.525-.437.988-.437.11 0 .217.01.32.03a.825.825 0 0 1 .053-.075 1.765 1.765 0 0 0-.373-.038c-.493 0-.933.198-1.071.482a.569.569 0 0 0 .093.636l.006.007-.116.185zm.078.094l-.111-.089.118-.187a.603.603 0 0 1-.09-.657c.144-.297.583-.496 1.093-.496.14 0 .274.014.4.043l.02.005-.014.016a.668.668 0 0 0-.065.088l-.008.013-.009-.001a1.7 1.7 0 0 0-.324-.031c-.454 0-.85.173-.965.422a.464.464 0 0 0 .13.568l.008.007-.183.299z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M13.447 12.01a.712.712 0 0 0-.268.28.585.585 0 0 0 .095.65l-.104.168a.703.703 0 0 1-.156-.433c0-.271.172-.508.433-.665z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M13.412 12.247c-.23.129-.355.276-.355.428 0 .143.109.285.315.41l.196-.143c-.215-.112-.333-.252-.333-.397 0-.09.045-.178.133-.26a.607.607 0 0 1 .044-.038zm-.035.883l-.025-.014c-.23-.134-.35-.286-.35-.44 0-.262.353-.509.97-.677l.03.021c-.274.079-.476.174-.584.276-.085.079-.128.163-.128.25 0 .14.119.278.333.386l.014.007-.26.19z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.363 11.415a.24.24 0 0 1 .235.176c.015.09.024.19.026.299v.033l.003.04c.004.227.036.427.082.55l-.347.332-.35-.332c.046-.123.079-.323.083-.55l.003-.04-.001-.033a2.11 2.11 0 0 1 .026-.299c.024-.1.126-.176.24-.176z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M16.038 12.51l.462.318.457-.318a1.393 1.393 0 0 1-.11-.547l-.002-.015-.003-.025.001-.013v-.02a1.524 1.524 0 0 0-.036-.297c-.03-.095-.16-.165-.307-.165-.148 0-.282.071-.312.166a1.62 1.62 0 0 0-.036.296v.016l.001.017c0 .007 0 .014-.002.022a1.362 1.362 0 0 1-.114.565zm.462.352l-.503-.345.004-.008c.065-.125.108-.329.114-.546 0-.007 0-.014.002-.021a.117.117 0 0 0 0-.035v-.017c.003-.106.016-.207.037-.3.034-.108.182-.187.346-.187.163 0 .307.078.341.186a1.539 1.539 0 0 1 .037.322v.012l.001.022.002.017c.005.216.047.42.112.547l.004.007-.497.346z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.363 11.523a.12.12 0 0 1 .12.09c.015.084.024.18.026.283v.03l.002.039c.003.214.034.403.078.52l-.228.216-.229-.216c.043-.117.074-.306.078-.52 0-.013.003-.026.003-.038v-.031c.001-.103.01-.199.025-.283.012-.053.066-.09.125-.09z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M16.178 12.481l.44.203.439-.203a.944.944 0 0 1-.159-.53l-.003-.024v-.016l.002-.015a.93.93 0 0 0-.053-.281c-.023-.047-.114-.08-.223-.08-.11 0-.21.035-.23.08a.939.939 0 0 0-.053.28v.016l.001.016a.095.095 0 0 1-.003.02l-.002.018a.964.964 0 0 1-.156.516zm.44.237l-.5-.23.005-.008a.94.94 0 0 0 .16-.516c0-.006 0-.013.002-.02l.002-.017v-.031a.95.95 0 0 1 .053-.285c.026-.058.147-.1.281-.1.133 0 .245.04.273.099.032.088.05.184.054.285v.032c0 .007 0 .014.002.021l.002.016a.918.918 0 0 0 .16.516l.005.008-.5.23z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.955 12.717l-.09.071-.134-.22a.497.497 0 0 0 .242-.479c-.013-.28-.355-.511-.788-.511a1.01 1.01 0 0 0-.57.16 1.646 1.646 0 0 0-.015-.12c.158-.092.362-.147.585-.147.498 0 .888.283.907.618l.003.06a.593.593 0 0 1-.212.45l.072.117z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M17.748 12.573l.12.196.07-.055-.07-.117.007-.007a.586.586 0 0 0 .204-.5c-.019-.335-.42-.607-.894-.607-.208 0-.41.05-.57.141l.01.092c.15-.098.348-.15.56-.15.435 0 .787.23.8.523a.506.506 0 0 1-.238.484h.001zm.114.234l-.148-.242.01-.007a.482.482 0 0 0 .237-.467c-.014-.281-.354-.5-.776-.5a1 1 0 0 0-.563.157l-.018.013-.002-.022a1.623 1.623 0 0 0-.014-.12l-.001-.008.007-.004c.165-.096.375-.15.591-.15.496 0 .9.278.92.63a.61.61 0 0 1-.204.514l.07.118-.109.088z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.95 12.719c.17-.127.275-.3.275-.49 0-.218-.143-.413-.36-.543a.573.573 0 0 1 .23.462c0 .178-.082.34-.212.451l.066.12z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M17.968 12.602l.142.098c.44-.13.68-.296.68-.47 0-.164-.217-.32-.607-.446.191.09.301.194.323.304a.252.252 0 0 1 .008.06c0 .172-.198.336-.546.454zm.121.136l-.204-.141.02-.007c.345-.113.543-.274.543-.442a.23.23 0 0 0-.008-.058c-.03-.15-.231-.286-.583-.394l.038-.02c.611.139.962.34.962.554 0 .186-.262.364-.738.5l-.03.008z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M19.45 12.94a.593.593 0 0 0 .094-.65c-.138-.283-.57-.489-1.082-.489-.14 0-.274.015-.398.044.028.03.05.062.07.095.103-.02.213-.03.328-.03.47 0 .862.182.976.429.03.062.047.133.047.206a.49.49 0 0 1-.18.376l.17.278.09-.073-.116-.186z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M19.32 12.924l.157.256.072-.056-.115-.185.006-.007a.574.574 0 0 0 .093-.637c-.139-.283-.58-.481-1.071-.481-.13 0-.256.013-.374.038a.75.75 0 0 1 .053.074c.103-.02.21-.03.32-.03.463 0 .87.18.988.437a.488.488 0 0 1 .048.212.504.504 0 0 1-.176.379zm.15.294l-.182-.3.008-.006a.479.479 0 0 0 .176-.367c0-.07-.016-.14-.046-.2-.114-.25-.511-.423-.964-.423-.112 0-.22.01-.325.03l-.008.002-.008-.011a.625.625 0 0 0-.066-.09l-.015-.016.022-.005c.126-.029.26-.043.4-.043.509 0 .948.199 1.093.496a.597.597 0 0 1-.09.657l.118.187-.112.089z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M19.275 12.01a.717.717 0 0 1 .27.28.588.588 0 0 1-.096.65l.103.168a.7.7 0 0 0 .156-.433c0-.271-.172-.508-.433-.665z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M19.703 12.942l.196.144c.205-.125.314-.267.314-.41 0-.152-.123-.298-.351-.426a.57.57 0 0 1 .041.035c.088.083.133.17.133.26 0 .144-.119.285-.333.397zm.19.188l-.26-.191.015-.007c.214-.109.332-.246.332-.387 0-.086-.043-.17-.127-.25-.11-.101-.311-.196-.584-.275l.029-.021c.617.168.97.415.97.676 0 .156-.12.308-.35.44l-.024.015z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.24 12.556c0-.064.054-.116.123-.116a.12.12 0 0 1 .122.116.12.12 0 0 1-.122.117.12.12 0 0 1-.124-.117z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M16.728 12.525a.405.405 0 0 0-.408.4.407.407 0 0 0 .814 0c0-.22-.182-.4-.406-.4zm0 .902z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.24 12.328a.12.12 0 0 1 .123-.117.12.12 0 0 1 .122.117.12.12 0 0 1-.122.116.12.12 0 0 1-.124-.116z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M16.728 12.296a.406.406 0 0 0-.408.403c0 .222.183.402.408.402.224 0 .406-.18.406-.402a.404.404 0 0 0-.406-.403zm0 .903a.501.501 0 1 1 .499-.5.5.5 0 0 1-.5.5z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.264 12.082c0-.051.044-.093.098-.093.054 0 .098.042.098.093a.095.095 0 0 1-.098.093.095.095 0 0 1-.098-.093z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M16.754 12.096c-.214 0-.39.17-.39.38a.388.388 0 0 0 .774.001c0-.21-.173-.38-.384-.38zm0 .88a.502.502 0 0 1-.503-.5.5.5 0 1 1 .503.5z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.292 11.86c0-.036.031-.066.07-.066.04 0 .07.03.07.067a.07.07 0 0 1-.07.067.07.07 0 0 1-.07-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M16.781 11.94a.345.345 0 0 0-.351.337.35.35 0 0 0 .698 0 .343.343 0 0 0-.347-.338zm0 .841z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.306 11.668c0-.03.025-.054.056-.054s.057.024.057.054-.026.053-.057.053a.055.055 0 0 1-.056-.053z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M16.795 11.791c-.176 0-.32.14-.32.31 0 .172.144.31.32.31a.313.313 0 0 0 .316-.31.313.313 0 0 0-.316-.31zm0 .81a.501.501 0 0 1-.502-.5.5.5 0 1 1 .502.5z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.373 13.256l.08.015a.31.31 0 0 0 .302.406.316.316 0 0 0 .301-.208c.005.003.03-.109.044-.107.011.001.01.116.014.114.02.151.16.254.315.254a.31.31 0 0 0 .314-.337l.1-.098.053.125a.274.274 0 0 0-.03.131c0 .159.136.287.304.287.105 0 .197-.05.252-.127l.064-.081-.001.098c0 .1.042.19.14.206 0 0 .111.006.26-.11.148-.116.229-.212.229-.212l.013.116s-.123.19-.256.268c-.074.042-.185.087-.274.073-.093-.016-.16-.09-.194-.177a.45.45 0 0 1-.23.063.439.439 0 0 1-.408-.25.469.469 0 0 1-.695-.02.466.466 0 0 1-.315.121.464.464 0 0 1-.384-.197.465.465 0 0 1-.384.197.464.464 0 0 1-.314-.12.47.47 0 0 1-.696.02.44.44 0 0 1-.408.249.449.449 0 0 1-.23-.063c-.034.087-.1.161-.194.177-.088.014-.2-.03-.273-.073-.134-.078-.257-.268-.257-.268l.013-.116s.082.096.23.212c.148.117.26.11.26.11.097-.016.14-.106.14-.206l-.001-.098.063.08a.308.308 0 0 0 .252.128.295.295 0 0 0 .303-.287.27.27 0 0 0-.03-.131l.054-.125.1.098a.309.309 0 0 0 .314.337c.156 0 .295-.103.315-.254.004.002.003-.113.015-.114.012-.002.038.11.043.107.041.12.16.207.302.207a.31.31 0 0 0 .302-.405l.083-.015z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M18.41 13.993l.005.016c.036.11.105.186.184.202a.18.18 0 0 0 .034.003.463.463 0 0 0 .231-.088c.12-.083.232-.278.25-.31l-.01-.1c-.032.042-.105.13-.211.23-.137.127-.245.134-.265.134h-.005c-.093-.019-.15-.118-.15-.26v-.074l-.042.063a.307.307 0 0 1-.261.156c-.174 0-.316-.16-.316-.356 0-.06.01-.112.028-.156l-.043-.123-.082.096a.397.397 0 0 1 .002.039c0 .205-.148.372-.33.372-.165 0-.305-.133-.327-.31a.257.257 0 0 1-.004-.05.499.499 0 0 0-.003-.053l-.013.049a.22.22 0 0 1-.015.048c-.045.151-.17.252-.312.252-.183 0-.33-.167-.33-.372 0-.047.003-.083.01-.114l-.062-.013-.066.013c.01.038.01.079.01.114 0 .205-.147.372-.33.372-.141 0-.266-.1-.312-.252-.004-.006-.007-.02-.014-.046l-.014-.05a1.869 1.869 0 0 0-.003.055.153.153 0 0 1-.004.046c-.022.18-.16.311-.327.311-.182 0-.33-.167-.33-.372l.002-.038-.082-.097-.044.123a.39.39 0 0 1 .029.156c0 .197-.142.356-.316.356a.307.307 0 0 1-.262-.157l-.04-.061v.073c0 .144-.056.241-.15.26h-.006c-.02 0-.129-.007-.264-.134-.107-.1-.18-.188-.213-.23l-.009.1c.018.032.13.227.25.31.095.065.196.098.265.085.08-.016.147-.09.185-.202l.006-.016.012.009a.385.385 0 0 0 .223.073.428.428 0 0 0 .397-.288l.007-.021.013.017c.085.11.198.168.326.168a.431.431 0 0 0 .351-.191l.009-.013.01.011c.082.09.19.14.305.14.15 0 .293-.087.374-.228l.01-.018.01.018a.432.432 0 0 0 .373.228c.115 0 .224-.05.307-.14l.01-.01.009.012a.43.43 0 0 0 .35.19.404.404 0 0 0 .326-.167l.013-.017.008.02a.427.427 0 0 0 .397.289.386.386 0 0 0 .222-.073l.013-.009zm.223.25a.202.202 0 0 1-.038-.003c-.084-.016-.157-.092-.198-.204a.406.406 0 0 1-.223.069.452.452 0 0 1-.412-.286.429.429 0 0 1-.333.162.453.453 0 0 1-.36-.19.437.437 0 0 1-.314.137.454.454 0 0 1-.384-.224.454.454 0 0 1-.384.224.434.434 0 0 1-.313-.137.454.454 0 0 1-.362.19.429.429 0 0 1-.331-.162.452.452 0 0 1-.412.286.406.406 0 0 1-.223-.069c-.043.114-.115.188-.2.204a.197.197 0 0 1-.037.004.487.487 0 0 1-.243-.092c-.136-.093-.256-.315-.261-.324l-.003-.005.017-.178.019.027s.083.115.228.25c.129.122.229.128.248.128h.003c.08-.016.128-.102.128-.23l-.001-.16.086.13a.283.283 0 0 0 .242.145c.16 0 .29-.146.29-.326a.353.353 0 0 0-.028-.149l-.003-.006.063-.176.118.137v.008l-.003.042c0 .189.136.342.304.342.156 0 .284-.122.303-.29l.002-.017.001-.022c.004-.086.006-.107.022-.109.017 0 .024.021.044.097l.006.023.001-.001.006.019c.04.141.157.236.29.236.168 0 .304-.153.304-.342a.365.365 0 0 0-.014-.12l-.006-.017.1-.02.098.02-.006.017a.385.385 0 0 0-.014.12c0 .189.136.342.304.342.134 0 .25-.095.29-.236l.005-.018.002.001.007-.026c.02-.075.027-.095.042-.095.017.002.02.022.023.106l.001.024.003.019c.018.165.148.29.302.29.168 0 .304-.154.304-.343 0-.016 0-.03-.002-.042l-.001-.007.117-.138.063.176-.003.006a.358.358 0 0 0-.028.15c0 .18.13.325.29.325a.283.283 0 0 0 .242-.144l.087-.131v.16c0 .128.048.214.128.23.02 0 .12-.006.25-.128.146-.135.228-.25.228-.25l.02-.027.016.178-.002.005c-.006.01-.126.23-.261.324a.486.486 0 0 1-.244.092z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.553 13.652c.018-.053.002-.106-.037-.118-.038-.012-.085.021-.103.075-.019.054-.003.107.036.119.039.012.086-.022.104-.076z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M18.986 13.631c-.165 0-.34.13-.416.308-.053.126-.05.257.008.35a.248.248 0 0 0 .217.118c.167 0 .344-.131.422-.311.052-.127.048-.259-.012-.352a.236.236 0 0 0-.147-.103.282.282 0 0 0-.072-.01zm-.191.888a.462.462 0 0 1-.109-.013.38.38 0 0 1-.232-.166.474.474 0 0 1-.016-.438c.114-.265.414-.433.661-.37a.37.37 0 0 1 .23.16.48.48 0 0 1 .02.44.63.63 0 0 1-.554.387z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.172 13.385c.008-.056-.019-.105-.06-.11-.04-.004-.079.037-.086.093-.007.056.02.105.06.11.04.005.08-.037.086-.093z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M17.554 13.372c-.185 0-.357.158-.392.36a.379.379 0 0 0 .103.336.292.292 0 0 0 .18.082c.205.02.382-.146.416-.359a.376.376 0 0 0-.098-.334.294.294 0 0 0-.21-.085zm-.08.89a.452.452 0 0 1-.454-.544.552.552 0 0 1 .576-.455.45.45 0 0 1 .28.125.464.464 0 0 1 .129.417.545.545 0 0 1-.532.457z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M15.57 13.385c-.008-.056.02-.105.06-.11.04-.004.08.037.086.093.007.056-.02.105-.06.11-.04.005-.079-.037-.087-.093z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M16.015 13.372c-.009 0-.018 0-.027.002a.29.29 0 0 0-.18.083.378.378 0 0 0-.102.335c.04.211.227.376.417.359a.293.293 0 0 0 .182-.083.375.375 0 0 0 .1-.336c-.032-.202-.204-.36-.39-.36zm.081.89a.555.555 0 0 1-.533-.456.466.466 0 0 1 .13-.417.455.455 0 0 1 .322-.127c.263 0 .492.197.533.457a.467.467 0 0 1-.13.418.45.45 0 0 1-.322.125z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.19 13.652c-.019-.053-.003-.106.036-.118.039-.012.085.021.103.075.018.054.002.107-.037.119-.038.012-.084-.022-.103-.076z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M14.577 13.632a.3.3 0 0 0-.072.008.24.24 0 0 0-.148.105c-.06.093-.064.224-.01.351.089.205.31.346.486.302a.245.245 0 0 0 .15-.108.392.392 0 0 0 .01-.352c-.075-.177-.25-.306-.416-.306zm.188.887c-.226 0-.452-.16-.55-.386a.474.474 0 0 1 .017-.44.37.37 0 0 1 .232-.16.444.444 0 0 1 .113-.014.62.62 0 0 1 .548.383.475.475 0 0 1-.018.44.378.378 0 0 1-.232.164.456.456 0 0 1-.11.013z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.79 12.731a.345.345 0 0 1 .148.196s.008-.016.046-.038c.038-.021.07-.02.07-.02l-.016.084c-.006.022-.006.09-.02.15a.53.53 0 0 1-.041.109.127.127 0 0 0-.188.031s-.042-.037-.078-.089c-.035-.052-.06-.115-.073-.134l-.046-.074s.03-.012.073-.003c.043.007.057.02.057.02a.33.33 0 0 1 .067-.232z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M14.65 13.151c.022.032.057.084.075.107a.95.95 0 0 1 .04.07c.027.05.064.117.107.175a.979.979 0 0 0 .133.14.305.305 0 0 1 .373-.057.898.898 0 0 0 .067-.168c.017-.065.024-.134.03-.19a.414.414 0 0 1 .012-.084 3.5 3.5 0 0 0 .026-.123.326.326 0 0 0-.182.092l-.031.048-.016-.054a.612.612 0 0 0-.269-.33.536.536 0 0 0-.116.388l.007.062-.05-.043s-.026-.02-.102-.03a.346.346 0 0 0-.104-.003zm.366.564l-.024-.019a1.066 1.066 0 0 1-.162-.167c-.046-.061-.083-.13-.11-.18a.566.566 0 0 0-.037-.065 3.082 3.082 0 0 1-.094-.136l-.016-.023.028-.01a.391.391 0 0 1 .162-.007.43.43 0 0 1 .082.02.59.59 0 0 1 .144-.397l.014-.016.02.01a.685.685 0 0 1 .297.331.423.423 0 0 1 .07-.043.36.36 0 0 1 .153-.041h.03l-.004.027c-.001.004-.023.115-.033.156a.586.586 0 0 0-.01.078c-.006.053-.013.127-.032.196a.91.91 0 0 1-.085.203l-.014.025-.024-.018a.247.247 0 0 0-.185-.043.22.22 0 0 0-.155.094l-.015.025z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.818 13.39a.12.12 0 0 1-.044-.069.114.114 0 0 1 .015-.08s-.057-.028-.118-.044a.745.745 0 0 0-.153-.013l-.074-.002a.373.373 0 0 0 .05.084.335.335 0 0 0-.196.135.357.357 0 0 0 .233.063s-.008.022-.013.055c-.004.028-.004.04-.004.04l.07-.025c.022-.009.099-.036.138-.063a.7.7 0 0 0 .096-.08z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M14.765 13.856l-.013.046c0 .001-.013.053-.022.13a1.846 1.846 0 0 0-.004.047l.092-.044.015-.008a1.2 1.2 0 0 0 .23-.141c.065-.06.124-.135.151-.172a.366.366 0 0 1-.067-.166.412.412 0 0 1 .018-.187 1.048 1.048 0 0 0-.187-.093.987.987 0 0 0-.27-.03 1.74 1.74 0 0 0-.097-.005l.016.04a.96.96 0 0 0 .056.115l.022.039-.035.01a.598.598 0 0 0-.325.294.49.49 0 0 0 .384.13l.036-.005zm-.086.313v-.044a1.189 1.189 0 0 1 .021-.199.544.544 0 0 1-.4-.162l-.02-.018.014-.025a.684.684 0 0 1 .333-.332 1.413 1.413 0 0 1-.074-.177l-.012-.043h.034s.09.002.134.006h.002c.07 0 .2.005.278.033.112.04.213.108.218.112l.021.015-.012.028a.325.325 0 0 0-.024.174c.01.072.044.123.07.152l.019.021-.017.024c-.004.005-.082.116-.176.203-.066.06-.183.12-.24.148l-.015.008-.124.061-.03.015z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M15.002 13.36a.112.112 0 0 0-.027-.149s.043-.046.095-.081c.038-.027.116-.053.138-.062l.07-.025s0 .011-.004.039c-.005.033-.013.056-.013.056a.35.35 0 0 1 .233.064.341.341 0 0 1-.196.134s.014.018.032.048l.018.036-.074-.002c-.025 0-.107 0-.153-.013-.062-.016-.12-.045-.12-.045z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M15.07 13.833c.035.022.11.066.188.093.077.028.214.03.27.03l.097.004a2.908 2.908 0 0 0-.017-.042c-.029-.068-.055-.11-.055-.111l-.023-.039.035-.011a.61.61 0 0 0 .327-.291.485.485 0 0 0-.385-.133l-.036.006.012-.046s.013-.055.022-.132l.005-.046a18.27 18.27 0 0 1-.092.046l-.023.012a1.1 1.1 0 0 0-.222.135c-.065.06-.123.135-.15.172a.344.344 0 0 1 .066.166.397.397 0 0 1-.02.187zm.626.191l-.17-.005a.974.974 0 0 1-.28-.033 1.106 1.106 0 0 1-.218-.111l.01-.029-.019-.017a.311.311 0 0 0 .025-.172.264.264 0 0 0-.068-.15l-.02-.021.017-.025a1.35 1.35 0 0 1 .175-.204c.062-.057.172-.112.231-.142l.023-.011.125-.064.03-.016v.045a1.094 1.094 0 0 1-.022.2.55.55 0 0 1 .402.164l.019.018-.014.025a.693.693 0 0 1-.333.33 1.393 1.393 0 0 1 .073.174l.014.044z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.758 13.3c0-.074.063-.133.14-.133.077 0 .14.06.14.133a.136.136 0 0 1-.14.132.136.136 0 0 1-.14-.132z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M15.246 13.24a.416.416 0 0 0-.418.415c0 .227.188.412.418.412.23 0 .417-.185.417-.412a.416.416 0 0 0-.417-.414zm0 .914a.5.5 0 1 1 0-1.001.5.5 0 0 1 0 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.367 12.519c.068.061.12.152.126.246 0 0 .012-.017.059-.034.047-.016.082-.01.082-.01l-.035.092c-.011.024-.025.098-.054.163a.59.59 0 0 1-.068.114.144.144 0 0 0-.216 0s-.04-.05-.068-.114c-.029-.065-.043-.14-.054-.163l-.036-.092s.036-.006.083.01c.046.017.059.034.059.034a.383.383 0 0 1 .122-.246z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M16.587 13.369c.07 0 .138.025.188.069a.922.922 0 0 0 .102-.164c.03-.064.052-.133.069-.189a.642.642 0 0 1 .027-.08 2.77 2.77 0 0 0 .052-.124.347.347 0 0 0-.108.018c-.072.024-.093.049-.093.049l-.036.043-.004-.054a.586.586 0 0 0-.2-.379.59.59 0 0 0-.194.379l-.005.056-.036-.045s-.022-.025-.094-.049a.338.338 0 0 0-.107-.018c.014.035.04.097.053.124.008.016.015.043.025.076a1.4 1.4 0 0 0 .07.193.901.901 0 0 0 .102.164.284.284 0 0 1 .189-.07zm.192.133l-.018-.019a.24.24 0 0 0-.174-.073.237.237 0 0 0-.174.073l-.018.019-.016-.02a.931.931 0 0 1-.123-.191 1.314 1.314 0 0 1-.072-.199c-.01-.03-.018-.057-.024-.07-.02-.04-.063-.148-.065-.152l-.01-.024.027-.004s.068-.012.158.018a.389.389 0 0 1 .08.035.646.646 0 0 1 .218-.38l.015-.013.015.012a.645.645 0 0 1 .226.381.403.403 0 0 1 .078-.035c.092-.03.158-.018.158-.018l.026.004-.009.023c-.002.005-.044.113-.063.153a.641.641 0 0 0-.025.075.934.934 0 0 1-.194.386l-.016.019z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.263 13.26a.129.129 0 0 1-.034-.086c0-.033.012-.063.033-.086 0 0-.058-.043-.122-.072-.05-.023-.141-.038-.168-.043l-.083-.016.013.044c.013.036.026.06.026.06a.39.39 0 0 0-.246.113.39.39 0 0 0 .246.113s-.013.024-.026.06a.472.472 0 0 0-.013.044l.083-.016c.027-.005.118-.02.168-.043.064-.03.123-.072.123-.072z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M15.723 13.442c.103.126.24.206.37.216l.033.003-.016.037a1.036 1.036 0 0 0-.053.175l.102-.025.021-.005c.058-.015.179-.045.247-.086.076-.047.147-.108.18-.136a.363.363 0 0 1-.048-.18c0-.065.016-.128.045-.179a1.154 1.154 0 0 0-.177-.135c-.072-.044-.206-.076-.256-.089l-.012-.002a7.988 7.988 0 0 0-.102-.026l.012.05c.02.074.04.124.04.124l.016.038-.032.002a.555.555 0 0 0-.37.218zm.28.5l.006-.04a1.308 1.308 0 0 1 .051-.194.616.616 0 0 1-.381-.246l-.015-.02.015-.019a.61.61 0 0 1 .381-.25 1.532 1.532 0 0 1-.051-.192l-.006-.04.03.008.134.033.011.003c.057.014.189.046.266.092.105.063.198.155.202.158l.018.018-.015.022a.292.292 0 0 0-.049.166c0 .076.028.132.05.166l-.015.02.012.022a1.438 1.438 0 0 1-.203.157 1.094 1.094 0 0 1-.256.09l-.021.005c-.045.01-.134.033-.134.033l-.03.008z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.474 13.26a.126.126 0 0 0 .001-.172s.058-.043.123-.072c.049-.023.14-.038.168-.043l.08-.016s0 .013-.011.044a.459.459 0 0 1-.026.06.39.39 0 0 1 .246.113.394.394 0 0 1-.246.113.483.483 0 0 0 .038.104l-.081-.016c-.028-.005-.12-.02-.168-.043-.065-.03-.124-.072-.124-.072z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M16.514 13.621c.032.029.104.09.18.137.068.04.19.071.249.086l.12.03a1.157 1.157 0 0 0-.053-.175l-.016-.038.033-.003a.56.56 0 0 0 .371-.215.554.554 0 0 0-.371-.219l-.032-.002.015-.038a1.165 1.165 0 0 0 .053-.174l-.11.027c-.051.013-.186.045-.259.09a1.12 1.12 0 0 0-.178.135.372.372 0 0 1-.002.36zm.6.321l-.179-.045c-.06-.015-.185-.046-.258-.09-.106-.065-.2-.154-.205-.158l.012-.023-.015-.019a.288.288 0 0 0 .05-.166.296.296 0 0 0-.047-.166l-.016-.022.018-.018c.004-.003.097-.095.203-.158a.999.999 0 0 1 .268-.093l.168-.042-.003.036a1.47 1.47 0 0 1-.05.196.61.61 0 0 1 .382.25l.014.019-.014.019a.614.614 0 0 1-.382.247l.03.097c.017.066.02.097.02.099l.004.037z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.953 12.731a.35.35 0 0 0-.149.196s-.008-.016-.046-.038c-.037-.021-.07-.02-.07-.02s.011.062.017.084c.005.022.005.09.02.15s.04.109.04.109a.127.127 0 0 1 .188.031s.043-.037.078-.089.06-.115.073-.134l.046-.074s-.03-.012-.073-.003c-.044.007-.057.02-.057.02a.327.327 0 0 0-.067-.232z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M18.021 13.547a.304.304 0 0 1 .222.097.98.98 0 0 0 .132-.14c.043-.059.079-.125.105-.174a.708.708 0 0 1 .041-.071 2.74 2.74 0 0 0 .075-.108.352.352 0 0 0-.103.002.245.245 0 0 0-.103.032l-.05.039.007-.06a.53.53 0 0 0-.115-.388.623.623 0 0 0-.27.332l-.018.06-.03-.057s-.016-.024-.082-.058a.323.323 0 0 0-.098-.033c.007.037.02.097.028.124.004.018.007.047.011.085.005.055.012.124.029.19a.84.84 0 0 0 .068.168.305.305 0 0 1 .151-.04zm.21.168l-.015-.025a.221.221 0 0 0-.155-.094.245.245 0 0 0-.185.043l-.024.017-.014-.024a.93.93 0 0 1-.086-.203c-.017-.069-.024-.142-.03-.196a.619.619 0 0 0-.01-.077c-.011-.042-.033-.153-.034-.157l-.005-.027h.03c.014 0 .08.002.154.04a.42.42 0 0 1 .07.044.68.68 0 0 1 .298-.33l.02-.011.013.016a.584.584 0 0 1 .143.397.454.454 0 0 1 .244-.013l.028.01-.015.023a3.424 3.424 0 0 1-.095.136.71.71 0 0 0-.037.066c-.027.05-.064.118-.109.18a1.004 1.004 0 0 1-.162.166l-.023.019z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.924 13.39a.111.111 0 0 0 .043-.069.109.109 0 0 0-.014-.08s.057-.028.118-.044a.747.747 0 0 1 .153-.013l.074-.002s-.004.011-.018.036c-.017.03-.032.048-.032.048a.34.34 0 0 1 .196.135.358.358 0 0 1-.232.063.434.434 0 0 0 .016.095l-.069-.025c-.023-.009-.1-.036-.14-.063a.82.82 0 0 1-.095-.08z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M17.972 13.714c.029.037.088.112.152.172.063.058.189.12.236.144l.1.05-.004-.048c-.01-.077-.022-.13-.022-.13l-.01-.045.034.004a.49.49 0 0 0 .383-.13.604.604 0 0 0-.324-.294l-.035-.01.022-.039s.026-.046.055-.115l.016-.04c-.029 0-.07.002-.096.004a.987.987 0 0 0-.27.03 1.058 1.058 0 0 0-.187.094c.021.06.027.123.017.187a.336.336 0 0 1-.067.166zm.535.455l-.163-.081c-.053-.027-.177-.088-.246-.151a1.576 1.576 0 0 1-.175-.202l-.018-.025.02-.021a.264.264 0 0 0 .07-.152.31.31 0 0 0-.023-.174l-.013-.029.022-.014a1.09 1.09 0 0 1 .217-.112.97.97 0 0 1 .28-.033c.044-.004.133-.005.133-.005h.032l-.01.04a1.396 1.396 0 0 1-.073.178.69.69 0 0 1 .332.333l.013.025-.019.018a.554.554 0 0 1-.4.162c.004.024.01.057.014.097.007.071.007.1.007.102v.044z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.74 13.36a.117.117 0 0 1-.015-.08.116.116 0 0 1 .043-.069s-.043-.046-.095-.081c-.04-.027-.116-.053-.14-.062a17.395 17.395 0 0 0-.068-.025s0 .011.004.039a.459.459 0 0 0 .012.056.351.351 0 0 0-.232.064.338.338 0 0 0 .196.134s-.016.018-.032.048a.171.171 0 0 0-.018.036l.073-.002a.75.75 0 0 0 .153-.013c.062-.016.12-.045.12-.045z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M17.295 13.466c.08.144.2.252.325.291l.036.012-.024.038s-.026.043-.055.112l-.016.042.096-.004a.981.981 0 0 0 .27-.03c.08-.029.155-.073.19-.095a.419.419 0 0 1-.02-.185.359.359 0 0 1 .067-.167 1.37 1.37 0 0 0-.15-.172 1.148 1.148 0 0 0-.232-.14l-.105-.054c0 .013.002.028.004.046.01.079.022.133.022.133l.01.045-.034-.005a.484.484 0 0 0-.384.133zm.198.559l.01-.042c.002-.003.01-.032.035-.094a.89.89 0 0 1 .039-.084.682.682 0 0 1-.333-.33l-.013-.025.019-.017a.544.544 0 0 1 .4-.165 1.959 1.959 0 0 1-.014-.098.756.756 0 0 1-.007-.103l.002-.042.166.085c.057.028.176.086.242.147.094.087.171.199.175.204l.017.025-.02.02a.275.275 0 0 0-.07.152.333.333 0 0 0 .027.172l-.02.017.01.028c-.005.003-.108.072-.219.111a.973.973 0 0 1-.281.033l-.165.006z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.704 13.3c0-.074.063-.133.14-.133.078 0 .14.06.14.133a.136.136 0 0 1-.14.132.136.136 0 0 1-.14-.132z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M18.19 13.24a.416.416 0 0 0-.416.415c0 .227.187.412.417.412.23 0 .418-.185.418-.412a.416.416 0 0 0-.418-.414zm0 .914a.5.5 0 1 1 .001-1 .5.5 0 0 1 0 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M19.27 13.594c-.033-.035-.102-.028-.153.016-.05.043-.066.107-.033.142.033.034.102.027.153-.016.05-.044.066-.107.032-.142z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M19.698 13.67a.539.539 0 0 0-.354.156.55.55 0 0 0-.187.36.252.252 0 0 0 .057.183.25.25 0 0 0 .195.08.546.546 0 0 0 .356-.155.56.56 0 0 0 .187-.363.248.248 0 0 0-.058-.18.25.25 0 0 0-.196-.08zm-.289.89a.353.353 0 0 1-.27-.114.366.366 0 0 1-.084-.265.667.667 0 0 1 .223-.44.638.638 0 0 1 .42-.182.35.35 0 0 1 .27.116c.06.068.09.158.086.261a.671.671 0 0 1-.223.443.644.644 0 0 1-.422.18z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M19.07 13.679a.152.152 0 0 1 .047-.069c.051-.044.12-.05.152-.016a.06.06 0 0 1 .012.016s.071-.134.155-.18c.084-.044.226-.033.226-.033a.189.189 0 0 0-.194-.186.203.203 0 0 0-.16.071l-.014-.069s-.088.018-.128.118c-.04.1.003.245.003.245s-.02-.062-.054-.104a.545.545 0 0 0-.16-.107c-.044-.02-.09-.051-.09-.051l-.003.04a.465.465 0 0 0 .001.053.524.524 0 0 0-.247.03c.031.062.09.12.168.15 0 0-.027.023-.053.048l-.028.031.082.013c.028.003.119.018.173.014a.942.942 0 0 0 .113-.014z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M19.212 13.91c.027 0 .05.018.067.05v.003c.024-.076.082-.256.151-.329a.26.26 0 0 1 .192-.072l.027.001c-.007-.179-.084-.315-.18-.315-.061 0-.117.049-.15.131l-.017.042-.017-.162c-.024.016-.078.068-.107.21-.032.159-.007.384.001.449a.079.079 0 0 1 .033-.009zm-.485.192l.06.018.017.004c.036.01.109.03.153.023a.508.508 0 0 0 .104-.024.422.422 0 0 1 .048-.132.225.225 0 0 1 .046-.057 1.172 1.172 0 0 0-.05-.181.68.68 0 0 0-.156-.204.697.697 0 0 1-.073-.08l-.001.036c-.002.061 0 .1 0 .101l.003.032-.016-.004a.284.284 0 0 0-.228.05.49.49 0 0 0 .155.255l.02.015-.017.027s-.027.046-.052.095l-.013.026zm.21.096a.578.578 0 0 1-.137-.025l-.016-.004a4.706 4.706 0 0 1-.083-.025l-.02-.006.012-.032a.715.715 0 0 1 .068-.136.583.583 0 0 1-.156-.289l-.006-.025.012-.01a.31.31 0 0 1 .239-.065v-.078l.003-.081.003-.039.017.023s.044.06.087.098a.74.74 0 0 1 .165.218l.014.04a1.317 1.317 0 0 1 .016-.313c.042-.206.133-.244.137-.245l.012-.005.012.113c.038-.072.094-.114.152-.114.116 0 .207.172.207.392v.026l-.014-.002s-.016-.002-.039-.002a.253.253 0 0 0-.18.066c-.08.084-.149.34-.15.343l-.01.042-.012-.042a.128.128 0 0 0-.01-.025c-.028-.06-.09-.042-.135.032a.354.354 0 0 0-.042.124l-.003.014-.007.003a.526.526 0 0 1-.136.03z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M13.671 13.679a.146.146 0 0 0-.046-.069c-.051-.044-.119-.05-.153-.016a.066.066 0 0 0-.01.016s-.072-.134-.156-.18c-.084-.044-.226-.033-.226-.033 0-.103.084-.186.194-.186.063 0 .124.026.16.071l.015-.069s.087.018.127.118c.04.1-.003.245-.003.245s.021-.062.054-.104a.54.54 0 0 1 .161-.107c.043-.02.089-.051.089-.051s.002.011.003.04c.002.032 0 .053 0 .053a.526.526 0 0 1 .247.03.318.318 0 0 1-.17.15s.029.023.054.048c.022.022.029.031.029.031l-.083.013c-.027.003-.118.018-.173.014a.965.965 0 0 1-.113-.014z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M13.12 13.562c.057 0 .136.013.192.072.068.073.127.251.15.328l.001-.002c.023-.046.062-.061.1-.042.008-.065.034-.29.002-.45-.029-.14-.083-.192-.107-.209l-.017.161-.017-.04c-.034-.083-.09-.132-.15-.132-.097 0-.174.136-.18.315h.026zm.56.56a.54.54 0 0 0 .105.025c.046.008.117-.013.154-.023l.017-.004a3.14 3.14 0 0 0 .06-.018.875.875 0 0 0-.014-.027 1.106 1.106 0 0 0-.053-.094l-.017-.027.02-.015a.494.494 0 0 0 .157-.256.288.288 0 0 0-.228-.05l-.016.005.002-.032a1.163 1.163 0 0 0 0-.137.704.704 0 0 1-.073.08.682.682 0 0 0-.157.204c-.024.06-.042.146-.05.181a.224.224 0 0 1 .046.056.407.407 0 0 1 .048.133zm.125.076l-.022-.001a.54.54 0 0 1-.114-.028l-.008-.003-.002-.015a.342.342 0 0 0-.042-.123c-.045-.075-.108-.09-.136-.033a.144.144 0 0 0-.008.025l-.011.043-.012-.042c0-.002-.07-.259-.15-.343-.054-.058-.136-.066-.18-.066-.023 0-.038.002-.039.002l-.013.002v-.026c0-.22.09-.392.206-.392.058 0 .114.042.153.114l.012-.113.012.005c.004.001.095.039.137.245.02.1.02.217.015.313a.78.78 0 0 1 .014-.04.73.73 0 0 1 .166-.218.782.782 0 0 0 .086-.099l.016-.021.004.037a1.115 1.115 0 0 1 .004.16.314.314 0 0 1 .238.066l.013.01-.006.024a.589.589 0 0 1-.157.288 1.242 1.242 0 0 1 .069.137l.012.032-.02.006-.083.025-.017.004a.581.581 0 0 1-.137.025z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M13.472 13.594c.034-.035.102-.028.153.016.052.043.066.107.033.142-.033.034-.102.027-.153-.016-.05-.044-.066-.107-.033-.142z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M13.8 13.667a.255.255 0 0 0-.199.081.252.252 0 0 0-.056.18.566.566 0 0 0 .188.366.54.54 0 0 0 .354.155.252.252 0 0 0 .194-.08.258.258 0 0 0 .059-.186.549.549 0 0 0-.188-.36.538.538 0 0 0-.353-.156zm.287.894a.638.638 0 0 1-.42-.182.68.68 0 0 1-.224-.445.366.366 0 0 1 .084-.263c.152-.171.471-.139.691.067a.66.66 0 0 1 .224.44.37.37 0 0 1-.087.269.348.348 0 0 1-.268.114z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.229 13.174c0-.073.063-.133.14-.133.077 0 .14.06.14.133a.137.137 0 0 1-.14.133.137.137 0 0 1-.14-.133z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M16.717 13.116a.415.415 0 0 0-.418.412c0 .228.187.414.418.414.23 0 .417-.186.417-.414a.415.415 0 0 0-.417-.412zm0 .913z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.077 11.159a.28.28 0 0 1 .286-.272.28.28 0 0 1 .286.272c0 .15-.128.27-.286.27a.279.279 0 0 1-.286-.27z",
    fill: "#005BBF"
  }), React__default.createElement("path", {
    d: "M16.569 10.91zm0 .969a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.288 10.4v.145h-.156v.148h.156v.427h-.197c-.002.014-.014.024-.014.039 0 .037.008.073.023.106l.002.001h.524l.002-.001a.263.263 0 0 0 .023-.106c0-.015-.013-.025-.014-.039h-.192v-.427h.157v-.148h-.157v-.146h-.157z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M16.132 11.372h.873a.21.21 0 0 0 .035-.113c0-.006-.004-.012-.01-.019a.09.09 0 0 1-.01-.014h-.328v-.502h.265v-.15h-.265v-.164h-.237v.165h-.265v.149h.265v.502h-.337l-.01.014c-.006.007-.011.013-.011.02a.2.2 0 0 0 .035.112zm.895.019h-.908l-.005-.003a.01.01 0 0 1-.007-.006.219.219 0 0 1-.038-.123c0-.01.007-.02.014-.028a.043.043 0 0 0 .01-.016l.002-.008h.331v-.464h-.264v-.187h.264v-.165h.295v.165h.264v.187h-.264v.464h.322l.002.008c0 .005.005.01.01.016.006.008.014.017.014.028a.225.225 0 0 1-.04.124l-.002.003v.005z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.392 22.592a5.509 5.509 0 0 1-2.387-.551 1.527 1.527 0 0 1-.863-1.369v-2.15h6.486v2.15c0 .593-.344 1.112-.863 1.369a5.451 5.451 0 0 1-2.373.551z",
    fill: "#CCC"
  }), React__default.createElement("path", {
    d: "M13.16 18.538v2.134c0 .574.326 1.093.853 1.354a5.52 5.52 0 0 0 2.379.55c.813 0 1.63-.19 2.366-.55.526-.26.853-.78.853-1.354v-2.134H13.16zm3.232 4.071a5.55 5.55 0 0 1-2.394-.553 1.542 1.542 0 0 1-.872-1.384v-2.167h6.519v2.167c0 .587-.334 1.118-.872 1.384a5.448 5.448 0 0 1-2.381.553z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#CCC",
    d: "M16.378 14.92h3.25v3.598h-3.25z"
  }), React__default.createElement("path", {
    d: "M16.395 18.501h3.216v-3.565h-3.216v3.565zm3.25.034H16.36v-3.632h3.284v3.632z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.38 20.67c0 .85-.72 1.539-1.617 1.539s-1.624-.689-1.624-1.539v-2.154h3.242v2.154z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M13.846 21.94c.102.054.24.143.39.179l-.01-3.679h-.38v3.5z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M13.909 21.93l.138.032c.2.047.446.105.703.135l-.023-3.64h-.818v3.473zm.92.21l-.049-.005a5.92 5.92 0 0 1-.772-.144 14.9 14.9 0 0 0-.157-.037l-.022-.004v-3.527h.977l.023 3.717z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M13.133 20.641c.01.453.19.791.37 1.012v-3.195h-.366l-.004 2.183z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M13.208 18.474l-.011 2.167c.024.44.454.764.84.966v-3.133h-.83zm.868 3.195a.075.075 0 0 1-.031-.006c-.41-.202-.903-.544-.929-1.022l.011-2.183c0-.009.018-.016.04-.016h.91c.021 0 .04.007.04.016v3.195c0 .007-.011.013-.027.015a.094.094 0 0 1-.014.001z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.57 22.2c.148.014.259.012.379 0v-3.76h-.38v3.76z",
    fill: "#C7B500"
  }), React__default.createElement("path", {
    d: "M14.634 22.185c.301.011.54.011.837 0v-3.728h-.837v3.728zm.424.042c-.147 0-.3-.004-.468-.01l-.037-.002v-3.792h1v3.792l-.037.002c-.166.007-.312.01-.458.01z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M15.283 22.119c.148-.03.316-.122.39-.17V18.44h-.38l-.01 3.679z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M15.368 18.457l-.022 3.641c.32-.032.667-.111.84-.158v-3.483h-.818zm-.102 3.682v-.02l.023-3.696h.977v3.535l-.018.005c-.18.05-.578.142-.934.172l-.048.004z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#AD1519",
    d: "M13.139 14.92h3.24v3.598h-3.24z"
  }), React__default.createElement("path", {
    d: "M13.155 18.501h3.207v-3.565h-3.207v3.565zm3.241.034h-3.274v-3.632h3.274v3.632z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.025 21.618c.158-.141.307-.46.36-.825l.01-2.353h-.38l.01 3.177z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M16.032 18.557h.346v-.1h-.346v.1zm0-.024l.01 3.045a.722.722 0 0 0 .059-.07 1.483 1.483 0 0 0 .263-.838v-2.137h-.331zm-2.877 0v2.137c0 .839.721 1.522 1.608 1.522.488 0 .943-.209 1.245-.564v-.01l-.009-3.085h-2.844zm1.608 3.692c-.905 0-1.641-.698-1.641-1.555V18.5h2.877v-.077h.413l-.01 2.37a1.996 1.996 0 0 1-.16.543 1.177 1.177 0 0 1-.114.192 1.655 1.655 0 0 1-1.365.697z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M19.631 18.516v2.154c0 .85-.728 1.538-1.625 1.538-.898 0-1.625-.688-1.625-1.538v-2.154h3.25z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M16.398 18.533v2.137c0 .839.72 1.522 1.608 1.522.887 0 1.609-.683 1.609-1.522v-2.137h-3.217zm1.608 3.692c-.906 0-1.642-.698-1.642-1.555V18.5h3.284v2.17c0 .857-.737 1.555-1.642 1.555z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.938 21.177l-.113-.032v-.288l.113-.03v.35zm.11 0l.114-.032v-.288l-.114-.03v.35zm-.128.522c0-.04.034-.072.076-.072.041 0 .075.032.075.072 0 .04-.034.071-.075.071-.042 0-.076-.032-.076-.071zm.782-1.47l-.033.108h-.304l-.033-.107h.37zm-1.422 0l.033.108h.305l.032-.107h-.37zm1.353.582l.065-.093-.198-.22-.108.047.24.266zm-.084.068l-.108.046-.198-.22.066-.092.24.266zm.148.634a1.18 1.18 0 0 1-.326.172l.085.078c.095-.034.184-.08.266-.136l-.025-.114zm-.055-.094a1.062 1.062 0 0 1-.326.173l-.025-.11a.913.913 0 0 0 .27-.135l.08.072zm.373-.92l-.113.026-.004.143a7.107 7.107 0 0 0-.012.145l.114.037a.976.976 0 0 0 .015-.18v-.172zm.094.356l.113-.025.017-.288-.113-.037v.165a.961.961 0 0 1-.017.185zm-.14.303a.078.078 0 0 0-.106-.008.069.069 0 0 0-.008.1c.027.03.075.035.106.009a.069.069 0 0 0 .009-.101zm-.408.32l.053.093a1.09 1.09 0 0 0 .245-.208.18.18 0 0 0 .168-.032.16.16 0 0 0 .02-.235l-.01-.01a.989.989 0 0 0 .085-.323h-.11a.902.902 0 0 1-.07.276.206.206 0 0 0-.095.01l-.276-.305-.083.067.275.305a.158.158 0 0 0 .006.185c-.06.067-.13.127-.208.177zm-1.217-.667l-.065-.093.198-.22.108.047-.241.266zm.083.068l.108.046.198-.22-.065-.092-.24.266zm-.147.634c.097.073.207.131.325.172l-.084.078a1.241 1.241 0 0 1-.266-.136l.025-.114zm.054-.094c.096.074.207.134.326.173l.025-.11a.92.92 0 0 1-.27-.135l-.08.072zm-.372-.92l.113.026s.006.185.003.143a3.37 3.37 0 0 1 .012.145l-.113.037a.92.92 0 0 1-.016-.18l.001-.172zm-.094.356l-.114-.025-.016-.288.113-.037v.165c0 .064.006.124.017.185zm.14.303a.078.078 0 0 1 .106-.008.069.069 0 0 1 .008.1.078.078 0 0 1-.106.009.069.069 0 0 1-.009-.101zm.409.32l-.055.093a1.14 1.14 0 0 1-.245-.208.181.181 0 0 1-.167-.032.16.16 0 0 1-.02-.235l.01-.01a1.016 1.016 0 0 1-.086-.323h.11c.01.097.033.19.07.276a.204.204 0 0 1 .095.01l.277-.305.083.067-.274.305a.158.158 0 0 1-.008.185c.06.067.132.127.21.177zm.742.152c.087-.014.166-.038.246-.071l.054.092c-.091.04-.19.067-.29.083a.174.174 0 0 1-.173.132.174.174 0 0 1-.172-.13 1.171 1.171 0 0 1-.306-.085l.054-.092c.083.035.172.059.264.071a.17.17 0 0 1 .102-.09v-.452h.11l.001.45a.179.179 0 0 1 .11.092zm.45-1.488v.087h.297a.17.17 0 0 0 .109.105v.26h.11v-.26a.168.168 0 0 0 .124-.159.13.13 0 0 0-.004-.033h-.105a.073.073 0 0 1-.067.104c-.042 0-.076-.031-.076-.07 0-.012.003-.023.008-.033l-.397-.001zm-.179 0v.087l-.267.001a.148.148 0 0 1-.017.033l.31.352-.083.068-.31-.353-.013.006-.002.583h-.109v-.586a.04.04 0 0 1-.013-.006l-.322.356-.083-.068.321-.356a.137.137 0 0 1-.013-.03h-.276v-.087h.878-.001zm-1.459 0c.006.01.009.022.009.033 0 .04-.033.071-.076.071-.042 0-.075-.031-.075-.07 0-.012.002-.023.007-.033l-.105-.001a.169.169 0 0 0 .12.193v.259h.11l.001-.26a.171.171 0 0 0 .11-.105h.296v-.087h-.397z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M18.046 19.268l.113.032v.289l-.113.03v-.35zm-.109 0l-.113.032v.289l.113.03v-.35zm.397-.337l.034-.108h.304l.033.108h-.37zm0 .104l.034.108h.304l.033-.108h-.37zm-.422-.052c0-.039.035-.071.076-.071.042 0 .076.032.076.071 0 .04-.034.072-.076.072-.041 0-.076-.032-.076-.072zm1.086 0c0-.039.033-.071.075-.071.042 0 .075.032.075.071 0 .04-.033.072-.075.072a.074.074 0 0 1-.075-.072zm-.296 1.145l-.033-.107h-.304l-.033.107h.37zm-1.054-1.197l-.033-.108h-.304l-.033.108h.37zm0 .104l-.033.108h-.304l-.033-.108h.37zm-.814-.052c0-.039.034-.071.076-.071.041 0 .075.032.075.071 0 .04-.034.072-.075.072a.074.074 0 0 1-.076-.072zm.446 1.145l.033-.107h.305l.032.107h-.37zm1.368-.609l.066.094-.196.221-.108-.045.238-.27zm-.084-.067l-.108-.045-.196.222.066.092.238-.269zm-1.24.077l-.066.094.198.22.108-.047-.24-.267zm.083-.068l.108-.046.198.22-.065.093-.241-.267zm1.719-.057l.113.032v.288l-.113.032v-.352zm-.111 0l-.113.032v.288l.113.032v-.352zm-2.052 0l.113.032v.288l-.113.032v-.352zm-.11 0l-.115.032v.288l.114.032v-.352zm1.193-.263v.216h-.11v-.214a.171.171 0 0 1-.115-.108h-.267v-.104h.267a.175.175 0 0 1 .167-.115c.079 0 .146.048.168.115h.273v.104h-.274a.169.169 0 0 1-.109.106zm1.081.002l-.001.35h-.11v-.352a.185.185 0 0 1-.024-.009l-.405.457-.084-.067.413-.466c-.003-.006-.008-.013-.01-.021h-.3v-.104h.3a.175.175 0 0 1 .167-.115c.097 0 .177.075.177.167a.167.167 0 0 1-.123.16zm-2.149-.002l.408.456.083-.067-.41-.455a.172.172 0 0 0 .02-.04h.297v-.104h-.298a.176.176 0 0 0-.168-.115.172.172 0 0 0-.177.167c0 .073.05.136.12.158l-.001.352h.109v-.35l.017-.002zm2.027 1.004a.077.077 0 0 1 .068-.039c.029 0 .055.017.067.04l.105-.001a.173.173 0 0 0-.12-.128v-.355h-.109v.358a.167.167 0 0 0-.112.108h-.296v.017h.397zm-1.453 0v-.017h.275a.113.113 0 0 1 .012-.025l-.339-.378.083-.067.335.37a.097.097 0 0 1 .018-.007v-.494h.109v.49c.005.003.012.004.018.006l.326-.373.084.067-.328.37a.163.163 0 0 1 .019.041h.266v.017h-.878zm-.82 0a.174.174 0 0 1 .12-.128l-.001-.355h.11v.357a.17.17 0 0 1 .112.109h.295v.017h-.397a.077.077 0 0 0-.067-.039.077.077 0 0 0-.068.04l-.105-.001z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M16.91 18.92c-.037 0-.068.028-.068.063s.03.063.068.063c.037 0 .067-.028.067-.063 0-.034-.031-.063-.067-.063zm0 .143a.082.082 0 0 1-.084-.08c0-.044.037-.08.084-.08.045 0 .083.037.083.08 0 .044-.037.08-.083.08zm1.078-.143c-.036 0-.067.029-.067.063 0 .035.03.063.067.063.037 0 .067-.028.067-.063s-.03-.063-.067-.063zm0 .143a.082.082 0 0 1-.084-.08c0-.043.039-.08.084-.08.047 0 .084.036.084.08 0 .044-.037.08-.084.08zm1.085-.143c-.037 0-.067.028-.067.063s.03.063.067.063a.065.065 0 0 0 .067-.063.065.065 0 0 0-.067-.063zm0 .143a.082.082 0 0 1-.084-.08c0-.044.038-.08.084-.08.046 0 .083.036.083.08 0 .044-.037.08-.083.08zm-2.169 1.05c-.037 0-.067.028-.067.063s.03.062.067.062c.037 0 .067-.028.067-.062a.065.065 0 0 0-.067-.064zm0 .142a.082.082 0 0 1-.083-.08c0-.044.037-.08.083-.08.046 0 .084.036.084.08 0 .044-.038.08-.084.08zm2.169-.143c-.037 0-.068.029-.068.064s.03.062.068.062a.065.065 0 0 0 .066-.062.065.065 0 0 0-.066-.064zm0 .143a.081.081 0 0 1-.084-.08c0-.044.037-.08.084-.08.046 0 .083.036.083.08 0 .044-.037.08-.083.08zm-2.008.886a.069.069 0 0 0-.052.023.059.059 0 0 0-.015.045c0 .017.01.032.023.043a.072.072 0 0 0 .095-.007.06.06 0 0 0 .016-.045.062.062 0 0 0-.024-.044.069.069 0 0 0-.043-.015zm-.001.143a.085.085 0 0 1-.054-.019.079.079 0 0 1-.03-.055.076.076 0 0 1 .02-.058.086.086 0 0 1 .119-.009.078.078 0 0 1 .03.056.076.076 0 0 1-.02.057.086.086 0 0 1-.065.028zm1.848-.143a.068.068 0 0 0-.043.015.062.062 0 0 0-.024.044.059.059 0 0 0 .016.045.07.07 0 0 0 .095.007.062.062 0 0 0 .023-.043.06.06 0 0 0-.015-.045.07.07 0 0 0-.052-.023zm0 .143a.086.086 0 0 1-.063-.028.076.076 0 0 1-.02-.057.078.078 0 0 1 .029-.056.086.086 0 0 1 .118.01.076.076 0 0 1 .02.057.08.08 0 0 1-.03.055.085.085 0 0 1-.053.02zm-.916.351a.065.065 0 0 0-.067.064c0 .035.03.063.067.063.037 0 .067-.028.067-.063a.066.066 0 0 0-.067-.064zm0 .144a.082.082 0 0 1-.084-.08c0-.045.037-.08.084-.08.046 0 .084.036.084.08 0 .044-.038.08-.084.08zm-.45-2.847h.09l-.027-.1h-.292l-.028.1h.257zm1.053 0h.095l-.028-.1h-.292l-.028.1h.253zm-1.215.108h.162v-.1h-.162v.1zm1.053 0h.162v-.1h-.162v.1zm-1.12.103h.292l.028-.1h-.348l.028.1zm1.057 0h.292l.028-.1h-.348l.028.1zm-.429.205h.092v-.213l.007-.002a.16.16 0 0 0 .103-.1l.002-.006h.271v-.087h-.27l-.002-.006a.166.166 0 0 0-.16-.11.166.166 0 0 0-.159.11l-.002.006h-.264v.087h.264l.002.005c.017.05.058.087.11.103l.006.001v.212zm0 .169h.1v-.152h-.1v.152zm.57.002l.071.057.063-.071.341-.384.006.003a.151.151 0 0 0 .023.009l.006.002v.349h.092v-.093l.002-.255.006-.002a.159.159 0 0 0 .116-.151.164.164 0 0 0-.168-.159.168.168 0 0 0-.16.11l-.002.006h-.296v.087h.298l.002.006c0 .004.003.01.006.014l.005.01-.411.462zm-1.534-.388l.003.004.402.45.07-.057-.407-.453.003-.005a.17.17 0 0 0 .018-.038l.002-.005h.296v-.087h-.296l-.002-.006a.168.168 0 0 0-.16-.11.164.164 0 0 0-.168.159c0 .068.045.128.113.15l.006.002v.349h.091v-.348l.006-.001a.061.061 0 0 1 .01-.002h.008l.005-.002zm.85.45l.1.026v-.329l-.1.028v.275zm.224-.303v.33l.1-.027v-.275l-.1-.028zm-1.194.375h.1V19.5h-.1v.152zm2.162 0h.1V19.5h-.1v.152zm-.622-.005l.071.056.103-.116-.071-.056-.103.116zm-.13-.02l.056.078.223-.252-.092-.038-.187.212zm-.874-.031l.104.115.07-.057-.103-.115-.07.057zm.024-.134l.226.25.055-.08-.19-.21-.09.04zm-.674.254l.098.026v-.09h.002v-.24l-.1.028v.276zm.224-.303v.329l.1-.026v-.276l-.1-.027zm1.94.303l.1.026v-.33l-.1.028v.276zm.223-.056v.082l.1-.026v-.276l-.1-.027v.247zm-.71.123l.092.038.187-.212-.055-.078-.06.067-.164.185zm-1.155-.163l.19.21.09-.04-.061-.068-.164-.182-.055.08zm.784.388l.007.002.256-.291-.067-.093.204-.23.11.044.343-.387a.112.112 0 0 1-.006-.01h-.189l-.033.107h-.316l-.034-.108h-.167a.177.177 0 0 1-.106.104v.114l.113.032v.3l-.115.032v.384zm-.395-.282l.262.29a.097.097 0 0 1 .007-.004v-.389l-.112-.03v-.301l.006-.002.107-.03v-.112a.18.18 0 0 1-.113-.106h-.161l-.033.108h-.316l-.033-.108h-.188a.198.198 0 0 1-.014.03l.339.376.108-.045.004.004.202.224-.065.095zm-.114.4h.095l-.027-.1h-.292l-.028.1h.252zm.113-.01h.164l.008-.016-.268-.297-.107.046-.004-.004-.202-.224.065-.095-.338-.378h-.005v.247l.114.032v.301l-.115.032v.25a.18.18 0 0 1 .11.106h.195l.033-.107h.318l.032.107zm.513 0h.156l.032-.107h.317l.034.107h.189a.177.177 0 0 1 .11-.106v-.25l-.114-.032v-.3l.114-.033v-.25a.153.153 0 0 1-.014-.004l-.335.377.066.093-.005.005-.2.225-.108-.045-.256.289.014.031zm.43.01h.091l-.028-.1h-.292l-.028.1h.257zm-1.223.107h.167v-.1h-.167v.1zm1.061 0h.162v-.1h-.162v.1zm-1.118.104h.292l.027-.1h-.347l.028.1zm1.051 0h.292l.028-.1h-.348l.028.1zm.246-.117h.295l.002.005a.162.162 0 0 0 .104.1l.005.002v.258h.095v-.257l.005-.002a.16.16 0 0 0 .118-.151.162.162 0 0 0-.119-.153l-.006-.001.001-.353h-.092l-.001.354-.006.002a.16.16 0 0 0-.106.103l-.002.005-.293.001v.087zm-1.758.365h.094v-.258l.006-.002a.164.164 0 0 0 .104-.1l.002-.005h.295v-.087h-.293l-.002-.006a.163.163 0 0 0-.107-.103l-.006-.002v-.354h-.091v.096h-.002l.001.257-.006.001a.163.163 0 0 0-.118.153c0 .069.047.13.117.151l.006.002v.257zm.004.168h.096a1.158 1.158 0 0 1-.003-.084v-.067h-.097v.067c0 .029.001.056.004.084zm2.16-.151v.067c0 .03 0 .058-.002.085h.096a.974.974 0 0 0 .003-.085v-.068l-.096.001zm-1.733.116l.054.08.226-.25-.091-.04-.19.21zm1.117-.171l.034.038.19.212.056-.08-.189-.21-.09.04zm-.022.136l.104.116.07-.057-.104-.116-.07.057zm-.968.059l.071.057.104-.115-.07-.057-.105.115zm1.478.064l.098.032.004-.018a1.12 1.12 0 0 0 .01-.15v-.162l-.097.023-.004.125v.02l-.011.13zm-1.925-.298v.161a1.02 1.02 0 0 0 .013.17l.099-.033-.01-.129a.035.035 0 0 1-.002-.009v-.012l-.003-.125-.097-.023zm2.16.246v.008a.999.999 0 0 1-.01.081l.094-.02.016-.276-.095-.031v.085l-.001.068c0 .03-.001.057-.003.084v.001zm-2.368.068l.094.021a.959.959 0 0 1-.01-.08l-.001-.01a.986.986 0 0 1-.003-.084v-.153l-.095.031.015.275zm1.185.088h.093v-.582l.007-.001.007-.003a.05.05 0 0 1 .007-.003l.006-.002.003.005.304.347.07-.057-.066-.073h.001l-.243-.278.002-.005.006-.01a.081.081 0 0 0 .01-.021l.002-.006h.007l.259-.001v-.087h-.264l-.002-.006a.14.14 0 0 0-.018-.038l-.003-.006.326-.367-.07-.056-.326.37-.005-.002a.157.157 0 0 0-.016-.005l-.007-.001v-.489h-.092v.49l-.006.003a.484.484 0 0 0-.018.007l-.005.003-.004-.005-.33-.365-.07.057.066.073.271.302-.004.008c-.004.007-.008.014-.01.022l-.002.005h-.272v.087h.274l.001.005.013.028.004.006-.005.004-.25.278-.065.073.07.057.32-.356.007.004a.044.044 0 0 0 .01.005l.007.002v.584zm-.505-.035l.091.04.19-.21-.055-.08-.226.25zm.812-.17l.19.21.091-.04-.226-.25-.055.08zm-1.193.323a.24.24 0 0 1 .066.01l.206-.228-.065-.094.005-.005.201-.224.108.047.25-.277a.14.14 0 0 1-.01-.02h-.165l-.032.108h-.318l-.033-.108h-.197a.18.18 0 0 1-.107.102v.152l.113.026v.007l.004.145.012.143v.006l-.113.037a.9.9 0 0 0 .054.174h.02zm1.582-.218l.207.229a.217.217 0 0 1 .086-.01.903.903 0 0 0 .054-.174l-.113-.037v-.006l.012-.141.005-.147v-.007l.113-.026v-.152a.178.178 0 0 1-.107-.102h-.191l-.034.108h-.317l-.032-.108h-.158c-.002.008-.006.014-.01.02a.076.076 0 0 0-.002.004l.24.273.106-.047.207.23-.066.093zm-.696.269h.1v-.152h-.1v.152zm.11-.152v.238l.1-.027v-.275l-.1-.026v.09zm-.224.211l.1.027v-.328l-.1.026v.275zm-.556.362l.008.006c.024.018.05.035.075.051l.045-.077a1.01 1.01 0 0 1-.204-.175l-.005-.005.005-.005a.149.149 0 0 0 .007-.175l-.004-.005.273-.304-.07-.057-.275.304-.006-.002a.193.193 0 0 0-.09-.01l-.006.001-.003-.006a.897.897 0 0 1-.056-.18l-.002-.01a.722.722 0 0 1-.012-.08h-.093l.012.082.002.012c.014.072.038.145.069.216l.002.005-.013.015a.15.15 0 0 0 .02.223.175.175 0 0 0 .159.03l.005-.001.004.004c.047.052.098.1.153.143zm1.295-.02l.045.077.075-.051.01-.008a1.12 1.12 0 0 0 .151-.141l.004-.004.005.001a.174.174 0 0 0 .16-.03.152.152 0 0 0 .02-.223l-.015-.015.002-.005a.989.989 0 0 0 .07-.216l.001-.012a.994.994 0 0 0 .012-.083h-.092a1.013 1.013 0 0 1-.012.081l-.001.01a.922.922 0 0 1-.058.18l-.002.006h-.006a.195.195 0 0 0-.09.01l-.006.001-.004-.004-.27-.3-.07.057.062.07.21.234-.003.005a.15.15 0 0 0 .006.175l.004.005-.005.005c-.06.067-.128.126-.203.175zm-.961.085l.043.015.021-.093a.93.93 0 0 1-.259-.13l-.068.06c.081.062.17.112.263.148zm.69-.078l.021.093a1.06 1.06 0 0 0 .307-.162l-.069-.061a.917.917 0 0 1-.259.13zm-.244.045a.186.186 0 0 1 .107.088c.047-.008.095-.02.142-.034l-.025-.11.008-.003a.87.87 0 0 0 .267-.134l.005-.004.082.073a.988.988 0 0 0 .115-.109.165.165 0 0 1-.006-.183l-.205-.227-.108.046-.004-.005-.202-.224.066-.095-.238-.272-.004.002v.478l.113.031v.301l-.113.032v.349zm-.387.053c.05.015.105.027.161.035a.18.18 0 0 1 .098-.087v-.35l-.113-.032v-.3l.114-.032v-.48l-.003-.002-.248.275.065.094-.005.005-.201.224-.108-.046-.205.227a.165.165 0 0 1-.007.183.988.988 0 0 0 .116.109l.081-.073.006.004a.905.905 0 0 0 .267.134l.007.002-.025.11zm.747-.023l.045.077a.885.885 0 0 0 .14-.073l-.045-.078a1.083 1.083 0 0 1-.14.074zm-1.043.004c.045.027.092.052.14.074l.046-.078a1.097 1.097 0 0 1-.14-.074l-.046.078zm-.11.057c.081.053.167.097.255.13l.07-.066a1.134 1.134 0 0 1-.074-.029l-.01-.004h.001a1.205 1.205 0 0 1-.14-.073l-.008-.004a1.05 1.05 0 0 1-.073-.05l-.02.096zm1.123.065l.07.065c.087-.032.173-.076.256-.13l-.021-.095a1.085 1.085 0 0 1-.073.05l-.008.004v-.001a1.18 1.18 0 0 1-.14.073l-.009.004-.075.03zm-.781-.013c.069.023.142.04.219.051h.005l.002.006a.165.165 0 0 0 .164.124c.08 0 .147-.051.164-.125l.001-.005.006-.001c.066-.01.13-.026.192-.046l.01-.003a1.18 1.18 0 0 0 .078-.03l-.046-.077a1.04 1.04 0 0 1-.24.068l-.007.001-.003-.005a.17.17 0 0 0-.104-.087l-.006-.002-.001-.448h-.093v.45l-.007.001a.162.162 0 0 0-.097.086l-.002.006-.006-.001a1.117 1.117 0 0 1-.169-.037l-.008-.002a.614.614 0 0 1-.082-.03l-.046.077.076.03zm.39.198a.182.182 0 0 1-.18-.131 1.224 1.224 0 0 1-.209-.049l-.084.08-.005-.002a1.24 1.24 0 0 1-.267-.138l-.005-.003.024-.114a1.168 1.168 0 0 1-.155-.144.192.192 0 0 1-.17-.035.17.17 0 0 1-.065-.121.167.167 0 0 1 .044-.127l.006-.006a1.07 1.07 0 0 1-.07-.222l-.114-.025-.017-.3.113-.038v-.158a.176.176 0 0 1-.123-.165.18.18 0 0 1 .124-.167v-.249l-.113-.03v-.302l.006-.001.107-.03v-.25a.175.175 0 0 1-.118-.164.18.18 0 0 1 .185-.175c.078 0 .147.046.174.115h.188l.033-.108h.316l.033.108h.161a.183.183 0 0 1 .173-.115c.079 0 .148.046.174.115h.166l.034-.108h.316l.033.108h.188a.185.185 0 0 1 .174-.115.18.18 0 0 1 .185.175c0 .075-.05.14-.123.165v.248l.113.032v.301l-.114.031v.25a.179.179 0 0 1 .123.166c0 .075-.049.14-.123.165v.158l.113.037-.016.3-.114.026a1.037 1.037 0 0 1-.07.222l.006.006a.169.169 0 0 1-.021.248.19.19 0 0 1-.17.035c-.047.053-.1.102-.156.145l.025.113-.004.004a1.274 1.274 0 0 1-.268.137l-.005.001-.085-.078a1.22 1.22 0 0 1-.194.046.182.182 0 0 1-.179.133z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M17.819 20.177c0-.093.08-.168.177-.168.098 0 .176.075.176.168a.172.172 0 0 1-.176.167.172.172 0 0 1-.177-.167z",
    fill: "#058E6E"
  }), React__default.createElement("path", {
    d: "M18.035 15.806l.003-.04.006-.022s-.104.008-.16-.007a.398.398 0 0 1-.154-.08c-.051-.045-.071-.072-.108-.077-.088-.014-.155.026-.155.026s.066.024.115.085c.049.06.102.09.126.098.038.012.172.003.208.005.037.002.119.012.119.012z",
    fill: "#DB4446"
  }), React__default.createElement("path", {
    d: "M18.186 16.413h.02c.046.006.132.03.172.042l.007-.134a.622.622 0 0 1-.073.005.287.287 0 0 1-.162-.04.8.8 0 0 1-.256-.325 4.104 4.104 0 0 1-.052-.113c-.046-.103-.072-.16-.111-.173a.155.155 0 0 0-.058-.012.212.212 0 0 0-.14.064c.04.05.101.146.152.3.077.233.16.344.193.37.02.015.063.022.13.022.037 0 .075-.002.109-.004l.069-.002zm.229.152l-.021-.007c-.002 0-.132-.04-.19-.046-.016-.002-.049 0-.086.002a1.916 1.916 0 0 1-.11.004c-.073 0-.118-.008-.142-.027-.04-.031-.13-.151-.212-.402-.075-.225-.175-.314-.176-.315l-.04-.036.036-.053c.004-.005.084-.12.199-.12.021 0 .043.004.064.012.05.017.083.09.132.199l.051.11a.749.749 0 0 0 .241.306.273.273 0 0 0 .15.035.555.555 0 0 0 .098-.008l.029-.006-.017.152-.006.2z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.521 15.66s0 .047.005.09c.004.044-.014.08-.007.105.007.024.01.042.02.06a.23.23 0 0 1 .013.06l-.048-.035-.039-.028.007.067c.002.02.014.057.033.08.019.021.056.057.068.086.011.029.009.093.009.093s-.03-.049-.056-.058c-.026-.009-.082-.04-.082-.04s.051.051.051.1c0 .049-.02.103-.02.103s-.024-.043-.054-.072a.638.638 0 0 0-.073-.058s.033.076.033.126c0 .051-.01.16-.01.16s-.024-.042-.05-.063c-.026-.02-.056-.037-.066-.05-.01-.013.03.042.035.075.004.033.02.152.124.303.06.088.154.244.355.192.2-.05.127-.32.084-.446a1.14 1.14 0 0 1-.06-.315c.002-.048.037-.192.032-.219a.546.546 0 0 1 .01-.212c.025-.086.046-.12.06-.155.014-.035.026-.055.03-.086.005-.031.005-.089.005-.089s.037.069.047.093c.009.025.009.097.009.097s.007-.072.063-.108c.056-.035.122-.073.138-.093.016-.02.021-.033.021-.033s-.005.124-.04.173c-.023.031-.114.135-.114.135s.047-.018.08-.02a.334.334 0 0 1 .055 0s-.04.031-.09.106c-.052.075-.031.082-.069.143-.037.063-.067.065-.114.103-.07.056-.033.28-.024.313.01.034.132.308.134.374.002.067.014.215-.103.31-.075.062-.198.063-.227.08-.028.018-.083.073-.083.188 0 .116.04.133.074.162.033.028.075.013.084.036.01.021.014.034.028.048.014.013.024.028.02.053-.006.024-.06.08-.078.12a.978.978 0 0 0-.057.159c0 .015-.004.064.012.089 0 0 .059.068.019.08-.026.01-.05-.016-.063-.012-.035.009-.054.03-.063.029-.023-.004-.023-.016-.026-.05-.002-.032 0-.046-.01-.046-.015 0-.022.012-.025.03-.002.017-.002.057-.019.057-.016 0-.039-.03-.053-.035-.014-.007-.054-.013-.056-.032-.002-.017.023-.055.049-.062.025-.006.049-.02.033-.033-.017-.013-.033-.013-.05 0-.016.014-.05.003-.049-.017.003-.02.008-.044.005-.056-.002-.01-.03-.033.006-.052.039-.02.055.017.092.01.038-.006.056-.02.07-.041.014-.022.011-.07-.014-.098-.026-.029-.051-.033-.06-.051-.01-.018-.024-.06-.024-.06s.007.078.002.09c-.004.01-.002.057-.002.057s-.025-.03-.047-.052c-.02-.021-.042-.088-.042-.088l-.002.087c0 .023.028.046.02.055-.01.009-.054-.046-.067-.055-.011-.01-.049-.038-.065-.069-.016-.03-.028-.075-.033-.091a.284.284 0 0 1-.005-.102 2.15 2.15 0 0 0 .03-.073h-.09c-.05 0-.084-.015-.103.018-.019.033-.01.1.014.186s.037.128.03.143a.205.205 0 0 1-.048.058c-.013.007-.045.005-.06-.002-.013-.006-.036-.017-.08-.017-.045 0-.073.002-.089-.002-.017-.005-.057-.025-.076-.02-.018.004-.05.02-.042.046.015.04-.013.048-.033.047-.018-.003-.034-.01-.058-.016-.023-.007-.058 0-.053-.027.004-.026.014-.028.026-.048.011-.02.016-.033.002-.035-.016 0-.033-.003-.045.007-.013.01-.033.033-.05.025-.016-.01-.029-.028-.029-.07 0-.041-.044-.077-.003-.075.04.001.091.03.1.008.01-.023.004-.033-.018-.05-.022-.018-.05-.028-.02-.05.03-.023.036-.023.048-.035.01-.012.026-.051.047-.041.04.019.001.047.042.092.04.044.065.06.133.053.067-.007.086-.016.086-.035 0-.018-.006-.053-.008-.067-.001-.014.01-.064.01-.064s-.031.02-.041.038a.845.845 0 0 1-.027.052s-.007-.039-.005-.07c.001-.02.007-.052.007-.058a.501.501 0 0 0-.015-.06s-.01.046-.018.06c-.007.013-.01.07-.01.07s-.044-.038-.031-.101c.008-.048-.008-.112.007-.133.014-.021.048-.106.133-.11.084-.002.149.004.178.003.03-.002.134-.022.134-.022s-.192-.098-.235-.128a.638.638 0 0 1-.134-.139c-.022-.035-.042-.102-.042-.102s-.034.001-.066.019a.327.327 0 0 0-.08.063c-.018.021-.047.068-.047.068s.005-.06.005-.079c0-.019-.004-.056-.004-.056s-.021.083-.065.114c-.044.032-.095.074-.095.074s.005-.045.005-.057a.78.78 0 0 1 .011-.064s-.031.047-.078.056c-.048.008-.117.007-.123.036-.005.03.013.07.002.09-.01.02-.035.035-.035.035s-.027-.023-.051-.024c-.023-.002-.046.01-.046.01s-.02-.026-.012-.044c.007-.016.043-.042.035-.053-.01-.01-.039.004-.057.012-.018.01-.057.017-.053-.012.003-.03.013-.047.003-.067-.009-.02-.003-.034.012-.04.014-.005.072.001.078-.012.005-.014-.014-.031-.053-.04-.038-.008-.057-.031-.037-.05.02-.02.026-.024.035-.041.01-.018.013-.05.048-.033.034.015.027.054.064.065a.272.272 0 0 0 .14-.015c.018-.01.077-.054.097-.064.02-.01.104-.072.104-.072s-.05-.035-.068-.052c-.018-.018-.05-.059-.067-.068a.582.582 0 0 0-.124-.041c-.027-.002-.11-.031-.11-.031s.037-.013.05-.023c.012-.01.041-.036.056-.034a.263.263 0 0 0 .018 0s-.078-.002-.095-.007c-.016-.006-.064-.035-.082-.035-.018 0-.054.007-.054.007s.049-.031.089-.038c.04-.007.071-.006.071-.006s-.062-.017-.077-.037c-.014-.021-.029-.051-.04-.066-.01-.013-.018-.036-.038-.038-.02-.002-.055.025-.075.023-.02-.002-.035-.014-.036-.044-.002-.03 0-.019-.007-.034-.008-.016-.037-.052-.01-.06.028-.01.086.005.092-.006.005-.01-.031-.042-.055-.053-.024-.012-.062-.033-.042-.05.02-.017.04-.025.051-.04.011-.016.024-.059.048-.045.023.013.056.081.075.076.018-.005.02-.053.016-.074-.004-.02 0-.057.018-.054.018.003.033.028.062.03.029.001.073-.007.07.013a.151.151 0 0 1-.041.069.102.102 0 0 0-.016.097c.013.03.046.077.075.095.029.019.084.033.119.055.034.023.115.087.142.094.027.007.055.02.055.02s.03-.013.073-.013c.042 0 .138.007.175-.009.036-.016.084-.041.07-.074-.015-.033-.095-.062-.088-.088.007-.026.036-.028.086-.03.049-.001.116.01.129-.06.013-.069.017-.109-.053-.124-.07-.016-.12-.018-.133-.068-.013-.05-.025-.062-.011-.076.015-.014.04-.02.09-.024.052-.004.11-.004.127-.016s.02-.044.04-.059c.02-.013.099-.025.099-.025s.094.045.18.11a.997.997 0 0 1 .15.144z",
    fill: "#ED72AA"
  }), React__default.createElement("path", {
    d: "M18.552 17.95c.02 0 .022.02.023.046v.016c.003.032.004.032.016.034l.01-.006a.163.163 0 0 1 .048-.022c.01-.003.018.002.028.006.011.005.023.01.034.007l.005-.004c.003-.011-.015-.04-.03-.057-.016-.026-.015-.067-.014-.089v-.008c0-.02.04-.13.057-.165a.444.444 0 0 1 .044-.066.226.226 0 0 0 .033-.051c.003-.019-.004-.03-.015-.041-.015-.014-.02-.027-.028-.044l-.004-.008c-.001-.005-.01-.007-.022-.009a.11.11 0 0 1-.058-.023.412.412 0 0 0-.012-.01c-.032-.025-.067-.054-.067-.161 0-.13.068-.185.09-.199.011-.007.031-.01.059-.016a.393.393 0 0 0 .166-.062c.106-.087.101-.218.099-.29v-.01a1.734 1.734 0 0 0-.104-.295l-.03-.076c-.008-.033-.049-.266.028-.327a.448.448 0 0 1 .04-.028.185.185 0 0 0 .072-.071c.016-.026.02-.042.025-.058.007-.021.013-.043.043-.086a.626.626 0 0 1 .07-.087h-.024c-.03.002-.075.02-.076.02l-.014-.02c.001-.002.091-.104.114-.135a.298.298 0 0 0 .034-.118.704.704 0 0 1-.097.066 3.174 3.174 0 0 0-.039.024c-.05.032-.057.098-.058.098l-.025-.001a.422.422 0 0 0-.008-.092.635.635 0 0 0-.024-.05.258.258 0 0 1-.023.105.778.778 0 0 0-.025.058.533.533 0 0 0-.056.329.544.544 0 0 1-.016.12c-.007.04-.015.08-.016.102-.002.046.018.183.06.31.058.171.065.298.022.377a.172.172 0 0 1-.115.086c-.2.05-.3-.097-.36-.185l-.008-.013a.73.73 0 0 1-.127-.307.21.21 0 0 0-.031-.069l-.001-.001-.006-.007.004-.01.005-.007.009.002c.002 0 .004.003.007.006.006.007.02.017.035.027l.03.021a.22.22 0 0 1 .033.036 1.99 1.99 0 0 0 .007-.123.36.36 0 0 0-.033-.12l-.017-.041.036.025c.002 0 .044.03.075.059a.294.294 0 0 1 .041.051.287.287 0 0 0 .012-.073c0-.043-.047-.09-.048-.091l.015-.02s.056.03.08.039a.103.103 0 0 1 .039.03.178.178 0 0 0-.008-.049.275.275 0 0 0-.052-.067.556.556 0 0 1-.014-.015.192.192 0 0 1-.036-.087l-.006-.067-.003-.026.022.014.04.03.023.016a.114.114 0 0 0-.008-.026.197.197 0 0 1-.015-.043l-.005-.02c-.004-.015-.001-.031.002-.05a.21.21 0 0 0 .005-.056.893.893 0 0 1-.005-.086.977.977 0 0 0-.144-.14 1.263 1.263 0 0 0-.175-.107.363.363 0 0 0-.09.024c-.008.005-.013.016-.018.027-.005.012-.01.024-.021.031-.015.011-.048.014-.099.016l-.034.003c-.046.002-.07.009-.084.02-.003.003-.004.004.004.026.003.01.007.022.01.038.01.033.038.04.095.052l.03.006c.085.019.074.077.062.139-.013.07-.076.07-.122.07h-.019c-.05.003-.07.005-.074.021 0 .007.023.022.035.031.022.015.044.03.052.048.021.05-.052.081-.076.092a.467.467 0 0 1-.15.01h-.03a.195.195 0 0 0-.068.012l-.006.002-.005-.002s-.027-.013-.052-.02a.512.512 0 0 1-.108-.068 1.31 1.31 0 0 0-.038-.027c-.017-.011-.04-.02-.062-.029a.303.303 0 0 1-.057-.026.267.267 0 0 1-.08-.101.118.118 0 0 1 .018-.11.148.148 0 0 0 .037-.061c-.006-.002-.022-.001-.032-.001h-.024a.086.086 0 0 1-.047-.02.056.056 0 0 0-.017-.01c-.003.003-.007.023-.004.04.003.015.007.079-.025.088-.019.005-.035-.016-.054-.043a.16.16 0 0 0-.03-.034l-.004-.001c-.006.002-.014.017-.018.026a.154.154 0 0 1-.01.016.106.106 0 0 1-.03.026l-.023.016c0 .004.006.012.04.03.02.01.055.036.06.055a.02.02 0 0 1 0 .015c-.007.013-.024.012-.05.01a.162.162 0 0 0-.049.001c-.004.006.007.025.01.032l.007.011a.082.082 0 0 0 .004.007c.003.007.003.01.004.023v.01c.002.026.015.03.026.031.007.001.02-.005.03-.01.016-.007.03-.014.044-.012.021.002.031.018.04.031l.007.011a.33.33 0 0 1 .022.036l.019.031c.008.011.046.025.07.032l-.004.025s-.03-.001-.069.005a.141.141 0 0 0-.026.008c.013.003.03.011.05.022l.025.012a.523.523 0 0 0 .088.007h.004v.025h-.023a.132.132 0 0 0-.041.028l-.003.003a.107.107 0 0 1-.022.012.43.43 0 0 0 .075.019c.03.002.112.034.129.043.013.007.03.027.048.046l.022.024c.018.016.066.05.066.05l.015.01-.014.01a1.42 1.42 0 0 1-.107.074c-.01.005-.033.022-.054.036a.908.908 0 0 1-.042.028.28.28 0 0 1-.15.016c-.024-.008-.033-.025-.04-.039-.007-.011-.013-.021-.025-.027-.007-.003-.012-.004-.015-.003-.005.002-.008.011-.012.02a.114.114 0 0 1-.005.01c-.01.02-.016.025-.037.045-.005.005-.004.008-.004.009.001.005.012.015.035.02.03.007.052.02.06.034a.026.026 0 0 1 .002.022c-.007.017-.032.017-.06.018-.01 0-.022 0-.026.002a.013.013 0 0 0-.007.006c-.001.003 0 .01.003.016.008.018.005.034.002.051a.217.217 0 0 0-.004.028c.004.004.021.001.035-.005l.004-.002c.023-.01.052-.024.067-.008.012.016-.003.033-.017.048a.103.103 0 0 0-.015.02c-.003.005 0 .014.005.022a.1.1 0 0 1 .042-.007c.02.001.04.014.05.021a.085.085 0 0 0 .024-.025c.004-.007.002-.023 0-.038a.146.146 0 0 1-.003-.048c.006-.031.05-.036.096-.042a.638.638 0 0 0 .037-.004c.04-.008.07-.05.07-.05l.022.009a.732.732 0 0 0-.012.089c.019-.015.046-.037.071-.055.04-.028.06-.106.06-.107l.026.002a.725.725 0 0 1 .002.088.344.344 0 0 1 .105-.095.177.177 0 0 1 .072-.02h.01l.002.01s.02.065.04.098a.629.629 0 0 0 .13.136c.043.029.232.126.234.127l.033.017-.036.007c-.004 0-.105.02-.135.021h-.05c-.032-.002-.077-.004-.129-.002-.065.003-.098.06-.115.09a.174.174 0 0 1-.008.014c-.006.008-.005.033-.003.056 0 .023.002.049-.002.072a.098.098 0 0 0 .009.064.142.142 0 0 1 .009-.041.359.359 0 0 0 .017-.058l.01-.047.014.046c0 .002.013.045.015.063 0 .005 0 .013-.003.029l-.004.031v.029a.338.338 0 0 0 .009-.016c.01-.022.042-.042.045-.044l.025-.016-.006.03a.385.385 0 0 0-.01.06l.002.01a.455.455 0 0 1 .006.058c0 .034-.04.041-.097.048-.072.007-.101-.011-.143-.058-.024-.026-.024-.048-.025-.064 0-.014 0-.019-.014-.025-.005-.003-.016.015-.02.023a.122.122 0 0 1-.012.016c-.007.007-.013.01-.021.016l-.029.02c-.007.005-.007.008-.007.008 0 .002.01.009.016.013l.012.009c.023.018.034.034.022.065-.01.024-.04.016-.068.008a.214.214 0 0 0-.045-.009h-.003a.125.125 0 0 0 .005.012.123.123 0 0 1 .015.051c0 .041.013.053.023.059.005.002.02-.01.027-.017l.008-.007c.016-.012.035-.01.052-.01.013.002.018.008.02.011.005.011 0 .024-.01.043a.123.123 0 0 1-.012.017.047.047 0 0 0-.013.027v.004a.072.072 0 0 0 .02.005.586.586 0 0 1 .048.011c.012.003.022.007.033.008.006 0 .016 0 .02-.006.004-.004.004-.013 0-.024a.037.037 0 0 1 .002-.03c.01-.018.032-.029.048-.033s.038.004.065.014l.018.006c.009.003.027.002.051.002h.033c.047 0 .073.012.087.018.012.006.04.007.047.003a.2.2 0 0 0 .044-.052c.004-.009-.008-.05-.022-.102l-.01-.033c-.027-.101-.03-.162-.012-.195.018-.032.048-.03.08-.027l.034.002h.11l-.008.017s-.018.048-.03.074a.286.286 0 0 0 .005.093l.001.004a.576.576 0 0 0 .031.085.23.23 0 0 0 .06.063.201.201 0 0 1 .022.021.55.55 0 0 0 .012.012.056.056 0 0 1-.005-.022l.002-.086.024-.004a.306.306 0 0 0 .04.084l.024.026a.58.58 0 0 0 0-.112l.025-.005s.014.042.022.058c.004.006.01.01.02.017a.19.19 0 0 1 .04.032c.03.033.031.086.014.112-.017.027-.04.041-.078.048a.077.077 0 0 1-.048-.01c-.015-.006-.024-.01-.04-.002a.032.032 0 0 0-.012.01c0 .004.003.01.006.015l.007.014a.17.17 0 0 1-.004.05l-.001.01c0 .002.005.005.006.006.007.004.018.004.022 0 .021-.017.044-.017.065 0 .011.009.011.018.01.023-.004.017-.028.027-.047.032-.02.005-.041.037-.04.048.001.005.025.013.033.015l.016.006c.007.003.015.01.023.017.007.006.02.017.025.017a.2.2 0 0 0 .005-.034l.002-.013c.005-.034.025-.04.036-.04zm.038.122h-.003c-.032-.007-.034-.027-.036-.058l-.001-.017a.27.27 0 0 0-.002-.02c-.002.001-.006.005-.007.017l-.002.011c-.002.024-.005.057-.03.057-.014 0-.028-.012-.041-.023a.103.103 0 0 0-.017-.013l-.014-.005c-.02-.006-.047-.015-.05-.036-.003-.024.027-.067.058-.076a.08.08 0 0 0 .028-.011c-.012-.01-.022-.009-.033 0-.013.012-.036.01-.05.003a.036.036 0 0 1-.02-.031l.002-.01a.18.18 0 0 0 .004-.042.027.027 0 0 0-.003-.006c-.005-.008-.013-.02-.009-.034.003-.01.01-.02.024-.027.027-.014.047-.005.062.003.012.005.022.01.034.007.035-.006.05-.019.061-.036.012-.018.009-.059-.013-.082a.148.148 0 0 0-.034-.028.095.095 0 0 1-.024-.02c0 .01 0 .018-.002.022a.246.246 0 0 0-.002.052l.002.036-.024-.027s-.025-.03-.046-.05a.144.144 0 0 1-.022-.036v.024c0 .009.006.019.01.027.008.012.016.026.005.038-.016.014-.038-.008-.065-.037l-.017-.017c-.016-.013-.053-.042-.07-.073-.015-.03-.026-.07-.032-.09l-.001-.004a.283.283 0 0 1-.004-.11 1.63 1.63 0 0 0 .023-.056h-.072a.407.407 0 0 1-.036-.002c-.032-.002-.047-.003-.056.014-.015.027-.01.084.015.177l.009.032c.02.072.029.102.021.12a.213.213 0 0 1-.054.063c-.017.01-.054.006-.07-.002a.161.161 0 0 0-.077-.016h-.033c-.027 0-.045.001-.058-.002l-.02-.007c-.015-.006-.04-.016-.05-.013-.012.003-.027.01-.032.02a.012.012 0 0 0 0 .01c.008.025.002.04-.004.048a.048.048 0 0 1-.043.015.17.17 0 0 1-.037-.01l-.023-.006a.064.064 0 0 0-.02-.003c-.015-.002-.03-.004-.038-.015a.03.03 0 0 1-.005-.023.07.07 0 0 1 .018-.039l.01-.014a.11.11 0 0 0 .008-.016c-.014 0-.025 0-.032.005l-.007.006c-.014.012-.035.031-.056.02-.025-.013-.036-.04-.036-.08a.101.101 0 0 0-.012-.041c-.007-.015-.013-.028-.006-.039.007-.009.019-.01.028-.01.016.002.034.007.05.01.012.004.033.01.037.007.006-.015.006-.02-.014-.036l-.01-.008c-.014-.009-.027-.018-.027-.033 0-.015.013-.025.017-.028l.03-.021a.072.072 0 0 0 .017-.013l.008-.012c.01-.016.028-.044.053-.032.027.013.028.032.028.048 0 .014.001.028.018.047.04.043.061.056.122.05.066-.008.075-.015.075-.023a.357.357 0 0 0-.006-.054l-.002-.011.004-.035a.057.057 0 0 0-.01.013.813.813 0 0 1-.028.052l-.017.03-.007-.034a.346.346 0 0 1 0-.107l.002-.022a.134.134 0 0 0-.002-.013.103.103 0 0 1-.007.018.284.284 0 0 0-.009.064l-.001.025-.02-.016a.121.121 0 0 1-.035-.113.288.288 0 0 0 .002-.066c-.002-.032-.003-.057.007-.072l.007-.011c.018-.032.057-.1.136-.103.053-.002.098 0 .132.001.02 0 .036.002.047 0 .017 0 .062-.008.095-.013-.057-.03-.17-.09-.204-.112a.65.65 0 0 1-.137-.143.49.49 0 0 1-.04-.096.149.149 0 0 0-.05.017.315.315 0 0 0-.078.06c-.017.02-.045.066-.046.067l-.023-.008s.005-.054.005-.074a.168.168 0 0 1-.05.064 1.574 1.574 0 0 0-.093.074l-.024.02.003-.031a.917.917 0 0 0 .009-.08.126.126 0 0 1-.056.029l-.038.005c-.028.003-.072.008-.074.02a.128.128 0 0 0 .002.04c.003.02.006.039-.002.054a.12.12 0 0 1-.04.04l-.007.004-.007-.006a.101.101 0 0 0-.044-.021c-.02-.001-.039.009-.039.009l-.01.005-.006-.009c-.002-.003-.024-.032-.014-.056a.108.108 0 0 1 .02-.026.205.205 0 0 0 .013-.014.164.164 0 0 0-.033.014l-.005.001c-.012.007-.042.016-.06.004-.004-.004-.013-.012-.01-.03 0-.008.003-.016.004-.024.003-.016.005-.025 0-.035-.008-.018-.006-.03-.003-.037a.035.035 0 0 1 .022-.02.122.122 0 0 1 .033-.003.14.14 0 0 0 .039-.004c-.002 0-.012-.013-.045-.02-.03-.007-.05-.022-.054-.039-.002-.007-.003-.02.01-.033.02-.02.025-.023.033-.038a.09.09 0 0 0 .004-.01c.005-.011.011-.026.026-.032.01-.004.021-.003.034.003.02.01.03.025.036.038.007.013.013.023.027.027a.265.265 0 0 0 .13-.014.899.899 0 0 0 .04-.027l.057-.038c.014-.006.06-.04.089-.06a.67.67 0 0 1-.055-.043.524.524 0 0 1-.024-.025.26.26 0 0 0-.041-.041.593.593 0 0 0-.119-.04.673.673 0 0 1-.114-.031l-.035-.013.035-.011a.206.206 0 0 0 .047-.02l.002-.003a.42.42 0 0 1 .016-.012.238.238 0 0 1-.034-.005.237.237 0 0 1-.03-.014.18.18 0 0 0-.049-.02.445.445 0 0 0-.051.006l-.01-.023a.306.306 0 0 1 .108-.042.082.082 0 0 1-.028-.02l-.02-.033a.327.327 0 0 0-.029-.047c-.007-.011-.012-.019-.02-.02-.007 0-.02.006-.031.011a.097.097 0 0 1-.044.012c-.017-.001-.045-.01-.048-.055v-.01l-.001-.01-.005-.01-.005-.01c-.01-.015-.021-.035-.015-.051a.027.027 0 0 1 .019-.017.176.176 0 0 1 .058-.002h.02a.158.158 0 0 0-.044-.033c-.026-.014-.051-.028-.054-.048 0-.006 0-.015.01-.023a.254.254 0 0 1 .025-.018.087.087 0 0 0 .024-.02l.007-.012c.009-.016.018-.034.034-.04a.03.03 0 0 1 .023.004c.013.007.025.024.038.041a.14.14 0 0 0 .03.034.14.14 0 0 0 .004-.06c-.002-.016-.002-.047.012-.062a.024.024 0 0 1 .021-.006c.01.001.02.008.028.014.01.007.02.014.033.015h.022c.024 0 .044-.002.054.01a.022.022 0 0 1 .005.019.166.166 0 0 1-.044.074c-.015.019-.025.058-.014.084a.26.26 0 0 0 .07.09.337.337 0 0 0 .053.024c.024.01.047.019.067.03l.039.028c.033.024.082.06.1.065a.339.339 0 0 1 .051.019.222.222 0 0 1 .073-.013h.031a.469.469 0 0 0 .139-.008c.05-.02.07-.04.063-.057-.005-.012-.025-.026-.043-.038-.026-.019-.052-.036-.046-.058.01-.036.05-.037.098-.04h.024c.05 0 .085-.004.093-.05.014-.072.014-.097-.043-.11l-.029-.005c-.056-.012-.1-.02-.114-.07a.561.561 0 0 0-.01-.037c-.007-.022-.012-.037.003-.052.018-.017.046-.024.099-.028l.035-.002a.282.282 0 0 0 .085-.011.06.06 0 0 0 .013-.022.088.088 0 0 1 .027-.037.384.384 0 0 1 .104-.028h.004l.003.001a1 1 0 0 1 .334.258l-.01.007h.013s0 .046.005.09a.231.231 0 0 1-.005.062c-.003.016-.006.03-.003.04a.626.626 0 0 1 .006.02.183.183 0 0 0 .013.037c.01.018.014.06.015.065l.002.028-.07-.052-.016-.012.003.04a.166.166 0 0 0 .03.072.56.56 0 0 0 .014.015c.02.022.046.05.056.075a.32.32 0 0 1 .01.098l-.001.042-.022-.036c-.01-.017-.033-.047-.05-.052a.315.315 0 0 1-.033-.015c.01.019.02.04.02.063 0 .05-.02.106-.022.108l-.01.026-.013-.025a.31.31 0 0 0-.088-.1.28.28 0 0 1 .02.09c0 .051-.01.156-.01.16l-.004.039-.02-.033s-.024-.04-.048-.059a.534.534 0 0 0-.019-.013.13.13 0 0 1 .008.027c.014.1.056.2.122.297l.01.013c.059.088.149.22.332.174a.148.148 0 0 0 .1-.073c.039-.073.03-.193-.025-.357a1.156 1.156 0 0 1-.061-.32.942.942 0 0 1 .016-.105.67.67 0 0 0 .017-.11c0-.002-.02-.12.01-.219a.866.866 0 0 1 .047-.125l.014-.03.01-.028a.177.177 0 0 0 .019-.056c.004-.03.004-.086.004-.087l.024-.006c.002.003.038.07.048.095a.16.16 0 0 1 .006.034.141.141 0 0 1 .048-.052 3.15 3.15 0 0 1 .039-.024c.041-.026.084-.052.095-.066a.144.144 0 0 0 .02-.03l.024.006c0 .005-.006.128-.043.179a2.5 2.5 0 0 1-.085.102.204.204 0 0 1 .04-.006c.033-.003.057 0 .058 0l.03.003-.024.02s-.04.03-.088.102c-.028.04-.033.06-.04.08a.238.238 0 0 1-.028.063.207.207 0 0 1-.08.079c-.011.007-.024.015-.037.026-.06.049-.032.253-.02.301l.03.074c.052.128.103.257.105.303v.01c.002.07.007.216-.109.31a.395.395 0 0 1-.177.067c-.022.005-.043.009-.05.014-.013.008-.078.056-.078.177 0 .095.028.118.058.142a.613.613 0 0 1 .012.01.084.084 0 0 0 .046.017c.017.003.035.006.042.024l.003.008a.098.098 0 0 0 .022.036.067.067 0 0 1 .023.064.204.204 0 0 1-.038.061.414.414 0 0 0-.041.062 1.029 1.029 0 0 0-.055.163c0 .018-.002.055.01.072.006.008.041.05.033.08a.03.03 0 0 1-.021.02c-.02.008-.039-.001-.052-.007l-.012-.005c-.018.005-.03.013-.042.02-.009.005-.016.01-.023.01z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.866 15.653s-.02-.053-.024-.069c-.003-.014-.014-.031-.014-.031s.103 0 .1.03c-.002.029-.033.029-.04.04a.19.19 0 0 1-.022.03z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.176 15.752c.012.03.024.062.031.094.013.051.055.176.096.289l.027-.041c.035-.059.09-.085.14-.11.079-.04.122-.062.128-.14-.026-.038-.212-.077-.422-.092zm.053.792l-.063-.164a6.462 6.462 0 0 1-.169-.492.76.76 0 0 0-.088-.192l-.096-.152h.189c.139 0 .607.013.756.168.042.044.06.097.054.151-.014.187-.156.257-.241.298a.306.306 0 0 0-.054.03 1.423 1.423 0 0 1-.168.22l-.12.133z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.108 15.526l-.004-.032s.05 0 .073.02c.037.03.06.076.058.079-.006.006-.034-.021-.054-.028 0 0-.015.003-.03.003-.014 0-.021-.008-.023-.016a.056.056 0 0 1 .002-.022l-.022-.004z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.684 16.175l.003.002c.066.031.144.098.212.158.07.061.138.12.171.12l.008-.001a2.172 2.172 0 0 0-.43-.741c-.148-.162-.45-.182-.518-.185l.024.278.17.04-.005.021c0 .001-.03.124-.016.206.007.03.041.139.166.139.103 0 .211-.035.213-.035l.002-.002zm.386.317c-.04 0-.106-.058-.183-.126-.066-.057-.141-.122-.204-.153a.813.813 0 0 1-.214.034c-.14 0-.18-.126-.19-.165a.667.667 0 0 1 .012-.207l-.159-.037-.03-.346h.014c.015 0 .372.002.547.192.26.275.457.74.438.788l-.003.006a.035.035 0 0 1-.028.014z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.49 15.936a.701.701 0 0 1-.05-.054.258.258 0 0 1-.026-.038l.027-.008.025.037c.008.011.037.04.048.05l-.024.013z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.127 15.6s.031.023.055.027c.024.003.05.003.053.003.003 0 .011-.035.007-.059-.013-.077-.084-.095-.084-.095s.022.047.011.07a.208.208 0 0 1-.042.055z",
    fill: "#DB4446"
  }), React__default.createElement("path", {
    d: "M17.376 16.22a.92.92 0 0 0 .249.085c.105.012.216.015.288.016a.566.566 0 0 0 .02-.238.577.577 0 0 0-.337-.4c.031.09.05.2.004.278a1.146 1.146 0 0 1-.224.26zm.591.238a3.77 3.77 0 0 1-.367-.018c-.181-.023-.398-.147-.407-.152l-.086-.05.078-.056c.002-.002.171-.127.262-.28.037-.062-.022-.222-.074-.316l-.072-.128.169.033c.022.004.535.11.63.57.023.118-.012.322-.064.37l-.025.025-.044.002z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.98 15.668s-.028-.05-.086-.043a.168.168 0 0 0-.098.052s.065-.002.081.008c.024.016.031.056.031.056s.035-.02.046-.035l.025-.038z",
    fill: "#DB4446"
  }), React__default.createElement("path", {
    d: "M17.038 15.968c.184.01.227.05.242.065.077.076.12.213.143.312a.805.805 0 0 0 .125-.153c.029-.057.067-.148.09-.202-.039-.077-.142-.237-.308-.207a.55.55 0 0 0-.292.185zm.31.644l-.013-.12c-.009-.064-.045-.247-.115-.317-.016-.016-.092-.042-.272-.042h-.054l-.126.006.082-.144c.008-.013.19-.329.467-.378.293-.054.43.316.436.33l.015.043-.016.042c-.003.007-.068.17-.116.263-.053.104-.201.24-.218.255l-.07.062z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.908 15.87s-.05.007-.077.038c-.027.032-.023.09-.023.09s.033-.034.062-.034c.03 0 .074.01.074.01s-.014-.036-.014-.052c0-.015-.022-.052-.022-.052z",
    fill: "#DB4446"
  }), React__default.createElement("path", {
    d: "M17.425 16.019c-.084.019-.257.07-.36.187a.562.562 0 0 0-.115.312.515.515 0 0 1 .284-.111c.103 0 .232.019.327.036a.795.795 0 0 1-.044-.203.752.752 0 0 0-.092-.221zm-.615.837l-.013-.167c-.001-.016-.026-.376.156-.58.176-.197.486-.244.5-.245l.049-.008.025.043c.024.038.139.237.139.341 0 .055.048.197.078.274l.051.128-.137-.03a2.382 2.382 0 0 0-.424-.06c-.113 0-.264.134-.308.18l-.116.124zm1.04-.93l.05-.096.05.088z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M17.835 15.914l.049-.1.051.092z"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M17.903 15.925l.048-.096.052.087z"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M17.885 15.914l.049-.1.051.09zm-.005-.264l.1.042-.09.057z"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M17.88 15.737l-.01-.1.1.043z"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M17.944 15.667l.1.028-.082.072z"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M17.952 15.755l-.02-.1.1.028zm-.165.866l-.012-.022c.001 0 .07-.035.09-.048a.25.25 0 0 0 .069-.065.471.471 0 0 0-.014-.098.144.144 0 0 1-.005-.054.235.235 0 0 1-.033.034.304.304 0 0 1-.119.054c-.044.01-.063.021-.064.021l-.017-.017s.034-.055.037-.098a.13.13 0 0 0-.004-.035v-.001a.641.641 0 0 1-.052.026.308.308 0 0 0-.031.02.68.68 0 0 1-.048.03.231.231 0 0 0-.055.067l-.022-.013a.258.258 0 0 1 .065-.075.673.673 0 0 0 .046-.03.21.21 0 0 1 .037-.023.803.803 0 0 0 .055-.028l-.002-.01c-.003-.023.01-.05.022-.071a.279.279 0 0 1-.048.01.094.094 0 0 1-.051-.008 1.406 1.406 0 0 0-.04-.01.11.11 0 0 0-.089.018l-.02.016v-.025c0-.002-.002-.04.024-.077.021-.032.075-.048.078-.048l.007.024a.143.143 0 0 0-.065.038.111.111 0 0 0-.017.038c.02-.01.052-.019.09-.01l.039.012a.094.094 0 0 0 .042.008.474.474 0 0 0 .078-.022l.045-.016-.03.036c-.013.014-.044.057-.04.084l.007.035a.153.153 0 0 1 .004.041.244.244 0 0 1-.024.079.39.39 0 0 1 .038-.01.277.277 0 0 0 .108-.05.357.357 0 0 0 .056-.063l.023.009a.235.235 0 0 0-.001.085c.007.02.012.06.014.087a.27.27 0 0 1 .038-.026.16.16 0 0 0 .053-.04.322.322 0 0 0 .02-.065l.024.001s.007.056.023.081a.468.468 0 0 1 .036.083.198.198 0 0 1 .028-.05c.01-.011.041-.047.042-.062a.257.257 0 0 0-.005-.051l.024-.008.026.055-.02.01c-.003.018-.021.042-.048.073a.278.278 0 0 0-.036.074l-.012.036-.012-.037a.668.668 0 0 0-.044-.109.152.152 0 0 1-.016-.038.093.093 0 0 1-.009.02.17.17 0 0 1-.06.048c-.025.013-.054.04-.055.04l-.002.002a.27.27 0 0 1-.075.07c-.02.013-.088.047-.091.048z"
  }), React__default.createElement("path", {
    d: "M17.074 16.527s-.027-.033-.074-.024c-.048.01-.08.071-.08.071s.041-.012.065-.005c.023.005.04.033.04.033s.022-.022.03-.033l.02-.042z",
    fill: "#DB4446"
  }), React__default.createElement("path", {
    d: "M17.272 16.97c.04 0 .074.007.103.018.084.03.153.123.196.195.036-.055.076-.117.092-.154a3.92 3.92 0 0 0 .074-.22c-.049-.055-.15-.137-.293-.098-.108.034-.2.157-.263.268a.53.53 0 0 1 .091-.008zm.28.519l-.041-.095c0-.002-.073-.167-.166-.2-.097-.04-.298.04-.3.04l-.15.067.078-.22c.007-.02.176-.492.448-.577.287-.081.438.195.443.206l.03.053-.019.065c-.003.01-.069.23-.106.321a1.86 1.86 0 0 1-.163.265l-.054.075z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.02 16.716s-.04-.007-.076.021c-.034.028-.036.08-.036.08s.033-.027.059-.023a.232.232 0 0 1 .056.017l.007-.041c.006-.025-.01-.054-.01-.054z",
    fill: "#DB4446"
  }), React__default.createElement("path", {
    d: "M17.345 17.25l.046.003c.103.013.217.053.298.085a4.19 4.19 0 0 1 .032-.185.511.511 0 0 0-.046-.274.622.622 0 0 0-.397.135.61.61 0 0 0-.176.309.534.534 0 0 1 .243-.073zm-.45.452l.006-.198c.001-.017.017-.411.272-.627.274-.227.569-.168.569-.168l.04.007.02.037c.005.01.128.238.083.44a8.946 8.946 0 0 0-.048.282l-.017.114-.1-.049a1.429 1.429 0 0 0-.375-.115c-.111 0-.261.11-.305.149l-.145.128z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.113 16.893s-.003.05.022.082c.026.033.074.038.074.038s-.016-.034-.018-.051c-.004-.026.022-.049.022-.049s-.024-.024-.048-.024a.448.448 0 0 0-.052.004z",
    fill: "#DB4446"
  }), React__default.createElement("path", {
    d: "M17.126 16.942c0 .038.005.107.028.154a.15.15 0 0 0 .062.067.622.622 0 0 1-.014-.077.224.224 0 0 1 .024-.118c-.012-.015-.029-.031-.043-.031a.34.34 0 0 0-.057.005zm.102.3l-.022-.005c-.002 0-.053-.015-.081-.104-.028-.084-.025-.214-.025-.22l.001-.024.01-.004c.001 0 .029-.009.053-.009.028 0 .053.061.056.069l.01.022-.01.022a.207.207 0 0 0-.018.088c.002.032.013.095.017.117l.009.048zm1.027.634l-.02-.037c0-.002.066-.208.07-.358.003-.12-.087-.28-.122-.332l.013-.052c.015.021.138.21.134.388-.004.169-.073.382-.075.391z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.587 17.347s-.033-.041-.078-.04c-.046.002-.094.045-.094.045s.057-.005.072.014l.03.043s.025-.013.036-.022c.01-.009.034-.04.034-.04z",
    fill: "#DB4446"
  }), React__default.createElement("path", {
    d: "M17.711 17.639c.095.019.16.064.195.138.04.092.08.195.105.263.038-.037.084-.085.109-.119.024-.033.075-.136.114-.22-.047-.078-.146-.215-.266-.215-.09.006-.184.08-.257.153zm.259.656l-.027-.079c-.001-.001-.063-.179-.126-.321-.015-.033-.081-.074-.212-.074-.035 0-.06.003-.06.003l-.166.022.125-.188c.009-.015.231-.348.452-.363.234 0 .39.326.396.34l.027.06-.026.058c-.011.025-.11.247-.163.317-.05.073-.16.171-.173.183l-.047.042z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.447 17.529s-.06-.01-.09.022c-.029.031-.027.088-.027.088s.036-.04.07-.036c.032.003.069.02.069.02l-.01-.05a.618.618 0 0 0-.012-.044z",
    fill: "#DB4446"
  }), React__default.createElement("path", {
    d: "M17.976 17.677c-.095 0-.27.016-.367.127a.66.66 0 0 0-.127.32c.09-.07.205-.135.33-.123.11.011.226.05.31.083a3.24 3.24 0 0 0-.09-.405.807.807 0 0 0-.056-.002zm-.652.838l-.006-.197c-.001-.017-.01-.404.182-.624.128-.148.33-.18.476-.18.075 0 .125.009.125.009l.048.008.013.049s.054.192.075.293c.023.105.057.33.057.33l.023.153-.13-.067c-.002-.001-.209-.108-.39-.127h-.001c-.143 0-.299.15-.348.208l-.124.145z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.577 17.72s-.03.042-.008.075a.148.148 0 0 0 .068.048s-.017-.024-.01-.051c.007-.022.044-.052.044-.052l-.094-.02z",
    fill: "#DB4446"
  }), React__default.createElement("path", {
    d: "M17.776 17.881c-.04.07-.103.215-.021.33a.685.685 0 0 0 .228.192.416.416 0 0 1 .01-.189c.025-.088.11-.184.187-.255l-.404-.078zm.57.826l-.24-.076c-.014-.004-.332-.107-.49-.334-.175-.245.042-.537.052-.55l.031-.04.85.163-.14.104c-.087.066-.233.2-.256.281a.328.328 0 0 0 .048.257l.144.195z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.378 17.799s-.053-.012-.082.005c-.03.017-.053.09-.053.09s.047-.04.082-.035c.035.005.06.02.06.02s.006-.03.002-.05a.174.174 0 0 0-.01-.03z",
    fill: "#DB4446"
  }), React__default.createElement("path", {
    d: "M18.88 17.95a.344.344 0 0 0-.2.05c-.06.043-.125.173-.177.308.095-.063.209-.116.313-.097a.975.975 0 0 1 .261.088.975.975 0 0 0-.003-.196 1.035 1.035 0 0 0-.033-.135.781.781 0 0 0-.161-.018zm-.663.832l.075-.28c.014-.053.143-.523.32-.647a.452.452 0 0 1 .268-.073c.12 0 .222.029.227.03l.034.01.014.04a1.4 1.4 0 0 1 .053.211c.023.15-.005.355-.006.364l-.017.116-.083-.056c-.002-.001-.134-.088-.305-.12-.131-.025-.334.152-.396.216l-.184.189z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.404 17.992s-.04.041-.026.076c.014.035.04.071.04.071s-.002-.052.015-.066c.023-.02.067-.024.067-.024s-.035-.03-.045-.034l-.051-.023z",
    fill: "#DB4446"
  }), React__default.createElement("path", {
    d: "M18.627 18.127c-.063.066-.148.184-.104.275.032.061.072.125.111.18.015-.07.043-.14.095-.178a.76.76 0 0 1 .28-.11.756.756 0 0 0-.125-.073 3.662 3.662 0 0 1-.257-.094zm.144.85l-.141-.169a2.304 2.304 0 0 1-.244-.359c-.102-.207.157-.431.168-.44l.037-.033.049.02c.093.037.248.096.292.108.071.02.232.134.297.182l.133.097-.177.01c-.002.001-.236.016-.358.104-.04.03-.064.166-.062.274l.006.205z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.604 18.053s-.02.05.018.082a.14.14 0 0 0 .072.037s-.03-.052-.02-.08a.102.102 0 0 1 .034-.046s-.048-.016-.055-.014a.617.617 0 0 0-.049.02z",
    fill: "#DB4446"
  }), React__default.createElement("path", {
    d: "M18.775 18.272c-.022.07-.061.256.105.383.1.077.192.125.267.155-.052-.115-.1-.267-.06-.378a.619.619 0 0 1 .15-.22 1.274 1.274 0 0 0-.194-.042c-.021.005-.15.055-.268.102zm.682.747l-.16-.014a1.08 1.08 0 0 1-.526-.236c-.296-.226-.149-.565-.142-.58l.012-.027.031-.013c.107-.044.296-.12.346-.127l.025-.003c.08 0 .315.069.385.09l.158.047-.137.085a.556.556 0 0 0-.201.24c-.036.094.06.303.13.412l.08.126z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.548 21.638c.135.04.203.141.203.259 0 .154-.148.27-.342.27-.193 0-.35-.116-.35-.27 0-.116.064-.246.199-.255 0 0-.004-.012-.016-.032l-.041-.043s.051-.01.08.002c.03.011.05.03.05.03s.014-.028.034-.05a.18.18 0 0 1 .045-.033s.03.024.04.041c.01.017.016.038.016.038s.027-.022.051-.032c.024-.01.054-.016.054-.016s-.008.03-.014.044c-.006.015-.01.047-.01.047z",
    fill: "#FFD691"
  }), React__default.createElement("path", {
    d: "M16.31 21.619l.025.026c.02.035.026.054.026.057l.009.029-.03.002c-.165.012-.251.183-.251.346 0 .206.201.368.459.368.255 0 .448-.158.448-.368 0-.171-.096-.3-.264-.353l-.018-.006.002-.02a.37.37 0 0 1 .02-.095.277.277 0 0 0-.096.054l-.026.023-.01-.034a.36.36 0 0 0-.02-.052.229.229 0 0 0-.037-.041.213.213 0 0 0-.043.036.316.316 0 0 0-.042.066l-.014.029-.023-.022s-.025-.025-.061-.04a.153.153 0 0 0-.053-.005zm.238.877c-.284 0-.506-.183-.506-.417 0-.175.09-.359.263-.39l-.007-.015a4.788 4.788 0 0 1-.054-.057l-.03-.032.043-.01s.03-.005.064-.005c.024 0 .044.003.06.009.021.009.04.02.053.03a.276.276 0 0 1 .105-.106l.014-.007.011.01a.33.33 0 0 1 .06.067l.013.028a.256.256 0 0 1 .051-.03.523.523 0 0 1 .078-.025l.038-.01-.01.04s-.013.045-.021.067a.24.24 0 0 0-.009.042.404.404 0 0 1 .278.394c0 .237-.212.417-.494.417z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.38 22.334s-.257-.174-.368-.197c-.142-.03-.302-.006-.371-.01.002.002.083.06.118.096a.678.678 0 0 0 .222.123c.208.052.4-.012.4-.012z",
    fill: "#058E6E"
  }), React__default.createElement("path", {
    d: "M15.71 22.244a3.2 3.2 0 0 1 .1.241c.04.118.18.37.26.427a.337.337 0 0 0 .203.072.408.408 0 0 0 .23-.08c-.086-.166-.301-.561-.404-.625a.375.375 0 0 0-.203-.054.929.929 0 0 0-.139.013l-.046.006zm.563.86a.356.356 0 0 1-.213-.074c-.082-.06-.232-.318-.28-.46-.034-.098-.105-.254-.131-.312a1.01 1.01 0 0 1-.014-.03l-.037-.112.053.009a.403.403 0 0 0 .104-.007c.042-.006.09-.013.14-.013a.39.39 0 0 1 .213.056c.137.085.443.69.456.715l.034.068-.039.039a.445.445 0 0 1-.286.122z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.454 22.349s.164-.172.337-.195c.203-.029.337.016.416.037.002 0-.066.032-.101.056-.036.024-.127.102-.267.103-.141.002-.296-.015-.321-.01l-.064.009z",
    fill: "#058E6E"
  }), React__default.createElement("path", {
    d: "M16.557 22.918c.02 0 .053.007.096.015.069.014.163.033.255.033h.028c.147-.006.25-.251.3-.37l.016-.038c.022-.05.053-.107.079-.152-.073-.065-.17-.141-.297-.141a.369.369 0 0 0-.154.036c-.142.064-.282.42-.353.626l.012-.006a.04.04 0 0 1 .018-.003zm-.15.21l.043-.147c.008-.03.208-.718.424-.815a.379.379 0 0 1 .16-.038c.147 0 .258.1.33.167l.04.036.003.04a.142.142 0 0 1-.026.103 1.975 1.975 0 0 0-.106.197l-.016.037c-.053.126-.163.389-.323.394h-.028c-.093 0-.188-.019-.258-.033-.052-.01-.092-.018-.104-.013l-.078.04-.06.032z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.404 22.137a.328.328 0 0 1 .001-.48.328.328 0 0 1 0 .48z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M16.785 21.722c-.235.111-.363.256-.363.411 0 .156.127.301.36.413.235-.112.363-.257.363-.413 0-.155-.127-.3-.36-.41zm-.003.912l-.047-.02c-.291-.126-.452-.297-.452-.48 0-.184.162-.354.455-.48l.048-.02.046.02c.291.126.451.297.451.48s-.16.354-.453.48l-.048.02z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.34 22.488s.039-.099.043-.183a.711.711 0 0 0-.01-.14h.052s.025.075.025.14c0 .066-.012.153-.012.153s-.035.005-.047.01a.762.762 0 0 1-.052.02z",
    fill: "#058E6E"
  }), React__default.createElement("path", {
    d: "M16.838 22.24c.025.07.06.203.043.338-.017.154-.13.321-.208.421.045-.006.086-.013.109-.017.055-.013.17-.023.25-.029.02-.071.063-.243.063-.378 0-.128-.09-.273-.132-.336h-.125zm-.528.908l.086-.091c.002-.003.245-.264.27-.484.024-.184-.06-.369-.06-.37l-.025-.055h.538l.025.03c.007.01.166.215.166.397 0 .18-.072.414-.075.424l-.01.034-.081.005a2.95 2.95 0 0 0-.268.026c-.087.017-.32.05-.347.053l-.219.03z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M19.59 13.185c0-.037.031-.067.07-.067.04 0 .071.03.071.067a.07.07 0 0 1-.07.067c-.04 0-.072-.03-.072-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M20.076 13.264a.344.344 0 0 0-.348.34c0 .189.156.343.348.343a.348.348 0 0 0 .35-.343.346.346 0 0 0-.35-.34zm0 .842a.5.5 0 1 1 .5-.502.502.502 0 0 1-.5.502z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M19.686 13.014a.07.07 0 0 1 .071-.068c.039 0 .07.03.07.068a.069.069 0 0 1-.07.067.069.069 0 0 1-.07-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M20.175 13.092a.346.346 0 0 0-.35.342c0 .188.157.342.35.342a.345.345 0 0 0 .347-.342.345.345 0 0 0-.347-.342zm0 .842a.5.5 0 1 1-.001-1.002.5.5 0 0 1 0 1.002z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M19.75 12.815c0-.037.032-.067.072-.067.038 0 .071.03.071.067 0 .037-.033.067-.071.067a.069.069 0 0 1-.071-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M20.237 12.894a.344.344 0 0 0-.348.34c0 .192.153.343.348.343a.348.348 0 0 0 .351-.343.346.346 0 0 0-.35-.34zm0 .841a.5.5 0 1 1 .5-.502.502.502 0 0 1-.5.502z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M19.76 12.601c0-.036.03-.066.07-.066.039 0 .07.03.07.066a.069.069 0 0 1-.07.068.069.069 0 0 1-.07-.068z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M20.245 12.68a.344.344 0 0 0-.347.34c0 .19.155.344.347.344.197 0 .35-.151.35-.344a.346.346 0 0 0-.35-.34zm0 .842a.5.5 0 1 1 .005-1.001.5.5 0 0 1-.005 1.001z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M19.707 12.392c0-.037.031-.067.07-.067.04 0 .071.03.071.067a.07.07 0 0 1-.07.067.07.07 0 0 1-.071-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M20.193 12.47a.344.344 0 0 0-.347.343.349.349 0 0 0 .697 0 .343.343 0 0 0-.35-.342zm0 .843a.5.5 0 0 1 0-1c.28 0 .501.219.501.5 0 .275-.225.5-.501.5z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M19.598 12.202c0-.038.031-.067.07-.067.04 0 .071.03.071.067a.07.07 0 0 1-.07.067.07.07 0 0 1-.071-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M20.083 12.28a.345.345 0 0 0-.347.342c0 .189.156.342.347.342a.346.346 0 0 0 .351-.342.343.343 0 0 0-.35-.342zm0 .842a.5.5 0 1 1 .004-1 .5.5 0 0 1-.004 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M19.452 12.045c0-.037.032-.067.07-.067.04 0 .072.03.072.067a.069.069 0 0 1-.071.067.069.069 0 0 1-.07-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M19.938 12.123a.345.345 0 0 0-.347.342c0 .192.153.343.347.343.197 0 .351-.15.351-.343a.347.347 0 0 0-.351-.342zm0 .842a.499.499 0 1 1 .502-.5c0 .28-.22.5-.502.5z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M19.283 11.915c0-.037.033-.067.071-.067.04 0 .071.03.071.067a.07.07 0 0 1-.07.067c-.04 0-.072-.03-.072-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M19.771 11.993a.35.35 0 0 0-.35.342c0 .185.16.342.35.342a.345.345 0 0 0 .349-.342.35.35 0 0 0-.349-.342zm0 .842a.501.501 0 0 1-.5-.5c0-.27.23-.5.5-.5a.5.5 0 0 1 0 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M19.082 11.808c0-.036.031-.066.07-.066.04 0 .072.03.072.066 0 .038-.033.067-.071.067-.04 0-.071-.03-.071-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M19.57 11.887a.345.345 0 0 0-.35.34c0 .192.153.343.35.343a.347.347 0 0 0 .349-.343.35.35 0 0 0-.35-.34zm0 .842z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.872 11.733a.07.07 0 0 1 .071-.067c.04 0 .071.03.071.067a.07.07 0 0 1-.07.067.07.07 0 0 1-.072-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M19.36 11.811a.346.346 0 0 0-.349.342.35.35 0 0 0 .698 0 .35.35 0 0 0-.35-.342zm0 .842a.5.5 0 1 1 .5-.5c0 .27-.23.5-.5.5z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.638 11.691c0-.037.032-.067.072-.067.039 0 .07.03.07.067a.07.07 0 0 1-.07.067c-.04 0-.072-.03-.072-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M19.129 11.77a.348.348 0 0 0-.353.341c0 .189.158.343.353.343a.35.35 0 0 0 .346-.343.345.345 0 0 0-.346-.342zm0 .841a.502.502 0 0 1-.503-.5.499.499 0 1 1 .503.5z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.416 11.68c0-.038.032-.067.071-.067.04 0 .071.03.071.066a.068.068 0 0 1-.07.067.069.069 0 0 1-.072-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M18.904 11.759a.345.345 0 0 0-.35.339c0 .193.155.343.35.343.192 0 .35-.153.35-.343a.345.345 0 0 0-.35-.34zm0 .841a.5.5 0 1 1-.001-1.001.5.5 0 0 1 0 1.001z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.199 11.687a.07.07 0 0 1 .07-.067c.04 0 .071.03.071.067a.069.069 0 0 1-.07.067.07.07 0 0 1-.071-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M18.688 11.765a.347.347 0 0 0-.35.342c0 .189.157.342.35.342a.344.344 0 0 0 .347-.342.345.345 0 0 0-.347-.342zm0 .842a.501.501 0 0 1-.502-.5.5.5 0 1 1 .502.5z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.98 11.687a.07.07 0 0 1 .072-.067c.039 0 .07.03.07.067a.07.07 0 0 1-.07.067.07.07 0 0 1-.071-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M18.467 11.765a.35.35 0 0 0-.347.342c0 .189.156.342.347.342.193 0 .35-.153.35-.342a.346.346 0 0 0-.35-.342zm0 .842a.5.5 0 1 1 .002-1 .5.5 0 0 1-.002 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.09 11.874a.07.07 0 0 1 .07-.068c.04 0 .071.03.071.068 0 .036-.03.067-.07.067-.04 0-.071-.03-.071-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M18.58 11.951a.347.347 0 0 0-.351.343c0 .188.157.342.35.342a.345.345 0 0 0 .347-.342.345.345 0 0 0-.347-.343zm0 .843a.501.501 0 0 1-.503-.5.5.5 0 1 1 .502.5z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.134 12.08c0-.037.032-.067.071-.067.039 0 .07.03.07.067a.068.068 0 0 1-.07.067c-.04 0-.07-.03-.07-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M18.623 12.16a.344.344 0 0 0-.35.344c0 .186.157.338.35.338a.343.343 0 0 0 .348-.338.346.346 0 0 0-.348-.344zm0 .84a.5.5 0 1 1-.004-.998.5.5 0 0 1 .004.999z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.142 12.286c0-.037.032-.067.071-.067.04 0 .071.03.071.067a.07.07 0 0 1-.071.067c-.039 0-.071-.03-.071-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M18.63 12.364a.35.35 0 0 0-.35.342c0 .185.16.342.35.342a.345.345 0 0 0 .349-.342.345.345 0 0 0-.349-.342zm0 .842a.5.5 0 1 1 0-1.002.5.5 0 0 1 0 1.002z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.078 12.473c0-.037.032-.067.07-.067.04 0 .071.03.071.067a.069.069 0 0 1-.07.067.069.069 0 0 1-.07-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M18.564 12.551a.345.345 0 0 0-.348.342c0 .189.156.342.348.342.196 0 .35-.15.35-.342a.347.347 0 0 0-.35-.342zm0 .842a.5.5 0 1 1 .002-.999.5.5 0 0 1-.002 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.957 12.646a.07.07 0 0 1 .071-.068c.039 0 .07.03.07.068a.068.068 0 0 1-.07.066c-.04 0-.07-.03-.07-.066z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M18.447 12.725a.343.343 0 0 0-.35.344c0 .186.156.338.35.338a.343.343 0 0 0 .346-.338.345.345 0 0 0-.346-.344zm0 .84a.5.5 0 1 1-.004-1 .5.5 0 0 1 .004 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.816 11.557c0-.037.032-.066.07-.066.04 0 .072.03.072.066 0 .037-.032.067-.071.067-.039 0-.071-.03-.071-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M18.302 11.637a.344.344 0 0 0-.349.34c0 .185.16.343.35.343.192 0 .35-.155.35-.344a.345.345 0 0 0-.35-.339zm0 .841a.5.5 0 1 1 .5-.502.502.502 0 0 1-.5.502z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.623 11.45c0-.037.031-.067.07-.067.04 0 .071.03.071.067a.069.069 0 0 1-.071.067.069.069 0 0 1-.07-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M18.108 11.528a.344.344 0 0 0-.347.342c0 .189.156.342.347.342.193 0 .35-.153.35-.342a.347.347 0 0 0-.35-.342zm0 .842a.5.5 0 1 1 .003-.999.5.5 0 0 1-.003 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.409 11.386a.07.07 0 0 1 .07-.067c.04 0 .072.03.072.067 0 .037-.032.067-.071.067-.039 0-.071-.03-.071-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M17.895 11.464a.345.345 0 0 0-.348.343.35.35 0 0 0 .698 0 .343.343 0 0 0-.35-.343zm0 .842a.5.5 0 1 1 .002-1 .5.5 0 0 1-.002 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M17.187 11.348a.07.07 0 0 1 .07-.067c.04 0 .072.03.072.067 0 .037-.032.066-.071.066a.068.068 0 0 1-.07-.066z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M17.674 11.427a.346.346 0 0 0-.348.343c0 .187.156.34.348.34.193 0 .35-.153.35-.34a.347.347 0 0 0-.35-.343zm0 .841a.5.5 0 1 1 0-.998.5.5 0 0 1 0 .998z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.97 11.351a.07.07 0 0 1 .07-.067c.04 0 .072.03.072.067a.069.069 0 0 1-.071.067.069.069 0 0 1-.07-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M17.456 11.43a.35.35 0 0 0-.348.341c0 .189.156.343.348.343.197 0 .35-.151.35-.343a.347.347 0 0 0-.35-.342zm0 .841a.5.5 0 1 1 .003-1 .5.5 0 0 1-.003 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.744 11.39c0-.038.032-.067.07-.067.04 0 .072.03.072.066a.069.069 0 0 1-.071.067.069.069 0 0 1-.07-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M17.23 11.469a.341.341 0 1 0 0 .683c.197 0 .35-.151.35-.344a.346.346 0 0 0-.35-.34zm0 .841a.5.5 0 1 1 .004-1 .5.5 0 0 1-.004 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.535 11.462c0-.037.032-.067.07-.067.04 0 .072.03.072.067 0 .036-.032.067-.072.067a.07.07 0 0 1-.07-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M17.02 11.54a.344.344 0 0 0-.346.342c0 .185.158.342.345.342a.347.347 0 0 0 .352-.342.347.347 0 0 0-.352-.342zm0 .842a.5.5 0 1 1 .004-.998.5.5 0 0 1-.005.998z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M12.991 13.185c0-.037.032-.067.071-.067.039 0 .07.03.07.067a.069.069 0 0 1-.07.067.069.069 0 0 1-.07-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M13.48 13.264a.346.346 0 0 0-.35.34c0 .189.157.343.35.343a.346.346 0 0 0 .348-.343.344.344 0 0 0-.347-.34zm0 .842z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M12.894 13.014a.07.07 0 0 1 .071-.068c.04 0 .071.03.071.068a.07.07 0 0 1-.07.067c-.04 0-.072-.03-.072-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M13.382 13.092a.347.347 0 0 0-.35.342c0 .192.154.342.35.342a.346.346 0 0 0 .349-.342.346.346 0 0 0-.349-.342zm0 .842a.5.5 0 1 1 0-1.001.5.5 0 0 1 0 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M12.83 12.815c0-.037.031-.067.07-.067.04 0 .072.03.072.067 0 .037-.032.067-.071.067a.069.069 0 0 1-.071-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M13.317 12.894a.345.345 0 0 0-.35.34c0 .192.154.343.35.343.193 0 .35-.154.35-.343a.345.345 0 0 0-.35-.34zm0 .841a.5.5 0 1 1-.002-1.002.5.5 0 0 1 .002 1.002z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M12.822 12.601c0-.036.031-.066.07-.066.04 0 .072.03.072.066 0 .038-.032.068-.072.068a.069.069 0 0 1-.07-.068z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M13.307 12.68a.343.343 0 0 0-.346.34c0 .19.155.344.346.344a.345.345 0 0 0 .352-.344.346.346 0 0 0-.352-.34zm0 .842a.5.5 0 1 1 .005-1 .5.5 0 0 1-.005 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M12.874 12.392c0-.037.032-.067.07-.067.04 0 .072.03.072.067a.07.07 0 0 1-.071.067.07.07 0 0 1-.07-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M13.36 12.47a.345.345 0 0 0-.347.343c0 .188.156.341.347.341.193 0 .35-.153.35-.341a.343.343 0 0 0-.35-.342zm0 .843a.5.5 0 0 1 0-1c.281 0 .502.219.502.5 0 .275-.226.5-.502.5z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M12.983 12.202a.07.07 0 0 1 .07-.067c.04 0 .072.03.072.067 0 .036-.032.067-.071.067-.039 0-.071-.03-.071-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M13.47 12.28a.345.345 0 0 0-.35.342.35.35 0 0 0 .7 0 .343.343 0 0 0-.35-.342zm0 .842a.5.5 0 1 1 .002-1 .5.5 0 0 1-.003 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M13.128 12.045c0-.037.032-.067.071-.067.04 0 .071.03.071.067a.069.069 0 0 1-.07.067.07.07 0 0 1-.072-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M13.616 12.123a.346.346 0 0 0-.35.342c0 .189.157.343.35.343a.342.342 0 1 0 0-.685zm0 .842a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M13.297 11.915c0-.037.032-.067.072-.067.038 0 .07.03.07.067a.069.069 0 0 1-.07.067c-.04 0-.072-.03-.072-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M13.788 11.993a.347.347 0 0 0-.352.342c0 .189.158.342.352.342a.344.344 0 0 0 .346-.342.344.344 0 0 0-.346-.342zm0 .842a.502.502 0 0 1-.503-.5.499.499 0 1 1 .503.5z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M13.499 11.808c0-.036.032-.066.071-.066.039 0 .07.03.07.066a.07.07 0 0 1-.07.067c-.04 0-.071-.03-.071-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M13.987 11.887a.346.346 0 0 0-.35.34c0 .192.153.343.35.343a.346.346 0 0 0 .349-.343.345.345 0 0 0-.349-.34zm0 .842z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M13.708 11.733a.07.07 0 0 1 .071-.067c.039 0 .07.03.07.067a.07.07 0 0 1-.07.067.07.07 0 0 1-.07-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M14.198 11.811a.347.347 0 0 0-.351.342c0 .189.157.342.35.342a.345.345 0 0 0 .347-.342.344.344 0 0 0-.346-.342zm0 .842a.501.501 0 0 1-.502-.5.5.5 0 1 1 .502.5z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M13.942 11.691a.07.07 0 0 1 .071-.067c.039 0 .071.03.071.067a.069.069 0 0 1-.07.067.07.07 0 0 1-.072-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M14.429 11.77a.345.345 0 0 0-.348.341.35.35 0 0 0 .698 0 .351.351 0 0 0-.35-.342zm0 .841a.5.5 0 0 1 0-1c.272 0 .5.23.5.5 0 .271-.228.5-.5.5z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.164 11.68c0-.038.032-.067.071-.067.039 0 .071.03.071.066a.07.07 0 0 1-.07.067.069.069 0 0 1-.072-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M14.652 11.759a.344.344 0 0 0-.35.339c0 .193.154.343.35.343.192 0 .35-.153.35-.343a.345.345 0 0 0-.35-.34zm0 .841a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.382 11.687a.07.07 0 0 1 .07-.067c.04 0 .072.03.072.067 0 .037-.032.067-.071.067a.069.069 0 0 1-.07-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M14.867 11.765a.349.349 0 0 0-.346.342c0 .189.155.342.346.342a.347.347 0 0 0 .352-.342.347.347 0 0 0-.352-.342zm0 .842a.5.5 0 1 1 .004-.998.5.5 0 0 1-.004.998z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.6 11.687a.07.07 0 0 1 .07-.067c.04 0 .072.03.072.067 0 .037-.032.067-.072.067a.07.07 0 0 1-.07-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M15.084 11.765a.349.349 0 0 0-.345.342c0 .189.155.342.345.342a.347.347 0 0 0 .352-.342.347.347 0 0 0-.352-.342zm0 .842a.5.5 0 1 1 .004-.998.5.5 0 0 1-.004.998z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.49 11.874a.07.07 0 0 1 .072-.068.07.07 0 0 1 .071.068c0 .036-.032.067-.071.067a.07.07 0 0 1-.071-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M14.977 11.951a.346.346 0 0 0-.348.343c0 .188.156.342.348.342.19 0 .351-.157.351-.342a.351.351 0 0 0-.35-.343zm0 .843a.5.5 0 1 1 .002-1 .5.5 0 0 1-.002 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.447 12.08c0-.037.03-.067.07-.067.04 0 .071.03.071.067a.068.068 0 0 1-.07.067c-.04 0-.071-.03-.071-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M14.932 12.16a.342.342 0 1 0 0 .682.345.345 0 0 0 .351-.338.344.344 0 0 0-.35-.344zm0 .84a.498.498 0 0 1-.498-.496c0-.283.219-.503.498-.503a.5.5 0 0 1 0 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.439 12.286a.07.07 0 0 1 .07-.067c.04 0 .071.03.071.067a.07.07 0 0 1-.07.067.07.07 0 0 1-.071-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M14.927 12.364a.346.346 0 0 0-.35.342c0 .189.157.342.35.342a.345.345 0 0 0 .348-.342.345.345 0 0 0-.348-.342zm0 .842a.501.501 0 0 1 0-1 .5.5 0 0 1 0 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.503 12.473c0-.037.032-.067.07-.067.04 0 .072.03.072.067 0 .038-.032.067-.072.067a.069.069 0 0 1-.07-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M14.988 12.551a.344.344 0 0 0-.346.342c0 .189.155.342.346.342.197 0 .351-.15.351-.342a.347.347 0 0 0-.351-.342zm0 .842a.499.499 0 1 1 .003-.998.499.499 0 0 1-.003.998z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.623 12.646a.07.07 0 0 1 .071-.068c.04 0 .071.03.071.068a.068.068 0 0 1-.07.066c-.04 0-.072-.03-.072-.066z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M15.11 12.725a.347.347 0 0 0-.349.344c0 .186.157.338.35.338a.344.344 0 0 0 .349-.338.343.343 0 0 0-.35-.344zm0 .84a.499.499 0 1 1 0-1c.28 0 .5.221.5.504a.5.5 0 0 1-.5.497z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.765 11.557c0-.037.031-.066.07-.066.04 0 .071.03.071.066a.07.07 0 0 1-.07.067c-.04 0-.071-.03-.071-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M15.255 11.637a.346.346 0 0 0-.352.34.349.349 0 0 0 .698-.001.343.343 0 0 0-.346-.339zm0 .841z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.959 11.45c0-.037.031-.067.07-.067.04 0 .07.03.07.067a.069.069 0 0 1-.07.067.069.069 0 0 1-.07-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M15.444 11.528a.344.344 0 0 0-.347.342c0 .189.155.342.347.342a.347.347 0 0 0 .35-.342.347.347 0 0 0-.35-.342zm0 .842a.5.5 0 1 1 .003-.999.5.5 0 0 1-.003 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M15.172 11.386c0-.038.031-.067.07-.067.04 0 .071.03.071.067a.069.069 0 0 1-.07.067.07.07 0 0 1-.071-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M15.661 11.464a.342.342 0 1 0 0 .685.341.341 0 1 0 0-.684zm0 .842a.501.501 0 0 1-.502-.5.5.5 0 1 1 .502.5z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M15.394 11.348a.07.07 0 0 1 .07-.067c.04 0 .071.03.071.067 0 .037-.032.066-.07.066-.04 0-.071-.03-.071-.066z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M15.878 11.427a.345.345 0 0 0-.346.343c0 .187.155.34.346.34a.346.346 0 0 0 .352-.34.348.348 0 0 0-.352-.343zm0 .841a.5.5 0 1 1 .503-.498.501.501 0 0 1-.503.498z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M15.61 11.351c0-.037.033-.067.072-.067.038 0 .07.03.07.067a.069.069 0 0 1-.07.067c-.04 0-.071-.03-.071-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M16.1 11.43a.347.347 0 0 0-.35.341c0 .192.154.343.35.343a.345.345 0 0 0 .347-.343.35.35 0 0 0-.346-.342zm0 .841a.502.502 0 0 1-.502-.5c0-.276.226-.5.503-.5a.5.5 0 1 1 0 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M15.837 11.39c0-.038.031-.067.07-.067.04 0 .071.03.071.066a.068.068 0 0 1-.07.067.069.069 0 0 1-.071-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M16.321 11.469a.341.341 0 1 0 0 .683.344.344 0 0 0 .352-.344.346.346 0 0 0-.352-.34zm0 .841a.5.5 0 1 1 .005-1 .5.5 0 0 1-.005 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.046 11.462c0-.037.031-.067.07-.067.04 0 .071.03.071.067a.07.07 0 0 1-.07.067c-.04 0-.07-.03-.07-.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M16.532 11.54a.345.345 0 0 0-.347.342c0 .189.156.342.347.342.193 0 .35-.153.35-.342a.347.347 0 0 0-.35-.342zm0 .842a.5.5 0 1 1 .003-1 .5.5 0 0 1-.003 1zm-1.983 3.071h.433v-.105h-.09v.06h-.09v-.06h-.074v.06h-.09v-.06h-.09v.105zm.329.13h.104v-.1h-.433v.1h.329zm-.21.064h.195v-.041h-.195v.041zm0 .085h.1v-.1h-.1v.1zm.105 0h.1v-.1h-.1v.1zm-.672.08h.418v-.105h-.075v.06h-.089v-.06h-.09v.06h-.089v-.06h-.075v.104zm.91 0h.419v-.105h-.075v.06h-.09v-.06h-.074v.06h-.105v-.06h-.074v.104zm-.343.04h.195v-.1h-.195v.1zm-.238.09h.09v-.1h-.42v.1h.329zm.91 0h.09v-.1h-.418v.1h.328zm-1.134.065h.209v-.044h-.209v.044zm.462-.036h.1v-.1h-.1v.1zm.105 0h.1v-.1h-.1v.1zm.343.036h.21v-.044h-.21v.044zm-.91.083h.1v-.1h-.1v.1zm.119 0h.1v-.1h-.1v.1zm.343 0h.195v-.1h-.195v.1zm.448 0h.1v-.1h-.1v.1zm.12 0h.1v-.1h-.1v.1zm-1.254.12h1.567v-.1h-1.567v.1zm0 .12h.1v-.1h-.1v.1zm.12 0h.417v-.1h-.418v.1zm.447 0h.194v-.1h-.194v.1zm.224 0h.209v-.1h-.209v.1zm.239 0h.418v-.1h-.418v.1zm.448 0h.1v-.1h-.1v.1zm-1.478.118h.194v-.1h-.194v.1zm.224 0h.209v-.1h-.209v.1zm.238 0h.195v-.1h-.195v.1zm.224 0h.195v-.1h-.195v.1zm.225 0h.193v-.1h-.193v.1zm.223 0h.21v-.1h-.21v.1zm.239 0h.194v-.1h-.194v.1zm-1.373.12h.1v-.1h-.1v.1zm.12 0h.193v-.1h-.194v.1zm.223 0h.194v-.1h-.194v.1zm.224 0h.194v-.1h-.194v.1zm.224 0h.209v-.1h-.209v.1zm.239 0h.194v-.1h-.194v.1zm.223 0h.195v-.1h-.195v.1zm.225 0h.1v-.1h-.1v.1zm-1.359.119h.1v-.1h-.1v.1zm.105 0h.209v-.1h-.209v.1zm.238 0h.195v-.1h-.195v.1zm.224 0h.195v-.1h-.195v.1zm.225 0h.193v-.1h-.193v.1zm.223 0h.21v-.1h-.21v.1zm.239 0h.1v-.1h-.1v.1zm-1.254.12h.418v-.1h-.418v.1zm.448 0h.194v-.1h-.194v.1zm.224 0h.209v-.1h-.209v.1zm.239 0h.418v-.1h-.418v.1zm-.91.119h.537v-.1H14.1v.1zm.566 0h.195v-.1h-.195v.1zm.225 0h.537v-.1h-.537v.1zm-.792.12h.642v-.1h-.642v.1zm.672 0h.657v-.1h-.657v.1zm-.672.119h.538v-.1H14.1v.1zm.567 0h.195v-.1h-.195v.1zm.225 0h.537v-.1h-.537v.1zm-.792.124h.194v-.105h-.194v.105zm.224 0h.194v-.105h-.194v.105zm.224 0h.194v-.105h-.194v.105zm.224 0h.209v-.105h-.209v.105zm.239 0h.194v-.105h-.194v.105zm.223 0h.195v-.105h-.195v.105zm-1.134.13h.1v-.1h-.1v.1zm.105 0h.209v-.1h-.209v.1zm.238 0h.195v-.1h-.195v.1zm.224 0h.195v-.1h-.195v.1zm.225 0h.193v-.1h-.193v.1zm.223 0h.21v-.1h-.21v.1zm.239 0h.1v-.1h-.1v.1zm-1.254.119h.194v-.1h-.194v.1zm.224 0h.194v-.1h-.194v.1zm.224 0h.433v-.1h-.433v.1zm.463 0h.194v-.1h-.194v.1zm.223 0h.195v-.1h-.195v.1zm-1.373.109h.1v-.105h-.1v.105zm.12 0h.194v-.105h-.194v.105zm.224 0h.209v-.105h-.209v.105zm.238 0h.642v-.105h-.642v.105zm.672 0h.21v-.105h-.21v.105zm.239 0h.195v-.105h-.195v.105zm.224 0h.1v-.105h-.1v.105zm-1.717.13h.21v-.1h-.21v.1zm.24 0h.193v-.1h-.194v.1zm.223 0h.88v-.1h-.88v.1zm.91 0h.195v-.1h-.195v.1zm.225 0h.208v-.1h-.208v.1zm-1.598.119h.1v-.1h-.1v.1zm.12 0h.194v-.1h-.194v.1zm.224 0h1.12v-.1h-1.12v.1zm1.149 0h.194v-.1h-.194v.1zm.224 0h.1v-.1h-.1v.1zm-1.717.12h.21v-.1h-.21v.1zm.24 0h.193v-.1h-.194v.1zm.223 0h.88v-.1h-.88v.1zm.91 0h.195v-.1h-.195v.1zm.225 0h.208v-.1h-.208v.1zm.238.019h-1.865v-.523h.239v-.925h-.12v-.507h.224v-.135h-.104v-.268h.134v.06h.03v-.06h.149v.06h.03v-.06h.134v.268h-.105v.135h.195v-.493h-.12v-.268h.15v.06h.03v-.06h.133v.06h.031v-.06h.149v.268h-.12v.493h.194v-.135h-.104v-.268h.134v.06h.045v-.06h.134v.06h.03v-.06h.135v.268h-.105v.135h.224v.507h-.12v.925h.24v.523z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M15.071 18.02v-.313c0-.06-.03-.24-.313-.24-.268 0-.298.18-.298.24v.313h.611z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M14.491 18.402h.908v-.514c0-.064-.023-.385-.465-.385-.421 0-.443.321-.443.385v.514zm.954.05h-1v-.564c0-.072.024-.435.489-.435.486 0 .511.363.511.435v.565z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.564 17.721l-.15-.014c0-.06.016-.15.06-.18l.135.105c-.015.015-.045.06-.045.09z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M14.529 18.314l.524.052a.89.89 0 0 1 .157-.31l-.486-.384c-.124.12-.187.399-.195.642zm.643.195l-.772-.077v-.06c0-.296.075-.693.288-.837l.038-.026.674.532-.052.052c-.062.063-.176.24-.176.344v.072z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.967 17.721l.15-.014c0-.06-.016-.15-.06-.18l-.135.105c.015.015.045.06.045.09z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M15.089 18.057a.893.893 0 0 1 .156.31l.525-.053c-.008-.243-.07-.52-.193-.642l-.488.385zm.036.452v-.072c0-.103-.114-.284-.174-.344l-.051-.052.675-.532.038.027c.212.143.287.54.287.837v.058l-.775.078z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.818 17.572l.075-.134a.359.359 0 0 0-.135-.03c-.03 0-.09.015-.12.03l.075.134h.105z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M14.97 18.24h.295l.213-.58a.863.863 0 0 0-.385-.114.846.846 0 0 0-.334.114l.211.58zm.354.153h-.413l-.293-.802.047-.036a.922.922 0 0 1 .428-.162c.163 0 .375.084.478.162l.047.036-.294.802z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.534 17.2v-.33c0-.089-.06-.164-.164-.164-.105 0-.164.075-.164.165v.328h.328z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M14.274 17.635h.834v-.6c0-.143-.129-.287-.417-.287s-.417.144-.417.286v.601zm.917.057h-1v-.658c0-.201.206-.342.5-.342.295 0 .5.14.5.342v.658z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.997 17.2v-.33c0-.089.06-.164.164-.164.104 0 .164.075.164.165v.328h-.328z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M15.065 17.635h.834v-.6c0-.169-.171-.287-.416-.287-.289 0-.418.144-.418.286v.601zm.917.057h-1v-.658c0-.201.206-.342.5-.342.295 0 .5.14.5.342v.658z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M14.878 16.393l.03-.298h-.284l.015.298z"
  }), React__default.createElement("path", {
    d: "M14.75 16.99h.67l.084-.82h-.797l.043.82zm.755.09h-.845l-.052-1h1l-.103 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M15.101 16.393l-.03-.298h.299l-.03.298z"
  }), React__default.createElement("path", {
    d: "M15.235 16.99h.64l.08-.82h-.8l.08.82zm.721.09h-.802l-.099-1h1l-.099 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M14.43 16.393l.014-.298h-.283l.03.298z"
  }), React__default.createElement("path", {
    d: "M14.335 16.99h.668l.043-.82h-.797l.086.82zm.758.09h-.843l-.105-1h1l-.052 1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M14.967 18.02v-.268c0-.045-.03-.18-.209-.18a.181.181 0 0 0-.194.18v.268h.403zm-.463-.851v-.284c0-.074-.044-.149-.134-.149-.09 0-.134.075-.134.15v.283h.268zm.523 0v-.284c0-.074.044-.149.134-.149.09 0 .135.075.135.15v.283h-.269z",
    fill: "#0039F0"
  }), React__default.createElement("path", {
    d: "M15.338 18.503c0-.653.47-1.182 1.05-1.182.58 0 1.05.529 1.05 1.182 0 .652-.47 1.181-1.05 1.181-.58 0-1.05-.529-1.05-1.181z",
    fill: "#AD1519"
  }), React__default.createElement("path", {
    d: "M16.388 17.34c-.568 0-1.03.522-1.03 1.163 0 .64.462 1.161 1.03 1.161.568 0 1.03-.52 1.03-1.161s-.462-1.163-1.03-1.163zm0 2.364c-.59 0-1.07-.54-1.07-1.201 0-.663.48-1.202 1.07-1.202.59 0 1.07.539 1.07 1.202 0 .662-.48 1.2-1.07 1.2z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M15.65 18.5c0-.479.33-.866.738-.866s.739.387.739.866c0 .478-.331.867-.739.867s-.739-.389-.739-.867z",
    fill: "#005BBF"
  }), React__default.createElement("path", {
    d: "M16.388 17.654c-.396 0-.719.38-.719.846 0 .467.323.847.72.847.396 0 .718-.38.718-.847 0-.467-.322-.846-.719-.846zm0 1.733c-.418 0-.758-.398-.758-.887 0-.488.34-.886.758-.886s.758.398.758.886c0 .489-.34.887-.758.887z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.039 17.904s-.087.096-.087.185c0 .09.036.164.036.164a.096.096 0 0 0-.09-.06.094.094 0 0 0-.097.091c0 .014.009.037.015.05l.032.064c.01-.024.035-.037.063-.037.038 0 .07.029.07.065 0 .006 0 .01-.003.016H15.9v.067h.07l-.052.104.069-.027.052.059.054-.059.07.027-.052-.104h.07v-.066l-.08-.001v-.016c0-.036.03-.065.068-.065.028 0 .053.013.063.037l.032-.065a.137.137 0 0 0 .015-.049.094.094 0 0 0-.096-.092.096.096 0 0 0-.091.06s.037-.073.037-.163c0-.09-.09-.185-.09-.185z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M16.183 18.787c.006 0 .012.002.016.005l.089.065.092-.065a.03.03 0 0 1 .024-.004l.085.022-.078-.103a.01.01 0 0 1 .001-.014.026.026 0 0 1 .019-.007h.117v-.058h-.135c-.01 0-.019-.006-.021-.012-.004-.008-.004-.016-.004-.024 0-.055.071-.1.16-.1.05 0 .094.012.123.033l.046-.061a.133.133 0 0 0 .028-.058c0-.059-.076-.106-.17-.106-.065 0-.123.021-.152.057l-.01.014c-.005.007-.017.01-.028.007-.01-.003-.016-.011-.012-.018a.383.383 0 0 0 .072-.21c0-.09-.114-.187-.157-.22-.042.033-.152.13-.152.22a.384.384 0 0 0 .071.21c.004.007 0 .015-.011.018-.011.003-.024 0-.029-.007l-.009-.013c-.028-.036-.087-.058-.153-.058-.094 0-.172.047-.172.106 0 .014.015.04.03.058l.046.061a.21.21 0 0 1 .124-.033c.088 0 .16.045.16.1 0 .01-.001.018-.006.026a.024.024 0 0 1-.02.01h-.136v.058h.119c.007 0 .014.003.018.007.004.004.005.01.001.014l-.079.103.085-.022a.033.033 0 0 1 .008 0zm.105.106a.026.026 0 0 1-.017-.005l-.094-.07-.124.033a.031.031 0 0 1-.024-.004c-.006-.004-.007-.01-.003-.016l.088-.116h-.105c-.012 0-.022-.006-.022-.014v-.087c0-.008.01-.015.022-.015h.14v-.007c0-.04-.052-.072-.116-.072-.05 0-.09.015-.107.04-.004.005-.012.008-.02.009-.009 0-.016-.003-.02-.008l-.063-.084c-.011-.014-.034-.048-.034-.071 0-.075.097-.135.216-.135a.32.32 0 0 1 .119.022.365.365 0 0 1-.032-.143c0-.122.172-.247.18-.252a.03.03 0 0 1 .015-.005.03.03 0 0 1 .017.004c.007.006.185.131.185.253a.364.364 0 0 1-.032.143.316.316 0 0 1 .118-.022c.118 0 .214.06.214.135 0 .023-.021.056-.033.071l-.064.084c-.003.005-.01.008-.02.008a.027.027 0 0 1-.02-.009c-.015-.025-.055-.04-.105-.04-.064 0-.115.032-.115.072v.006l.138.001c.012 0 .022.007.022.015v.087c0 .008-.01.014-.022.014h-.104l.087.116c.004.005.003.012-.003.016a.031.031 0 0 1-.024.004l-.124-.032-.098.07a.03.03 0 0 1-.016.004z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M15.9 18.443h.281v.1H15.9z"
  }), React__default.createElement("path", {
    d: "M15.961 19.184h.855v-.504h-.855v.504zm.928.248h-1v-1h1v1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.726 17.904s-.088.096-.088.185c0 .09.037.164.037.164a.096.096 0 0 0-.09-.06.094.094 0 0 0-.098.091c0 .014.01.037.016.05l.031.064c.01-.024.035-.037.064-.037.039 0 .069.029.069.065 0 .006 0 .01-.002.016h-.079v.067h.07l-.052.104.07-.027.052.059.054-.059.069.027-.053-.104h.071v-.066l-.079-.001a.062.062 0 0 1-.002-.016c0-.036.031-.065.07-.065.028 0 .052.013.063.037l.031-.065a.137.137 0 0 0 .016-.049.094.094 0 0 0-.096-.092.098.098 0 0 0-.092.06s.037-.073.037-.163c0-.09-.09-.185-.09-.185z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M16.87 18.787c.006 0 .012.002.016.005l.089.065.091-.065a.03.03 0 0 1 .024-.004l.085.022-.079-.103a.01.01 0 0 1 .001-.014.026.026 0 0 1 .019-.007h.119v-.058H17.1c-.01 0-.02-.005-.022-.012a.066.066 0 0 1-.004-.024c0-.055.071-.1.16-.1a.21.21 0 0 1 .124.033l.046-.061a.133.133 0 0 0 .028-.058c0-.059-.076-.106-.17-.106-.065 0-.126.023-.155.058l-.009.013c-.005.007-.017.01-.028.007-.01-.003-.016-.011-.012-.019a.378.378 0 0 0 .074-.21c0-.09-.114-.186-.158-.22-.042.034-.152.131-.152.22a.385.385 0 0 0 .072.21c.004.008-.001.016-.012.019-.01.003-.023 0-.028-.007l-.009-.013c-.028-.036-.087-.058-.153-.058-.095 0-.172.047-.172.106 0 .014.015.04.029.058l.046.061a.21.21 0 0 1 .124-.033c.09 0 .16.044.16.1a.066.066 0 0 1-.005.024c-.002.007-.01.011-.02.011h-.136v.06h.118c.008 0 .015.002.019.006s.004.01 0 .014l-.078.103.085-.022a.034.034 0 0 1 .008 0zm.104.106a.035.035 0 0 1-.016-.005l-.095-.07-.123.033a.032.032 0 0 1-.025-.004c-.006-.004-.007-.01-.003-.016l.089-.116h-.105c-.012 0-.022-.006-.022-.014v-.087c0-.008.01-.015.022-.015h.139v-.007c0-.04-.05-.072-.116-.072-.05 0-.09.015-.106.04a.025.025 0 0 1-.02.009c-.009 0-.016-.003-.02-.008l-.063-.084c-.014-.016-.034-.05-.034-.071 0-.075.097-.135.216-.135a.31.31 0 0 1 .118.022.367.367 0 0 1-.032-.143c0-.122.173-.247.18-.252a.03.03 0 0 1 .016-.005c.006 0 .012.002.016.004.008.006.186.131.186.253a.361.361 0 0 1-.033.143.315.315 0 0 1 .119-.022c.118 0 .214.06.214.135 0 .023-.022.056-.033.071l-.063.084c-.004.005-.011.008-.02.008-.009 0-.017-.004-.02-.009-.016-.025-.056-.04-.106-.04-.064 0-.116.032-.116.072v.006l.139.001c.012 0 .022.007.022.015v.087c0 .008-.01.014-.022.014h-.106l.09.116a.012.012 0 0 1-.004.016.032.032 0 0 1-.025.004l-.124-.032-.098.07a.03.03 0 0 1-.016.004z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M16.586 18.443h.281v.1h-.28z"
  }), React__default.createElement("path", {
    d: "M16.648 19.184h.854v-.504h-.854v.504zm.927.248h-1v-1h1v1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M16.383 18.494s-.088.096-.088.186c0 .089.037.163.037.163a.097.097 0 0 0-.092-.06.094.094 0 0 0-.096.091c0 .015.009.038.016.05l.03.064c.012-.024.036-.037.065-.037.038 0 .069.029.069.066 0 .005 0 .01-.003.016h-.078v.067h.07l-.052.104.07-.028.052.06.054-.06.069.028-.053-.104h.071v-.067h-.079a.067.067 0 0 1 .067-.082c.029 0 .053.013.064.037l.031-.064a.135.135 0 0 0 .016-.05c0-.05-.044-.092-.097-.092a.097.097 0 0 0-.09.061s.036-.074.036-.163c0-.09-.09-.186-.09-.186z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M16.527 19.378c.006 0 .012.002.016.005l.089.065.092-.066a.032.032 0 0 1 .024-.003l.083.021-.079-.101c-.003-.005-.003-.01 0-.014a.027.027 0 0 1 .02-.007h.12v-.06h-.136c-.01 0-.019-.004-.021-.01a.066.066 0 0 1-.005-.025c0-.057.07-.1.16-.1.05 0 .094.012.123.033l.047-.06c.014-.019.029-.045.029-.06 0-.059-.077-.106-.172-.106-.065 0-.125.024-.154.06l-.007.011c-.006.007-.018.01-.029.007-.01-.003-.016-.011-.012-.018a.381.381 0 0 0 .071-.21c0-.089-.112-.186-.155-.22-.043.034-.153.131-.153.22a.382.382 0 0 0 .072.21c.004.007-.001.015-.012.018-.01.003-.023 0-.028-.007l-.01-.014c-.028-.034-.088-.057-.152-.057-.095 0-.172.047-.172.106 0 .015.015.04.03.059l.045.061a.213.213 0 0 1 .125-.034c.088 0 .16.045.16.1 0 .01-.002.02-.007.027-.003.006-.011.01-.02.01h-.134v.059h.119c.007 0 .014.002.018.007.004.004.005.01.001.014l-.078.102.084-.022.008-.001zm.104.106a.028.028 0 0 1-.016-.005l-.094-.07-.124.032a.031.031 0 0 1-.024-.003c-.006-.005-.008-.011-.003-.017l.088-.114h-.105c-.012 0-.022-.007-.022-.015v-.088c0-.008.01-.014.022-.014h.138v-.007c0-.04-.05-.072-.115-.072-.05 0-.09.015-.108.04-.004.005-.011.008-.02.008-.008 0-.016-.003-.02-.008l-.06-.083c-.017-.02-.035-.05-.035-.072 0-.075.096-.135.215-.135.042 0 .083.008.118.023a.362.362 0 0 1-.032-.143c0-.111.145-.226.176-.25.007-.01.031-.01.04 0 .028.02.18.137.18.25a.366.366 0 0 1-.031.143.309.309 0 0 1 .118-.023c.119 0 .216.06.216.135 0 .027-.029.065-.034.072l-.063.083c-.004.005-.011.008-.02.008-.008 0-.016-.003-.02-.008-.018-.025-.057-.04-.106-.04-.065 0-.116.031-.116.072v.007h.14c.011 0 .021.006.021.014v.088c0 .008-.01.015-.022.015h-.106l.09.114c.004.006.003.012-.003.016a.031.031 0 0 1-.025.004l-.124-.032-.098.07a.03.03 0 0 1-.016.005z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M16.243 19.033h.281v.1h-.281z"
  }), React__default.createElement("path", {
    d: "M16.305 19.775h.854v-.507h-.854v.507zm.927.247h-1v-1h1v1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.484 15.383l-.02.001a.096.096 0 0 1-.016.023c-.017.016-.042.018-.056.005a.032.032 0 0 1-.009-.027.03.03 0 0 1-.032 0c-.017-.01-.021-.033-.01-.052l.008-.011-.002-.02-.022.004-.007.013c-.014.016-.035.02-.045.01a.034.034 0 0 1-.008-.017s-.006.006-.011.007c-.035.009-.049-.068-.05-.087l-.011.016s.01.045.005.084c-.005.038-.019.077-.019.077.048.012.12.052.192.107a.613.613 0 0 1 .151.156s.038-.02.076-.033a.386.386 0 0 1 .088-.013l.015-.014c-.021.004-.103.007-.101-.027 0-.005.004-.012.005-.012 0 0-.014 0-.02-.004-.01-.008-.01-.028.002-.044l.011-.009.001-.022-.022.004-.01.008c-.017.015-.041.016-.055.002a.027.027 0 0 1-.007-.03.039.039 0 0 1-.03-.003c-.016-.01-.02-.034-.006-.052a.082.082 0 0 1 .02-.02l-.005-.02z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M18.207 15.62c.09.031.213.113.334.221.118.106.22.226.268.319a.777.777 0 0 1 .127-.062.45.45 0 0 1 .082-.02c-.03-.005-.06-.015-.077-.036a.062.062 0 0 1-.013-.051.073.073 0 0 1-.018-.007.065.065 0 0 1-.023-.044.116.116 0 0 1 .02-.076l.004-.004.014-.012v-.017l-.015.003a.166.166 0 0 1-.008.007l-.007.006c-.038.039-.092.04-.121.004a.078.078 0 0 1-.02-.054.068.068 0 0 1-.042-.012.08.08 0 0 1-.032-.054.117.117 0 0 1 .015-.08.2.2 0 0 1 .031-.04l-.003-.015h-.014a.23.23 0 0 1-.029.044c-.034.039-.091.043-.12.01a.094.094 0 0 1-.02-.044.061.061 0 0 1-.053-.012.083.083 0 0 1-.033-.052.119.119 0 0 1 .012-.079l.01-.022v-.015l-.017.005-.01.022c-.03.039-.078.05-.103.025a.07.07 0 0 1-.013-.022.043.043 0 0 1-.008.003c-.043.013-.071-.035-.088-.087a.554.554 0 0 1 0 .1c-.007.06-.022.118-.03.147zm.59.587l-.006-.015a1.23 1.23 0 0 0-.268-.323 1.074 1.074 0 0 0-.339-.22l-.016-.005.006-.019s.024-.08.033-.158a.666.666 0 0 0-.01-.17v-.007l.047-.083.003.051c.003.047.026.168.065.168h.006a.03.03 0 0 0 .01-.008l.028-.033v.046c.002.003.006.016.01.02.004.005.01.006.015.006.014 0 .031-.01.044-.026l.014-.031.064-.017.004.072-.005.006a.07.07 0 0 0-.008.016l-.003.004a.08.08 0 0 0-.008.052c.003.014.01.025.02.031.014.011.03.011.044.001l.026-.017-.004.035a.054.054 0 0 0 .012.041c.018.021.056.017.079-.01a.198.198 0 0 0 .026-.04l.003-.012h.01l.047-.004.004.015.01.056-.012.005a.202.202 0 0 0-.028.036.078.078 0 0 0-.01.054.046.046 0 0 0 .018.03c.01.008.025.01.04.005l.027-.007-.009.03a.045.045 0 0 0 .009.044c.02.023.055.02.08-.004a.056.056 0 0 1 .008-.009.096.096 0 0 0 .007-.006l.004-.005.006-.002.057-.01-.002.076-.024.021a.078.078 0 0 0-.014.048.03.03 0 0 0 .009.02.096.096 0 0 0 .021.004h.047l-.034.032-.003.01c0 .007.002.012.006.017.014.017.053.027.105.027a.315.315 0 0 0 .053-.004l.047-.008-.064.072h-.006s-.087.002-.153.026a.779.779 0 0 0-.134.068l-.013.008z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.354 15.448c.008-.013.027-.01.041 0 .015.011.019.029.01.038-.008.011-.026.011-.043-.002-.012-.009-.017-.027-.008-.036z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.417 15.51l-.036-.034c-.007-.005-.008-.016-.005-.022.005-.005.013-.005.02 0l.036.036.036.035c.006.005.01.015.005.02-.005.007-.014.007-.02 0l-.036-.035z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.5 15.512a.08.08 0 0 0-.066.028.124.124 0 0 0-.008.072.137.137 0 0 0 .045.084l.347.321.338.332c.05.044.124.044.153.004.01-.012.013-.026.011-.046a.171.171 0 0 0-.048-.107l-.344-.326-.34-.331a.155.155 0 0 0-.088-.031zm.742.937a.18.18 0 0 1-.116-.049l-.34-.332-.345-.319a.208.208 0 0 1-.065-.126.18.18 0 0 1 .02-.124c.054-.066.15-.065.22-.009l.342.334.347.325a.241.241 0 0 1 .068.153.127.127 0 0 1-.027.096.125.125 0 0 1-.104.05zm-.933-1.004l-.033-.027c-.01-.008-.013-.022-.01-.03.004-.01.015-.011.022-.004l.034.029.034.026c.007.006.011.02.008.03-.003.008-.013.01-.022.003l-.033-.027z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.413 15.46a.085.085 0 0 0-.08.055c-.023.056.002.167.074.231l.313.251.314.26c.062.053.14.038.166-.017.017-.06-.015-.178-.07-.218l-.315-.25-.32-.276a.117.117 0 0 0-.082-.036zm.705.917a.182.182 0 0 1-.114-.046l-.314-.261-.313-.248c-.099-.088-.14-.245-.096-.35.045-.104.164-.126.245-.05l.318.275.314.25c.086.058.124.229.097.33-.029.066-.079.1-.137.1zm-.883-1.001c.009-.01.029-.01.043 0 .015.012.018.03.01.04-.01.009-.028.009-.042-.002-.015-.01-.018-.027-.011-.038z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.27 15.427a.042.042 0 0 1-.027-.01c-.017-.012-.02-.032-.012-.044.01-.013.034-.012.05 0 .01.007.015.017.016.027a.026.026 0 0 1-.006.019.032.032 0 0 1-.022.008zm.246.143c.01-.01.006-.025-.01-.037-.014-.012-.034-.012-.043 0-.007.008-.003.026.012.038.014.01.032.01.041 0z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.525 15.603l.032.033c.008.007.02.01.027.004.005-.006.005-.017-.002-.025l-.03-.032-.033-.032c-.007-.008-.02-.01-.027-.005-.007.005-.005.018.002.025l.03.032z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.648 15.612a.099.099 0 0 0-.06.018l-.007.006a.06.06 0 0 0-.025.046.169.169 0 0 0 .048.13l.287.298.298.297c.065.061.153.083.203.04a.124.124 0 0 0 .025-.075.157.157 0 0 0-.04-.102l-.287-.299-.302-.3a.213.213 0 0 0-.14-.059zm.68.93a.282.282 0 0 1-.186-.082l-.3-.3-.288-.3a.238.238 0 0 1-.067-.186.139.139 0 0 1 .058-.096c.064-.064.213-.038.29.043l.3.298.288.3c.04.04.063.098.063.153 0 .05-.017.096-.05.128a.162.162 0 0 1-.109.042z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.614 15.666c.009-.011.005-.027-.009-.038-.015-.013-.032-.013-.041-.001-.01.01-.006.026.009.04.014.008.032.01.041 0z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M18.415 15.232h-.06l-.012.086.006.014.015-.001.079-.05z"
  }), React__default.createElement("path", {
    d: "M18.543 15.994l.01.02.017-.001.496-.333-.137-.252-.312.005-.074.56zm-.12.229l-.089-.199.102-.79.614-.011.284.523-.697.465-.214.012z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M18.285 15.274l-.002.058.086.013.014-.007-.002-.017-.05-.076z"
  }), React__default.createElement("path", {
    d: "M18.474 15.936l.568.08.023-.01-.002-.02-.331-.48-.249.147-.009.283zm.598.298l-.797-.112.02-.598.492-.29.46.67.028.23-.203.1z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M18.437 15.36l-.045.03-.05-.077-.002-.016.013-.007.087.012z"
  }), React__default.createElement("path", {
    d: "M18.535 15.523l.334.483.244-.15.015-.281-.575-.076-.019.008.001.016zm.284.759l-.473-.681-.015-.233.194-.086.806.105-.031.597-.481.298z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.335 15.305a.049.049 0 0 1 .068-.016.047.047 0 0 1 .018.066.05.05 0 0 1-.068.017.048.048 0 0 1-.018-.067z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M18.37 15.372a.05.05 0 0 1-.043-.076.05.05 0 0 1 .068-.016c.01.005.019.015.022.028a.051.051 0 0 1-.005.04.05.05 0 0 1-.042.024z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.213 15.252c-.002 0-.013-.038-.025-.058-.009-.016-.038-.036-.038-.036.002-.004.04-.015.084.008.037.025-.003.071-.003.071s-.008.011-.018.015z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M18.461 15.32a.774.774 0 0 1 .189.22c.06.101.114.257.152.366l.015-.02c.005-.006.254-.318.042-.471a.703.703 0 0 0-.398-.094zm.295.824c-.08 0-.094-.044-.138-.175-.035-.102-.088-.257-.144-.353-.042-.084-.185-.204-.268-.262l-.067-.048.043-.066c.044-.066.196-.096.318-.096.113 0 .284.022.473.13.294.212.132.558.006.712a.47.47 0 0 1-.184.151l-.039.007z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M18.287 15.275l-.038.042-.062-.067.005-.009.003-.017.084-.007z"
  }), React__default.createElement("path", {
    d: "M18.424 15.555l.355.366.198-.204-.041-.28-.496.043-.016.075zm.355.653l-.603-.625.079-.123.03-.182.805-.07.086.59-.397.41z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.195 15.251c.009-.026.032-.041.05-.036.02.008.027.033.018.06-.01.027-.032.042-.052.036-.02-.007-.028-.032-.016-.06z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M18.217 15.305l-.012-.001a.042.042 0 0 1-.027-.02.047.047 0 0 1 .002-.044c.009-.024.038-.04.062-.034.028.01.038.036.027.063a.057.057 0 0 1-.052.036z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M18.562 15.324l-.057-.005-.025.084.005.015h.015l.08-.04z"
  }), React__default.createElement("path", {
    d: "M18.682 16.1l.023.002.524-.27-.093-.27-.303-.034-.157.557.006.016zm.063.21l-.206-.014-.067-.207.217-.78.59.06.193.566-.727.375z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M18.43 15.347l-.01.056.086.023.014-.004v-.014l-.04-.082z"
  }), React__default.createElement("path", {
    d: "M18.636 15.952l.556.151.023-.01-.266-.522-.264.107-.05.274zm.556.364l-.78-.212.103-.577.522-.211.374.732-.015.212-.204.056z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M18.568 15.455l-.051.02-.04-.08.001-.016.014-.003.085.024z"
  }), React__default.createElement("path", {
    d: "M18.667 15.594l.261.516.267-.106.048-.268-.557-.155-.02.013zm.17.773l-.369-.726.013-.224.21-.05.777.218-.1.57-.53.212z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.476 15.384a.05.05 0 0 1 .07-.007.048.048 0 0 1 .008.07c-.018.02-.048.022-.071.006a.048.048 0 0 1-.007-.069z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M18.507 15.458a.055.055 0 0 1-.031-.01.05.05 0 0 1-.02-.034.053.053 0 0 1 .012-.039.051.051 0 0 1 .068-.007.05.05 0 0 1 .02.032.053.053 0 0 1-.01.04.049.049 0 0 1-.04.018z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M18.691 15.446l.01.056-.083.03-.015-.004-.001-.013.034-.083z"
  }), React__default.createElement("path", {
    d: "M18.794 16.206l.02.004.552-.194-.055-.281-.291-.074-.227.536v.009zm.029.217l-.216-.056-.014-.206.314-.738.572.142.114.586-.77.272z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M18.68 15.575l-.054.013-.03-.083.004-.015.014-.002.082.035z"
  }), React__default.createElement("path", {
    d: "M18.79 15.711l.193.53.281-.069.082-.262-.528-.224-.022.003-.005.022zm.071.768l-.274-.758.055-.215.204-.027.741.315-.172.549-.554.136z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M18.56 15.45l-.018.052.082.034.015-.002.003-.014-.028-.084z"
  }), React__default.createElement("path", {
    d: "M18.775 15.996l.527.222.029-.015-.185-.536-.284.07-.087.259zm.501.43l-.744-.313.183-.55.556-.137.26.762-.04.212-.215.026z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.668 15.563c.02-.02.02-.05.003-.071a.056.056 0 0 0-.071-.004c-.02.02-.022.052-.002.071a.05.05 0 0 0 .07.004z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M18.626 15.568a.049.049 0 0 1-.037-.016.049.049 0 0 1-.014-.034c0-.014.006-.027.016-.037a.053.053 0 0 1 .071.002.052.052 0 0 1-.002.072.049.049 0 0 1-.034.013z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.704 15.649c0 .001.037.003.058.01a.137.137 0 0 1 .038.031c.005-.005.01-.048-.02-.09-.03-.032-.065.025-.065.025s-.01.013-.011.024z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M18.921 16.04c.11.013.256.031.362.061a.767.767 0 0 1 .25.158.791.791 0 0 0-.173-.41.155.155 0 0 0-.11-.044c-.133 0-.278.165-.323.228l-.006.008zm.666.542l-.048-.048c-.05-.053-.202-.191-.288-.215a2.864 2.864 0 0 0-.398-.06c-.099-.011-.158-.018-.158-.124l.004-.034a.694.694 0 0 1 .114-.225c.007-.01.21-.294.437-.294.077 0 .148.033.211.095.226.289.239.558.234.66-.002.055-.014.15-.06.199l-.048.046z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#C8B100",
    d: "M18.68 15.567l-.03.046.078.05.009-.007.013-.004-.012-.088z"
  }), React__default.createElement("path", {
    d: "M18.912 16.01l.439.294.066-.036-.069-.503-.29.019-.146.227zm.457.545l-.73-.488.304-.476.578-.036.118.854-.162.05-.108.096z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M18.753 15.68c.025-.011.038-.039.027-.055s-.04-.018-.065-.003c-.025.014-.036.04-.025.055.008.017.038.019.063.004z",
    fill: "#C8B100"
  }), React__default.createElement("path", {
    d: "M18.715 15.697a.036.036 0 0 1-.034-.02.044.044 0 0 1-.003-.032.062.062 0 0 1 .028-.038c.022-.016.053-.013.065.01a.037.037 0 0 1 .004.03.062.062 0 0 1-.028.04.059.059 0 0 1-.032.01zm2.495-.804h.788v-.084h-.345v-.479h.215v-.084h-.215v-.173h-.11v.173h-.219v.084h.22v.479h-.334v.084zm.894.09h-1v-.264h.333v-.299h-.219v-.264h.219v-.173h.322v.173h.215v.264h-.215v.3h.345v.263zm-10.526-.006h-.003v-.1h.003zm-.021 0h-.006v-.1h.006zm-.007.9h-.071v-1h.072v1zm.6 0h-.073v-1h.074v1z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M11.498 14.977h-.008v-.1h.008z"
  }), React__default.createElement("path", {
    d: "M11.441 15.862l-.017-.948h.105l.02.948h-.108zm.585.016h-.109v-1h.11v1z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M11.437 14.98l-.002-.1h.012l.002.1zm-.142.018l-.002-.1h.022l.002.1zm1.05.864h-.02l.02-.977h.017l-.017.977zm-.76.015h-.018v-1h.018v1zm9.638-.898h-.004v-.1h.004zm-.022 0h-.005v-.1h.005zm-.005.9h-.072v-1h.072v1zm.583 0h-.07v-1h.07v1z"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M21.143 14.979h-.009v-.1h.009z"
  }), React__default.createElement("path", {
    d: "M21.086 15.863l-.018-.95h.107l.017.95h-.106zm.575.017h-.106v-1h.106v1z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M21.081 14.982l-.001-.1h.012l.002.1zM20.94 15l-.001-.1h.021l.002.099zm.306-.021h-.002v-.1h.002z"
  })));
},
    _extends$75 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$75(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var FI = function FI(e) {
  e.styles;

  var t = _objectWithoutProperties$75(e, ["styles"]);

  return React__default.createElement("svg", _extends$75({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#FFF",
    d: "M.84 12.273h14.963V.169H.84zm23.872 0H54.84V.169H24.712zM.84 33.505h14.963V21.476H.84zm23.872 0H54.84V21.476H24.712z"
  }), React__default.createElement("path", {
    fill: "#04357F",
    d: "M15.803.169v12.104H.84v9.204h14.963v12.028h8.91V21.477H54.84v-9.204H24.712V.169z"
  })));
},
    _extends$76 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$76(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var FR = function FR(e) {
  e.styles;

  var t = _objectWithoutProperties$76(e, ["styles"]);

  return React__default.createElement("svg", _extends$76({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 35"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#062493",
    d: "M.81 34.064h18.022V.771H.81z"
  }), React__default.createElement("path", {
    fill: "#EC2938",
    d: "M37.189 34.063h18.414V.77H37.189z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M18.832 34.064h18.356V.771H18.832z"
  })));
},
    _extends$77 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$77(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var GB = function GB(e) {
  e.styles;

  var t = _objectWithoutProperties$77(e, ["styles"]);

  return React__default.createElement("svg", _extends$77({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#04247B",
    d: "M.56 33.681h54.387V.415H.56z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M48.808.387L32.242 10.588.56 29.995v3.686h6.142L54.947 4.1V.415l-.985-.027z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M54.947 29.995L6.838.415H.56V4.21l48.337 29.47h6.05z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M54.947 22.62H.56V11.474l54.387.056z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M23.244.415l.001 33.266h9.064L32.264.415z"
  }), React__default.createElement("path", {
    fill: "#CE142A",
    d: "M54.947 13.75H.56v6.598l54.387.054zM50.892.387L32.67 11.511h4.172L54.947.414l-.986-.027z"
  }), React__default.createElement("path", {
    fill: "#CE142A",
    d: "M30.45.415l-.044 33.266h-5.393L25.058.415zM.56.415l18.062 11.079-4.034-.004L.56 2.826zm0 33.266L18.622 22.62h3.942L4.662 33.681zM36.977 22.62l17.97 11.061v-2.523L40.92 22.62z"
  })));
},
    _extends$78 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$78(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var GR = function GR(e) {
  e.styles;

  var t = _objectWithoutProperties$78(e, ["styles"]);

  return React__default.createElement("svg", _extends$78({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#115EAD",
    d: "M20.997 11.4H55.54V7.671H20.997zM.952 26.183h54.587V22.58H.952zM20.997 3.946H55.54V.317H20.997zm0 14.782H55.54v-3.603H20.997zM.952 33.721h54.587v-3.685H.952z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M20.997 7.671H55.54V3.946H20.997zm0 7.455H55.54V11.4H20.997zM.952 22.581h54.587v-3.853H.952zm0 7.454h54.587v-3.852H.952z"
  }), React__default.createElement("path", {
    fill: "#115EAD",
    d: "M.952 18.728h8.853v-7.241H.952zm13.278 0h8.848v-7.241H14.23zM.952 7.649h8.853V.316H.952zm13.278 0h8.848V.316H14.23z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M14.23.316H9.804V7.65H.952v3.838h8.852v7.241h4.426v-7.24h8.848V7.648H14.23z"
  })));
},
    _extends$79 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$79(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var HK = function HK(e) {
  e.styles;

  var t = _objectWithoutProperties$79(e, ["styles"]);

  return React__default.createElement("svg", _extends$79({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#DE2910",
    d: "M.915 33.489h53.946V.038H.915z"
  }), React__default.createElement("path", {
    d: "M27.568 11.241l-.388.55-.118-.661-.607-.124.53-.296v-.637l.482.446.606-.266-.32.595.489.472-.674-.079zm2.832-4.22c-1.181-.158-3.843.266-5.192 2.368-1.35 2.103-1.568 5.399 2.293 7.202 0 0-2.698-1.709-.928-5.006 0 0 .05-.093.169.017 0 0-1.872 2.903.876 4.91 0 0-1.424-1.435.338-3.074.4-.374 1.247-.345 1.753-1.522.505-1.176.32-1.821-.27-2.746-.202-.408-.354-1.443.96-2.149z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M33.89 14.816l-.33.58-.128-.624-.68-.172.636-.308-.059-.577.468.377.65-.196-.309.564.46.454-.708-.098zm.705-2.704c-2.566-.544-6 .281-6.65 4.256 0 0 .913-2.918 4.826-2.369 0 0 .113.015.037.154 0 0-3.545-.758-4.747 2.295 0 0 1.026-1.705 3.247-.653.504.24.738.997 2.097 1.08 1.36.086 1.96-.28 2.722-1.088.354-.304 1.366-.757 2.493.186-.204-1.092-1.46-3.318-4.025-3.86z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M32.167 21.59l-.324.548-.116-.658-.693-.114.595-.304-.032-.657.511.469.571-.23-.242.53.401.517-.67-.101zm-3.857-4.897s3.263-.09 3.907 3.545c0 0 .02.104-.147.08 0 0-.314-3.372-3.805-3.498 0 0 2.058.385 1.666 2.674-.09.523-.793.96-.46 2.19.332 1.229.888 1.65 1.95 2.076.42.22 1.197.976.577 2.267 1.054-.52 2.944-2.316 2.71-4.755-.234-2.44-2.134-5.226-6.398-4.58z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M24.777 22.15l-.403.512-.104-.624-.66-.118.637-.305-.096-.649.495.433.661-.23-.322.597.41.433-.618-.05zm3.314-5.033s1.094 2.86-2.424 4.55c0 0-.1.046-.126-.106 0 0 3.351-1.316 2.405-4.446 0 0 .241 1.94-2.22 2.297-.56.082-1.227-.407-2.382.267-1.154.672-1.41 1.293-1.522 2.366-.095.441-.629 1.358-2.138 1.207.853.774 3.272 1.895 5.693.938 2.422-.958 4.69-3.496 2.714-7.073z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M21.558 16.294l-.145-.561-.651-.192.604-.292-.091-.618.514.465.63-.291-.284.575.445.509-.71-.094-.312.499zm.63.07s-.081-.072.067-.143c0 0 2.407 2.538 5.295.707 0 0-1.901.829-3.048-1.23-.26-.466.024-1.21-1.028-2.014-1.053-.807-1.768-.835-2.894-.592-.48.056-1.586-.122-1.911-1.502-.518 1-.89 3.49.856 5.322 1.746 1.833 5.054 3.024 8.07.144 0 0-2.567 1.876-5.407-.691z",
    fill: "#FFF"
  })));
},
    _extends$80 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$80(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var HU = function HU(e) {
  e.styles;

  var t = _objectWithoutProperties$80(e, ["styles"]);

  return React__default.createElement("svg", _extends$80({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54 35"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#CD1225",
    d: "M0 11.746h53.892V.784H0z"
  }), React__default.createElement("path", {
    fill: "#008651",
    d: "M0 34.259h53.892V22.962H0z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M0 22.961h53.892V11.746H0z"
  })));
},
    _extends$81 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$81(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var ID = function ID(e) {
  e.styles;

  var t = _objectWithoutProperties$81(e, ["styles"]);

  return React__default.createElement("svg", _extends$81({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#CD1225",
    d: "M.894 17.01h54.239V.463H.894z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M.894 33.485h54.239V17.01H.894z"
  })));
},
    _extends$82 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$82(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var IE = function IE(e) {
  e.styles;

  var t = _objectWithoutProperties$82(e, ["styles"]);

  return React__default.createElement("svg", _extends$82({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 35"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#009A49",
    d: "M.56 34.135h18.127V.783H.56z"
  }), React__default.createElement("path", {
    fill: "#FF780A",
    d: "M36.743 34.136h18.204V.784H36.743z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M18.687 34.135h18.056V.783H18.687z"
  })));
},
    _extends$83 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$83(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var IN = function IN(e) {
  e.styles;

  var t = _objectWithoutProperties$83(e, ["styles"]);

  return React__default.createElement("svg", _extends$83({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#FE9836",
    d: "M.61 10.978h53.669V0H.61z"
  }), React__default.createElement("path", {
    fill: "#0D8710",
    d: "M.61 33.285h53.669V22.158H.61z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M.61 22.158h53.669V10.979H.61z"
  }), React__default.createElement("path", {
    d: "M27.722 16.466c0 .453-.363.82-.81.82a.815.815 0 0 1-.81-.82c0-.453.363-.767.81-.767.447 0 .81.314.81.767",
    fill: "#060486"
  }), React__default.createElement("path", {
    fill: "#060486",
    d: "M26.88 15.779l-.112-.912.136-2.452.138 2.452-.104.912zm.181.015l.126-.91.758-2.334-.492 2.406-.334.854zm.175.064l.354-.845 1.333-2.053-1.094 2.191-.541.737zm.155.109l.563-.72 1.82-1.622-1.627 1.82-.715.565zm.117.145l.73-.548 2.172-1.091-2.039 1.332-.833.358zm.078.165l.841-.343 2.375-.496-2.306.764-.896.132zm.032.186l.9-.107 2.42.151-2.421.126-.901-.11zm-.017.182l.898.128 2.303.77-2.373-.502-.843-.338zm-.065.181l.833.364 2.02 1.36-2.158-1.12-.723-.553zm-.106.152l.71.571 1.6 1.846-1.795-1.649-.558-.726zm-.14.118l.544.735 1.085 2.197-1.322-2.058-.359-.845zm-.168.078l.34.853.486 2.406-.753-2.334-.128-.91zm-.18.032l.108.913-.142 2.451-.131-2.453.105-.91zm-.182-.016l-.13.91-.765 2.33.5-2.403.338-.852zm-.176-.063l-.355.845-1.334 2.05 1.098-2.19.541-.735zm-.149-.107l-.56.722-1.812 1.632 1.618-1.828.713-.568zm-.119-.143l-.724.552-2.17 1.101 2.034-1.342.832-.362zm-.078-.169l-.841.344-2.375.496 2.304-.765.898-.133zm-.031-.183l-.9.11-2.421-.142 2.42-.135.901.107zm.015-.185l-.897-.13-2.304-.772 2.375.504.841.34zm.063-.177l-.834-.36-2.027-1.348 2.163 1.11.728.548zm.106-.153l-.716-.565-1.612-1.834 1.807 1.638.562.72zm.141-.12l-.548-.733-1.09-2.194 1.328 2.056.36.842zm.165-.078l-.34-.852-.492-2.405.758 2.332.132.91z"
  }), React__default.createElement("path", {
    d: "M26.912 20.588c-2.262 0-4.041-1.82-4.041-4.13 0-2.31 1.779-4.024 4.04-4.024 2.26 0 4.04 1.715 4.04 4.025 0 2.31-1.78 4.129-4.04 4.129m.027-8.801c-2.552 0-4.672 2.113-4.672 4.719 0 2.606 2.12 4.719 4.672 4.719 2.552 0 4.62-2.113 4.62-4.72 0-2.605-2.068-4.718-4.62-4.718",
    fill: "#060486"
  }), React__default.createElement("path", {
    d: "M28.687 20.29a.214.214 0 1 1-.428-.003.214.214 0 0 1 .428.002m-1.03.291a.215.215 0 0 1-.215.213.212.212 0 0 1-.212-.213.213.213 0 1 1 .427 0m-1.067 0a.213.213 0 0 1-.426 0 .212.212 0 1 1 .425 0m-1.036-.283a.212.212 0 1 1-.424 0 .211.211 0 1 1 .424 0m-.904-.532a.213.213 0 1 1-.426 0 .213.213 0 0 1 .426 0m-.747-.759a.215.215 0 0 1-.215.215.214.214 0 1 1 .215-.215m-.818-3.046a.214.214 0 1 1-.427 0 .214.214 0 0 1 .427 0m.275-1.05a.213.213 0 1 1-.426 0 .213.213 0 1 1 .426 0m.531-.94a.215.215 0 0 1-.214.214.214.214 0 1 1 .214-.214m.747-.755a.213.213 0 0 1-.214.212.213.213 0 1 1 0-.426c.117 0 .214.095.214.214m.925-.533a.212.212 0 0 1-.212.213.214.214 0 0 1 0-.428c.118 0 .212.097.212.215m1.016-.27a.213.213 0 1 1-.426 0 .213.213 0 1 1 .426 0m1.072 0a.212.212 0 0 1-.211.214.214.214 0 1 1 0-.427c.118 0 .212.095.212.213m1.023.27a.211.211 0 1 1-.424 0c0-.118.094-.215.211-.215.118 0 .213.097.213.215m.914.542a.213.213 0 1 1-.427 0 .214.214 0 1 1 .427 0m.756.764a.214.214 0 0 1-.215.214.212.212 0 0 1-.21-.214c0-.118.093-.214.21-.214.12 0 .215.096.215.214m.538.922a.213.213 0 1 1-.425 0c0-.119.095-.215.211-.215.12 0 .214.096.214.215m.272 1.043a.214.214 0 0 1-.428 0c0-.119.097-.213.214-.213.117 0 .214.094.214.213m0 1.076a.215.215 0 0 1-.214.214.213.213 0 1 1 0-.427c.117 0 .214.094.214.213m-.263 1.044a.214.214 0 0 1-.213.215.214.214 0 0 1 0-.428c.117 0 .213.095.213.213m-.531.93a.213.213 0 1 1-.426 0c0-.118.096-.215.214-.215.116 0 .212.097.212.215m-.752.762a.214.214 0 1 1-.427 0 .214.214 0 0 1 .427 0",
    fill: "#060486"
  })));
},
    _extends$84 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$84(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var IT = function IT(e) {
  e.styles;

  var t = _objectWithoutProperties$84(e, ["styles"]);

  return React__default.createElement("svg", _extends$84({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 35"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#CD2B36",
    d: "M36.553 34.21h17.963V.778H36.553z"
  }), React__default.createElement("path", {
    fill: "#009147",
    d: "M.894 34.21h17.829V.778H.894z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M18.723 34.21h17.83V.778h-17.83z"
  })));
},
    _extends$85 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$85(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var JP = function JP(e) {
  e.styles;

  var t = _objectWithoutProperties$85(e, ["styles"]);

  return React__default.createElement("svg", _extends$85({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#FFF",
    d: "M.809 33.266h54.484V.342H.809z"
  }), React__default.createElement("path", {
    d: "M36.971 16.773c0 5.459-4.139 9.883-9.246 9.883-5.108 0-9.248-4.424-9.248-9.883 0-5.46 4.14-9.884 9.248-9.884 5.107 0 9.246 4.425 9.246 9.884",
    fill: "#E20B17"
  })));
},
    _extends$86 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$86(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var KR = function KR(e) {
  e.styles;

  var t = _objectWithoutProperties$86(e, ["styles"]);

  return React__default.createElement("svg", _extends$86({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 35"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#FFF",
    d: "M.903 34.18h53.562V.549H.903z"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M35.34 6.878l1.07-.756 2.04 3.175-1.09.76zm2.356 3.809l2.042 3.154 1.07-.756-1.962-3.2zm-.712-4.986l4.419 6.983 1.09-.757-4.418-7.025zm1.704-1.219L40.67 7.72l1.089-.779-2.041-3.195zm2.358 3.868l1.983 3.135 1.108-.779-2.02-3.153zm-.213 13.305l-2.007 3.17-1.084-.773 1.976-3.186zm1.621 1.135l-2.006 3.172-1.085-.774 1.976-3.186zm1.666 1.184l-2.01 3.17-1.084-.772 1.978-3.186zm-2.366 3.802l-2.006 3.17-1.085-.772 1.978-3.188zm-1.65-1.183l-2.007 3.17-1.084-.772 1.979-3.189zm-1.649-1.167l-2.005 3.17-1.088-.773 1.98-3.186zm-22.89-4.56l4.386 6.989-1.101.771-4.384-6.971zm-3.315 2.335l4.385 6.988-1.1.773-4.385-6.974zm2.974 3.407l1.977 3.171 1.07-.757-1.992-3.187zm-2.364-3.803l1.978 3.172 1.069-.758-1.99-3.186zm7.076-15.917l-4.4 6.959-1.055-.742 4.354-7.02zM18.3 5.69l-4.399 6.958-1.055-.743L17.2 4.887zm-1.665-1.166l-4.398 6.956-1.057-.74 4.355-7.02z"
  }), React__default.createElement("path", {
    d: "M34.413 17.57c-1.13-1.972-3.51-2.572-5.173-1.688-1.916.994-1.916 3.407-4.921 3.344-2.26-.055-4.534-1.968-3.796-5.622a8.69 8.69 0 0 0-.82 3.708c0 4.647 3.6 8.413 7.966 8.413 3.034 0 5.665-1.816 6.991-4.48.252-1.002.43-2.491-.246-3.674",
    fill: "#033477"
  }), React__default.createElement("path", {
    d: "M27.668 8.898c-3.115 0-5.84 1.917-7.145 4.705-.738 3.654 1.535 5.567 3.795 5.623 3.005.063 3.005-2.35 4.921-3.345 1.664-.884 4.044-.284 5.174 1.69.677 1.182.498 2.671.247 3.673a8.813 8.813 0 0 0 .916-3.932c0-4.647-3.54-8.414-7.908-8.414",
    fill: "#C50D2F"
  })));
},
    _extends$87 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$87(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var MX = function MX(e) {
  e.styles;

  var t = _objectWithoutProperties$87(e, ["styles"]);

  return React__default.createElement("svg", _extends$87({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 33"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#008248",
    d: "M.036.018h18.321v32.964H.036z"
  }), React__default.createElement("path", {
    fill: "#EEE",
    d: "M18.357.018h18.321v32.964H18.357z"
  }), React__default.createElement("path", {
    fill: "#EC1C2E",
    d: "M36.679.018H55v32.964H36.679z"
  }), React__default.createElement("path", {
    d: "M26.48 19.613c-.59.163-.846-.307-.937-.647-.066.307-.059.477-.295.412-.236-.066-.962-.392-1.139-.458-.177-.065-.216.092.072.242s.557.32.563.425c.006.104-.249.235-.34.28.432 0 .913.09 1.067.125.288.065.307.261-.164.575 1.198-.13 1.153.45 1.761.444.446-.004.937.001 1.14-.006.55-.02.144-.242.674-.373.372-.091.747-.222 1.035-.313-.295-.066-.459-.137-.459-.203 0-.065.59-.287.87-.405a1.21 1.21 0 0 0-.634.013 3.981 3.981 0 0 1-1.434.085c-.622-.072-1.31.04-1.78-.196z",
    fill: "#0099D8"
  }), React__default.createElement("path", {
    d: "M25.634 20.534c.487 0 .708.146.905.275.153.101.286.189.52.189h.01c.197-.003.407-.003.592-.003.233 0 .434 0 .546-.004.276-.01.303-.07.336-.144.033-.073.073-.163.336-.228.289-.071.576-.165.83-.248l.156-.05c-.279-.066-.42-.135-.42-.205 0-.053.21-.147.684-.338l.159-.065a1.005 1.005 0 0 0-.231-.024c-.119 0-.24.016-.36.048a3.757 3.757 0 0 1-.945.114c-.164 0-.33-.01-.494-.029a6.555 6.555 0 0 0-.653-.03c-.42-.006-.816-.012-1.127-.165a.872.872 0 0 1-.228.033c-.445 0-.634-.411-.705-.638a8.416 8.416 0 0 0-.012.064c-.037.192-.062.319-.198.319a.34.34 0 0 1-.09-.015c-.155-.042-.515-.195-.804-.318a10.835 10.835 0 0 0-.337-.14.202.202 0 0 0-.069-.014c-.016 0-.044.004-.05.027-.01.043.049.124.202.205.373.194.565.34.57.436.005.073-.092.16-.298.268.398.007.833.083 1.015.124.126.029.2.083.214.156.02.11-.09.248-.329.414.097-.01.19-.014.275-.014zm1.424.49c-.24 0-.384-.093-.534-.192-.193-.127-.412-.27-.89-.27-.1 0-.21.006-.325.018l-.01-.025c.323-.214.375-.344.362-.416-.015-.078-.113-.116-.193-.134a5.522 5.522 0 0 0-1.065-.124l-.006-.026c.296-.147.336-.23.334-.268-.006-.082-.203-.229-.556-.413-.18-.094-.229-.185-.216-.235.012-.048.074-.062.155-.032.061.023.19.077.338.14.288.123.647.275.8.317.187.052.21-.052.254-.283a7.57 7.57 0 0 1 .024-.118h.026c.055.2.23.67.694.67a.855.855 0 0 0 .226-.033l.005-.002.004.002c.307.153.702.159 1.12.164.217.003.442.006.657.031.162.019.327.028.49.028.448 0 .78-.07.939-.112.122-.033.245-.05.366-.05.105 0 .208.014.277.037l.034.011-.034.014-.195.08c-.246.1-.658.266-.667.313 0 .021.032.097.448.189l.049.011-.048.015-.203.066c-.255.083-.543.177-.833.248-.25.062-.285.142-.317.213-.036.08-.067.15-.36.16-.113.004-.314.004-.547.004-.185 0-.394 0-.593.003h-.01z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M28.555 20.717c.085.118.255.095.327-.006a.201.201 0 0 0-.059-.288c.06-.157.092-.523 0-.66a.201.201 0 0 0 .06-.287c-.073-.102-.243-.124-.328-.007-.498-.098-1.604-.072-1.964 0-.086-.117-.256-.095-.328.007a.2.2 0 0 0 .06.287c-.093.137-.06.503 0 .66a.201.201 0 0 0-.06.288c.072.1.242.124.328.006.412.164 1.538.164 1.964 0z",
    fill: "#FDBC11"
  }), React__default.createElement("path", {
    d: "M26.586 20.7l.01.005c.192.076.555.121.972.121.416 0 .784-.045.982-.121l.01-.004.006.008a.175.175 0 0 0 .145.074c.064 0 .125-.03.16-.08a.178.178 0 0 0 .031-.143.194.194 0 0 0-.086-.125l-.01-.006.004-.01c.062-.165.087-.52.002-.648l-.008-.012.012-.007a.194.194 0 0 0 .086-.125.178.178 0 0 0-.03-.144.198.198 0 0 0-.16-.08.176.176 0 0 0-.146.074l-.005.007-.009-.001a5.403 5.403 0 0 0-.944-.064c-.416 0-.824.025-1.015.064l-.008.001-.006-.007a.175.175 0 0 0-.145-.074.198.198 0 0 0-.16.08.18.18 0 0 0-.031.144c.01.051.043.098.086.125l.012.007-.008.012c-.085.128-.06.483.002.647l.004.011-.01.006a.194.194 0 0 0-.086.125.179.179 0 0 0 .031.143c.035.05.097.08.16.08.06 0 .111-.026.145-.074l.007-.008zm.982.154c-.413 0-.775-.045-.973-.12a.201.201 0 0 1-.16.076.226.226 0 0 1-.183-.091.207.207 0 0 1-.036-.165.225.225 0 0 1 .09-.136c-.06-.168-.085-.507-.003-.65a.225.225 0 0 1-.087-.136.207.207 0 0 1 .036-.164.226.226 0 0 1 .182-.092c.065 0 .123.028.162.078.196-.037.6-.062 1.012-.062.396 0 .73.022.94.062a.202.202 0 0 1 .163-.078c.072 0 .142.035.182.092a.206.206 0 0 1 .036.164.225.225 0 0 1-.087.135c.087.152.05.5-.002.65a.225.225 0 0 1 .09.137.206.206 0 0 1-.037.165.225.225 0 0 1-.182.091.201.201 0 0 1-.161-.076c-.203.075-.57.12-.982.12z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M26.602 20.725l-.023-.016c.05-.068.037-.137.002-.176a.097.097 0 0 0-.124-.02l-.014-.023a.124.124 0 0 1 .158.025c.042.047.059.13 0 .21zm-.094-1.011a.13.13 0 0 1-.065-.018l.014-.023a.097.097 0 0 0 .124-.02c.035-.038.048-.108-.002-.176l.023-.016c.058.08.041.163 0 .21a.126.126 0 0 1-.094.043zm2.036 1.011c-.058-.08-.042-.163 0-.21a.124.124 0 0 1 .158-.025l-.013.024a.097.097 0 0 0-.125.02c-.035.038-.047.107.002.175l-.022.016zm.094-1.011a.125.125 0 0 1-.094-.043c-.042-.047-.058-.13 0-.21l.022.016c-.05.068-.037.138-.002.176a.098.098 0 0 0 .125.02l.013.023a.129.129 0 0 1-.064.018zm-.999 1.141c-.24 0-.39-.366-.535-.72-.133-.324-.27-.66-.463-.66l-.01.001-.002-.027h.013c.21 0 .345.328.487.675.142.346.289.704.51.704h.011l.002.027h-.013zm.364-.017c-.245 0-.414-.371-.578-.731-.15-.327-.304-.664-.5-.664h-.013l-.002-.027c.22-.016.376.322.54.68.168.368.34.748.585.712l.004.027a.258.258 0 0 1-.036.003zm.286-.045c-.209 0-.366-.331-.531-.682-.16-.335-.323-.681-.525-.681h-.013l-.002-.027h.015c.22 0 .387.354.55.697.154.328.315.666.508.666l.032-.003.005.026a.21.21 0 0 1-.039.004z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M24.436 19.664c-.264 0-.264.393 0 .393.265 0 .268-.393 0-.393z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M24.723 19.715a.42.42 0 0 0-.326.135.452.452 0 0 0-.108.3c0 .21.135.436.434.436a.423.423 0 0 0 .328-.137c.07-.08.11-.186.11-.301 0-.209-.138-.433-.438-.433zm0 .935c-.327 0-.499-.251-.499-.5 0-.13.044-.252.125-.343a.482.482 0 0 1 .374-.157c.344 0 .501.258.501.498 0 .25-.172.502-.501.502z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.484 18.801c-.264 0-.264.394 0 .394s.268-.394 0-.394z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M25.77 18.853a.422.422 0 0 0-.325.135.452.452 0 0 0-.109.3c0 .21.137.435.435.435a.424.424 0 0 0 .328-.137.452.452 0 0 0 .109-.301c0-.208-.137-.432-.437-.432zm0 .935c-.327 0-.498-.252-.498-.5a.52.52 0 0 1 .125-.344.482.482 0 0 1 .374-.156c.344 0 .501.258.501.497 0 .13-.045.253-.126.345a.486.486 0 0 1-.375.158z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M29.818 20.16c-.264 0-.264.394 0 .394.265 0 .268-.393 0-.393z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M30.105 20.212a.424.424 0 0 0-.326.135.452.452 0 0 0-.109.3c0 .21.137.436.435.436.3 0 .437-.227.437-.439 0-.208-.136-.432-.437-.432zm0 .935c-.327 0-.499-.252-.499-.5a.481.481 0 0 1 .499-.5c.344 0 .501.258.501.497a.516.516 0 0 1-.126.345.485.485 0 0 1-.375.158z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M24.076 18.776c-.16-.08-.353-.052-.412.04-.06.091.091.267.249.34.157.071.3.012.347-.053.045-.065 0-.235-.184-.327z",
    fill: "#81683B"
  }), React__default.createElement("path", {
    d: "M24.004 18.772c-.142 0-.26.063-.308.164a.228.228 0 0 0-.009.152c.039.176.206.4.38.507a.416.416 0 0 0 .216.065c.14 0 .25-.085.29-.163a.332.332 0 0 0 .013-.202.68.68 0 0 0-.285-.43.537.537 0 0 0-.297-.093zm.279.944a.445.445 0 0 1-.233-.07.967.967 0 0 1-.403-.543.3.3 0 0 1 .014-.197c.056-.117.188-.19.343-.19a.56.56 0 0 1 .315.1.736.736 0 0 1 .308.465.402.402 0 0 1-.02.248.37.37 0 0 1-.324.187z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.25 20.349c-.17.054-.29.209-.268.315.021.107.252.128.415.07.163-.057.218-.21.192-.285-.04-.11-.144-.162-.339-.1z",
    fill: "#81683B"
  }), React__default.createElement("path", {
    d: "M25.64 20.366a.585.585 0 0 0-.226.055c-.263.114-.432.436-.403.637.018.118.148.193.332.193.099 0 .2-.023.287-.064.252-.123.319-.436.284-.57-.043-.167-.135-.251-.274-.251zm-.297.943c-.163 0-.347-.063-.373-.24-.038-.253.168-.589.432-.703.288-.125.482-.042.552.231.046.18-.052.518-.31.644a.695.695 0 0 1-.3.068z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M30.258 19.932c.172-.05.362-.226.32-.326-.052-.124-.268-.1-.432-.045-.164.053-.249.187-.224.263.036.112.14.165.336.108z",
    fill: "#81683B"
  }), React__default.createElement("path", {
    d: "M30.603 19.561a.826.826 0 0 0-.344.093c-.235.115-.341.39-.31.528.038.174.126.262.26.262a.517.517 0 0 0 .2-.048.91.91 0 0 0 .436-.495.289.289 0 0 0 .013-.165c-.034-.116-.119-.175-.255-.175zm-.393.942c-.152 0-.256-.105-.299-.302-.04-.188.094-.485.336-.602a.852.852 0 0 1 .356-.096c.151 0 .252.073.291.21a.37.37 0 0 1-.014.213c-.066.21-.273.446-.46.526a.54.54 0 0 1-.21.05z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M30.743 20.994c.016-.078-.05-.322-.118-.387a.12.12 0 0 0 .05-.213c-.067-.053-.155-.018-.186.02-.032.038-.031.168.065.193.012.08.092.363.024.476.132.005.364.081.426.136-.032.094.077.165.126.16.049-.006.126-.06.119-.146a.12.12 0 0 0-.207-.074c-.038-.067-.225-.136-.299-.165z",
    fill: "#CD7418"
  }), React__default.createElement("path", {
    d: "M30.633 21.07c.168.012.436.083.513.139l.008.005-.003.009c-.015.037.001.067.018.086a.17.17 0 0 0 .12.056c.053-.005.141-.053.133-.13-.007-.066-.072-.1-.133-.1a.142.142 0 0 0-.094.034l-.016.014-.011-.017c-.04-.058-.24-.121-.336-.151l-.04-.013.003-.011c.019-.075-.064-.315-.141-.374l-.025-.019.033-.004c.05-.007.091-.038.104-.079.014-.042-.005-.083-.048-.11a.159.159 0 0 0-.087-.024.19.19 0 0 0-.121.042c-.019.017-.027.064-.01.105a.105.105 0 0 0 .082.066l.01.002.002.009a.946.946 0 0 0 .015.061c.03.115.078.302.024.405zm.651.323a.213.213 0 0 1-.143-.068c-.028-.032-.037-.067-.026-.102a1.454 1.454 0 0 0-.509-.126l-.028-.001.014-.02c.066-.088.013-.294-.016-.404a.945.945 0 0 1-.013-.054.137.137 0 0 1-.096-.082c-.019-.046-.011-.104.017-.13a.227.227 0 0 1 .255-.023c.053.034.076.087.06.139a.147.147 0 0 1-.103.093.63.63 0 0 1 .134.37l.014.004c.1.032.28.089.341.15a.185.185 0 0 1 .104-.03c.076 0 .158.042.167.123.01.092-.09.153-.163.16h-.009z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M32.589 19.477c-.01-.078-.152-.29-.237-.328a.12.12 0 0 0-.02-.219c-.081-.028-.153.034-.17.08-.019.045.024.169.123.161.038.073.204.315.176.444.126-.038.371-.04.447-.009 0 .1.127.132.17.111.045-.02.101-.097.067-.176a.12.12 0 0 0-.22-.003c-.058-.052-.257-.057-.336-.061z",
    fill: "#CD7418"
  }), React__default.createElement("path", {
    d: "M32.724 19.709c.086 0 .155.01.19.028l.008.004v.011c0 .03.009.057.027.078.037.045.1.055.125.041a.17.17 0 0 0 .059-.191c-.018-.05-.055-.079-.098-.079-.043 0-.08.03-.097.075l-.008.02-.014-.015c-.049-.053-.221-.063-.304-.068l-.035-.002-.002-.014c-.01-.091-.15-.34-.228-.384l-.025-.014.024-.015c.036-.023.057-.07.054-.122-.003-.052-.03-.094-.072-.112a.097.097 0 0 0-.037-.007c-.06 0-.105.055-.117.093-.008.024-.001.077.023.119.015.026.043.059.087.054h.01l.004.01.03.065c.06.122.157.321.15.455a.915.915 0 0 1 .246-.03zm.322.2a.159.159 0 0 1-.117-.056.157.157 0 0 1-.034-.09.84.84 0 0 0-.43.014l-.022.008.005-.027c.021-.12-.086-.34-.143-.457a2.392 2.392 0 0 1-.028-.058c-.04 0-.077-.025-.103-.07a.214.214 0 0 1-.025-.149c.015-.047.07-.114.142-.114a.12.12 0 0 1 .045.01c.052.02.087.075.091.14a.178.178 0 0 1-.049.138c.085.068.203.28.222.381l.013.001c.086.005.241.014.308.064a.13.13 0 0 1 .114-.076c.054 0 .1.038.122.099.037.102-.019.203-.072.234a.076.076 0 0 1-.039.009z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M33.623 17.442c-.045-.065-.205-.203-.28-.225a.12.12 0 0 0-.12-.184c-.084.013-.12.1-.114.149.006.049.1.139.185.086.067.047.245.228.28.355.095-.092.34-.157.422-.163.046.088.174.059.203.02.03-.04.044-.133-.023-.187a.12.12 0 0 0-.196.098c-.076-.02-.284.018-.357.05z",
    fill: "#CD7418"
  }), React__default.createElement("path", {
    d: "M33.294 17.388l.008.009c.065.073.23.336.278.542a.797.797 0 0 1 .415-.242l.009-.001.004.012c.023.07.066.08.09.08.041 0 .078-.026.09-.052.025-.053.04-.188-.02-.265-.045-.057-.11-.048-.147.016a.222.222 0 0 0-.028.121l.001.03-.018-.008a.137.137 0 0 0-.053-.008.648.648 0 0 0-.294.088l-.01.007-.007-.015c-.043-.098-.2-.314-.273-.347l-.018-.008.01-.025a.247.247 0 0 0 .006-.17c-.022-.065-.064-.1-.111-.089-.078.018-.108.146-.104.212.004.048.057.143.117.143a.068.068 0 0 0 .047-.022l.008-.008zm.273.63l-.006-.035c-.033-.19-.199-.46-.268-.543a.082.082 0 0 1-.054.021c-.072 0-.138-.11-.144-.18-.006-.096.039-.24.126-.26.06-.015.113.03.14.11.02.061.02.133.002.191.08.053.215.24.265.341a.681.681 0 0 1 .295-.084c.017 0 .03.002.043.004a.277.277 0 0 1 .035-.126c.047-.08.128-.09.183-.02.07.089.062.25.025.325a.127.127 0 0 1-.11.07c-.05 0-.088-.033-.11-.091-.087.015-.316.115-.406.252l-.016.025z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M33.521 17.679c.066-.314.08-.587-.101-.85-.204-.294-.007-.667-.099-.85.125.131.387.438.439.589.098-.19.354-.582.557-.64-.013.11.017.272.045.398.046.202-.185.498-.38.673-.13.118-.323.2-.382.735l-.079-.055z",
    fill: "#008248"
  }), React__default.createElement("path", {
    d: "M33.613 17.735l-.027-.003c.052-.47.207-.596.333-.697.019-.016.037-.03.054-.046.218-.195.418-.475.376-.66a1.495 1.495 0 0 1-.048-.382c-.186.072-.42.418-.529.627l-.015.028-.01-.03c-.047-.134-.263-.394-.393-.538.014.07.005.153-.004.247-.017.173-.037.37.08.54.181.262.173.533.104.86l-.026-.005c.067-.32.075-.586-.1-.84-.123-.178-.103-.38-.085-.558.011-.119.022-.221-.014-.293l.022-.015c.114.12.358.404.43.565.12-.222.363-.566.552-.621l.02-.006-.003.02c-.013.114.02.28.045.395.051.224-.217.537-.383.686a1.382 1.382 0 0 1-.056.047c-.122.098-.272.22-.323.68z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M33.57 17.649c.105-.752-.105-1.657.269-1.957.268.418.281.94.111 1.163-.17.222-.354.526-.38.794z",
    fill: "#008248"
  }), React__default.createElement("path", {
    d: "M34.094 15.713c-.434.196-.428.645-.421 1.12.002.198.005.401-.021.6.155-.234.454-.459.641-.586.314-.212.306-.716-.199-1.134zm-.485 1.938l-.052-.003a.403.403 0 0 1 .012-.048c.058-.25.055-.512.051-.767-.006-.49-.013-.953.463-1.152l.023-.01.016.014c.533.43.54.957.213 1.178-.229.156-.626.458-.714.74l-.012.048z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M32.221 19.763c.256-.216.452-.366.4-.771-.07-.537.078-1.163.563-1.261.033.15.059.542.04.699.202-.203.353-.438.772-.464-.314.3-.42 1.032-.805 1.19-.387.156-.701.463-.89.718l-.08-.111z",
    fill: "#008248"
  }), React__default.createElement("path", {
    d: "M32.31 19.882l-.02-.016c.115-.155.433-.536.895-.723.216-.088.346-.368.472-.64.089-.191.18-.39.303-.52-.324.03-.476.192-.637.363l-.09.094-.028.027.005-.039a3.174 3.174 0 0 0-.037-.681c-.467.105-.607.716-.539 1.243.052.4-.138.56-.378.762l-.026.021-.017-.02.025-.022c.243-.205.42-.353.37-.738-.07-.544.079-1.176.573-1.276l.013-.003.003.014c.03.14.055.49.043.665a3.05 3.05 0 0 0 .063-.066c.163-.173.331-.352.692-.375l.037-.002-.027.026c-.132.127-.23.336-.323.539-.128.276-.26.561-.486.653-.456.185-.771.561-.885.714z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M32.405 19.678c.164-.196.275-.3.36-.758.095-.512.396-1.203.835-1.392.072.373-.062.895-.37 1.274-.308.38-.714.745-.825.876z",
    fill: "#008248"
  }), React__default.createElement("path", {
    d: "M33.59 17.548c-.4.185-.71.828-.812 1.374-.052.283-.116.433-.195.552l.015-.014c.177-.176.42-.418.62-.666.288-.353.438-.863.371-1.246zm-1.175 2.139l-.02-.018.033-.04c.142-.169.245-.29.323-.711.102-.544.408-1.215.843-1.402l.015-.007.004.017c.076.393-.077.921-.373 1.285-.203.25-.445.492-.623.668a4.05 4.05 0 0 0-.202.208z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M30.512 21.083c.34-.215.433-.357.511-.581.203-.582.792-.81.812-1.052.066.294.02.627-.072.797a1.53 1.53 0 0 1 .714-.288c-.131.262 0 .601-.504.765-.505.163-.727-.079-1.48.45l.02-.09z",
    fill: "#008248"
  }), React__default.createElement("path", {
    d: "M30.5 21.186l-.015-.022c.497-.35.77-.366 1.033-.381.137-.008.278-.017.45-.072.35-.113.386-.306.425-.511.015-.075.03-.153.061-.225-.22.026-.527.152-.682.282l-.02-.017c.078-.146.13-.444.081-.73-.037.089-.134.176-.252.282-.192.171-.43.385-.545.714-.08.232-.175.372-.516.589l-.015-.023c.335-.212.426-.349.505-.575.118-.336.359-.552.553-.725.14-.126.25-.225.258-.324l.027-.002c.062.279.023.581-.049.755a1.61 1.61 0 0 1 .677-.256l.024-.002-.011.022c-.038.075-.053.155-.07.24-.038.203-.078.413-.442.532-.176.057-.319.065-.458.073-.26.015-.528.03-1.018.376z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M30.526 21.11c.3-.25.693-.622.91-.89.216-.267.647-.64 1.073-.64-.183.53-.635.974-1.204 1.157-.57.183-.576.255-.78.372z",
    fill: "#008248"
  }), React__default.createElement("path", {
    d: "M32.49 19.594c-.429.012-.856.403-1.044.635a6.913 6.913 0 0 1-.748.751c.103-.067.238-.139.603-.256a1.894 1.894 0 0 0 1.19-1.13zm-1.958 1.527l-.015-.022c.277-.23.68-.604.908-.887.24-.298.668-.645 1.084-.645h.02l-.007.018a1.918 1.918 0 0 1-1.213 1.165c-.429.137-.537.212-.651.29a1.654 1.654 0 0 1-.126.081z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M28.561 21.508c.498-.092.616-.81 1.611-.68-.144.13-.262.47-.471.588.235.04.589.118.838.262-.275-.04-.904.457-1.428.209-.523-.249-.445-.288-.55-.38z",
    fill: "#008248"
  }), React__default.createElement("path", {
    d: "M28.59 21.516c.015.016.026.03.038.045.045.06.096.127.489.314a.728.728 0 0 0 .32.068c.236 0 .472-.09.68-.17.144-.055.269-.103.366-.11-.24-.124-.555-.195-.785-.233l-.038-.006.034-.02c.121-.068.215-.218.297-.35.05-.083.1-.161.151-.216a1.753 1.753 0 0 0-.2-.012c-.463 0-.7.216-.91.407-.137.124-.267.242-.442.283zm.847.454a.756.756 0 0 1-.332-.07c-.398-.19-.452-.26-.5-.322a.362.362 0 0 0-.053-.06l-.02-.018.027-.005c.18-.034.314-.154.454-.283.214-.193.455-.413.929-.413.073 0 .151.005.232.016l.029.004-.022.02a1.14 1.14 0 0 0-.167.23c-.077.123-.163.263-.276.34.245.043.572.121.807.257l-.008.025a.24.24 0 0 0-.032-.002c-.095 0-.226.05-.377.109-.21.08-.45.172-.69.172z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M28.797 21.73c.404.248 1.506-.092 1.873-.706-.459-.052-.996.157-1.297.3a1.298 1.298 0 0 1-.812.105c-.641-.11-1.375-.117-2.108.406-.052.032.063.167.137.11.622-.47 1.474-.666 2.207-.215z",
    fill: "#008248"
  }), React__default.createElement("path", {
    d: "M27.917 21.394c-.542 0-1.02.156-1.456.477-.004.002-.011.007-.006.026.01.035.056.077.095.077a.052.052 0 0 0 .032-.01c.403-.315.871-.488 1.317-.488.324 0 .628.089.905.264a.67.67 0 0 0 .354.083c.493 0 1.202-.315 1.489-.786a1.325 1.325 0 0 0-.127-.007c-.432 0-.9.199-1.141.317a1.24 1.24 0 0 1-.561.133 1.46 1.46 0 0 1-.26-.024 3.652 3.652 0 0 0-.641-.062zm-1.367.608c-.053 0-.109-.052-.121-.098-.007-.024 0-.045.017-.056a2.404 2.404 0 0 1 1.47-.482c.2 0 .411.02.648.063.089.015.172.023.254.023.191 0 .37-.042.55-.13.242-.12.715-.32 1.152-.32.052 0 .103.003.151.01l.02.001-.01.02c-.283.489-1.016.818-1.523.818a.697.697 0 0 1-.368-.087 1.64 1.64 0 0 0-.891-.26c-.44 0-.902.171-1.3.482a.075.075 0 0 1-.049.016z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M24.397 21.024c-.013-.17-.033-.294-.078-.385-.046-.092-.073-.3.02-.308.09-.006.156.144.117.269-.04.124 0 .405.085.51l-.144-.086z",
    fill: "#CD7418"
  }), React__default.createElement("path", {
    d: "M24.53 21.118c-.09-.111-.127-.397-.087-.522a.243.243 0 0 0-.032-.213c-.015-.019-.04-.04-.072-.038-.014.001-.025.009-.033.023-.031.054-.012.191.025.265.042.083.065.197.08.39l-.028.002c-.014-.19-.036-.3-.077-.38-.036-.072-.063-.221-.024-.29a.067.067 0 0 1 .055-.037.113.113 0 0 1 .095.048c.047.06.062.157.037.238-.037.117-.001.394.083.497l-.021.017z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M24.341 20.577c-.12-.043-.155.017-.108.11.062.125.223.138.279.046.078-.128.026-.202-.027-.176a.216.216 0 0 1-.144.02z",
    fill: "#CD7418"
  }), React__default.createElement("path", {
    d: "M24.4 20.68c-.055 0-.091.02-.11.062-.03.067-.018.187.035.331.099.268.28.364.416.364.122 0 .225-.072.28-.197.117-.264.12-.452.083-.542-.024-.056-.064-.073-.106-.045a.558.558 0 0 1-.305.098.282.282 0 0 1-.118-.022.414.414 0 0 0-.175-.049zm.34.858c-.201 0-.386-.16-.48-.42-.067-.179-.078-.33-.034-.429a.18.18 0 0 1 .174-.11.48.48 0 0 1 .2.054c.023.01.056.017.093.017.09 0 .19-.033.271-.087.078-.053.163-.017.205.085.061.149.03.389-.085.644-.068.154-.197.246-.343.246z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M24.366 21.065c-.167.033-.292.048-.393.029-.1-.02-.31.012-.29.102.018.09.18.112.29.04.109-.07.39-.11.514-.056l-.12-.115z",
    fill: "#CD7418"
  }), React__default.createElement("path", {
    d: "M23.827 21.293a.227.227 0 0 1-.086-.016c-.04-.016-.065-.044-.072-.078a.067.067 0 0 1 .02-.062c.056-.057.207-.07.287-.056.088.017.2.008.388-.03l.005.027c-.191.039-.306.047-.398.03-.081-.016-.219.003-.262.048-.012.012-.016.024-.013.038.006.032.034.05.055.058.063.026.15.015.215-.026.11-.072.395-.115.527-.058l-.011.025c-.121-.053-.398-.012-.502.055a.288.288 0 0 1-.153.045z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M23.92 21.133c-.074-.105-.026-.154.077-.134.137.026.193.176.12.255-.103.11-.188.08-.177.023a.216.216 0 0 0-.02-.144z",
    fill: "#CD7418"
  }), React__default.createElement("path", {
    d: "M24.162 21.057c-.055 0-.152.007-.186.06-.035.055 0 .148.1.263.07.08.117.26.078.428-.007.027 0 .05.016.066.021.02.057.032.102.032.055 0 .207-.019.408-.194a.283.283 0 0 0 .073-.33c-.065-.16-.24-.28-.458-.314a.846.846 0 0 0-.133-.011zm.11.924a.243.243 0 0 1-.173-.059.132.132 0 0 1-.037-.128c.034-.145-.005-.306-.062-.37-.154-.179-.143-.285-.106-.342.029-.046.1-.1.268-.1.046 0 .098.003.151.012.25.038.453.178.528.365.06.15.026.301-.093.404-.218.19-.391.218-.476.218z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M22.557 19.46c.029-.169.041-.31.02-.41-.023-.099.002-.308.092-.292.091.016.118.177.05.288-.068.111-.085.396-.028.518l-.134-.105z",
    fill: "#CD7418"
  }), React__default.createElement("path", {
    d: "M22.679 19.57c-.059-.126-.044-.414.028-.53a.243.243 0 0 0 .02-.215c-.01-.022-.027-.048-.06-.054a.04.04 0 0 0-.037.014c-.044.045-.059.183-.04.263.02.091.014.218-.02.414l-.026-.005c.032-.191.038-.315.019-.403-.018-.079-.008-.23.047-.287a.067.067 0 0 1 .062-.023c.034.006.063.031.08.07a.27.27 0 0 1-.021.24c-.067.108-.082.387-.027.504l-.025.012z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M22.613 18.996c-.107-.07-.154-.02-.132.082.03.136.183.187.26.112.106-.106.074-.19.017-.178a.217.217 0 0 1-.145-.016z",
    fill: "#CD7418"
  }), React__default.createElement("path", {
    d: "M22.646 19.043a.084.084 0 0 0-.077.042c-.035.053-.042.163-.016.3.054.309.26.47.434.47.085 0 .16-.037.217-.106.174-.216.201-.394.174-.48-.017-.049-.05-.07-.092-.057-.147.042-.339.012-.427-.062-.085-.07-.158-.107-.213-.107zm.34.907c-.204 0-.444-.188-.508-.545-.029-.17-.019-.301.032-.38.073-.113.213-.1.39.046a.4.4 0 0 0 .238.067.472.472 0 0 0 .132-.018c.079-.022.148.024.178.112.038.12.009.335-.191.584a.342.342 0 0 1-.27.134z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M22.557 19.482c-.17.005-.308.007-.404-.029-.096-.036-.307-.04-.304.05.003.093.16.142.28.09.119-.051.472-.031.585.043l-.157-.154z",
    fill: "#CD7418"
  }), React__default.createElement("path", {
    d: "M22.707 19.647c-.113-.073-.463-.09-.573-.041a.273.273 0 0 1-.241-.012c-.036-.023-.057-.055-.058-.09a.07.07 0 0 1 .03-.058c.066-.046.217-.034.293-.006.096.036.243.033.399.029v.027c-.165.004-.308.008-.409-.03-.077-.03-.216-.034-.266.003-.014.009-.02.02-.02.034.002.033.025.055.045.068.058.036.146.04.215.01.12-.052.48-.035.6.044l-.015.022z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M22.094 19.482c-.055-.116 0-.156.1-.119.13.05.159.208.073.272-.12.09-.2.047-.178-.008a.217.217 0 0 0 .005-.145z",
    fill: "#CD7418"
  }), React__default.createElement("path", {
    d: "M22.323 19.41c-.07 0-.117.016-.141.045-.044.05-.025.145.051.265.056.086.065.27-.015.427-.015.027-.012.052.006.072.025.027.078.042.146.042a.93.93 0 0 0 .43-.135.288.288 0 0 0 .153-.312c-.033-.164-.191-.306-.415-.368a.797.797 0 0 0-.215-.035zm.047.926c-.101 0-.184-.027-.229-.075a.115.115 0 0 1-.017-.14c.07-.138.064-.299.018-.369-.092-.147-.109-.263-.046-.337.03-.036.095-.079.227-.079.072 0 .158.014.25.04.258.072.442.236.479.428.03.154-.041.297-.192.38-.222.126-.39.152-.49.152z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.424 17.466c.094-.142.19-.28.21-.38.019-.1.126-.282.203-.231.076.05.036.21-.071.284-.107.074-.243.334-.29.556l-.052-.229z",
    fill: "#CD7418"
  }), React__default.createElement("path", {
    d: "M21.49 17.697l-.026-.005c.046-.224.183-.488.294-.564a.243.243 0 0 0 .105-.188c0-.024-.006-.055-.034-.074a.043.043 0 0 0-.04-.002c-.058.024-.127.143-.143.225-.018.095-.101.22-.189.352l-.021.032-.023-.015.021-.032c.086-.13.168-.253.185-.343.016-.079.086-.214.16-.244a.067.067 0 0 1 .065.005c.03.019.045.053.046.095a.271.271 0 0 1-.117.211c-.105.073-.238.33-.283.547z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.69 17.051c-.07-.107-.134-.081-.154.022-.027.136.092.244.192.206.14-.054.144-.144.087-.156a.215.215 0 0 1-.126-.072z",
    fill: "#CD7418"
  }), React__default.createElement("path", {
    d: "M21.765 17.05c-.07 0-.128.09-.157.24-.03.16.006.319.1.439.106.133.27.189.402.136.237-.094.336-.227.328-.317-.003-.038-.027-.064-.067-.073-.174-.035-.335-.147-.39-.236-.077-.122-.153-.19-.216-.19zm.237.918a.463.463 0 0 1-.354-.187.623.623 0 0 1-.118-.506c.038-.195.123-.307.235-.307.092 0 .19.079.281.228.046.071.19.168.34.199a.16.16 0 0 1 .131.146c.01.112-.084.283-.378.4a.358.358 0 0 1-.137.027z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.367 17.465c-.15-.082-.269-.15-.333-.229-.065-.08-.245-.19-.289-.11-.044.081.066.203.196.22.13.015.424.21.484.331l-.058-.212z",
    fill: "#CD7418"
  }), React__default.createElement("path", {
    d: "M21.413 17.683c-.06-.12-.354-.31-.474-.324a.273.273 0 0 1-.201-.132c-.02-.038-.021-.076-.005-.106a.066.066 0 0 1 .056-.035h.01c.08 0 .196.082.245.142.065.08.194.15.33.226l-.013.023c-.139-.076-.27-.148-.338-.232-.05-.062-.16-.132-.224-.132h-.007a.041.041 0 0 0-.035.02c-.015.03-.006.06.005.081.031.06.105.108.18.118.13.015.432.211.496.34l-.025.011z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M20.967 17.231c.012-.127.08-.134.147-.052.087.108.033.26-.074.272-.15.018-.195-.06-.15-.097a.214.214 0 0 0 .077-.123z",
    fill: "#CD7418"
  }), React__default.createElement("path", {
    d: "M21.412 17.188c-.086 0-.145.097-.162.264-.01.098-.112.264-.265.372-.034.023-.045.054-.032.086.025.063.143.125.353.125.04 0 .083-.002.128-.006a.372.372 0 0 0 .3-.217.438.438 0 0 0-.092-.486c-.081-.088-.165-.138-.23-.138zm-.106.924c-.269 0-.402-.091-.436-.176-.026-.064-.004-.127.06-.172.147-.103.226-.252.233-.319.03-.29.17-.333.25-.333.094 0 .196.057.296.166a.504.504 0 0 1 .106.563.456.456 0 0 1-.37.264 1.477 1.477 0 0 1-.14.007z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M21.53 17.92c-.02-.248-.236-.83-.139-.94.099-.112.096-.135.027-.187-.069-.052 0-.156.108-.196.157-.059.222-.188.104-.18-.192.013-.307-.02-.192-.085.138-.079.289-.179.258-.294-.013-.049-.078-.062-.15-.036-.072.026-.144-.016-.06-.075.109-.075.024-.15.102-.202.079-.053.05-.125 0-.118-.05.006-.17.134-.22.075-.048-.059-.11-.123-.166-.007-.082.167.02.272-.033.35-.052.079-.121.105-.186.02-.066-.085-.161-.06-.167.045-.007.105.042.17.11.268.07.098.057.174-.068.115-.124-.06-.183-.06-.19.04-.006.097.046.133.203.205.157.072.184.092.197.173.022.144.163.118.21.31.045.193.156.494.143.775l.108-.056z",
    fill: "#008248"
  }), React__default.createElement("path", {
    d: "M21.435 17.976h-.028c.01-.215-.053-.441-.103-.623a3.968 3.968 0 0 1-.04-.148c-.023-.098-.07-.135-.116-.172-.042-.034-.082-.067-.094-.14-.012-.073-.033-.091-.189-.163-.155-.07-.218-.11-.21-.219.003-.042.015-.069.038-.083.033-.019.082-.01.171.033.05.024.078.022.086.012.01-.012.004-.051-.034-.107l-.008-.01c-.066-.094-.113-.161-.106-.266.003-.054.03-.094.069-.106.041-.013.087.007.122.052.025.032.05.048.074.048h.002c.038-.001.07-.037.089-.066.02-.03.014-.066.007-.111-.01-.062-.024-.14.025-.238.022-.045.046-.068.075-.071h.008c.04 0 .074.037.106.075.024.03.083-.009.13-.04.031-.02.057-.037.077-.04a.057.057 0 0 1 .06.036c.01.027.003.071-.05.107-.03.02-.032.043-.034.074a.14.14 0 0 1-.068.128c-.024.017-.036.034-.03.044.006.013.038.021.077.008.05-.019.097-.02.13-.002.02.01.033.026.038.047.033.12-.108.22-.265.31-.041.023-.038.034-.038.035.003.012.064.034.224.024.056-.004.07.021.073.037.012.052-.067.13-.172.169-.067.025-.12.076-.126.122a.051.051 0 0 0 .021.05c.033.025.052.045.055.071.003.035-.025.074-.08.135-.057.065.008.33.066.562.035.143.069.277.076.37l-.028.001c-.007-.09-.04-.223-.074-.364-.062-.251-.127-.51-.06-.587.047-.052.075-.09.073-.114-.002-.017-.018-.032-.045-.052a.079.079 0 0 1-.031-.077c.008-.055.067-.114.143-.143.105-.04.162-.108.156-.138-.004-.016-.033-.016-.045-.015-.07.005-.236.01-.252-.044-.01-.032.036-.058.05-.067.14-.08.28-.175.253-.278a.047.047 0 0 0-.025-.03c-.025-.013-.065-.012-.108.003-.047.017-.096.008-.111-.02-.006-.012-.014-.042.04-.079.053-.037.054-.071.056-.107.002-.034.004-.068.046-.096.04-.026.046-.057.04-.074a.028.028 0 0 0-.03-.018.233.233 0 0 0-.067.035c-.056.037-.126.083-.166.035-.028-.034-.06-.07-.09-.066-.018.002-.036.021-.054.056a.327.327 0 0 0-.023.221c.008.05.015.092-.01.13-.034.05-.072.078-.11.079-.035 0-.069-.018-.1-.058-.027-.036-.062-.053-.092-.043-.029.009-.047.04-.05.081-.006.096.037.157.101.249l.008.01c.043.062.055.114.033.14-.014.017-.046.03-.119-.005-.076-.036-.122-.047-.145-.033-.015.008-.023.028-.025.061-.006.088.036.12.195.193.155.07.19.094.204.183.01.063.044.09.084.123.047.037.1.08.126.186.01.044.024.094.039.148.051.183.115.411.105.63z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M22.937 19.659c-.44-.233-.603-.419-.615-.667-.012-.209-.007-.307.065-.392.072-.085.033-.177-.06-.098-.09.078-.182.052-.163-.085.02-.137.079-.314.027-.418-.053-.105-.172-.101-.204.039-.013.059-.058.124-.124.124s-.059-.144-.033-.235c.027-.092-.058-.157-.104-.078-.046.078-.15.156-.197.039-.046-.118-.157-.053-.134.026-.111-.04-.124.046-.085.098.052.069.072.13 0 .114s-.213-.065-.187.043c.027.108.262.186.413.215.15.03.16.099.092.121-.07.023-.112.013-.217-.003-.104-.016-.124.065-.042.154.082.088.298.114.396.124.157.016.17.134.102.13-.07-.003-.2-.049-.21.02-.01.069.173.144.31.13.138-.012.156.02.184.056.19.255.537.556.756.64l.03-.097z",
    fill: "#008248"
  }), React__default.createElement("path", {
    d: "M22.903 19.77c-.215-.084-.564-.38-.763-.646l-.003-.004c-.025-.033-.042-.057-.168-.046-.105.011-.248-.032-.303-.09a.069.069 0 0 1-.023-.056.05.05 0 0 1 .02-.035c.032-.023.09-.013.144-.004a.557.557 0 0 0 .06.008h.002c.014 0 .022-.007.023-.019.003-.03-.036-.075-.129-.085-.077-.008-.316-.033-.404-.128-.049-.053-.066-.106-.047-.142.01-.018.034-.046.101-.035l.025.004c.086.014.125.02.185 0 .02-.007.032-.018.032-.03-.002-.02-.04-.048-.122-.064-.144-.028-.394-.107-.423-.226-.007-.03-.003-.053.011-.067.033-.032.106-.014.164.001l.028.007c.018.004.027.002.029-.001.005-.008-.003-.039-.043-.092-.026-.034-.03-.078-.01-.104.01-.015.034-.035.09-.022a.083.083 0 0 1 .055-.08c.033-.012.081 0 .108.069.012.032.03.05.052.051.043.004.092-.045.12-.092.025-.044.06-.048.085-.037.035.015.062.064.044.126-.02.072-.027.172 0 .207.005.007.012.01.02.01.056 0 .098-.057.111-.113.016-.07.056-.116.106-.122.049-.007.095.025.123.08.041.083.017.204-.006.32a1.876 1.876 0 0 0-.02.106c-.007.054.003.093.029.107.028.015.07.002.113-.034.061-.053.094-.03.103-.02.029.028.018.087-.025.137-.07.083-.073.18-.062.382.013.247.184.43.608.656l-.012.024c-.435-.23-.61-.42-.623-.678-.011-.205-.008-.312.069-.402.038-.045.04-.087.026-.1-.011-.011-.037-.003-.066.021-.052.045-.106.059-.144.038-.021-.012-.055-.045-.042-.135.005-.034.012-.07.02-.107.022-.112.045-.228.007-.303-.022-.045-.059-.07-.095-.065-.038.005-.07.042-.082.101-.015.067-.067.135-.138.135a.052.052 0 0 1-.042-.022c-.037-.049-.022-.167-.004-.23.013-.046-.004-.084-.029-.094-.018-.008-.037.002-.05.025-.032.054-.093.11-.146.106-.023-.002-.055-.015-.076-.068-.02-.051-.051-.061-.074-.054a.057.057 0 0 0-.034.071l.007.026-.025-.01c-.039-.013-.067-.012-.08.005-.012.017-.008.049.01.073.031.04.064.093.045.123-.01.015-.03.019-.058.012l-.028-.006c-.047-.012-.117-.03-.138-.009-.008.008-.01.022-.005.042.024.098.254.176.403.205.088.017.14.05.143.09.001.025-.017.046-.05.057-.067.022-.11.015-.198.001l-.025-.004c-.036-.005-.063.002-.073.02-.013.025.004.07.043.111.082.088.312.112.387.12.105.011.157.067.153.114-.002.028-.024.045-.053.044a.557.557 0 0 1-.063-.008c-.045-.008-.101-.017-.123-.001a.023.023 0 0 0-.01.017c-.002.013.008.025.016.034.044.047.174.091.28.081.14-.013.165.02.193.057l.003.004c.196.263.54.554.75.636l-.01.025z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M24.73 21.168c-.425-.13-.687-.523-.7-.732-.013-.209-.062-.153-.091-.105-.03.05-.124.116-.164-.045-.049-.2-.016-.37-.095-.46-.078-.092-.164-.131-.206.035-.043.167-.138.075-.134-.065.003-.14.006-.275-.056-.337s-.108-.059-.108.075-.06.16-.125.036-.166-.19-.16-.055c.007.134.062.251-.052.248-.115-.003-.207.016-.111.105a.424.424 0 0 0 .225.12c.062.014.072.092.004.122-.07.029-.135.01-.194-.017-.059-.026-.154.01-.062.114.092.105.233.157.413.157.18 0 .242.079.134.138a.416.416 0 0 1-.305.045c-.117-.02-.14.079.024.177.163.098.32.075.468.026.147-.049.153.006.13.052-.023.046-.013.111.118.072.131-.04.262-.085.42.026.157.111.33.271.527.373l.1-.105z",
    fill: "#008248"
  }), React__default.createElement("path", {
    d: "M24.623 21.285a2.415 2.415 0 0 1-.372-.255c-.055-.043-.106-.083-.157-.119-.145-.103-.265-.067-.392-.029l-.015.005c-.066.02-.11.016-.132-.01-.016-.02-.017-.05-.001-.08.009-.02.01-.036.004-.044-.005-.005-.027-.02-.119.01-.13.043-.302.079-.48-.028-.109-.065-.133-.127-.12-.163.012-.033.052-.047.107-.038a.406.406 0 0 0 .295-.044c.034-.019.05-.039.046-.056-.007-.027-.064-.056-.173-.056-.187 0-.329-.054-.423-.162-.056-.063-.043-.1-.03-.117.022-.031.073-.034.108-.018.053.023.117.044.182.016.032-.014.041-.037.04-.055-.003-.02-.018-.035-.04-.04a.44.44 0 0 1-.233-.124c-.037-.035-.05-.063-.04-.087.012-.031.063-.044.161-.042.022 0 .038-.003.046-.013.019-.02.011-.068.003-.123a1.02 1.02 0 0 1-.01-.098c-.003-.05.009-.08.035-.087.047-.012.111.062.15.136.031.058.058.075.07.072.015-.003.03-.036.03-.102 0-.073.012-.113.04-.124.025-.01.054.003.09.04.067.066.064.201.06.344-.002.084.031.14.055.143.015.001.037-.018.053-.08.018-.073.046-.113.086-.122.04-.01.089.018.143.081.05.058.058.145.067.246a1.4 1.4 0 0 0 .031.22c.014.056.035.088.062.092.029.004.063-.026.077-.05.015-.024.039-.058.065-.05.03.006.045.055.052.161.014.216.283.595.691.72l-.008.026c-.42-.129-.696-.52-.71-.744-.008-.13-.03-.137-.031-.137 0 0-.01-.003-.036.039-.017.028-.06.068-.104.062-.04-.006-.068-.044-.084-.112a1.391 1.391 0 0 1-.032-.225c-.01-.1-.016-.179-.06-.23-.048-.055-.088-.08-.117-.073-.028.006-.05.042-.066.104-.024.093-.062.1-.083.099-.046-.007-.08-.08-.078-.169.003-.139.006-.268-.052-.326-.026-.027-.047-.038-.06-.034-.008.003-.024.019-.024.1 0 .074-.018.12-.05.128-.022.005-.058-.005-.1-.086-.043-.08-.098-.128-.12-.122-.011.003-.017.025-.015.059.001.033.006.066.01.095.01.065.017.116-.01.145-.013.015-.033.023-.062.023h-.027c-.095 0-.111.019-.114.025-.002.005-.003.02.035.056a.414.414 0 0 0 .22.117.074.074 0 0 1 .06.065c.003.027-.01.063-.055.082-.075.032-.145.01-.204-.017-.028-.012-.063-.007-.076.01-.013.017-.002.048.03.083.088.102.223.153.402.153.11 0 .187.029.2.076.004.018.002.053-.06.086a.428.428 0 0 1-.313.048c-.04-.007-.07 0-.076.02-.01.026.02.078.108.131.168.1.325.069.457.025.078-.026.127-.026.148-.002.015.017.015.043 0 .073-.008.016-.013.038-.002.052.014.016.051.017.103 0l.015-.003c.128-.039.26-.079.416.032.05.036.103.076.157.119.117.09.236.184.369.252l-.013.025z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M28.633 21.906c-.648-.464-1.4-.695-2.036-.522-.144.039-.242.085-.327-.06-.086-.143-.128-.084-.164-.039-.036.046-.138.046-.223-.104-.085-.15-.157-.2-.262-.19-.104.01-.14.066-.085.164.056.098.003.173-.085.082-.088-.092-.213-.216-.314-.213-.101.003-.2.017-.134.115.065.098.065.202-.053.11-.118-.09-.203-.136-.314-.12-.16.023-.046.166-.187.206a.5.5 0 0 0-.219.12c-.04.05-.043.18.275.131.317-.049.33-.032.305.066-.027.098-.027.214.154.173.229-.052.35-.226.435-.144.052.05-.011.123-.06.173-.078.082.103.153.207.072.102-.078.226-.219.298-.193.072.027.003.118-.023.17-.026.053 0 .163.128.101.127-.062.206-.44.599-.388.114-.213 1.037-.324 1.797.303.052.053.115.053.187.046.072-.006.173-.003.101-.059z",
    fill: "#008248"
  }), React__default.createElement("path", {
    d: "M25.825 21.717a.07.07 0 0 1 .024.004.057.057 0 0 1 .037.034c.014.036-.014.084-.038.126l-.015.028a.084.084 0 0 0 .003.076c.018.03.056.032.107.007.036-.017.07-.065.108-.12.083-.116.195-.275.425-.275.02 0 .043.002.065.004.063-.1.28-.166.545-.166.208 0 .75.046 1.268.474a.16.16 0 0 0 .123.046.618.618 0 0 0 .053-.003l.033-.003c.028-.001.074-.005.082-.013-.001 0-.004-.006-.02-.019-.52-.372-1.083-.577-1.585-.577-.153 0-.301.02-.44.057l-.04.011a.548.548 0 0 1-.143.029c-.067 0-.116-.033-.16-.105-.032-.055-.061-.084-.084-.084-.02 0-.038.022-.054.044a.09.09 0 0 1-.072.034c-.062 0-.126-.05-.176-.138-.081-.144-.15-.192-.248-.183-.034.003-.077.013-.093.043-.012.023-.006.058.018.1.026.046.032.092.016.12-.021.036-.073.03-.123-.022-.07-.073-.2-.208-.3-.208h-.004c-.037.001-.123.004-.139.035-.007.012-.001.032.016.058.033.05.058.115.04.149-.015.029-.055.025-.112-.02-.11-.085-.196-.133-.304-.118-.074.011-.081.047-.09.092-.01.043-.02.093-.095.114a.495.495 0 0 0-.212.116c-.013.017-.022.044-.01.067.023.049.123.065.272.042a1.63 1.63 0 0 1 .239-.027c.043 0 .067.007.08.024.016.02.01.05 0 .085-.017.066-.015.112.005.138.02.028.067.034.133.019a.856.856 0 0 0 .242-.106c.058-.033.104-.06.145-.06.023 0 .043.008.061.025.066.063-.021.154-.058.193-.015.015-.019.028-.013.041.01.025.053.043.1.043a.164.164 0 0 0 .1-.033c.027-.02.055-.044.082-.068.076-.067.148-.13.206-.13zm.057.32a.078.078 0 0 1-.07-.037.112.112 0 0 1-.003-.103l.016-.029c.019-.033.045-.08.035-.104-.003-.008-.01-.014-.02-.018a.044.044 0 0 0-.015-.002c-.048 0-.12.062-.188.123-.028.024-.056.05-.083.07a.193.193 0 0 1-.117.038c-.059 0-.11-.024-.125-.059-.006-.013-.011-.04.018-.071.052-.054.1-.115.06-.154-.04-.038-.094-.008-.174.038-.066.038-.147.086-.25.11-.079.017-.133.007-.161-.03-.025-.032-.029-.087-.009-.16.009-.032.012-.053.005-.062-.007-.01-.027-.014-.06-.014-.043 0-.111.008-.234.027a.857.857 0 0 1-.126.01c-.117 0-.16-.036-.175-.067a.093.093 0 0 1 .013-.096.508.508 0 0 1 .227-.125c.06-.017.067-.053.075-.094.01-.047.02-.1.113-.112.117-.017.209.033.325.123.036.028.054.032.062.032.006 0 .008-.002.01-.004.008-.017-.004-.068-.04-.12-.023-.036-.029-.064-.017-.087.019-.037.079-.046.163-.05h.004c.102 0 .219.112.32.217.034.036.067.048.08.027.008-.016.007-.05-.016-.092-.03-.052-.036-.094-.02-.127.018-.032.056-.051.115-.057.113-.01.187.042.275.197.064.112.127.124.152.124a.06.06 0 0 0 .048-.022c.022-.028.045-.056.078-.056.035 0 .069.03.108.097.038.064.079.091.136.091a.53.53 0 0 0 .136-.027 1.701 1.701 0 0 1 .487-.07c.508 0 1.076.208 1.601.584.016.012.036.03.03.049-.008.025-.051.028-.106.032l-.032.002a.595.595 0 0 1-.056.003.187.187 0 0 1-.141-.053 1.998 1.998 0 0 0-1.25-.467c-.302 0-.484.083-.526.16l-.004.008h-.01a.572.572 0 0 0-.07-.005c-.216 0-.32.145-.402.263a.388.388 0 0 1-.12.129.173.173 0 0 1-.072.02z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M27.646 21.948c.166.125.375.236.417.377a.51.51 0 0 0-.124.13c-.103-.125-.277-.23-.419-.364.034-.034.108-.107.126-.143z",
    fill: "#0099D8"
  }), React__default.createElement("path", {
    d: "M27.569 22.223c.095.093.2.179.3.261.145.121.283.235.388.361a.914.914 0 0 1 .189-.206c-.063-.18-.275-.335-.5-.498-.062-.046-.127-.093-.188-.14-.04.065-.13.16-.19.222zm.691.704l-.02-.025c-.102-.132-.248-.252-.4-.378-.108-.09-.22-.182-.321-.282l-.018-.017.017-.019c.056-.058.183-.19.212-.253l.013-.026.023.018c.066.052.138.105.207.155.239.173.464.337.523.542l.005.017-.014.01a.86.86 0 0 0-.209.23l-.018.028z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M27.205 21.712c-.175.169-.544.248-.628.58a.512.512 0 0 1 .234-.033c.022-.167.404-.36.55-.497a.332.332 0 0 1-.156-.05z",
    fill: "#0099D8"
  }), React__default.createElement("path", {
    d: "M27.335 21.752a1.547 1.547 0 0 1-.252.23c-.189.148-.403.317-.478.643a.47.47 0 0 1 .243-.043c.032-.184.24-.38.424-.553.08-.075.156-.146.211-.21a.338.338 0 0 1-.148-.067zm-.777.943l.008-.04c.068-.372.298-.552.5-.712.098-.076.19-.149.257-.235l.01-.013.011.012c.039.042.118.066.178.074l.036.005-.026.033a2.471 2.471 0 0 1-.241.246c-.186.175-.396.373-.413.544l-.002.022-.017-.003a.446.446 0 0 0-.272.052l-.03.015z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M27.346 21.761c-.15-.02-.219-.084-.219-.286 0-.216.034-.262.226-.271.069-.003.06.139.06.265s.021.309-.067.292z",
    fill: "#0099D8"
  }), React__default.createElement("path", {
    d: "M27.88 21.236c-.586.016-.68.078-.68.44 0 .353.23.436.655.466.046.005.068 0 .09-.013.092-.05.085-.22.08-.358a2.678 2.678 0 0 1-.004-.105v-.063c.002-.144.005-.306-.083-.354a.12.12 0 0 0-.058-.013zm.003.954c-.014 0-.028 0-.042-.002-.53-.038-.727-.176-.727-.511 0-.388.127-.47.756-.487h.002c.055 0 .094.009.127.027.113.06.11.219.109.386v.063l.003.104c.006.16.014.327-.104.392a.26.26 0 0 1-.124.028z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M27.83 21.706c.172.173.549.25.633.586a.512.512 0 0 0-.233-.033c-.02-.153-.343-.327-.509-.461.006-.016.007-.032.012-.047a.237.237 0 0 0 .096-.045z",
    fill: "#EC1C2E"
  }), React__default.createElement("path", {
    d: "M28.441 22.573a.58.58 0 0 1 .213.046c-.08-.323-.31-.49-.513-.637-.104-.076-.203-.148-.278-.236a.304.304 0 0 1-.108.061l-.004.022-.005.026c.055.055.122.113.193.174.198.172.42.365.455.547a.405.405 0 0 1 .047-.003zm.264.114l-.031-.014a.513.513 0 0 0-.292-.052l-.018.003-.002-.022c-.018-.169-.244-.364-.443-.537-.075-.065-.147-.127-.205-.185l-.009-.01.004-.014.007-.036.008-.037.003-.012.01-.003a.269.269 0 0 0 .116-.067l.012-.014.012.015c.072.09.174.164.282.243.218.157.464.336.538.703l.008.04z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M27.734 21.751c-.076.335-.457.49-.633.704a.503.503 0 0 0-.124-.13c.062-.204.466-.343.595-.555a.965.965 0 0 0 .162-.019z",
    fill: "#EC1C2E"
  }), React__default.createElement("path", {
    d: "M27.001 22.517c.05.04.097.09.138.152.076-.093.177-.177.283-.265.207-.173.42-.35.49-.62a1.886 1.886 0 0 1-.17.017c-.08.132-.23.242-.376.35-.164.12-.32.233-.365.366zm.136.212l-.013-.02a.637.637 0 0 0-.153-.17l-.01-.008.003-.012c.044-.15.208-.271.382-.398.146-.107.297-.218.37-.347l.006-.008h.009a1.24 1.24 0 0 0 .2-.023l.03-.014-.008.035c-.064.298-.3.494-.51.668-.11.093-.217.18-.292.278l-.014.019z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M27.612 21.767c.2-.01.288-.06.288-.292 0-.235-.04-.269-.281-.273.068-.003.06.14.06.267 0 .125.021.315-.067.298z",
    fill: "#EC1C2E"
  }), React__default.createElement("path", {
    d: "M27.804 21.237c.082.071.081.214.08.362l-.001.062.003.106c.008.142.015.288-.067.365.474-.027.7-.117.7-.46 0-.35-.09-.42-.715-.435zm-.153.951a.41.41 0 0 1-.042-.002l.006-.045c.025 0 .049-.002.073-.003.126-.029.116-.225.109-.37-.002-.037-.004-.074-.004-.107v-.063c.002-.158.005-.355-.136-.364h-.018l-.001-.046h.025c.805.01.946.082.946.483 0 .403-.316.491-.902.513a.351.351 0 0 1-.056.004z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M27.573 21.769c-.128.213-.534.352-.596.556a.366.366 0 0 0-.166-.066c.022-.167.405-.36.55-.498.045.01.18.01.212.008z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M26.835 22.58a.415.415 0 0 1 .177.094c.053-.174.207-.317.37-.468.134-.124.272-.251.35-.398a1.138 1.138 0 0 1-.226-.013 2.47 2.47 0 0 1-.246.247c-.184.173-.393.367-.425.539zm.196.166l-.02-.018a.38.38 0 0 0-.199-.106l-.017-.003.003-.022c.02-.196.244-.406.443-.592.097-.09.189-.176.247-.25l.007-.009.009.003c.053.016.22.017.258.012l.033-.003-.017.038c-.076.17-.229.311-.377.448-.167.154-.324.3-.364.472l-.006.03z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M27.646 21.948c.166.125.375.236.417.377a.366.366 0 0 1 .166-.066c-.02-.153-.342-.327-.508-.462a.666.666 0 0 1-.075.15z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M27.69 22.072c.057.046.117.092.176.136.21.158.411.308.478.491a.583.583 0 0 1 .23-.098c-.041-.18-.312-.384-.552-.566a5.342 5.342 0 0 1-.232-.182 1.544 1.544 0 0 1-.1.22zm.63.703l-.009-.032c-.05-.181-.254-.334-.47-.496-.065-.049-.133-.1-.196-.15l-.02-.016.017-.02a1.21 1.21 0 0 0 .117-.255l.01-.031.025.021c.071.062.16.13.254.2.257.195.55.416.574.622l.004.023-.023.004a.539.539 0 0 0-.257.11l-.025.02z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M27.612 21.767c.088.017.067-.173.067-.298 0-.126.008-.27-.06-.267l-.105-.001c-.063 0-.116 0-.16.002.068-.002.06.14.06.266 0 .125.02.308-.068.292a2.042 2.042 0 0 0 .266.006z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M27.51 22.137a10.603 10.603 0 0 0 .596.002l.03.001a.1.1 0 0 0 .056-.014c.083-.05.076-.221.07-.36 0-.036-.003-.073-.003-.106l.001-.062c.001-.142.002-.304-.076-.35a.097.097 0 0 0-.052-.013h-.025l-.28-.002c-.13 0-.233 0-.32.002.08.069.078.212.076.363v.062l.002.103c.006.15.012.304-.076.374zm.317.05a6.654 6.654 0 0 1-.484-.014l.012-.045.02.001c.03 0 .047-.004.062-.013.083-.05.076-.218.07-.352a2.884 2.884 0 0 1-.002-.104v-.062c.002-.141.004-.301-.075-.348a.1.1 0 0 0-.052-.012h-.005l-.003-.046c.115-.003.251-.005.457-.005l.281.002h.02c.046 0 .082.009.11.026.103.06.1.217.1.383l-.001.062.003.106c.007.161.014.328-.092.392a.23.23 0 0 1-.148.026 8.623 8.623 0 0 1-.273.003z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M23.264 16.842c-.112.112-.327-.006-.419-.098-.092-.092-.19-.255-.006-.431.143-.138.32-.06.432.117.111.177.092.314-.007.412z",
    fill: "#EC1C2E"
  }), React__default.createElement("path", {
    d: "M23.155 16.27a.343.343 0 0 0-.235.098c-.102.093-.155.191-.155.292-.002.134.089.248.165.32.109.104.301.208.457.208.07 0 .126-.02.17-.062.162-.153.164-.35.007-.587-.113-.169-.265-.27-.409-.27zm.232.959c-.187 0-.394-.132-.487-.22-.082-.077-.18-.201-.178-.35 0-.111.057-.219.168-.32a.384.384 0 0 1 .265-.11c.161 0 .323.105.445.289.21.317.11.521-.013.637a.28.28 0 0 1-.2.074z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M22.613 16.394c-.113-.089-.113-.147-.044-.214.07-.066.129-.058.201.025.092.105.1.186.058.228-.042.043-.104.048-.215-.04z",
    fill: "#EC1C2E"
  }), React__default.createElement("path", {
    d: "M22.926 16.202c-.07 0-.142.037-.22.113-.086.083-.125.154-.121.223.005.091.083.196.24.32.253.2.427.242.55.115.116-.118.055-.339-.164-.592-.105-.12-.198-.18-.285-.18zm.287.92c-.12 0-.261-.067-.434-.203-.179-.141-.264-.26-.27-.377-.005-.093.04-.183.143-.282.21-.204.395-.184.617.071.247.286.307.546.16.696a.3.3 0 0 1-.216.094z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M22.605 16.509c-.109-.03-.126-.072-.097-.14.03-.07.072-.061.15-.023.098.047.13.083.114.126-.017.043-.06.066-.167.037z",
    fill: "#EC1C2E"
  }), React__default.createElement("path", {
    d: "M22.768 16.42c-.05 0-.107.023-.16.187-.041.128-.049.22-.023.29.035.096.136.173.308.236a.798.798 0 0 0 .253.053c.164 0 .213-.1.235-.177.037-.124-.008-.25-.348-.471-.09-.058-.19-.117-.265-.117zm.378.883a.84.84 0 0 1-.276-.058c-.201-.072-.317-.166-.363-.296-.04-.103-.032-.227.02-.388.056-.176.133-.258.241-.258.092 0 .2.062.304.13.29.187.468.364.392.619-.05.167-.157.251-.318.251z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M22.94 16.11c0-.144.027-.186.138-.176.095.008.122.069.101.176-.026.137-.052.196-.134.193-.06-.002-.105-.052-.105-.193z",
    fill: "#EC1C2E"
  }), React__default.createElement("path", {
    d: "M23.377 15.987c-.275 0-.35.088-.35.413 0 .293.114.444.336.45h.02c.227 0 .322-.102.421-.457.04-.148.027-.251-.045-.316-.055-.05-.148-.079-.283-.087a1.305 1.305 0 0 0-.099-.003zm.007.932h-.025c-.197-.006-.433-.1-.433-.52 0-.346.084-.508.56-.476.161.009.28.047.353.113.09.08.11.202.064.37-.097.348-.2.513-.52.513z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#EC1C2E",
    d: "M22.652 15.744l.16.278-.068.04-.16-.278z"
  }), React__default.createElement("path", {
    d: "M22.705 15.903l.551.718.17-.072-.553-.719-.168.073zm.513.823l-.653-.852.347-.148.653.851-.347.149z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M22.59 15.583c-.141 0-.143.223 0 .223.14 0 .149-.223 0-.223z",
    fill: "#EC1C2E"
  }), React__default.createElement("path", {
    d: "M22.967 15.678a.366.366 0 0 0-.287.121.412.412 0 0 0-.098.272c0 .188.12.39.385.39.256 0 .39-.203.39-.402a.39.39 0 0 0-.096-.265.381.381 0 0 0-.294-.116zm0 .891c-.326 0-.497-.25-.497-.498 0-.25.17-.502.497-.502.157 0 .286.054.378.154.08.088.125.207.125.336 0 .254-.173.51-.503.51z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M22.753 16.259c-.09-.13-.074-.194.015-.246.088-.052.154-.024.205.087.064.143.042.232-.012.266-.054.034-.119.02-.208-.107z",
    fill: "#EC1C2E"
  }), React__default.createElement("path", {
    d: "M23.163 16.039a.495.495 0 0 0-.208.055c-.113.055-.174.11-.192.175-.024.088.028.203.163.363.156.184.297.277.419.277.042 0 .084-.01.127-.032.13-.067.203-.256.02-.59-.092-.167-.2-.248-.33-.248zm.182.935c-.152 0-.31-.1-.484-.305-.147-.175-.203-.307-.174-.414.022-.084.095-.153.228-.217.279-.133.492-.06.649.223.203.371.107.59-.05.67a.368.368 0 0 1-.169.043zm-.381.4l-.144-.072.011-.028.144.072z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M23.686 16.837l-.042-.196.057-.003.043.196zm.466.563l-.02-.018.144-.157.02.018zm-.582.755l-.01-.025.289-.111.01.025zm-.44-.239l-.006-.034.242-.066.006.033z"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M23.068 17.86v-.078l.235-.017v.076zm1.533-.26l-.078-.13.023-.014.079.13zm-.45.923l-.006-.037.203-.063.006.037zm.595.192l-.017-.021.144-.111.017.02zm.106.051l-.02-.019.145-.144.019.02zm1.165.354l-.019-.02.164-.157.02.02zm.609.11l-.02-.019.184-.19.02.02zm-.5-1.226l-.262-.13.012-.025.262.131zm.27-.09l-.151-.248.023-.014.15.248zm.057-.015l-.091-.249.025-.009.092.248zm.553.095l-.05-.236.051-.003.05.236zm.173.018h-.076l.017-.242h.077zm-.004 1.136l-.027-.011.072-.15.028.01zm.115.05l-.032-.007.07-.222.03.007zm2.512.242a.436.436 0 0 1-.102-.211l.027-.003a.405.405 0 0 0 .095.194l-.02.02zm.442-.956a.56.56 0 0 1 .065-.263l.033.012a.552.552 0 0 0-.06.247l-.038.004zm.386-.205l-.025-.011.104-.236.026.012zm.244 1.124l-.23-.098.011-.025.23.098zm.068-.063l-.216-.06.005-.04.216.06zm.227-.3l-.004-.046.263-.055.003.046zm-2.163.356l-.242-.144.014-.023.242.143zm.141-.082l-.294-.073.006-.027.295.073z"
  }), React__default.createElement("path", {
    d: "M24.187 18.097c-.667-.027-1.204-.38-1.244-.797a.493.493 0 0 1 .707-.51c.616.274.459.915.813.967l-.276.34z",
    fill: "#008248"
  }), React__default.createElement("path", {
    d: "M23.428 16.755a.474.474 0 0 0-.35.152.5.5 0 0 0-.12.391c.038.413.575.757 1.223.785l.256-.317c-.148-.034-.205-.178-.27-.342-.084-.21-.187-.473-.522-.622a.53.53 0 0 0-.217-.047zm.766 1.355h-.007c-.665-.026-1.217-.381-1.257-.81a.5.5 0 0 1 .498-.573c.077 0 .154.017.228.05.345.154.451.422.536.637.068.171.122.307.273.33l.023.003-.294.363z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.916 18.214c-.314-.3-1.008-.862-1.467-.575-.458.288-.311.625-.183.771.183.21 1.009.34 1.584.157l.066-.353z",
    fill: "#008248"
  }), React__default.createElement("path", {
    d: "M24.738 17.574a.52.52 0 0 0-.281.077c-.18.112-.28.242-.302.385a.478.478 0 0 0 .121.366c.12.136.527.239.948.239.226 0 .438-.03.615-.084l.062-.338c-.208-.198-.726-.645-1.163-.645zm.486 1.094c-.435 0-.842-.104-.968-.249a.506.506 0 0 1-.128-.387c.022-.151.128-.287.314-.404a.547.547 0 0 1 .296-.082c.45 0 .98.46 1.187.659l.006.005-.001.007-.068.36-.007.003a2.12 2.12 0 0 1-.63.088z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M28.142 18.384c-.916-.366-1.545-.705-2.056-.405-.51.3-.327.745-.026.954.301.21 1.231.118 1.637.013.406-.104.51-.3.445-.562z",
    fill: "#008248"
  }), React__default.createElement("path", {
    d: "M26.528 17.877a.833.833 0 0 0-.435.114c-.199.117-.307.267-.313.434-.008.213.143.397.288.497.116.08.344.123.658.123.365 0 .757-.058.967-.112.364-.093.503-.265.438-.539a29.689 29.689 0 0 1-.352-.143c-.505-.21-.904-.374-1.25-.374zm.198 1.196c-.223 0-.52-.023-.674-.129-.192-.133-.306-.332-.3-.52.005-.123.066-.303.327-.457a.86.86 0 0 1 .45-.117c.35 0 .752.166 1.26.376.116.047.234.096.359.145l.006.003.002.007c.074.295-.071.48-.456.578a4.416 4.416 0 0 1-.974.114z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M29.557 18.829c.497.02.474-.13.608-.307.145-.19.532-.43.832-.19.328.261.393.614 0 .83-.393.215-.661.275-1.067.15-.406-.124-.642-.202-.727-.215.203-.079.301-.17.354-.268z",
    fill: "#008248"
  }), React__default.createElement("path", {
    d: "M29.25 19.093c.074.018.2.057.385.114l.299.092c.14.043.264.064.38.064.205 0 .401-.062.676-.213.16-.088.251-.204.263-.337.013-.154-.083-.326-.265-.47a.433.433 0 0 0-.275-.098c-.21 0-.43.143-.537.285a1.051 1.051 0 0 0-.061.093c-.076.124-.136.221-.475.221a2.7 2.7 0 0 1-.076-.001c-.058.103-.158.183-.315.25zm1.065.297c-.12 0-.247-.021-.39-.065a64.717 64.717 0 0 1-.298-.092c-.228-.07-.366-.114-.426-.123l-.05-.008.047-.018c.178-.069.287-.152.346-.262l.004-.007h.009c.398.016.454-.076.534-.206.02-.03.038-.062.064-.095.111-.147.339-.296.558-.296a.46.46 0 0 1 .292.103c.189.151.289.331.275.495-.013.141-.108.265-.276.358-.28.153-.48.216-.69.216z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M28.234 19.874c.04-.954 1.467-.379 1.362-1.307-.048-.417-.799-.365-1.401-.222-.603.144-.642.797-.668 1.555 0 .053.118.053.353.053.236 0 .36.013.354-.079z",
    fill: "#008248"
  }), React__default.createElement("path", {
    d: "M28.969 18.254c-.277 0-.573.057-.771.104-.61.146-.633.824-.658 1.543 0 .038.135.038.34.038h.14c.09 0 .165-.002.19-.028.008-.009.011-.02.01-.036.02-.487.387-.583.742-.676.345-.09.671-.177.62-.63-.03-.26-.35-.315-.613-.315zm-.948 1.713h-.14c-.26 0-.368 0-.368-.067.024-.697.049-1.418.678-1.568.2-.048.498-.105.778-.105.394 0 .615.117.64.339.054.477-.283.565-.64.659-.345.09-.703.184-.722.65a.07.07 0 0 1-.017.054c-.03.032-.094.038-.21.038z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M31.147 18.267c-.182.111-.229.248-.176.353.052.104.275.078.419-.007.144-.085.23-.255.164-.36-.066-.104-.256-.078-.407.014z",
    fill: "#EC1C2E"
  }), React__default.createElement("path", {
    d: "M31.653 18.224a.675.675 0 0 0-.382.149c-.247.184-.347.427-.263.633.03.074.107.115.218.115a.7.7 0 0 0 .66-.549.357.357 0 0 0-.022-.232c-.048-.096-.142-.116-.21-.116zm-.427.948c-.127 0-.218-.05-.256-.143-.074-.182-.04-.462.279-.7a.71.71 0 0 1 .404-.157c.115 0 .2.049.247.14a.42.42 0 0 1 .027.272.753.753 0 0 1-.285.443.75.75 0 0 1-.416.145z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#EC1C2E",
    d: "M31.998 17.888l-.223.23-.056-.054.223-.231z"
  }), React__default.createElement("path", {
    d: "M31.82 18.584l.117.111.641-.65-.117-.112-.64.65zm.119.23l-.24-.228.76-.772.24.228-.76.772z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M32.136 17.784c-.039-.136-.255-.076-.215.062.039.133.256.08.215-.062z",
    fill: "#EC1C2E"
  }), React__default.createElement("path", {
    d: "M32.424 17.806a.437.437 0 0 0-.348.172.373.373 0 0 0-.049.327.359.359 0 0 0 .36.276.423.423 0 0 0 .34-.164.378.378 0 0 0 .048-.336.353.353 0 0 0-.35-.275zm-.036.888a.467.467 0 0 1-.464-.358.49.49 0 0 1 .066-.426.545.545 0 0 1 .434-.216c.224 0 .394.133.456.356a.489.489 0 0 1-.066.434.53.53 0 0 1-.426.21z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M31.383 18.008c.076-.124.122-.167.216-.107.081.05.065.13-.003.216-.086.11-.136.15-.207.11-.052-.029-.079-.098-.006-.219z",
    fill: "#EC1C2E"
  }), React__default.createElement("path", {
    d: "M31.91 17.93c-.13 0-.233.112-.38.321-.105.15-.145.282-.116.378.017.056.057.1.117.13a.3.3 0 0 0 .129.033c.127 0 .252-.112.426-.304.122-.136.175-.251.155-.342-.012-.062-.056-.112-.135-.155a.418.418 0 0 0-.195-.062zm-.25.93a.387.387 0 0 1-.168-.041.287.287 0 0 1-.155-.172c-.035-.117.007-.262.125-.43.16-.232.28-.356.449-.356.07 0 .148.023.237.072.098.052.156.12.172.2.024.112-.035.245-.17.397-.195.215-.33.33-.49.33z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M31.682 18.252c.144-.023.206-.015.222.095.013.095-.058.133-.168.137-.14.006-.203-.006-.218-.087-.012-.058.025-.123.164-.145z",
    fill: "#EC1C2E"
  }), React__default.createElement("path", {
    d: "M32.179 18.329c-.06 0-.134.011-.24.037-.165.04-.28.124-.335.244a.434.434 0 0 0-.033.234c.027.214.117.284.37.284l.12-.003c.164-.01.275-.068.332-.172a.495.495 0 0 0 .04-.278c-.023-.255-.09-.346-.254-.346zm-.237.9c-.241 0-.398-.062-.435-.367a.583.583 0 0 1 .043-.31c.066-.145.193-.24.379-.285.11-.026.187-.039.25-.039.199 0 .291.126.319.433a.622.622 0 0 1-.056.357c-.069.126-.196.196-.377.207a2.302 2.302 0 0 1-.123.003z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M31.558 18.089c.113-.113.177-.107.241-.016.055.078.026.154-.087.198-.13.05-.184.087-.234.022-.036-.047-.02-.105.08-.204z",
    fill: "#EC1C2E"
  }), React__default.createElement("path", {
    d: "M32.091 18.068c-.09 0-.196.073-.336.23-.283.316-.26.446-.2.53.093.138.197.088.42-.014l.136-.06c.141-.061.23-.147.258-.248.021-.079.002-.168-.054-.258-.077-.123-.148-.18-.224-.18zm-.403.923c-.075 0-.135-.036-.189-.114-.11-.16-.048-.35.207-.634.154-.172.276-.252.385-.252.1 0 .19.068.281.212a.41.41 0 0 1 .063.326c-.034.125-.137.228-.3.297l-.134.06c-.134.061-.23.105-.313.105z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M23.328 17.094c-.126.063-.066.184.06.12.127-.063.068-.184-.06-.12z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M23.923 17.148a.574.574 0 0 0-.3.104c-.264.167-.329.387-.302.525a.25.25 0 0 0 .26.212.568.568 0 0 0 .296-.1c.267-.17.332-.392.305-.53-.024-.13-.124-.21-.259-.21zm-.342.921a.319.319 0 0 1-.322-.273c-.032-.167.037-.428.335-.616a.63.63 0 0 1 .329-.111c.167 0 .29.104.322.27.03.168-.039.432-.338.62a.621.621 0 0 1-.326.11z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M23.68 17.057c-.135.038-.099.168.038.13.135-.038.1-.169-.037-.13z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M24.218 17.13a.574.574 0 0 0-.205.042c-.274.109-.378.333-.36.506.021.231.24.342.508.237.275-.11.381-.335.363-.51-.015-.168-.135-.276-.306-.276zm-.258.913c-.23 0-.352-.177-.37-.352-.02-.21.098-.478.406-.602a.62.62 0 0 1 .222-.046c.203 0 .347.138.368.35.02.212-.098.482-.408.606a.612.612 0 0 1-.218.044z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M23.219 17.423c-.018.14.116.157.134.017.018-.14-.116-.16-.134-.017z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M23.758 17.378c-.184 0-.393.127-.446.407-.034.172.011.313.123.399a.376.376 0 0 0 .226.074c.183 0 .396-.125.45-.404.032-.172-.013-.315-.125-.402a.385.385 0 0 0-.228-.074zm-.097.94a.495.495 0 0 1-.294-.094c-.13-.1-.183-.258-.145-.447a.541.541 0 0 1 .536-.459c.11 0 .213.034.296.094.13.1.182.26.144.45a.541.541 0 0 1-.537.456z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M23.552 17.417c-.076.097 0 .158.076.06.076-.096.002-.158-.076-.06z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M24.256 17.44c-.136 0-.3.097-.454.27-.204.23-.227.405-.175.494.027.051.077.078.147.078.134 0 .298-.098.45-.27.206-.23.228-.408.176-.496-.025-.051-.077-.077-.144-.077zm-.482.92c-.103 0-.187-.044-.229-.122-.078-.142-.008-.358.187-.578.17-.19.363-.3.524-.3.1 0 .184.045.225.12.08.144.01.362-.187.582-.17.19-.36.299-.52.299z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M23.962 17.331c-.138.027-.113.16.026.133.14-.027.115-.16-.026-.133z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M24.466 17.41c-.05 0-.1.006-.156.022-.283.08-.397.302-.386.486.012.157.12.314.339.314a.516.516 0 0 0 .151-.024c.285-.08.4-.304.388-.488a.32.32 0 0 0-.336-.31zm-.203.91c-.257 0-.386-.198-.398-.392a.566.566 0 0 1 .433-.582.614.614 0 0 1 .168-.025c.256 0 .384.195.396.39a.569.569 0 0 1-.436.586.63.63 0 0 1-.163.024z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M23.91 17.728c-.088.101-.012.189.075.088.088-.101.014-.19-.075-.088z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M24.586 17.747c-.072 0-.221.03-.417.226-.231.232-.25.434-.199.536.033.062.095.096.176.096.07 0 .221-.028.412-.221.234-.235.253-.438.2-.54-.032-.062-.094-.097-.172-.097zm-.44.93c-.112 0-.204-.051-.25-.139-.066-.127-.044-.354.212-.612.16-.162.33-.25.478-.25.11 0 .2.05.246.138.067.128.045.356-.213.616-.158.16-.326.246-.473.246z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M23.566 17.736c-.071.122.046.19.117.068.071-.122-.044-.191-.117-.068z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M24.196 17.729c-.16 0-.329.107-.458.29-.13.183-.158.36-.079.475a.26.26 0 0 0 .22.105c.158 0 .33-.108.456-.288.13-.183.158-.362.079-.477a.26.26 0 0 0-.218-.105zm-.318.935a.34.34 0 0 1-.286-.138c-.094-.137-.066-.333.077-.538.146-.206.339-.324.527-.324.12 0 .225.05.286.137.095.14.066.337-.08.542-.143.204-.333.321-.524.321z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M24.457 17.983c-.071.122.045.19.117.068.071-.122-.044-.192-.117-.068z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M25.087 17.975c-.16 0-.328.107-.459.293-.129.181-.158.359-.078.474a.262.262 0 0 0 .219.105c.16 0 .33-.108.456-.289.13-.182.158-.36.079-.478a.255.255 0 0 0-.217-.105zm-.318.936a.342.342 0 0 1-.286-.137c-.095-.137-.066-.334.078-.538.144-.206.337-.325.526-.325.121 0 .224.05.285.138.096.138.067.336-.078.542-.143.203-.335.32-.525.32z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M24.72 17.775c-.09.108.012.195.104.087.091-.107-.01-.196-.103-.087z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M25.36 17.787c-.138 0-.29.084-.428.238-.163.18-.22.365-.156.5.04.08.12.125.223.125.138 0 .29-.082.425-.232.162-.183.22-.37.156-.505a.237.237 0 0 0-.22-.126zm-.361.932a.308.308 0 0 1-.287-.167c-.078-.158-.017-.371.164-.572.152-.168.323-.261.484-.261a.31.31 0 0 1 .285.165c.079.16.016.374-.166.576-.15.167-.322.259-.48.259z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M24.562 18.317c-.002.142.133.143.135.002.002-.141-.133-.145-.135-.001z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M25.058 18.265c-.193 0-.406.137-.412.438-.002.163.06.297.178.374a.408.408 0 0 0 .228.068c.195 0 .406-.137.412-.435.003-.165-.06-.299-.178-.378a.416.416 0 0 0-.228-.067zm-.006.94a.538.538 0 0 1-.294-.085.475.475 0 0 1-.203-.418.487.487 0 0 1 .503-.497c.106 0 .21.03.292.085a.47.47 0 0 1 .205.42c-.005.34-.266.495-.503.495z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M24.904 18.195c-.046.133.08.178.128.045.047-.133-.08-.18-.128-.045z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M25.504 18.17c-.145 0-.348.091-.47.347-.087.18-.082.34.013.44a.308.308 0 0 0 .223.089c.15 0 .35-.091.472-.345.087-.18.081-.343-.016-.443a.3.3 0 0 0-.222-.088zm-.233.938a.403.403 0 0 1-.292-.115c-.112-.116-.122-.297-.026-.496.14-.287.376-.39.551-.39.118 0 .22.04.29.114.115.118.124.3.028.502-.136.284-.374.385-.551.385z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M25.39 18.28c-.048.133.08.178.127.045s-.08-.18-.128-.045z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M25.989 18.255c-.146 0-.349.09-.472.347-.085.18-.08.34.016.442a.31.31 0 0 0 .222.087c.148 0 .35-.09.472-.344.087-.181.08-.344-.017-.445a.301.301 0 0 0-.221-.087zm-.232.938h-.002a.402.402 0 0 1-.291-.114c-.113-.117-.122-.298-.026-.497.138-.288.375-.39.55-.39.118 0 .22.04.292.114.113.118.122.3.025.501-.134.285-.373.386-.548.386z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M25.123 18.48c-.002.141.133.143.135.002.002-.141-.133-.145-.135-.002z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M25.619 18.428c-.194 0-.406.137-.41.438-.005.163.057.296.174.374a.409.409 0 0 0 .227.067c.195 0 .407-.135.413-.434.003-.165-.06-.299-.177-.378a.406.406 0 0 0-.227-.067zm-.01.94a.525.525 0 0 1-.29-.086.467.467 0 0 1-.203-.419c.007-.34.267-.496.503-.496.106 0 .21.03.293.086.135.091.208.24.204.421-.008.34-.267.493-.506.493z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M26.173 18.355c-.072.122.045.19.116.068.072-.121-.044-.191-.116-.068z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M26.802 18.348c-.16 0-.327.106-.459.292-.127.181-.158.36-.076.474a.258.258 0 0 0 .217.105c.16 0 .33-.107.458-.289s.157-.36.077-.477a.254.254 0 0 0-.217-.105zm-.318.936a.341.341 0 0 1-.286-.138c-.094-.137-.066-.334.079-.538.145-.206.336-.324.525-.324.121 0 .224.049.285.137.096.138.069.336-.078.542-.143.203-.335.32-.525.32z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M26.312 18.756c.037.136.168.101.131-.035-.037-.136-.168-.103-.13.035z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M26.702 18.688a.325.325 0 0 0-.222.082c-.101.093-.121.25-.053.428.103.271.315.368.466.368.088 0 .168-.03.225-.082.103-.094.122-.25.054-.427-.103-.272-.318-.369-.47-.369zm.191.94c-.19 0-.434-.11-.55-.412-.077-.202-.052-.374.068-.484a.428.428 0 0 1 .29-.105c.184 0 .438.108.555.414.076.199.05.369-.068.48a.432.432 0 0 1-.295.106z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M26.493 18.074c-.071.122.046.19.117.069.072-.122-.044-.192-.117-.069z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M27.123 18.067c-.16 0-.328.106-.458.292-.13.181-.157.359-.079.474a.26.26 0 0 0 .219.105c.16 0 .33-.107.457-.288.13-.182.158-.362.079-.478a.257.257 0 0 0-.218-.105zm-.318.935a.342.342 0 0 1-.286-.137c-.094-.137-.066-.333.078-.539.145-.206.337-.324.526-.324.122 0 .225.05.285.138.097.138.067.336-.079.542-.142.204-.334.32-.524.32z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M26.726 18.415c-.095.105.006.196.1.09.095-.105-.004-.196-.1-.09z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M27.365 18.43c-.136 0-.284.081-.422.229-.167.178-.23.367-.166.502.04.084.12.131.222.131.134 0 .283-.08.418-.225.169-.18.231-.37.168-.507-.038-.083-.119-.13-.22-.13zm-.366.93a.307.307 0 0 1-.288-.17c-.075-.162-.008-.379.18-.578.15-.16.319-.251.474-.251.129 0 .236.064.285.172.076.162.008.38-.179.58-.15.16-.317.248-.472.248z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M27.06 18.157c-.095.105.006.195.1.09.095-.105-.005-.197-.1-.09z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M27.699 18.171c-.134 0-.284.081-.422.228-.169.18-.23.368-.166.504.038.083.119.131.222.131.134 0 .285-.08.419-.226.17-.179.231-.369.167-.506-.038-.083-.118-.13-.22-.13zm-.366.932a.304.304 0 0 1-.288-.172c-.075-.162-.008-.377.178-.577.152-.163.32-.251.476-.251.128 0 .236.063.285.17.076.163.01.38-.178.582-.15.16-.32.248-.473.248z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M26.893 18.833c.06.128.182.072.123-.057-.06-.128-.183-.073-.123.057z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M27.228 18.76a.277.277 0 0 0-.22.095c-.087.106-.074.275.036.46.118.2.291.319.466.319.093 0 .17-.035.22-.096.089-.109.077-.275-.03-.458-.12-.2-.296-.32-.472-.32zm.282.937c-.207 0-.408-.132-.54-.354-.122-.206-.132-.397-.028-.523a.368.368 0 0 1 .286-.123c.21 0 .412.132.544.356.12.204.131.392.027.519a.368.368 0 0 1-.289.125z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M27.205 18.54c-.05.133.077.18.126.048.05-.132-.076-.181-.126-.047z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M27.81 18.516c-.145 0-.346.09-.472.343-.092.182-.09.343.005.444a.29.29 0 0 0 .221.089c.146 0 .345-.09.472-.338.091-.182.09-.345-.007-.448a.297.297 0 0 0-.22-.09zm-.246.938a.398.398 0 0 1-.29-.115c-.11-.119-.116-.301-.015-.501.121-.24.325-.384.55-.384.116 0 .22.043.29.117.111.12.117.303.016.505-.142.279-.377.378-.55.378z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M28.07 19.319c-.122-.07-.21.066-.086.136.122.07.21-.065.086-.136z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M28.311 19.364a.327.327 0 0 0-.323.26c-.031.14.015.345.246.497a.52.52 0 0 0 .287.1c.158 0 .29-.104.325-.26.033-.139-.016-.344-.248-.498a.528.528 0 0 0-.287-.099zm.21.928a.577.577 0 0 1-.318-.108c-.261-.173-.313-.411-.274-.578a.39.39 0 0 1 .382-.314.58.58 0 0 1 .319.108c.26.175.314.415.276.58a.392.392 0 0 1-.385.312z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M27.848 18.927c-.123-.07-.21.066-.087.136s.211-.065.087-.136z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M28.088 18.972a.325.325 0 0 0-.321.261c-.034.14.014.344.244.497a.519.519 0 0 0 .289.099.325.325 0 0 0 .323-.26c.033-.14-.015-.344-.248-.498a.521.521 0 0 0-.287-.099zm.212.928a.58.58 0 0 1-.32-.107c-.26-.174-.312-.413-.274-.58a.39.39 0 0 1 .382-.313.57.57 0 0 1 .318.108c.263.175.317.413.277.58a.391.391 0 0 1-.383.312z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M28.62 18.88c-.122-.07-.229.08-.106.15.123.07.23-.078.106-.15z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M28.904 18.924a.396.396 0 0 0-.382.314c-.04.176.038.349.211.462.089.06.178.088.266.088a.395.395 0 0 0 .383-.313c.04-.175-.04-.35-.214-.464a.49.49 0 0 0-.264-.087zm.095.932a.536.536 0 0 1-.295-.097c-.197-.13-.287-.331-.239-.539a.456.456 0 0 1 .439-.364c.097 0 .197.032.293.095.2.132.291.334.242.542a.456.456 0 0 1-.44.363z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M28.764 18.471c-.135-.045-.178.082-.044.128.134.045.18-.082.044-.128z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M28.989 18.539a.281.281 0 0 0-.293.258c-.02.166.079.39.345.514.082.039.16.058.232.058a.28.28 0 0 0 .294-.259c.021-.165-.08-.389-.349-.513a.55.55 0 0 0-.23-.058zm.285.915a.606.606 0 0 1-.253-.062c-.321-.15-.408-.422-.386-.61.024-.198.163-.328.353-.328.078 0 .162.021.251.062.324.151.412.422.39.609-.024.2-.165.33-.355.33z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M28.195 18.854c-.106-.05-.14.093-.034.145.105.05.141-.093.034-.145z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M28.449 18.913a.27.27 0 0 0-.273.22c-.04.18.043.434.332.571a.51.51 0 0 0 .22.057.27.27 0 0 0 .275-.222c.04-.178-.046-.432-.335-.57a.514.514 0 0 0-.219-.056zm.279.924a.597.597 0 0 1-.255-.064c-.324-.156-.42-.45-.371-.656a.345.345 0 0 1 .347-.28c.077 0 .164.022.253.064.328.157.424.45.376.655a.348.348 0 0 1-.35.281z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M29.019 18.974c-.134-.045-.178.082-.044.128.134.045.18-.082.044-.128z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M29.244 19.043c-.158 0-.274.1-.291.257-.022.166.078.392.344.515.082.038.16.058.232.058.16 0 .276-.102.294-.258.02-.167-.08-.391-.349-.515a.548.548 0 0 0-.23-.057zm.285.915a.6.6 0 0 1-.252-.062c-.321-.152-.41-.423-.386-.61.023-.2.162-.328.353-.328.078 0 .162.02.25.061.325.15.413.422.39.609-.023.2-.163.33-.355.33z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M29.23 18.593c-.135-.045-.192.097-.059.143.135.045.194-.097.058-.143z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M29.493 18.656c-.208 0-.32.154-.341.307-.019.153.052.372.317.488a.54.54 0 0 0 .211.049c.211 0 .325-.154.344-.308.021-.16-.052-.37-.319-.487a.54.54 0 0 0-.212-.049zm.187.922a.576.576 0 0 1-.231-.054c-.3-.13-.38-.391-.356-.574.023-.185.156-.372.4-.372.073 0 .151.018.23.054.306.132.385.39.362.573a.408.408 0 0 1-.405.373z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M29.828 18.989c-.092-.107-.195-.018-.102.088.093.107.196.02.102-.088z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M30.002 19.003c-.101 0-.182.047-.221.128-.064.135-.006.323.157.503.138.15.29.231.427.231.102 0 .184-.046.222-.127.064-.134.004-.322-.163-.504-.136-.15-.285-.231-.422-.231zm.363.93c-.158 0-.33-.089-.48-.254-.182-.201-.247-.416-.171-.576a.31.31 0 0 1 .288-.17c.158 0 .327.091.476.256.186.202.25.418.173.578a.304.304 0 0 1-.286.167z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M30.327 18.931c-.12-.074-.203.065-.083.14.12.074.205-.064.083-.14z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M30.561 18.972a.31.31 0 0 0-.308.24c-.037.143.008.354.246.517.1.069.203.104.295.104.15 0 .271-.094.309-.238.037-.143-.008-.354-.25-.518a.515.515 0 0 0-.292-.105zm.233.93a.58.58 0 0 1-.329-.114c-.267-.184-.317-.427-.272-.596a.373.373 0 0 1 .368-.29c.105 0 .214.04.325.116.273.185.322.428.279.595a.377.377 0 0 1-.371.29z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M30.687 19.016c-.12-.075-.203.065-.083.14.12.074.205-.064.083-.14z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M30.92 19.058a.309.309 0 0 0-.305.239c-.039.143.006.355.245.517.1.07.202.104.296.104.148 0 .27-.093.308-.239.038-.142-.008-.353-.25-.517a.531.531 0 0 0-.293-.104zm.236.93a.58.58 0 0 1-.33-.115c-.269-.183-.317-.427-.273-.596a.373.373 0 0 1 .368-.29c.106 0 .216.04.327.116.27.184.32.428.277.595a.373.373 0 0 1-.37.29z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M30.478 18.467c-.12-.074-.217.071-.097.146s.218-.07.097-.146z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M30.738 18.507a.354.354 0 0 0-.344.272c-.047.182.035.366.222.495a.51.51 0 0 0 .284.098.356.356 0 0 0 .345-.27c.048-.183-.037-.368-.226-.497a.503.503 0 0 0-.281-.098zm.162.933a.556.556 0 0 1-.316-.11c-.25-.17-.293-.405-.25-.57a.418.418 0 0 1 .404-.32c.103 0 .208.036.315.108.25.172.295.407.253.571a.418.418 0 0 1-.406.32z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M30.753 18.63c-.12-.074-.216.072-.096.146.12.075.218-.07.096-.146z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M31.013 18.67a.355.355 0 0 0-.344.272c-.047.182.036.368.222.496a.508.508 0 0 0 .285.097.355.355 0 0 0 .346-.271c.048-.182-.037-.367-.227-.496a.491.491 0 0 0-.282-.097zm.163.933a.563.563 0 0 1-.318-.108c-.249-.17-.291-.407-.249-.57a.418.418 0 0 1 .404-.322.55.55 0 0 1 .314.108c.253.172.296.408.254.572a.417.417 0 0 1-.405.32z",
    fill: "#AAC456"
  }), React__default.createElement("path", {
    d: "M25.13 17.466c-.193.13-.248.389-.14.552.108.164.291.118.392 0 .102-.117.082-.398.027-.497l-.279-.055z",
    fill: "#EC1C2E"
  }), React__default.createElement("path", {
    d: "M25.309 17.494c-.323.179-.437.538-.242.773a.393.393 0 0 0 .31.145h.001c.13 0 .268-.055.368-.148.176-.163.142-.551.05-.693l-.487-.077zm.07.958h-.001a.447.447 0 0 1-.353-.164c-.21-.254-.087-.642.264-.832l.01-.004.01.001.52.083.005.008c.101.14.15.562-.05.746a.616.616 0 0 1-.406.162z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.353 17.066c-.141 0-.143.224 0 .224.14 0 .149-.224 0-.224z",
    fill: "#EC1C2E"
  }), React__default.createElement("path", {
    d: "M25.73 17.161c-.265 0-.385.205-.385.394 0 .187.12.39.384.39.257 0 .391-.204.391-.403a.393.393 0 0 0-.097-.264.38.38 0 0 0-.294-.117zm0 .892c-.326 0-.497-.251-.497-.498a.52.52 0 0 1 .123-.343.482.482 0 0 1 .373-.16c.157 0 .287.054.38.154.08.089.124.207.124.336 0 .253-.173.51-.504.51z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.206 17.156c-.149 0-.15.235 0 .235.147 0 .156-.235 0-.235z",
    fill: "#EC1C2E"
  }), React__default.createElement("path", {
    d: "M25.577 17.246c-.266 0-.39.207-.39.399 0 .19.123.394.39.394.26 0 .395-.205.395-.407a.392.392 0 0 0-.096-.267.388.388 0 0 0-.299-.119zm0 .896c-.34 0-.497-.258-.497-.497 0-.13.045-.252.125-.342a.475.475 0 0 1 .372-.16.5.5 0 0 1 .38.153.502.502 0 0 1 .123.336c0 .253-.172.51-.503.51z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.435 17.205c-.149 0-.15.235 0 .235.147 0 .157-.235 0-.235z",
    fill: "#EC1C2E"
  }), React__default.createElement("path", {
    d: "M25.806 17.295a.375.375 0 0 0-.29.122.423.423 0 0 0-.1.277c0 .19.123.394.39.394.26 0 .395-.204.395-.407a.385.385 0 0 0-.097-.267.386.386 0 0 0-.298-.119zm0 .896a.482.482 0 0 1-.497-.497c0-.13.044-.252.124-.343a.478.478 0 0 1 .373-.16c.157 0 .288.053.38.154a.5.5 0 0 1 .123.336c0 .253-.172.51-.503.51z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.343 17.531c.072.112.288.043.291-.15-.045.02-.183.06-.261.013l-.03.137z",
    fill: "#EC1C2E"
  }), React__default.createElement("path", {
    d: "M25.42 18.067c.062.115.16.18.28.18.245 0 .504-.266.539-.714-.11.052-.296.117-.476.117a.53.53 0 0 1-.266-.064l-.077.481zm.28.293c-.154 0-.285-.09-.362-.249l-.01-.02.109-.678.05.04a.44.44 0 0 0 .276.082c.208 0 .421-.092.505-.14l.06-.035v.088c-.007.572-.326.912-.629.912z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.235 17.384c-.082-.013-.167-.049-.19-.144a.168.168 0 0 0 .193.272l-.003-.128z",
    fill: "#EC1C2E"
  }), React__default.createElement("path", {
    d: "M25.198 17.378a.393.393 0 0 0-.074.464c.088.176.29.29.513.29a.78.78 0 0 0 .241-.04l-.011-.325c-.35-.054-.574-.184-.669-.39zm.44.836c-.265 0-.503-.134-.606-.34-.106-.21-.048-.443.152-.608l.063-.052.02.072c.065.22.286.356.658.405l.041.005.014.45-.031.01a.908.908 0 0 1-.312.058z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.255 17.574c-.082-.026-.084-.146-.072-.2.026-.123.278-.058.245.082-.025.11-.095.143-.173.118z",
    fill: "#EC1C2E"
  }), React__default.createElement("path", {
    d: "M25.571 17.386c-.075 0-.255.017-.292.183-.038.166-.033.536.223.612.269.082.48-.052.556-.36a.278.278 0 0 0-.062-.256.583.583 0 0 0-.425-.179zm.084.91c-.06 0-.12-.01-.182-.029-.308-.092-.34-.488-.29-.716.037-.16.182-.256.388-.256.194 0 .39.084.5.213a.36.36 0 0 1 .08.334c-.07.288-.252.453-.496.453zm-2.384-.857l-.157-.085.013-.024.157.085zm.061-.269l-.118-.163.022-.016.118.163zm.358-.046l-.033-.193.067-.002.033.193zm-.12.323l-.122-.108.019-.02.12.107zm.031.338l-.164-.098.014-.023.164.097zm.319-.011l-.144-.131.018-.02.144.13zm.053-.4l-.064-.189.037-.006.063.19zm-.592-.237l-.032-.183.068-.002.032.183zm1.122.893l-.164-.078.011-.024.164.078zm.238-.204l-.11-.105.018-.02.11.105zm-.113.489l-.177-.073.01-.027.177.071zm.312-.005l-.15-.018v-.077l.15.02zm.011-.098l-.15-.124.017-.022.15.125zm.532.134l-.21-.042.003-.058.21.042zm-.313.194h-.197v-.077h.197zm1.026-.056l-.177-.042.003-.058.177.041zm.032-.128l-.15-.118.016-.021.151.118zm.305-.231l-.15-.07.01-.03.15.07zm.549.081l-.144-.078.012-.024.145.079zm-.364.317l-.177-.066.007-.034.177.067zm.046-.09l-.124-.124.019-.02.125.125zm.492.162l-.21-.063.006-.037.209.063zm-.472.301l-.008-.033.17-.067.009.033zm1.02.098l-.042-.19.058-.003.042.19zm.291.39h-.077v-.203h.077z",
    fill: "#000"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M28.07 19.396l-.013-.024.177-.104.014.023zm.536-.449l-.058-.002.042-.19.058.003z"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M28.62 18.965l-.013-.024.223-.118.013.024zm.607-.297l-.021-.018.118-.138.02.018zm-.465-.118l-.022-.017.125-.163.022.016zm1.04.49l-.02-.017.118-.138.02.018zm.469-.057l-.034-.008.067-.196.033.007zm.028.033l-.018-.021.131-.111.018.02zm.347.071l-.018-.02.144-.13.018.02zm.054-.367l-.021-.018.118-.137.02.018zm-.246-.168l-.027-.009.074-.21.026.01z"
  }), React__default.createElement("path", {
    d: "M24.986 12.425c-.116-.084-.09-.191.118-.34.16-.115.337-.31.33-.448-.007-.152.038-.161.08-.013a.55.55 0 0 1 .014.295c.092-.13.13-.383.126-.481-.003-.098.069-.196.098-.026.03.17.03.229.02.3.054-.028.105-.05.162-.078a1.23 1.23 0 0 0 .054-.284c.007-.167.06-.249.085-.108.015.08.025.189.026.297a.44.44 0 0 0 .158-.18c.055-.127.094-.249.127-.01a.57.57 0 0 1-.001.148c.274-.157.66.15.862.104.203-.046.184 0 .118.059a.58.58 0 0 1-.118.077c.24.07.384.258.502.453a.596.596 0 0 0-.476-.752c-.275-.033-.595-.073-.432-.399.085-.17.182-.3.503-.307.059-.148.258-.22.676-.19.537.04 1.08.144 1.551.406.472.261.76.405 1.022.287a.588.588 0 0 1-.123.247c.799.496 1.41 1.181 1.616 1.844.118.38.21.771.537.824a.366.366 0 0 1-.183.08c.124.431.11 1.142.006 1.527-.105.386 0 1.066-.137 1.523-.128.425-.158.137-.158-.059 0-.536-.118-.706-.111-1.836 0-.156-.085-.295-.178-.423-.059.712.217 1.135.047 2.148-.05.294-.137.04-.157-.405-.02-.445-.164-.693-.216-1.098a1.12 1.12 0 0 0-.13-.392c.007.425.162 1.241.117 1.673-.032.3-.131.059-.131-.098 0-.458-.19-.706-.243-1.118-.014-.114-.093-.284-.218-.475.08.32.127.704.134.887.006.183-.02.274-.092.157-.072-.118-.144-.34-.17-.621-.027-.28-.225-.425-.382-.581.111.209.228.545.277.764.045.2-.013.235-.053.157-.039-.079-.163-.294-.229-.497a.755.755 0 0 0-.4-.457c-.176-.072-.183-.066-.379-.268.196.222.413.522.524.751.111.229.078.268-.026.177-.105-.092-.144-.15-.242-.314-.209-.347-.25-.268-.38-.3-.131-.033-.262-.08-.439-.302a.23.23 0 0 1-.123.084c.177.32.262.658.28.975.458.34 1.572 1.059 2.252 1.53.319.22.066.318-.176.326-.177.007-.258.005-.328-.039-.046.157-.353.275-.543.13-.085.132-.303.178-.491.007-.105.105-.249.086-.347-.006-.099-.092-.15-.13-.439-.405.02.34-.098.15-.144.026-.02.366-.103.296-.175.172-.057.295-.192.311-.277.174l-.117-.193c-.06.353-.184.252-.243.134-.059-.117-.138-.223-.289-.438-.057.066-.136-.041-.28-.254-.032-.047-.074-.102-.123-.167-.043.457-.173.42-.283.274-.124.059-.36.167-.583.187-.237.02-.247-.081-.16-.205-.301-.04-.567-.102-.573-.213-.007-.112.382-.333.605-.477-.198-.16-.286-.339-.252-.373.046-.046.197.007.334.078-.19-.222-.425-.621-.373-.751-.046-.05-.092-.1-.137-.146-.08.05-.187.068-.165-.063.027-.15-.17-.464-.183-.712-.013-.249.164-.367.236-.615-.058-.011-.074-.055-.059-.117.03-.121.226-.287.288-.48-.087.002-.104-.006-.046-.08a.797.797 0 0 0 .134-.317c-.045.03-.062.015-.062-.032 0-.081-.05-.104-.104-.117-.125-.03-.93-.072-1.14-.222z",
    fill: "#AD6119"
  }), React__default.createElement("path", {
    d: "M29.942 17.745l.01.008c.097.089.19.108.251.107a.257.257 0 0 0 .22-.11l.007-.013.012.009c.054.04.122.062.196.062.148 0 .297-.085.326-.186l.005-.017.015.01c.047.03.1.04.2.04l.12-.003c.14-.005.29-.043.31-.114.015-.05-.034-.114-.14-.188a79.09 79.09 0 0 0-.98-.66c-.493-.33-1.003-.669-1.274-.87l-.005-.004v-.006a2.278 2.278 0 0 0-.278-.97l-.008-.014.016-.005a.219.219 0 0 0 .116-.079l.01-.015.012.015c.173.218.303.264.43.296a.435.435 0 0 0 .069.01c.087.008.15.014.32.297.095.158.133.218.24.31.045.04.063.043.068.043.006-.006.016-.038-.063-.203a3.742 3.742 0 0 0-.522-.748l.02-.019c.18.187.199.194.34.251l.035.014a.76.76 0 0 1 .407.466c.053.163.143.334.198.436l.03.059c.012.022.023.03.028.03l.004-.002c.013-.016.019-.071-.004-.176a3.6 3.6 0 0 0-.276-.761l.022-.016.07.068c.144.136.292.277.315.522.027.295.105.511.168.615.028.044.041.046.043.046l.003-.002c.006-.007.026-.04.02-.194a5.22 5.22 0 0 0-.132-.884l.025-.01c.127.196.205.367.22.48.022.174.07.32.116.463.062.192.126.391.126.657 0 .047.01.106.026.154.017.055.035.073.041.073 0 0 .023-.004.037-.13.027-.258-.017-.648-.06-1.025-.027-.245-.054-.477-.056-.647l.026-.006c.071.133.113.26.13.396.023.174.063.32.101.462.051.188.104.383.115.637.016.366.072.517.093.518 0 0 .02-.005.038-.114.099-.59.047-.973-.003-1.343a3.44 3.44 0 0 1-.045-.804l.003-.037.022.03c.094.13.182.271.18.43-.003.676.038 1.01.07 1.28.023.183.042.34.042.557 0 .04.001.12.01.183.011.077.026.082.027.082.003 0 .032-.006.093-.21.073-.243.078-.547.081-.841.004-.258.007-.5.057-.681.099-.365.12-1.08-.007-1.52l-.004-.015.016-.003a.38.38 0 0 0 .153-.059c-.286-.065-.385-.39-.49-.734l-.028-.093c-.202-.649-.804-1.336-1.61-1.837l-.014-.008.01-.012a.58.58 0 0 0 .114-.215.486.486 0 0 1-.176.032c-.22 0-.472-.13-.832-.33-.406-.226-.912-.358-1.546-.404-.387-.028-.602.03-.662.18l-.004.01h-.009c-.318.006-.41.139-.49.3-.048.093-.056.166-.026.22.06.112.266.137.447.158a.596.596 0 0 1 .401.253c.102.148.132.33.086.516l-.008.032-.017-.028c-.11-.181-.254-.376-.494-.447l-.033-.01.03-.016a.56.56 0 0 0 .116-.074c.041-.038.04-.049.04-.05 0 0-.005-.004-.026-.004a.618.618 0 0 0-.12.018.215.215 0 0 1-.048.005.929.929 0 0 1-.276-.069 1.137 1.137 0 0 0-.36-.085.343.343 0 0 0-.175.043l-.024.014.004-.027a.535.535 0 0 0-.03-.269c-.012.004-.038.065-.056.105l-.014.034a.453.453 0 0 1-.162.185l-.021.015v-.026a1.656 1.656 0 0 0-.027-.295c-.01-.055-.021-.06-.021-.06-.01.003-.032.058-.036.166a1.258 1.258 0 0 1-.055.288l-.001.005-.006.003a2.746 2.746 0 0 1-.07.033 2.383 2.383 0 0 0-.092.045l-.023.013.003-.026a.87.87 0 0 0-.02-.297c-.01-.064-.026-.081-.033-.081-.003 0-.006.002-.01.005a.159.159 0 0 0-.028.1c.004.104-.036.357-.128.488l-.024-.011a.532.532 0 0 0-.015-.287c-.02-.074-.038-.095-.043-.097-.002.003-.012.028-.009.105.007.14-.164.337-.336.46-.12.085-.181.16-.182.22 0 .035.021.067.064.098.152.108.633.16.92.192.105.011.181.02.215.027.057.014.115.04.115.131 0 .013.001.034.01.034.004 0 .013-.002.03-.013l.028-.02-.007.034a.791.791 0 0 1-.136.323c-.031.04-.032.05-.031.052.001.001.008.005.048.005h.037l-.006.018a1.039 1.039 0 0 1-.172.288c-.055.074-.103.137-.116.19-.008.034-.006.059.005.076.008.013.022.021.043.025l.015.003-.005.015c-.029.102-.075.18-.12.257-.065.112-.122.209-.114.353.006.12.058.261.104.385.05.135.093.25.079.33-.006.033-.003.058.008.072.02.024.08.013.135-.022l.01-.006.007.008c.028.028.056.057.083.087l.055.058.006.006-.003.009c-.046.114.165.497.37.738l-.016.02c-.156-.081-.285-.113-.318-.08-.002 0-.004.005-.004.015.003.055.086.2.254.338l.015.012-.016.01a8.9 8.9 0 0 1-.12.075c-.204.128-.484.304-.48.389.006.085.195.152.563.2l.022.003-.013.018c-.043.062-.057.11-.041.142.019.036.085.051.188.042.229-.02.474-.136.58-.185l.01-.005.006.009c.046.06.088.092.122.092.047 0 .108-.062.136-.36l.003-.034.027.036c.047.061.087.114.117.159.095.138.183.268.233.268.006 0 .016-.002.027-.015l.011-.013.01.014.076.108c.103.147.166.235.214.332.025.05.065.102.104.102.028 0 .08-.03.113-.232l.006-.036.019.031c.046.076.084.14.118.193.03.05.066.077.101.077.064 0 .12-.093.15-.247l.007-.036.019.032c.047.08.073.093.084.093.015 0 .053-.025.065-.26l.027-.003c.033.09.08.157.099.157l.003-.002c.008-.007.023-.04.015-.176l-.002-.034.025.024c.197.188.282.264.35.325.031.027.058.05.089.08a.258.258 0 0 0 .174.073c.057 0 .11-.023.154-.066l.01-.01zm.261.143a.393.393 0 0 1-.26-.106.24.24 0 0 1-.164.066.285.285 0 0 1-.193-.081c-.03-.03-.057-.053-.088-.08-.065-.059-.146-.131-.326-.302.004.117-.011.148-.024.162a.031.031 0 0 1-.023.01c-.039 0-.078-.07-.102-.121-.013.156-.041.227-.089.227-.027 0-.056-.025-.09-.077-.047.203-.125.235-.17.235-.045 0-.089-.032-.125-.09l-.099-.162c-.028.146-.073.22-.133.22-.064 0-.114-.09-.128-.117a2.684 2.684 0 0 0-.212-.33l-.067-.094a.057.057 0 0 1-.035.012c-.062 0-.133-.101-.255-.28-.027-.04-.062-.085-.102-.138-.025.235-.077.35-.16.35-.04 0-.086-.032-.136-.095-.111.052-.352.163-.578.183-.118.01-.19-.009-.215-.057-.02-.037-.01-.088.03-.151-.378-.051-.557-.122-.563-.223-.006-.093.21-.236.492-.413l.103-.065c-.157-.132-.245-.275-.249-.345 0-.016.003-.028.011-.037.014-.014.036-.02.065-.02a.61.61 0 0 1 .228.068c-.18-.227-.378-.573-.337-.708a5.355 5.355 0 0 1-.124-.132c-.067.04-.133.045-.162.011-.016-.02-.021-.051-.014-.093.012-.073-.031-.191-.078-.317a1.438 1.438 0 0 1-.105-.393c-.009-.152.053-.256.117-.367.042-.072.086-.146.114-.238a.082.082 0 0 1-.046-.034c-.015-.024-.018-.056-.008-.097.014-.059.063-.124.12-.2.06-.08.127-.168.162-.262-.04 0-.064-.004-.072-.022-.01-.019.006-.044.035-.08a.743.743 0 0 0 .124-.283c-.037.013-.055-.008-.055-.058 0-.068-.037-.09-.095-.104a2.78 2.78 0 0 0-.211-.027c-.29-.032-.775-.084-.933-.197-.05-.036-.075-.077-.075-.121 0-.07.063-.149.193-.241.162-.116.331-.308.325-.436-.003-.067.003-.11.018-.126a.026.026 0 0 1 .018-.008c.01 0 .037 0 .07.116a.692.692 0 0 1 .028.224 1.08 1.08 0 0 0 .085-.406c-.001-.047.013-.096.036-.118a.04.04 0 0 1 .029-.015c.028 0 .049.035.06.104a.93.93 0 0 1 .023.28l.071-.034.064-.031a1.24 1.24 0 0 0 .051-.275c.004-.089.023-.193.065-.193.022 0 .037.027.047.083.015.078.024.177.026.274a.405.405 0 0 0 .132-.16l.014-.032c.034-.08.053-.122.081-.122.023 0 .042.025.059.149a.55.55 0 0 1 0 .125.379.379 0 0 1 .166-.035c.122 0 .254.046.37.087.12.042.233.08.308.063a.633.633 0 0 1 .126-.02c.019 0 .044.003.052.023.007.018-.007.042-.048.079a.517.517 0 0 1-.092.063c.218.077.356.252.46.421a.583.583 0 0 0-.47-.703c-.188-.022-.402-.047-.468-.171-.035-.064-.026-.145.025-.247.083-.167.18-.305.506-.315.07-.157.291-.218.686-.19.638.047 1.148.18 1.557.408.357.197.606.327.819.327.068 0 .13-.013.19-.04l.025-.011-.006.026a.594.594 0 0 1-.116.24c.805.504 1.406 1.193 1.609 1.844l.028.093c.106.347.206.675.498.721l.028.005-.021.019a.372.372 0 0 1-.175.08c.124.447.1 1.156.002 1.52-.048.179-.052.42-.055.675-.004.296-.009.602-.082.849-.061.202-.095.23-.12.23-.027 0-.044-.033-.054-.106a1.45 1.45 0 0 1-.01-.187c0-.215-.02-.372-.042-.554a8.796 8.796 0 0 1-.07-1.282c.001-.14-.07-.267-.153-.385-.02.278.013.513.046.761.051.372.103.757.003 1.351-.016.095-.036.138-.064.138-.076 0-.11-.342-.12-.545a2.66 2.66 0 0 0-.114-.63 3.381 3.381 0 0 1-.102-.466 1.061 1.061 0 0 0-.1-.333c.007.16.03.367.055.583.043.378.087.77.06 1.03-.012.106-.033.155-.065.155-.031 0-.054-.05-.067-.091a.558.558 0 0 1-.027-.163c0-.262-.06-.45-.125-.649a2.378 2.378 0 0 1-.117-.467c-.012-.096-.073-.237-.173-.4.07.313.11.654.115.81.006.177-.02.204-.028.213a.033.033 0 0 1-.023.01c-.02 0-.041-.019-.066-.06-.084-.137-.148-.37-.172-.626-.022-.234-.166-.371-.306-.504l-.014-.013c.105.22.2.511.242.696.022.1.022.17 0 .199a.033.033 0 0 1-.026.013c-.019 0-.037-.016-.052-.046l-.03-.058a2.914 2.914 0 0 1-.2-.44.736.736 0 0 0-.391-.45l-.035-.014a.639.639 0 0 1-.176-.09c.155.197.293.406.372.57.081.166.076.21.065.227-.016.025-.054.016-.112-.035-.106-.092-.147-.153-.245-.317-.163-.271-.22-.276-.3-.284a.437.437 0 0 1-.072-.01c-.13-.033-.261-.08-.435-.293a.24.24 0 0 1-.104.07c.16.291.254.623.274.96.271.201.778.539 1.267.865.345.23.701.468.98.66.12.083.17.156.152.219-.027.09-.19.128-.336.133-.175.007-.256.003-.32-.033-.043.106-.193.19-.347.19a.352.352 0 0 1-.2-.06.287.287 0 0 1-.235.112z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.76 12.226l-.003-.027c.235-.025.49-.173.492-.37.001-.034-.004-.078-.028-.09-.049-.023-.161.07-.198.101a1.503 1.503 0 0 1-.367.228l-.01-.025c.174-.078.28-.157.36-.223.08-.068.17-.133.226-.106.031.015.046.053.045.116-.004.212-.271.37-.517.396zm1.184-.158l-.054-.002.003-.027c.107.008.176-.009.194-.046.015-.031-.005-.082-.055-.134-.094-.101-.417-.25-.667-.25v-.028c.267 0 .59.156.687.26.059.061.08.121.06.164-.02.042-.077.063-.168.063z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M26.85 12.223a.582.582 0 0 1-.125-.017 1.697 1.697 0 0 1-.528-.204l.014-.024c.14.082.281.147.52.201.125.029.181.015.192-.007.012-.023-.016-.066-.07-.11a1.837 1.837 0 0 0-.571-.281l.008-.026c.233.073.45.18.58.287.068.054.096.106.078.142-.013.025-.046.039-.098.039zm.842.7c-.01 0-.02-.004-.032-.02-.051-.068-.157-.095-.236-.106l.003-.027c.085.012.198.041.255.117.005.007.01.01.01.009.029-.015.049-.21.005-.363-.045-.158-.176-.417-.54-.752l.019-.02c.369.34.501.603.547.764.044.152.033.37-.019.395a.025.025 0 0 1-.012.003z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M27.316 13.092c-.045 0-.092-.048-.138-.095a1.377 1.377 0 0 0-.04-.04c-.105-.097-.345-.365-.319-.742l.028.001c-.027.377.23.647.31.721l.04.041c.045.045.096.098.129.085.02-.006.049-.038.07-.157.05-.293-.085-.691-.304-.89l.019-.02c.224.204.364.614.311.914-.019.11-.047.167-.088.18a.065.065 0 0 1-.018.002zm-.956-.661a.878.878 0 0 1-.184-.03.6.6 0 0 0-.212-.028l-.004-.027a.647.647 0 0 1 .222.028c.125.03.244.057.265-.018a.058.058 0 0 0-.019-.062c-.071-.068-.313-.078-.488-.02l-.009-.026c.167-.056.43-.056.516.026a.085.085 0 0 1 .026.089c-.015.051-.057.068-.113.068z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M26.328 12.247l-.011-.024c.06-.028.075-.075.087-.112l.003-.01.026.008-.003.01c-.013.04-.03.096-.102.128zm.306.35c-.089 0-.182-.065-.239-.166l.024-.013c.052.092.136.152.215.152h.003c.074-.002.14-.054.19-.152l.024.013c-.069.135-.154.164-.213.166h-.004zm.568 2.53c-.056 0-.13-.047-.28-.176-.202-.174-.259-.475-.168-.896l.027.006c-.089.41-.035.702.159.87.132.112.218.175.272.168.026-.004.048-.024.074-.068.08-.129.098-.325.051-.525-.055-.235-.077-.417-.013-.596l.026.01c-.062.173-.042.343.013.58.05.206.029.41-.054.546-.022.035-.05.073-.093.08a.077.077 0 0 1-.014.001z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M26.638 15.084a.054.054 0 0 1-.02-.004c-.026-.01-.043-.041-.054-.098-.004-.02-.019-.054-.037-.098-.079-.18-.24-.555-.053-.917l.024.012c-.181.351-.029.705.053.895a.576.576 0 0 1 .04.103c.008.045.02.072.037.078.014.006.038-.003.072-.028.066-.048.086-.152.1-.245l.026.004c-.014.099-.035.21-.11.263-.032.024-.057.035-.078.035z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M26.316 15.009l-.015-.002c-.037-.011-.054-.06-.052-.145a.347.347 0 0 0-.047-.158c-.065-.141-.155-.334.062-.744l.024.013c-.21.398-.128.576-.06.72.027.06.05.111.049.17-.003.097.021.114.032.118.02.005.051-.018.067-.044a.537.537 0 0 0 .06-.29h.027a.562.562 0 0 1-.064.304c-.018.03-.051.058-.083.058zm.577-.858a.136.136 0 0 1-.036-.005c-.079-.02-.142-.103-.169-.222-.054-.24.055-.608.29-.984l.024.015c-.274.436-.327.783-.287.963.024.107.081.184.15.202.046.012.094-.006.135-.051.106-.12.152-.213.2-.323l.025.01a1.08 1.08 0 0 1-.205.33.171.171 0 0 1-.127.065z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M27.415 13.959c-.035 0-.071-.018-.108-.054-.156-.157-.182-.377-.088-.758l.026.006c-.09.371-.067.583.082.732.035.036.069.051.1.045.045-.007.087-.054.127-.139.105-.224.148-.59.103-.894l.027-.004c.045.308.002.682-.106.91-.044.094-.092.145-.146.154a.092.092 0 0 1-.017.002zm-1.058.058a.088.088 0 0 1-.055-.018c-.04-.03-.053-.098-.04-.191.017-.111.072-.378.172-.675l.025.008c-.098.296-.153.56-.17.67-.012.083-.001.143.03.166.022.018.056.016.102-.003a.426.426 0 0 0 .267-.317l.027.006a.458.458 0 0 1-.283.336.193.193 0 0 1-.075.018zm.321 1.32c-.022 0-.045-.017-.066-.05-.037-.054-.088-.1-.141-.15-.043-.04-.088-.081-.127-.13l.021-.016c.038.046.082.087.125.126.054.05.106.098.144.156.013.019.032.041.05.035.044-.013.09-.159.09-.38h.026c0 .18-.033.384-.107.406a.053.053 0 0 1-.015.003zm.188 1.267h-.005c-.07-.003-.137-.066-.204-.194-.066-.125-.1-.518-.086-.7l.027.002c-.013.178.02.565.083.686.063.118.122.176.181.179h.004c.051 0 .105-.043.158-.128l.023.015c-.059.093-.12.14-.181.14z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M27.66 14.798c-.075 0-.173-.05-.299-.154l.017-.021c.147.12.25.166.317.142.051-.018.083-.076.107-.193.052-.26-.018-.437-.085-.608a.984.984 0 0 1-.093-.39h.028c-.003.14.043.257.09.38.07.174.14.355.086.623-.018.09-.047.186-.124.214a.13.13 0 0 1-.045.007zm.285-.984c-.03 0-.06-.027-.095-.067a1.404 1.404 0 0 0-.052-.057c-.078-.083-.158-.168-.147-.273l.027.002c-.01.094.066.174.14.252l.053.058c.027.031.058.062.08.057.042-.01.075-.159.086-.208.057-.254.04-.587-.01-.751l.027-.008c.051.17.069.504.01.765-.035.154-.065.218-.107.229a.042.042 0 0 1-.012.001z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M27.982 14.344a.45.45 0 0 1-.153-.031l.01-.026c.102.038.186.04.237.005.035-.025.053-.066.053-.123a.662.662 0 0 0-.148-.403l.021-.017a.69.69 0 0 1 .154.42c0 .066-.023.116-.065.145a.19.19 0 0 1-.11.03zm-2.726-1.927c-.047 0-.09-.007-.113-.029a.05.05 0 0 1-.016-.043l.027.002c-.001.01.001.016.008.021.024.023.099.029.182.014.089-.016.196-.096.208-.185.009-.063-.003-.121-.03-.152a.062.062 0 0 0-.054-.022l-.001-.027h.004a.09.09 0 0 1 .07.03c.034.037.048.102.038.175-.013.102-.13.19-.23.207a.54.54 0 0 1-.093.009z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.315 12.313h-.001c-.057 0-.108-.036-.118-.067l.026-.008c.006.02.045.047.092.048.064 0 .116-.052.147-.147l.026.009c-.046.143-.128.165-.172.165z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.309 12.226c-.022 0-.043-.006-.053-.017-.01-.01-.01-.023-.002-.034l.021.016s.005.004.017.006c.017.003.041.002.056-.009.023-.016.04-.066.033-.082 0-.001-.003-.005-.014-.002l-.008-.026c.03-.009.043.009.046.016.016.032-.01.094-.04.116a.095.095 0 0 1-.056.016zm4.381-.608c-.024 0-.057-.013-.098-.06a.457.457 0 0 0-.223-.153l.008-.026a.483.483 0 0 1 .236.16c.033.04.063.057.086.05.02-.006.037-.034.044-.075.011-.076-.025-.195-.094-.304l.024-.015c.072.116.11.24.097.323-.008.053-.032.088-.063.097a.067.067 0 0 1-.017.003zm-.42-.128a.107.107 0 0 1-.066-.025 1.743 1.743 0 0 1-.12-.104c-.035-.032-.065-.06-.102-.085l.016-.023c.038.026.069.055.105.088.033.03.07.065.118.102.026.02.05.026.07.016.039-.02.06-.094.059-.151-.004-.089-.096-.222-.186-.315l.02-.019c.086.09.189.23.193.332.002.066-.023.15-.074.177a.07.07 0 0 1-.033.008z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M28.946 11.425a.323.323 0 0 1-.111-.027 3.882 3.882 0 0 0-.952-.195l.001-.027c.306.017.76.118.96.197.088.034.122.027.136.015.026-.023.006-.096-.006-.14-.026-.094-.092-.182-.222-.293l.018-.021c.134.115.203.207.23.307.02.07.034.136-.002.168a.075.075 0 0 1-.052.016z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M28.764 11.372c-.067-.02-.107-.089-.152-.167-.066-.113-.141-.242-.321-.27l.004-.027c.193.03.275.17.34.283.043.074.08.138.137.155l-.008.026zm1.14.688a.562.562 0 0 1-.23-.081 4.3 4.3 0 0 0-.743-.24l.007-.027c.291.068.642.186.75.243.113.06.238.118.29.044l.013-.02c.058-.082.13-.185.096-.282l.026-.009c.039.11-.042.224-.1.308l-.013.018a.109.109 0 0 1-.096.047z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M29.755 12.566l-.017-.022c.156-.116.182-.341.127-.494l.025-.01c.059.163.03.402-.135.526zm-.145.484l-.016-.022c.101-.073.157-.159.168-.255.014-.139-.073-.252-.11-.294-.128-.14-.393-.282-.632-.27l-.001-.027c.247-.012.521.134.652.28a.412.412 0 0 1 .118.314c-.011.104-.071.196-.178.274z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M31.48 13.974c-.07 0-.172-.068-.303-.2-.353-.36-1.072-1.237-1.284-1.498l.021-.017c.212.26.93 1.137 1.283 1.496.145.148.263.217.313.184.048-.031.037-.157-.028-.32-.138-.347-.856-1.245-1.398-1.746l.019-.02c.543.504 1.265 1.406 1.404 1.756.073.184.08.313.018.353a.08.08 0 0 1-.045.012z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M30.922 14.119c-.066 0-.148-.062-.228-.122-.15-.112-.414-.431-.668-.74a24.12 24.12 0 0 0-.297-.353l.021-.018c.092.107.192.227.297.355.253.306.515.624.663.735.105.078.19.136.241.108.062-.032.083-.188.065-.476l.027-.001c.02.307-.005.462-.079.501a.087.087 0 0 1-.042.01z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M30.636 14.272c-.051 0-.12-.039-.216-.098-.195-.118-.557-.49-.85-.787l-.043-.044.02-.02.043.045c.29.297.653.666.844.783.11.067.189.112.227.087.035-.021.044-.103.028-.25l.027-.003c.018.165.006.247-.04.276a.073.073 0 0 1-.04.011zm-1.834.731a.484.484 0 0 1-.1-.017l.006-.026c.063.015.102.023.122.01.013-.01.02-.03.025-.064.014-.099.02-.222-.055-.303-.065-.07-.229-.293-.387-.507l-.099-.134.023-.017.098.134c.158.215.32.436.385.506.082.088.076.22.063.324-.006.044-.017.069-.037.083a.074.074 0 0 1-.044.011zm-.501-1.121l-.004-.027c.073-.01.12-.036.137-.078.024-.056-.004-.144-.08-.247l.022-.016c.083.112.112.207.083.274-.022.052-.075.083-.158.094z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M28.438 13.627l-.002-.027c.207-.007.304-.106.315-.32l.027.001c-.012.228-.12.338-.34.346z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M28.735 13.282a.225.225 0 0 1-.15-.063l.018-.02c.087.076.189.074.272-.006.084-.081.124-.23.042-.328l.021-.018c.092.11.048.276-.045.365a.231.231 0 0 1-.158.07zm.087-.436l-.04-.003.004-.027c.086.01.154-.015.19-.071.054-.083.034-.22-.053-.366l.023-.014c.093.155.113.303.053.395-.036.056-.098.086-.177.086z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M28.803 12.402a.33.33 0 0 1-.047-.003l.004-.027c.1.014.178-.02.218-.093.052-.097.035-.272-.12-.447l.021-.018c.141.16.19.352.123.478-.038.071-.11.11-.2.11z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M28.698 11.88l-.018-.021c.006-.005.01-.01.015-.013.034-.03.063-.057.127-.05a.082.082 0 0 0 .074-.029c.02-.027.02-.068 0-.118-.053-.13-.08-.212-.07-.266l.027.005c-.009.047.018.128.068.25.03.076.015.121-.004.146a.108.108 0 0 1-.098.04c-.05-.005-.073.013-.105.042l-.016.014zm-1.744-.677l-.007-.027.062-.018c.155-.046.349-.103.492-.02l-.014.024c-.133-.078-.32-.022-.47.022l-.063.019zm.973.225c-.134-.095-.32-.072-.448-.007l-.01-.034c.133-.068.33-.091.47.01l-.012.031zm.418.438c-.031-.117-.14-.176-.202-.201-.108-.043-.216-.044-.255-.02l-.015-.023c.052-.032.175-.024.28.018.115.046.193.124.219.22l-.027.006zm.065.319c-.01-.063-.065-.123-.15-.163-.086-.041-.18-.051-.229-.023l-.013-.024c.057-.032.158-.023.254.022.093.045.153.111.165.184l-.027.004zm.06.523l-.027-.005a.243.243 0 0 0-.068-.196.415.415 0 0 0-.317-.134l-.001-.027h.012c.123 0 .247.054.326.143a.27.27 0 0 1 .075.219zm-1.242 3.395c-.032 0-.068-.032-.11-.075-.202-.2-.755-.773-.911-.968l.021-.017c.154.192.714.771.91.966.036.037.075.073.095.066.031-.01.051-.116.058-.15l.027.005c-.022.113-.043.16-.077.172a.046.046 0 0 1-.013.001z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M27.643 16.126a.312.312 0 0 1-.136-.05c-.203-.112-.481-.43-.684-.661l-.099-.113.02-.018.1.113c.201.23.477.545.676.656.075.04.123.054.146.04.036-.022.034-.11.032-.231l-.002-.111h.027l.002.11c.003.136.005.226-.045.255a.071.071 0 0 1-.037.01z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M28.043 15.978c-.041 0-.097-.026-.17-.079-.228-.164-.464-.558-.588-.855l.025-.01c.122.293.355.682.579.843.087.063.147.086.18.068.044-.026.042-.135.033-.239-.023-.294-.212-.645-.336-.877a3.768 3.768 0 0 1-.035-.065l.024-.013.035.065c.126.234.316.588.34.888.01.136.007.234-.048.264a.077.077 0 0 1-.039.01zm-1.033.145a.195.195 0 0 1-.135-.062l.02-.02c.049.053.122.067.155.044.028-.018.028-.061 0-.12l.024-.011c.047.097.015.138-.008.154a.099.099 0 0 1-.055.015zm1.172.964c-.03 0-.068-.025-.127-.07-.144-.111-.625-.553-.822-.92l.024-.013c.195.364.672.8.815.91.056.044.097.072.117.064.02-.007.033-.058.051-.134l.027.006c-.022.092-.034.142-.069.154a.048.048 0 0 1-.016.003z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M28.45 17.025c-.039 0-.09-.028-.157-.066-.15-.086-.358-.372-.62-.849l.023-.013c.26.473.466.755.61.838.075.043.134.074.164.058.028-.015.042-.072.048-.19h.027c-.007.135-.024.193-.062.214a.067.067 0 0 1-.032.008z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M28.69 16.936c-.039 0-.087-.03-.145-.09-.201-.21-.408-.686-.488-.88l.026-.011c.166.409.342.726.481.871.062.065.111.092.143.08.029-.012.063-.065.063-.253h.027c0 .165-.026.256-.08.278a.07.07 0 0 1-.026.005zm-.27-1.237c-.058 0-.154-.05-.337-.159l.014-.023c.203.12.306.173.347.148.035-.021.033-.117.025-.24-.019-.303-.153-.733-.359-1.152l.025-.011c.207.42.342.855.361 1.161.01.162.007.238-.038.265a.069.069 0 0 1-.038.01z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M28.648 15.365a.549.549 0 0 1-.177-.046l.01-.025c.117.045.18.055.207.033.03-.024.027-.097.01-.221-.032-.237-.166-.579-.398-1.015l.024-.013c.234.44.369.784.402 1.024.019.14.02.214-.021.246a.088.088 0 0 1-.057.017z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M28.912 16.789c-.032 0-.086-.035-.186-.235a7.977 7.977 0 0 1-.296-.865l.027-.007c.078.285.241.756.293.86.105.21.152.222.167.22.024-.007.049-.078.043-.26-.006-.201-.113-.69-.28-1.158l.025-.01c.169.472.276.964.283 1.168.005.177-.017.273-.065.285a.047.047 0 0 1-.011.002z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M29.096 16.662c-.034 0-.074-.042-.127-.133l.023-.014c.069.116.098.121.108.12.052-.015.046-.312.044-.472-.007-.4-.15-.83-.287-1.198l.025-.01c.139.37.282.803.289 1.207.005.324-.003.481-.064.499a.034.034 0 0 1-.01.001zm-.384-2.396l-.013-.024c.131-.071.203-.167.203-.27 0-.13-.115-.261-.32-.372l.012-.024c.216.116.335.256.335.396 0 .113-.077.218-.217.294z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M28.927 13.927l-.01-.025c.193-.077.306-.183.31-.291.004-.12-.124-.245-.37-.364l.011-.024c.261.125.39.256.386.389-.004.119-.124.234-.327.315z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M29.217 13.51l-.002-.027c.197-.012.341-.147.334-.313-.003-.085-.054-.363-.57-.386l.002-.027c.538.024.592.321.596.412.007.181-.148.328-.36.34zm.171 1.08a1.03 1.03 0 0 1-.274-.061l.008-.026c.15.046.292.09.366.03.057-.048.075-.158.055-.336l.027-.003c.021.19 0 .305-.065.36a.178.178 0 0 1-.117.036z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M29.98 14.315a.913.913 0 0 1-.178-.028c-.227-.05-.343-.19-.504-.381a7.78 7.78 0 0 0-.118-.14l.02-.017c.044.049.083.096.12.14.162.194.27.323.489.371.13.03.202.04.23.01.041-.041.008-.179-.06-.453l-.004-.017.027-.006.004.017c.074.301.104.426.052.478-.017.018-.042.026-.078.026zm-4.837-1.852a.103.103 0 0 1-.024-.086c.021-.16.328-.367.331-.37a.163.163 0 0 0 .065-.092l.026.008a.19.19 0 0 1-.076.108c-.078.051-.303.227-.32.35a.077.077 0 0 0 .019.064l-.021.018z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.539 11.927l-.022-.017a.734.734 0 0 1 .248-.21l.013.024a.71.71 0 0 0-.24.203zm.254.067l-.023-.015c.056-.085.11-.213.151-.349l.027.008a1.449 1.449 0 0 1-.155.356zm.339-.221l-.062-.004a.565.565 0 0 0 .036-.23h.063c.002.09-.01.17-.037.234zm1.97 1.067c-.035 0-.062-.003-.063-.003a.46.46 0 0 1-.331-.247l.024-.011c.07.147.225.219.31.23.042.006.157.003.164-.017 0 0 .005-.017-.077-.062-.129-.07-.219-.228-.314-.395a5.02 5.02 0 0 0-.08-.138l.023-.014c.029.046.055.093.08.139.094.163.182.318.304.385.071.038.099.067.09.094-.01.032-.078.039-.13.039zm-1.078-1.016a.242.242 0 0 1-.033-.002l.004-.03a.412.412 0 0 0 .244-.068l.012.028a.497.497 0 0 1-.227.072zm-.736-.033l-.023-.014a.715.715 0 0 0 .104-.282l.027.004a.743.743 0 0 1-.108.292zm3.758-.082a.472.472 0 0 1-.315-.124l.018-.02a.445.445 0 0 0 .331.115.556.556 0 0 0 .377-.207l.021.017a.586.586 0 0 1-.432.219zm.364 3.339c-.153-.152-.362-.36-.39-.543l.028-.004c.026.173.231.378.38.528l-.018.019zm.508.156a4.213 4.213 0 0 0-.24-.327l.022-.017c.098.123.177.231.24.33l-.022.014zm.474.017a2.772 2.772 0 0 0-.173-.27 2.81 2.81 0 0 1-.162-.253l.024-.012c.047.086.102.165.16.249.06.086.123.176.176.274l-.025.012zm.457-.251a5.023 5.023 0 0 0-.053-.072c-.08-.106-.157-.208-.171-.302l.027-.004c.013.088.087.186.165.29l.054.072-.022.016zm.503-.72c-.24 0-.579-.144-.856-.563l.023-.015c.306.463.686.583.917.544l.004.027a.535.535 0 0 1-.088.007z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M28.172 14.13h-.017v-.027c.081.004.135-.014.155-.048.02-.033.009-.087-.029-.147-.069-.11-.127-.226-.205-.645l-.001-.007.005-.005c.343-.316.421-.455.337-.994-.102-.65-.148-.673-.507-.861a8.472 8.472 0 0 1-.18-.097l-.108-.057c-.184-.095-.295-.153-.312-.365a.325.325 0 0 1 .02-.15l.025.01a.3.3 0 0 0-.018.138c.016.197.116.249.298.343.033.018.07.036.108.058.067.037.127.068.18.095.361.19.417.219.52.881.089.562-.01.71-.339 1.014.076.407.134.522.2.628.044.07.054.132.03.174-.024.042-.079.063-.162.063zm.911.628l-.022-.016c.097-.136.007-.4-.201-.589l.018-.02c.222.2.312.475.205.625zm-.146.082a2.076 2.076 0 0 0-.076-.124l.023-.015c.027.042.053.084.077.127l-.024.013zm.241 1.659l-.028-.007c.059-.214.082-.45.068-.682l.028-.002a2.13 2.13 0 0 1-.068.69zm.756 1.275l-.207-.19c-.164-.15-.35-.321-.605-.549l.018-.02a51.485 51.485 0 0 1 .812.738l-.018.02zm.492-.006a22.279 22.279 0 0 1-.706-.606 39.622 39.622 0 0 0-.598-.519l.018-.02c.14.116.372.32.598.519.294.257.597.523.704.604l-.016.022z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M30.97 17.637a19.782 19.782 0 0 1-1.815-1.38l.018-.02a19.76 19.76 0 0 0 1.812 1.378l-.015.022zM29 17.383l-.02-.057c-.05-.132-.124-.331-.209-.59l.026-.01c.085.26.159.459.208.59l.021.057-.026.01zm-.569.156l-.268-.448.023-.014.269.447-.024.015zm.395.017c-.05-.086-.132-.213-.226-.36-.04-.06-.08-.125-.122-.19l.023-.014.122.19c.095.147.176.273.227.36l-.024.014zm.331-.204a8.977 8.977 0 0 0-.066-.698l.034-.003c.025.154.042.367.066.7l-.034.001zm-2.663-.282l-.022-.016a.783.783 0 0 1 .09-.104c.1-.1.237-.21.497-.258l.006.026a.858.858 0 0 0-.484.251.774.774 0 0 0-.087.1z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M27.216 17.088a.973.973 0 0 1-.074-.115c-.126-.23-.125-.529-.113-.733l.027.001c-.012.202-.013.495.11.719a.9.9 0 0 0 .071.112l-.021.016zm.707.148l-.02-.018c.026-.032.05-.112.075-.26l.027.004c-.027.155-.051.237-.082.274zm-1.181-.702a1.237 1.237 0 0 1-.236-.151l.017-.021c.071.058.149.108.23.148l-.011.024z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M27.497 16.815c-.249-.327-.757-.93-1.282-1.48l.02-.019c.526.55 1.035 1.154 1.284 1.482l-.022.017zm-1.403-1.623l-.014-.023a.472.472 0 0 0 .177-.27l.026.006a.496.496 0 0 1-.19.287zm-.088-1.386a.18.18 0 0 1-.034-.003l.005-.027a.2.2 0 0 0 .062 0 .384.384 0 0 0 .266-.152l.02.018a.415.415 0 0 1-.32.164zm.198-.6v-.027h.032c.085-.003.254-.037.43-.24l.02.017c-.182.211-.36.248-.449.25h-.033zm.096-.399l-.016-.022a.487.487 0 0 0 .052-.044c.05-.047.106-.12.087-.266l.027-.003c.02.16-.044.241-.096.29a.5.5 0 0 1-.055.045z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M24.94 12.385c-.085.007-.193.075-.137.164a.496.496 0 0 0-.17.706c.111.163.399.156.478.143-.15-.052-.217-.392-.144-.483.072-.092.222-.275.589.11.118-.11.236-.208.347-.215.144-.007.288-.137.196-.255-.091-.117-.589.066-.74-.046-.15-.11-.333-.006-.419-.124z",
    fill: "#FAB381"
  }), React__default.createElement("path", {
    d: "M24.934 12.4c-.047.005-.105.032-.126.072a.071.071 0 0 0 .006.07l.008.011-.012.007a.48.48 0 0 0-.166.687c.088.13.293.144.377.144.015 0 .03 0 .044-.002a.362.362 0 0 1-.117-.193c-.035-.12-.032-.24.008-.29.036-.045.102-.13.215-.13.109 0 .238.078.386.23.106-.1.228-.203.345-.21.086-.003.173-.054.202-.118a.105.105 0 0 0-.015-.114c-.02-.025-.063-.037-.134-.037a1.92 1.92 0 0 0-.202.016 2.002 2.002 0 0 1-.224.018c-.084 0-.14-.013-.178-.04-.07-.053-.147-.055-.221-.057-.077-.003-.148-.005-.196-.064zm.087 1.018c-.088 0-.304-.015-.4-.156a.513.513 0 0 1-.072-.395.505.505 0 0 1 .236-.323.09.09 0 0 1 0-.084c.025-.052.097-.084.154-.088l.008-.001.005.006c.039.055.104.057.178.06a.39.39 0 0 1 .238.062c.031.023.084.034.161.034.068 0 .146-.008.22-.017.075-.008.145-.016.206-.016.081 0 .13.015.155.047a.133.133 0 0 1 .019.142c-.034.074-.129.13-.225.135-.112.006-.234.112-.339.212l-.01.009-.009-.01c-.146-.153-.272-.231-.375-.231-.1 0-.159.074-.194.119-.033.043-.035.157-.003.265.03.104.083.177.141.197l-.002.027a.586.586 0 0 1-.092.006z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.368 12.863l-.017-.02a.715.715 0 0 1 .33-.17c.1-.017.168-.007.206.03.026.024.036.061.03.109l-.028-.004c.006-.038-.002-.067-.021-.086-.03-.03-.094-.037-.182-.023a.692.692 0 0 0-.318.164zm-.488-.262h-.002c-.05 0-.089-.022-.089-.052h.028c0 .01.024.025.061.025h.002c.056 0 .117-.035.119-.133h.027c-.002.119-.08.16-.146.16z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M28.528 17.672c.046.163-.242.288-.399.229-.157-.059-.34.006-.34.209 0 .13.078.21.216.242-.027.098.085.268.235.274a.271.271 0 0 0 .275-.268c.203.04.498-.17.714-.032.059.163.236.196.439.084.203-.11.117-.37-.066-.365-.32.006-.561-.188-.764-.495-.058.27-.179.35-.31.122z",
    fill: "#FDBC11"
  }), React__default.createElement("path", {
    d: "M28.017 17.894c-.099 0-.215.056-.215.216 0 .119.07.196.206.228l.013.004-.003.013c-.011.042.005.1.044.153a.24.24 0 0 0 .18.104h.01a.26.26 0 0 0 .25-.254v-.016l.016.003a.282.282 0 0 0 .053.004c.068 0 .144-.02.223-.04a1.06 1.06 0 0 1 .259-.044c.07 0 .13.016.183.049l.004.002.002.005c.032.09.105.141.204.141.065 0 .14-.022.215-.064.104-.056.122-.147.105-.213a.165.165 0 0 0-.16-.127h-.02c-.284 0-.52-.15-.742-.475-.037.152-.096.236-.167.236-.043 0-.087-.032-.131-.094a.161.161 0 0 1-.033.076.392.392 0 0 1-.293.128.271.271 0 0 1-.096-.015.306.306 0 0 0-.107-.02zm.234.746h-.011a.268.268 0 0 1-.2-.116.234.234 0 0 1-.051-.162c-.14-.038-.214-.124-.214-.252 0-.168.121-.244.242-.244.039 0 .079.008.117.022.025.01.053.014.086.014.105 0 .22-.05.271-.118a.121.121 0 0 0 .024-.109l.025-.01c.048.083.095.126.137.126.06 0 .115-.089.147-.244l.007-.032.018.027c.22.334.455.49.738.489h.02a.19.19 0 0 1 .185.147c.02.076 0 .18-.118.244a.487.487 0 0 1-.228.067.229.229 0 0 1-.228-.155.31.31 0 0 0-.165-.042c-.082 0-.168.022-.252.044-.081.02-.159.04-.23.04a.34.34 0 0 1-.042-.002.284.284 0 0 1-.278.266z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M28.018 18.355l-.026-.007c.026-.088.152-.146.253-.193a.478.478 0 0 0 .13-.073.553.553 0 0 1 .254-.162l.002.027a.529.529 0 0 0-.236.152.422.422 0 0 1-.138.08c-.097.045-.216.1-.239.176z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M28.758 18.081c-.064 0-.106-.012-.127-.037-.014-.016-.019-.037-.015-.064a1.044 1.044 0 0 0-.01-.192l.028-.003c0 .006.018.149.01.2-.004.018-.001.032.008.042.016.019.056.029.118.027h.006c.08-.002.132-.004.149-.024.007-.009.01-.024.006-.049a2.243 2.243 0 0 1-.033-.329h.027c0 .114.021.251.033.325.005.033.001.055-.012.071-.025.03-.076.03-.17.033h-.018zm-.236.291h-.007l.001-.028h.006a.27.27 0 0 0 .255-.192l.026.007a.298.298 0 0 1-.28.213zm.249-.03l-.007-.027c.068-.017.155-.072.174-.166l.026.006c-.021.106-.117.167-.193.187zm.208-.042l-.004-.027c.075-.01.123-.057.123-.12h.027c0 .076-.059.135-.146.147zm-.416-.1c-.07-.028-.119-.08-.125-.132a.07.07 0 0 1 .027-.067l.016.022c-.016.011-.018.03-.016.042.004.032.035.08.108.11l-.01.026zm-.193.185c-.074-.01-.118-.077-.129-.138-.009-.05.006-.094.036-.11l.012.024c-.02.01-.028.043-.02.082.008.05.044.106.105.115l-.004.027zm.923-.258l-.023-.023c.013-.043.057-.096.281-.07l-.002.048c-.216-.026-.25.028-.256.045z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M27.998 18.796c-.255-.111-.206-.392-.016-.431.19-.04.196.081.196.16 0 .078-.265.111-.18.271z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M28.435 18.4c-.05 0-.106.005-.167.015-.212.035-.362.17-.385.343-.02.149.065.344.352.47-.064-.186.149-.29.31-.367.1-.049.193-.095.193-.14 0-.163-.023-.32-.303-.32zm-.052.944l-.094-.033c-.388-.134-.501-.377-.476-.559.025-.198.198-.352.44-.392.067-.011.128-.016.182-.016.374 0 .374.254.374.377 0 .077-.105.128-.227.188-.217.105-.362.193-.247.363l.048.072z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M27.582 18.41c-.2-.147-.052-.415.144-.421.197-.007.18.203.112.251-.07.05-.305-.055-.256.17z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M28.09 18.033h-.02a.569.569 0 0 0-.509.367.387.387 0 0 0 .123.433c-.01-.086.007-.15.049-.198.131-.148.473-.048.578-.116.074-.048.126-.192.083-.314-.029-.078-.104-.172-.304-.172zm-.31.942l-.07-.046c-.205-.137-.282-.337-.21-.547a.634.634 0 0 1 .568-.407h.022c.252 0 .336.133.365.213.048.137 0 .31-.106.378-.132.086-.46-.015-.566.106-.04.045-.047.122-.022.228l.018.075z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M29.655 18.721c.281-.033.3-.242.235-.366s-.206-.114-.249-.072c-.042.043-.094.157-.006.213.088.055.095.137.02.225z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M30.003 18.295a.403.403 0 0 0-.214.05c-.078.057-.153.166-.139.257.008.054.047.097.114.128.123.055.194.125.212.206.015.074-.016.152-.092.232.267-.035.455-.12.549-.249.11-.151.064-.325-.017-.436-.123-.17-.33-.188-.413-.188zm-.296.946l.063-.053c.101-.087.146-.171.131-.244-.014-.064-.073-.12-.177-.168-.087-.04-.138-.098-.148-.168-.02-.122.085-.247.16-.302a.493.493 0 0 1 .267-.065c.098 0 .337.021.48.217.09.123.141.316.016.487-.08.111-.267.251-.697.287l-.095.009zM28.2 17.987c-.002-.034-.046-.065-.114-.083l.007-.026c.08.02.13.06.135.107l-.027.002z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M26.126 16.463c.13.052.51.163.864.261a.852.852 0 0 0-.334.157 9.625 9.625 0 0 0-.835-.147c-.134.128-.2.14-.245.082-.041-.052-.147-.1-.275-.175a.267.267 0 0 1-.144.056c-.068.067-.127.08-.177.061-.056.095-.112.133-.216.038a.526.526 0 0 1-.154-.343.13.13 0 0 1 .114-.134c.036-.123.117-.178.215-.165.019-.123.145-.209.296-.188.196.027.655-.091.76.046.075.105.278.31.13.45z",
    fill: "#FDBC11"
  }), React__default.createElement("path", {
    d: "M25.816 16.748h.007c.224.028.61.099.83.152a.814.814 0 0 1 .286-.147 12.328 12.328 0 0 1-.818-.258l-.02-.008.015-.015c.118-.117-.01-.286-.095-.398l-.037-.05c-.032-.044-.108-.065-.233-.065-.075 0-.157.007-.238.014-.11.01-.215.018-.28.009-.139-.02-.263.062-.28.182l-.002.013-.013-.002a.215.215 0 0 0-.026-.002c-.083 0-.145.059-.174.164l-.003.009-.009.001a.12.12 0 0 0-.102.125c0 .082.047.249.149.345.038.035.07.053.097.053.033 0 .063-.027.098-.09l.006-.01.011.005c.049.02.104-.001.162-.061l.004-.005h.006a.24.24 0 0 0 .136-.055l.007-.005.008.004.101.06a.631.631 0 0 1 .177.126c.016.02.031.03.05.03.04 0 .096-.038.176-.116l.004-.005zm.843.182l-.006-.001a9.176 9.176 0 0 0-.827-.151c-.084.081-.143.118-.19.118-.027 0-.051-.013-.071-.04-.028-.037-.09-.072-.17-.118l-.094-.056a.261.261 0 0 1-.139.056c-.06.061-.121.083-.176.066-.028.048-.064.094-.116.094-.034 0-.072-.02-.116-.06a.568.568 0 0 1-.158-.366c0-.09.06-.14.118-.151.035-.118.115-.182.214-.175.024-.114.131-.196.262-.196a1.518 1.518 0 0 0 .321-.005c.08-.007.164-.015.24-.015.136 0 .216.025.254.076l.038.05c.087.116.217.288.106.42.126.05.437.146.845.263l.05.014-.05.013a.83.83 0 0 0-.33.16l-.005.004z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M24.975 16.77c-.094-.036-.152-.173-.172-.23-.017-.049-.04-.087-.057-.118-.025-.044-.044-.075-.035-.106l.027.007c-.006.02.01.047.031.085a.695.695 0 0 1 .06.122c.019.054.072.182.156.216l-.01.025zm.181-.06c-.088-.002-.129-.084-.137-.16-.01-.078-.036-.151-.059-.216a.981.981 0 0 1-.026-.076.238.238 0 0 1-.008-.106l.027.004a.207.207 0 0 0 .007.094.963.963 0 0 0 .026.075c.024.066.05.14.06.221.003.032.022.135.111.137v.027zm.138-.058l-.01-.005-.041-.026c-.08-.05-.097-.113-.097-.157 0-.074.049-.152.124-.199a.226.226 0 0 1 .22-.012c.047.024.077.063.08.104.006.09.013.182.155.237l-.01.025c-.158-.061-.166-.166-.173-.258-.002-.033-.026-.064-.064-.083a.198.198 0 0 0-.193.01c-.068.042-.112.111-.112.176 0 .053.029.1.084.135l.042.025.009.005-.014.023zm.536.092l-.018-.02.152-.134c.067-.059.105-.091.152-.137l.02.02c-.049.046-.088.08-.154.138l-.152.133z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.17 16.695c.052.098.2.193.37.088-.073-.055-.197-.116-.24-.142a.25.25 0 0 1-.13.054z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M25.255 17c.09.26.263.5.476.5.1 0 .2-.052.3-.154-.118-.16-.277-.324-.397-.448a4.364 4.364 0 0 1-.117-.125c-.077.1-.16.193-.262.226zm.476.624c-.26 0-.47-.325-.56-.646l-.023-.086.05-.006c.111-.013.2-.105.299-.237l.017-.025.019.022c.03.035.077.084.133.142.135.141.32.334.444.515l.038.055-.04.048c-.125.144-.25.218-.377.218z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25 16.762c.029.082.205.152.363.067a.259.259 0 0 1-.193-.134h-.012c-.023.035-.103.085-.159.067z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M25.088 17.171c.07.198.233.375.435.375a.41.41 0 0 0 .258-.105c-.137-.087-.285-.28-.37-.61-.061.155-.2.34-.323.34zm.435.51c-.244 0-.469-.246-.524-.574l-.022-.13.062.043c.015.01.032.015.05.015.11 0 .245-.194.285-.324l.01-.03h.063l.009.039c.09.394.28.585.427.632l.094.032-.083.095c-.114.132-.243.203-.371.202z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M24.873 16.852c.025.062.18.09.254.006-.036-.013-.113-.049-.128-.096a.039.039 0 0 1-.018-.005c-.02.033-.054.096-.108.095z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M25 17.407a.41.41 0 0 0 .346.185.425.425 0 0 0 .346-.18c-.113-.079-.314-.247-.38-.482l-.008-.003c-.062.168-.158.416-.304.48zm.346.332a.478.478 0 0 1-.467-.362l-.026-.105.07.003c.145 0 .249-.278.31-.444l.034-.092.038.031c.017.013.032.019.04.019h.034l.01.051c.041.214.272.399.401.475l.063.036-.044.082c-.11.197-.273.306-.463.306z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.484 15.898c-.295-.02-.367.218-.354.415.007.098.094.113.184.088.059-.016.105-.065.072-.18-.03-.104-.023-.235.098-.323z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M25.931 15.933c-.223.001-.401.053-.528.155-.16.128-.239.342-.217.586.01.105.09.159.243.159a.859.859 0 0 0 .165-.018c.07-.015.12-.042.148-.081.04-.052.041-.126.006-.22-.088-.23-.021-.439.183-.581zm-.502.95c-.186 0-.298-.074-.31-.206-.013-.151 0-.434.234-.623.158-.126.38-.183.67-.169l.092.005-.074.04c-.321.176-.281.433-.229.57.041.107.037.194-.011.259a.307.307 0 0 1-.189.104.887.887 0 0 1-.183.02z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M24.492 11.709c.101.095.092.366-.01.458.016-.092.026-.256-.049-.327l.059-.131z",
    fill: "#FDBC11"
  }), React__default.createElement("path", {
    d: "M24.62 11.977c.407.138.39.394.334.549.18-.09.288-.224.292-.369.005-.158-.118-.297-.334-.38l-.292.2zm.078.71l.044-.077c.126-.216.117-.49-.28-.608l-.045-.012.44-.304.089.025c.3.087.476.254.47.447-.005.203-.21.386-.533.477l-.185.051z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M24.552 13.022c-.57.226-.705-.107-.712-.232a1.195 1.195 0 0 0-.078-.385c-.077-.19-.053-.32.137-.432a3.53 3.53 0 0 0 .472-.326c.098-.085.198-.145.137.052-.026.085-.091.274-.196.38-.105.104-.177.215-.085.293.092.079.347-.059.465-.183.026.066-.08.19-.184.222-.105.033-.332.087-.314.177.026.13.288.02.51.039a.467.467 0 0 0-.152.395z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M24.5 11.58c-.015 0-.047.014-.12.077a3.597 3.597 0 0 1-.474.328c-.173.102-.21.218-.131.415.046.115.071.24.08.39.004.102.086.295.355.295a.927.927 0 0 0 .328-.072.469.469 0 0 1 .136-.374h-.027c-.064 0-.129.007-.19.015a1.265 1.265 0 0 1-.145.012c-.05 0-.118-.008-.131-.076-.019-.09.154-.142.28-.179l.043-.013a.304.304 0 0 0 .166-.143.116.116 0 0 0 .012-.037c-.1.096-.269.19-.381.19a.124.124 0 0 1-.13-.115c-.002-.062.04-.133.131-.224.098-.098.163-.276.193-.374.026-.082.018-.105.014-.11-.002-.003-.003-.004-.009-.004zm-.29 1.533c-.3 0-.378-.232-.383-.322a1.16 1.16 0 0 0-.078-.38c-.084-.21-.042-.34.144-.449.198-.116.378-.247.469-.326.065-.056.11-.082.138-.082.017 0 .026.007.03.014.016.021.013.064-.009.135-.03.1-.097.283-.2.385-.084.084-.125.151-.123.203a.1.1 0 0 0 .037.07.1.1 0 0 0 .066.02c.111 0 .29-.106.38-.201l.015-.016.008.02c.01.023.006.051-.009.083a.333.333 0 0 1-.183.157l-.043.013c-.103.03-.275.082-.262.148.008.038.04.054.105.054.04 0 .09-.006.14-.012a1.597 1.597 0 0 1 .254-.014l.03.003-.022.02a.452.452 0 0 0-.148.386l.001.01-.01.003a.966.966 0 0 1-.347.078z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.572 16.466c.21-.085.566-.29.357-.8-.262-.64-1.037-.176-1.23-.451-.276-.392-.22-.63.47-1.144.669-.496.606-.833.387-1.045-.053-.062-.246-.242-.393-.236-.147.007-.255.17-.22.288.177.128.253.375.063.516-.603.447-1.172.895-.91 1.693.2.609.72.495.897.503.301.013.57-.013.471.183a.504.504 0 0 1-.092.117.491.491 0 0 0 .019.156c.052-.002.112.02.14.057.041.052.022.127.041.163z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M25.4 16.232a.19.19 0 0 1 .142.062c.027.035.03.078.033.113 0 .015.002.03.005.041.186-.077.308-.184.364-.315.054-.13.045-.285-.027-.462-.128-.312-.383-.354-.615-.354-.056 0-.111.003-.165.005-.052.002-.1.004-.146.004-.12 0-.24-.012-.304-.103-.293-.418-.19-.668.475-1.163.338-.252.517-.484.53-.69.009-.12-.041-.233-.146-.335-.061-.073-.24-.231-.375-.231h-.007a.223.223 0 0 0-.17.099.205.205 0 0 0-.039.166c.108.08.175.2.175.313a.27.27 0 0 1-.116.223c-.549.407-1.171.868-.905 1.677.17.517.576.504.797.496a.905.905 0 0 1 .087-.002l.126.004c.182.005.326.008.368.078.018.03.015.07-.01.121a.487.487 0 0 1-.092.117.513.513 0 0 0 .016.136zm.166.251l-.006-.01a.157.157 0 0 1-.012-.064c-.003-.033-.006-.07-.027-.098a.168.168 0 0 0-.125-.052h-.015l-.003-.009a.517.517 0 0 1-.02-.16v-.006l.004-.004a.492.492 0 0 0 .09-.113c.021-.042.025-.073.012-.095-.034-.057-.179-.06-.346-.065-.04 0-.083-.002-.126-.004-.023 0-.052 0-.085.002l-.102.002c-.237 0-.57-.053-.722-.516-.272-.829.358-1.296.915-1.708a.242.242 0 0 0 .105-.2.383.383 0 0 0-.168-.294l-.004-.003-.001-.004a.231.231 0 0 1 .042-.195.25.25 0 0 1 .19-.11c.16-.008.363.191.404.24.11.106.162.226.154.355-.014.214-.197.453-.542.71-.702.522-.733.748-.469 1.125.057.081.17.092.282.092.045 0 .094-.002.145-.004a3.55 3.55 0 0 1 .166-.005c.241 0 .506.044.64.37.075.185.084.347.027.483-.06.142-.192.255-.392.336l-.01.004z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M24.605 14.62c-.113.202-.063.372.093.595.194.275.97-.19 1.231.45.209.51-.147.716-.357.801-.02-.036 0-.11-.04-.163a.182.182 0 0 0-.141-.057.49.49 0 0 1-.019-.156.503.503 0 0 0 .092-.117c.099-.196-.19-.17-.49-.183-.694-.03-.644-.83-.37-1.17z",
    fill: "#CD7418"
  }), React__default.createElement("path", {
    d: "M25.4 16.232a.19.19 0 0 1 .142.062c.027.035.03.078.033.113 0 .015.002.03.005.041.186-.077.308-.184.364-.315.054-.13.045-.285-.027-.462-.128-.312-.383-.354-.615-.354-.056 0-.111.003-.165.005-.052.002-.1.004-.146.004-.115 0-.24-.012-.304-.103-.116-.166-.185-.316-.146-.48-.11.207-.157.508-.055.736.084.184.252.287.488.297l.128.004c.19.005.34.009.384.08.018.03.015.07-.01.119a.487.487 0 0 1-.09.117.513.513 0 0 0 .015.136zm.166.251l-.006-.01a.157.157 0 0 1-.012-.064c-.003-.033-.006-.07-.027-.098a.168.168 0 0 0-.125-.052h-.015l-.003-.009a.517.517 0 0 1-.02-.16v-.006l.004-.004a.492.492 0 0 0 .09-.113c.02-.04.024-.07.01-.092-.035-.06-.193-.063-.361-.068-.042 0-.085-.002-.128-.004-.312-.013-.45-.177-.512-.313-.128-.283-.03-.676.133-.878l.023.015c-.102.181-.077.339.092.58.057.081.17.092.282.092.045 0 .094-.002.145-.004a3.55 3.55 0 0 1 .166-.005c.241 0 .506.044.64.37.075.185.084.347.027.483-.06.142-.192.255-.392.336l-.01.004z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M24.955 12.942a.248.248 0 0 1 .208-.152c.147-.006.34.174.393.236.21.203.277.522-.303.984.42-.32.153-1.003-.298-1.068z",
    fill: "#CD7418"
  }), React__default.createElement("path", {
    d: "M24.986 12.931a.76.76 0 0 1 .604.466.478.478 0 0 1-.06.465c.237-.178.361-.346.37-.498.007-.118-.057-.229-.187-.328-.079-.074-.307-.232-.478-.232h-.009a.305.305 0 0 0-.24.127zm.364 1.09L25.33 14l.03-.02c.206-.137.28-.352.197-.575a.73.73 0 0 0-.599-.45l-.022-.002.01-.017a.339.339 0 0 1 .28-.16c.203-.007.46.192.513.24.137.105.203.223.197.349-.011.194-.197.408-.555.637a.926.926 0 0 1-.03.02z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M24.873 16.852c-.427.348-.784.114-.875-.376-.061-.326-.144-.392-.413-.582-.407-.287-.242-.647-.137-.94.104-.295-.027-.412-.23-.51-.203-.098-.654-.34-.02-.327.636.013.675.712.557.954s-.163.418.21.562c.373.144.255.673.51.823a.255.255 0 0 0 .138.031c.027.172.125.345.26.365z",
    fill: "#549334"
  }), React__default.createElement("path", {
    d: "M23.151 14.13c-.22 0-.26.035-.265.056-.003.018.009.086.338.245.217.105.34.235.237.527l-.021.056c-.103.284-.22.606.153.87.275.194.357.264.418.59.061.327.241.53.47.53a.604.604 0 0 0 .362-.145c-.131-.039-.216-.206-.242-.358a.262.262 0 0 1-.133-.033c-.118-.07-.158-.213-.2-.366-.053-.186-.107-.379-.308-.456-.161-.062-.252-.132-.287-.22-.044-.111.01-.24.07-.36.067-.137.085-.447-.054-.674a.557.557 0 0 0-.49-.261l-.048-.001zm1.33 2.902c-.243 0-.433-.212-.497-.553-.06-.316-.133-.38-.407-.573-.39-.276-.264-.623-.162-.901l.02-.056c.098-.275-.008-.39-.222-.493-.375-.18-.359-.252-.353-.276.013-.057.12-.081.339-.077.229.005.406.1.513.275a.82.82 0 0 1 .056.699c-.07.142-.105.248-.07.339.032.08.12.146.272.205.214.082.272.29.324.474.04.147.08.286.189.35a.236.236 0 0 0 .121.029h.02l.003.011c.024.161.117.335.248.353l.031.005-.024.02c-.138.112-.273.169-.401.169z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M22.983 14.127c.045-.035.081-.154-.04-.185-.141-.037-.15.085-.232.11-.107.031-.131.065-.037.145.064.055.007.173.15.21.12.03.152-.096.124-.144-.02-.036-.002-.107.035-.136z",
    fill: "#CD7418"
  }), React__default.createElement("path", {
    d: "M23.272 13.975c-.113 0-.171.056-.234.116-.048.046-.099.095-.177.115-.124.032-.188.064-.195.096-.008.032.032.081.12.147.065.047.082.114.1.18.025.096.05.189.23.23a.344.344 0 0 0 .075.008c.089 0 .137-.043.161-.08.04-.061.04-.136.014-.174-.054-.081-.01-.238.088-.304.054-.036.099-.124.082-.198-.015-.061-.07-.103-.16-.123a.47.47 0 0 0-.104-.013zm-.081.946a.402.402 0 0 1-.09-.01c-.219-.049-.25-.167-.277-.271-.015-.061-.03-.114-.078-.15-.112-.083-.156-.144-.142-.199.014-.057.083-.096.24-.137a.343.343 0 0 0 .149-.1c.065-.062.138-.133.28-.133.036 0 .076.005.118.015.145.032.192.107.205.164.024.097-.034.205-.103.251-.073.05-.112.177-.073.235.04.06.034.156-.015.228a.247.247 0 0 1-.214.107z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M23.145 14.169c.045-.035.08-.155-.04-.186-.142-.036-.15.086-.232.11-.107.032-.132.066-.038.146.065.055.008.172.15.209.12.031.153-.095.125-.143-.021-.036-.002-.107.035-.136z",
    fill: "#CD7418"
  }), React__default.createElement("path", {
    d: "M23.434 14.017c-.113 0-.172.056-.234.116-.049.046-.1.095-.177.115-.125.032-.189.063-.196.096-.008.032.032.08.121.147.065.047.082.114.098.179.027.097.05.19.232.23a.346.346 0 0 0 .075.009c.089 0 .136-.043.16-.08.041-.061.04-.136.015-.174-.055-.081-.01-.238.089-.304.052-.037.098-.125.08-.198-.014-.062-.069-.103-.16-.123a.472.472 0 0 0-.103-.013zm-.081.946a.402.402 0 0 1-.09-.01c-.219-.05-.25-.168-.277-.271-.016-.062-.03-.114-.079-.15-.111-.083-.155-.144-.141-.2.014-.056.083-.095.239-.136a.354.354 0 0 0 .149-.1c.065-.062.139-.133.28-.133.036 0 .076.004.119.014.145.032.192.107.205.165.023.097-.034.204-.104.251-.071.05-.112.176-.071.235.039.06.032.156-.015.228a.249.249 0 0 1-.215.107z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M23.306 14.21c.045-.035.082-.154-.04-.185-.14-.037-.15.085-.231.11-.107.032-.132.066-.038.145.064.055.008.173.15.21.12.03.152-.095.124-.144-.02-.035-.002-.107.035-.136z",
    fill: "#CD7418"
  }), React__default.createElement("path", {
    d: "M23.596 14.058c-.114 0-.172.056-.234.116a.398.398 0 0 1-.177.116c-.124.031-.188.063-.196.095-.008.033.033.081.12.147.065.048.083.114.1.18.025.097.05.189.23.23a.348.348 0 0 0 .075.008c.09 0 .137-.043.161-.08.041-.06.04-.136.015-.173-.056-.082-.01-.239.088-.305.053-.036.098-.124.08-.198-.014-.061-.068-.103-.16-.123a.477.477 0 0 0-.102-.013zm-.082.947a.398.398 0 0 1-.09-.011c-.218-.049-.249-.167-.276-.27-.016-.062-.03-.115-.079-.151-.111-.082-.155-.144-.142-.199.014-.056.083-.096.24-.136.061-.016.103-.057.149-.1.065-.063.139-.133.28-.133a.52.52 0 0 1 .118.014c.145.032.192.107.206.164a.255.255 0 0 1-.104.252c-.072.049-.111.176-.072.234.04.06.034.156-.015.229a.247.247 0 0 1-.215.107zm1.749-.982l-.017-.021a.533.533 0 0 0 .183-.578c-.065-.25-.257-.438-.477-.47l.003-.027c.232.034.433.23.5.49a.56.56 0 0 1-.192.606zm-.16.098c-.07-.105-.132-.49-.062-.575l.021.018c-.058.07-.004.439.063.542l-.022.015z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.098 14.137l-.13-.03A9.383 9.383 0 0 1 24.52 14l.008-.025c.078.024.29.072.445.107.05.011.096.021.13.03l-.006.026z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M24.87 14.327c-.046-.116-.094-.506-.036-.613l.036.01c-.054.1-.007.485.037.595l-.037.008z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.324 13.863a2.19 2.19 0 0 1-.315-.04 1.182 1.182 0 0 0-.237-.029l-.004-.03c.04-.006.136.01.245.029.137.023.365.061.387.023l.024.015c-.013.023-.047.032-.1.032z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.343 13.944l-.02-.02c.074-.073-.023-.206-.11-.323-.056-.077-.105-.144-.106-.193h.027c.001.04.05.106.102.176.092.127.197.27.107.36z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.065 13.592a.11.11 0 0 1-.034-.005l.009-.025c.048.016.246-.034.33-.118.032-.032.043-.063.032-.094l.026-.008c.014.04 0 .082-.038.121a.567.567 0 0 1-.325.129zm-.429.951c-.053-.16-.141-.442-.135-.55h.028c-.007.109.09.415.133.541l-.026.009z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M24.824 14.345a1.06 1.06 0 0 1-.255-.056c-.106-.03-.217-.063-.27-.05l-.006-.027c.061-.014.17.017.284.051.106.032.216.064.272.053l.006.027a.157.157 0 0 1-.031.002zm-.741.286l-.026-.009c.019-.052.132-.06.317-.067.12-.004.257-.009.284-.042l.021.018c-.035.042-.16.046-.304.052-.124.004-.279.01-.292.048z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M24.508 14.75c-.022-.04-.056-.09-.092-.145-.098-.147-.2-.3-.158-.361l.023.015c-.032.047.078.211.158.331.036.054.07.106.093.147l-.024.013zm-.068.272l-.027-.006c.006-.031-.087-.1-.161-.156-.11-.082-.215-.16-.199-.223l.027.006c-.012.047.099.13.188.196.112.083.18.137.172.183z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M24.033 15.09c-.011-.085.147-.172.3-.255.082-.045.16-.087.18-.115l.022.016a.74.74 0 0 1-.188.123c-.125.068-.296.16-.287.227l-.027.003zm.103.326c-.04-.098.073-.22.174-.326.055-.06.106-.114.116-.15l.027.007c-.012.043-.064.097-.123.161-.09.096-.203.216-.17.298l-.024.01z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M24.4 15.315c-.012-.078-.113-.144-.206-.174-.068-.022-.115-.02-.128-.008l-.02-.02c.036-.034.128-.007.156.002.094.03.21.1.225.196l-.027.004zm.178-.234c-.012-.037-.047-.038-.08-.04-.026-.001-.05-.003-.066-.02l.015-.04c.01.01.03.011.05.012.04.002.085.004.105.064l-.024.024zm.11.193c-.014-.033-.09-.032-.145-.03-.071.002-.116.001-.133-.032a.072.072 0 0 1-.007-.034h.027v-.004c.009.019.071.017.113.016.087-.002.145 0 .166.048l-.021.036z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M24.44 15.424c-.012-.041.028-.092.07-.126.056-.048.148-.091.22-.056l-.011.024c-.057-.027-.137.007-.193.053-.041.034-.066.075-.06.098l-.026.007zm.091.18c-.018-.056.053-.194.124-.27.046-.05.09-.073.125-.064l-.006.027c-.026-.007-.061.013-.1.055-.074.08-.129.206-.117.244l-.026.008zm.167.132c-.02-.013-.023-.048-.006-.108.031-.117.138-.326.238-.329v.027c-.074.002-.179.186-.212.309-.016.058-.009.076-.006.078l-.014.023zm.205.058c-.03-.004-.028-.053-.027-.069.007-.124.106-.429.23-.429v.027c-.044 0-.098.065-.143.175-.055.133-.069.256-.055.27l-.005.026zm.158.01c-.018-.001-.04-.015-.04-.077-.002-.14.095-.427.226-.436l.002.027c-.109.007-.203.281-.201.408 0 .034.008.05.014.05v.028zm.18.006c-.023 0-.05-.022-.046-.118.004-.136.074-.4.186-.4h.002v.028h-.002c-.082 0-.154.225-.159.373-.002.065.01.09.02.09l-.001.027zm.118.012c-.056-.016-.026-.156-.01-.216.032-.122.104-.295.18-.295.003 0 .007 0 .01.002l-.006.026c-.043-.01-.116.115-.158.274-.03.118-.023.18-.008.184l-.008.025zm.089.033c-.06-.06.051-.31.132-.419.045-.06.081-.082.11-.067l-.013.025c-.01-.006-.036.006-.075.059-.095.127-.172.346-.135.383l-.019.019zm.019.034c-.015-.053.229-.345.326-.391.036-.017.052-.003.06.007l-.023.015c-.001-.001-.004-.005-.017 0-.095.032-.32.329-.319.362l-.027.007zm.02.068l-.026-.008c.02-.063.362-.196.472-.196h.006c.033.002.043.016.046.028l-.027.006c0-.003-.006-.006-.02-.006h-.006c-.113 0-.431.134-.445.176zm-.038.081l-.022-.02c.04-.063.43-.113.544-.052.036.019.04.046.037.066l-.027-.007c0-.004.003-.016-.021-.029-.106-.057-.483-.003-.511.042z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.957 16.17l-.023-.015c.002-.002.003-.005-.005-.012-.07-.064-.482-.101-.514-.076l-.02-.018c.043-.046.468.008.548.07.028.022.02.043.014.05zm-.09.12l-.02-.02c-.009-.036-.353-.137-.471-.137v-.027c.103 0 .47.092.497.155.004.01.002.02-.006.029zm-.122.101l-.018-.02c.004-.004.004-.006.003-.01-.014-.045-.197-.126-.349-.143l.003-.027c.146.016.351.095.372.162a.035.035 0 0 1-.011.038zm-1.52-.883c-.03 0-.054-.01-.066-.035l.024-.015c.02.045.143-.004.209-.03l.057-.02.007.03a.7.7 0 0 0-.056.02.56.56 0 0 1-.175.05zm.157.19c-.028 0-.053-.008-.07-.028l.019-.026c.04.047.152 0 .217-.046l.013.032a.351.351 0 0 1-.179.068zm.722-2.338c-.008-.087.118-.19.203-.213l.007.026c-.075.02-.189.114-.183.185l-.027.002z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.401 13.333l-.033-.01c-.101-.028-.288-.082-.337-.142l.022-.017c.042.054.239.11.322.133l.034.01-.008.026zm-.287-.337l-.02-.019.003-.003c.088-.094.177-.177.23-.15l-.013.024c-.029-.014-.094.035-.197.145l-.003.003zm.161.114l-.02-.018c.066-.082.136-.159.193-.162a.054.054 0 0 1 .046.018l-.02.019a.032.032 0 0 0-.024-.01c-.054.003-.139.108-.175.152zm.091.122l-.02-.02c.041-.04.16-.143.235-.143h.005c.017.001.03.008.04.02l-.022.017c-.004-.006-.01-.01-.02-.01-.054-.002-.16.077-.218.136z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M25.42 13.344l-.017-.022c.07-.054.205-.132.271-.108.019.006.031.02.036.04l-.026.007a.029.029 0 0 0-.019-.022c-.047-.017-.164.041-.245.105zm.044.148l-.013-.024.026-.014c.122-.067.198-.105.228-.084.007.004.015.014.012.033l-.027-.003v-.008c-.016-.015-.14.053-.2.086l-.026.014zm.003.145l-.012-.026c.152-.077.19-.083.204-.065.006.006.01.017 0 .035l-.023-.014a.613.613 0 0 0-.17.07zm-.017.155l-.01-.045a.236.236 0 0 1 .123-.055v.048c-.028 0-.07.02-.113.052zm-1.234-.684h-.003l.002-.027c.044 0 .128-.125.197-.225.085-.127.166-.246.227-.246v.027c-.047 0-.13.124-.205.234-.086.127-.16.237-.218.237zm-.19-.032c-.012-.008-.024-.026-.014-.066.029-.118.223-.357.347-.37l.003.027c-.113.012-.297.24-.324.35-.004.019-.003.032.003.036l-.015.023zm-.176-.325h-.027c0-.031.019-.064.054-.096a.49.49 0 0 1 .321-.113l-.002.027a.46.46 0 0 0-.3.106c-.03.026-.045.053-.045.076z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M24.14 13.102a.442.442 0 0 1-.07-.416c.027-.071.073-.12.121-.13l.006.025c-.038.009-.078.053-.102.114a.412.412 0 0 0 .067.391l-.022.016zm.366-.054c-.078-.038-.248-.194-.286-.317-.011-.037-.01-.07.005-.094l.023.013c-.01.019-.01.043-.002.073.034.108.19.261.271.3l-.011.025zm-.298 3.833h-.015c-.022-.003-.039-.01-.05-.024l.023-.017c.005.008.015.012.03.014.106.011.378-.13.46-.202l.018.02c-.084.074-.343.21-.466.21z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M24.492 17.032a.06.06 0 0 1-.047-.021c-.043-.052-.011-.19.019-.324.018-.079.045-.198.025-.21l.015-.023c.036.02.02.1-.012.239-.026.115-.059.26-.024.3.006.008.014.011.025.012v.027zm-.369-.2c-.022-.04.026-.097.087-.169.08-.096.181-.216.141-.323l.026-.01c.045.123-.06.25-.146.35-.048.057-.097.116-.084.139l-.024.013zm-.103-.211c-.026-.072.057-.19.138-.303.06-.083.122-.17.111-.208l.026-.007c.014.05-.046.134-.115.231-.073.103-.156.219-.134.278l-.025.01zm-.11-.401c-.04-.088.029-.226.09-.348.034-.07.077-.158.058-.173l.017-.021c.036.028 0 .103-.052.206-.054.11-.122.249-.088.325l-.025.011z",
    fill: "#000"
  }), React__default.createElement("path", {
    d: "M23.745 16.015c-.022 0-.039-.004-.05-.015l.016-.024c.023.02.106-.001.187-.022.143-.036.322-.082.364.044l-.025.01c-.034-.1-.2-.058-.333-.024a.735.735 0 0 1-.159.03zm.455.555a.374.374 0 0 1-.174-.032c-.02-.012-.032-.027-.035-.045l.027-.005c.001.01.012.018.021.023.072.042.303.047.487-.04l.01.026a.82.82 0 0 1-.336.073zm-.015-.195a.375.375 0 0 1-.122-.02c-.07-.023-.123-.066-.14-.11l.025-.01c.014.038.062.073.123.094a.34.34 0 0 0 .28-.025l.014.024a.353.353 0 0 1-.18.047zm-.545-.424c-.02-.014-.033-.05.021-.139.056-.092.19-.245.244-.217l-.011.024c-.024-.01-.14.091-.21.207-.038.064-.04.096-.029.103l-.015.022zm-.206-.179c-.04-.05.027-.145.097-.211.067-.063.16-.122.2-.085l-.017.02c-.018-.016-.086.012-.164.085-.076.071-.117.146-.095.174l-.021.017zm-.111-.217c-.023-.08.084-.154.194-.19.071-.023.153-.032.17.012l-.026.01c-.007-.018-.06-.02-.136.004-.098.032-.193.098-.176.156l-.026.008zm.033-.268l-.026-.007c.022-.088.177-.127.271-.11.065.013.099.048.093.099l-.028-.003c.006-.045-.035-.062-.07-.068-.09-.017-.224.023-.24.089zm.412-.21l-.025-.011c.001-.004.006-.014-.005-.028-.03-.038-.132-.07-.216-.058-.034.006-.076.021-.091.063l-.026-.01c.015-.042.054-.07.112-.08.088-.014.204.018.242.068.018.023.015.043.009.056zm-.281-.21l-.027-.004c.011-.071.133-.113.235-.105.079.007.125.045.123.101h-.027c.001-.059-.068-.071-.098-.074-.085-.007-.198.029-.206.082zm-.027-.182c-.012-.068.076-.132.163-.153.088-.021.154.004.171.065l-.025.007c-.017-.054-.083-.06-.14-.046-.074.018-.151.072-.142.122l-.027.005zm-.053-.099c-.018-.022-.02-.05-.008-.08.032-.075.157-.15.237-.158.044-.004.065.012.075.026l-.023.015c-.01-.015-.032-.015-.05-.014-.07.007-.186.076-.214.142-.008.02-.007.038.005.052l-.022.017zm-.058-.049c-.016-.01-.034-.032-.03-.078.006-.09.092-.23.162-.261.03-.013.049-.006.06.003l-.017.022c-.002-.003-.012-.01-.032 0-.061.028-.14.157-.146.238-.003.026.003.044.017.053l-.014.023zm.647-2.031c-.04-.067-.053-.207.015-.271a.523.523 0 0 0 .155-.224c.007-.023.004-.029.004-.029 0 .002-.011.005-.033.022-.021.016-.05.02-.07.009a.041.041 0 0 1-.022-.042.136.136 0 0 1 .1-.109.035.035 0 0 1 .035.01c.016.017.012.05.007.066l-.026-.007c.005-.016.004-.035-.001-.04-.001-.001-.002-.003-.01-.002a.11.11 0 0 0-.078.084c-.001.008.002.013.008.016.009.005.026.004.04-.007.031-.024.052-.03.066-.02.018.01.012.037.007.056a.546.546 0 0 1-.163.237c-.058.054-.045.179-.01.238l-.024.013z",
    fill: "#000"
  })));
},
    _extends$88 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$88(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var MY = function MY(e) {
  e.styles;

  var t = _objectWithoutProperties$88(e, ["styles"]);

  return React__default.createElement("svg", _extends$88({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#CB0202",
    d: "M.56 12.394h54.31V9.938H.56zm0 9.409h54.31v-2.455H.56zm0 4.705h54.31v-2.456H.56zm0-9.41h54.31v-2.455H.56zm0 14.114h54.31v-2.456H.56zm0-23.523h54.31V5.182H.56zm0-4.756h54.31V.519H.56z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M.56 5.182h54.31V2.933H.56zm0 4.756h54.31v-2.25H.56zm0 4.705h54.31v-2.25H.56zm0 4.705h54.31v-2.25H.56zm0 4.704h54.31v-2.249H.56zm0 4.704h54.31v-2.249H.56zm0 4.705h54.31v-2.249H.56z"
  }), React__default.createElement("path", {
    fill: "#040265",
    d: "M.56 19.348h27.185V.519H.56z"
  }), React__default.createElement("path", {
    fill: "#FECB16",
    d: "M17.879 12.123l-.54 3.022-.517-3.022-1.712 2.5.727-3.021-2.486 1.459 1.829-2.371-2.722.13 2.488-1.254-2.558-1.273 2.84.208-1.854-2.371 2.487 1.46-.751-3.023 1.69 2.475.587-2.97.492 2.918 1.736-2.397-.751 3.022L21.35 6.13l-1.806 2.346 2.745-.131-2.487 1.22 2.512 1.28-2.793-.181 1.829 2.397-2.463-1.434.657 2.97z"
  }), React__default.createElement("path", {
    d: "M14.688 3.968S10.206.71 6.475 5.61c0 0-3.192 4.507.797 8.936 0 0 3.145 3.49 7.322.676 0 0-4.32 1.59-6.477-2.89-2.16-4.482 1.643-10.005 6.57-8.364",
    fill: "#FECB16"
  })));
},
    _extends$89 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$89(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var NL = function NL(e) {
  e.styles;

  var t = _objectWithoutProperties$89(e, ["styles"]);

  return React__default.createElement("svg", _extends$89({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 35"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#22468A",
    d: "M.952 34.024h54.704V22.861H.952z"
  }), React__default.createElement("path", {
    fill: "#AD1C27",
    d: "M.952 11.946h54.704V.784H.952z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M.952 22.862h54.704V11.946H.952z"
  })));
},
    _extends$90 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$90(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var NO = function NO(e) {
  e.styles;

  var t = _objectWithoutProperties$90(e, ["styles"]);

  return React__default.createElement("svg", _extends$90({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#EE2B2D",
    d: "M.952 33.305h15.021V21.004H.952zm0-20.614h15.021V.387H.952zm24.867 0h29.837V.387H25.819zm-.001 20.614h29.837V21.004H25.818z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M.952 14.811v6.193h15.021v12.301h9.845v-12.3h29.838V12.69H25.818V.386h-9.845V12.69H.953z"
  }), React__default.createElement("path", {
    fill: "#022867",
    d: "M18.33 14.811H.954v4.072H18.33v14.422h4.982V18.883h32.343v-4.072H23.313V.386H18.33z"
  })));
},
    _extends$91 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$91(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var NZ = function NZ(e) {
  e.styles;

  var t = _objectWithoutProperties$91(e, ["styles"]);

  return React__default.createElement("svg", _extends$91({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#04247B",
    d: "M0 33.624h54.315V.502H0z"
  }), React__default.createElement("path", {
    fill: "#CB142A",
    d: "M32.598 14.09h1.39l.47-1.627.432 1.604h1.484l-1.165 1.1.414 1.605-1.147-1.01-1.165 1.032.433-1.627z"
  }), React__default.createElement("path", {
    d: "M33.84 15.13l-.374 1.404 1.01-.894.995.875-.357-1.385 1.021-.965H34.83l-.375-1.393-.409 1.418h-1.21l1.003.94zm-.192.073l-1.1-1.035.05-.078-.05.078-.189-.18h1.571l.53-1.834.488 1.813h1.664l-1.308 1.236.47 1.823-1.298-1.141-1.32 1.169.492-1.851z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    fill: "#CB142A",
    d: "M38.819 26.072h1.456l.492-1.705.452 1.68h1.554l-1.22 1.152.433 1.68-1.2-1.058-1.22 1.081.454-1.703z"
  }), React__default.createElement("path", {
    d: "M40.12 27.161l-.392 1.469 1.058-.936 1.041.916-.373-1.449 1.07-1.01h-1.367l-.393-1.46-.429 1.485H39.07l1.05.985zm-.2.075l-1.153-1.082.052-.082-.052.082-.198-.186h1.645l.555-1.923.512 1.898h1.741l-1.37 1.293.492 1.909-1.358-1.195-1.38 1.224.513-1.938z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    fill: "#CB142A",
    d: "M38.976 6.419h1.306l.44-1.53.407 1.508h1.394L41.429 7.43l.388 1.507-1.076-.95-1.094.97.406-1.527z"
  }), React__default.createElement("path", {
    d: "M40.142 7.395l-.35 1.318.948-.839.935.822-.335-1.3.958-.907h-1.224l-.354-1.31-.384 1.332H39.2l.94.884zm-.18.067l-1.032-.97.046-.076-.046.076-.178-.167h1.475l.498-1.724.459 1.701h1.562l-1.228 1.16.44 1.714-1.217-1.072-1.24 1.098.462-1.74z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    fill: "#CB142A",
    d: "M44.43 12.135h1.225l.414-1.434.38 1.414h1.308l-1.027.968.364 1.413-1.01-.886-1.026.908.38-1.435z"
  }), React__default.createElement("path", {
    d: "M45.522 13.053l-.328 1.234.89-.787.876.772-.314-1.221.9-.85h-1.149l-.332-1.227-.36 1.248H44.64l.882.83zm-.167.062l-.97-.911.044-.07-.044.07-.166-.156h1.384l.466-1.616.431 1.596h1.465l-1.152 1.087.414 1.607-1.143-1.005-1.162 1.029.433-1.631z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    fill: "#04247B",
    d: "M.023 17.154h27.102V.502H.023z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M24.066.488l-8.255 5.107L.024 15.31v1.845h3.06L27.125 2.348V.502l-.49-.014z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M27.125 15.31L3.152.5H.023v1.903l24.088 14.75h3.014z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M27.125 11.618H.023V6.039l27.102.028z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M11.328.502v16.652h4.518L15.823.502z"
  }), React__default.createElement("path", {
    fill: "#E5173A",
    d: "M27.125 7.178H.023v3.303l27.102.028zM25.106.488l-9.081 5.57h2.079L27.126.502l-.491-.014z"
  }), React__default.createElement("path", {
    fill: "#E5173A",
    d: "M14.918.502l-.022 16.652h-2.688L12.231.502zM.024.502l9 5.547-2.01-.001L.025 1.71zm0 16.652l9-5.536h1.965l-8.921 5.536zm18.146-5.536l8.956 5.536v-1.261l-6.99-4.275z"
  })));
},
    _extends$92 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$92(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var PE = function PE(e) {
  e.styles;

  var t = _objectWithoutProperties$92(e, ["styles"]);

  return React__default.createElement("svg", _extends$92({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 32"
  }, t), React__default.createElement("path", {
    fill: "#F5513C",
    d: "M0 0h16v32H0z"
  }), React__default.createElement("path", {
    fill: "#ECEFF0",
    d: "M16 0h16v32H16z"
  }), React__default.createElement("path", {
    fill: "#F5513C",
    d: "M32 0h16v32H32z"
  }), React__default.createElement("circle", {
    fill: "#40B193",
    cx: "24",
    cy: "16",
    r: "3.9"
  }));
},
    _extends$93 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$93(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var PH = function PH(e) {
  e.styles;

  var t = _objectWithoutProperties$93(e, ["styles"]);

  return React__default.createElement("svg", _extends$93({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#0738A6",
    d: "M1.082 16.746h53.933V.152H1.082z"
  }), React__default.createElement("path", {
    fill: "#CD1225",
    d: "M1.082 33.506h53.933v-16.76H1.082z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M.914.233v33.19L24.41 16.747z"
  }), React__default.createElement("path", {
    fill: "#FBD022",
    d: "M3.733 5.317l.81.858H3.51l-.517 1.043-.203-1.25-1.055-.157.875-.65-.156-1.171.787.767.943-.597zm15.271 10.525l.629.95-.618 1.118 1.068-.415.595.949V17.3l1.045-.417-1.034-.416V15.23l-.583.95zM1.745 27.888l1.022-.13.247-1.195.46 1.117 1.045-.104-.745.866.386 1.085-.932-.585-.747.864.186-1.282zM12.138 16.87c0 1.708-1.192 3.096-2.662 3.096-1.472 0-2.664-1.388-2.664-3.096 0-1.71 1.192-3.097 2.664-3.097 1.47 0 2.662 1.388 2.662 3.097"
  }), React__default.createElement("path", {
    fill: "#FBD022",
    d: "M8.498 11.3l.506 2.68.157-.063-.37-2.954zm.809 2.629l-.19-3.278.36-.416.335.391-.179 3.343zm.506 0l.325-2.952.276.317-.455 2.662zm2.371-1.798l-1.277 2.31.15.084 1.541-2.394zm-1.032 2.521l1.867-2.475h.508v.553l-2.17 2.217zm.358.414l2.032-1.821v.45l-1.944 1.51zm2.774.671l-2.314.586.056.182 2.55-.43zm-2.27.938l2.833-.223.36.418-.338.39-2.888-.21zm0 .585l2.552.377-.275.318-2.298-.527zm1.553 2.746l-1.995-1.48-.07.174 2.065 1.785zM11.39 18.81l2.138 2.162v.588h-.477l-1.915-2.51zm-.358.414l1.573 2.355h-.389l-1.303-2.254zm-.579 3.213l-.506-2.68-.157.065.371 2.953zm-.809-2.627l.191 3.276-.359.417-.338-.389.181-3.344zm-.506 0l-.325 2.953-.277-.32.456-2.659zm-2.372 1.797l1.28-2.31-.152-.08-1.54 2.39zM7.8 19.085l-1.868 2.476h-.509v-.552l2.17-2.218zm-.357-.412l-2.035 1.822v-.451l1.946-1.51zm-2.776-.672l2.314-.585-.056-.183-2.551.43zm2.269-.936l-2.832.22-.358-.415.337-.391 2.887.208zm0-.586l-2.551-.376.276-.32 2.297.527zm-1.552-2.747l1.994 1.48.07-.173-2.064-1.785zm2.176 1.196l-2.137-2.162v-.588h.476l1.915 2.512zm.359-.413l-1.574-2.356h.39l1.304 2.254z"
  })));
},
    _extends$94 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$94(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var PL = function PL(e) {
  e.styles;

  var t = _objectWithoutProperties$94(e, ["styles"]);

  return React__default.createElement("svg", _extends$94({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#FFF",
    d: "M.904 17.053h53.792V.7H.904z"
  }), React__default.createElement("path", {
    fill: "#DB153B",
    d: "M.904 33.406h53.792V17.052H.904z"
  })));
},
    _extends$95 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$95(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var PT = function PT(e) {
  e.styles;

  var t = _objectWithoutProperties$95(e, ["styles"]);

  return React__default.createElement("svg", _extends$95({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 33"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#060",
    d: "M.036.018h22.227v32.964H.036z"
  }), React__default.createElement("path", {
    fill: "red",
    d: "M22.262.018H55v32.964H22.262z"
  }), React__default.createElement("path", {
    d: "M30.034 20.075a1.65 1.65 0 0 1-.177-.014c-1.034-.123-4.107-1.552-7.584-3.565-3.477-2.012-6.248-3.965-6.872-4.8a1.475 1.475 0 0 1-.097-.14l-.735 1.28c-.04.069-.082.079.026.228.604.827 3.386 2.79 6.882 4.813 3.497 2.024 6.586 3.457 7.601 3.568.182.019.15-.037.208-.092l.747-1.278z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M15.305 11.614l-.71 1.237-.018.029c-.027.04-.038.056.042.166.617.844 3.443 2.82 6.873 4.805 3.43 1.985 6.552 3.451 7.59 3.564a.507.507 0 0 0 .06.003c.061 0 .07-.013.086-.04a.216.216 0 0 1 .034-.044l.72-1.231a1.854 1.854 0 0 1-.128-.012c-1.06-.127-4.184-1.595-7.596-3.57-3.412-1.973-6.241-3.95-6.881-4.808a2.198 2.198 0 0 1-.072-.099zm13.837 9.864c-.019 0-.04 0-.067-.003-1.045-.114-4.176-1.583-7.613-3.572-3.436-1.989-6.27-3.971-6.892-4.822-.094-.13-.085-.17-.043-.234a.428.428 0 0 0 .016-.026l.76-1.324.027.044c.025.043.06.09.095.137.636.851 3.458 2.822 6.863 4.792 3.405 1.971 6.52 3.436 7.573 3.562.067.007.121.013.167.013h.052l-.02.045-.753 1.284a.172.172 0 0 0-.028.036c-.025.04-.05.068-.137.068z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M15.235 11.444c-.07.085.002.187.118.342.624.835 3.395 2.787 6.872 4.799 3.478 2.013 6.551 3.442 7.584 3.567.191.023.309.035.353-.07.046-.108-.144-.362-.144-.362.044.122.108.247-.073.227-1.016-.11-4.103-1.545-7.6-3.569-3.496-2.023-6.28-3.985-6.884-4.812-.108-.148 0-.155.14-.176-.22-.005-.29-.036-.366.054z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M15.386 11.411c-.064 0-.094.012-.128.052-.052.063-.001.146.118.305.638.851 3.46 2.821 6.864 4.79 3.405 1.971 6.519 3.437 7.572 3.564.204.024.29.025.323-.052.015-.035-.006-.101-.04-.17a.086.086 0 0 1-.015.04c-.023.032-.064.045-.138.037-1.043-.113-4.173-1.582-7.613-3.573-3.437-1.99-6.272-3.972-6.892-4.82-.028-.04-.064-.097-.044-.144a.079.079 0 0 1 .02-.029h-.027zm14.606 8.786c-.05 0-.11-.006-.187-.016-1.06-.128-4.184-1.596-7.595-3.57-3.41-1.974-6.24-3.95-6.882-4.807-.109-.146-.203-.272-.116-.38.052-.06.103-.073.174-.073.025 0 .054.002.089.004l.126.005.004.06-.02.003c-.06.008-.127.018-.136.04-.003.006-.005.028.037.085.616.843 3.442 2.819 6.873 4.804 3.434 1.987 6.555 3.453 7.59 3.565.044.005.073 0 .082-.012.016-.022-.008-.087-.028-.139l-.013-.037.052-.027c.021.027.199.271.148.392-.04.092-.126.103-.198.103z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M14.374 12.909c-.06.083.01.202.126.357.625.834 3.396 2.786 6.873 4.798 3.478 2.013 6.55 3.443 7.583 3.568.191.023.295.027.354-.07.014-.084.015-.052-.04-.186 0 0 .004.07-.177.051-1.015-.111-4.103-1.545-7.6-3.57-3.497-2.023-6.28-3.985-6.884-4.811-.108-.148-.067-.123-.06-.189-.066.01-.092-.014-.175.052z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M14.396 12.93c-.043.065.017.17.128.319.638.85 3.46 2.82 6.864 4.79 3.405 1.97 6.518 3.435 7.572 3.563.068.008.122.014.166.014.081 0 .125-.018.155-.065l.002-.01c.007-.041.007-.041-.014-.088l-.007-.017c-.034.022-.086.03-.172.021-1.046-.115-4.176-1.585-7.613-3.574-3.436-1.988-6.27-3.97-6.893-4.82-.077-.106-.086-.133-.074-.173h-.007c-.034 0-.057 0-.107.04zm14.73 8.746c-.047 0-.103-.006-.174-.014-1.06-.129-4.183-1.598-7.594-3.572-3.41-1.973-6.24-3.949-6.882-4.806-.11-.147-.203-.288-.127-.393l.006-.006c.069-.054.107-.054.147-.055.013 0 .027 0 .043-.002l.039-.006-.004.039c-.003.019-.007.032-.01.042-.007.017-.01.025.063.125.618.844 3.445 2.819 6.874 4.804 3.43 1.985 6.55 3.451 7.589 3.566.11.011.142-.015.144-.023l.057-.01a.73.73 0 0 0 .028.063c.026.061.027.067.017.124l-.007.026c-.052.086-.135.097-.209.097z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M15.254 21.043c.804.389 3.638.677 7.012.677 3.363 0 6.19-.286 7.004-.674l.429-.727c-.822.415-3.838.724-7.434.724-3.6 0-6.618-.31-7.435-.725l.424.725z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M15.276 21.02c.83.395 3.699.67 6.99.67 3.276 0 6.143-.274 6.982-.667l.376-.636c-.956.405-3.934.686-7.359.686-3.43 0-6.409-.281-7.36-.688l.37.635zm6.99.73c-3.31 0-6.198-.28-7.025-.68l-.008-.005-.48-.82.09.046c.836.425 3.888.722 7.422.722 3.53 0 6.58-.297 7.42-.72l.091-.047-.485.823-.008.004c-.836.399-3.722.677-7.017.677z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M29.386 20.854a.674.674 0 0 1-.211.125c-.95.363-3.684.625-6.91.625-3.227 0-5.962-.262-6.91-.625a.789.789 0 0 1-.212-.121c-.018.041-.022.081-.022.081 0 .493 3.198.892 7.145.892 3.946 0 7.145-.4 7.145-.892 0 0-.006-.044-.025-.085z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M15.158 20.906a.262.262 0 0 0-.007.036c0 .413 2.859.859 7.115.859 4.255 0 7.114-.445 7.115-.861 0 0-.003-.017-.009-.037a.638.638 0 0 1-.187.104c-.982.375-3.762.627-6.92.627-3.16 0-5.941-.252-6.92-.627a.772.772 0 0 1-.187-.101zm7.108.955c-3.527 0-7.175-.345-7.175-.922 0-.004.004-.048.025-.093l.015-.034.03.022c.07.053.121.085.205.117.973.373 3.746.623 6.9.623 3.15 0 5.922-.25 6.898-.623a.651.651 0 0 0 .204-.12l.03-.024.015.035c.02.045.027.091.028.093 0 .581-3.648.926-7.175.926z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M14.806 20.072c-.03.086.041.16.121.192.962.39 3.884.674 7.339.674 3.363 0 6.536-.348 7.34-.674.08-.033.147-.08.128-.173.083.034.086.132.086.132 0 .518-3.382.94-7.554.94-4.173 0-7.554-.422-7.554-.94 0 0-.007-.095.094-.15z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M14.771 20.139a.127.127 0 0 0-.03.082c0 .441 3.024.911 7.525.911 4.5 0 7.524-.47 7.524-.91a.142.142 0 0 0-.025-.07c-.017.087-.11.124-.148.14-.805.326-3.95.676-7.351.676-3.398 0-6.352-.272-7.35-.676-.069-.028-.132-.083-.145-.153zm7.495 1.053c-3.728 0-7.584-.362-7.584-.97a.198.198 0 0 1 .11-.176l.068-.038-.026.074c-.023.068.038.127.104.155.976.395 3.99.67 7.328.67 3.394 0 6.529-.346 7.328-.67.093-.038.124-.077.111-.14l-.011-.055.052.021c.1.04.104.154.104.16 0 .607-3.856.97-7.584.97z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M30.666 16.158a1.291 1.291 0 0 1-.158.116c-.944.623-4.278 1.081-8.246 1.081-3.965 0-7.298-.458-8.244-1.08a1.404 1.404 0 0 1-.151-.11l.001.543c0 .12-.031.166.134.278.925.625 4.272 1.089 8.26 1.089 3.99 0 7.339-.464 8.262-1.09.165-.112.11-.162.132-.277l.01-.55z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M13.897 16.228l.001.48-.001.05c-.004.082-.005.116.122.203.943.638 4.333 1.084 8.243 1.084 3.913 0 7.303-.446 8.245-1.085.11-.075.11-.112.112-.174 0-.025.001-.052.008-.084l.008-.48c-.033.025-.07.05-.11.077-.97.64-4.369 1.086-8.263 1.086-3.892 0-7.289-.446-8.26-1.086a2.46 2.46 0 0 1-.105-.072zm8.365 1.876c-3.92 0-7.325-.45-8.277-1.094-.147-.1-.152-.156-.148-.255l.001-.048-.002-.607.05.043c.039.033.087.066.148.106.963.634 4.347 1.076 8.228 1.076 3.884 0 7.268-.443 8.23-1.076.06-.04.113-.076.154-.114l.051-.047-.01.62c-.007.033-.007.056-.008.08-.002.07-.003.13-.138.221-.951.645-4.356 1.095-8.279 1.095z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M30.533 15.848c.098.127.16.27-.006.382-.923.627-4.271 1.09-8.261 1.09-3.988 0-7.336-.462-8.26-1.089-.165-.111-.103-.263-.005-.39 0 0-.251.157-.249.28-.017.165.094.245.27.36.945.621 4.278 1.079 8.244 1.079 3.967 0 7.3-.458 8.246-1.079.175-.115.281-.189.268-.36-.014-.176-.247-.273-.247-.273z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M13.897 15.956c-.063.055-.116.118-.115.165-.016.15.082.221.256.336.963.631 4.346 1.073 8.228 1.073 3.883 0 7.267-.442 8.23-1.074.18-.119.266-.182.254-.332-.007-.081-.067-.144-.124-.187a.25.25 0 0 1 .031.16c-.01.061-.048.114-.113.158-.95.645-4.354 1.095-8.278 1.095-3.922 0-7.326-.45-8.277-1.094a.242.242 0 0 1-.113-.16.261.261 0 0 1 .02-.14zm8.369 1.634c-3.892 0-7.29-.446-8.261-1.083-.163-.107-.303-.2-.283-.389-.003-.133.236-.286.263-.303l.04.044c-.07.09-.1.167-.09.229.008.045.036.084.088.118.942.639 4.331 1.084 8.243 1.084 3.913 0 7.304-.446 8.244-1.084.052-.035.08-.074.088-.118.01-.059-.02-.131-.088-.222l-.069-.089.104.044c.01.004.25.106.265.298.015.192-.11.274-.282.387-.971.638-4.368 1.084-8.262 1.084z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M30.66 16.664c-.018-.008.032.175-.133.287-.923.624-4.272 1.087-8.261 1.087-3.988 0-7.336-.462-8.26-1.086-.166-.112-.144-.162-.14-.292 0 0-.09.063-.114.182-.01.161.094.245.27.36.945.618 4.278 1.075 8.244 1.075 3.967 0 7.3-.457 8.246-1.076.175-.115.265-.187.267-.36-.01-.1-.073-.144-.118-.177z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M13.833 16.736a.273.273 0 0 0-.051.112c-.008.133.069.206.256.329.964.63 4.348 1.07 8.228 1.07 3.882 0 7.266-.44 8.23-1.07.178-.119.252-.182.254-.335a.18.18 0 0 0-.066-.122.317.317 0 0 1-.14.256c-.951.643-4.355 1.092-8.278 1.092-3.92 0-7.324-.449-8.277-1.091-.137-.093-.156-.15-.156-.241zm8.433 1.571c-3.89 0-7.288-.444-8.261-1.08-.172-.113-.294-.207-.283-.387a.344.344 0 0 1 .126-.204l.05-.035-.004.098c-.004.1-.006.137.129.228.943.637 4.333 1.081 8.243 1.081 3.912 0 7.302-.445 8.245-1.082.11-.074.113-.184.114-.236 0-.023.002-.056.035-.056l.016.004.007.005c.046.034.115.086.127.196-.003.195-.11.274-.282.387-.972.637-4.37 1.081-8.262 1.081z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M29.741 12.682c-.2.493-3.47.886-7.476.886-3.95 0-7.185-.382-7.465-.866l.401-.736c.246.46 3.314.824 7.064.824s6.819-.364 7.064-.824l.412.716z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M14.835 12.701c.33.47 3.572.837 7.43.837 3.878 0 7.195-.382 7.442-.855l-.38-.661c-.404.457-3.385.798-7.062.798-3.674 0-6.653-.34-7.06-.798l-.37.68zm7.43.897c-3.98 0-7.2-.379-7.49-.88l-.009-.015.436-.8.026.049c.242.453 3.333.808 7.037.808 3.705 0 6.796-.355 7.038-.808l.025-.048.446.776-.005.013c-.21.516-3.435.905-7.504.905z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M29.386 11.909a.668.668 0 0 1-.212.125c-.95.363-3.684.625-6.909.625-3.227 0-5.962-.263-6.91-.625a.785.785 0 0 1-.212-.121c-.019.04-.023.081-.023.081 0 .493 3.199.891 7.145.891 3.947 0 7.146-.398 7.146-.89 0 0-.006-.045-.025-.086z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M15.158 11.96a.232.232 0 0 0-.008.037c0 .413 2.86.859 7.115.859 4.256 0 7.115-.445 7.116-.862 0 0-.003-.015-.01-.036a.622.622 0 0 1-.186.104c-.981.375-3.762.627-6.92.627-3.16 0-5.941-.252-6.92-.628a.766.766 0 0 1-.187-.1zm7.107.955c-3.527 0-7.175-.344-7.175-.92 0-.006.005-.05.026-.095l.015-.034.03.023a.78.78 0 0 0 .205.117c.973.373 3.746.623 6.9.623 3.15 0 5.922-.25 6.897-.623a.643.643 0 0 0 .204-.12l.03-.024.016.035c.02.044.027.091.027.093 0 .58-3.648.925-7.175.925z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M14.806 12.577c-.03.086.041.16.121.193.962.392 3.884.677 7.339.677 3.363 0 6.536-.35 7.34-.677.08-.034.147-.08.128-.174.083.034.086.133.086.133 0 .52-3.382.942-7.555.942-4.172 0-7.553-.422-7.553-.942 0 0-.007-.095.094-.152z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M14.771 12.644c-.032.04-.03.082-.03.083 0 .442 3.024.914 7.524.914 4.501 0 7.525-.472 7.525-.912a.144.144 0 0 0-.025-.073c-.017.088-.11.125-.148.141-.804.328-3.95.68-7.351.68-3.398 0-6.352-.273-7.35-.68-.069-.027-.132-.083-.145-.153zm7.494 1.057c-3.727 0-7.583-.364-7.583-.972a.198.198 0 0 1 .11-.178l.068-.038-.026.074c-.023.068.038.128.104.155.977.397 3.99.675 7.328.675 3.394 0 6.529-.35 7.328-.675.093-.038.124-.077.111-.14l-.011-.055.052.021c.1.041.104.155.104.16 0 .61-3.856.973-7.585.973z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M30.54 16.5c0 4.56-3.705 8.258-8.274 8.258-4.57 0-8.274-3.697-8.274-8.258 0-4.56 3.704-8.258 8.274-8.258 4.57 0 8.273 3.697 8.273 8.258zm-8.274-7.3c-4.04 0-7.315 3.268-7.315 7.3s3.275 7.3 7.315 7.3c4.04 0 7.314-3.268 7.314-7.3s-3.274-7.3-7.314-7.3z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M22.266 9.23c-4.017 0-7.285 3.261-7.285 7.27 0 4.009 3.268 7.27 7.285 7.27 4.016 0 7.284-3.261 7.284-7.27 0-4.009-3.268-7.27-7.284-7.27zm0 14.6c-4.05 0-7.345-3.288-7.345-7.33s3.295-7.33 7.345-7.33 7.344 3.288 7.344 7.33-3.295 7.33-7.344 7.33zm0-15.558c-4.546 0-8.244 3.691-8.244 8.228s3.698 8.228 8.244 8.228c4.545 0 8.243-3.691 8.243-8.228s-3.698-8.228-8.243-8.228zm0 16.516c-4.579 0-8.304-3.718-8.304-8.288s3.725-8.287 8.304-8.287c4.578 0 8.303 3.717 8.303 8.287s-3.725 8.288-8.303 8.288z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M22.266 8.512c-4.414 0-8.004 3.583-8.004 7.988s3.59 7.988 8.004 7.988c4.413 0 8.004-3.583 8.004-7.988s-3.591-7.988-8.004-7.988zm0 16.036c-4.447 0-8.064-3.61-8.064-8.048 0-4.438 3.617-8.048 8.064-8.048 4.446 0 8.063 3.61 8.063 8.048 0 4.438-3.617 8.048-8.063 8.048z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M22.266 8.99c-4.15 0-7.525 3.37-7.525 7.51 0 4.141 3.376 7.51 7.525 7.51 4.149 0 7.524-3.369 7.524-7.51 0-4.14-3.375-7.51-7.524-7.51zm0 15.08c-4.182 0-7.585-3.396-7.585-7.57s3.403-7.57 7.585-7.57 7.584 3.396 7.584 7.57-3.402 7.57-7.584 7.57z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M13.866 16.86c.041-.037.093-.074.158-.116.944-.623 4.278-1.082 8.245-1.082 3.966 0 7.299.459 8.245 1.082.06.039.11.073.151.109l-.002-.543c0-.12.032-.166-.134-.278-.924-.626-4.272-1.09-8.26-1.09-3.99 0-7.338.465-8.261 1.09-.165.113-.11.162-.132.278l-.01.55z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M22.27 14.973c-3.913 0-7.303.446-8.245 1.084-.11.075-.11.112-.112.175a.458.458 0 0 1-.008.084l-.008.48c.03-.024.067-.048.11-.077.97-.64 4.368-1.087 8.262-1.087 3.893 0 7.29.447 8.261 1.087.041.026.075.05.105.071l-.002-.48c0-.018 0-.035.002-.05.003-.083.005-.117-.123-.204-.943-.638-4.333-1.083-8.243-1.083zm-8.436 1.956l.012-.62a.435.435 0 0 0 .007-.079c.002-.07.003-.13.138-.222.951-.645 4.355-1.095 8.278-1.095 3.921 0 7.325.45 8.277 1.094.148.1.153.156.148.255v.048l.001.608-.05-.043a1.472 1.472 0 0 0-.148-.106c-.962-.634-4.346-1.077-8.228-1.077-3.884 0-7.268.443-8.229 1.077a1.236 1.236 0 0 0-.154.113l-.052.047z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M13.998 17.17c-.097-.128-.158-.271.006-.383.923-.627 4.272-1.09 8.262-1.09 3.987 0 7.335.462 8.26 1.09.165.111.102.263.005.39 0 0 .251-.157.248-.28.018-.165-.093-.246-.269-.36-.946-.622-4.278-1.08-8.244-1.08-3.967 0-7.3.458-8.246 1.08-.175.115-.281.189-.268.36.014.175.246.273.246.273z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M22.266 15.488c-3.883 0-7.268.441-8.23 1.073-.18.12-.266.183-.254.333.007.08.067.144.124.186a.262.262 0 0 1-.031-.16c.01-.06.047-.113.113-.157.949-.646 4.353-1.096 8.278-1.096 3.923 0 7.326.45 8.277 1.095a.24.24 0 0 1 .112.158.26.26 0 0 1-.02.142c.062-.055.115-.118.114-.165.016-.15-.081-.222-.255-.336-.963-.632-4.346-1.074-8.228-1.074zM14.09 17.24l-.103-.044c-.01-.004-.25-.107-.265-.298-.015-.192.11-.274.282-.388.97-.638 4.368-1.083 8.262-1.083 3.892 0 7.29.445 8.26 1.083.15.098.281.184.285.346v.012c0 .01 0 .02-.002.03.003.133-.235.286-.262.303l-.04-.043c.07-.092.1-.167.09-.229-.008-.045-.037-.084-.088-.119-.942-.638-4.331-1.084-8.243-1.084-3.914 0-7.305.446-8.245 1.085-.051.035-.08.073-.087.118-.01.059.019.131.088.221l.068.09z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M13.87 16.354c.02.008-.03-.176.134-.288.923-.624 4.272-1.087 8.262-1.087 3.987 0 7.335.463 8.26 1.086.165.112.144.162.14.293 0 0 .09-.064.113-.183.01-.161-.093-.245-.269-.36-.946-.618-4.278-1.075-8.244-1.075-3.967 0-7.3.458-8.246 1.076-.175.115-.266.188-.268.36.01.1.074.145.119.178z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M22.266 14.77c-3.882 0-7.266.44-8.23 1.07-.179.119-.252.182-.254.336a.181.181 0 0 0 .066.122.316.316 0 0 1 .14-.257c.951-.643 4.355-1.092 8.278-1.092 3.92 0 7.324.449 8.277 1.092.136.092.157.15.156.241a.278.278 0 0 0 .05-.112c.009-.133-.068-.207-.255-.33-.965-.63-4.348-1.07-8.228-1.07zm8.368 1.647l.003-.098c.005-.1.007-.138-.128-.229-.943-.636-4.333-1.08-8.243-1.08-3.912 0-7.303.444-8.245 1.081-.11.075-.113.184-.114.237 0 .022-.002.057-.035.057l-.019-.007c-.05-.037-.12-.089-.13-.2.002-.194.108-.274.28-.387.973-.636 4.37-1.081 8.263-1.081 3.89 0 7.287.444 8.26 1.08.174.114.295.207.283.387a.344.344 0 0 1-.126.205l-.049.035z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    fill: "#FCE12E",
    d: "M22.625 24.877h-.72V8.122h.72z"
  }), React__default.createElement("path", {
    d: "M21.953 24.848h.846V8.153h-.846v16.695zm.923.06h-1V8.092h1v16.814z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M22.026 24.877a.12.12 0 0 1-.24 0V8.123a.12.12 0 0 1 .24 0v16.754z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M22.256 8.033c-.165 0-.3.04-.3.09v16.754c0 .05.135.09.3.09.166 0 .3-.04.3-.09V8.123c0-.05-.134-.09-.3-.09zm0 16.994c-.275 0-.5-.067-.5-.15V8.123c0-.083.225-.15.5-.15.276 0 .5.067.5.15v16.754c0 .083-.224.15-.5.15z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M22.745 24.877a.12.12 0 0 1-.24 0V8.123a.12.12 0 0 1 .24 0v16.754z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M22.975 8.033c-.164 0-.3.04-.3.09v16.754c0 .05.136.09.3.09.166 0 .3-.04.3-.09V8.123c0-.05-.134-.09-.3-.09zm0 16.994c-.275 0-.5-.067-.5-.15V8.123c0-.083.225-.15.5-.15.277 0 .5.067.5.15v16.754c0 .083-.223.15-.5.15z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M14.79 20.246c.2-.493 3.47-.885 7.476-.885 3.95 0 7.185.381 7.465.865l-.401.737c-.246-.46-3.314-.824-7.064-.824s-6.819.363-7.064.824l-.412-.717z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M14.824 20.245l.38.662c.404-.458 3.384-.798 7.062-.798 3.675 0 6.654.34 7.06.798l.37-.68c-.33-.47-3.572-.837-7.43-.837-3.878 0-7.195.383-7.442.855zm14.506.78l-.027-.048c-.241-.453-3.332-.808-7.037-.808s-6.796.355-7.038.808l-.025.047-.446-.775.005-.014c.21-.515 3.436-.904 7.504-.904 3.98 0 7.2.378 7.49.88l.009.015-.435.8z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M15.434 21.198c-.225-.184-.167-.27-.077-.303.95-.363 3.684-.626 6.909-.626 3.227 0 5.962.263 6.91.626.084.032.13.127-.065.295.31-.123.3-.256.3-.256 0-.492-3.198-.89-7.145-.89-3.947 0-7.145.398-7.145.89 0 0-.028.125.313.264z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M22.266 20.24c3.159 0 5.94.252 6.921.627.05.019.081.054.09.098.006.039-.006.082-.037.129.14-.086.14-.158.14-.159 0-.417-2.858-.862-7.114-.862s-7.115.445-7.115.86c0 .006-.007.072.137.16-.032-.046-.046-.088-.04-.125.006-.032.027-.074.098-.102.982-.375 3.763-.627 6.92-.627zm-6.844.985c-.354-.144-.334-.282-.33-.298-.001-.57 3.647-.914 7.174-.914 3.527 0 7.175.345 7.175.92.001.014.003.157-.319.284l-.03-.05c.12-.104.13-.165.125-.192-.005-.029-.03-.044-.051-.052-.975-.373-3.748-.624-6.9-.624-3.15 0-5.923.25-6.898.623-.025.01-.056.027-.06.055-.004.026.009.086.144.197l-.03.05z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M29.64 20.412c.1-.116.044-.221-.035-.254-.963-.391-3.884-.676-7.34-.676-3.363 0-6.535.349-7.34.677-.08.033-.158.118-.068.249-.18-.12-.146-.208-.146-.208 0-.52 3.383-.942 7.555-.942s7.554.421 7.554.942c0 0-.009.148-.18.212z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M22.266 19.452c3.399 0 6.352.273 7.35.679a.17.17 0 0 1 .103.118.164.164 0 0 1-.001.083.211.211 0 0 0 .072-.134c0-.439-3.023-.91-7.524-.91-4.501 0-7.525.471-7.525.912l-.002.011s-.01.04.048.102c-.002-.02 0-.04.006-.06a.2.2 0 0 1 .122-.122c.803-.328 3.949-.679 7.35-.679zm7.383.988l-.032-.048c.038-.044.054-.089.044-.13a.113.113 0 0 0-.068-.076c-.975-.397-3.988-.674-7.327-.674-3.395 0-6.53.349-7.329.675-.021.008-.072.034-.087.083-.01.035 0 .076.031.121l-.041.042c-.175-.116-.166-.211-.158-.238.02-.605 3.865-.967 7.584-.967 3.728 0 7.584.364 7.584.972 0 .009-.012.17-.2.24z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M29.277 11.884c-.803-.39-3.637-.678-7.01-.678-3.364 0-6.192.286-7.006.674l-.428.73c.821-.417 3.838-.727 7.433-.727 3.6 0 6.618.31 7.436.728l-.425-.727z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M22.266 11.854c3.43 0 6.41.281 7.361.69l-.371-.637c-.83-.395-3.7-.67-6.99-.67-3.277 0-6.144.273-6.983.666l-.376.64c.955-.408 3.934-.69 7.359-.69zm7.513.83l-.091-.046c-.835-.427-3.887-.725-7.422-.725-3.53 0-6.581.298-7.42.723l-.091.047.485-.826.009-.004c.835-.399 3.72-.677 7.017-.677 3.31 0 6.198.28 7.024.68l.008.005.481.823z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M15.145 12.072a.668.668 0 0 1 .211-.125c.95-.363 3.685-.625 6.91-.625 3.227 0 5.962.262 6.91.626a.786.786 0 0 1 .212.12.29.29 0 0 0 .023-.081c0-.493-3.199-.892-7.145-.892-3.947 0-7.146.4-7.146.892 0 0 .006.044.025.085z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M15.15 11.986s.003.017.009.037a.637.637 0 0 1 .187-.104c.981-.375 3.762-.627 6.92-.627 3.16 0 5.941.252 6.921.628a.781.781 0 0 1 .186.1.275.275 0 0 0 .008-.036c0-.413-2.86-.859-7.115-.859-4.256 0-7.115.446-7.116.861zm-.017.133l-.015-.035a.363.363 0 0 1-.027-.093c0-.58 3.648-.925 7.175-.925 3.527 0 7.175.344 7.175.921a.31.31 0 0 1-.026.093l-.015.035-.03-.023a.768.768 0 0 0-.204-.117c-.974-.372-3.747-.623-6.9-.623-3.151 0-5.924.25-6.899.623a.638.638 0 0 0-.203.12l-.03.024z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M29.725 12.857c.03-.086-.04-.16-.12-.192-.963-.392-3.885-.677-7.34-.677-3.363 0-6.536.35-7.34.677-.08.034-.147.08-.128.174-.083-.034-.086-.133-.086-.133 0-.52 3.382-.942 7.555-.942 4.172 0 7.554.422 7.554.942 0 0 .006.095-.095.151z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M22.266 11.958c3.399 0 6.352.273 7.35.68.068.027.131.082.144.153.032-.04.03-.08.03-.083 0-.442-3.023-.914-7.524-.914-4.501 0-7.525.472-7.525.912 0 .002.002.04.026.072.017-.087.108-.124.147-.14.804-.328 3.95-.68 7.352-.68zm7.405.964l.026-.074c.024-.068-.037-.128-.104-.155-.975-.397-3.988-.675-7.327-.675-3.395 0-6.53.349-7.329.675-.093.038-.124.077-.111.14l.011.055-.052-.021c-.1-.041-.103-.155-.104-.16 0-.61 3.857-.973 7.585-.973 3.728 0 7.584.363 7.584.972 0 .003.006.113-.11.178l-.069.038z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M14.497 12.925c.049 0 .107.006.177.014 1.033.123 4.107 1.552 7.585 3.565 3.476 2.012 6.247 3.965 6.871 4.8.04.053.073.099.097.14l.735-1.28c.04-.07.083-.08-.025-.228-.605-.827-3.387-2.79-6.883-4.814-3.497-2.024-6.586-3.457-7.601-3.567-.182-.02-.15.036-.208.092l-.748 1.278z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M14.549 12.897c.037.002.077.006.129.012 1.06.127 4.183 1.594 7.595 3.57 3.412 1.973 6.241 3.95 6.881 4.808.025.032.05.066.072.099l.71-1.237.019-.03c.027-.04.037-.056-.042-.166-.618-.845-3.445-2.82-6.874-4.805-3.431-1.985-6.552-3.45-7.59-3.564a.507.507 0 0 0-.06-.003c-.06 0-.069.013-.086.04a.233.233 0 0 1-.034.044l-.72 1.232zm14.678 8.607l-.026-.045a1.567 1.567 0 0 0-.095-.136c-.635-.852-3.457-2.822-6.862-4.793-3.407-1.971-6.521-3.436-7.573-3.561a1.551 1.551 0 0 0-.168-.014h-.052l.02-.045.754-1.285a.147.147 0 0 0 .027-.036c.026-.04.05-.068.137-.068.019 0 .04 0 .067.004 1.045.113 4.176 1.582 7.613 3.572 3.436 1.987 6.27 3.97 6.892 4.82.094.13.086.172.044.236-.006.007-.011.016-.017.025l-.76 1.326z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M29.296 21.556c.069-.084-.002-.187-.118-.342-.625-.834-3.396-2.786-6.872-4.798-3.478-2.013-6.551-3.443-7.584-3.568-.191-.023-.309-.034-.353.07-.047.108.144.363.144.363-.043-.123-.108-.248.073-.228 1.015.11 4.103 1.545 7.6 3.569 3.496 2.023 6.28 3.985 6.884 4.812.108.149 0 .156-.14.176.22.005.29.036.366-.054z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M29.117 21.589h.028c.065 0 .095-.012.128-.052.052-.063.001-.145-.118-.305-.637-.85-3.46-2.82-6.864-4.79-3.405-1.971-6.52-3.437-7.572-3.564a1.629 1.629 0 0 0-.18-.015c-.082 0-.122.019-.143.067-.015.036.006.102.04.17a.083.083 0 0 1 .015-.039c.023-.033.064-.046.138-.038 1.043.113 4.173 1.582 7.613 3.573 3.437 1.99 6.271 3.972 6.892 4.82.029.04.064.097.044.145a.075.075 0 0 1-.02.028zm.029.06l-.09-.003c-.036-.002-.077-.005-.126-.006l-.004-.06.02-.003c.06-.008.127-.018.136-.04.003-.006.005-.028-.036-.085-.617-.843-3.443-2.819-6.874-4.805-3.433-1.986-6.554-3.452-7.59-3.564-.043-.005-.073 0-.082.012-.015.022.009.087.028.14l.013.036-.052.027c-.02-.027-.2-.271-.148-.391.04-.092.127-.104.198-.104.052 0 .112.007.187.016 1.06.128 4.183 1.596 7.595 3.57 3.41 1.975 6.24 3.951 6.882 4.808.11.145.203.272.116.378-.051.062-.103.074-.173.074z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M30.158 20.09c.06-.083-.01-.202-.127-.357-.625-.834-3.396-2.786-6.873-4.798-3.477-2.013-6.55-3.442-7.583-3.568-.191-.023-.294-.027-.353.07-.015.084-.015.052.04.186 0 0-.005-.07.177-.05 1.015.11 4.103 1.545 7.6 3.569 3.496 2.023 6.279 3.985 6.884 4.811.108.149.066.123.059.189.067-.01.092.014.176-.051z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M15.38 11.54c.018 0 .039 0 .062.003 1.044.114 4.175 1.583 7.612 3.573 3.436 1.988 6.27 3.97 6.893 4.82.078.107.086.134.074.173h.008c.034 0 .056 0 .107-.039.043-.066-.018-.171-.128-.32-.64-.85-3.462-2.82-6.865-4.79-3.404-1.97-6.517-3.435-7.571-3.563-.197-.024-.275-.02-.322.051l-.001.01c-.008.042-.008.042.013.088l.007.017a.208.208 0 0 1 .112-.024zm14.568 8.637l.004-.038c.002-.02.007-.033.01-.042.006-.017.01-.026-.063-.126-.619-.844-3.445-2.819-6.875-4.803-3.431-1.986-6.552-3.452-7.589-3.566-.11-.012-.142.014-.143.022l-.058.011a2.594 2.594 0 0 0-.027-.065c-.027-.06-.028-.066-.018-.122l.007-.027c.053-.086.135-.097.21-.097.047 0 .1.005.173.014 1.06.129 4.184 1.597 7.594 3.57 3.41 1.973 6.24 3.95 6.882 4.807.11.147.203.288.127.393l-.006.006c-.069.054-.107.054-.147.055-.012 0-.026 0-.043.003l-.038.005z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M17.255 17.414c0 2.759 2.262 4.995 5.026 4.995a4.994 4.994 0 0 0 4.998-4.995v-6.46H17.255v6.46z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M17.285 10.984v6.43c0 2.738 2.24 4.965 4.996 4.965a4.972 4.972 0 0 0 4.968-4.965v-6.43h-9.964zM22.28 22.44c-2.788 0-5.056-2.254-5.056-5.025v-6.49h10.084v6.49a5.032 5.032 0 0 1-5.028 5.025z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M17.375 17.396c0 2.693 2.208 4.876 4.906 4.876a4.875 4.875 0 0 0 4.878-4.876v-6.305h-9.784v6.305z",
    fill: "#EC1C2E"
  }), React__default.createElement("path", {
    fill: "#FCE12E",
    d: "M25.248 18.869l.06.06-.073.074.058.059.075-.074.056.057-.074.074.06.059.073-.074.059.059-.074.073-.027-.027-.039.038-.235-.235.038-.038-.031-.031zm.45.139l-.08.078.03.03-.038.038.237.236.038-.038.03.03.078-.08-.06-.06-.08.08-.058-.06.079-.078-.057-.058-.079.08-.06-.061.078-.079zm.14.45l-.074.074.03.03-.038.037.235.235.038-.038.03.03.074-.075-.06-.058-.073.074-.061-.06.074-.074-.057-.058-.074.074-.059-.058.074-.075zm-.941-.177l-.036.036.824.822.036-.035zm-.077.076l-.037.039.823.822.039-.038zm.427 1.264a.914.914 0 0 0 .126-.227l.09-.09.029.029.076-.077-.824-.822-.076.076.03.03-.091.09a.958.958 0 0 0-.228.126l.142.142c.202-.146.453-.159.595-.017.143.142.13.392-.017.593l.148.147z"
  }), React__default.createElement("path", {
    d: "M25.258 20.709a1.194 1.194 0 0 1-.091.138l-1.018-1.016a1.45 1.45 0 0 1 .14-.09l.25.25c.169-.168.41-.2.54-.07.13.13.1.372-.07.54l.249.248zm-.338-.335c.106-.106.125-.257.044-.34-.082-.08-.234-.061-.34.045l.296.295z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M24.898 20.27c.06-.06.072-.148.025-.194-.047-.047-.134-.036-.195.025l.17.17zm1.069-.708l-.518.52-.482-.481.52-.52.48.481zm-.43-.158l-.234.234.112.112.234-.234-.113-.112zm1.019.748l-.517.517-.483-.484.516-.516.484.483zm-.435-.162l-.232.232.111.111.233-.232-.112-.111z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M26.26 19.562l-.66.66-.34-.342.658-.659.341.34zm-.416-.003l-.262.262.08.078.26-.262-.078-.078zm-7.428.192l.06-.06.075.074.058-.059-.074-.074.058-.057.074.074.058-.059-.074-.074.06-.058.073.074-.027.027.038.038-.236.235-.038-.038-.03.031zm.139-.448l.079.078.03-.029.038.038.237-.236-.038-.039.029-.029-.079-.079-.061.06.08.08-.06.058-.078-.079-.058.057.08.08-.061.06-.08-.079zm.451-.14l.074.073.03-.03.038.039.235-.235-.038-.038.03-.03-.074-.073-.06.059.075.073-.06.06-.075-.073-.057.057.074.074-.059.059-.074-.074zm-.176.938l.035.037.824-.823-.036-.036zm.076.077l.038.038.824-.822-.038-.039zm1.266-.425a.927.927 0 0 0-.228-.127l-.09-.088.029-.03-.077-.076-.824.822.076.077.03-.03.09.09c.03.078.073.156.127.228l.143-.143c-.147-.2-.16-.45-.017-.593.142-.142.392-.13.594.017l.147-.147z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M20.26 19.742c.047.026.093.056.138.09l-1.017 1.016a1.248 1.248 0 0 1-.09-.14l.25-.249c-.169-.168-.2-.41-.07-.54.13-.13.372-.098.54.07l.248-.247zm-.335.337c-.107-.106-.259-.126-.34-.044-.082.082-.063.233.043.34l.297-.296z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M19.82 20.1c-.06-.06-.148-.071-.194-.024-.048.046-.036.133.025.194l.17-.17z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M19.11 19.669l.52.52-.481.48-.52-.519.481-.481zm-.157.43l.233.234.111-.112-.232-.233-.112.112zm.748-1.019l.517.517-.484.483-.516-.517.483-.483zm-.163.435l.232.232.112-.112-.231-.231-.113.11z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M19.11 19.223l.659.659-.34.34-.66-.658.341-.341zm-.003.415l.261.262.08-.079-.263-.261-.078.078zm-1.291-4.39h.086v.105h.083v-.105h.08v.105h.084v-.105h.083v.105h-.039v.054h-.333v-.054h-.044zm.416-.219v.111h.042v.054h.335v-.054h.041v-.111h-.085v.111h-.083v-.111H18.4v.111h-.086v-.111zm.418.219v.105h.042v.054h.333v-.054h.042v-.105h-.083v.105h-.086v-.105h-.08v.105h-.084v-.105zm-.79.639h1.165v-.1H17.86zm0 .108h1.165v-.1H17.86zm1.197.493a.927.927 0 0 0-.073-.25v-.127h.041v-.108H17.86v.108h.042v.128a.964.964 0 0 0-.073.25h.203c.038-.247.206-.432.408-.432.202 0 .37.185.409.431h.208z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M19.126 16.839c.015.087.026.179.034.272h-1.44c.01-.091.02-.185.036-.272h.353c0-.402.15-.728.334-.728.184 0 .332.326.332.728h.351zm-.476.003c0-.253-.093-.458-.209-.458-.115 0-.21.205-.21.458h.42z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M18.561 16.486c0-.086-.053-.155-.12-.155-.066 0-.12.07-.12.155h.24z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M18.902 16.463h-1v-1h1v1zm-.613-.287h.233v-.45h-.233v.45z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M19.734 16.463h-1v-1h1v1zm-.617-.287h.23v-.45h-.23v.45z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M19.315 16.248h-1v-1h1v1zm-.613-.29h.23v-.398h-.23v.398zm6.752-.71h.086v.105h.083v-.105h.081v.105h.083v-.105h.083v.105h-.039v.054h-.333v-.054h-.044zm.416-.219v.111h.042v.054h.336v-.054h.041v-.111h-.086v.111h-.083v-.111h-.08v.111h-.087v-.111zm.42.219v.105h.04v.054h.333v-.054h.042v-.105h-.083v.105h-.086v-.105h-.08v.105h-.084v-.105zm-.792.639h1.165v-.1h-1.165zm0 .108h1.165v-.1h-1.165zm1.197.493a.93.93 0 0 0-.072-.25v-.127h.04v-.108h-1.165v.108h.042v.128a.954.954 0 0 0-.072.25h.202c.039-.247.207-.432.408-.432.202 0 .37.185.409.431h.208z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M26.765 16.839c.014.087.026.179.033.272H25.36c.008-.091.02-.185.036-.272h.353c0-.402.15-.728.333-.728.184 0 .333.326.333.728h.35zm-.476.003c0-.253-.093-.458-.21-.458-.115 0-.209.205-.209.458h.42z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M26.2 16.486c0-.086-.054-.155-.12-.155-.067 0-.12.07-.12.155h.24z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M26.54 16.463h-1v-1h1v1zm-.612-.287h.232v-.45h-.232v.45z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M27.372 16.463h-1v-1h1v1zm-.617-.287h.23v-.45h-.23v.45z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M26.953 16.248h-1v-1h1v1zm-.614-.29h.23v-.398h-.23v.398zm-.885-4.308h.086v.104h.083v-.104h.081v.104h.083v-.104h.083v.104h-.039v.054h-.333v-.054h-.044zm.416-.22v.112h.042v.054h.336v-.054h.041v-.111h-.086v.11h-.083v-.11h-.08v.11h-.087v-.11zm.42.22v.104h.04v.054h.333v-.054h.042v-.104h-.083v.104h-.086v-.104h-.08v.104h-.084v-.104zm-.792.639h1.165v-.1h-1.165zm0 .108h1.165v-.1h-1.165zm1.197.493a.928.928 0 0 0-.072-.25v-.127h.04v-.108h-1.165v.108h.042v.128a.955.955 0 0 0-.072.25h.202c.039-.247.207-.432.408-.432.202 0 .37.185.409.431h.208z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M26.765 13.24c.014.088.026.179.033.273H25.36c.008-.092.02-.186.036-.273h.353c0-.402.15-.727.333-.727.184 0 .333.325.333.727h.35zm-.476.003c0-.253-.093-.457-.21-.457-.115 0-.209.204-.209.457h.42z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M26.2 12.888c0-.086-.054-.155-.12-.155-.067 0-.12.069-.12.155h.24z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M26.54 12.865h-1v-1h1v1zm-.612-.287h.232v-.45h-.232v.45z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M27.372 12.865h-1v-1h1v1zm-.617-.287h.23v-.45h-.23v.45z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M26.953 12.65h-1v-1h1v1zm-.614-.29h.23v-.397h-.23v.397zm-8.523-.71h.086v.104h.082v-.104h.081v.104h.083v-.104h.084v.104h-.04v.054h-.332v-.054h-.044zm.416-.22v.112h.041v.054h.336v-.054h.041v-.111h-.085v.11h-.084v-.11h-.08v.11h-.086v-.11zm.418.22v.104h.042v.054h.333v-.054h.041v-.104h-.083v.104h-.085v-.104h-.081v.104h-.083v-.104zm-.79.639h1.165v-.1H17.86zm0 .108h1.165v-.1H17.86zm1.197.493a.909.909 0 0 0-.073-.25v-.127h.04v-.108H17.86v.108h.041v.128a.966.966 0 0 0-.072.25h.202c.04-.247.207-.432.409-.432.201 0 .37.185.408.431h.209z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M19.126 13.24c.015.088.026.179.034.273h-1.44a3.33 3.33 0 0 1 .036-.273h.353c0-.402.15-.727.333-.727.184 0 .333.325.333.727h.35zm-.476.003c0-.253-.093-.457-.209-.457-.116 0-.21.204-.21.457h.42z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M18.561 12.888c0-.086-.054-.155-.12-.155s-.12.069-.12.155h.24z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M18.902 12.865h-1v-1h1v1zm-.613-.287h.233v-.45h-.233v.45z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M19.733 12.865h-1v-1h1v1zm-.617-.287h.23v-.45h-.23v.45z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M19.315 12.65h-1v-1h1v1zm-.613-.29h.23v-.397h-.23v.397zm2.938-.714h.086v.105h.084v-.105h.08v.105h.083v-.105h.084v.105h-.04v.053h-.332v-.053h-.044zm.417-.219v.111h.041v.054h.336v-.054h.041v-.111h-.085v.111h-.084v-.111h-.08v.111h-.086v-.111zm.418.219v.105h.042v.053h.333v-.053h.041v-.105h-.083v.105h-.085v-.105h-.081v.105h-.083v-.105zm-.79.64h1.165v-.1h-1.165zm0 .107h1.165v-.1h-1.165zm1.197.493a.914.914 0 0 0-.073-.25v-.127h.04v-.108h-1.164v.108h.041v.128a.944.944 0 0 0-.072.25h.202c.039-.247.207-.432.409-.432.201 0 .37.185.408.431h.209z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M22.95 13.236c.016.088.027.18.035.273h-1.44a3.33 3.33 0 0 1 .036-.273h.353c0-.401.15-.727.333-.727.184 0 .333.326.333.727h.35zm-.475.004c0-.254-.094-.458-.209-.458-.116 0-.21.204-.21.458h.42z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M22.386 12.885c0-.087-.054-.156-.12-.156s-.12.07-.12.156h.24z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M22.726 12.862h-1v-1h1v1zm-.613-.288h.234v-.45h-.234v.45z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M23.559 12.862h-1v-1h1v1zm-.62-.288h.232v-.45h-.231v.45z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M23.14 12.646h-1v-1h1v1zm-.615-.29h.23v-.397h-.23v.397z",
    fill: "#FCE12E"
  }), React__default.createElement("path", {
    d: "M19.39 17.256c0 1.669 1.298 3.021 2.885 3.021 1.587 0 2.87-1.352 2.87-3.02V13.35h-5.756v3.906z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M19.42 13.38v3.876c0 1.65 1.28 2.991 2.855 2.991 1.566 0 2.84-1.342 2.84-2.99V13.38h-5.696zm2.855 6.927c-1.608 0-2.916-1.369-2.916-3.05V13.32h5.816v3.936c0 1.682-1.301 3.051-2.9 3.051z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M21.6 14.759c0 .391.3.708.667.708.368 0 .665-.317.665-.708v-.916H21.6v.916z",
    fill: "#007AC1"
  }), React__default.createElement("path", {
    d: "M21.607 13.85v.909c0 .386.296.7.66.7.363 0 .657-.314.657-.7v-.909h-1.317zm.66 1.625c-.372 0-.675-.322-.675-.716v-.924h1.347v.924c0 .394-.301.716-.672.716z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M22.266 14.663a.124.124 0 1 0 0-.248.124.124 0 0 0 0 .248zm-.316-.412a.124.124 0 1 0 0-.248.124.124 0 0 0 0 .248zm.632 0a.124.124 0 1 1 0-.247.124.124 0 0 1 0 .247zm-.632.575a.124.124 0 1 1 0 .248.124.124 0 0 1 0-.248zm.632 0a.124.124 0 1 0 0 .248.124.124 0 1 0 0-.248z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M21.6 16.884c0 .391.3.708.667.708.368 0 .665-.317.665-.708v-.915H21.6v.915z",
    fill: "#007AC1"
  }), React__default.createElement("path", {
    d: "M21.607 15.976v.908c0 .386.296.7.66.7.363 0 .657-.314.657-.7v-.908h-1.317zm.66 1.624c-.372 0-.675-.322-.675-.716v-.923h1.347v.923c0 .394-.301.716-.672.716z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M22.266 16.788a.124.124 0 1 0 0-.248.124.124 0 1 0 0 .247zm-.316-.411a.124.124 0 1 0 0-.248.124.124 0 0 0 0 .248zm.632 0a.124.124 0 1 1 .124-.123.124.124 0 0 1-.124.123zm-.632.575a.124.124 0 1 1 0 .248.124.124 0 0 1 0-.248zm.632 0a.124.124 0 1 0 0 .248.124.124 0 0 0 0-.248z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M21.6 19.01c0 .39.3.708.667.708.368 0 .665-.317.665-.708v-.916H21.6v.916z",
    fill: "#007AC1"
  }), React__default.createElement("path", {
    d: "M21.607 18.102v.908c0 .386.296.7.66.7.363 0 .657-.314.657-.7v-.908h-1.317zm.66 1.623c-.372 0-.675-.32-.675-.715v-.924h1.347v.924c0 .394-.301.715-.672.715z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M22.266 18.914a.124.124 0 1 0 0-.248.124.124 0 0 0 0 .248zm-.316-.411a.124.124 0 1 0-.001-.249.124.124 0 0 0 0 .249zm.632 0a.124.124 0 1 1 0-.249.124.124 0 0 1 0 .249zm-.632.575a.124.124 0 1 1 0 .247.124.124 0 0 1 0-.247zm.632 0a.124.124 0 1 0 0 .247.124.124 0 0 0 0-.247z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M19.878 16.884c0 .391.3.708.668.708.367 0 .664-.317.664-.708v-.915h-1.332v.915z",
    fill: "#007AC1"
  }), React__default.createElement("path", {
    d: "M19.885 15.976v.908c0 .386.296.7.66.7.362 0 .657-.314.657-.7v-.908h-1.317zm.66 1.624c-.372 0-.675-.322-.675-.716v-.923h1.347v.923c0 .394-.301.716-.671.716z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M20.544 16.788a.124.124 0 1 0 0-.248.124.124 0 1 0 0 .247zm-.316-.411a.124.124 0 1 0 0-.248.124.124 0 0 0 0 .248zm.632 0a.124.124 0 1 1 0-.248.124.124 0 0 1 0 .248zm-.632.575a.124.124 0 1 1 0 .247.124.124 0 0 1-.125-.124c0-.068.056-.123.125-.123zm.632 0a.124.124 0 1 0 0 .248.124.124 0 0 0 0-.248z",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M24.653 16.884c0 .391-.3.708-.667.708-.367 0-.664-.317-.664-.708v-.915h1.331v.915z",
    fill: "#007AC1"
  }), React__default.createElement("path", {
    d: "M23.33 15.976v.908c0 .386.294.7.656.7.364 0 .66-.314.66-.7v-.908h-1.317zm.656 1.624c-.37 0-.672-.322-.672-.716v-.923h1.347v.923c0 .394-.303.716-.675.716z",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M23.988 16.788a.123.123 0 1 1 0-.248.124.124 0 0 1 0 .248zm.316-.411a.124.124 0 1 1 0-.248.124.124 0 1 1 0 .248zm-.633 0a.124.124 0 1 0 .001-.248.124.124 0 0 0 0 .248zm.633.575a.124.124 0 1 0 0 .247.124.124 0 0 0 0-.248zm-.633 0a.124.124 0 1 1 .001.248.124.124 0 0 1 0-.248z",
    fill: "#FFF"
  })));
},
    _extends$96 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$96(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var QA = function QA(e) {
  e.styles;

  var t = _objectWithoutProperties$96(e, ["styles"]);

  return React__default.createElement("svg", _extends$96({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#FFF",
    d: "M.73 33.604h53.994V.764H.73z"
  }), React__default.createElement("path", {
    fill: "#8C1B3C",
    d: "M23.192 33.604h31.532V.69H17.765l4.266 1.867-4.238 1.834 4.21 1.875-4.238 1.793 4.239 1.79-4.24 1.919 4.24 1.793-4.211 1.75 4.238 1.832-4.185 1.835 4.185 1.834-4.238 1.832 4.238 1.79-4.266 1.877 4.239 1.79-4.211 1.877 4.238 1.792-4.266 1.834z"
  })));
},
    _extends$97 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$97(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var RO = function RO(e) {
  e.styles;

  var t = _objectWithoutProperties$97(e, ["styles"]);

  return React__default.createElement("svg", _extends$97({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54 35"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#042B7D",
    d: "M0 34.009h17.784V.386H0z"
  }), React__default.createElement("path", {
    fill: "#CD1225",
    d: "M35.928 34.01h17.964V.387H35.928z"
  }), React__default.createElement("path", {
    fill: "#FBD022",
    d: "M17.784 34.009h18.143V.386H17.784z"
  })));
},
    _extends$98 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$98(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var SE = function SE(e) {
  e.styles;

  var t = _objectWithoutProperties$98(e, ["styles"]);

  return React__default.createElement("svg", _extends$98({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#045292",
    d: "M.81 13.646h17.131V.169H.81zm0 20.167h17.133V20.331H.81zm23.981-20.167h30.812V.169H24.791zm0 20.167h30.812V20.352H24.791z"
  }), React__default.createElement("path", {
    fill: "#FDCA16",
    d: "M24.791 13.646V.169h-6.85v13.477H.81v6.685h17.131v13.482h6.85V20.352h30.811v-6.706z"
  })));
},
    _extends$99 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$99(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var SG = function SG(e) {
  e.styles;

  var t = _objectWithoutProperties$99(e, ["styles"]);

  return React__default.createElement("svg", _extends$99({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#FFF",
    d: "M.952 33.216h54.356V16.845H.952z"
  }), React__default.createElement("path", {
    fill: "#EC2938",
    d: "M.952 16.845h54.356V.536H.952z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M9.176 5.371h.835l.263-.933.261.906h.811l-.667.561.288.906-.707-.563-.692.576.261-.89zM6.388 7.538h.837l.262-.933.261.905h.811l-.667.562.288.904-.707-.56-.693.575.262-.89zm5.585 0h.835l.263-.933.263.905h.81l-.668.562.288.904-.707-.56-.692.575.261-.89zm-1.047 3.496h.838l.261-.932.261.905h.811l-.668.563.29.903-.708-.56-.692.575.261-.891zm-3.492 0h.837l.262-.932.263.905h.81l-.668.563.287.903-.704-.56-.695.575.263-.891z"
  }), React__default.createElement("path", {
    d: "M4.554 8.918c0-2.286 1.49-4.94 4.794-5.266-.549-.143-1.127-.274-1.726-.274-3.543 0-5.282 3.035-5.282 5.45 0 2.376 1.61 5.527 5.153 5.527.634 0 1.245-.084 1.821-.244-3.35-.263-4.76-3.145-4.76-5.193",
    fill: "#FFF"
  })));
},
    _extends$100 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$100(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var SK = function SK(e) {
  e.styles;

  var t = _objectWithoutProperties$100(e, ["styles"]);

  return React__default.createElement("svg", _extends$100({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 35"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#FFF",
    d: "M.914 11.891h53.793V.849H.914z"
  }), React__default.createElement("path", {
    fill: "#ED1C25",
    d: "M.915 34.101h53.793v-10.98H.915z"
  }), React__default.createElement("path", {
    fill: "#0F4EA0",
    d: "M.915 23.12h53.793V11.891H.915z"
  }), React__default.createElement("path", {
    d: "M12.075 8.364H22.92l.226 7.337s.4 6.77-5.631 10.069c0 0-5.196-2.604-5.581-8.551 0-4.513 0-7.985.14-8.855",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M14.709 19.564c.786 0 1.075.678 1.234.877 0 0 .546-1.816 1.669-1.816 0 0 1.042.019 1.559 1.8.44-.908 1.582-1.494 2.481.358 1.234-2.556 1.092-4.972 1.092-4.972l-.209-6.747h-9.974c-.129.797-.129 3.992-.129 8.145a9.138 9.138 0 0 0 .991 3.613c.165-.352.653-1.258 1.286-1.258",
    fill: "#ED1C25"
  }), React__default.createElement("path", {
    d: "M17.103 16.16v2.83h.914v-2.845s1.768-.046 2.658.419V14.6s-.998.556-2.682.375v-1.69s1.347-.06 2.104.388v-1.915s-1.046.493-2.104.343c0 0 .095-1.601.277-2.44h-1.457s.302 1.707.302 2.471c-.795 0-1.913-.166-2.105-.404v1.93s.818-.449 2.069-.373v1.72s-1.6.134-2.646-.405v1.963s.636-.436 2.67-.404",
    fill: "#FFF"
  }), React__default.createElement("path", {
    d: "M17.564 25.073c2.092-1.145 3.343-2.742 4.088-4.29-.9-1.852-2.041-1.266-2.481-.356-.517-1.783-1.56-1.802-1.56-1.802-1.122 0-1.668 1.816-1.668 1.816-.16-.2-.448-.877-1.234-.877-.633 0-1.121.906-1.286 1.258 1.5 2.926 4.14 4.25 4.14 4.25",
    fill: "#0F4EA0"
  })));
},
    _extends$101 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$101(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var TH = function TH(e) {
  e.styles;

  var t = _objectWithoutProperties$101(e, ["styles"]);

  return React__default.createElement("svg", _extends$101({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#EC1C24",
    d: "M.61 5.753h53.437V.164H.61zm0 27.674h53.437v-5.584H.61z"
  }), React__default.createElement("path", {
    d: "M.61 27.843v-5.525M54.047 5.753v5.519M.61 11.271V5.752m53.437 16.566v5.525",
    fill: "#006506"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M.61 11.272h53.437V5.753H.61zm0 16.571h53.437v-5.525H.61z"
  }), React__default.createElement("path", {
    d: "M54.047 11.271v11.046M.61 22.318V11.272",
    fill: "#006506"
  }), React__default.createElement("path", {
    fill: "#352F6B",
    d: "M.61 22.318h53.437V11.272H.61z"
  })));
},
    _extends$102 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$102(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var TR = function TR(e) {
  e.styles;

  var t = _objectWithoutProperties$102(e, ["styles"]);

  return React__default.createElement("svg", _extends$102({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#E20B17",
    d: "M.81 33.87h54.484V.549H.81z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M30.152 13.27v2.969l-2.816.939 2.755.937v3.032l1.729-2.438 2.814.938-1.726-2.47 1.726-2.406-2.785.969z"
  }), React__default.createElement("path", {
    d: "M27.656 21.752c-1.446 2.28-3.938 3.772-6.771 3.772-4.467 0-8.027-3.71-8.027-8.362 0-4.653 3.785-8.3 8.027-8.3 2.882 0 5.412 1.519 6.844 3.846 0 0-3.368-4.038-8.177-1.188-4.695 2.782-3.846 10.66 1.817 12.159 0 0 3.29 1.165 6.287-1.927",
    fill: "#FFF"
  })));
},
    _extends$103 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$103(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var TW = function TW(e) {
  e.styles;

  var t = _objectWithoutProperties$103(e, ["styles"]);

  return React__default.createElement("svg", _extends$103({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#FE0000",
    d: "M28.09.484V17.23H.893v16.744h54.391V.484z"
  }), React__default.createElement("path", {
    fill: "#000095",
    d: "M.894 17.23h27.195V.484H.894z"
  }), React__default.createElement("path", {
    d: "M17.926 8.844c0 1.753-1.529 3.173-3.416 3.173s-3.416-1.42-3.416-3.173c0-1.752 1.53-3.173 3.416-3.173 1.887 0 3.416 1.42 3.416 3.173m2.398-3.141l-2.952.79c.362.38.639.83.8 1.328l2.152-2.118zm-2.091 3.954l3.048-.771-3.024-.756a3.303 3.303 0 0 1-.024 1.527m2.107 2.35l-2.189-2.075a3.53 3.53 0 0 1-.875 1.36l3.064.715zm-2.475 2.286l-.82-2.795a3.976 3.976 0 0 1-1.426.74l2.246 2.055zm-4.15-1.973l.767 2.785.845-2.797a4.15 4.15 0 0 1-1.612.012m-2.645 2.01l2.298-2.091a3.935 3.935 0 0 1-1.477-.784l-.82 2.875zm-2.435-2.345l3.05-.72a3.505 3.505 0 0 1-.849-1.335l-2.2 2.055zm2.097-3.865l-3.026.744 3.048.795a3.327 3.327 0 0 1-.022-1.538M8.635 5.714l2.19 2.073c.163-.484.434-.923.79-1.293l-2.98-.78zm2.482-2.263l.754 2.801c.402-.35.886-.619 1.423-.781l-2.177-2.02zm4.172 1.919l-.794-2.78-.833 2.788a4.136 4.136 0 0 1 1.627-.008m2.592-1.93l-2.195 2.03c.52.157.993.411 1.39.744l.805-2.774z",
    fill: "#FFF"
  })));
},
    _extends$104 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$104(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var US = function US(e) {
  e.styles;

  var t = _objectWithoutProperties$104(e, ["styles"]);

  return React__default.createElement("svg", _extends$104({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#B22234",
    d: "M.952 2.943h54.561V.422H.952zm0 30.661h54.561v-2.523H.952z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M.952 31.081h54.561v-2.68H.952zm0-25.537h54.561V2.943H.952z"
  }), React__default.createElement("path", {
    fill: "#B22234",
    d: "M.952 8.024h54.561v-2.48H.952zm0 20.377h54.561v-2.29H.952z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M.952 26.111h54.561v-2.72H.952zm0-15.37h54.561V8.024H.952z"
  }), React__default.createElement("path", {
    fill: "#B22234",
    d: "M.952 23.391h54.561V20.79H.952zm0-10.165h54.561v-2.485H.952z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M.952 15.79h54.561v-2.564H.952zm0 5.001h54.561v-2.6H.952z"
  }), React__default.createElement("path", {
    fill: "#B22234",
    d: "M.952 18.191h54.561v-2.4H.952z"
  }), React__default.createElement("path", {
    fill: "#3C3B6E",
    d: "M.952 18.191h21.81V.421H.952z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M1.603 1.804h.637l.236-.717.2.717h.648l-.518.481.2.716-.53-.48-.519.48.153-.716zm3.757 0h.635l.235-.717.2.717h.65l-.519.481.2.716-.53-.48-.519.48.153-.716zm3.754 0h.636l.236-.717.2.717h.649l-.52.481.2.716-.53-.48-.518.48.153-.716zm3.755 0h.635l.238-.717.199.717h.648l-.518.481.2.716-.53-.48-.518.48.153-.716zm3.755 0h.637l.234-.717.201.717h.648l-.518.481.199.716-.53-.48-.518.48.152-.716zm3.754 0h.637l.236-.717.2.717h.649l-.52.481.2.716-.53-.48-.517.48.152-.716zM1.603 5.396h.637l.236-.716.2.716h.648l-.518.483.2.716-.53-.48-.519.48.153-.716zm3.757 0h.635l.235-.716.2.716h.65l-.519.483.2.716-.53-.48-.519.48.153-.716zm3.754 0h.636l.236-.716.2.716h.649l-.52.483.2.716-.53-.48-.518.48.153-.716zm3.755 0h.635l.238-.716.199.716h.648l-.518.483.2.716-.53-.48-.518.48.153-.716zm3.755 0h.637l.234-.716.201.716h.648l-.518.483.199.716-.53-.48-.518.48.152-.716zm3.754 0h.637l.236-.716.2.716h.649l-.52.483.2.716-.53-.48-.517.48.152-.716zM1.603 8.873h.637l.236-.716.2.716h.648l-.518.48.2.717-.53-.48-.519.48.153-.716zm3.757 0h.635l.235-.716.2.716h.65l-.519.48.2.717-.53-.48-.519.48.153-.716zm3.754 0h.636l.236-.716.2.716h.649l-.52.48.2.717-.53-.48-.518.48.153-.716zm3.755 0h.635l.238-.716.199.716h.648l-.518.48.2.717-.53-.48-.518.48.153-.716zm3.755 0h.637l.234-.716.201.716h.648l-.518.48.199.717-.53-.48-.518.48.152-.716zm3.754 0h.637l.236-.716.2.716h.649l-.52.48.2.717-.53-.48-.517.48.152-.716zM1.62 12.505h.637l.235-.716.2.716h.65l-.52.483.2.716-.53-.484-.518.484.153-.716zm3.755 0h.636l.236-.716.2.716h.647l-.517.483.2.716-.53-.484-.518.484.152-.716zm3.755 0h.637l.236-.716.199.716h.649l-.52.483.2.716-.528-.484-.52.484.154-.716zm3.756 0h.635l.236-.716.2.716h.649l-.52.483.2.716-.53-.484-.517.484.153-.716zm3.754 0h.637l.236-.716.199.716h.649l-.52.483.202.716-.53-.484-.52.484.154-.716zm3.755 0h.636l.237-.716.2.716h.648l-.519.483.2.716-.529-.484-.52.484.154-.716zM1.62 16.021h.637l.235-.717.2.717h.65l-.52.48.2.717-.53-.48-.518.48.153-.717zm3.755 0h.636l.236-.717.2.717h.647l-.517.48.2.717-.53-.48-.518.48.152-.717zm3.755 0h.637l.236-.717.199.717h.649l-.52.48.2.717-.528-.48-.52.48.154-.717zm3.756 0h.635l.236-.717.2.717h.649l-.52.48.2.717-.53-.48-.517.48.153-.717zm3.754 0h.637l.236-.717.199.717h.649l-.52.48.202.717-.53-.48-.52.48.154-.717zm3.755 0h.636l.237-.717.2.717h.648l-.519.48.2.717-.529-.48-.52.48.154-.717zM3.478 14.207h.637l.236-.718.2.718H5.2l-.518.482.2.715-.53-.48-.518.48.152-.715zm3.756 0h.636l.236-.718.2.718h.648l-.518.482.2.715-.53-.48-.52.48.154-.715zm3.755 0h.636l.236-.718.2.718h.649l-.52.482.2.715-.53-.48-.517.48.152-.715zm3.754 0h.637l.236-.718.2.718h.648l-.519.482.2.715-.529-.48-.519.48.153-.715zm3.755 0h.637l.236-.718.2.718h.647l-.517.482.2.715-.53-.48-.518.48.151-.715zm-15.02-3.516h.637l.236-.716.2.716H5.2l-.518.482.2.717-.53-.48-.518.48.152-.717zm3.756 0h.636l.236-.716.2.716h.648l-.518.482.2.717-.53-.48-.52.48.154-.717zm3.755 0h.636l.236-.716.2.716h.649l-.52.482.2.717-.53-.48-.517.48.152-.717zm3.754 0h.637l.236-.716.2.716h.648l-.519.482.2.717-.529-.48-.519.48.153-.717zm3.755 0h.637l.236-.716.2.716h.647l-.517.482.2.717-.53-.48-.518.48.151-.717zM3.518 7.138h.636l.236-.718.201.718h.647l-.518.48.199.716-.529-.48-.519.48.153-.715zm3.754 0h.637l.236-.718.2.718h.65l-.52.48.2.716-.53-.48-.519.48.153-.715zm3.756 0h.636l.236-.718.2.718h.649l-.52.48.2.716-.53-.48-.518.48.154-.715zm3.755 0h.636l.236-.718.2.718h.648l-.517.48.2.716-.531-.48-.52.48.154-.715zm3.754 0h.637l.236-.718.2.718h.648l-.519.48.201.716-.53-.48-.52.48.154-.715zM3.518 3.623h.636l.236-.716.201.716h.647l-.518.482.199.716-.529-.482-.519.482.153-.716zm3.754 0h.637l.236-.716.2.716h.65l-.52.482.2.716-.53-.482-.519.482.153-.716zm3.756 0h.636l.236-.716.2.716h.649l-.52.482.2.716-.53-.482-.518.482.154-.716zm3.755 0h.636l.236-.716.2.716h.648l-.517.482.2.716-.531-.482-.52.482.154-.716zm3.754 0h.637l.236-.716.2.716h.648l-.519.482.201.716-.53-.482-.52.482.154-.716z"
  })));
},
    _extends$105 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$105(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var VN = function VN(e) {
  e.styles;

  var t = _objectWithoutProperties$105(e, ["styles"]);

  return React__default.createElement("svg", _extends$105({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 34"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#D9251D",
    d: "M.81 33.409h54.177V.283H.81z"
  }), React__default.createElement("path", {
    fill: "#FDFE1F",
    d: "M19.125 13.75h6.725l2.073-6.815 2.133 6.815 6.704.021-5.445 4.268 2.112 6.878-5.504-4.29-5.425 4.269 2.053-6.857z"
  })));
},
    _extends$106 = Object.assign || function (e) {
  for (var t, a = 1; a < arguments.length; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$106(e, t) {
  var a = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
}

var ZA = function ZA(e) {
  e.styles;

  var t = _objectWithoutProperties$106(e, ["styles"]);

  return React__default.createElement("svg", _extends$106({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 35"
  }, t), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#062493",
    d: "M11.588 34.05H54.57V22.977H29.355z"
  }), React__default.createElement("path", {
    fill: "#DD3831",
    d: "M11.498.947l17.969 11.117 25.103-.02V.947z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M11.498.947H.73v33.104h10.858l17.767-11.076H54.57v-10.93l-25.103.02z"
  }), React__default.createElement("path", {
    fill: "#00794D",
    d: "M7.146.947l21.581 13.21h25.844v6.624H28.683L7.146 34.051H.731V.947z"
  }), React__default.createElement("path", {
    fill: "#FEB51D",
    d: "M.73 4.964L21.144 17.51.73 30.097z"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M.73 7.653l16.107 9.898L.73 27.405z"
  })));
},
    flags = Object.freeze({
  AE: AE,
  AR: AR,
  AT: AT,
  AU: AU,
  BE: BE,
  BG: BG,
  BH: BH,
  BR: BR,
  CA: CA,
  CH: CH,
  CL: CL,
  CN: CN,
  CO: CO,
  CZ: CZ,
  DE: DE,
  DK: DK,
  ES: ES,
  FI: FI,
  FR: FR,
  GB: GB,
  GR: GR,
  HK: HK,
  HU: HU,
  ID: ID,
  IE: IE,
  IN: IN,
  IT: IT,
  JP: JP,
  KR: KR,
  MX: MX,
  MY: MY,
  NL: NL,
  NO: NO,
  NZ: NZ,
  PE: PE,
  PH: PH,
  PL: PL,
  PT: PT,
  QA: QA,
  RO: RO,
  SE: SE,
  SG: SG,
  SK: SK,
  TH: TH,
  TR: TR,
  TW: TW,
  US: US,
  VN: VN,
  ZA: ZA
}),
    classCallCheck = function classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
},
    createClass = function () {
  function e(e, t) {
    for (var a = 0; a < t.length; a++) {
      var n = t[a];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  return function (t, a, n) {
    return a && e(t.prototype, a), n && e(t, n), t;
  };
}(),
    _extends$107 = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var a = arguments[t];

    for (var n in a) {
      Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
    }
  }

  return e;
},
    inherits = function inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
},
    objectWithoutProperties = function objectWithoutProperties(e, t) {
  var a = {};

  for (var n in e) {
    t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
},
    possibleConstructorReturn = function possibleConstructorReturn(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
},
    taggedTemplateLiteral = function taggedTemplateLiteral(e, t) {
  return Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
},
    _templateObject = taggedTemplateLiteral(["\n\tfont-family: ", ";\n\tdisplay: inline-flex;\n\talign-items: center;\n\tborder-radius: 8px;\n\tborder-width: 1px;\n\tborder-style: solid;\n\tfont-weight: 600;\n\tpadding: 13px 26px 13px 13px;\n\ttext-align: left;\n\tcolor: ", ";\n"], ["\n\tfont-family: ", ";\n\tdisplay: inline-flex;\n\talign-items: center;\n\tborder-radius: 8px;\n\tborder-width: 1px;\n\tborder-style: solid;\n\tfont-weight: 600;\n\tpadding: 13px 26px 13px 13px;\n\ttext-align: left;\n\tcolor: ", ";\n"]),
    _templateObject2 = taggedTemplateLiteral(["\n\tbackground-color: #f0f8f4;\n\tborder-color: #cae8df;\n"], ["\n\tbackground-color: #f0f8f4;\n\tborder-color: #cae8df;\n"]),
    _templateObject3 = taggedTemplateLiteral(["\n\tbackground-color: #fff9ef;\n\tborder-color: #fae5b4;\n"], ["\n\tbackground-color: #fff9ef;\n\tborder-color: #fae5b4;\n"]),
    _templateObject4 = taggedTemplateLiteral(["\n\tbackground-color: #fef0ee;\n\tborder-color: #fcd3cb;\n"], ["\n\tbackground-color: #fef0ee;\n\tborder-color: #fcd3cb;\n"]),
    _templateObject5 = taggedTemplateLiteral(["\n\theight: 20px;\n\twidth: auto;\n\tmargin-right: 10px;\n\tflex-shrink: 0;\n\tfill: ", ";\n"], ["\n\theight: 20px;\n\twidth: auto;\n\tmargin-right: 10px;\n\tflex-shrink: 0;\n\tfill: ", ";\n"]),
    AlertWrapper = styled__default.div(_templateObject, function (e) {
  return e.theme.fontFamily;
}, function (e) {
  return e.theme.neutralDark[4];
}),
    OkWrapper = styled__default(AlertWrapper)(_templateObject2),
    WarningWrapper = styled__default(AlertWrapper)(_templateObject3),
    DangerWrapper = styled__default(AlertWrapper)(_templateObject4),
    selectComponent = function selectComponent(e) {
  switch (e) {
    case "ok":
      return OkWrapper;

    case "warning":
      return WarningWrapper;

    case "danger":
    default:
      return DangerWrapper;
  }
},
    StyledAlertIcon = styled__default(AlertIcon)(_templateObject5, function (e) {
  return e.fill || "#f76e5c";
}),
    selectFill = function selectFill(e) {
  switch (e) {
    case "ok":
      return "#52c1a3";

    case "warning":
      return "#fae5b4";

    case "danger":
    default:
      return "#f76e5c";
  }
},
    renderIconDefault = function renderIconDefault(e) {
  return React.createElement(StyledAlertIcon, {
    fill: selectFill(e)
  });
},
    Alert$$1 = function Alert$$1(e) {
  var t = e.renderIcon,
      a = objectWithoutProperties(e, ["renderIcon"]),
      n = selectComponent(e.alertType);
  return React.createElement(n, _extends$107({
    style: {}
  }, a), (t || renderIconDefault)(e.alertType), e.children);
},
    _templateObject$1 = taggedTemplateLiteral(["\n\tbackground-color: ", ";\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n\t&:active {\n\t\tbackground-color: ", ";\n\t}\n\tfont-family: ", ";\n\tdisplay: inline-block;\n\tfont-size: 12px;\n\tfont-weight: 600;\n\ttext-align: center;\n\tcolor: ", ";\n\twidth: ", ";\n\theight: ", ";\n\tpadding: 0 2em;\n\tborder-radius: 0.54em;\n\tborder: 0 none;\n\tcursor: pointer;\n\twhite-space: nowrap;\n\t&:focus {\n\t\toutline: none;\n\t\tbox-shadow: ", ";\n\t}\n\t&:disabled {\n\t\tcursor: default;\n\t\tbackground-color: ", ";\n\t}\n"], ["\n\tbackground-color: ", ";\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n\t&:active {\n\t\tbackground-color: ", ";\n\t}\n\tfont-family: ", ";\n\tdisplay: inline-block;\n\tfont-size: 12px;\n\tfont-weight: 600;\n\ttext-align: center;\n\tcolor: ", ";\n\twidth: ", ";\n\theight: ", ";\n\tpadding: 0 2em;\n\tborder-radius: 0.54em;\n\tborder: 0 none;\n\tcursor: pointer;\n\twhite-space: nowrap;\n\t&:focus {\n\t\toutline: none;\n\t\tbox-shadow: ", ";\n\t}\n\t&:disabled {\n\t\tcursor: default;\n\t\tbackground-color: ", ";\n\t}\n"]),
    getBackground = function getBackground(e) {
  var t = e.theme;

  switch (e.swatch) {
    case "accent":
      return t.accent[2];

    case "danger":
      return t.danger[2];

    case "neutralDark":
      return t.neutralDark[3];

    case "neutralLight":
      return t.neutralLight[3];

    default:
      return t.primary[2];
  }
},
    getHoverBackground = function getHoverBackground(e) {
  var t = e.theme;

  switch (e.swatch) {
    case "accent":
      return t.accent[1];

    case "danger":
      return t.danger[1];

    case "neutralDark":
      return t.neutralDark[2];

    case "neutralLight":
      return t.neutralLight[2];

    default:
      return t.primary[1];
  }
},
    getActiveBackground = function getActiveBackground(e) {
  var t = e.theme;

  switch (e.swatch) {
    case "accent":
      return t.accent[0];

    case "danger":
      return t.danger[0];

    case "neutralDark":
      return t.neutralDark[1];

    case "neutralLight":
      return t.neutralLight[1];

    default:
      return t.primary[0];
  }
},
    Button = styled__default.button(_templateObject$1, getBackground, getHoverBackground, getActiveBackground, function (e) {
  return e.theme.fontFamily;
}, function (e) {
  return e.theme.neutralLight[7];
}, function (e) {
  return e.width;
}, function (e) {
  return e.height || "36px";
}, function (e) {
  return e.theme.focusShadowA;
}, function (e) {
  return e.theme.neutralLight[1];
}),
    _templateObject$2 = taggedTemplateLiteral(["\n\tstroke: ", ";\n"], ["\n\tstroke: ", ";\n"]),
    Spinner = function Spinner(e) {
  return React__default.createElement("svg", _extends$107({
    width: "1em",
    height: "1em",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("g", {
    transform: "translate(1 1)",
    strokeWidth: "2",
    strokeLinecap: "2"
  }, React__default.createElement("circle", {
    strokeOpacity: ".5",
    cx: "18",
    cy: "18",
    r: "18"
  }), React__default.createElement("path", {
    d: "M36 18c0-9.94-8.06-18-18-18"
  }, React__default.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 18 18",
    to: "360 18 18",
    dur: "1s",
    repeatCount: "indefinite"
  })))));
},
    StyledSpinner = styled__default(Spinner)(_templateObject$2, function (e) {
  return e.theme.primary[2];
}),
    _templateObject$3 = taggedTemplateLiteral(["\n\tmargin-right: 0.7em;\n\tposition: relative;\n\tbox-sizing: border-box;\n\tline-height: 36px;\n\tinput {\n\t\topacity: 0;\n\t\tposition: absolute;\n\t\theight: 0;\n\t\twidth: 0;\n\t\ttop: 0;\n\t\tpointer-events: none;\n\t}\n\t&.focus {\n\t\tbox-shadow: ", ";\n\t}\n\t", " {\n\t\theight: 1em;\n\t\twidth: auto;\n\t\tvertical-align: middle;\n\t\tmargin-right: 0.5em;\n\t}\n"], ["\n\tmargin-right: 0.7em;\n\tposition: relative;\n\tbox-sizing: border-box;\n\tline-height: 36px;\n\tinput {\n\t\topacity: 0;\n\t\tposition: absolute;\n\t\theight: 0;\n\t\twidth: 0;\n\t\ttop: 0;\n\t\tpointer-events: none;\n\t}\n\t&.focus {\n\t\tbox-shadow: ", ";\n\t}\n\t", " {\n\t\theight: 1em;\n\t\twidth: auto;\n\t\tvertical-align: middle;\n\t\tmargin-right: 0.5em;\n\t}\n"]),
    Upload = function (e) {
  function t(e) {
    classCallCheck(this, t);
    var a = possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
    return a.state = {
      hasFocus: !1
    }, a.focusOn = a.focusOn.bind(a), a.focusOff = a.focusOff.bind(a), a;
  }

  return inherits(t, e), createClass(t, [{
    key: "focusOn",
    value: function value() {
      this.setState({
        hasFocus: !0
      }), this.props.onFocus && this.props.onFocus();
    }
  }, {
    key: "focusOff",
    value: function value() {
      this.setState({
        hasFocus: !1
      }), this.props.onBlur && this.props.onBlur();
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.loading,
          a = e.children,
          n = e.className,
          r = objectWithoutProperties(e, ["loading", "children", "className"]),
          l = t ? React.createElement("div", null, React.createElement(StyledSpinner, null), "Loading") : a || "Upload",
          o = this.state.hasFocus ? "focus" : "";
      return React.createElement("label", {
        className: n + " " + o,
        onFocus: this.focusOn,
        onBlur: this.focusOff
      }, React.createElement("input", _extends$107({
        disabled: t,
        type: "file"
      }, r)), React.createElement("span", null, l));
    }
  }]), t;
}(React.Component),
    StyledUpload = styled__default(Button.withComponent(Upload))(_templateObject$3, function (e) {
  return e.theme.focusShadowA;
}, StyledSpinner),
    _templateObject$4 = taggedTemplateLiteral(["\n\tfont-size: 12px;\n\tborder-radius: 0.58em;\n\tdisplay: flex;\n"], ["\n\tfont-size: 12px;\n\tborder-radius: 0.58em;\n\tdisplay: flex;\n"]),
    _templateObject2$1 = taggedTemplateLiteral(["\n\tfont-size: 1em;\n\tfont-family: ", ";\n\tfont-weight: 600;\n\tcolor: ", ";\n\tbackground-color: ", ";\n\tcursor: pointer;\n\tborder-color: ", ";\n\tborder-style: solid;\n\tborder-width: 1px;\n\theight: 3.58em;\n\tline-height: 3.58em;\n\twhite-space: nowrap;\n\tflex-grow: 1;\n\tflex-basis: 0;\n\ttext-align: center;\n\tborder-radius: 0;\n\t&:first-of-type {\n\t\tborder-top-left-radius: inherit;\n\t\tborder-bottom-left-radius: inherit;\n\t}\n\t&:last-of-type {\n\t\tborder-top-right-radius: inherit;\n\t\tborder-bottom-right-radius: inherit;\n\t}\n\t&:focus {\n\t\toutline: none;\n\t\tbox-shadow: ", ";\n\t}\n\t&.active {\n\t\tcolor: ", ";\n\t\tcursor: default;\n\t\tbackground-color: ", ";\n\t\tpointer-events: none;\n\t}\n\t&:not(.active) {\n\t\t&:hover {\n\t\t\tbackground-color: ", ";\n\t\t}\n\t\t&:active {\n\t\t\tcolor: ", ";\n\t\t\tbackground-color: ", ";\n\t\t}\n\t}\n"], ["\n\tfont-size: 1em;\n\tfont-family: ", ";\n\tfont-weight: 600;\n\tcolor: ", ";\n\tbackground-color: ", ";\n\tcursor: pointer;\n\tborder-color: ", ";\n\tborder-style: solid;\n\tborder-width: 1px;\n\theight: 3.58em;\n\tline-height: 3.58em;\n\twhite-space: nowrap;\n\tflex-grow: 1;\n\tflex-basis: 0;\n\ttext-align: center;\n\tborder-radius: 0;\n\t&:first-of-type {\n\t\tborder-top-left-radius: inherit;\n\t\tborder-bottom-left-radius: inherit;\n\t}\n\t&:last-of-type {\n\t\tborder-top-right-radius: inherit;\n\t\tborder-bottom-right-radius: inherit;\n\t}\n\t&:focus {\n\t\toutline: none;\n\t\tbox-shadow: ", ";\n\t}\n\t&.active {\n\t\tcolor: ", ";\n\t\tcursor: default;\n\t\tbackground-color: ", ";\n\t\tpointer-events: none;\n\t}\n\t&:not(.active) {\n\t\t&:hover {\n\t\t\tbackground-color: ", ";\n\t\t}\n\t\t&:active {\n\t\t\tcolor: ", ";\n\t\t\tbackground-color: ", ";\n\t\t}\n\t}\n"]),
    ButtonGroup = styled__default.div(_templateObject$4),
    GroupedButton = styled__default.button(_templateObject2$1, function (e) {
  return e.theme.fontFamily;
}, function (e) {
  return e.theme.primary[2];
}, function (e) {
  return e.theme.neutralLight[7];
}, function (e) {
  return e.theme.primary[2];
}, function (e) {
  return e.theme.focusShadowA;
}, function (e) {
  return e.theme.neutralLight[7];
}, function (e) {
  return e.theme.primary[2];
}, function (e) {
  return e.theme.primary[5];
}, function (e) {
  return e.theme.primary[2];
}, function (e) {
  return e.theme.primary[4];
}),
    _templateObject$5 = taggedTemplateLiteral(["\n\theight: 55px;\n\tbackground-color: #696c7a;\n\tcolor: white;\n\tborder-radius: 6px;\n\ttext-transform: none;\n\tfont-weight: normal;\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tpadding: 0 16px;\n"], ["\n\theight: 55px;\n\tbackground-color: #696c7a;\n\tcolor: white;\n\tborder-radius: 6px;\n\ttext-transform: none;\n\tfont-weight: normal;\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tpadding: 0 16px;\n"]),
    _templateObject2$2 = taggedTemplateLiteral(["\n\tborder-bottom: 1px solid #dddddd;\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n"], ["\n\tborder-bottom: 1px solid #dddddd;\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n"]),
    TableHeader = styled__default.div(_templateObject$5),
    TableRow = styled__default.div(_templateObject2$2),
    _templateObject$6 = taggedTemplateLiteral(["\n\tstroke: #c8e2db;\n"], ["\n\tstroke: #c8e2db;\n"]),
    _templateObject2$3 = taggedTemplateLiteral(["\n\tstroke: #3ea8dd;\n"], ["\n\tstroke: #3ea8dd;\n"]),
    BackgroundLine = styled__default.line(_templateObject$6),
    ProgressLine = styled__default.line(_templateObject2$3),
    ProgressBar = function ProgressBar(e) {
  var t = e.current,
      a = e.max,
      n = e.width,
      r = void 0 === n ? 9 : n,
      l = e.height,
      o = void 0 === l ? 1 : l,
      c = objectWithoutProperties(e, ["current", "max", "width", "height"]),
      i = Math.min(t / a, 1),
      s = {
    strokeLinecap: "round",
    strokeWidth: o,
    x1: "" + o / 2,
    y1: "" + o / 2,
    y2: "" + o / 2
  };
  return React__default.createElement("svg", _extends$107({
    viewBox: "0 0 " + r + " " + o
  }, c), React__default.createElement(BackgroundLine, _extends$107({
    x2: r - o / 2
  }, s)), React__default.createElement(ProgressLine, _extends$107({
    x2: r * i - o / 2
  }, s)));
},
    commonjsGlobal = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function unwrapExports(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}

function createCommonjsModule(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}

function componentWillMount() {
  var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
  null !== e && void 0 !== e && this.setState(e);
}

function componentWillReceiveProps(e) {
  this.setState(function (t) {
    var a = this.constructor.getDerivedStateFromProps(e, t);
    return null !== a && void 0 !== a ? a : null;
  }.bind(this));
}

function componentWillUpdate(e, t) {
  try {
    var a = this.props,
        n = this.state;
    this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(a, n);
  } finally {
    this.props = a, this.state = n;
  }
}

function polyfill(e) {
  var t = e.prototype;
  if (!t || !t.isReactComponent) throw new Error("Can only polyfill class components");
  if ("function" != typeof e.getDerivedStateFromProps && "function" != typeof t.getSnapshotBeforeUpdate) return e;
  var a = null,
      n = null,
      r = null;

  if ("function" == typeof t.componentWillMount ? a = "componentWillMount" : "function" == typeof t.UNSAFE_componentWillMount && (a = "UNSAFE_componentWillMount"), "function" == typeof t.componentWillReceiveProps ? n = "componentWillReceiveProps" : "function" == typeof t.UNSAFE_componentWillReceiveProps && (n = "UNSAFE_componentWillReceiveProps"), "function" == typeof t.componentWillUpdate ? r = "componentWillUpdate" : "function" == typeof t.UNSAFE_componentWillUpdate && (r = "UNSAFE_componentWillUpdate"), null !== a || null !== n || null !== r) {
    var l = e.displayName || e.name,
        o = "function" == typeof e.getDerivedStateFromProps ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + l + " uses " + o + " but also contains the following legacy lifecycles:" + (null !== a ? "\n  " + a : "") + (null !== n ? "\n  " + n : "") + (null !== r ? "\n  " + r : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks");
  }

  if ("function" == typeof e.getDerivedStateFromProps && (t.componentWillMount = componentWillMount, t.componentWillReceiveProps = componentWillReceiveProps), "function" == typeof t.getSnapshotBeforeUpdate) {
    if ("function" != typeof t.componentDidUpdate) throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
    t.componentWillUpdate = componentWillUpdate;
    var c = t.componentDidUpdate;

    t.componentDidUpdate = function (e, t, a) {
      var n = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : a;
      c.call(this, e, t, n);
    };
  }

  return e;
}

componentWillMount.__suppressDeprecationWarning = !0, componentWillReceiveProps.__suppressDeprecationWarning = !0, componentWillUpdate.__suppressDeprecationWarning = !0;

var _reactLifecyclesCompat = Object.freeze({
  polyfill: polyfill
}),
    entry = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  t.default = function () {
    for (var e = arguments.length, t = Array(e), a = 0; a < e; a++) {
      t[a] = arguments[a];
    }

    return t.reduce(function (e, t) {
      return "string" == typeof t || t instanceof Array ? e.concat(t) : e;
    }, []).filter(function (e) {
      return e;
    }).join(" ");
  };
});

unwrapExports(entry);
var entry$2 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  t.default = function (e, t) {
    return {
      get collidedTop() {
        return e.getBoundingClientRect().top < t.getBoundingClientRect().top;
      },

      get collidedBottom() {
        return e.getBoundingClientRect().bottom > t.getBoundingClientRect().bottom;
      },

      get collidedLeft() {
        return e.getBoundingClientRect().left < t.getBoundingClientRect().left;
      },

      get collidedRight() {
        return e.getBoundingClientRect().right > t.getBoundingClientRect().right;
      },

      get overflowTop() {
        return t.getBoundingClientRect().top - e.getBoundingClientRect().top;
      },

      get overflowBottom() {
        return e.getBoundingClientRect().bottom - t.getBoundingClientRect().bottom;
      },

      get overflowLeft() {
        return t.getBoundingClientRect().left - e.getBoundingClientRect().left;
      },

      get overflowRight() {
        return e.getBoundingClientRect().right - t.getBoundingClientRect().right;
      }

    };
  };
});
unwrapExports(entry$2);
var dates = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = function () {
    return function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var a = [],
            n = !0,
            r = !1,
            l = void 0;

        try {
          for (var o, c = e[Symbol.iterator](); !(n = (o = c.next()).done) && (a.push(o.value), !t || a.length !== t); n = !0) {
            ;
          }
        } catch (e) {
          r = !0, l = e;
        } finally {
          try {
            !n && c.return && c.return();
          } finally {
            if (r) throw l;
          }
        }

        return a;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
  }(),
      n = t.getYear = function (e) {
    if (e instanceof Date) return e.getFullYear();
    if ("number" == typeof e) return e;
    var t = parseInt(e, 10);
    if ("string" == typeof e && !isNaN(t)) return t;
    throw new Error("Failed to get year from date: " + e + ".");
  },
      r = t.getMonth = function (e) {
    return e.getMonth() + 1;
  },
      l = t.getMonthIndex = function (e) {
    return e.getMonth();
  },
      o = t.getDay = function (e) {
    return e.getDate();
  },
      c = t.getDayOfWeek = function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "ISO 8601",
        a = e.getDay();

    switch (t) {
      case "ISO 8601":
        return (a + 6) % 7;

      case "US":
        return a;

      default:
        throw new Error("Unsupported calendar type.");
    }
  },
      i = t.getBeginOfCenturyYear = function (e) {
    var t = n(e) - 1;
    return t + -t % 100 + 1;
  },
      s = t.getBeginOfCentury = function (e) {
    var t = i(e);
    return new Date(t, 0, 1);
  },
      u = t.getEndOfCentury = function (e) {
    var t = i(e);
    return new Date(t + 100, 0, 1, 0, 0, 0, -1);
  },
      f = t.getCenturyRange = function (e) {
    return [s(e), u(e)];
  },
      d = t.getBeginOfPreviousCentury = function (e) {
    var t = n(e) - 100;
    return s(t);
  },
      p = t.getEndOfPreviousCentury = function (e) {
    var t = n(e) - 100;
    return u(t);
  },
      h = t.getBeginOfNextCentury = function (e) {
    var t = n(e) + 100;
    return s(t);
  },
      m = t.getBeginOfDecadeYear = function (e) {
    var t = n(e) - 1;
    return t + -t % 10 + 1;
  },
      _ = t.getBeginOfDecade = function (e) {
    var t = m(e);
    return new Date(t, 0, 1);
  },
      v = t.getEndOfDecade = function (e) {
    var t = m(e);
    return new Date(t + 10, 0, 1, 0, 0, 0, -1);
  },
      y = t.getDecadeRange = function (e) {
    return [_(e), v(e)];
  },
      g = t.getBeginOfPreviousDecade = function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 10,
        a = m(e) - t;
    return _(a);
  },
      E = t.getEndOfPreviousDecade = function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 10,
        a = m(e) - t;
    return v(a);
  },
      b = t.getBeginOfNextDecade = function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 10,
        a = m(e) + t;
    return _(a);
  },
      z = t.getBeginOfYear = function (e) {
    var t = n(e);
    return new Date(t, 0, 1);
  },
      R = t.getEndOfYear = function (e) {
    var t = n(e);
    return new Date(t + 1, 0, 1, 0, 0, 0, -1);
  },
      M = t.getYearRange = function (e) {
    return [z(e), R(e)];
  },
      w = t.getBeginOfPreviousYear = function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
        a = n(e) - t;
    return z(a);
  },
      O = t.getEndOfPreviousYear = function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
        a = n(e) - t;
    return R(a);
  },
      C = t.getBeginOfNextYear = function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
        a = n(e) + t;
    return z(a);
  },
      x = t.getBeginOfMonth = function (e) {
    var t = n(e),
        a = l(e);
    return new Date(t, a, 1);
  },
      P = t.getEndOfMonth = function (e) {
    var t = n(e),
        a = l(e);
    return new Date(t, a + 1, 1, 0, 0, 0, -1);
  },
      T = t.getBeginOfWeek = function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "ISO 8601",
        a = n(e),
        r = l(e),
        o = e.getDate() - c(e, t);
    return new Date(a, r, o);
  },
      j = t.getMonthRange = function (e) {
    return [x(e), P(e)];
  },
      S = function S(e, t) {
    var a = n(e),
        r = l(e) + t;
    return new Date(a, r, 1);
  },
      D = t.getBeginOfPreviousMonth = function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
        a = S(e, -t);
    return x(a);
  },
      k = t.getEndOfPreviousMonth = function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
        a = S(e, -t);
    return P(a);
  },
      F = t.getBeginOfNextMonth = function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
        a = S(e, t);
    return x(a);
  },
      A = t.getBeginOfDay = function (e) {
    var t = n(e),
        a = l(e),
        r = o(e);
    return new Date(t, a, r);
  },
      $ = t.getEndOfDay = function (e) {
    var t = n(e),
        a = l(e),
        r = o(e);
    return new Date(t, a, r + 1, 0, 0, 0, -1);
  },
      N = t.getDayRange = function (e) {
    return [A(e), $(e)];
  },
      L = (t.getWeekNumber = function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "ISO 8601",
        a = T(e, t),
        r = n(e) + 1,
        l = void 0,
        o = void 0;

    do {
      l = new Date(r, 0, "ISO 8601" === t ? 4 : 1), o = T(l, t), r -= 1;
    } while (e - o < 0);

    return Math.round((a - o) / 6048e5) + 1;
  }, t.getBegin = function (e, t) {
    switch (e) {
      case "century":
        return s(t);

      case "decade":
        return _(t);

      case "year":
        return z(t);

      case "month":
        return x(t);

      case "day":
        return A(t);

      default:
        throw new Error("Invalid rangeType: " + e);
    }
  }),
      V = (t.getBeginPrevious = function (e, t) {
    switch (e) {
      case "century":
        return d(t);

      case "decade":
        return g(t);

      case "year":
        return w(t);

      case "month":
        return D(t);

      default:
        throw new Error("Invalid rangeType: " + e);
    }
  }, t.getBeginNext = function (e, t) {
    switch (e) {
      case "century":
        return h(t);

      case "decade":
        return b(t);

      case "year":
        return C(t);

      case "month":
        return F(t);

      default:
        throw new Error("Invalid rangeType: " + e);
    }
  }, t.getBeginPrevious2 = function (e, t) {
    switch (e) {
      case "decade":
        return g(t, 100);

      case "year":
        return w(t, 10);

      case "month":
        return D(t, 12);

      default:
        throw new Error("Invalid rangeType: " + e);
    }
  }, t.getBeginNext2 = function (e, t) {
    switch (e) {
      case "decade":
        return b(t, 100);

      case "year":
        return C(t, 10);

      case "month":
        return F(t, 12);

      default:
        throw new Error("Invalid rangeType: " + e);
    }
  }, t.getEnd = function (e, t) {
    switch (e) {
      case "century":
        return u(t);

      case "decade":
        return v(t);

      case "year":
        return R(t);

      case "month":
        return P(t);

      case "day":
        return $(t);

      default:
        throw new Error("Invalid rangeType: " + e);
    }
  }),
      B = (t.getEndPrevious = function (e, t) {
    switch (e) {
      case "century":
        return p(t);

      case "decade":
        return E(t);

      case "year":
        return O(t);

      case "month":
        return k(t);

      default:
        throw new Error("Invalid rangeType: " + e);
    }
  }, t.getEndPrevious2 = function (e, t) {
    switch (e) {
      case "decade":
        return E(t, 100);

      case "year":
        return O(t, 10);

      case "month":
        return k(t, 12);

      default:
        throw new Error("Invalid rangeType: " + e);
    }
  }, t.getRange = function (e, t) {
    switch (e) {
      case "century":
        return f(t);

      case "decade":
        return y(t);

      case "year":
        return M(t);

      case "month":
        return j(t);

      case "day":
        return N(t);

      default:
        throw new Error("Invalid rangeType: " + e);
    }
  }, t.getValueRange = function (e, t, a) {
    var n = [t, a].sort(function (e, t) {
      return e.getTime() > t.getTime();
    });
    return [L(e, n[0]), V(e, n[1])];
  }, t.getDaysInMonth = function (e) {
    var t = n(e),
        a = l(e);
    return new Date(t, a + 1, 0).getDate();
  }, function (e) {
    var t = a(e, 2),
        r = t[0],
        l = t[1];
    return n(r) + " – " + n(l);
  });

  t.getCenturyLabel = function (e) {
    return B(f(e));
  }, t.getDecadeLabel = function (e) {
    return B(y(e));
  }, t.isWeekend = function (e) {
    return c(e) >= 5;
  }, t.getISOLocalMonth = function (e) {
    if (!e) return e;
    var t = new Date(e);
    if (isNaN(t.getTime())) throw new Error("Invalid date: " + e);
    return n(t) + "-" + ("0" + r(t)).slice(-2);
  }, t.getISOLocalDate = function (e) {
    if (!e) return e;
    var t = new Date(e);
    if (isNaN(t.getTime())) throw new Error("Invalid date: " + e);
    return n(t) + "-" + ("0" + r(t)).slice(-2) + "-" + ("0" + o(t)).slice(-2);
  };
});
unwrapExports(dates);
var dates_1 = dates.getYear,
    dates_2 = dates.getMonth,
    dates_3 = dates.getMonthIndex,
    dates_4 = dates.getDay,
    dates_5 = dates.getDayOfWeek,
    dates_6 = dates.getBeginOfCenturyYear,
    dates_7 = dates.getBeginOfCentury,
    dates_8 = dates.getEndOfCentury,
    dates_9 = dates.getCenturyRange,
    dates_10 = dates.getBeginOfPreviousCentury,
    dates_11 = dates.getEndOfPreviousCentury,
    dates_12 = dates.getBeginOfNextCentury,
    dates_13 = dates.getBeginOfDecadeYear,
    dates_14 = dates.getBeginOfDecade,
    dates_15 = dates.getEndOfDecade,
    dates_16 = dates.getDecadeRange,
    dates_17 = dates.getBeginOfPreviousDecade,
    dates_18 = dates.getEndOfPreviousDecade,
    dates_19 = dates.getBeginOfNextDecade,
    dates_20 = dates.getBeginOfYear,
    dates_21 = dates.getEndOfYear,
    dates_22 = dates.getYearRange,
    dates_23 = dates.getBeginOfPreviousYear,
    dates_24 = dates.getEndOfPreviousYear,
    dates_25 = dates.getBeginOfNextYear,
    dates_26 = dates.getBeginOfMonth,
    dates_27 = dates.getEndOfMonth,
    dates_28 = dates.getBeginOfWeek,
    dates_29 = dates.getMonthRange,
    dates_30 = dates.getBeginOfPreviousMonth,
    dates_31 = dates.getEndOfPreviousMonth,
    dates_32 = dates.getBeginOfNextMonth,
    dates_33 = dates.getBeginOfDay,
    dates_34 = dates.getEndOfDay,
    dates_35 = dates.getDayRange,
    dates_36 = dates.getWeekNumber,
    dates_37 = dates.getBegin,
    dates_38 = dates.getBeginPrevious,
    dates_39 = dates.getBeginNext,
    dates_40 = dates.getBeginPrevious2,
    dates_41 = dates.getBeginNext2,
    dates_42 = dates.getEnd,
    dates_43 = dates.getEndPrevious,
    dates_44 = dates.getEndPrevious2,
    dates_45 = dates.getRange,
    dates_46 = dates.getValueRange,
    dates_47 = dates.getDaysInMonth,
    dates_48 = dates.getCenturyLabel,
    dates_49 = dates.getDecadeLabel,
    dates_50 = dates.isWeekend,
    dates_51 = dates.getISOLocalMonth,
    dates_52 = dates.getISOLocalDate,
    FUNC_ERROR_TEXT = "Expected a function",
    INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e308,
    NAN = NaN,
    symbolTag = "[object Symbol]",
    reTrim = /^\s+|\s+$/g,
    reIsBadHex = /^[-+]0x[0-9a-f]+$/i,
    reIsBinary = /^0b[01]+$/i,
    reIsOctal = /^0o[0-7]+$/i,
    freeParseInt = parseInt,
    objectProto = Object.prototype,
    objectToString = objectProto.toString;

function before(e, t) {
  var a;
  if ("function" != typeof t) throw new TypeError(FUNC_ERROR_TEXT);
  return e = toInteger(e), function () {
    return --e > 0 && (a = t.apply(this, arguments)), e <= 1 && (t = void 0), a;
  };
}

function once(e) {
  return before(2, e);
}

function isObject(e) {
  var t = typeof e;
  return !!e && ("object" == t || "function" == t);
}

function isObjectLike(e) {
  return !!e && "object" == typeof e;
}

function isSymbol(e) {
  return "symbol" == typeof e || isObjectLike(e) && objectToString.call(e) == symbolTag;
}

function toFinite(e) {
  return e ? (e = toNumber(e)) === INFINITY || e === -INFINITY ? (e < 0 ? -1 : 1) * MAX_INTEGER : e == e ? e : 0 : 0 === e ? e : 0;
}

function toInteger(e) {
  var t = toFinite(e),
      a = t % 1;
  return t == t ? a ? t - a : t : 0;
}

function toNumber(e) {
  if ("number" == typeof e) return e;
  if (isSymbol(e)) return NAN;

  if (isObject(e)) {
    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
    e = isObject(t) ? t + "" : t;
  }

  if ("string" != typeof e) return 0 === e ? e : +e;
  e = e.replace(reTrim, "");
  var a = reIsBinary.test(e);
  return a || reIsOctal.test(e) ? freeParseInt(e.slice(2), a ? 2 : 8) : reIsBadHex.test(e) ? NAN : +e;
}

var lodash_once = once,
    locales = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.getDefaultLocale = t.getDefaultLocales = void 0;
  var a,
      n = (a = lodash_once) && a.__esModule ? a : {
    default: a
  };
  var r = t.getDefaultLocales = (0, n.default)(function () {
    var e = [];
    return "undefined" != typeof window && (window.navigator.languages ? e.push.apply(e, function (e) {
      if (Array.isArray(e)) {
        for (var t = 0, a = Array(e.length); t < e.length; t++) {
          a[t] = e[t];
        }

        return a;
      }

      return Array.from(e);
    }(window.navigator.languages)) : window.navigator.userLanguage && e.push(window.navigator.userLanguage)), e.push("en-GB"), e;
  });
  t.getDefaultLocale = (0, n.default)(function () {
    return r()[0];
  });
});
unwrapExports(locales);
var locales_1 = locales.getDefaultLocale,
    locales_2 = locales.getDefaultLocales,
    dateFormatter = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.formatShortWeekday = t.formatMonth = t.formatMonthYear = t.formatDate = void 0;

  var a = {},
      n = function n(e, t) {
    t || (t = (0, locales.getDefaultLocale)());
    var n = JSON.stringify(e);
    return a[t] || (a[t] = {}), a[t][n] || (a[t][n] = new Intl.DateTimeFormat(t, e).format), a[t][n];
  },
      r = function r(e) {
    var t = new Date(e);
    return new Date(t.setHours(12));
  };

  t.formatDate = function (e, t) {
    return n({
      day: "numeric",
      month: "numeric",
      year: "numeric"
    }, t)(r(e));
  }, t.formatMonthYear = function (e, t) {
    return n({
      month: "long",
      year: "numeric"
    }, t)(r(e));
  }, t.formatMonth = function (e, t) {
    return n({
      month: "long"
    }, t)(r(e));
  }, t.formatShortWeekday = function (e, t) {
    return n({
      weekday: "short"
    }, t)(r(e));
  };
});
unwrapExports(dateFormatter);
var dateFormatter_1 = dateFormatter.formatShortWeekday,
    dateFormatter_2 = dateFormatter.formatMonth,
    dateFormatter_3 = dateFormatter.formatMonthYear,
    dateFormatter_4 = dateFormatter.formatDate,
    propTypes = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.tileProps = t.tileGroupProps = t.isView = t.isClassName = t.isViews = t.isValue = t.isMaxDate = t.isMinDate = t.isCalendarType = void 0;
  var a,
      n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      r = (a = PropTypes) && a.__esModule ? a : {
    default: a
  };

  var l = ["century", "decade", "year", "month"],
      o = (t.isCalendarType = r.default.oneOf(["ISO 8601", "US"]), t.isMinDate = function (e, t, a) {
    var r = e[t];

    if (r) {
      if (!(r instanceof Date)) return new Error("Invalid prop `" + t + "` of type `" + (void 0 === r ? "undefined" : n(r)) + "` supplied to `" + a + "`, expected instance of `Date`.");
      var l = e.maxDate;
      if (l && r > l) return new Error("Invalid prop `" + t + "` of type `" + (void 0 === r ? "undefined" : n(r)) + "` supplied to `" + a + "`, minDate cannot be larger than maxDate.");
    }

    return null;
  }),
      c = t.isMaxDate = function (e, t, a) {
    var r = e[t];

    if (r) {
      if (!(r instanceof Date)) return new Error("Invalid prop `" + t + "` of type `" + (void 0 === r ? "undefined" : n(r)) + "` supplied to `" + a + "`, expected instance of `Date`.");
      var l = e.minDate;
      if (l && r < l) return new Error("Invalid prop `" + t + "` of type `" + (void 0 === r ? "undefined" : n(r)) + "` supplied to `" + a + "`, maxDate cannot be smaller than minDate.");
    }

    return null;
  },
      i = t.isValue = r.default.oneOfType([r.default.instanceOf(Date), r.default.arrayOf(r.default.instanceOf(Date))]),
      s = (t.isViews = r.default.arrayOf(r.default.oneOf(l)), t.isClassName = r.default.oneOfType([r.default.string, r.default.arrayOf(r.default.string)])),
      u = t.isView = function (e, t, a) {
    var n = e[t];
    return -1 === (e.views || l).indexOf(n) ? new Error("Invalid prop `" + t + "` of value `" + n + "` supplied to `" + a + "`, expected one of [" + ["a", "b", "c", "d", "e"].map(function (e) {
      return '"' + e + '"';
    }).join(", ") + "].") : null;
  };

  u.isRequired = function (e, t, a) {
    var n = e[t];
    return n ? u(e, t, a) : new Error("The prop `" + t + "` is marked as required in `" + a + "`, but its value is `" + n + "`.");
  };

  t.tileGroupProps = {
    activeStartDate: r.default.instanceOf(Date).isRequired,
    hover: r.default.instanceOf(Date),
    maxDate: c,
    minDate: o,
    onClick: r.default.func,
    onMouseOver: r.default.func,
    tileClassName: r.default.oneOfType([r.default.func, s]),
    tileContent: r.default.oneOfType([r.default.func, r.default.node]),
    value: i,
    valueType: r.default.string
  }, t.tileProps = {
    classes: r.default.arrayOf(r.default.string).isRequired,
    date: r.default.instanceOf(Date).isRequired,
    maxDate: c,
    minDate: o,
    onClick: r.default.func,
    onMouseOver: r.default.func,
    style: r.default.objectOf(r.default.oneOfType([r.default.string, r.default.number])),
    tileClassName: r.default.oneOfType([r.default.func, s]),
    tileContent: r.default.oneOfType([r.default.func, r.default.node]),
    tileDisabled: r.default.func
  };
});
unwrapExports(propTypes);
var propTypes_1 = propTypes.tileProps,
    propTypes_2 = propTypes.tileGroupProps,
    propTypes_3 = propTypes.isView,
    propTypes_4 = propTypes.isClassName,
    propTypes_5 = propTypes.isViews,
    propTypes_6 = propTypes.isValue,
    propTypes_7 = propTypes.isMaxDate,
    propTypes_8 = propTypes.isMinDate,
    propTypes_9 = propTypes.isCalendarType,
    Navigation_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }(),
      n = l(React__default),
      r = l(PropTypes);

  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function o(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  }

  var c = function (e) {
    function t() {
      var e, a, n;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      for (var r = arguments.length, l = Array(r), c = 0; c < r; c++) {
        l[c] = arguments[c];
      }

      return a = n = o(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), n.onClickPrevious = function () {
        var e = n.props,
            t = e.activeStartDate,
            a = e.view;
        (0, e.setActiveStartDate)((0, dates.getBeginPrevious)(a, t));
      }, n.onClickNext = function () {
        var e = n.props,
            t = e.activeStartDate,
            a = e.view;
        (0, e.setActiveStartDate)((0, dates.getBeginNext)(a, t));
      }, n.onClickPrevious2 = function () {
        var e = n.props,
            t = e.activeStartDate,
            a = e.view;
        (0, e.setActiveStartDate)((0, dates.getBeginPrevious2)(a, t));
      }, n.onClickNext2 = function () {
        var e = n.props,
            t = e.activeStartDate,
            a = e.view;
        (0, e.setActiveStartDate)((0, dates.getBeginNext2)(a, t));
      }, o(n, a);
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, React__default.Component), a(t, [{
      key: "shouldComponentUpdate",
      value: function value(e) {
        return e.activeStartDate !== this.props.activeStartDate || e.view !== this.props.view;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.label,
            t = this.props,
            a = t.drillUp,
            r = t.view,
            l = t.activeStartDate,
            o = "react-calendar__navigation";
        return n.default.createElement("div", {
          className: o,
          style: {
            display: "flex"
          }
        }, null !== this.props.prev2Label && "century" !== r && n.default.createElement("button", {
          className: o + "__arrow " + o + "__prev2-button",
          disabled: this.prev2ButtonDisabled,
          onClick: this.onClickPrevious2,
          type: "button"
        }, this.props.prev2Label), n.default.createElement("button", {
          className: o + "__arrow " + o + "__prev-button",
          disabled: this.prevButtonDisabled,
          onClick: this.onClickPrevious,
          type: "button"
        }, this.props.prevLabel), n.default.createElement("button", {
          className: "react-calendar__navigation__label",
          onClick: a,
          disabled: !this.drillUpAvailable,
          style: {
            flexGrow: 1
          },
          type: "button"
        }, this.props.navigationLabel ? this.props.navigationLabel({
          date: l,
          view: r,
          label: e
        }) : e), n.default.createElement("button", {
          className: o + "__arrow " + o + "__next-button",
          disabled: this.nextButtonDisabled,
          onClick: this.onClickNext,
          type: "button"
        }, this.props.nextLabel), null !== this.props.next2Label && "century" !== r && n.default.createElement("button", {
          className: o + "__arrow " + o + "__next2-button",
          disabled: this.next2ButtonDisabled,
          onClick: this.onClickNext2,
          type: "button"
        }, this.props.next2Label));
      }
    }, {
      key: "drillUpAvailable",
      get: function get() {
        var e = this.props,
            t = e.view;
        return e.views.indexOf(t) > 0;
      }
    }, {
      key: "prevButtonDisabled",
      get: function get() {
        var e = this.props,
            t = e.activeStartDate,
            a = e.minDate,
            n = e.view;
        if ((0, dates.getBeginPrevious)(n, t).getFullYear() < 1e3) return !0;
        var r = (0, dates.getEndPrevious)(n, t);
        return a && a >= r;
      }
    }, {
      key: "prev2ButtonDisabled",
      get: function get() {
        var e = this.props,
            t = e.activeStartDate,
            a = e.minDate,
            n = e.view;
        if ((0, dates.getBeginPrevious2)(n, t).getFullYear() < 1e3) return !0;
        var r = (0, dates.getEndPrevious2)(n, t);
        return a && a >= r;
      }
    }, {
      key: "nextButtonDisabled",
      get: function get() {
        var e = this.props,
            t = e.activeStartDate,
            a = e.maxDate,
            n = e.view,
            r = (0, dates.getBeginNext)(n, t);
        return a && a <= r;
      }
    }, {
      key: "next2ButtonDisabled",
      get: function get() {
        var e = this.props,
            t = e.activeStartDate,
            a = e.maxDate,
            n = e.view,
            r = (0, dates.getBeginNext2)(n, t);
        return a && a <= r;
      }
    }, {
      key: "label",
      get: function get() {
        var e = this.props,
            t = e.activeStartDate,
            a = e.formatMonthYear,
            n = e.locale,
            r = e.view;

        switch (r) {
          case "century":
            return (0, dates.getCenturyLabel)(t);

          case "decade":
            return (0, dates.getDecadeLabel)(t);

          case "year":
            return (0, dates.getYear)(t);

          case "month":
            return a(t, n);

          default:
            throw new Error("Invalid view: " + r + ".");
        }
      }
    }]), t;
  }();

  t.default = c, c.defaultProps = {
    formatMonthYear: dateFormatter.formatMonthYear,
    next2Label: "»",
    nextLabel: "›",
    prev2Label: "«",
    prevLabel: "‹"
  }, c.propTypes = {
    activeStartDate: r.default.instanceOf(Date).isRequired,
    drillUp: r.default.func.isRequired,
    formatMonthYear: r.default.func,
    locale: r.default.string,
    maxDate: r.default.instanceOf(Date),
    minDate: r.default.instanceOf(Date),
    next2Label: r.default.oneOfType([r.default.string, r.default.node]),
    nextLabel: r.default.oneOfType([r.default.string, r.default.node]),
    navigationLabel: r.default.func,
    prev2Label: r.default.oneOfType([r.default.string, r.default.node]),
    prevLabel: r.default.oneOfType([r.default.string, r.default.node]),
    setActiveStartDate: r.default.func.isRequired,
    view: propTypes.isView.isRequired,
    views: propTypes.isViews.isRequired
  };
});
unwrapExports(Navigation_1);
var Flex_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = l(React__default),
      r = l(PropTypes);

  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var o = function o(e) {
    return e + "%";
  },
      c = function c(e) {
    var t = e.children,
        r = e.className,
        l = e.direction,
        c = e.count,
        i = e.offset,
        s = e.style,
        u = e.wrap,
        f = function (e, t) {
      var a = {};

      for (var n in e) {
        t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
      }

      return a;
    }(e, ["children", "className", "direction", "count", "offset", "style", "wrap"]);

    return n.default.createElement("div", a({
      className: r,
      style: a({
        display: "flex",
        flexDirection: l,
        flexWrap: u ? "wrap" : "no-wrap"
      }, s)
    }, f), n.default.Children.map(t, function (e, t) {
      return n.default.cloneElement(e, a({}, e.props, {
        style: {
          flexBasis: o(100 / c),
          maxWidth: o(100 / c),
          overflow: "hidden",
          marginLeft: i && 0 === t ? o(100 * i / c) : null
        }
      }));
    }));
  };

  c.propTypes = {
    children: r.default.node,
    className: r.default.string,
    count: r.default.number.isRequired,
    direction: r.default.string,
    offset: r.default.number,
    style: r.default.objectOf(r.default.oneOfType([r.default.string, r.default.number])),
    wrap: r.default.bool
  }, t.default = c;
});
unwrapExports(Flex_1);
var utils = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.getTileClasses = t.between = t.doRangesOverlap = t.isRangeWithinRange = t.isValueWithinRange = t.callIfDefined = t.mergeFunctions = void 0;
  t.mergeFunctions = function () {
    for (var e = arguments.length, t = Array(e), a = 0; a < e; a++) {
      t[a] = arguments[a];
    }

    return function () {
      for (var e = arguments.length, a = Array(e), n = 0; n < e; n++) {
        a[n] = arguments[n];
      }

      return t.filter(Boolean).forEach(function (e) {
        return e.apply(void 0, a);
      });
    };
  }, t.callIfDefined = function (e) {
    for (var t = arguments.length, a = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
      a[n - 1] = arguments[n];
    }

    e && "function" == typeof e && e.apply(void 0, a);
  };

  var a = t.isValueWithinRange = function (e, t) {
    return t[0] <= e && t[1] >= e;
  },
      n = t.isRangeWithinRange = function (e, t) {
    return e[0] <= t[0] && e[1] >= t[1];
  },
      r = t.doRangesOverlap = function (e, t) {
    return a(e[0], t) || a(e[1], t);
  };

  t.between = function (e, t, a) {
    return t && t > e ? t : a && a < e ? a : e;
  }, t.getTileClasses = function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.value,
        l = e.valueType,
        o = e.date,
        c = e.dateType,
        i = e.hover,
        s = "react-calendar__tile",
        u = [s];
    if (!t) return u;
    if (!(o && (t instanceof Array || l) && (o instanceof Array || c))) throw new Error("getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.");
    var f = t instanceof Array ? t : (0, dates.getRange)(l, t),
        d = o instanceof Array ? o : (0, dates.getRange)(c, o),
        p = new Date();
    return n(f, d) ? u.push(s + "--active") : r(f, d) ? u.push(s + "--hasActive") : i && (d[1] < f[0] && n([i, f[0]], d) || d[0] > f[1] && n([f[1], i], d)) && u.push(s + "--hover"), a(p, d) && u.push(s + "--now"), u;
  };
});
unwrapExports(utils);
var utils_1 = utils.getTileClasses,
    utils_2 = utils.between,
    utils_3 = utils.doRangesOverlap,
    utils_4 = utils.isRangeWithinRange,
    utils_5 = utils.isValueWithinRange,
    utils_6 = utils.callIfDefined,
    utils_7 = utils.mergeFunctions,
    TileGroup_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = o(React__default),
      r = o(PropTypes),
      l = o(Flex_1);

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = function c(e) {
    for (var t = e.className, r = e.count, o = e.dateTransform, c = e.dateType, i = e.end, s = e.hover, u = e.offset, f = e.start, d = e.step, p = e.tile, h = e.value, m = e.valueType, _ = function (e, t) {
      var a = {};

      for (var n in e) {
        t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
      }

      return a;
    }(e, ["className", "count", "dateTransform", "dateType", "end", "hover", "offset", "start", "step", "tile", "value", "valueType"]), v = [], y = f; y <= i; y += d) {
      var g = o(y);
      v.push(n.default.createElement(p, a({
        classes: (0, utils.getTileClasses)({
          value: h,
          valueType: m,
          date: g,
          dateType: c,
          hover: s
        }),
        date: g,
        point: y,
        key: g.getTime()
      }, _)));
    }

    return n.default.createElement(l.default, {
      className: t,
      count: r,
      offset: u,
      wrap: !0
    }, v);
  };

  c.propTypes = a({}, propTypes.tileGroupProps, {
    activeStartDate: r.default.instanceOf(Date),
    count: r.default.number,
    dateTransform: r.default.func.isRequired,
    offset: r.default.number,
    tile: r.default.func.isRequired,
    step: r.default.number
  }), c.defaultProps = {
    count: 3,
    step: 1
  }, t.default = c;
});
unwrapExports(TileGroup_1);
var Tile_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = o(React__default),
      r = o(PropTypes),
      l = o(entry);

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = function c(e) {
    var t = e.children,
        a = e.classes,
        r = e.date,
        o = e.dateTime,
        c = e.maxDate,
        i = e.maxDateTransform,
        s = e.minDate,
        u = e.minDateTransform,
        f = e.onClick,
        d = e.onMouseOver,
        p = e.style,
        h = e.tileClassName,
        m = e.tileContent,
        _ = e.tileDisabled,
        v = e.view;
    return n.default.createElement("button", {
      className: (0, l.default)(a, h instanceof Function ? h({
        date: r,
        view: v
      }) : h),
      disabled: s && u(s) > r || c && i(c) < r || _ && _({
        date: r,
        view: v
      }),
      onClick: f && function () {
        return f(r);
      },
      onMouseOver: d && function () {
        return d(r);
      },
      onFocus: d && function () {
        return d(r);
      },
      style: p,
      type: "button"
    }, n.default.createElement("time", {
      dateTime: o
    }, t), "function" == typeof m ? m({
      date: r,
      view: v
    }) : m);
  };

  c.propTypes = a({}, propTypes.tileProps, {
    children: r.default.node.isRequired,
    dateTime: r.default.string.isRequired,
    maxDateTransform: r.default.func.isRequired,
    minDateTransform: r.default.func.isRequired
  }), t.default = c;
});
unwrapExports(Tile_1);
var Decade_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = o(React__default),
      r = o(PropTypes),
      l = o(Tile_1);

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = function c(e) {
    var t = e.classes,
        r = e.point,
        o = function (e, t) {
      var a = {};

      for (var n in e) {
        t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
      }

      return a;
    }(e, ["classes", "point"]);

    return n.default.createElement(l.default, a({}, o, {
      classes: [].concat(function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, a = Array(e.length); t < e.length; t++) {
            a[t] = e[t];
          }

          return a;
        }

        return Array.from(e);
      }(t), ["react-calendar__century-view__decades__decade"]),
      dateTime: r + "T00:00:00.000",
      maxDateTransform: dates.getEndOfDecade,
      minDateTransform: dates.getBeginOfDecade,
      view: "century"
    }), (0, dates.getDecadeLabel)(r));
  };

  c.propTypes = a({
    point: r.default.number.isRequired
  }, propTypes.tileProps), t.default = c;
});
unwrapExports(Decade_1);
var Decades_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }(),
      r = c(React__default),
      l = c(TileGroup_1),
      o = c(Decade_1);

  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var i = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, React__default.PureComponent), n(t, [{
      key: "render",
      value: function value() {
        var e = this.props,
            t = (e.activeStartDate, function (e, t) {
          var a = {};

          for (var n in e) {
            t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
          }

          return a;
        }(e, ["activeStartDate"]));
        return r.default.createElement(l.default, a({}, t, {
          className: "react-calendar__century-view__decades",
          dateTransform: dates.getBeginOfDecade,
          dateType: "decade",
          end: this.end,
          start: this.start,
          step: 10,
          tile: o.default
        }));
      }
    }, {
      key: "start",
      get: function get() {
        var e = this.props.activeStartDate;
        return (0, dates.getBeginOfCenturyYear)(e);
      }
    }, {
      key: "end",
      get: function get() {
        return this.start + 99;
      }
    }]), t;
  }();

  t.default = i, i.propTypes = a({}, propTypes.tileGroupProps);
});
unwrapExports(Decades_1);
var CenturyView_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }(),
      n = o(React__default),
      r = o(PropTypes),
      l = o(Decades_1);

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, React__default.PureComponent), a(t, [{
      key: "renderDecades",
      value: function value() {
        return n.default.createElement(l.default, this.props);
      }
    }, {
      key: "render",
      value: function value() {
        return n.default.createElement("div", {
          className: "react-calendar__century-view"
        }, this.renderDecades());
      }
    }]), t;
  }();

  t.default = c, c.propTypes = {
    activeStartDate: r.default.instanceOf(Date).isRequired,
    maxDate: propTypes.isMaxDate,
    minDate: propTypes.isMinDate,
    onChange: r.default.func,
    setActiveRange: r.default.func,
    value: propTypes.isValue,
    valueType: r.default.string
  };
});
unwrapExports(CenturyView_1);
var Year_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = o(React__default),
      r = o(PropTypes),
      l = o(Tile_1);

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = function c(e) {
    var t = e.classes,
        r = e.point,
        o = function (e, t) {
      var a = {};

      for (var n in e) {
        t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
      }

      return a;
    }(e, ["classes", "point"]);

    return n.default.createElement(l.default, a({}, o, {
      classes: [].concat(function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, a = Array(e.length); t < e.length; t++) {
            a[t] = e[t];
          }

          return a;
        }

        return Array.from(e);
      }(t), ["react-calendar__decade-view__years__year"]),
      dateTime: r + "T00:00:00.000",
      maxDateTransform: dates.getEndOfYear,
      minDateTransform: dates.getBeginOfYear,
      view: "decade"
    }), r);
  };

  c.propTypes = a({
    point: r.default.number.isRequired
  }, propTypes.tileProps), t.default = c;
});
unwrapExports(Year_1);
var Years_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }(),
      r = c(React__default),
      l = c(TileGroup_1),
      o = c(Year_1);

  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var i = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, React__default.PureComponent), n(t, [{
      key: "render",
      value: function value() {
        var e = this.props,
            t = (e.activeStartDate, function (e, t) {
          var a = {};

          for (var n in e) {
            t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
          }

          return a;
        }(e, ["activeStartDate"]));
        return r.default.createElement(l.default, a({}, t, {
          className: "react-calendar__decade-view__years",
          dateTransform: function dateTransform(e) {
            return new Date(e, 0, 1);
          },
          dateType: "year",
          end: this.end,
          start: this.start,
          tile: o.default
        }));
      }
    }, {
      key: "start",
      get: function get() {
        var e = this.props.activeStartDate;
        return (0, dates.getBeginOfDecadeYear)(e);
      }
    }, {
      key: "end",
      get: function get() {
        return this.start + 9;
      }
    }]), t;
  }();

  t.default = i, i.propTypes = a({}, propTypes.tileGroupProps);
});
unwrapExports(Years_1);
var DecadeView_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }(),
      n = o(React__default),
      r = o(PropTypes),
      l = o(Years_1);

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, React__default.PureComponent), a(t, [{
      key: "renderYears",
      value: function value() {
        return n.default.createElement(l.default, this.props);
      }
    }, {
      key: "render",
      value: function value() {
        return n.default.createElement("div", {
          className: "react-calendar__decade-view"
        }, this.renderYears());
      }
    }]), t;
  }();

  t.default = c, c.propTypes = {
    activeStartDate: r.default.instanceOf(Date).isRequired,
    maxDate: propTypes.isMaxDate,
    minDate: propTypes.isMinDate,
    onChange: r.default.func,
    setActiveRange: r.default.func,
    value: propTypes.isValue,
    valueType: r.default.string
  };
});
unwrapExports(DecadeView_1);
var Month_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = o(React__default),
      r = o(PropTypes),
      l = o(Tile_1);

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = function c(e) {
    var t = e.classes,
        r = e.date,
        o = e.formatMonth,
        c = e.locale,
        i = function (e, t) {
      var a = {};

      for (var n in e) {
        t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
      }

      return a;
    }(e, ["classes", "date", "formatMonth", "locale"]);

    return n.default.createElement(l.default, a({}, i, {
      classes: [].concat(function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, a = Array(e.length); t < e.length; t++) {
            a[t] = e[t];
          }

          return a;
        }

        return Array.from(e);
      }(t), ["react-calendar__year-view__months__month"]),
      date: r,
      dateTime: (0, dates.getISOLocalMonth)(r) + "T00:00:00.000",
      maxDateTransform: dates.getEndOfMonth,
      minDateTransform: dates.getBeginOfMonth,
      view: "year"
    }), o(r, c));
  };

  c.defaultProps = {
    formatMonth: dateFormatter.formatMonth
  }, c.propTypes = a({}, propTypes.tileProps, {
    formatMonth: r.default.func,
    locale: r.default.string
  }), t.default = c;
});
unwrapExports(Month_1);
var Months_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }(),
      r = i(React__default),
      l = i(PropTypes),
      o = i(TileGroup_1),
      c = i(Month_1);

  function i(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function s(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  }

  var u = function (e) {
    function t() {
      var e, a, n;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      for (var r = arguments.length, l = Array(r), o = 0; o < r; o++) {
        l[o] = arguments[o];
      }

      return a = n = s(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), n.start = 0, n.end = 11, s(n, a);
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, React__default.PureComponent), n(t, [{
      key: "render",
      value: function value() {
        var e = this,
            t = this.props,
            n = (t.activeStartDate, function (e, t) {
          var a = {};

          for (var n in e) {
            t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
          }

          return a;
        }(t, ["activeStartDate"]));
        return r.default.createElement(o.default, a({}, n, {
          className: "react-calendar__year-view__months",
          dateTransform: function dateTransform(t) {
            return new Date(e.year, t, 1);
          },
          dateType: "month",
          end: this.end,
          start: this.start,
          tile: c.default
        }));
      }
    }, {
      key: "year",
      get: function get() {
        var e = this.props.activeStartDate;
        return (0, dates.getYear)(e);
      }
    }]), t;
  }();

  t.default = u, u.propTypes = a({}, propTypes.tileGroupProps, {
    locale: l.default.string
  });
});
unwrapExports(Months_1);
var YearView_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }(),
      n = o(React__default),
      r = o(PropTypes),
      l = o(Months_1);

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, React__default.PureComponent), a(t, [{
      key: "renderMonths",
      value: function value() {
        return n.default.createElement(l.default, this.props);
      }
    }, {
      key: "render",
      value: function value() {
        return n.default.createElement("div", {
          className: "react-calendar__year-view"
        }, this.renderMonths());
      }
    }]), t;
  }();

  t.default = c, c.propTypes = {
    activeStartDate: r.default.instanceOf(Date).isRequired,
    formatMonth: r.default.func,
    locale: r.default.string,
    maxDate: propTypes.isMaxDate,
    minDate: propTypes.isMinDate,
    onChange: r.default.func,
    setActiveRange: r.default.func,
    value: propTypes.isValue,
    valueType: r.default.string
  };
});
unwrapExports(YearView_1);
var Day_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = o(React__default),
      r = o(PropTypes),
      l = o(Tile_1);

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = "react-calendar__month-view__days__day",
      i = function i(e) {
    var t = e.classes,
        r = e.currentMonthIndex,
        o = e.date,
        i = function (e, t) {
      var a = {};

      for (var n in e) {
        t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
      }

      return a;
    }(e, ["classes", "currentMonthIndex", "date"]);

    return n.default.createElement(l.default, a({}, i, {
      classes: [].concat(function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, a = Array(e.length); t < e.length; t++) {
            a[t] = e[t];
          }

          return a;
        }

        return Array.from(e);
      }(t), [c, (0, dates.isWeekend)(o) ? c + "--weekend" : null, o.getMonth() !== r ? c + "--neighboringMonth" : null]),
      date: o,
      dateTime: (0, dates.getISOLocalDate)(o) + "T00:00:00.000",
      maxDateTransform: dates.getEndOfDay,
      minDateTransform: dates.getBeginOfDay,
      view: "month"
    }), (0, dates.getDay)(o));
  };

  i.propTypes = a({
    currentMonthIndex: r.default.number.isRequired
  }, propTypes.tileProps), t.default = i;
});
unwrapExports(Day_1);
var Days_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }(),
      r = i(React__default),
      l = i(PropTypes),
      o = i(TileGroup_1),
      c = i(Day_1);

  function i(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var s = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, React__default.PureComponent), n(t, [{
      key: "render",
      value: function value() {
        var e = this,
            t = this.monthIndex,
            n = this.props,
            l = (n.activeStartDate, n.calendarType, n.showNeighboringMonth, function (e, t) {
          var a = {};

          for (var n in e) {
            t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
          }

          return a;
        }(n, ["activeStartDate", "calendarType", "showNeighboringMonth"]));
        return r.default.createElement(o.default, a({}, l, {
          className: "react-calendar__month-view__days",
          count: 7,
          dateTransform: function dateTransform(a) {
            return new Date(e.year, t, a);
          },
          dateType: "day",
          end: this.end,
          offset: this.offset,
          start: this.start,
          tile: c.default,
          currentMonthIndex: t
        }));
      }
    }, {
      key: "offset",
      get: function get() {
        if (this.props.showNeighboringMonth) return 0;
        var e = this.props,
            t = e.activeStartDate,
            a = e.calendarType;
        return (0, dates.getDayOfWeek)(t, a);
      }
    }, {
      key: "start",
      get: function get() {
        if (this.props.showNeighboringMonth) {
          var e = this.props,
              t = e.activeStartDate,
              a = e.calendarType;
          return 1 - (0, dates.getDayOfWeek)(t, a);
        }

        return 1;
      }
    }, {
      key: "end",
      get: function get() {
        var e = this.props.activeStartDate,
            t = (0, dates.getDaysInMonth)(e);

        if (this.props.showNeighboringMonth) {
          var a = this.year,
              n = this.monthIndex,
              r = this.props.calendarType,
              l = new Date(a, n, t);
          return t + (7 - (0, dates.getDayOfWeek)(l, r) - 1);
        }

        return t;
      }
    }, {
      key: "year",
      get: function get() {
        var e = this.props.activeStartDate;
        return (0, dates.getYear)(e);
      }
    }, {
      key: "monthIndex",
      get: function get() {
        var e = this.props.activeStartDate;
        return (0, dates.getMonthIndex)(e);
      }
    }]), t;
  }();

  t.default = s, s.propTypes = a({
    calendarType: propTypes.isCalendarType.isRequired,
    showNeighboringMonth: l.default.bool
  }, propTypes.tileGroupProps);
});
unwrapExports(Days_1);
var Weekdays_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }(),
      n = o(React__default),
      r = o(PropTypes),
      l = o(Flex_1);

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, React__default.Component), a(t, [{
      key: "shouldComponentUpdate",
      value: function value(e) {
        return e.calendarType !== this.props.calendarType || e.locale !== this.props.locale;
      }
    }, {
      key: "render",
      value: function value() {
        for (var e = this.props, t = e.calendarType, a = e.formatShortWeekday, r = e.locale, o = this.beginOfMonth, c = this.year, i = this.monthIndex, s = [], u = 1; u <= 7; u += 1) {
          var f = new Date(c, i, u - (0, dates.getDayOfWeek)(o, t));
          s.push(n.default.createElement("div", {
            className: "react-calendar__month-view__weekdays__weekday",
            key: u,
            style: {
              flexGrow: 1
            }
          }, a(f, r).replace(".", "")));
        }

        return n.default.createElement(l.default, {
          className: "react-calendar__month-view__weekdays",
          count: 7
        }, s);
      }
    }, {
      key: "beginOfMonth",
      get: function get() {
        var e = this.props.month;
        return (0, dates.getBeginOfMonth)(e);
      }
    }, {
      key: "year",
      get: function get() {
        var e = this.beginOfMonth;
        return (0, dates.getYear)(e);
      }
    }, {
      key: "monthIndex",
      get: function get() {
        var e = this.beginOfMonth;
        return (0, dates.getMonthIndex)(e);
      }
    }]), t;
  }();

  t.default = c, c.defaultProps = {
    formatShortWeekday: dateFormatter.formatShortWeekday
  }, c.propTypes = {
    calendarType: propTypes.isCalendarType.isRequired,
    formatShortWeekday: r.default.func,
    locale: r.default.string,
    month: r.default.oneOfType([r.default.string, r.default.number, r.default.instanceOf(Date)]).isRequired
  };
});
unwrapExports(Weekdays_1);
var WeekNumber_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = r(React__default),
      n = r(PropTypes);

  function r(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var l = function l(e) {
    var t = e.date,
        n = e.onClickWeekNumber,
        r = e.weekNumber;
    return n ? a.default.createElement("button", {
      className: "react-calendar__tile",
      onClick: function onClick() {
        return n(r, t);
      },
      style: {
        flexGrow: 1
      },
      type: "button"
    }, a.default.createElement("span", null, r)) : a.default.createElement("div", {
      className: "react-calendar__tile",
      style: {
        flexGrow: 1
      }
    }, a.default.createElement("span", null, r));
  };

  l.propTypes = {
    date: n.default.instanceOf(Date).isRequired,
    onClickWeekNumber: n.default.func,
    weekNumber: n.default.number.isRequired
  }, t.default = l;
});
unwrapExports(WeekNumber_1);
var WeekNumbers_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }(),
      n = c(React__default),
      r = c(PropTypes),
      l = c(WeekNumber_1),
      o = c(Flex_1);

  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var i = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, React__default.PureComponent), a(t, [{
      key: "render",
      value: function value() {
        var e = this.dates,
            t = this.numberOfWeeks,
            a = this.weekNumbers,
            r = this.props.onClickWeekNumber;
        return n.default.createElement(o.default, {
          className: "react-calendar__month-view__weekNumbers",
          count: t,
          direction: "column",
          style: {
            flexBasis: "calc(100% * (1 / 8)",
            flexShrink: 0
          }
        }, a.map(function (t, a) {
          return n.default.createElement(l.default, {
            date: e[a],
            key: t,
            onClickWeekNumber: r,
            weekNumber: t
          });
        }));
      }
    }, {
      key: "startWeekday",
      get: function get() {
        var e = this.props,
            t = e.activeStartDate,
            a = e.calendarType;
        return (0, dates.getDayOfWeek)(t, a);
      }
    }, {
      key: "numberOfDays",
      get: function get() {
        var e = this.props.activeStartDate;
        return (0, dates.getDaysInMonth)(e);
      }
    }, {
      key: "numberOfWeeks",
      get: function get() {
        var e = this.numberOfDays - (7 - this.startWeekday);
        return 1 + Math.ceil(e / 7);
      }
    }, {
      key: "year",
      get: function get() {
        var e = this.props.activeStartDate;
        return (0, dates.getYear)(e);
      }
    }, {
      key: "monthIndex",
      get: function get() {
        var e = this.props.activeStartDate;
        return (0, dates.getMonthIndex)(e);
      }
    }, {
      key: "day",
      get: function get() {
        var e = this.props.activeStartDate;
        return (0, dates.getDay)(e);
      }
    }, {
      key: "dates",
      get: function get() {
        for (var e = this.year, t = this.monthIndex, a = this.numberOfWeeks, n = this.day, r = this.props.calendarType, l = [], o = 0; o < a; o += 1) {
          l.push((0, dates.getBeginOfWeek)(new Date(e, t, n + 7 * o), r));
        }

        return l;
      }
    }, {
      key: "weekNumbers",
      get: function get() {
        var e = this.dates,
            t = this.props.calendarType;
        return e.map(function (e) {
          return (0, dates.getWeekNumber)(e, t);
        });
      }
    }]), t;
  }();

  t.default = i, i.propTypes = {
    activeStartDate: r.default.instanceOf(Date).isRequired,
    calendarType: propTypes.isCalendarType.isRequired,
    onClickWeekNumber: r.default.func
  };
});
unwrapExports(WeekNumbers_1);
var MonthView_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }(),
      r = s(React__default),
      l = s(PropTypes),
      o = s(Days_1),
      c = s(Weekdays_1),
      i = s(WeekNumbers_1);

  function s(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var u = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, React__default.PureComponent), n(t, [{
      key: "renderWeekdays",
      value: function value() {
        return r.default.createElement(c.default, {
          calendarType: this.calendarType,
          locale: this.props.locale,
          month: this.props.activeStartDate,
          formatShortWeekday: this.props.formatShortWeekday
        });
      }
    }, {
      key: "renderWeekNumbers",
      value: function value() {
        return this.props.showWeekNumbers ? r.default.createElement(i.default, {
          activeStartDate: this.props.activeStartDate,
          calendarType: this.calendarType,
          onClickWeekNumber: this.props.onClickWeekNumber
        }) : null;
      }
    }, {
      key: "renderDays",
      value: function value() {
        var e = this.props,
            t = (e.calendarType, e.showWeekNumbers, function (e, t) {
          var a = {};

          for (var n in e) {
            t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
          }

          return a;
        }(e, ["calendarType", "showWeekNumbers"]));
        return r.default.createElement(o.default, a({
          calendarType: this.calendarType
        }, t));
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props.showWeekNumbers,
            t = "react-calendar__month-view";
        return r.default.createElement("div", {
          className: [t, e ? t + "--weekNumbers" : ""].join(" ")
        }, r.default.createElement("div", {
          style: {
            display: "flex",
            alignItems: "flex-end"
          }
        }, this.renderWeekNumbers(), r.default.createElement("div", {
          style: {
            flexGrow: 1,
            width: "100%"
          }
        }, this.renderWeekdays(), this.renderDays())));
      }
    }, {
      key: "calendarType",
      get: function get() {
        var e = this.props,
            t = e.calendarType,
            a = e.locale;
        if (t) return t;

        switch (a) {
          case "en-US":
            return "US";

          default:
            return "ISO 8601";
        }
      }
    }]), t;
  }();

  t.default = u, u.propTypes = {
    activeStartDate: l.default.instanceOf(Date).isRequired,
    calendarType: propTypes.isCalendarType,
    formatShortWeekday: l.default.func,
    locale: l.default.string,
    maxDate: propTypes.isMaxDate,
    minDate: propTypes.isMinDate,
    onChange: l.default.func,
    onClickWeekNumber: l.default.func,
    setActiveRange: l.default.func,
    showNeighboringMonth: l.default.bool,
    showWeekNumbers: l.default.bool,
    value: propTypes.isValue,
    valueType: l.default.string
  };
});
unwrapExports(MonthView_1);
var Calendar_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }(),
      r = d(React__default),
      l = d(PropTypes),
      o = d(entry),
      c = d(Navigation_1),
      i = d(CenturyView_1),
      s = d(DecadeView_1),
      u = d(YearView_1),
      f = d(MonthView_1);

  function d(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function p(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  }

  function h(e) {
    if (Array.isArray(e)) {
      for (var t = 0, a = Array(e.length); t < e.length; t++) {
        a[t] = e[t];
      }

      return a;
    }

    return Array.from(e);
  }

  var m = ["century", "decade", "year", "month"],
      _ = [].concat(h(m.slice(1)), ["day"]),
      v = function v(e, t) {
    return e && !t || !e && t || e && t && e.getTime() !== t.getTime();
  },
      y = function y(e, t) {
    return m.slice(m.indexOf(e), m.indexOf(t) + 1);
  },
      g = function g(e, t, a) {
    return e && -1 !== y(t, a).indexOf(e) ? e : y(t, a).pop();
  },
      E = function E(e) {
    return _[m.indexOf(e)];
  },
      b = function b(e, t, a, n) {
    if (!e) return null;
    var r = e instanceof Array && 2 === e.length ? e[0] : e;
    if (!r) return null;
    var l = new Date(r);
    if (isNaN(l.getTime())) throw new Error("Invalid date: " + e);
    var o = (0, dates.getBegin)(E(n), l);
    return (0, utils.between)(o, t, a);
  },
      z = function z(e, t, a, n) {
    if (!e) return null;
    var r = e instanceof Array && 2 === e.length ? e[1] : e;
    if (!r) return null;
    var l = new Date(r);
    if (isNaN(l.getTime())) throw new Error("Invalid date: " + e);
    var o = (0, dates.getEnd)(E(n), l);
    return (0, utils.between)(o, t, a);
  },
      R = function (e) {
    function t() {
      var e, a, n;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      for (var r = arguments.length, l = Array(r), o = 0; o < r; o++) {
        l[o] = arguments[o];
      }

      return a = n = p(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), n.state = {}, n.setActiveStartDate = function (e) {
        n.setState({
          activeStartDate: e
        }, function () {
          (0, utils.callIfDefined)(n.props.onActiveDateChange, {
            activeStartDate: e,
            view: n.state.view
          });
        });
      }, n.drillDown = function (e) {
        if (n.drillDownAvailable) {
          var t = y(n.props.minDetail, n.props.maxDetail);
          n.setState(function (a) {
            var n = t[t.indexOf(a.view) + 1];
            return {
              activeStartDate: e,
              view: n
            };
          }, function () {
            (0, utils.callIfDefined)(n.props.onDrillDown, {
              activeStartDate: e,
              view: n.state.view
            });
          });
        }
      }, n.drillUp = function () {
        if (n.drillUpAvailable) {
          var e = y(n.props.minDetail, n.props.maxDetail);
          n.setState(function (t) {
            var a = e[e.indexOf(t.view) - 1];
            return {
              activeStartDate: (0, dates.getBegin)(a, t.activeStartDate),
              view: a
            };
          }, function () {
            (0, utils.callIfDefined)(n.props.onDrillUp, {
              activeStartDate: n.state.activeStartDate,
              view: n.state.view
            });
          });
        }
      }, n.onChange = function (e) {
        var t = n.props,
            a = t.onChange,
            r = void 0,
            l = void 0;

        if (t.selectRange) {
          var o = n.state.value;
          o && 1 === [].concat(o).length ? (r = (0, dates.getValueRange)(n.valueType, o, e), l = function l() {
            return (0, utils.callIfDefined)(a, r);
          }) : r = (0, dates.getBegin)(n.valueType, e);
        } else r = n.getProcessedValue(e), l = function l() {
          return (0, utils.callIfDefined)(a, r);
        };

        n.setState({
          value: r
        }, l);
      }, n.onMouseOver = function (e) {
        n.setState({
          hover: e
        });
      }, n.onMouseOut = function () {
        n.setState({
          hover: null
        });
      }, p(n, a);
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, React__default.Component), n(t, [{
      key: "getProcessedValue",
      value: function value(e) {
        var t = this.props,
            a = t.minDate,
            n = t.maxDate,
            r = t.maxDetail;

        switch (t.returnValue) {
          case "start":
            return b(e, a, n, r);

          case "end":
            return z(e, a, n, r);

          case "range":
            return function (e, t, a, n) {
              return e instanceof Array ? e : [b(e, t, a, n), z(e, t, a, n)];
            }(e, a, n, r);

          default:
            throw new Error("Invalid returnValue.");
        }
      }
    }, {
      key: "renderContent",
      value: function value() {
        var e = this.props,
            t = e.calendarType,
            n = e.locale,
            l = e.maxDate,
            o = e.minDate,
            c = e.renderChildren,
            d = e.tileClassName,
            p = e.tileContent,
            h = e.tileDisabled,
            m = this.state,
            _ = m.activeStartDate,
            v = m.hover,
            y = m.value,
            g = m.view,
            E = this.onMouseOver,
            b = this.valueType,
            z = {
          activeStartDate: _,
          hover: v,
          locale: n,
          maxDate: l,
          minDate: o,
          onMouseOver: this.props.selectRange ? E : null,
          tileClassName: d,
          tileContent: p || c,
          tileDisabled: h,
          value: y,
          valueType: b
        },
            R = this.drillDownAvailable ? this.drillDown : this.onChange;

        switch (g) {
          case "century":
            return r.default.createElement(i.default, a({
              onClick: (0, utils.mergeFunctions)(R, this.props.onClickDecade)
            }, z));

          case "decade":
            return r.default.createElement(s.default, a({
              onClick: (0, utils.mergeFunctions)(R, this.props.onClickYear)
            }, z));

          case "year":
            return r.default.createElement(u.default, a({
              formatMonth: this.props.formatMonth,
              onClick: (0, utils.mergeFunctions)(R, this.props.onClickMonth)
            }, z));

          case "month":
            return r.default.createElement(f.default, a({
              calendarType: t,
              formatShortWeekday: this.props.formatShortWeekday,
              onClick: (0, utils.mergeFunctions)(R, this.props.onClickDay),
              onClickWeekNumber: this.props.onClickWeekNumber,
              showNeighboringMonth: this.props.showNeighboringMonth,
              showWeekNumbers: this.props.showWeekNumbers
            }, z));

          default:
            throw new Error("Invalid view: " + g + ".");
        }
      }
    }, {
      key: "renderNavigation",
      value: function value() {
        return this.props.showNavigation ? r.default.createElement(c.default, {
          activeRange: this.state.activeRange,
          activeStartDate: this.state.activeStartDate,
          drillUp: this.drillUp,
          formatMonthYear: this.props.formatMonthYear,
          locale: this.props.locale,
          maxDate: this.props.maxDate,
          minDate: this.props.minDate,
          next2Label: this.props.next2Label,
          nextLabel: this.props.nextLabel,
          navigationLabel: this.props.navigationLabel,
          prev2Label: this.props.prev2Label,
          prevLabel: this.props.prevLabel,
          setActiveStartDate: this.setActiveStartDate,
          view: this.state.view,
          views: y(this.props.minDetail, this.props.maxDetail)
        }) : null;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
            t = e.className,
            a = e.selectRange,
            n = this.state.value,
            l = this.onMouseOut,
            c = [].concat(n);
        return r.default.createElement("div", {
          className: (0, o.default)("react-calendar", a && 1 === c.length && "react-calendar--selectRange", t),
          onMouseOut: a ? l : null,
          onBlur: a ? l : null
        }, this.renderNavigation(), this.renderContent());
      }
    }, {
      key: "drillDownAvailable",
      get: function get() {
        var e = y(this.props.minDetail, this.props.maxDetail);
        return e.indexOf(this.state.view) < e.length - 1;
      }
    }, {
      key: "drillUpAvailable",
      get: function get() {
        return y(this.props.minDetail, this.props.maxDetail).indexOf(this.state.view) > 0;
      }
    }, {
      key: "valueType",
      get: function get() {
        return E(this.props.maxDetail);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function value(e, t) {
        var a,
            n,
            r,
            l = e.minDate,
            o = e.maxDate,
            c = e.minDetail,
            i = e.maxDetail,
            s = {},
            u = (n = g((a = e).view, a.minDetail, a.maxDetail), r = b(a.value, a.minDate, a.maxDate, a.maxDetail) || a.activeStartDate || new Date(), (0, dates.getBegin)(n, r));
        v(u, t.activeStartDateProps) && (s.activeStartDate = u, s.activeStartDateProps = u);
        var f = g(e.view, c, i);
        f === t.viewProps || function (e, t, a) {
          return -1 !== y(t, a).indexOf(e);
        }(t.view, c, i) || (s.view = f, s.viewProps = f);
        var d = [e.value, t.valueProps];
        return (s.view || v.apply(void 0, h(d.map(function (e) {
          return b(e, l, o, i);
        }))) || v.apply(void 0, h(d.map(function (e) {
          return z(e, l, o, i);
        })))) && (s.value = e.value, s.valueProps = e.value), !e.selectRange && t.hover && (s.hover = null), s;
      }
    }]), t;
  }();

  t.default = R, R.defaultProps = {
    maxDetail: "month",
    minDetail: "century",
    returnValue: "start",
    showNavigation: !0,
    showNeighboringMonth: !0,
    view: "month"
  }, R.propTypes = {
    activeStartDate: l.default.instanceOf(Date),
    calendarType: propTypes.isCalendarType,
    className: propTypes.isClassName,
    formatMonth: l.default.func,
    formatMonthYear: l.default.func,
    formatShortWeekday: l.default.func,
    locale: l.default.string,
    maxDate: propTypes.isMaxDate,
    maxDetail: l.default.oneOf(m),
    minDate: propTypes.isMinDate,
    minDetail: l.default.oneOf(m),
    navigationLabel: l.default.func,
    next2Label: l.default.oneOfType([l.default.string, l.default.node]),
    nextLabel: l.default.oneOfType([l.default.string, l.default.node]),
    onActiveDateChange: l.default.func,
    onChange: l.default.func,
    onClickDay: l.default.func,
    onClickDecade: l.default.func,
    onClickMonth: l.default.func,
    onClickWeekNumber: l.default.func,
    onClickYear: l.default.func,
    onDrillDown: l.default.func,
    onDrillUp: l.default.func,
    prev2Label: l.default.oneOfType([l.default.string, l.default.node]),
    prevLabel: l.default.oneOfType([l.default.string, l.default.node]),
    renderChildren: l.default.func,
    returnValue: l.default.oneOf(["start", "end", "range"]),
    selectRange: l.default.bool,
    showNavigation: l.default.bool,
    showNeighboringMonth: l.default.bool,
    showWeekNumbers: l.default.bool,
    tileClassName: l.default.oneOfType([l.default.func, propTypes.isClassName]),
    tileContent: l.default.oneOfType([l.default.func, l.default.node]),
    tileDisabled: l.default.func,
    value: l.default.oneOfType([l.default.string, propTypes.isValue]),
    view: l.default.oneOf(m)
  }, (0, _reactLifecyclesCompat.polyfill)(R);
});
unwrapExports(Calendar_1);
var entry_nostyle = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.MonthView = t.YearView = t.DecadeView = t.CenturyView = t.Calendar = void 0;
  var a = c(Calendar_1),
      n = c(CenturyView_1),
      r = c(DecadeView_1),
      l = c(YearView_1),
      o = c(MonthView_1);

  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  t.default = a.default, t.Calendar = a.default, t.CenturyView = n.default, t.DecadeView = r.default, t.YearView = l.default, t.MonthView = o.default;
});
unwrapExports(entry_nostyle);
var entry_nostyle_1 = entry_nostyle.MonthView,
    entry_nostyle_2 = entry_nostyle.YearView,
    entry_nostyle_3 = entry_nostyle.DecadeView,
    entry_nostyle_4 = entry_nostyle.CenturyView,
    entry_nostyle_5 = entry_nostyle.Calendar,
    Divider_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = r(React__default),
      n = r(PropTypes);

  function r(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var l = function l(e) {
    var t = e.children;
    return a.default.createElement("span", {
      className: "react-date-picker__button__input__divider"
    }, t);
  };

  l.propTypes = {
    children: n.default.node
  }, t.default = l;
});
unwrapExports(Divider_1);
var dates$2 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "getYear", {
    enumerable: !0,
    get: function get() {
      return dates.getYear;
    }
  }), Object.defineProperty(t, "getMonth", {
    enumerable: !0,
    get: function get() {
      return dates.getMonth;
    }
  }), Object.defineProperty(t, "getMonthIndex", {
    enumerable: !0,
    get: function get() {
      return dates.getMonthIndex;
    }
  }), Object.defineProperty(t, "getDay", {
    enumerable: !0,
    get: function get() {
      return dates.getDay;
    }
  }), Object.defineProperty(t, "getDaysInMonth", {
    enumerable: !0,
    get: function get() {
      return dates.getDaysInMonth;
    }
  }), Object.defineProperty(t, "getBegin", {
    enumerable: !0,
    get: function get() {
      return dates.getBegin;
    }
  }), Object.defineProperty(t, "getEnd", {
    enumerable: !0,
    get: function get() {
      return dates.getEnd;
    }
  }), Object.defineProperty(t, "getISOLocalMonth", {
    enumerable: !0,
    get: function get() {
      return dates.getISOLocalMonth;
    }
  }), Object.defineProperty(t, "getISOLocalDate", {
    enumerable: !0,
    get: function get() {
      return dates.getISOLocalDate;
    }
  });
});
unwrapExports(dates$2);
var propTypes$2 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.isValueType = t.isDetail = t.isMinDate = t.isMaxDate = void 0, Object.defineProperty(t, "isMaxDate", {
    enumerable: !0,
    get: function get() {
      return propTypes.isMaxDate;
    }
  }), Object.defineProperty(t, "isMinDate", {
    enumerable: !0,
    get: function get() {
      return propTypes.isMinDate;
    }
  });
  var a,
      n = (a = PropTypes) && a.__esModule ? a : {
    default: a
  };
  var r = ["century", "decade", "year", "month"],
      l = [].concat(function (e) {
    if (Array.isArray(e)) {
      for (var t = 0, a = Array(e.length); t < e.length; t++) {
        a[t] = e[t];
      }

      return a;
    }

    return Array.from(e);
  }(r.slice(1)), ["day"]);
  t.isDetail = n.default.oneOf(r), t.isValueType = n.default.oneOf(l);
});
unwrapExports(propTypes$2);
var propTypes_1$1 = propTypes$2.isValueType,
    propTypes_2$1 = propTypes$2.isDetail,
    propTypes_3$1 = propTypes$2.isMinDate,
    propTypes_4$1 = propTypes$2.isMaxDate,
    utils$2 = createCommonjsModule(function (e, t) {
  function a(e) {
    if (Array.isArray(e)) {
      for (var t = 0, a = Array(e.length); t < e.length; t++) {
        a[t] = e[t];
      }

      return a;
    }

    return Array.from(e);
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "between", {
    enumerable: !0,
    get: function get() {
      return utils.between;
    }
  });

  var n = function n(e) {
    return "number" == typeof e && !isNaN(e);
  };

  t.min = function () {
    for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) {
      t[r] = arguments[r];
    }

    return Math.min.apply(Math, a(t.filter(n)));
  }, t.max = function () {
    for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) {
      t[r] = arguments[r];
    }

    return Math.max.apply(Math, a(t.filter(n)));
  }, t.updateInputWidth = function (e) {
    var t = document.createElement("span");
    t.innerHTML = e.value || e.placeholder;
    var a = e.parentElement;
    a.appendChild(t);
    var n = t.getBoundingClientRect().width + 4;
    e.style.width = n + "px", a.removeChild(t);
  };
});
unwrapExports(utils$2);
var utils_1$1 = utils$2.min,
    utils_2$1 = utils$2.max,
    utils_3$1 = utils$2.updateInputWidth,
    DayInput_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }(),
      n = o(React__default),
      r = o(PropTypes),
      l = o(entry);

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, React__default.PureComponent), a(t, [{
      key: "render",
      value: function value() {
        var e = this.maxDay,
            t = this.minDay,
            a = this.props,
            r = a.className,
            o = a.disabled,
            c = a.itemRef,
            i = a.value,
            s = a.onChange,
            u = a.onKeyDown,
            f = a.required,
            d = a.showLeadingZeros && null !== i && i < 10;
        return [d ? "0" : null, n.default.createElement("input", {
          key: "day",
          className: (0, l.default)(r + "__input", r + "__day", d && r + "__input--hasLeadingZero"),
          disabled: o,
          name: "day",
          max: e,
          min: t,
          onChange: s,
          onKeyDown: u,
          placeholder: "--",
          ref: function ref(e) {
            e && ((0, utils$2.updateInputWidth)(e), c && c(e));
          },
          required: f,
          type: "number",
          value: null !== i ? i : ""
        })];
      }
    }, {
      key: "currentMonthMaxDays",
      get: function get() {
        var e = this.props,
            t = e.year,
            a = e.month;
        return a ? (0, dates$2.getDaysInMonth)(new Date(t, a - 1, 1)) : 31;
      }
    }, {
      key: "maxDay",
      get: function get() {
        var e = this.props,
            t = e.maxDate,
            a = e.month,
            n = e.year;
        return (0, utils$2.min)(this.currentMonthMaxDays, t && n === (0, dates$2.getYear)(t) && a === (0, dates$2.getMonth)(t) && (0, dates$2.getDay)(t));
      }
    }, {
      key: "minDay",
      get: function get() {
        var e = this.props,
            t = e.minDate,
            a = e.month,
            n = e.year;
        return (0, utils$2.max)(1, t && n === (0, dates$2.getYear)(t) && a === (0, dates$2.getMonth)(t) && (0, dates$2.getDay)(t));
      }
    }]), t;
  }();

  t.default = c, c.propTypes = {
    className: r.default.string.isRequired,
    disabled: r.default.bool,
    itemRef: r.default.func,
    maxDate: propTypes$2.isMaxDate,
    minDate: propTypes$2.isMinDate,
    month: r.default.number,
    onChange: r.default.func,
    onKeyDown: r.default.func,
    required: r.default.bool,
    showLeadingZeros: r.default.bool,
    value: r.default.number,
    year: r.default.number
  };
});
unwrapExports(DayInput_1);
var MonthInput_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }(),
      n = o(React__default),
      r = o(PropTypes),
      l = o(entry);

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, React__default.PureComponent), a(t, [{
      key: "render",
      value: function value() {
        var e = this.maxMonth,
            t = this.minMonth,
            a = this.props,
            r = a.className,
            o = a.disabled,
            c = a.itemRef,
            i = a.value,
            s = a.onChange,
            u = a.onKeyDown,
            f = a.required,
            d = a.showLeadingZeros && null !== i && i < 10;
        return [d ? "0" : null, n.default.createElement("input", {
          key: "month",
          className: (0, l.default)(r + "__input", r + "__month", d && r + "__input--hasLeadingZero"),
          disabled: o,
          name: "month",
          max: e,
          min: t,
          onChange: s,
          onKeyDown: u,
          placeholder: "--",
          ref: function ref(e) {
            e && ((0, utils$2.updateInputWidth)(e), c && c(e));
          },
          type: "number",
          required: f,
          value: null !== i ? i : ""
        })];
      }
    }, {
      key: "maxMonth",
      get: function get() {
        var e = this.props,
            t = e.maxDate,
            a = e.year;
        return (0, utils$2.min)(12, t && a === (0, dates$2.getYear)(t) && (0, dates$2.getMonth)(t));
      }
    }, {
      key: "minMonth",
      get: function get() {
        var e = this.props,
            t = e.minDate,
            a = e.year;
        return (0, utils$2.max)(1, t && a === (0, dates$2.getYear)(t) && (0, dates$2.getMonth)(t));
      }
    }]), t;
  }();

  t.default = c, c.propTypes = {
    className: r.default.string.isRequired,
    disabled: r.default.bool,
    itemRef: r.default.func,
    maxDate: propTypes$2.isMaxDate,
    minDate: propTypes$2.isMinDate,
    onChange: r.default.func,
    onKeyDown: r.default.func,
    required: r.default.bool,
    showLeadingZeros: r.default.bool,
    value: r.default.number,
    year: r.default.number
  };
});
unwrapExports(MonthInput_1);
var YearInput_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }(),
      n = o(React__default),
      r = o(PropTypes),
      l = o(entry);

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, React__default.PureComponent), a(t, [{
      key: "render",
      value: function value() {
        var e = this.maxYear,
            t = this.minYear,
            a = this.yearStep,
            r = this.props,
            o = r.className,
            c = r.disabled,
            i = r.itemRef,
            s = r.value,
            u = r.onChange,
            f = r.onKeyDown,
            d = r.required;
        return n.default.createElement("input", {
          className: (0, l.default)(o + "__input", o + "__year"),
          disabled: c,
          name: "year",
          max: e,
          min: t,
          onChange: u,
          onKeyDown: f,
          placeholder: "--",
          ref: function ref(e) {
            e && ((0, utils$2.updateInputWidth)(e), i && i(e));
          },
          required: d,
          step: a,
          type: "number",
          value: null !== s ? s : ""
        });
      }
    }, {
      key: "maxYear",
      get: function get() {
        var e = this.props.maxDate;
        return e ? (0, dates$2.getYear)(e) : null;
      }
    }, {
      key: "minYear",
      get: function get() {
        var e = this.props.minDate;
        return (0, utils$2.max)(1e3, e && (0, dates$2.getYear)(e));
      }
    }, {
      key: "yearStep",
      get: function get() {
        return "century" === this.props.valueType ? 10 : 1;
      }
    }]), t;
  }();

  t.default = c, c.propTypes = {
    className: r.default.string.isRequired,
    disabled: r.default.bool,
    itemRef: r.default.func,
    maxDate: propTypes$2.isMaxDate,
    minDate: propTypes$2.isMinDate,
    onChange: r.default.func,
    onKeyDown: r.default.func,
    required: r.default.bool,
    value: r.default.number,
    valueType: propTypes$2.isValueType
  };
});
unwrapExports(YearInput_1);
var NativeInput_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }(),
      n = l(React__default),
      r = l(PropTypes);

  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function o(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  }

  var c = function (e) {
    function t() {
      var e, a, n;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      for (var r = arguments.length, l = Array(r), c = 0; c < r; c++) {
        l[c] = arguments[c];
      }

      return a = n = o(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), n.stopPropagation = function (e) {
        return e.stopPropagation();
      }, o(n, a);
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, React__default.PureComponent), a(t, [{
      key: "render",
      value: function value() {
        var e = this.nativeValueParser,
            t = this.props,
            a = t.disabled,
            r = t.maxDate,
            l = t.minDate,
            o = t.name,
            c = t.onChange,
            i = t.required,
            s = t.value;
        return n.default.createElement("input", {
          type: this.nativeInputType,
          disabled: a,
          max: r ? e(r) : null,
          min: l ? e(l) : null,
          name: o,
          onChange: c,
          onFocus: this.stopPropagation,
          required: i,
          style: {
            visibility: "hidden",
            position: "absolute",
            top: "-9999px",
            left: "-9999px"
          },
          value: s ? e(s) : ""
        });
      }
    }, {
      key: "nativeInputType",
      get: function get() {
        switch (this.props.valueType) {
          case "decade":
          case "year":
            return "number";

          case "month":
            return "month";

          case "day":
            return "date";

          default:
            throw new Error("Invalid valueType.");
        }
      }
    }, {
      key: "nativeValueParser",
      get: function get() {
        switch (this.props.valueType) {
          case "century":
          case "decade":
          case "year":
            return dates$2.getYear;

          case "month":
            return dates$2.getISOLocalMonth;

          case "day":
            return dates$2.getISOLocalDate;

          default:
            throw new Error("Invalid valueType.");
        }
      }
    }]), t;
  }();

  t.default = c, c.propTypes = {
    disabled: r.default.bool,
    maxDate: propTypes$2.isMaxDate,
    minDate: propTypes$2.isMinDate,
    name: r.default.string,
    onChange: r.default.func,
    required: r.default.bool,
    value: r.default.oneOfType([r.default.string, r.default.instanceOf(Date)]),
    valueType: propTypes$2.isValueType
  };
});
unwrapExports(NativeInput_1);
var locales$2 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "getDefaultLocale", {
    enumerable: !0,
    get: function get() {
      return locales.getDefaultLocale;
    }
  });
});
unwrapExports(locales$2);
var dateFormatter$2 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.formatDate = void 0;
  var a = {};

  t.formatDate = function (e, t) {
    return function (e, t) {
      t || (t = (0, locales$2.getDefaultLocale)());
      var n = JSON.stringify(e);
      return a[t] || (a[t] = {}), a[t][n] || (a[t][n] = new Intl.DateTimeFormat(t, e).format), a[t][n];
    }({
      day: "numeric",
      month: "numeric",
      year: "numeric"
    }, t)(e);
  };
});
unwrapExports(dateFormatter$2);
var dateFormatter_1$1 = dateFormatter$2.formatDate,
    DateInput_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }(),
      r = f(React__default),
      l = f(PropTypes),
      o = f(Divider_1),
      c = f(DayInput_1),
      i = f(MonthInput_1),
      s = f(YearInput_1),
      u = f(NativeInput_1);

  function f(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function d(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  }

  function p(e) {
    if (Array.isArray(e)) {
      for (var t = 0, a = Array(e.length); t < e.length; t++) {
        a[t] = e[t];
      }

      return a;
    }

    return Array.from(e);
  }

  var h = new Date(-864e13),
      m = new Date(864e13),
      _ = ["century", "decade", "year", "month"],
      v = [].concat(p(_.slice(1)), ["day"]),
      y = "react-date-picker__button__input",
      g = function g(e, t) {
    return e && !t || !e && t || e && t && e.getTime() !== t.getTime();
  },
      E = function E(e) {
    return v[_.indexOf(e)];
  },
      b = function b(e, t, a, n) {
    if (!e) return null;
    var r = e instanceof Array && 2 === e.length ? e[0] : e;
    if (!r) return null;
    var l = new Date(r);
    if (isNaN(l.getTime())) throw new Error("Invalid date: " + e);
    var o = (0, dates$2.getBegin)(E(n), l);
    return (0, utils$2.between)(o, t, a);
  },
      z = function z(e, t, a, n) {
    if (!e) return null;
    var r = e instanceof Array && 2 === e.length ? e[1] : e;
    if (!r) return null;
    var l = new Date(r);
    if (isNaN(l.getTime())) throw new Error("Invalid date: " + e);
    var o = (0, dates$2.getEnd)(E(n), l);
    return (0, utils$2.between)(o, t, a);
  },
      R = function R(e) {
    var t = e.previousElementSibling;
    return t ? t.previousElementSibling : null;
  },
      M = function M(e) {
    var t = e.nextElementSibling;
    return t ? t.nextElementSibling : null;
  },
      w = function w(e) {
    e && (e.focus(), e.select());
  },
      O = function O(e) {
    return e.split("").filter(function (e) {
      return 32 !== e.charCodeAt(0) && 8206 !== e.charCodeAt(0);
    }).join("");
  },
      C = function (e) {
    function t() {
      var e, a, n;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      for (var r = arguments.length, l = Array(r), o = 0; o < r; o++) {
        l[o] = arguments[o];
      }

      return a = n = d(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), n.state = {
        year: null,
        month: null,
        day: null
      }, n.onKeyDown = function (e) {
        switch (e.key) {
          case "ArrowLeft":
            e.preventDefault();
            var t = e.target,
                a = R(t);
            w(a);
            break;

          case "ArrowRight":
          case n.divider:
            e.preventDefault();
            var r = e.target,
                l = M(r);
            w(l);
        }
      }, n.onChange = function (e) {
        var t = e.target,
            a = t.name,
            r = t.value;
        n.setState(function (e, t, a) {
          return t in e ? Object.defineProperty(e, t, {
            value: a,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = a, e;
        }({}, a, r ? parseInt(r, 10) : null), n.onChangeExternal);
      }, n.onChangeNative = function (e) {
        var t = e.target.value;
        n.props.onChange && n.props.onChange(new Date(t));
      }, n.onChangeExternal = function () {
        if (n.props.onChange) {
          var e = [n.dayInput, n.monthInput, n.yearInput].filter(Boolean),
              t = {};

          if (e.forEach(function (e) {
            t[e.name] = e.value;
          }), e.every(function (e) {
            return e.value && e.checkValidity();
          })) {
            var a = new Date(t.year, (t.month || 1) - 1, t.day || 1),
                r = n.getProcessedValue(a);
            n.props.onChange(r, !1);
          }
        }
      }, d(n, a);
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, React__default.PureComponent), n(t, [{
      key: "getProcessedValue",
      value: function value(e) {
        var t = this.props,
            a = t.minDate,
            n = t.maxDate,
            r = t.maxDetail;

        switch (t.returnValue) {
          case "start":
            return b(e, a, n, r);

          case "end":
            return z(e, a, n, r);

          default:
            throw new Error("Invalid returnValue.");
        }
      }
    }, {
      key: "renderDay",
      value: function value() {
        var e = this.props,
            t = e.maxDetail,
            n = e.showLeadingZeros;
        if (_.indexOf(t) < 3) return null;
        var l = this.state.day;
        return r.default.createElement(c.default, a({
          key: "day",
          className: y,
          maxDetail: this.props.maxDetail,
          month: this.state.month,
          showLeadingZeros: n,
          value: l,
          year: this.state.year
        }, this.commonInputProps));
      }
    }, {
      key: "renderMonth",
      value: function value() {
        var e = this.props,
            t = e.maxDetail,
            n = e.showLeadingZeros;
        if (_.indexOf(t) < 2) return null;
        var l = this.state.month;
        return r.default.createElement(i.default, a({
          key: "month",
          className: y,
          maxDetail: this.props.maxDetail,
          showLeadingZeros: n,
          value: l,
          year: this.state.year
        }, this.commonInputProps));
      }
    }, {
      key: "renderYear",
      value: function value() {
        return r.default.createElement(s.default, a({
          key: "year",
          className: y,
          value: this.state.year,
          valueType: this.valueType
        }, this.commonInputProps));
      }
    }, {
      key: "renderCustomInputs",
      value: function value() {
        var e = this,
            t = this.divider;
        return this.placeholder.split(t).map(function (t) {
          switch (t) {
            case "day":
              return e.renderDay();

            case "month":
              return e.renderMonth();

            case "year":
              return e.renderYear();

            default:
              return null;
          }
        }).filter(Boolean).reduce(function (e, a, n) {
          return n && e.push(r.default.createElement(o.default, {
            key: "separator_" + n
          }, t)), e.push(a), e;
        }, []);
      }
    }, {
      key: "renderNativeInput",
      value: function value() {
        return r.default.createElement(u.default, {
          key: "date",
          disabled: this.props.disabled,
          maxDate: this.props.maxDate || m,
          minDate: this.props.minDate || h,
          name: this.props.name,
          onChange: this.onChangeNative,
          required: this.props.required,
          value: this.props.value,
          valueType: this.valueType
        });
      }
    }, {
      key: "render",
      value: function value() {
        return r.default.createElement("div", {
          className: y
        }, this.renderNativeInput(), this.renderCustomInputs());
      }
    }, {
      key: "divider",
      get: function get() {
        var e = this.props.locale,
            t = new Date(2017, 11, 11);
        return O((0, dateFormatter$2.formatDate)(t, e)).match(/[^0-9]/)[0];
      }
    }, {
      key: "placeholder",
      get: function get() {
        var e = this.props.locale,
            t = new Date(2017, 11, 11);
        return O((0, dateFormatter$2.formatDate)(t, e)).replace("2017", "year").replace("12", "month").replace("11", "day");
      }
    }, {
      key: "commonInputProps",
      get: function get() {
        var e = this;
        return {
          disabled: this.props.disabled,
          maxDate: this.props.maxDate || m,
          minDate: this.props.minDate || h,
          onChange: this.onChange,
          onKeyDown: this.onKeyDown,
          required: this.props.required || this.props.isCalendarOpen,
          itemRef: function itemRef(t) {
            t && (e[t.name + "Input"] = t);
          }
        };
      }
    }, {
      key: "valueType",
      get: function get() {
        return E(this.props.maxDetail);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function value(e, t) {
        var a = e.minDate,
            n = e.maxDate,
            r = e.maxDetail,
            l = {};
        e.isCalendarOpen !== t.isCalendarOpen && (l.isCalendarOpen = e.isCalendarOpen);
        var o = b(e.value, a, n, r),
            c = [o, t.value];
        return (l.isCalendarOpen || g.apply(void 0, p(c.map(function (e) {
          return b(e, a, n, r);
        }))) || g.apply(void 0, p(c.map(function (e) {
          return z(e, a, n, r);
        })))) && (o ? (l.year = (0, dates$2.getYear)(o), l.month = (0, dates$2.getMonth)(o), l.day = (0, dates$2.getDay)(o)) : (l.year = null, l.month = null, l.day = null), l.value = o), l;
      }
    }]), t;
  }();

  t.default = C, C.defaultProps = {
    maxDetail: "month",
    name: "date",
    returnValue: "start"
  }, C.propTypes = {
    disabled: l.default.bool,
    isCalendarOpen: l.default.bool,
    locale: l.default.string,
    maxDate: propTypes$2.isMaxDate,
    maxDetail: l.default.oneOf(_),
    minDate: propTypes$2.isMinDate,
    name: l.default.string,
    onChange: l.default.func,
    returnValue: l.default.oneOf(["start", "end"]),
    required: l.default.bool,
    showLeadingZeros: l.default.bool,
    value: l.default.oneOfType([l.default.string, l.default.instanceOf(Date)])
  }, (0, _reactLifecyclesCompat.polyfill)(C);
});
unwrapExports(DateInput_1);
var DatePicker_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = function () {
    return function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var a = [],
            n = !0,
            r = !1,
            l = void 0;

        try {
          for (var o, c = e[Symbol.iterator](); !(n = (o = c.next()).done) && (a.push(o.value), !t || a.length !== t); n = !0) {
            ;
          }
        } catch (e) {
          r = !0, l = e;
        } finally {
          try {
            !n && c.return && c.return();
          } finally {
            if (r) throw l;
          }
        }

        return a;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
  }(),
      r = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }(),
      l = f(React__default),
      o = f(PropTypes),
      c = f(entry),
      i = f(entry$2),
      s = f(entry_nostyle),
      u = f(DateInput_1);

  function f(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function d(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  }

  var p = function (e) {
    function t() {
      var e, a, n;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      for (var r = arguments.length, l = Array(r), o = 0; o < r; o++) {
        l[o] = arguments[o];
      }

      return a = n = d(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), n.state = {}, n.onClick = function (e) {
        n.wrapper && !n.wrapper.contains(e.target) && n.closeCalendar();
      }, n.openCalendar = function () {
        n.setState({
          isOpen: !0
        });
      }, n.closeCalendar = function () {
        n.setState({
          isOpen: !1
        });
      }, n.toggleCalendar = function () {
        n.setState(function (e) {
          return {
            isOpen: !e.isOpen
          };
        });
      }, n.onChange = function (e) {
        var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
        n.setState({
          isOpen: !t
        });
        var a = n.props.onChange;
        a && a(e);
      }, n.onFocus = function () {
        n.props.disabled || n.openCalendar();
      }, n.stopPropagation = function (e) {
        return e.stopPropagation();
      }, n.clear = function () {
        return n.onChange(null);
      }, d(n, a);
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, React__default.PureComponent), r(t, [{
      key: "componentDidMount",
      value: function value() {
        document.addEventListener("mousedown", this.onClick);
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        document.removeEventListener("mousedown", this.onClick);
      }
    }, {
      key: "renderInputs",
      value: function value() {
        var e = this.props.disabled,
            t = [].concat(this.props.value),
            a = n(t, 1)[0];
        return l.default.createElement("div", {
          className: "react-date-picker__button"
        }, l.default.createElement(u.default, {
          disabled: e,
          locale: this.props.locale,
          isCalendarOpen: this.state.isOpen,
          maxDate: this.props.maxDate,
          maxDetail: this.props.maxDetail,
          minDate: this.props.minDate,
          name: this.props.name,
          onChange: this.onChange,
          returnValue: this.props.returnValue,
          required: this.props.required,
          showLeadingZeros: this.props.showLeadingZeros,
          value: a
        }), null !== this.props.clearIcon && l.default.createElement("button", {
          className: "react-date-picker__clear-button react-date-picker__button__icon",
          disabled: e,
          onClick: this.clear,
          onFocus: this.stopPropagation,
          type: "button"
        }, this.props.clearIcon), null !== this.props.calendarIcon && l.default.createElement("button", {
          className: "react-date-picker__calendar-button react-date-picker__button__icon",
          disabled: e,
          onClick: this.toggleCalendar,
          onFocus: this.stopPropagation,
          onBlur: this.resetValue,
          type: "button"
        }, this.props.calendarIcon));
      }
    }, {
      key: "renderCalendar",
      value: function value() {
        var e = this,
            t = this.state.isOpen;
        if (null === t) return null;

        var n = this.props,
            r = n.calendarClassName,
            o = (n.className, n.onChange, n.value),
            u = function (e, t) {
          var a = {};

          for (var n in e) {
            t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
          }

          return a;
        }(n, ["calendarClassName", "className", "onChange", "value"]),
            f = "react-date-picker__calendar";

        return l.default.createElement("div", {
          className: (0, c.default)(f, f + "--" + (t ? "open" : "closed")),
          ref: function ref(a) {
            if (a && t) {
              a.classList.remove(f + "--above-label");
              var n = (0, i.default)(a, document.body);
              if (n.collidedBottom) n.overflowTop + a.clientHeight + e.wrapper.clientHeight < n.overflowBottom && a.classList.add(f + "--above-label");
            }
          }
        }, l.default.createElement(s.default, a({
          className: r,
          onChange: this.onChange,
          value: o || null
        }, u)));
      }
    }, {
      key: "render",
      value: function value() {
        var e = this;
        return l.default.createElement("div", {
          className: (0, c.default)("react-date-picker", "react-date-picker--" + (this.state.isOpen ? "open" : "closed"), "react-date-picker--" + (this.props.disabled ? "disabled" : "enabled"), this.props.className),
          onFocus: this.onFocus,
          ref: function ref(t) {
            t && (e.wrapper = t);
          }
        }, this.renderInputs(), this.renderCalendar());
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function value(e, t) {
        return e.isOpen !== t.isOpenProps ? {
          isOpen: e.isOpen,
          isOpenProps: e.isOpen
        } : null;
      }
    }]), t;
  }();

  t.default = p;
  var h = l.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "19",
    height: "19",
    viewBox: "0 0 19 19"
  }, l.default.createElement("g", {
    stroke: "black",
    strokeWidth: "2"
  }, l.default.createElement("rect", {
    width: "15",
    height: "15",
    x: "2",
    y: "2",
    fill: "none"
  }), l.default.createElement("line", {
    x1: "6",
    y1: "0",
    x2: "6",
    y2: "4"
  }), l.default.createElement("line", {
    x1: "13",
    y1: "0",
    x2: "13",
    y2: "4"
  }))),
      m = l.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "19",
    height: "19",
    viewBox: "0 0 19 19"
  }, l.default.createElement("g", {
    stroke: "black",
    strokeWidth: "2"
  }, l.default.createElement("line", {
    x1: "4",
    y1: "4",
    x2: "15",
    y2: "15"
  }), l.default.createElement("line", {
    x1: "15",
    y1: "4",
    x2: "4",
    y2: "15"
  })));
  p.defaultProps = {
    calendarIcon: h,
    clearIcon: m,
    isOpen: null,
    returnValue: "start"
  }, p.propTypes = a({}, s.default.propTypes, {
    calendarClassName: o.default.oneOfType([o.default.string, o.default.arrayOf(o.default.string)]),
    calendarIcon: o.default.node,
    className: o.default.oneOfType([o.default.string, o.default.arrayOf(o.default.string)]),
    clearIcon: o.default.node,
    disabled: o.default.bool,
    isOpen: o.default.bool,
    name: o.default.string,
    returnValue: o.default.oneOf(["start", "end"]),
    required: o.default.bool,
    showLeadingZeros: o.default.bool
  }), (0, _reactLifecyclesCompat.polyfill)(p);
});
unwrapExports(DatePicker_1);

var entry$4 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
      n = (a = DatePicker_1) && a.__esModule ? a : {
    default: a
  };
  t.default = n.default;
}),
    Datepicker = unwrapExports(entry$4),
    _templateObject$7 = taggedTemplateLiteral(["\n\tfill: ", ";\n\twidth: 0.75em;\n\theight: 1.5em;\n"], ["\n\tfill: ", ";\n\twidth: 0.75em;\n\theight: 1.5em;\n"]),
    _templateObject2$4 = taggedTemplateLiteral(["\n\tfont-size: 1.2rem;\n\tcolor: ", ";\n\tdisplay: inline-flex;\n\tposition: relative;\n\t/* Baseline */\n\t& *,\n\t& *:before,\n\t& *:after {\n\t\t-moz-box-sizing: border-box;\n\t\t-webkit-box-sizing: border-box;\n\t\tbox-sizing: border-box;\n\t}\n\t.react-date-picker--disabled {\n\t\tbackground-color: #f0f0f0;\n\t\tcolor: #6d6d6d;\n\t}\n\t.react-date-picker__button {\n\t\tdisplay: flex;\n\t\tborder: thin solid gray;\n\t}\n\t.react-date-picker__button__input {\n\t\tmin-width: calc(4px + (4px * 3) + 4.32em + 0.434em);\n\t\tflex-grow: 1;\n\t\tdisplay: flex;\n\t\tpadding: 0 2px;\n\t\talign-items: baseline;\n\t}\n\t.react-date-picker__button__input__divider {\n\t\tpadding: 1px 0;\n\t}\n\t.react-date-picker__button__input__input {\n\t\tmin-width: calc(4px + 0.54em);\n\t\theight: 100%;\n\t\tposition: relative;\n\t\tpadding: 1px;\n\t\tborder: 0;\n\t\tbackground: none;\n\t\t-moz-appearance: textfield;\n\t}\n\t.react-date-picker__button__input__input::-webkit-outer-spin-button,\n\t.react-date-picker__button__input__input::-webkit-inner-spin-button {\n\t\t-webkit-appearance: none;\n\t\tmargin: 0;\n\t}\n\t.react-date-picker__button__input__input:invalid {\n\t\tbackground: rgba(255, 0, 0, 0.1);\n\t}\n\t.react-date-picker__button__input__input--hasLeadingZero {\n\t\tmin-width: calc(4px + 1.08em);\n\t\tmargin-left: -0.54em;\n\t\tpadding-left: calc(1px + 0.54em);\n\t}\n\t.react-date-picker__button__icon {\n\t\tborder: 0;\n\t\tbackground: transparent;\n\t\tpadding: 4px 6px;\n\t}\n\t.react-date-picker__button__icon:enabled {\n\t\tcursor: pointer;\n\t}\n\t.react-date-picker__button__icon:enabled:hover svg g,\n\t.react-date-picker__button__icon:enabled:focus svg g {\n\t\tstroke: #0078d7;\n\t}\n\t.react-date-picker__button__icon:disabled svg g {\n\t\tstroke: #6d6d6d;\n\t}\n\t.react-date-picker__button__icon svg {\n\t\tdisplay: inherit;\n\t}\n\t.react-date-picker__calendar {\n\t\twidth: 350px;\n\t\tmax-width: 100vw;\n\t\tposition: absolute;\n\t\ttop: 100%;\n\t\tleft: 0;\n\t\tz-index: 1;\n\t}\n\t.react-date-picker__calendar--closed {\n\t\tdisplay: none;\n\t}\n\t.react-date-picker__calendar--above-label {\n\t\tbottom: 100%;\n\t\ttop: auto;\n\t}\n\t.react-date-picker__calendar .react-calendar {\n\t\tborder-width: thin;\n\t}\n\n\t/* Overrides */\n\t.react-calendar__navigation {\n\t\tborder-bottom: 1px solid #f0f1f2;\n\t}\n\t.react-date-picker__calendar--above-label {\n\t\tbottom: auto;\n\t\ttop: 100%;\n\t}\n\t.react-date-picker__calendar {\n\t\twidth: 22.5em;\n\t}\n\t.react-date-picker__calendar .react-calendar {\n\t\tborder-width: 1px;\n\t\tborder-radius: 0.5em;\n\t\tbackground: white;\n\t}\n\t.react-calendar__month-view__weekdays {\n\t\tfont-size: 1em;\n\t}\n\t.react-calendar__tile--active {\n\t\tbackground: none;\n\t\tborder: 1px solid ", ";\n\t}\n\t.react-calendar__month-view {\n\t\tpadding: 0 1.25em 0.5em;\n\t}\n\t.react-date-picker__button {\n\t\twidth: 10em;\n\t\theight: 3em;\n\t\tborder: 1px solid ", ";\n\t\tborder-radius: 0.5em;\n\t\tpadding: 0.25em 0.5em;\n\t}\n\t.react-date-picker__button__input__input {\n\t\ttext-align: center;\n\t}\n\t.react-calendar__month-view__weekdays__weekday {\n\t\tfont-size: 1em;\n\t\ttext-transform: none;\n\t\tcolor: ", ";\n\t\tfont-weight: 600;\n\t}\n\t.react-calendar {\n\t\tborder: 1px solid ", ";\n\t}\n\t.react-calendar button {\n\t\tcolor: ", ";\n\t\tfont-size: inherit;\n\t\tfont-weight: 600;\n\t\tborder: 0 none;\n\t\tbackground: none;\n\t\tcursor: pointer;\n\t}\n"], ["\n\tfont-size: 1.2rem;\n\tcolor: ", ";\n\tdisplay: inline-flex;\n\tposition: relative;\n\t/* Baseline */\n\t& *,\n\t& *:before,\n\t& *:after {\n\t\t-moz-box-sizing: border-box;\n\t\t-webkit-box-sizing: border-box;\n\t\tbox-sizing: border-box;\n\t}\n\t.react-date-picker--disabled {\n\t\tbackground-color: #f0f0f0;\n\t\tcolor: #6d6d6d;\n\t}\n\t.react-date-picker__button {\n\t\tdisplay: flex;\n\t\tborder: thin solid gray;\n\t}\n\t.react-date-picker__button__input {\n\t\tmin-width: calc(4px + (4px * 3) + 4.32em + 0.434em);\n\t\tflex-grow: 1;\n\t\tdisplay: flex;\n\t\tpadding: 0 2px;\n\t\talign-items: baseline;\n\t}\n\t.react-date-picker__button__input__divider {\n\t\tpadding: 1px 0;\n\t}\n\t.react-date-picker__button__input__input {\n\t\tmin-width: calc(4px + 0.54em);\n\t\theight: 100%;\n\t\tposition: relative;\n\t\tpadding: 1px;\n\t\tborder: 0;\n\t\tbackground: none;\n\t\t-moz-appearance: textfield;\n\t}\n\t.react-date-picker__button__input__input::-webkit-outer-spin-button,\n\t.react-date-picker__button__input__input::-webkit-inner-spin-button {\n\t\t-webkit-appearance: none;\n\t\tmargin: 0;\n\t}\n\t.react-date-picker__button__input__input:invalid {\n\t\tbackground: rgba(255, 0, 0, 0.1);\n\t}\n\t.react-date-picker__button__input__input--hasLeadingZero {\n\t\tmin-width: calc(4px + 1.08em);\n\t\tmargin-left: -0.54em;\n\t\tpadding-left: calc(1px + 0.54em);\n\t}\n\t.react-date-picker__button__icon {\n\t\tborder: 0;\n\t\tbackground: transparent;\n\t\tpadding: 4px 6px;\n\t}\n\t.react-date-picker__button__icon:enabled {\n\t\tcursor: pointer;\n\t}\n\t.react-date-picker__button__icon:enabled:hover svg g,\n\t.react-date-picker__button__icon:enabled:focus svg g {\n\t\tstroke: #0078d7;\n\t}\n\t.react-date-picker__button__icon:disabled svg g {\n\t\tstroke: #6d6d6d;\n\t}\n\t.react-date-picker__button__icon svg {\n\t\tdisplay: inherit;\n\t}\n\t.react-date-picker__calendar {\n\t\twidth: 350px;\n\t\tmax-width: 100vw;\n\t\tposition: absolute;\n\t\ttop: 100%;\n\t\tleft: 0;\n\t\tz-index: 1;\n\t}\n\t.react-date-picker__calendar--closed {\n\t\tdisplay: none;\n\t}\n\t.react-date-picker__calendar--above-label {\n\t\tbottom: 100%;\n\t\ttop: auto;\n\t}\n\t.react-date-picker__calendar .react-calendar {\n\t\tborder-width: thin;\n\t}\n\n\t/* Overrides */\n\t.react-calendar__navigation {\n\t\tborder-bottom: 1px solid #f0f1f2;\n\t}\n\t.react-date-picker__calendar--above-label {\n\t\tbottom: auto;\n\t\ttop: 100%;\n\t}\n\t.react-date-picker__calendar {\n\t\twidth: 22.5em;\n\t}\n\t.react-date-picker__calendar .react-calendar {\n\t\tborder-width: 1px;\n\t\tborder-radius: 0.5em;\n\t\tbackground: white;\n\t}\n\t.react-calendar__month-view__weekdays {\n\t\tfont-size: 1em;\n\t}\n\t.react-calendar__tile--active {\n\t\tbackground: none;\n\t\tborder: 1px solid ", ";\n\t}\n\t.react-calendar__month-view {\n\t\tpadding: 0 1.25em 0.5em;\n\t}\n\t.react-date-picker__button {\n\t\twidth: 10em;\n\t\theight: 3em;\n\t\tborder: 1px solid ", ";\n\t\tborder-radius: 0.5em;\n\t\tpadding: 0.25em 0.5em;\n\t}\n\t.react-date-picker__button__input__input {\n\t\ttext-align: center;\n\t}\n\t.react-calendar__month-view__weekdays__weekday {\n\t\tfont-size: 1em;\n\t\ttext-transform: none;\n\t\tcolor: ", ";\n\t\tfont-weight: 600;\n\t}\n\t.react-calendar {\n\t\tborder: 1px solid ", ";\n\t}\n\t.react-calendar button {\n\t\tcolor: ", ";\n\t\tfont-size: inherit;\n\t\tfont-weight: 600;\n\t\tborder: 0 none;\n\t\tbackground: none;\n\t\tcursor: pointer;\n\t}\n"]),
    StyledCaret = styled__default(Caret)(_templateObject$7, function (e) {
  return e.theme.neutralDark[4];
}),
    StyledDatepicker = styled__default(Datepicker).attrs({
  calendarIcon: React__default.createElement(StyledCaret, null)
})(_templateObject2$4, function (e) {
  return e.theme.neutralDark[4];
}, function (e) {
  return e.theme.primary[2];
}, function (e) {
  return e.theme.neutralLight[4];
}, function (e) {
  return e.theme.primary[2];
}, function (e) {
  return e.theme.neutralLight[4];
}, function (e) {
  return e.theme.neutralDark[4];
}),
    classnames = createCommonjsModule(function (e) {
  !function () {
    var t = {}.hasOwnProperty;

    function a() {
      for (var e = [], n = 0; n < arguments.length; n++) {
        var r = arguments[n];

        if (r) {
          var l = typeof r;
          if ("string" === l || "number" === l) e.push(r);else if (Array.isArray(r)) e.push(a.apply(null, r));else if ("object" === l) for (var o in r) {
            t.call(r, o) && r[o] && e.push(o);
          }
        }
      }

      return e.join(" ");
    }

    e.exports ? e.exports = a : window.classNames = a;
  }();
}),
    check = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
      n = (a = React__default) && a.__esModule ? a : {
    default: a
  };

  t.default = function () {
    return n.default.createElement("svg", {
      width: "14",
      height: "11",
      viewBox: "0 0 14 11"
    }, n.default.createElement("title", null, "switch-check"), n.default.createElement("path", {
      d: "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",
      fill: "#fff",
      fillRule: "evenodd"
    }));
  };
});

unwrapExports(check);
var x = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
      n = (a = React__default) && a.__esModule ? a : {
    default: a
  };

  t.default = function () {
    return n.default.createElement("svg", {
      width: "10",
      height: "10",
      viewBox: "0 0 10 10"
    }, n.default.createElement("title", null, "switch-x"), n.default.createElement("path", {
      d: "M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",
      fill: "#fff",
      fillRule: "evenodd"
    }));
  };
});
unwrapExports(x);
var util = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.pointerCoord = function (e) {
    if (e) {
      var t = e.changedTouches;

      if (t && t.length > 0) {
        var a = t[0];
        return {
          x: a.clientX,
          y: a.clientY
        };
      }

      var n = e.pageX;
      if (void 0 !== n) return {
        x: n,
        y: e.pageY
      };
    }

    return {
      x: 0,
      y: 0
    };
  };
});
unwrapExports(util);

for (var util_1 = util.pointerCoord, component = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, ("value" in n) && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }(),
      r = s(React__default),
      l = s(classnames),
      o = s(PropTypes),
      c = s(check),
      i = s(x);

  function s(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var u = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var a = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

      return a.handleClick = a.handleClick.bind(a), a.handleTouchStart = a.handleTouchStart.bind(a), a.handleTouchMove = a.handleTouchMove.bind(a), a.handleTouchEnd = a.handleTouchEnd.bind(a), a.handleFocus = a.handleFocus.bind(a), a.handleBlur = a.handleBlur.bind(a), a.previouslyChecked = !(!e.checked && !e.defaultChecked), a.state = {
        checked: !(!e.checked && !e.defaultChecked),
        hasFocus: !1
      }, a;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, React__default.PureComponent), n(t, [{
      key: "componentWillReceiveProps",
      value: function value(e) {
        ("checked" in e) && this.setState({
          checked: !!e.checked
        });
      }
    }, {
      key: "handleClick",
      value: function value(e) {
        var t = this.input;
        if (e.target !== t && !this.moved) return this.previouslyChecked = t.checked, e.preventDefault(), t.focus(), void t.click();
        var a = this.props.hasOwnProperty("checked") ? this.props.checked : t.checked;
        this.setState({
          checked: a
        });
      }
    }, {
      key: "handleTouchStart",
      value: function value(e) {
        this.startX = (0, util.pointerCoord)(e).x, this.activated = !0;
      }
    }, {
      key: "handleTouchMove",
      value: function value(e) {
        if (this.activated && (this.moved = !0, this.startX)) {
          var t = (0, util.pointerCoord)(e).x;
          this.state.checked && t + 15 < this.startX ? (this.setState({
            checked: !1
          }), this.startX = t, this.activated = !0) : t - 15 > this.startX && (this.setState({
            checked: !0
          }), this.startX = t, this.activated = t < this.startX + 5);
        }
      }
    }, {
      key: "handleTouchEnd",
      value: function value(e) {
        if (this.moved) {
          var t = this.input;

          if (e.preventDefault(), this.startX) {
            var a = (0, util.pointerCoord)(e).x;
            !0 === this.previouslyChecked && this.startX + 4 > a ? this.previouslyChecked !== this.state.checked && (this.setState({
              checked: !1
            }), this.previouslyChecked = this.state.checked, t.click()) : this.startX - 4 < a && this.previouslyChecked !== this.state.checked && (this.setState({
              checked: !0
            }), this.previouslyChecked = this.state.checked, t.click()), this.activated = !1, this.startX = null, this.moved = !1;
          }
        }
      }
    }, {
      key: "handleFocus",
      value: function value(e) {
        var t = this.props.onFocus;
        t && t(e), this.setState({
          hasFocus: !0
        });
      }
    }, {
      key: "handleBlur",
      value: function value(e) {
        var t = this.props.onBlur;
        t && t(e), this.setState({
          hasFocus: !1
        });
      }
    }, {
      key: "getIcon",
      value: function value(e) {
        var a = this.props.icons;
        return a ? void 0 === a[e] ? t.defaultProps.icons[e] : a[e] : null;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
            t = this.props,
            n = t.className,
            o = (t.icons, function (e, t) {
          var a = {};

          for (var n in e) {
            t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
          }

          return a;
        }(t, ["className", "icons"])),
            c = (0, l.default)("react-toggle", {
          "react-toggle--checked": this.state.checked,
          "react-toggle--focus": this.state.hasFocus,
          "react-toggle--disabled": this.props.disabled
        }, n);
        return r.default.createElement("div", {
          className: c,
          onClick: this.handleClick,
          onTouchStart: this.handleTouchStart,
          onTouchMove: this.handleTouchMove,
          onTouchEnd: this.handleTouchEnd
        }, r.default.createElement("div", {
          className: "react-toggle-track"
        }, r.default.createElement("div", {
          className: "react-toggle-track-check"
        }, this.getIcon("checked")), r.default.createElement("div", {
          className: "react-toggle-track-x"
        }, this.getIcon("unchecked"))), r.default.createElement("div", {
          className: "react-toggle-thumb"
        }), r.default.createElement("input", a({}, o, {
          ref: function ref(t) {
            e.input = t;
          },
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          className: "react-toggle-screenreader-only",
          type: "checkbox"
        })));
      }
    }]), t;
  }();

  t.default = u, u.displayName = "Toggle", u.defaultProps = {
    icons: {
      checked: r.default.createElement(c.default, null),
      unchecked: r.default.createElement(i.default, null)
    }
  }, u.propTypes = {
    checked: o.default.bool,
    disabled: o.default.bool,
    defaultChecked: o.default.bool,
    onChange: o.default.func,
    onFocus: o.default.func,
    onBlur: o.default.func,
    className: o.default.string,
    name: o.default.string,
    value: o.default.string,
    id: o.default.string,
    "aria-labelledby": o.default.string,
    "aria-label": o.default.string,
    icons: o.default.oneOfType([o.default.bool, o.default.shape({
      checked: o.default.node,
      unchecked: o.default.node
    })])
  };
}), Toggle = unwrapExports(component), _templateObject$8 = taggedTemplateLiteral(["\n\ttouch-action: pan-x;\n\tdisplay: inline-block;\n\tposition: relative;\n\tcursor: pointer;\n\tbackground-color: transparent;\n\tborder: 0;\n\tpadding: 0;\n\tuser-select: none;\n\t-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n\t-webkit-tap-highlight-color: transparent;\n\t&.react-toggle--checked .react-toggle-track {\n\t\tbackground-color: ", ";\n\t}\n\t&.react-toggle--checked .react-toggle-track-x {\n\t\topacity: 0;\n\t}\n\t&.react-toggle--checked .react-toggle-thumb {\n\t\tleft: 33px;\n\t}\n\t&.react-toggle--disabled {\n\t\tcursor: not-allowed;\n\t\topacity: 0.5;\n\t\ttransition: opacity 0.25s;\n\t}\n\t&.react-toggle--focus .react-toggle-track {\n\t\tbox-shadow: ", ";\n\t}\n\t.react-toggle-screenreader-only {\n\t\tborder: 0;\n\t\tclip: rect(0 0 0 0);\n\t\theight: 1px;\n\t\tmargin: -1px;\n\t\toverflow: hidden;\n\t\tpadding: 0;\n\t\tposition: absolute;\n\t\twidth: 1px;\n\t}\n\t.react-toggle-thumb {\n\t\ttransition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n\t\tposition: absolute;\n\t\ttop: 2px;\n\t\tleft: 2px;\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tborder-radius: 50%;\n\t\tbackground-color: #fafafa;\n\t\tbox-sizing: border-box;\n\t\ttransition: all 0.25s ease;\n\t}\n\t.react-toggle-track {\n\t\twidth: 60px;\n\t\theight: 28px;\n\t\tpadding: 0;\n\t\tborder-radius: 30px;\n\t\tbackground-color: ", ";\n\t\ttransition: all 0.2s ease;\n\t}\n\t.react-toggle--checked .react-toggle-track-check {\n\t\topacity: 1;\n\t\ttransition: opacity 0.25s ease;\n\t}\n\t.react-toggle-track-check {\n\t\tposition: absolute;\n\t\twidth: 14px;\n\t\theight: 10px;\n\t\ttop: 0px;\n\t\tbottom: 0px;\n\t\tmargin-top: auto;\n\t\tmargin-bottom: auto;\n\t\tline-height: 0;\n\t\tleft: 8px;\n\t\topacity: 0;\n\t\ttransition: opacity 0.25s ease;\n\t}\n\t.react-toggle-track-x {\n\t\tposition: absolute;\n\t\twidth: 10px;\n\t\theight: 10px;\n\t\ttop: 0px;\n\t\tbottom: 0px;\n\t\tmargin-top: auto;\n\t\tmargin-bottom: auto;\n\t\tline-height: 0;\n\t\tright: 10px;\n\t\topacity: 1;\n\t\ttransition: opacity 0.25s ease;\n\t}\n"], ["\n\ttouch-action: pan-x;\n\tdisplay: inline-block;\n\tposition: relative;\n\tcursor: pointer;\n\tbackground-color: transparent;\n\tborder: 0;\n\tpadding: 0;\n\tuser-select: none;\n\t-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n\t-webkit-tap-highlight-color: transparent;\n\t&.react-toggle--checked .react-toggle-track {\n\t\tbackground-color: ", ";\n\t}\n\t&.react-toggle--checked .react-toggle-track-x {\n\t\topacity: 0;\n\t}\n\t&.react-toggle--checked .react-toggle-thumb {\n\t\tleft: 33px;\n\t}\n\t&.react-toggle--disabled {\n\t\tcursor: not-allowed;\n\t\topacity: 0.5;\n\t\ttransition: opacity 0.25s;\n\t}\n\t&.react-toggle--focus .react-toggle-track {\n\t\tbox-shadow: ", ";\n\t}\n\t.react-toggle-screenreader-only {\n\t\tborder: 0;\n\t\tclip: rect(0 0 0 0);\n\t\theight: 1px;\n\t\tmargin: -1px;\n\t\toverflow: hidden;\n\t\tpadding: 0;\n\t\tposition: absolute;\n\t\twidth: 1px;\n\t}\n\t.react-toggle-thumb {\n\t\ttransition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n\t\tposition: absolute;\n\t\ttop: 2px;\n\t\tleft: 2px;\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tborder-radius: 50%;\n\t\tbackground-color: #fafafa;\n\t\tbox-sizing: border-box;\n\t\ttransition: all 0.25s ease;\n\t}\n\t.react-toggle-track {\n\t\twidth: 60px;\n\t\theight: 28px;\n\t\tpadding: 0;\n\t\tborder-radius: 30px;\n\t\tbackground-color: ", ";\n\t\ttransition: all 0.2s ease;\n\t}\n\t.react-toggle--checked .react-toggle-track-check {\n\t\topacity: 1;\n\t\ttransition: opacity 0.25s ease;\n\t}\n\t.react-toggle-track-check {\n\t\tposition: absolute;\n\t\twidth: 14px;\n\t\theight: 10px;\n\t\ttop: 0px;\n\t\tbottom: 0px;\n\t\tmargin-top: auto;\n\t\tmargin-bottom: auto;\n\t\tline-height: 0;\n\t\tleft: 8px;\n\t\topacity: 0;\n\t\ttransition: opacity 0.25s ease;\n\t}\n\t.react-toggle-track-x {\n\t\tposition: absolute;\n\t\twidth: 10px;\n\t\theight: 10px;\n\t\ttop: 0px;\n\t\tbottom: 0px;\n\t\tmargin-top: auto;\n\t\tmargin-bottom: auto;\n\t\tline-height: 0;\n\t\tright: 10px;\n\t\topacity: 1;\n\t\ttransition: opacity 0.25s ease;\n\t}\n"]), StyledToggle = styled__default(Toggle).attrs({
  icons: !1
})(_templateObject$8, function (e) {
  return e.theme.accent[2];
}, function (e) {
  return e.theme.focusShadowA;
}, function (e) {
  return e.theme.neutralLight[1];
}), _templateObject$9 = taggedTemplateLiteral(["\n\tfont-size: 1em;\n\tborder-radius: 0.5em;\n\tborder: 1px solid ", ";\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tfont-family: ", ";\n\tmargin-right: 0.25em;\n\tpadding: 0.6em 0.9em;\n\t", ";\n\t&:focus {\n\t\toutline: none;\n\t\tborder-color: transparent;\n\t\tbox-shadow: 0 0 0 2px ", ";\n\t}\n\t&:disabled {\n\t\tcolor: ", ";\n\t}\n"], ["\n\tfont-size: 1em;\n\tborder-radius: 0.5em;\n\tborder: 1px solid ", ";\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tfont-family: ", ";\n\tmargin-right: 0.25em;\n\tpadding: 0.6em 0.9em;\n\t", ";\n\t&:focus {\n\t\toutline: none;\n\t\tborder-color: transparent;\n\t\tbox-shadow: 0 0 0 2px ", ";\n\t}\n\t&:disabled {\n\t\tcolor: ", ";\n\t}\n"]), TextInput = styled__default.input(_templateObject$9, function (e) {
  return e.theme.neutralLight[4];
}, function (e) {
  return e.theme.neutralLight[7];
}, function (e) {
  return e.theme.neutralDark[2];
}, function (e) {
  return e.theme.fontFamily;
}, function (e) {
  var t = e.invalid,
      a = e.theme;
  return t ? "border-color: transparent; box-shadow: 0 0 0 2px " + a.danger[2] : "";
}, function (e) {
  return e.theme.primary[2];
}, function (e) {
  return e.theme.neutralLight[3];
}), _templateObject$10 = taggedTemplateLiteral(["\n\tfont-family: ", ";\n\tfont-size: 1em;\n\twhite-space: nowrap;\n"], ["\n\tfont-family: ", ";\n\tfont-size: 1em;\n\twhite-space: nowrap;\n"]), _templateObject2$5 = taggedTemplateLiteral(["\n\tfont-size: 1em;\n\tdisplay: inline-block;\n\tborder-width: 0 0 1px 0;\n\tbackground: transparent;\n\tcolor: ", ";\n\tfont-family: ", ";\n\tmargin-right: 0.25em;\n"], ["\n\tfont-size: 1em;\n\tdisplay: inline-block;\n\tborder-width: 0 0 1px 0;\n\tbackground: transparent;\n\tcolor: ", ";\n\tfont-family: ", ";\n\tmargin-right: 0.25em;\n"]), _templateObject3$1 = taggedTemplateLiteral(["\n\tfont-size: 1em;\n\theight: 1em;\n\twidth: 1em;\n\tfill: ", ";\n"], ["\n\tfont-size: 1em;\n\theight: 1em;\n\twidth: 1em;\n\tfill: ", ";\n"]), _templateObject4$1 = taggedTemplateLiteral([""], [""]), StyledParent = styled__default.span(_templateObject$10, function (e) {
  return e.theme.fontFamily;
}), StyledInput = styled__default.input(_templateObject2$5, function (e) {
  return e.theme.neutralDark[3];
}, function (e) {
  return e.theme.fontFamily;
}), StyledIcon = styled__default(PencilIcon)(_templateObject3$1, function (e) {
  return e.theme.neutralLight[1];
}), LineInput = function LineInput(e) {
  var t = e.Pencil;
  objectWithoutProperties(e, ["Pencil"]);
  return React__default.createElement(StyledParent, null, React__default.createElement(StyledInput, e), void 0 === t ? React__default.createElement(StyledIcon, null) : React__default.createElement(t, null));
}, TextInputLine = styled__default(LineInput)(_templateObject4$1), performanceNow = createCommonjsModule(function (e) {
  (function () {
    var t, a, n, r, l, o;
    "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function () {
      return performance.now();
    } : "undefined" != typeof process && null !== process && process.hrtime ? (e.exports = function () {
      return (t() - l) / 1e6;
    }, a = process.hrtime, r = (t = function t() {
      var e;
      return 1e9 * (e = a())[0] + e[1];
    })(), o = 1e9 * process.uptime(), l = r - o) : Date.now ? (e.exports = function () {
      return Date.now() - n;
    }, n = Date.now()) : (e.exports = function () {
      return new Date().getTime() - n;
    }, n = new Date().getTime());
  }).call(commonjsGlobal);
}), root = "undefined" == typeof window ? commonjsGlobal : window, vendors = ["moz", "webkit"], suffix = "AnimationFrame", raf = root["request" + suffix], caf = root["cancel" + suffix] || root["cancelRequest" + suffix], i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + "Request" + suffix], caf = root[vendors[i] + "Cancel" + suffix] || root[vendors[i] + "CancelRequest" + suffix];
}

if (!raf || !caf) {
  var last = 0,
      id = 0,
      queue = [],
      frameDuration = 1e3 / 60;
  raf = function raf(e) {
    if (0 === queue.length) {
      var t = performanceNow(),
          a = Math.max(0, frameDuration - (t - last));
      last = a + t, setTimeout(function () {
        var e = queue.slice(0);
        queue.length = 0;

        for (var t = 0; t < e.length; t++) {
          if (!e[t].cancelled) try {
            e[t].callback(last);
          } catch (e) {
            setTimeout(function () {
              throw e;
            }, 0);
          }
        }
      }, Math.round(a));
    }

    return queue.push({
      handle: ++id,
      callback: e,
      cancelled: !1
    }), id;
  }, caf = function caf(e) {
    for (var t = 0; t < queue.length; t++) {
      queue[t].handle === e && (queue[t].cancelled = !0);
    }
  };
}

var raf_1 = function raf_1(e) {
  return raf.call(root, e);
},
    cancel = function cancel() {
  caf.apply(root, arguments);
},
    polyfill$1 = function polyfill$1(e) {
  e || (e = root), e.requestAnimationFrame = raf, e.cancelAnimationFrame = caf;
};

function memoize(e) {
  var t = {};
  return function (a) {
    return void 0 === t[a] && (t[a] = e(a)), t[a];
  };
}

raf_1.cancel = cancel, raf_1.polyfill = polyfill$1;
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function murmurhash2_32_gc(e) {
  for (var t, a = e.length, n = a ^ a, r = 0; a >= 4;) {
    t = 1540483477 * (65535 & (t = 255 & e.charCodeAt(r) | (255 & e.charCodeAt(++r)) << 8 | (255 & e.charCodeAt(++r)) << 16 | (255 & e.charCodeAt(++r)) << 24)) + ((1540483477 * (t >>> 16) & 65535) << 16), n = 1540483477 * (65535 & n) + ((1540483477 * (n >>> 16) & 65535) << 16) ^ (t = 1540483477 * (65535 & (t ^= t >>> 24)) + ((1540483477 * (t >>> 16) & 65535) << 16)), a -= 4, ++r;
  }

  switch (a) {
    case 3:
      n ^= (255 & e.charCodeAt(r + 2)) << 16;

    case 2:
      n ^= (255 & e.charCodeAt(r + 1)) << 8;

    case 1:
      n = 1540483477 * (65535 & (n ^= 255 & e.charCodeAt(r))) + ((1540483477 * (n >>> 16) & 65535) << 16);
  }

  return n = 1540483477 * (65535 & (n ^= n >>> 13)) + ((1540483477 * (n >>> 16) & 65535) << 16), ((n ^= n >>> 15) >>> 0).toString(36);
}

var W = function e(t) {
  function a(e, t, a) {
    var r = t.trim().split(m);
    t = r;
    var l = r.length,
        o = e.length;

    switch (o) {
      case 0:
      case 1:
        var c = 0;

        for (e = 0 === o ? "" : e[0] + " "; c < l; ++c) {
          t[c] = n(e, t[c], a).trim();
        }

        break;

      default:
        var i = c = 0;

        for (t = []; c < l; ++c) {
          for (var s = 0; s < o; ++s) {
            t[i++] = n(e[s] + " ", r[c], a).trim();
          }
        }

    }

    return t;
  }

  function n(e, t, a) {
    var n = t.charCodeAt(0);

    switch (33 > n && (n = (t = t.trim()).charCodeAt(0)), n) {
      case 38:
        return t.replace(_, "$1" + e.trim());

      case 58:
        return e.trim() + t.replace(_, "$1" + e.trim());

      default:
        if (0 < 1 * a && 0 < t.indexOf("\f")) return t.replace(_, (58 === e.charCodeAt(0) ? "" : "$1") + e.trim());
    }

    return e + t;
  }

  function r(e, t, a, n) {
    var o = e + ";",
        c = 2 * t + 3 * a + 4 * n;

    if (944 === c) {
      e = o.indexOf(":", 9) + 1;
      var i = o.substring(e, o.length - 1).trim();
      return i = o.substring(0, e).trim() + i + ";", 1 === T || 2 === T && l(i, 1) ? "-webkit-" + i + i : i;
    }

    if (0 === T || 2 === T && !l(o, 1)) return o;

    switch (c) {
      case 1015:
        return 97 === o.charCodeAt(10) ? "-webkit-" + o + o : o;

      case 951:
        return 116 === o.charCodeAt(3) ? "-webkit-" + o + o : o;

      case 963:
        return 110 === o.charCodeAt(5) ? "-webkit-" + o + o : o;

      case 1009:
        if (100 !== o.charCodeAt(4)) break;

      case 969:
      case 942:
        return "-webkit-" + o + o;

      case 978:
        return "-webkit-" + o + "-moz-" + o + o;

      case 1019:
      case 983:
        return "-webkit-" + o + "-moz-" + o + "-ms-" + o + o;

      case 883:
        if (45 === o.charCodeAt(8)) return "-webkit-" + o + o;
        if (0 < o.indexOf("image-set(", 11)) return o.replace(O, "$1-webkit-$2") + o;
        break;

      case 932:
        if (45 === o.charCodeAt(4)) switch (o.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + o.replace("-grow", "") + "-webkit-" + o + "-ms-" + o.replace("grow", "positive") + o;

          case 115:
            return "-webkit-" + o + "-ms-" + o.replace("shrink", "negative") + o;

          case 98:
            return "-webkit-" + o + "-ms-" + o.replace("basis", "preferred-size") + o;
        }
        return "-webkit-" + o + "-ms-" + o + o;

      case 964:
        return "-webkit-" + o + "-ms-flex-" + o + o;

      case 1023:
        if (99 !== o.charCodeAt(8)) break;
        return "-webkit-box-pack" + (i = o.substring(o.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify")) + "-webkit-" + o + "-ms-flex-pack" + i + o;

      case 1005:
        return p.test(o) ? o.replace(d, ":-webkit-") + o.replace(d, ":-moz-") + o : o;

      case 1e3:
        switch (t = (i = o.substring(13).trim()).indexOf("-") + 1, i.charCodeAt(0) + i.charCodeAt(t)) {
          case 226:
            i = o.replace(E, "tb");
            break;

          case 232:
            i = o.replace(E, "tb-rl");
            break;

          case 220:
            i = o.replace(E, "lr");
            break;

          default:
            return o;
        }

        return "-webkit-" + o + "-ms-" + i + o;

      case 1017:
        if (-1 === o.indexOf("sticky", 9)) break;

      case 975:
        switch (t = (o = e).length - 10, c = (i = (33 === o.charCodeAt(t) ? o.substring(0, t) : o).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | i.charCodeAt(7))) {
          case 203:
            if (111 > i.charCodeAt(8)) break;

          case 115:
            o = o.replace(i, "-webkit-" + i) + ";" + o;
            break;

          case 207:
          case 102:
            o = o.replace(i, "-webkit-" + (102 < c ? "inline-" : "") + "box") + ";" + o.replace(i, "-webkit-" + i) + ";" + o.replace(i, "-ms-" + i + "box") + ";" + o;
        }

        return o + ";";

      case 938:
        if (45 === o.charCodeAt(5)) switch (o.charCodeAt(6)) {
          case 105:
            return "-webkit-" + o + "-webkit-box-" + (i = o.replace("-items", "")) + "-ms-flex-" + i + o;

          case 115:
            return "-webkit-" + o + "-ms-flex-item-" + o.replace(R, "") + o;

          default:
            return "-webkit-" + o + "-ms-flex-line-pack" + o.replace("align-content", "").replace(R, "") + o;
        }
        break;

      case 973:
      case 989:
        if (45 !== o.charCodeAt(3) || 122 === o.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === w.test(e)) return 115 === (i = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? r(e.replace("stretch", "fill-available"), t, a, n).replace(":fill-available", ":stretch") : o.replace(i, "-webkit-" + i) + o.replace(i, "-moz-" + i.replace("fill-", "")) + o;
        break;

      case 962:
        if (o = "-webkit-" + o + (102 === o.charCodeAt(5) ? "-ms-" + o : "") + o, 211 === a + n && 105 === o.charCodeAt(13) && 0 < o.indexOf("transform", 10)) return o.substring(0, o.indexOf(";", 27) + 1).replace(h, "$1-webkit-$2") + o;
    }

    return o;
  }

  function l(e, t) {
    var a = e.indexOf(1 === t ? ":" : "{"),
        n = e.substring(0, 3 !== t ? a : 10);
    return a = e.substring(a + 1, e.length - 1), k(2 !== t ? n : n.replace(M, "$1"), a, t);
  }

  function o(e, t) {
    var a = r(t, t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2));
    return a !== t + ";" ? a.replace(z, " or ($1)").substring(4) : "(" + t + ")";
  }

  function c(e, t, a, n, r, l, o, c, i, u) {
    for (var f, d = 0, p = t; d < D; ++d) {
      switch (f = S[d].call(s, e, p, a, n, r, l, o, c, i, u)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          p = f;
      }
    }

    if (p !== t) return p;
  }

  function i(e) {
    return void 0 !== (e = e.prefix) && (k = null, e ? "function" != typeof e ? T = 1 : (T = 2, k = e) : T = 0), i;
  }

  function s(t, n) {
    if (void 0 !== this && this.constructor === s) return e(t);
    var i = t;

    if (33 > i.charCodeAt(0) && (i = i.trim()), i = [i], 0 < D) {
      var d = c(-1, n, i, i, x, C, 0, 0, 0, 0);
      void 0 !== d && "string" == typeof d && (n = d);
    }

    var p = function e(t, n, i, s, d) {
      for (var p, h, m, _, E, z = 0, R = 0, M = 0, w = 0, O = 0, S = 0, k = m = p = 0, A = 0, $ = 0, N = 0, L = 0, V = i.length, B = V - 1, I = "", H = "", W = "", U = ""; A < V;) {
        if (h = i.charCodeAt(A), A === B && 0 !== R + w + M + z && (0 !== R && (h = 47 === R ? 10 : 47), w = M = z = 0, V++, B++), 0 === R + w + M + z) {
          if (A === B && (0 < $ && (I = I.replace(f, "")), 0 < I.trim().length)) {
            switch (h) {
              case 32:
              case 9:
              case 59:
              case 13:
              case 10:
                break;

              default:
                I += i.charAt(A);
            }

            h = 59;
          }

          switch (h) {
            case 123:
              for (p = (I = I.trim()).charCodeAt(0), m = 1, L = ++A; A < V;) {
                switch (h = i.charCodeAt(A)) {
                  case 123:
                    m++;
                    break;

                  case 125:
                    m--;
                    break;

                  case 47:
                    switch (h = i.charCodeAt(A + 1)) {
                      case 42:
                      case 47:
                        e: {
                          for (k = A + 1; k < B; ++k) {
                            switch (i.charCodeAt(k)) {
                              case 47:
                                if (42 === h && 42 === i.charCodeAt(k - 1) && A + 2 !== k) {
                                  A = k + 1;
                                  break e;
                                }

                                break;

                              case 10:
                                if (47 === h) {
                                  A = k + 1;
                                  break e;
                                }

                            }
                          }

                          A = k;
                        }

                    }

                    break;

                  case 91:
                    h++;

                  case 40:
                    h++;

                  case 34:
                  case 39:
                    for (; A++ < B && i.charCodeAt(A) !== h;) {
                      ;
                    }

                }

                if (0 === m) break;
                A++;
              }

              switch (m = i.substring(L, A), 0 === p && (p = (I = I.replace(u, "").trim()).charCodeAt(0)), p) {
                case 64:
                  switch (0 < $ && (I = I.replace(f, "")), h = I.charCodeAt(1)) {
                    case 100:
                    case 109:
                    case 115:
                    case 45:
                      $ = n;
                      break;

                    default:
                      $ = j;
                  }

                  if (L = (m = e(n, $, m, h, d + 1)).length, 0 < D && (E = c(3, m, $ = a(j, I, N), n, x, C, L, h, d, s), I = $.join(""), void 0 !== E && 0 === (L = (m = E.trim()).length) && (h = 0, m = "")), 0 < L) switch (h) {
                    case 115:
                      I = I.replace(b, o);

                    case 100:
                    case 109:
                    case 45:
                      m = I + "{" + m + "}";
                      break;

                    case 107:
                      m = (I = I.replace(v, "$1 $2")) + "{" + m + "}", m = 1 === T || 2 === T && l("@" + m, 3) ? "@-webkit-" + m + "@" + m : "@" + m;
                      break;

                    default:
                      m = I + m, 112 === s && (H += m, m = "");
                  } else m = "";
                  break;

                default:
                  m = e(n, a(n, I, N), m, s, d + 1);
              }

              W += m, m = N = $ = k = p = 0, I = "", h = i.charCodeAt(++A);
              break;

            case 125:
            case 59:
              if (1 < (L = (I = (0 < $ ? I.replace(f, "") : I).trim()).length)) switch (0 === k && (p = I.charCodeAt(0), 45 === p || 96 < p && 123 > p) && (L = (I = I.replace(" ", ":")).length), 0 < D && void 0 !== (E = c(1, I, n, t, x, C, H.length, s, d, s)) && 0 === (L = (I = E.trim()).length) && (I = "\0\0"), p = I.charCodeAt(0), h = I.charCodeAt(1), p) {
                case 0:
                  break;

                case 64:
                  if (105 === h || 99 === h) {
                    U += I + i.charAt(A);
                    break;
                  }

                default:
                  58 !== I.charCodeAt(L - 1) && (H += r(I, p, h, I.charCodeAt(2)));
              }
              N = $ = k = p = 0, I = "", h = i.charCodeAt(++A);
          }
        }

        switch (h) {
          case 13:
          case 10:
            47 === R ? R = 0 : 0 === 1 + p && 107 !== s && 0 < I.length && ($ = 1, I += "\0"), 0 < D * F && c(0, I, n, t, x, C, H.length, s, d, s), C = 1, x++;
            break;

          case 59:
          case 125:
            if (0 === R + w + M + z) {
              C++;
              break;
            }

          default:
            switch (C++, _ = i.charAt(A), h) {
              case 9:
              case 32:
                if (0 === w + z + R) switch (O) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    _ = "";
                    break;

                  default:
                    32 !== h && (_ = " ");
                }
                break;

              case 0:
                _ = "\\0";
                break;

              case 12:
                _ = "\\f";
                break;

              case 11:
                _ = "\\v";
                break;

              case 38:
                0 === w + R + z && ($ = N = 1, _ = "\f" + _);
                break;

              case 108:
                if (0 === w + R + z + P && 0 < k) switch (A - k) {
                  case 2:
                    112 === O && 58 === i.charCodeAt(A - 3) && (P = O);

                  case 8:
                    111 === S && (P = S);
                }
                break;

              case 58:
                0 === w + R + z && (k = A);
                break;

              case 44:
                0 === R + M + w + z && ($ = 1, _ += "\r");
                break;

              case 34:
              case 39:
                0 === R && (w = w === h ? 0 : 0 === w ? h : w);
                break;

              case 91:
                0 === w + R + M && z++;
                break;

              case 93:
                0 === w + R + M && z--;
                break;

              case 41:
                0 === w + R + z && M--;
                break;

              case 40:
                if (0 === w + R + z) {
                  if (0 === p) switch (2 * O + 3 * S) {
                    case 533:
                      break;

                    default:
                      p = 1;
                  }
                  M++;
                }

                break;

              case 64:
                0 === R + M + w + z + k + m && (m = 1);
                break;

              case 42:
              case 47:
                if (!(0 < w + z + M)) switch (R) {
                  case 0:
                    switch (2 * h + 3 * i.charCodeAt(A + 1)) {
                      case 235:
                        R = 47;
                        break;

                      case 220:
                        L = A, R = 42;
                    }

                    break;

                  case 42:
                    47 === h && 42 === O && L + 2 !== A && (33 === i.charCodeAt(L + 2) && (H += i.substring(L, A + 1)), _ = "", R = 0);
                }
            }

            0 === R && (I += _);
        }

        S = O, O = h, A++;
      }

      if (0 < (L = H.length)) {
        if ($ = n, 0 < D && void 0 !== (E = c(2, H, $, t, x, C, L, s, d, s)) && 0 === (H = E).length) return U + H + W;

        if (H = $.join(",") + "{" + H + "}", 0 != T * P) {
          switch (2 !== T || l(H, 2) || (P = 0), P) {
            case 111:
              H = H.replace(g, ":-moz-$1") + H;
              break;

            case 112:
              H = H.replace(y, "::-webkit-input-$1") + H.replace(y, "::-moz-$1") + H.replace(y, ":-ms-input-$1") + H;
          }

          P = 0;
        }
      }

      return U + H + W;
    }(j, i, n, 0, 0);

    return 0 < D && void 0 !== (d = c(-2, p, i, i, x, C, p.length, 0, 0, 0)) && (p = d), "", P = 0, C = x = 1, p;
  }

  var u = /^\0+/g,
      f = /[\0\r\f]/g,
      d = /: */g,
      p = /zoo|gra/,
      h = /([,: ])(transform)/g,
      m = /,\r+?/g,
      _ = /([\t\r\n ])*\f?&/g,
      v = /@(k\w+)\s*(\S*)\s*/,
      y = /::(place)/g,
      g = /:(read-only)/g,
      E = /[svh]\w+-[tblr]{2}/,
      b = /\(\s*(.*)\s*\)/g,
      z = /([\s\S]*?);/g,
      R = /-self|flex-/g,
      M = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      w = /stretch|:\s*\w+\-(?:conte|avail)/,
      O = /([^-])(image-set\()/,
      C = 1,
      x = 1,
      P = 0,
      T = 1,
      j = [],
      S = [],
      D = 0,
      k = null,
      F = 0;
  return s.use = function e(t) {
    switch (t) {
      case void 0:
      case null:
        D = S.length = 0;
        break;

      default:
        switch (t.constructor) {
          case Array:
            for (var a = 0, n = t.length; a < n; ++a) {
              e(t[a]);
            }

            break;

          case Function:
            S[D++] = t;
            break;

          case Boolean:
            F = 0 | !!t;
        }

    }

    return e;
  }, s.set = i, void 0 !== t && i(t), s;
},
    stylisRuleSheet = createCommonjsModule(function (e, t) {
  e.exports = function (e) {
    function t(t) {
      if (t) try {
        e(t + "}");
      } catch (e) {}
    }

    return function (a, n, r, l, o, c, i, s, u, f) {
      switch (a) {
        case 1:
          if (0 === u && 64 === n.charCodeAt(0)) return e(n + ";"), "";
          break;

        case 2:
          if (0 === s) return n + "/*|*/";
          break;

        case 3:
          switch (s) {
            case 102:
            case 112:
              return e(r[0] + n), "";

            default:
              return n + (0 === f ? "/*|*/" : "");
          }

        case -2:
          n.split("/*|*/}").forEach(t);
      }
    };
  };
}),
    hyphenateRegex = /[A-Z]|^ms/g,
    processStyleName = memoize(function (e) {
  return e.replace(hyphenateRegex, "-$&").toLowerCase();
}),
    processStyleValue = function processStyleValue(e, t) {
  return null == t || "boolean" == typeof t ? "" : 1 === unitlessKeys[e] || 45 === e.charCodeAt(1) || isNaN(t) || 0 === t ? t : t + "px";
};

if ("production" !== process.env.NODE_ENV) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/,
      contentValues = ["normal", "none", "counter", "open-quote", "close-quote", "no-open-quote", "no-close-quote", "initial", "inherit", "unset"],
      oldProcessStyleValue = processStyleValue;

  processStyleValue = function processStyleValue(e, t) {
    return "content" === e && ("string" != typeof t || -1 === contentValues.indexOf(t) && !contentValuePattern.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || '"' !== t.charAt(0) && "'" !== t.charAt(0))) && console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`"), oldProcessStyleValue(e, t);
  };
}

var classnames$1 = function e(t) {
  for (var a = t.length, n = 0, r = ""; n < a; n++) {
    var l = t[n];

    if (null != l) {
      var o = void 0;

      switch (typeof l) {
        case "boolean":
          break;

        case "function":
          "production" !== process.env.NODE_ENV && console.error("Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\nPlease call the function before passing it to cx."), o = e([l()]);
          break;

        case "object":
          if (Array.isArray(l)) o = e(l);else for (var c in o = "", l) {
            l[c] && c && (o && (o += " "), o += c);
          }
          break;

        default:
          o = l;
      }

      o && (r && (r += " "), r += o);
    }
  }

  return r;
},
    isBrowser = "undefined" != typeof document;

function sheetForTag(e) {
  if (e.sheet) return e.sheet;

  for (var t = 0; t < document.styleSheets.length; t++) {
    if (document.styleSheets[t].ownerNode === e) return document.styleSheets[t];
  }
}

function makeStyleTag(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key || ""), void 0 !== e.nonce && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), (void 0 !== e.container ? e.container : document.head).appendChild(t), t;
}

var StyleSheet = function () {
  function e(e) {
    this.isSpeedy = "production" === process.env.NODE_ENV, this.tags = [], this.ctr = 0, this.opts = e;
  }

  var t = e.prototype;
  return t.inject = function () {
    if (this.injected) throw new Error("already injected!");
    this.tags[0] = makeStyleTag(this.opts), this.injected = !0;
  }, t.speedy = function (e) {
    if (0 !== this.ctr) throw new Error("cannot change speedy now");
    this.isSpeedy = !!e;
  }, t.insert = function (e, t) {
    if (this.isSpeedy) {
      var a = sheetForTag(this.tags[this.tags.length - 1]);

      try {
        a.insertRule(e, a.cssRules.length);
      } catch (t) {
        "production" !== process.env.NODE_ENV && console.warn("illegal rule", e);
      }
    } else {
      var n = makeStyleTag(this.opts);
      this.tags.push(n), n.appendChild(document.createTextNode(e + (t || "")));
    }

    this.ctr++, this.ctr % 65e3 == 0 && this.tags.push(makeStyleTag(this.opts));
  }, t.flush = function () {
    this.tags.forEach(function (e) {
      return e.parentNode.removeChild(e);
    }), this.tags = [], this.ctr = 0, this.injected = !1;
  }, e;
}();

function createEmotion(e, t) {
  if (void 0 !== e.__SECRET_EMOTION__) return e.__SECRET_EMOTION__;
  void 0 === t && (t = {});
  var a,
      n = t.key || "css";
  if ("production" !== process.env.NODE_ENV && /[^a-z-]/.test(n)) throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var r,
      l = stylisRuleSheet(function (e) {
    a += e, isBrowser && c.insert(e, s);
  });
  void 0 !== t.prefix && (r = {
    prefix: t.prefix
  });
  var o = {
    registered: {},
    inserted: {},
    nonce: t.nonce,
    key: n
  },
      c = new StyleSheet(t);
  isBrowser && c.inject();
  var i = new W(r);
  i.use(t.stylisPlugins)(l);
  var s = "";

  function u(e, t) {
    if (null == e) return "";

    switch (typeof e) {
      case "boolean":
        return "";

      case "function":
        if (void 0 !== e.__emotion_styles) {
          var a = e.toString();
          if ("NO_COMPONENT_SELECTOR" === a && "production" !== process.env.NODE_ENV) throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");
          return a;
        }

        return void 0 === this && "production" !== process.env.NODE_ENV && console.error("Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`"), u.call(this, void 0 === this ? e() : e(this.mergedProps, this.context), t);

      case "object":
        return function (e) {
          if (p.has(e)) return p.get(e);
          var t = "";
          Array.isArray(e) ? e.forEach(function (e) {
            t += u.call(this, e, !1);
          }, this) : Object.keys(e).forEach(function (a) {
            if ("object" != typeof e[a]) void 0 !== o.registered[e[a]] ? t += a + "{" + o.registered[e[a]] + "}" : t += processStyleName(a) + ":" + processStyleValue(a, e[a]) + ";";else {
              if ("NO_COMPONENT_SELECTOR" === a && "production" !== process.env.NODE_ENV) throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");
              Array.isArray(e[a]) && "string" == typeof e[a][0] && void 0 === o.registered[e[a][0]] ? e[a].forEach(function (e) {
                t += processStyleName(a) + ":" + processStyleValue(a, e) + ";";
              }) : t += a + "{" + u.call(this, e[a], !1) + "}";
            }
          }, this);
          return p.set(e, t), t;
        }.call(this, e);

      default:
        var n = o.registered[e];
        return !1 === t && void 0 !== n ? n : e;
    }
  }

  var f,
      d,
      p = new WeakMap();

  var h = /label:\s*([^\s;\n{]+)\s*;/g,
      m = function m(e, t) {
    return murmurhash2_32_gc(e + t) + t;
  };

  if ("production" !== process.env.NODE_ENV) {
    var _ = m,
        v = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;

    m = function m(e, t) {
      return _(e.replace(v, function (e) {
        return s = e, "";
      }), t);
    };
  }

  var y = function y(e) {
    var t = !0,
        a = "",
        n = "";
    null == e || void 0 === e.raw ? (t = !1, a += u.call(this, e, !1)) : a += e[0];

    for (var r = arguments.length, l = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) {
      l[o - 1] = arguments[o];
    }

    return l.forEach(function (n, r) {
      a += u.call(this, n, 46 === a.charCodeAt(a.length - 1)), !0 === t && void 0 !== e[r + 1] && (a += e[r + 1]);
    }, this), d = a, a = a.replace(h, function (e, t) {
      return n += "-" + t, "";
    }), f = m(a, n), a;
  };

  if ("production" !== process.env.NODE_ENV) {
    var g = i;

    i = function i(e, t) {
      g(e, t), s = "";
    };
  }

  function E(e, t) {
    void 0 === o.inserted[f] && (a = "", i(e, t), o.inserted[f] = a);
  }

  var b = function b() {
    var e = y.apply(this, arguments),
        t = n + "-" + f;
    return void 0 === o.registered[t] && (o.registered[t] = d), E("." + t, e), t;
  };

  function z(e, t) {
    var a = "";
    return t.split(" ").forEach(function (t) {
      void 0 !== o.registered[t] ? e.push(t) : a += t + " ";
    }), a;
  }

  function R(e, t) {
    var a = [],
        n = z(a, e);
    return a.length < 2 ? e : n + b(a, t);
  }

  function M(e) {
    o.inserted[e] = !0;
  }

  if (isBrowser) {
    var w = document.querySelectorAll("[data-emotion-" + n + "]");
    Array.prototype.forEach.call(w, function (e) {
      c.tags[0].parentNode.insertBefore(e, c.tags[0]), e.getAttribute("data-emotion-" + n).split(" ").forEach(M);
    });
  }

  var O = {
    flush: function flush() {
      isBrowser && (c.flush(), c.inject()), o.inserted = {}, o.registered = {};
    },
    hydrate: function hydrate(e) {
      e.forEach(M);
    },
    cx: function cx() {
      for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) {
        t[a] = arguments[a];
      }

      return R(classnames$1(t));
    },
    merge: R,
    getRegisteredStyles: z,
    injectGlobal: function injectGlobal() {
      E("", y.apply(this, arguments));
    },
    keyframes: function keyframes() {
      var e = y.apply(this, arguments),
          t = "animation-" + f;
      return E("", "@keyframes " + t + "{" + e + "}"), t;
    },
    css: b,
    sheet: c,
    caches: o
  };
  return e.__SECRET_EMOTION__ = O, O;
}

var context = "undefined" != typeof global ? global : {},
    _createEmotion = createEmotion(context),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    caches = _createEmotion.caches,
    AutosizeInput_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }(),
      r = o(React__default),
      l = o(PropTypes);

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = {
    position: "absolute",
    top: 0,
    left: 0,
    visibility: "hidden",
    height: 0,
    overflow: "scroll",
    whiteSpace: "pre"
  },
      i = ["extraWidth", "injectStyles", "inputClassName", "inputRef", "inputStyle", "minWidth", "onAutosize", "placeholderIsMinWidth"],
      s = function s(e, t) {
    t.style.fontSize = e.fontSize, t.style.fontFamily = e.fontFamily, t.style.fontWeight = e.fontWeight, t.style.fontStyle = e.fontStyle, t.style.letterSpacing = e.letterSpacing, t.style.textTransform = e.textTransform;
  },
      u = !("undefined" == typeof window || !window.navigator) && /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent),
      f = function f() {
    return u ? "_" + Math.random().toString(36).substr(2, 12) : void 0;
  },
      d = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var a = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

      return a.inputRef = function (e) {
        a.input = e, "function" == typeof a.props.inputRef && a.props.inputRef(e);
      }, a.placeHolderSizerRef = function (e) {
        a.placeHolderSizer = e;
      }, a.sizerRef = function (e) {
        a.sizer = e;
      }, a.state = {
        inputWidth: e.minWidth,
        inputId: e.id || f()
      }, a;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, React__default.Component), n(t, [{
      key: "componentDidMount",
      value: function value() {
        this.mounted = !0, this.copyInputStyles(), this.updateInputWidth();
      }
    }, {
      key: "componentWillReceiveProps",
      value: function value(e) {
        var t = e.id;
        t !== this.props.id && this.setState({
          inputId: t || f()
        });
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e, t) {
        t.inputWidth !== this.state.inputWidth && "function" == typeof this.props.onAutosize && this.props.onAutosize(this.state.inputWidth), this.updateInputWidth();
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.mounted = !1;
      }
    }, {
      key: "copyInputStyles",
      value: function value() {
        if (this.mounted && window.getComputedStyle) {
          var e = this.input && window.getComputedStyle(this.input);
          e && (s(e, this.sizer), this.placeHolderSizer && s(e, this.placeHolderSizer));
        }
      }
    }, {
      key: "updateInputWidth",
      value: function value() {
        if (this.mounted && this.sizer && void 0 !== this.sizer.scrollWidth) {
          var e = void 0;
          e = this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth) ? Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2 : this.sizer.scrollWidth + 2, (e += "number" === this.props.type && void 0 === this.props.extraWidth ? 16 : parseInt(this.props.extraWidth) || 0) < this.props.minWidth && (e = this.props.minWidth), e !== this.state.inputWidth && this.setState({
            inputWidth: e
          });
        }
      }
    }, {
      key: "getInput",
      value: function value() {
        return this.input;
      }
    }, {
      key: "focus",
      value: function value() {
        this.input.focus();
      }
    }, {
      key: "blur",
      value: function value() {
        this.input.blur();
      }
    }, {
      key: "select",
      value: function value() {
        this.input.select();
      }
    }, {
      key: "renderStyles",
      value: function value() {
        var e = this.props.injectStyles;
        return u && e ? r.default.createElement("style", {
          dangerouslySetInnerHTML: {
            __html: "input#" + this.state.inputId + "::-ms-clear {display: none;}"
          }
        }) : null;
      }
    }, {
      key: "render",
      value: function value() {
        var e = [this.props.defaultValue, this.props.value, ""].reduce(function (e, t) {
          return null !== e && void 0 !== e ? e : t;
        }),
            t = a({}, this.props.style);
        t.display || (t.display = "inline-block");

        var n = a({
          boxSizing: "content-box",
          width: this.state.inputWidth + "px"
        }, this.props.inputStyle),
            l = function (e, t) {
          var a = {};

          for (var n in e) {
            t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
          }

          return a;
        }(this.props, []);

        return function (e) {
          i.forEach(function (t) {
            return delete e[t];
          });
        }(l), l.className = this.props.inputClassName, l.id = this.state.inputId, l.style = n, r.default.createElement("div", {
          className: this.props.className,
          style: t
        }, this.renderStyles(), r.default.createElement("input", a({}, l, {
          ref: this.inputRef
        })), r.default.createElement("div", {
          ref: this.sizerRef,
          style: c
        }, e), this.props.placeholder ? r.default.createElement("div", {
          ref: this.placeHolderSizerRef,
          style: c
        }, this.props.placeholder) : null);
      }
    }]), t;
  }();

  d.propTypes = {
    className: l.default.string,
    defaultValue: l.default.any,
    extraWidth: l.default.oneOfType([l.default.number, l.default.string]),
    id: l.default.string,
    injectStyles: l.default.bool,
    inputClassName: l.default.string,
    inputRef: l.default.func,
    inputStyle: l.default.object,
    minWidth: l.default.oneOfType([l.default.number, l.default.string]),
    onAutosize: l.default.func,
    onChange: l.default.func,
    placeholder: l.default.string,
    placeholderIsMinWidth: l.default.bool,
    style: l.default.object,
    value: l.default.any
  }, d.defaultProps = {
    minWidth: 1,
    injectStyles: !0
  }, t.default = d;
}),
    AutosizeInput = unwrapExports(AutosizeInput_1),
    simpleIsEqual = function simpleIsEqual(e, t) {
  return e === t;
};

function index(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : simpleIsEqual,
      a = void 0,
      n = [],
      r = void 0,
      l = !1,
      o = function o(e, a) {
    return t(e, n[a]);
  };

  return function () {
    for (var t = arguments.length, c = Array(t), i = 0; i < t; i++) {
      c[i] = arguments[i];
    }

    return l && a === this && c.length === n.length && c.every(o) ? r : (l = !0, a = this, n = c, r = e.apply(this, c));
  };
}

var hasClass_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e, t) {
    return e.classList ? !!t && e.classList.contains(t) : -1 !== (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ");
  }, e.exports = t.default;
});
unwrapExports(hasClass_1);
var addClass_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e, t) {
    e.classList ? e.classList.add(t) : (0, n.default)(e, t) || ("string" == typeof e.className ? e.className = e.className + " " + t : e.setAttribute("class", (e.className && e.className.baseVal || "") + " " + t));
  };
  var a,
      n = (a = hasClass_1) && a.__esModule ? a : {
    default: a
  };
  e.exports = t.default;
});

function replaceClassName(e, t) {
  return e.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}

unwrapExports(addClass_1);

var removeClass = function removeClass(e, t) {
  e.classList ? e.classList.remove(t) : "string" == typeof e.className ? e.className = replaceClassName(e.className, t) : e.setAttribute("class", replaceClassName(e.className && e.className.baseVal || "", t));
},
    PropTypes$1 = createCommonjsModule(function (e, t) {
  t.__esModule = !0, t.classNamesShape = t.timeoutsShape = void 0, t.transitionTimeout = function (e) {
    var t = "transition" + e + "Timeout",
        a = "transition" + e;
    return function (e) {
      if (e[a]) {
        if (null == e[t]) return new Error(t + " wasn't supplied to CSSTransitionGroup: this can cause unreliable animations and won't be supported in a future version of React. See https://fb.me/react-animation-transition-group-timeout for more information.");
        if ("number" != typeof e[t]) return new Error(t + " must be a number (in milliseconds)");
      }

      return null;
    };
  };
  var a,
      n = (a = PropTypes) && a.__esModule ? a : {
    default: a
  };
  t.timeoutsShape = n.default.oneOfType([n.default.number, n.default.shape({
    enter: n.default.number,
    exit: n.default.number
  }).isRequired]), t.classNamesShape = n.default.oneOfType([n.default.string, n.default.shape({
    enter: n.default.string,
    exit: n.default.string,
    active: n.default.string
  }), n.default.shape({
    enter: n.default.string,
    enterDone: n.default.string,
    enterActive: n.default.string,
    exit: n.default.string,
    exitDone: n.default.string,
    exitActive: n.default.string
  })]);
});

unwrapExports(PropTypes$1);
var PropTypes_1 = PropTypes$1.classNamesShape,
    PropTypes_2 = PropTypes$1.timeoutsShape,
    PropTypes_3 = PropTypes$1.transitionTimeout,
    Transition_1 = createCommonjsModule(function (e, t) {
  t.__esModule = !0, t.EXITING = t.ENTERED = t.ENTERING = t.EXITED = t.UNMOUNTED = void 0;

  var a = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  }(PropTypes),
      n = l(React__default),
      r = l(ReactDOM__default);

  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var o = t.UNMOUNTED = "unmounted",
      c = t.EXITED = "exited",
      i = t.ENTERING = "entering",
      s = t.ENTERED = "entered",
      u = t.EXITING = "exiting",
      f = function (e) {
    function t(a, n) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var r = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this, a, n)),
          l = n.transitionGroup,
          u = l && !l.isMounting ? a.enter : a.appear,
          f = void 0;

      return r.appearStatus = null, a.in ? u ? (f = c, r.appearStatus = i) : f = s : f = a.unmountOnExit || a.mountOnEnter ? o : c, r.state = {
        status: f
      }, r.nextCallback = null, r;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, e), t.prototype.getChildContext = function () {
      return {
        transitionGroup: null
      };
    }, t.getDerivedStateFromProps = function (e, t) {
      return e.in && t.status === o ? {
        status: c
      } : null;
    }, t.prototype.componentDidMount = function () {
      this.updateStatus(!0, this.appearStatus);
    }, t.prototype.componentDidUpdate = function (e) {
      var t = null;

      if (e !== this.props) {
        var a = this.state.status;
        this.props.in ? a !== i && a !== s && (t = i) : a !== i && a !== s || (t = u);
      }

      this.updateStatus(!1, t);
    }, t.prototype.componentWillUnmount = function () {
      this.cancelNextCallback();
    }, t.prototype.getTimeouts = function () {
      var e = this.props.timeout,
          t = void 0,
          a = void 0,
          n = void 0;
      return t = a = n = e, null != e && "number" != typeof e && (t = e.exit, a = e.enter, n = e.appear), {
        exit: t,
        enter: a,
        appear: n
      };
    }, t.prototype.updateStatus = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
          t = arguments[1];

      if (null !== t) {
        this.cancelNextCallback();
        var a = r.default.findDOMNode(this);
        t === i ? this.performEnter(a, e) : this.performExit(a);
      } else this.props.unmountOnExit && this.state.status === c && this.setState({
        status: o
      });
    }, t.prototype.performEnter = function (e, t) {
      var a = this,
          n = this.props.enter,
          r = this.context.transitionGroup ? this.context.transitionGroup.isMounting : t,
          l = this.getTimeouts();
      t || n ? (this.props.onEnter(e, r), this.safeSetState({
        status: i
      }, function () {
        a.props.onEntering(e, r), a.onTransitionEnd(e, l.enter, function () {
          a.safeSetState({
            status: s
          }, function () {
            a.props.onEntered(e, r);
          });
        });
      })) : this.safeSetState({
        status: s
      }, function () {
        a.props.onEntered(e);
      });
    }, t.prototype.performExit = function (e) {
      var t = this,
          a = this.props.exit,
          n = this.getTimeouts();
      a ? (this.props.onExit(e), this.safeSetState({
        status: u
      }, function () {
        t.props.onExiting(e), t.onTransitionEnd(e, n.exit, function () {
          t.safeSetState({
            status: c
          }, function () {
            t.props.onExited(e);
          });
        });
      })) : this.safeSetState({
        status: c
      }, function () {
        t.props.onExited(e);
      });
    }, t.prototype.cancelNextCallback = function () {
      null !== this.nextCallback && (this.nextCallback.cancel(), this.nextCallback = null);
    }, t.prototype.safeSetState = function (e, t) {
      t = this.setNextCallback(t), this.setState(e, t);
    }, t.prototype.setNextCallback = function (e) {
      var t = this,
          a = !0;
      return this.nextCallback = function (n) {
        a && (a = !1, t.nextCallback = null, e(n));
      }, this.nextCallback.cancel = function () {
        a = !1;
      }, this.nextCallback;
    }, t.prototype.onTransitionEnd = function (e, t, a) {
      this.setNextCallback(a), e ? (this.props.addEndListener && this.props.addEndListener(e, this.nextCallback), null != t && setTimeout(this.nextCallback, t)) : setTimeout(this.nextCallback, 0);
    }, t.prototype.render = function () {
      var e = this.state.status;
      if (e === o) return null;

      var t = this.props,
          a = t.children,
          r = function (e, t) {
        var a = {};

        for (var n in e) {
          t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
        }

        return a;
      }(t, ["children"]);

      if (delete r.in, delete r.mountOnEnter, delete r.unmountOnExit, delete r.appear, delete r.enter, delete r.exit, delete r.timeout, delete r.addEndListener, delete r.onEnter, delete r.onEntering, delete r.onEntered, delete r.onExit, delete r.onExiting, delete r.onExited, "function" == typeof a) return a(e, r);
      var l = n.default.Children.only(a);
      return n.default.cloneElement(l, r);
    }, t;
  }(n.default.Component);

  function d() {}

  f.contextTypes = {
    transitionGroup: a.object
  }, f.childContextTypes = {
    transitionGroup: function transitionGroup() {}
  }, f.propTypes = "production" !== process.env.NODE_ENV ? {
    children: a.oneOfType([a.func.isRequired, a.element.isRequired]).isRequired,
    in: a.bool,
    mountOnEnter: a.bool,
    unmountOnExit: a.bool,
    appear: a.bool,
    enter: a.bool,
    exit: a.bool,
    timeout: function timeout(e) {
      for (var t = arguments.length, a = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
        a[n - 1] = arguments[n];
      }

      var r = PropTypes$1.timeoutsShape;
      return e.addEndListener || (r = r.isRequired), r.apply(void 0, [e].concat(a));
    },
    addEndListener: a.func,
    onEnter: a.func,
    onEntering: a.func,
    onEntered: a.func,
    onExit: a.func,
    onExiting: a.func,
    onExited: a.func
  } : {}, f.defaultProps = {
    in: !1,
    mountOnEnter: !1,
    unmountOnExit: !1,
    appear: !1,
    enter: !0,
    exit: !0,
    onEnter: d,
    onEntering: d,
    onEntered: d,
    onExit: d,
    onExiting: d,
    onExited: d
  }, f.UNMOUNTED = 0, f.EXITED = 1, f.ENTERING = 2, f.ENTERED = 3, f.EXITING = 4, t.default = (0, _reactLifecyclesCompat.polyfill)(f);
});
unwrapExports(Transition_1);
var Transition_2 = Transition_1.EXITING,
    Transition_3 = Transition_1.ENTERED,
    Transition_4 = Transition_1.ENTERING,
    Transition_5 = Transition_1.EXITED,
    Transition_6 = Transition_1.UNMOUNTED,
    CSSTransition_1 = createCommonjsModule(function (e, t) {
  t.__esModule = !0;

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  }(PropTypes),
      r = i(addClass_1),
      l = i(removeClass),
      o = i(React__default),
      c = i(Transition_1);

  function i(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function s(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  }

  var u = function u(e, t) {
    return e && t && t.split(" ").forEach(function (t) {
      return (0, r.default)(e, t);
    });
  },
      f = function f(e, t) {
    return e && t && t.split(" ").forEach(function (t) {
      return (0, l.default)(e, t);
    });
  },
      d = a({}, c.default.propTypes, {
    classNames: PropTypes$1.classNamesShape,
    onEnter: n.func,
    onEntering: n.func,
    onEntered: n.func,
    onExit: n.func,
    onExiting: n.func,
    onExited: n.func
  }),
      p = function (e) {
    function t() {
      var a, n;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      for (var r = arguments.length, l = Array(r), o = 0; o < r; o++) {
        l[o] = arguments[o];
      }

      return a = n = s(this, e.call.apply(e, [this].concat(l))), n.onEnter = function (e, t) {
        var a = n.getClassNames(t ? "appear" : "enter").className;
        n.removeClasses(e, "exit"), u(e, a), n.props.onEnter && n.props.onEnter(e);
      }, n.onEntering = function (e, t) {
        var a = n.getClassNames(t ? "appear" : "enter").activeClassName;
        n.reflowAndAddClass(e, a), n.props.onEntering && n.props.onEntering(e);
      }, n.onEntered = function (e, t) {
        var a = n.getClassNames("enter").doneClassName;
        n.removeClasses(e, t ? "appear" : "enter"), u(e, a), n.props.onEntered && n.props.onEntered(e);
      }, n.onExit = function (e) {
        var t = n.getClassNames("exit").className;
        n.removeClasses(e, "appear"), n.removeClasses(e, "enter"), u(e, t), n.props.onExit && n.props.onExit(e);
      }, n.onExiting = function (e) {
        var t = n.getClassNames("exit").activeClassName;
        n.reflowAndAddClass(e, t), n.props.onExiting && n.props.onExiting(e);
      }, n.onExited = function (e) {
        var t = n.getClassNames("exit").doneClassName;
        n.removeClasses(e, "exit"), u(e, t), n.props.onExited && n.props.onExited(e);
      }, n.getClassNames = function (e) {
        var t = n.props.classNames,
            a = "string" != typeof t ? t[e] : t + "-" + e;
        return {
          className: a,
          activeClassName: "string" != typeof t ? t[e + "Active"] : a + "-active",
          doneClassName: "string" != typeof t ? t[e + "Done"] : a + "-done"
        };
      }, s(n, a);
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, e), t.prototype.removeClasses = function (e, t) {
      var a = this.getClassNames(t),
          n = a.className,
          r = a.activeClassName,
          l = a.doneClassName;
      n && f(e, n), r && f(e, r), l && f(e, l);
    }, t.prototype.reflowAndAddClass = function (e, t) {
      t && (e && e.scrollTop, u(e, t));
    }, t.prototype.render = function () {
      var e = a({}, this.props);
      return delete e.classNames, o.default.createElement(c.default, a({}, e, {
        onEnter: this.onEnter,
        onEntered: this.onEntered,
        onEntering: this.onEntering,
        onExit: this.onExit,
        onExiting: this.onExiting,
        onExited: this.onExited
      }));
    }, t;
  }(o.default.Component);

  p.propTypes = "production" !== process.env.NODE_ENV ? d : {}, t.default = p, e.exports = t.default;
});
unwrapExports(CSSTransition_1);
var ChildMapping = createCommonjsModule(function (e, t) {
  function a(e, t) {
    var a = Object.create(null);
    return e && React__default.Children.map(e, function (e) {
      return e;
    }).forEach(function (e) {
      a[e.key] = function (e) {
        return t && (0, React__default.isValidElement)(e) ? t(e) : e;
      }(e);
    }), a;
  }

  function n(e, t) {
    function a(a) {
      return a in t ? t[a] : e[a];
    }

    e = e || {}, t = t || {};
    var n = Object.create(null),
        r = [];

    for (var l in e) {
      l in t ? r.length && (n[l] = r, r = []) : r.push(l);
    }

    var o = void 0,
        c = {};

    for (var i in t) {
      if (n[i]) for (o = 0; o < n[i].length; o++) {
        var s = n[i][o];
        c[n[i][o]] = a(s);
      }
      c[i] = a(i);
    }

    for (o = 0; o < r.length; o++) {
      c[r[o]] = a(r[o]);
    }

    return c;
  }

  function r(e, t, a) {
    return null != a[t] ? a[t] : e.props[t];
  }

  t.__esModule = !0, t.getChildMapping = a, t.mergeChildMappings = n, t.getInitialChildMapping = function (e, t) {
    return a(e.children, function (a) {
      return (0, React__default.cloneElement)(a, {
        onExited: t.bind(null, a),
        in: !0,
        appear: r(a, "appear", e),
        enter: r(a, "enter", e),
        exit: r(a, "exit", e)
      });
    });
  }, t.getNextChildMapping = function (e, t, l) {
    var o = a(e.children),
        c = n(t, o);
    return Object.keys(c).forEach(function (a) {
      var n = c[a];

      if ((0, React__default.isValidElement)(n)) {
        var i = a in t,
            s = a in o,
            u = t[a],
            f = (0, React__default.isValidElement)(u) && !u.props.in;
        !s || i && !f ? s || !i || f ? s && i && (0, React__default.isValidElement)(u) && (c[a] = (0, React__default.cloneElement)(n, {
          onExited: l.bind(null, n),
          in: u.props.in,
          exit: r(n, "exit", e),
          enter: r(n, "enter", e)
        })) : c[a] = (0, React__default.cloneElement)(n, {
          in: !1
        }) : c[a] = (0, React__default.cloneElement)(n, {
          onExited: l.bind(null, n),
          in: !0,
          exit: r(n, "exit", e),
          enter: r(n, "enter", e)
        });
      }
    }), c;
  };
});
unwrapExports(ChildMapping);
var ChildMapping_1 = ChildMapping.getChildMapping,
    ChildMapping_2 = ChildMapping.mergeChildMappings,
    ChildMapping_3 = ChildMapping.getInitialChildMapping,
    ChildMapping_4 = ChildMapping.getNextChildMapping,
    TransitionGroup_1 = createCommonjsModule(function (e, t) {
  t.__esModule = !0;

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = l(PropTypes),
      r = l(React__default);

  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var o = Object.values || function (e) {
    return Object.keys(e).map(function (t) {
      return e[t];
    });
  },
      c = {
    component: n.default.any,
    children: n.default.node,
    appear: n.default.bool,
    enter: n.default.bool,
    exit: n.default.bool,
    childFactory: n.default.func
  },
      i = function (e) {
    function t(a, n) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var r = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this, a, n)),
          l = r.handleExited.bind(r);

      return r.state = {
        handleExited: l,
        firstRender: !0
      }, r;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, e), t.prototype.getChildContext = function () {
      return {
        transitionGroup: {
          isMounting: !this.appeared
        }
      };
    }, t.prototype.componentDidMount = function () {
      this.appeared = !0;
    }, t.getDerivedStateFromProps = function (e, t) {
      var a = t.children,
          n = t.handleExited;
      return {
        children: t.firstRender ? (0, ChildMapping.getInitialChildMapping)(e, n) : (0, ChildMapping.getNextChildMapping)(e, a, n),
        firstRender: !1
      };
    }, t.prototype.handleExited = function (e, t) {
      var n = (0, ChildMapping.getChildMapping)(this.props.children);
      e.key in n || (e.props.onExited && e.props.onExited(t), this.setState(function (t) {
        var n = a({}, t.children);
        return delete n[e.key], {
          children: n
        };
      }));
    }, t.prototype.render = function () {
      var e = this.props,
          t = e.component,
          a = e.childFactory,
          n = function (e, t) {
        var a = {};

        for (var n in e) {
          t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
        }

        return a;
      }(e, ["component", "childFactory"]),
          l = o(this.state.children).map(a);

      return delete n.appear, delete n.enter, delete n.exit, null === t ? l : r.default.createElement(t, n, l);
    }, t;
  }(r.default.Component);

  i.childContextTypes = {
    transitionGroup: n.default.object.isRequired
  }, i.propTypes = "production" !== process.env.NODE_ENV ? c : {}, i.defaultProps = {
    component: "div",
    childFactory: function childFactory(e) {
      return e;
    }
  }, t.default = (0, _reactLifecyclesCompat.polyfill)(i), e.exports = t.default;
});
unwrapExports(TransitionGroup_1);
var ReplaceTransition_1 = createCommonjsModule(function (e, t) {
  t.__esModule = !0;
  var a = l(PropTypes),
      n = l(React__default),
      r = l(TransitionGroup_1);

  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function o(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  }

  var c = {
    in: a.default.bool.isRequired,
    children: function children(e, t) {
      return 2 !== n.default.Children.count(e[t]) ? new Error('"' + t + '" must be exactly two transition components.') : null;
    }
  },
      i = function (e) {
    function t() {
      var a, n;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      for (var r = arguments.length, l = Array(r), c = 0; c < r; c++) {
        l[c] = arguments[c];
      }

      return a = n = o(this, e.call.apply(e, [this].concat(l))), s.call(n), o(n, a);
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, e), t.prototype.handleLifecycle = function (e, t, a) {
      var r,
          l = this.props.children,
          o = n.default.Children.toArray(l)[t];
      o.props[e] && (r = o.props)[e].apply(r, a), this.props[e] && this.props[e]((0, ReactDOM__default.findDOMNode)(this));
    }, t.prototype.render = function () {
      var e = this.props,
          t = e.children,
          a = e.in,
          l = function (e, t) {
        var a = {};

        for (var n in e) {
          t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
        }

        return a;
      }(e, ["children", "in"]),
          o = n.default.Children.toArray(t),
          c = o[0],
          i = o[1];

      return delete l.onEnter, delete l.onEntering, delete l.onEntered, delete l.onExit, delete l.onExiting, delete l.onExited, n.default.createElement(r.default, l, a ? n.default.cloneElement(c, {
        key: "first",
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onEntered: this.handleEntered
      }) : n.default.cloneElement(i, {
        key: "second",
        onEnter: this.handleExit,
        onEntering: this.handleExiting,
        onEntered: this.handleExited
      }));
    }, t;
  }(n.default.Component),
      s = function s() {
    var e = this;
    this.handleEnter = function () {
      for (var t = arguments.length, a = Array(t), n = 0; n < t; n++) {
        a[n] = arguments[n];
      }

      return e.handleLifecycle("onEnter", 0, a);
    }, this.handleEntering = function () {
      for (var t = arguments.length, a = Array(t), n = 0; n < t; n++) {
        a[n] = arguments[n];
      }

      return e.handleLifecycle("onEntering", 0, a);
    }, this.handleEntered = function () {
      for (var t = arguments.length, a = Array(t), n = 0; n < t; n++) {
        a[n] = arguments[n];
      }

      return e.handleLifecycle("onEntered", 0, a);
    }, this.handleExit = function () {
      for (var t = arguments.length, a = Array(t), n = 0; n < t; n++) {
        a[n] = arguments[n];
      }

      return e.handleLifecycle("onExit", 1, a);
    }, this.handleExiting = function () {
      for (var t = arguments.length, a = Array(t), n = 0; n < t; n++) {
        a[n] = arguments[n];
      }

      return e.handleLifecycle("onExiting", 1, a);
    }, this.handleExited = function () {
      for (var t = arguments.length, a = Array(t), n = 0; n < t; n++) {
        a[n] = arguments[n];
      }

      return e.handleLifecycle("onExited", 1, a);
    };
  };

  i.propTypes = "production" !== process.env.NODE_ENV ? c : {}, t.default = i, e.exports = t.default;
});
unwrapExports(ReplaceTransition_1);
var reactTransitionGroup = createCommonjsModule(function (e) {
  var t = l(CSSTransition_1),
      a = l(ReplaceTransition_1),
      n = l(TransitionGroup_1),
      r = l(Transition_1);

  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  e.exports = {
    Transition: r.default,
    TransitionGroup: n.default,
    ReplaceTransition: a.default,
    CSSTransition: t.default
  };
});
unwrapExports(reactTransitionGroup);

var reactTransitionGroup_1 = reactTransitionGroup.Transition,
    reactTransitionGroup_2 = reactTransitionGroup.TransitionGroup,
    reactTransitionGroup_3 = reactTransitionGroup.ReplaceTransition,
    reactTransitionGroup_4 = reactTransitionGroup.CSSTransition,
    _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
  return typeof e;
} : function (e) {
  return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
},
    classCallCheck$1 = function classCallCheck$1(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
},
    createClass$1 = function () {
  function e(e, t) {
    for (var a = 0; a < t.length; a++) {
      var n = t[a];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  return function (t, a, n) {
    return a && e(t.prototype, a), n && e(t, n), t;
  };
}(),
    defineProperty$1 = function defineProperty$1(e, t, a) {
  return t in e ? Object.defineProperty(e, t, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = a, e;
},
    _extends$108 = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var a = arguments[t];

    for (var n in a) {
      Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
    }
  }

  return e;
},
    inherits$1 = function inherits$1(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
},
    objectWithoutProperties$1 = function objectWithoutProperties$1(e, t) {
  var a = {};

  for (var n in e) {
    t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
  }

  return a;
},
    possibleConstructorReturn$1 = function possibleConstructorReturn$1(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
},
    slicedToArray$1 = function () {
  return function (e, t) {
    if (Array.isArray(e)) return e;
    if (Symbol.iterator in Object(e)) return function (e, t) {
      var a = [],
          n = !0,
          r = !1,
          l = void 0;

      try {
        for (var o, c = e[Symbol.iterator](); !(n = (o = c.next()).done) && (a.push(o.value), !t || a.length !== t); n = !0) {
          ;
        }
      } catch (e) {
        r = !0, l = e;
      } finally {
        try {
          !n && c.return && c.return();
        } finally {
          if (r) throw l;
        }
      }

      return a;
    }(e, t);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
}(),
    toConsumableArray$1 = function toConsumableArray$1(e) {
  if (Array.isArray(e)) {
    for (var t = 0, a = Array(e.length); t < e.length; t++) {
      a[t] = e[t];
    }

    return a;
  }

  return Array.from(e);
},
    noop = function noop() {};

function applyPrefixToName(e, t) {
  return t ? "-" === t[0] ? e + t : e + "__" + t : e;
}

function classNames(e, t, a, n) {
  var r = [t, n];
  if (a && e) for (var l in a) {
    a.hasOwnProperty(l) && a[l] && r.push("" + applyPrefixToName(e, l));
  }
  return r.filter(function (e) {
    return e;
  }).map(function (e) {
    return String(e).trim();
  }).join(" ");
}

var cleanValue = function cleanValue(e) {
  return Array.isArray(e) ? e.filter(Boolean) : "object" === (void 0 === e ? "undefined" : _typeof$1(e)) && null !== e ? [e] : [];
};

function handleInputChange(e, t, a) {
  if (a) {
    var n = a(e, t);
    if ("string" == typeof n) return n;
  }

  return e;
}

function isDocumentElement(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}

function getScrollTop(e) {
  return isDocumentElement(e) ? window.pageYOffset : e.scrollTop;
}

function scrollTo(e, t) {
  isDocumentElement(e) ? window.scrollTo(0, t) : e.scrollTop = t;
}

function getScrollParent(e) {
  var t = getComputedStyle(e),
      a = "absolute" === t.position,
      n = /(auto|scroll)/,
      r = document.documentElement;
  if ("fixed" === t.position) return r;

  for (var l = e; l = l.parentElement;) {
    if (t = getComputedStyle(l), (!a || "static" !== t.position) && n.test(t.overflow + t.overflowY + t.overflowX)) return l;
  }

  return r;
}

function easeOutCubic(e, t, a, n) {
  return a * ((e = e / n - 1) * e * e + 1) + t;
}

function animatedScrollTo(e, t) {
  var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 200,
      n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : noop,
      r = getScrollTop(e),
      l = t - r,
      o = 10,
      c = 0;
  !function t() {
    var i = easeOutCubic(c += o, r, l, a);
    scrollTo(e, i), c < a ? raf_1(t) : n(e);
  }();
}

function scrollIntoView(e, t) {
  var a = e.getBoundingClientRect(),
      n = t.getBoundingClientRect(),
      r = t.offsetHeight / 3;
  n.bottom + r > a.bottom ? scrollTo(e, Math.min(t.offsetTop + t.clientHeight - e.offsetHeight + r, e.scrollHeight)) : n.top - r < a.top && scrollTo(e, Math.max(t.offsetTop - r, 0));
}

function getBoundingClientObj(e) {
  var t = e.getBoundingClientRect();
  return {
    bottom: t.bottom,
    height: t.height,
    left: t.left,
    right: t.right,
    top: t.top,
    width: t.width
  };
}

function isTouchCapable() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch (e) {
    return !1;
  }
}

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return !1;
  }
}

function getMenuPlacement(e) {
  var t = e.maxHeight,
      a = e.menuEl,
      n = e.minHeight,
      r = e.placement,
      l = e.shouldScroll,
      o = e.isFixedPosition,
      c = e.theme.spacing,
      i = getScrollParent(a),
      s = {
    placement: "bottom",
    maxHeight: t
  };
  if (!a || !a.offsetParent) return s;
  var u = i.getBoundingClientRect().height,
      f = a.getBoundingClientRect(),
      d = f.bottom,
      p = f.height,
      h = f.top,
      m = a.offsetParent.getBoundingClientRect().top,
      _ = window.innerHeight,
      v = getScrollTop(i),
      y = parseInt(getComputedStyle(a).marginBottom, 10),
      g = parseInt(getComputedStyle(a).marginTop, 10),
      E = m - g,
      b = _ - h,
      z = E + v,
      R = u - v - h,
      M = d - _ + v + y,
      w = v + h - g;

  switch (r) {
    case "auto":
    case "bottom":
      if (b >= p) return {
        placement: "bottom",
        maxHeight: t
      };
      if (R >= p && !o) return l && animatedScrollTo(i, M, 160), {
        placement: "bottom",
        maxHeight: t
      };
      if (!o && R >= n || o && b >= n) return l && animatedScrollTo(i, M, 160), {
        placement: "bottom",
        maxHeight: o ? b - y : R - y
      };

      if ("auto" === r || o) {
        var O = t;
        return (!o && z >= n || o && E >= n) && (O = o ? E - y - c.controlHeight : z - y - c.controlHeight), {
          placement: "top",
          maxHeight: O
        };
      }

      if ("bottom" === r) return scrollTo(i, M), {
        placement: "bottom",
        maxHeight: t
      };
      break;

    case "top":
      if (E >= p) return {
        placement: "top",
        maxHeight: t
      };
      if (z >= p && !o) return l && animatedScrollTo(i, w, 160), {
        placement: "top",
        maxHeight: t
      };

      if (!o && z >= n || o && E >= n) {
        var C = t;
        return (!o && z >= n || o && E >= n) && (C = o ? E - g : z - g), l && animatedScrollTo(i, w, 160), {
          placement: "top",
          maxHeight: C
        };
      }

      return {
        placement: "bottom",
        maxHeight: t
      };

    default:
      throw new Error('Invalid placement provided "' + r + '".');
  }

  return s;
}

function alignToControl(e) {
  return e ? {
    bottom: "top",
    top: "bottom"
  }[e] : "bottom";
}

var coercePlacement = function coercePlacement(e) {
  return "auto" === e ? "bottom" : e;
},
    menuCSS = function menuCSS(e) {
  var t,
      a = e.placement,
      n = e.theme,
      r = n.borderRadius,
      l = n.spacing,
      o = n.colors;
  return defineProperty$1(t = {}, alignToControl(a), "100%"), defineProperty$1(t, "backgroundColor", o.neutral0), defineProperty$1(t, "borderRadius", r), defineProperty$1(t, "boxShadow", "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)"), defineProperty$1(t, "marginBottom", l.menuGutter), defineProperty$1(t, "marginTop", l.menuGutter), defineProperty$1(t, "position", "absolute"), defineProperty$1(t, "width", "100%"), defineProperty$1(t, "zIndex", 1), t;
},
    MenuPlacer = function (e) {
  function t() {
    var e, a, n;
    classCallCheck$1(this, t);

    for (var r = arguments.length, l = Array(r), o = 0; o < r; o++) {
      l[o] = arguments[o];
    }

    return a = n = possibleConstructorReturn$1(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), n.state = {
      maxHeight: n.props.maxMenuHeight,
      placement: null
    }, n.getPlacement = function (e) {
      var t = n.props,
          a = t.minMenuHeight,
          r = t.maxMenuHeight,
          l = t.menuPlacement,
          o = t.menuPosition,
          c = t.menuShouldScrollIntoView,
          i = t.theme,
          s = n.context.getPortalPlacement;

      if (e) {
        var u = "fixed" === o,
            f = getMenuPlacement({
          maxHeight: r,
          menuEl: e,
          minHeight: a,
          placement: l,
          shouldScroll: c && !u,
          isFixedPosition: u,
          theme: i
        });
        s && s(f), n.setState(f);
      }
    }, n.getUpdatedProps = function () {
      var e = n.props.menuPlacement,
          t = n.state.placement || coercePlacement(e);
      return _extends$108({}, n.props, {
        placement: t,
        maxHeight: n.state.maxHeight
      });
    }, possibleConstructorReturn$1(n, a);
  }

  return inherits$1(t, e), createClass$1(t, [{
    key: "render",
    value: function value() {
      return (0, this.props.children)({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]), t;
}(React.Component);

MenuPlacer.contextTypes = {
  getPortalPlacement: PropTypes.func
};

var Menu = function Menu(e) {
  var t = e.children,
      a = e.className,
      n = e.cx,
      r = e.getStyles,
      l = e.innerRef,
      o = e.innerProps,
      c = n(css(r("menu", e)), {
    menu: !0
  }, a);
  return React__default.createElement("div", _extends$108({
    className: c
  }, o, {
    ref: l
  }), t);
},
    menuListCSS = function menuListCSS(e) {
  var t = e.maxHeight,
      a = e.theme.spacing.baseUnit;
  return {
    maxHeight: t,
    overflowY: "auto",
    paddingBottom: a,
    paddingTop: a,
    position: "relative",
    WebkitOverflowScrolling: "touch"
  };
},
    MenuList = function MenuList(e) {
  var t = e.children,
      a = e.className,
      n = e.cx,
      r = e.getStyles,
      l = e.isMulti,
      o = e.innerRef;
  return React__default.createElement("div", {
    className: n(css(r("menuList", e)), {
      "menu-list": !0,
      "menu-list--is-multi": l
    }, a),
    ref: o
  }, t);
},
    noticeCSS = function noticeCSS(e) {
  var t = e.theme,
      a = t.spacing.baseUnit;
  return {
    color: t.colors.neutral40,
    padding: 2 * a + "px " + 3 * a + "px",
    textAlign: "center"
  };
},
    noOptionsMessageCSS = noticeCSS,
    loadingMessageCSS = noticeCSS,
    NoOptionsMessage = function NoOptionsMessage(e) {
  var t = e.children,
      a = e.className,
      n = e.cx,
      r = e.getStyles,
      l = e.innerProps;
  return React__default.createElement("div", _extends$108({
    className: n(css(r("noOptionsMessage", e)), {
      "menu-notice": !0,
      "menu-notice--no-options": !0
    }, a)
  }, l), t);
};

NoOptionsMessage.defaultProps = {
  children: "No options"
};

var LoadingMessage = function LoadingMessage(e) {
  var t = e.children,
      a = e.className,
      n = e.cx,
      r = e.getStyles,
      l = e.innerProps;
  return React__default.createElement("div", _extends$108({
    className: n(css(r("loadingMessage", e)), {
      "menu-notice": !0,
      "menu-notice--loading": !0
    }, a)
  }, l), t);
};

LoadingMessage.defaultProps = {
  children: "Loading..."
};

var menuPortalCSS = function menuPortalCSS(e) {
  var t = e.rect,
      a = e.offset,
      n = e.position;
  return {
    left: t.left,
    position: n,
    top: a,
    width: t.width,
    zIndex: 1
  };
},
    MenuPortal = function (e) {
  function t() {
    var e, a, n;
    classCallCheck$1(this, t);

    for (var r = arguments.length, l = Array(r), o = 0; o < r; o++) {
      l[o] = arguments[o];
    }

    return a = n = possibleConstructorReturn$1(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), n.state = {
      placement: null
    }, n.getPortalPlacement = function (e) {
      var t = e.placement;
      t !== coercePlacement(n.props.menuPlacement) && n.setState({
        placement: t
      });
    }, possibleConstructorReturn$1(n, a);
  }

  return inherits$1(t, e), createClass$1(t, [{
    key: "getChildContext",
    value: function value() {
      return {
        getPortalPlacement: this.getPortalPlacement
      };
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.appendTo,
          a = e.children,
          n = e.controlElement,
          r = e.menuPlacement,
          l = e.menuPosition,
          o = e.getStyles,
          c = "fixed" === l;
      if (!t && !c || !n) return null;
      var i = this.state.placement || coercePlacement(r),
          s = getBoundingClientObj(n),
          u = c ? 0 : window.pageYOffset,
          f = {
        offset: s[i] + u,
        position: l,
        rect: s
      },
          d = React__default.createElement("div", {
        className: css(o("menuPortal", f))
      }, a);
      return t ? ReactDOM.createPortal(d, t) : d;
    }
  }]), t;
}(React.Component);

MenuPortal.childContextTypes = {
  getPortalPlacement: PropTypes.func
};
var isArray = Array.isArray,
    keyList = Object.keys,
    hasProp = Object.prototype.hasOwnProperty;

function equal(e, t) {
  if (e === t) return !0;

  if (e && t && "object" == (void 0 === e ? "undefined" : _typeof$1(e)) && "object" == (void 0 === t ? "undefined" : _typeof$1(t))) {
    var a,
        n,
        r,
        l = isArray(e),
        o = isArray(t);

    if (l && o) {
      if ((n = e.length) != t.length) return !1;

      for (a = n; 0 != a--;) {
        if (!equal(e[a], t[a])) return !1;
      }

      return !0;
    }

    if (l != o) return !1;
    var c = e instanceof Date,
        i = t instanceof Date;
    if (c != i) return !1;
    if (c && i) return e.getTime() == t.getTime();
    var s = e instanceof RegExp,
        u = t instanceof RegExp;
    if (s != u) return !1;
    if (s && u) return e.toString() == t.toString();
    var f = keyList(e);
    if ((n = f.length) !== keyList(t).length) return !1;

    for (a = n; 0 != a--;) {
      if (!hasProp.call(t, f[a])) return !1;
    }

    for (a = n; 0 != a--;) {
      if (!("_owner" === (r = f[a]) && e.$$typeof || equal(e[r], t[r]))) return !1;
    }

    return !0;
  }

  return e != e && t != t;
}

function exportedEqual(e, t) {
  try {
    return equal(e, t);
  } catch (e) {
    if (e.message && e.message.match(/stack|recursion/i)) return console.warn("Warning: react-fast-compare does not handle circular references.", e.name, e.message), !1;
    throw e;
  }
}

var diacritics = [{
  base: "A",
  letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
}, {
  base: "AA",
  letters: /[\uA732]/g
}, {
  base: "AE",
  letters: /[\u00C6\u01FC\u01E2]/g
}, {
  base: "AO",
  letters: /[\uA734]/g
}, {
  base: "AU",
  letters: /[\uA736]/g
}, {
  base: "AV",
  letters: /[\uA738\uA73A]/g
}, {
  base: "AY",
  letters: /[\uA73C]/g
}, {
  base: "B",
  letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
}, {
  base: "C",
  letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
}, {
  base: "D",
  letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
}, {
  base: "DZ",
  letters: /[\u01F1\u01C4]/g
}, {
  base: "Dz",
  letters: /[\u01F2\u01C5]/g
}, {
  base: "E",
  letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
}, {
  base: "F",
  letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
}, {
  base: "G",
  letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
}, {
  base: "H",
  letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
}, {
  base: "I",
  letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
}, {
  base: "J",
  letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g
}, {
  base: "K",
  letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
}, {
  base: "L",
  letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
}, {
  base: "LJ",
  letters: /[\u01C7]/g
}, {
  base: "Lj",
  letters: /[\u01C8]/g
}, {
  base: "M",
  letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
}, {
  base: "N",
  letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
}, {
  base: "NJ",
  letters: /[\u01CA]/g
}, {
  base: "Nj",
  letters: /[\u01CB]/g
}, {
  base: "O",
  letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
}, {
  base: "OI",
  letters: /[\u01A2]/g
}, {
  base: "OO",
  letters: /[\uA74E]/g
}, {
  base: "OU",
  letters: /[\u0222]/g
}, {
  base: "P",
  letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
}, {
  base: "Q",
  letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
}, {
  base: "R",
  letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
}, {
  base: "S",
  letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
}, {
  base: "T",
  letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
}, {
  base: "TZ",
  letters: /[\uA728]/g
}, {
  base: "U",
  letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
}, {
  base: "V",
  letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
}, {
  base: "VY",
  letters: /[\uA760]/g
}, {
  base: "W",
  letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
}, {
  base: "X",
  letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
}, {
  base: "Y",
  letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
}, {
  base: "Z",
  letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
}, {
  base: "a",
  letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
}, {
  base: "aa",
  letters: /[\uA733]/g
}, {
  base: "ae",
  letters: /[\u00E6\u01FD\u01E3]/g
}, {
  base: "ao",
  letters: /[\uA735]/g
}, {
  base: "au",
  letters: /[\uA737]/g
}, {
  base: "av",
  letters: /[\uA739\uA73B]/g
}, {
  base: "ay",
  letters: /[\uA73D]/g
}, {
  base: "b",
  letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
}, {
  base: "c",
  letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
}, {
  base: "d",
  letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
}, {
  base: "dz",
  letters: /[\u01F3\u01C6]/g
}, {
  base: "e",
  letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
}, {
  base: "f",
  letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
}, {
  base: "g",
  letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
}, {
  base: "h",
  letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
}, {
  base: "hv",
  letters: /[\u0195]/g
}, {
  base: "i",
  letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
}, {
  base: "j",
  letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
}, {
  base: "k",
  letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
}, {
  base: "l",
  letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
}, {
  base: "lj",
  letters: /[\u01C9]/g
}, {
  base: "m",
  letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
}, {
  base: "n",
  letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
}, {
  base: "nj",
  letters: /[\u01CC]/g
}, {
  base: "o",
  letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
}, {
  base: "oi",
  letters: /[\u01A3]/g
}, {
  base: "ou",
  letters: /[\u0223]/g
}, {
  base: "oo",
  letters: /[\uA74F]/g
}, {
  base: "p",
  letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
}, {
  base: "q",
  letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
}, {
  base: "r",
  letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
}, {
  base: "s",
  letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
}, {
  base: "t",
  letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
}, {
  base: "tz",
  letters: /[\uA729]/g
}, {
  base: "u",
  letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
}, {
  base: "v",
  letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
}, {
  base: "vy",
  letters: /[\uA761]/g
}, {
  base: "w",
  letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
}, {
  base: "x",
  letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
}, {
  base: "y",
  letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
}, {
  base: "z",
  letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
}],
    stripDiacritics = function stripDiacritics(e) {
  for (var t = 0; t < diacritics.length; t++) {
    e = e.replace(diacritics[t].letters, diacritics[t].base);
  }

  return e;
},
    trimString = function trimString(e) {
  return e.replace(/^\s+|\s+$/g, "");
},
    defaultStringify = function defaultStringify(e) {
  return e.label + " " + e.value;
},
    createFilter = function createFilter(e) {
  return function (t, a) {
    var n = _extends$108({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: defaultStringify,
      trim: !0,
      matchFrom: "any"
    }, e),
        r = n.ignoreCase,
        l = n.ignoreAccents,
        o = n.stringify,
        c = n.trim,
        i = n.matchFrom,
        s = c ? trimString(a) : a,
        u = c ? trimString(o(t)) : o(t);

    return r && (s = s.toLowerCase(), u = u.toLowerCase()), l && (s = stripDiacritics(s), u = stripDiacritics(u)), "start" === i ? u.substr(0, s.length) === s : u.indexOf(s) > -1;
  };
},
    A11yText = function A11yText(e) {
  return React__default.createElement("span", _extends$108({
    className: css({
      zIndex: 9999,
      border: 0,
      clip: "rect(1px, 1px, 1px, 1px)",
      height: 1,
      width: 1,
      position: "absolute",
      overflow: "hidden",
      padding: 0,
      whiteSpace: "nowrap",
      backgroundColor: "red",
      color: "blue"
    })
  }, e));
},
    DummyInput = function (e) {
  function t() {
    return classCallCheck$1(this, t), possibleConstructorReturn$1(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
  }

  return inherits$1(t, e), createClass$1(t, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = (e.in, e.out, e.onExited, e.appear, e.enter, e.exit, e.innerRef),
          a = objectWithoutProperties$1(e, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef"]);
      return React__default.createElement("input", _extends$108({
        ref: t
      }, a, {
        className: css({
          background: 0,
          border: 0,
          fontSize: "inherit",
          outline: 0,
          padding: 0,
          width: 1,
          color: "transparent",
          left: -100,
          opacity: 0,
          position: "relative",
          transform: "scale(0)"
        })
      }));
    }
  }]), t;
}(React.Component),
    NodeResolver = function (e) {
  function t() {
    return classCallCheck$1(this, t), possibleConstructorReturn$1(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
  }

  return inherits$1(t, e), createClass$1(t, [{
    key: "componentDidMount",
    value: function value() {
      this.props.innerRef(ReactDOM.findDOMNode(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.props.innerRef(null);
    }
  }, {
    key: "render",
    value: function value() {
      return this.props.children;
    }
  }]), t;
}(React.Component),
    STYLE_KEYS = ["boxSizing", "height", "overflow", "paddingRight", "position"],
    LOCK_STYLES = {
  boxSizing: "border-box",
  overflow: "hidden",
  position: "relative",
  height: "100%"
};

function preventTouchMove(e) {
  e.preventDefault();
}

function allowTouchMove(e) {
  e.stopPropagation();
}

function preventInertiaScroll() {
  var e = this.scrollTop,
      t = this.scrollHeight,
      a = e + this.offsetHeight;
  0 === e ? this.scrollTop = 1 : a === t && (this.scrollTop = e - 1);
}

function isTouchDevice() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}

var canUseDOM = !("undefined" == typeof window || !window.document || !window.document.createElement),
    activeScrollLocks = 0,
    ScrollLock = function (e) {
  function t() {
    var e, a, n;
    classCallCheck$1(this, t);

    for (var r = arguments.length, l = Array(r), o = 0; o < r; o++) {
      l[o] = arguments[o];
    }

    return a = n = possibleConstructorReturn$1(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), n.originalStyles = {}, n.listenerOptions = {
      capture: !1,
      passive: !1
    }, possibleConstructorReturn$1(n, a);
  }

  return inherits$1(t, e), createClass$1(t, [{
    key: "componentDidMount",
    value: function value() {
      var e = this;

      if (canUseDOM) {
        var t = this.props,
            a = t.accountForScrollbars,
            n = t.touchScrollTarget,
            r = document.body,
            l = r && r.style;

        if (a && STYLE_KEYS.forEach(function (t) {
          var a = l && l[t];
          e.originalStyles[t] = a;
        }), a && activeScrollLocks < 1) {
          var o = parseInt(this.originalStyles.paddingRight, 10) || 0,
              c = document.body ? document.body.clientWidth : 0,
              i = window.innerWidth - c + o || 0;
          Object.keys(LOCK_STYLES).forEach(function (e) {
            var t = LOCK_STYLES[e];
            l && (l[e] = t);
          }), l && (l.paddingRight = i + "px");
        }

        r && isTouchDevice() && (r.addEventListener("touchmove", preventTouchMove, this.listenerOptions), n && (n.addEventListener("touchstart", preventInertiaScroll, this.listenerOptions), n.addEventListener("touchmove", allowTouchMove, this.listenerOptions))), activeScrollLocks += 1;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      var e = this;

      if (canUseDOM) {
        var t = this.props,
            a = t.accountForScrollbars,
            n = t.touchScrollTarget,
            r = document.body,
            l = r && r.style;
        activeScrollLocks = Math.max(activeScrollLocks - 1, 0), a && activeScrollLocks < 1 && STYLE_KEYS.forEach(function (t) {
          var a = e.originalStyles[t];
          l && (l[t] = a);
        }), r && isTouchDevice() && (r.removeEventListener("touchmove", preventTouchMove, this.listenerOptions), n && (n.removeEventListener("touchstart", preventInertiaScroll, this.listenerOptions), n.removeEventListener("touchmove", allowTouchMove, this.listenerOptions)));
      }
    }
  }, {
    key: "render",
    value: function value() {
      return null;
    }
  }]), t;
}(React.Component);

ScrollLock.defaultProps = {
  accountForScrollbars: !0
};

var ScrollBlock = function (e) {
  function t() {
    var e, a, n;
    classCallCheck$1(this, t);

    for (var r = arguments.length, l = Array(r), o = 0; o < r; o++) {
      l[o] = arguments[o];
    }

    return a = n = possibleConstructorReturn$1(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), n.state = {
      touchScrollTarget: null
    }, n.getScrollTarget = function (e) {
      e !== n.state.touchScrollTarget && n.setState({
        touchScrollTarget: e
      });
    }, n.blurSelectInput = function () {
      document.activeElement && document.activeElement.blur();
    }, possibleConstructorReturn$1(n, a);
  }

  return inherits$1(t, e), createClass$1(t, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.children,
          a = e.isEnabled,
          n = this.state.touchScrollTarget;
      return a ? React__default.createElement("div", null, React__default.createElement("div", {
        onClick: this.blurSelectInput,
        className: css({
          position: "fixed",
          left: 0,
          bottom: 0,
          right: 0,
          top: 0
        })
      }), React__default.createElement(NodeResolver, {
        innerRef: this.getScrollTarget
      }, t), n ? React__default.createElement(ScrollLock, {
        touchScrollTarget: n
      }) : null) : t;
    }
  }]), t;
}(React.PureComponent),
    ScrollCaptor = function (e) {
  function t() {
    var e, a, n;
    classCallCheck$1(this, t);

    for (var r = arguments.length, l = Array(r), o = 0; o < r; o++) {
      l[o] = arguments[o];
    }

    return a = n = possibleConstructorReturn$1(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), n.isBottom = !1, n.isTop = !1, n.cancelScroll = function (e) {
      e.preventDefault(), e.stopPropagation();
    }, n.handleEventDelta = function (e, t) {
      var a = n.props,
          r = a.onBottomArrive,
          l = a.onBottomLeave,
          o = a.onTopArrive,
          c = a.onTopLeave,
          i = n.scrollTarget,
          s = i.scrollTop,
          u = i.scrollHeight,
          f = i.clientHeight,
          d = n.scrollTarget,
          p = t > 0,
          h = u - f - s,
          m = !1;
      h > t && n.isBottom && (l && l(e), n.isBottom = !1), p && n.isTop && (c && c(e), n.isTop = !1), p && t > h ? (r && !n.isBottom && r(e), d.scrollTop = u, m = !0, n.isBottom = !0) : !p && -t > s && (o && !n.isTop && o(e), d.scrollTop = 0, m = !0, n.isTop = !0), m && n.cancelScroll(e);
    }, n.onWheel = function (e) {
      n.handleEventDelta(e, e.deltaY);
    }, n.onTouchStart = function (e) {
      n.touchStart = e.changedTouches[0].clientY;
    }, n.onTouchMove = function (e) {
      var t = n.touchStart - e.changedTouches[0].clientY;
      n.handleEventDelta(e, t);
    }, n.getScrollTarget = function (e) {
      n.scrollTarget = e;
    }, possibleConstructorReturn$1(n, a);
  }

  return inherits$1(t, e), createClass$1(t, [{
    key: "componentDidMount",
    value: function value() {
      this.startListening(this.scrollTarget);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.stopListening(this.scrollTarget);
    }
  }, {
    key: "startListening",
    value: function value(e) {
      e.scrollHeight <= e.clientHeight || ("function" == typeof e.addEventListener && e.addEventListener("wheel", this.onWheel, !1), "function" == typeof e.addEventListener && e.addEventListener("touchstart", this.onTouchStart, !1), "function" == typeof e.addEventListener && e.addEventListener("touchmove", this.onTouchMove, !1));
    }
  }, {
    key: "stopListening",
    value: function value(e) {
      e.scrollHeight <= e.clientHeight || ("function" == typeof e.removeEventListener && e.removeEventListener("wheel", this.onWheel, !1), "function" == typeof e.removeEventListener && e.removeEventListener("touchstart", this.onTouchStart, !1), "function" == typeof e.removeEventListener && e.removeEventListener("touchmove", this.onTouchMove, !1));
    }
  }, {
    key: "render",
    value: function value() {
      return React__default.createElement(NodeResolver, {
        innerRef: this.getScrollTarget
      }, this.props.children);
    }
  }]), t;
}(React.Component),
    ScrollCaptorSwitch = function (e) {
  function t() {
    return classCallCheck$1(this, t), possibleConstructorReturn$1(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
  }

  return inherits$1(t, e), createClass$1(t, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.isEnabled,
          a = objectWithoutProperties$1(e, ["isEnabled"]);
      return t ? React__default.createElement(ScrollCaptor, a) : this.props.children;
    }
  }]), t;
}(React.Component);

ScrollCaptorSwitch.defaultProps = {
  isEnabled: !0
};

var instructionsAriaMessage = function instructionsAriaMessage(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      a = t.isSearchable,
      n = t.isMulti,
      r = t.label;

  switch (e) {
    case "menu":
      return "Use Up and Down to choose options, press Backspace to select the currently focused option, press Escape to exit the menu, press Tab to select the option and exit the menu.";

    case "input":
      return (r || "Select") + " is focused " + (a ? ",type to refine list" : "") + ", press Down to open the menu, " + (n ? " press left to focus selected values" : "");

    case "value":
      return "Use left and right to toggle between focused values, press Enter to remove the currently focused value";
  }
},
    valueEventAriaMessage = function valueEventAriaMessage(e, t) {
  var a = t.value;
  if (a) switch (e) {
    case "deselect-option":
    case "pop-value":
    case "remove-value":
      return "option " + a + ", deselected.";

    case "select-option":
      return "option " + a + ", selected.";
  }
},
    valueFocusAriaMessage = function valueFocusAriaMessage(e) {
  var t = e.focusedValue,
      a = e.getOptionLabel,
      n = e.selectValue;
  return "value " + a(t) + " focused, " + (n.indexOf(t) + 1) + " of " + n.length + ".";
},
    optionFocusAriaMessage = function optionFocusAriaMessage(e) {
  var t = e.focusedOption,
      a = e.getOptionLabel,
      n = e.options;
  return "option " + a(t) + " focused, " + (n.indexOf(t) + 1) + " of " + n.length + ".";
},
    resultsAriaMessage = function resultsAriaMessage(e) {
  var t = e.inputValue;
  return e.screenReaderMessage + (t ? " for search term " + t : "") + ".";
},
    formatGroupLabel = function formatGroupLabel(e) {
  return e.label;
},
    getOptionLabel = function getOptionLabel(e) {
  return e.label;
},
    getOptionValue = function getOptionValue(e) {
  return e.value;
},
    isOptionDisabled = function isOptionDisabled(e) {
  return !!e.isDisabled;
},
    containerCSS = function containerCSS(e) {
  var t = e.isDisabled;
  return {
    direction: e.isRtl ? "rtl" : null,
    pointerEvents: t ? "none" : null,
    position: "relative"
  };
},
    SelectContainer = function SelectContainer(e) {
  var t = e.children,
      a = e.className,
      n = e.cx,
      r = e.getStyles,
      l = e.innerProps,
      o = e.isDisabled,
      c = e.isRtl;
  return React__default.createElement("div", _extends$108({
    className: n(css(r("container", e)), {
      "--is-disabled": o,
      "--is-rtl": c
    }, a)
  }, l), t);
},
    valueContainerCSS = function valueContainerCSS(e) {
  var t = e.theme.spacing;
  return {
    alignItems: "center",
    display: "flex",
    flex: 1,
    flexWrap: "wrap",
    padding: t.baseUnit / 2 + "px " + 2 * t.baseUnit + "px",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  };
},
    ValueContainer = function (e) {
  function t() {
    return classCallCheck$1(this, t), possibleConstructorReturn$1(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
  }

  return inherits$1(t, e), createClass$1(t, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.children,
          a = e.className,
          n = e.cx,
          r = e.isMulti,
          l = e.getStyles,
          o = e.hasValue;
      return React__default.createElement("div", {
        className: n(css(l("valueContainer", this.props)), {
          "value-container": !0,
          "value-container--is-multi": r,
          "value-container--has-value": o
        }, a)
      }, t);
    }
  }]), t;
}(React.Component),
    indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
},
    IndicatorsContainer = function IndicatorsContainer(e) {
  var t = e.children,
      a = e.className,
      n = e.cx,
      r = e.getStyles;
  return React__default.createElement("div", {
    className: n(css(r("indicatorsContainer", e)), {
      indicators: !0
    }, a)
  }, t);
},
    Svg = function Svg(e) {
  var t = e.size,
      a = objectWithoutProperties$1(e, ["size"]);
  return React__default.createElement("svg", _extends$108({
    height: t,
    width: t,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    className: css({
      display: "inline-block",
      fill: "currentColor",
      lineHeight: 1,
      stroke: "currentColor",
      strokeWidth: 0
    })
  }, a));
},
    CrossIcon = function CrossIcon(e) {
  return React__default.createElement(Svg, _extends$108({
    size: 20
  }, e), React__default.createElement("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
},
    DownChevron = function DownChevron(e) {
  return React__default.createElement(Svg, _extends$108({
    size: 20
  }, e), React__default.createElement("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
},
    baseCSS = function baseCSS(e) {
  var t = e.isFocused,
      a = e.theme,
      n = a.spacing.baseUnit,
      r = a.colors;
  return {
    color: t ? r.neutral60 : r.neutral20,
    display: "flex",
    padding: 2 * n,
    transition: "color 150ms",
    ":hover": {
      color: t ? r.neutral80 : r.neutral40
    }
  };
},
    dropdownIndicatorCSS = baseCSS,
    DropdownIndicator = function DropdownIndicator(e) {
  var t = e.children,
      a = e.className,
      n = e.cx,
      r = e.getStyles,
      l = e.innerProps;
  return React__default.createElement("div", _extends$108({}, l, {
    className: n(css(r("dropdownIndicator", e)), {
      indicator: !0,
      "dropdown-indicator": !0
    }, a)
  }), t);
};

DropdownIndicator.defaultProps = {
  children: React__default.createElement(DownChevron, null)
};

var clearIndicatorCSS = baseCSS,
    ClearIndicator = function ClearIndicator(e) {
  var t = e.children,
      a = e.className,
      n = e.cx,
      r = e.getStyles,
      l = e.innerProps;
  return React__default.createElement("div", _extends$108({}, l, {
    className: n(css(r("clearIndicator", e)), {
      indicator: !0,
      "clear-indicator": !0
    }, a)
  }), t);
};

ClearIndicator.defaultProps = {
  children: React__default.createElement(CrossIcon, null)
};

var indicatorSeparatorCSS = function indicatorSeparatorCSS(e) {
  var t = e.isDisabled,
      a = e.theme,
      n = a.spacing.baseUnit,
      r = a.colors;
  return {
    alignSelf: "stretch",
    backgroundColor: t ? r.neutral10 : r.neutral20,
    marginBottom: 2 * n,
    marginTop: 2 * n,
    width: 1
  };
},
    IndicatorSeparator = function IndicatorSeparator(e) {
  var t = e.className,
      a = e.cx,
      n = e.getStyles,
      r = e.innerProps;
  return React__default.createElement("span", _extends$108({}, r, {
    className: a(css(n("indicatorSeparator", e)), {
      "indicator-separator": !0
    }, t)
  }));
},
    keyframesName = "react-select-loading-indicator",
    loadingIndicatorCSS = function loadingIndicatorCSS(e) {
  var t = e.isFocused,
      a = e.size,
      n = e.theme,
      r = n.colors,
      l = n.spacing.baseUnit;
  return {
    color: t ? r.neutral60 : r.neutral20,
    display: "flex",
    padding: 2 * l,
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: a,
    lineHeight: 1,
    marginRight: a,
    textAlign: "center",
    verticalAlign: "middle"
  };
},
    LoadingDot = function LoadingDot(e) {
  var t = e.color,
      a = e.delay,
      n = e.offset;
  return React__default.createElement("span", {
    className: css({
      animationDuration: "1s",
      animationDelay: a + "ms",
      animationIterationCount: "infinite",
      animationName: keyframesName,
      animationTimingFunction: "ease-in-out",
      backgroundColor: t,
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: n ? "1em" : null,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    })
  });
};

injectGlobal("@keyframes ", keyframesName, "{0%,80%,100%{opacity:0;}40%{opacity:1;}};");

var LoadingIndicator = function LoadingIndicator(e) {
  var t = e.className,
      a = e.cx,
      n = e.getStyles,
      r = e.innerProps,
      l = e.isFocused,
      o = e.isRtl,
      c = e.theme.colors,
      i = l ? c.neutral80 : c.neutral20;
  return React__default.createElement("div", _extends$108({}, r, {
    className: a(css(n("loadingIndicator", e)), {
      indicator: !0,
      "loading-indicator": !0
    }, t)
  }), React__default.createElement(LoadingDot, {
    color: i,
    delay: 0,
    offset: o
  }), React__default.createElement(LoadingDot, {
    color: i,
    delay: 160,
    offset: !0
  }), React__default.createElement(LoadingDot, {
    color: i,
    delay: 320,
    offset: !o
  }));
};

LoadingIndicator.defaultProps = {
  size: 4
};

var css$1 = function css$1(e) {
  var t = e.isDisabled,
      a = e.isFocused,
      n = e.theme,
      r = n.colors,
      l = n.borderRadius,
      o = n.spacing;
  return {
    alignItems: "center",
    backgroundColor: t ? r.neutral5 : r.neutral0,
    borderColor: t ? r.neutral10 : a ? r.primary : r.neutral20,
    borderRadius: l,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: a ? "0 0 0 1px " + r.primary : null,
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: o.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms",
    "&:hover": {
      borderColor: a ? r.primary : r.neutral30
    }
  };
},
    Control = function Control(e) {
  var t = e.children,
      a = e.cx,
      n = e.getStyles,
      r = e.className,
      l = e.isDisabled,
      o = e.isFocused,
      c = e.innerRef,
      i = e.innerProps;
  return React__default.createElement("div", _extends$108({
    ref: c,
    className: a(css(n("control", e)), {
      control: !0,
      "control--is-disabled": l,
      "control--is-focused": o
    }, r)
  }, i), t);
},
    groupCSS = function groupCSS(e) {
  var t = e.theme.spacing;
  return {
    paddingBottom: 2 * t.baseUnit,
    paddingTop: 2 * t.baseUnit
  };
},
    Group = function Group(e) {
  var t = e.children,
      a = e.className,
      n = e.cx,
      r = e.getStyles,
      l = e.Heading,
      o = e.headingProps,
      c = e.label,
      i = e.theme;
  return React__default.createElement("div", {
    className: n(css(r("group", e)), {
      group: !0
    }, a)
  }, React__default.createElement(l, _extends$108({}, o, {
    theme: i,
    getStyles: r,
    cx: n
  }), c), React__default.createElement("div", null, t));
},
    groupHeadingCSS = function groupHeadingCSS(e) {
  var t = e.theme.spacing;
  return {
    color: "#999",
    cursor: "default",
    display: "block",
    fontSize: "75%",
    fontWeight: "500",
    marginBottom: "0.25em",
    paddingLeft: 3 * t.baseUnit,
    paddingRight: 3 * t.baseUnit,
    textTransform: "uppercase"
  };
},
    GroupHeading = function GroupHeading(e) {
  var t = e.className,
      a = e.cx,
      n = e.getStyles,
      r = e.theme,
      l = objectWithoutProperties$1(e, ["className", "cx", "getStyles", "theme"]);
  return React__default.createElement("div", _extends$108({
    className: a(css(n("groupHeading", _extends$108({
      theme: r
    }, l))), {
      "group-heading": !0
    }, t)
  }, l));
},
    inputCSS = function inputCSS(e) {
  var t = e.isDisabled,
      a = e.theme,
      n = a.spacing,
      r = a.colors;
  return {
    margin: n.baseUnit / 2,
    paddingBottom: n.baseUnit / 2,
    paddingTop: n.baseUnit / 2,
    visibility: t ? "hidden" : "visible",
    color: r.neutral80
  };
},
    inputStyle = function inputStyle(e) {
  return {
    background: 0,
    border: 0,
    fontSize: "inherit",
    opacity: e ? 0 : 1,
    outline: 0,
    padding: 0,
    color: "inherit"
  };
},
    Input = function Input(e) {
  var t = e.className,
      a = e.cx,
      n = e.getStyles,
      r = e.innerRef,
      l = e.isHidden,
      o = e.isDisabled,
      c = e.theme,
      i = objectWithoutProperties$1(e, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme"]);
  return React__default.createElement("div", {
    className: css(n("input", _extends$108({
      theme: c
    }, i)))
  }, React__default.createElement(AutosizeInput, _extends$108({
    className: a(null, {
      input: !0
    }, t),
    inputRef: r,
    inputStyle: inputStyle(l),
    disabled: o
  }, i)));
},
    multiValueCSS = function multiValueCSS(e) {
  var t = e.theme,
      a = t.spacing,
      n = t.borderRadius;
  return {
    backgroundColor: t.colors.neutral10,
    borderRadius: n / 2,
    display: "flex",
    margin: a.baseUnit / 2,
    minWidth: 0
  };
},
    multiValueLabelCSS = function multiValueLabelCSS(e) {
  var t = e.theme,
      a = t.borderRadius,
      n = t.colors,
      r = e.cropWithEllipsis;
  return {
    borderRadius: a / 2,
    color: n.neutral80,
    fontSize: "85%",
    overflow: "hidden",
    padding: 3,
    paddingLeft: 6,
    textOverflow: r ? "ellipsis" : null,
    whiteSpace: "nowrap"
  };
},
    multiValueRemoveCSS = function multiValueRemoveCSS(e) {
  var t = e.theme,
      a = t.spacing,
      n = t.borderRadius,
      r = t.colors;
  return {
    alignItems: "center",
    borderRadius: n / 2,
    backgroundColor: e.isFocused && r.dangerLight,
    display: "flex",
    paddingLeft: a.baseUnit,
    paddingRight: a.baseUnit,
    ":hover": {
      backgroundColor: r.dangerLight,
      color: r.danger
    }
  };
},
    MultiValueGeneric = function MultiValueGeneric(e) {
  var t = e.children,
      a = e.innerProps;
  return React__default.createElement("div", a, t);
},
    MultiValueContainer = MultiValueGeneric,
    MultiValueLabel = MultiValueGeneric,
    MultiValueRemove = function (e) {
  function t() {
    return classCallCheck$1(this, t), possibleConstructorReturn$1(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
  }

  return inherits$1(t, e), createClass$1(t, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.children,
          a = e.innerProps;
      return React__default.createElement("div", a, t);
    }
  }]), t;
}(React.Component);

MultiValueRemove.defaultProps = {
  children: React__default.createElement(CrossIcon, {
    size: 14
  })
};

var MultiValue = function (e) {
  function t() {
    return classCallCheck$1(this, t), possibleConstructorReturn$1(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
  }

  return inherits$1(t, e), createClass$1(t, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.children,
          a = e.className,
          n = e.components,
          r = e.cx,
          l = e.data,
          o = e.getStyles,
          c = e.innerProps,
          i = e.isDisabled,
          s = e.removeProps,
          u = e.selectProps,
          f = n.Container,
          d = n.Label,
          p = n.Remove,
          h = _extends$108({
        className: r(css(o("multiValue", this.props)), {
          "multi-value": !0,
          "multi-value--is-disabled": i
        }, a)
      }, c),
          m = {
        className: r(css(o("multiValueLabel", this.props)), {
          "multi-value__label": !0
        }, a)
      },
          _ = _extends$108({
        className: r(css(o("multiValueRemove", this.props)), {
          "multi-value__remove": !0
        }, a)
      }, s);

      return React__default.createElement(f, {
        data: l,
        innerProps: h,
        selectProps: u
      }, React__default.createElement(d, {
        data: l,
        innerProps: m,
        selectProps: u
      }, t), React__default.createElement(p, {
        data: l,
        innerProps: _,
        selectProps: u
      }));
    }
  }]), t;
}(React.Component);

MultiValue.defaultProps = {
  cropWithEllipsis: !0
};

var optionCSS = function optionCSS(e) {
  var t = e.isDisabled,
      a = e.isFocused,
      n = e.isSelected,
      r = e.theme,
      l = r.spacing,
      o = r.colors;
  return {
    backgroundColor: n ? o.primary : a ? o.primary25 : "transparent",
    color: t ? o.neutral20 : n ? o.neutral0 : "inherit",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    padding: 2 * l.baseUnit + "px " + 3 * l.baseUnit + "px",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
    ":active": {
      backgroundColor: n ? o.primary : o.primary50
    }
  };
},
    Option = function Option(e) {
  var t = e.children,
      a = e.className,
      n = e.cx,
      r = e.getStyles,
      l = e.isDisabled,
      o = e.isFocused,
      c = e.isSelected,
      i = e.innerRef,
      s = e.innerProps;
  return React__default.createElement("div", _extends$108({
    ref: i,
    className: n(css(r("option", e)), {
      option: !0,
      "option--is-disabled": l,
      "option--is-focused": o,
      "option--is-selected": c
    }, a)
  }, s), t);
},
    placeholderCSS = function placeholderCSS(e) {
  var t = e.theme,
      a = t.spacing;
  return {
    color: t.colors.neutral50,
    marginLeft: a.baseUnit / 2,
    marginRight: a.baseUnit / 2,
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)"
  };
},
    Placeholder = function Placeholder(e) {
  var t = e.children,
      a = e.className,
      n = e.cx,
      r = e.getStyles,
      l = e.innerProps;
  return React__default.createElement("div", _extends$108({
    className: n(css(r("placeholder", e)), {
      placeholder: !0
    }, a)
  }, l), t);
},
    css$2 = function css$2(e) {
  var t = e.isDisabled,
      a = e.theme,
      n = a.spacing,
      r = a.colors;
  return {
    color: t ? r.neutral40 : r.neutral80,
    marginLeft: n.baseUnit / 2,
    marginRight: n.baseUnit / 2,
    maxWidth: "calc(100% - " + 2 * n.baseUnit + "px)",
    overflow: "hidden",
    position: "absolute",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    top: "50%",
    transform: "translateY(-50%)"
  };
},
    SingleValue = function SingleValue(e) {
  var t = e.children,
      a = e.className,
      n = e.cx,
      r = e.getStyles,
      l = e.isDisabled,
      o = e.innerProps;
  return React__default.createElement("div", _extends$108({
    className: n(css(r("singleValue", e)), {
      "single-value": !0,
      "single-value--is-disabled": l
    }, a)
  }, o), t);
},
    components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
},
    defaultComponents = function defaultComponents(e) {
  return _extends$108({}, components, e.components);
},
    defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css$2,
  valueContainer: valueContainerCSS
},
    colors = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
},
    borderRadius = 4,
    baseUnit = 4,
    controlHeight = 38,
    menuGutter = 2 * baseUnit,
    spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
},
    defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
},
    defaultProps = {
  backspaceRemovesValue: !0,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function screenReaderStatus(e) {
    var t = e.count;
    return t + " result" + (1 !== t ? "s" : "") + " available";
  },
  styles: {},
  tabIndex: "0",
  tabSelectsValue: !0
},
    instanceId = 1,
    Select = function (e) {
  function t(e) {
    classCallCheck$1(this, t);
    var a = possibleConstructorReturn$1(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

    _initialiseProps.call(a);

    var n = e.value;
    a.cacheComponents = index(a.cacheComponents, exportedEqual).bind(a), a.cacheComponents(e.components), a.instancePrefix = "react-select-" + (a.props.instanceId || ++instanceId);
    var r = cleanValue(n),
        l = a.buildMenuOptions(e, r);
    return a.state.menuOptions = l, a.state.selectValue = r, a;
  }

  return inherits$1(t, e), createClass$1(t, [{
    key: "componentDidMount",
    value: function value() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function value(e) {
      var t = this.props,
          a = t.options,
          n = t.value,
          r = t.inputValue;

      if (this.cacheComponents(e.components), e.value !== n || e.options !== a || e.inputValue !== r) {
        var l = cleanValue(e.value),
            o = this.buildMenuOptions(e, l),
            c = this.getNextFocusedValue(l),
            i = this.getNextFocusedOption(o.focusable);
        this.setState({
          menuOptions: o,
          selectValue: l,
          focusedOption: i,
          focusedValue: c
        });
      }

      null != this.inputIsHiddenAfterUpdate && (this.setState({
        inputIsHidden: this.inputIsHiddenAfterUpdate
      }), delete this.inputIsHiddenAfterUpdate);
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e) {
      var t = this.props,
          a = t.isDisabled,
          n = t.menuIsOpen,
          r = this.state.isFocused;
      (r && !a && e.isDisabled || r && n && !e.menuIsOpen) && this.focusInput(), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && scrollIntoView(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1;
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
  }, {
    key: "onMenuOpen",
    value: function value() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function value() {
      var e = this.props,
          t = e.isSearchable,
          a = e.isMulti;
      this.announceAriaLiveContext({
        event: "input",
        context: {
          isSearchable: t,
          isMulti: a
        }
      }), this.onInputChange("", {
        action: "menu-close"
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function value(e, t) {
      this.props.onInputChange(e, t);
    }
  }, {
    key: "focusInput",
    value: function value() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function value() {
      this.inputRef && this.inputRef.blur();
    }
  }, {
    key: "openMenu",
    value: function value(e) {
      var t = this.state,
          a = t.menuOptions,
          n = t.selectValue,
          r = this.props.isMulti,
          l = "first" === e ? 0 : a.focusable.length - 1;

      if (!r) {
        var o = a.focusable.indexOf(n[0]);
        o > -1 && (l = o);
      }

      this.scrollToFocusedOptionOnUpdate = !0, this.inputIsHiddenAfterUpdate = !1, this.onMenuOpen(), this.setState({
        focusedValue: null,
        focusedOption: a.focusable[l]
      }), this.announceAriaLiveContext({
        event: "menu"
      });
    }
  }, {
    key: "focusValue",
    value: function value(e) {
      var t = this.props,
          a = t.isMulti,
          n = t.isSearchable,
          r = this.state,
          l = r.selectValue,
          o = r.focusedValue;

      if (a) {
        this.setState({
          focusedOption: null
        });
        var c = l.indexOf(o);
        o || (c = -1, this.announceAriaLiveContext({
          event: "value"
        }));
        var i = l.length - 1,
            s = -1;

        if (l.length) {
          switch (e) {
            case "previous":
              s = 0 === c ? 0 : -1 === c ? i : c - 1;
              break;

            case "next":
              c > -1 && c < i && (s = c + 1);
          }

          -1 === s && this.announceAriaLiveContext({
            event: "input",
            context: {
              isSearchable: n,
              isMulti: a
            }
          }), this.setState({
            inputIsHidden: -1 !== s,
            focusedValue: l[s]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function value() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "first",
          t = this.props.pageSize,
          a = this.state,
          n = a.focusedOption,
          r = a.menuOptions.focusable;

      if (r.length) {
        var l = 0,
            o = r.indexOf(n);
        n || (o = -1, this.announceAriaLiveContext({
          event: "menu"
        })), "up" === e ? l = o > 0 ? o - 1 : r.length - 1 : "down" === e ? l = (o + 1) % r.length : "pageup" === e ? (l = o - t) < 0 && (l = 0) : "pagedown" === e ? (l = o + t) > r.length - 1 && (l = r.length - 1) : "last" === e && (l = r.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: r[l],
          focusedValue: null
        });
      }
    }
  }, {
    key: "getTheme",
    value: function value() {
      return this.props.theme ? "function" == typeof this.props.theme ? this.props.theme(defaultTheme) : _extends$108({}, defaultTheme, this.props.theme) : defaultTheme;
    }
  }, {
    key: "getCommonProps",
    value: function value() {
      var e = this.clearValue,
          t = this.getStyles,
          a = this.setValue,
          n = this.selectOption,
          r = this.props,
          l = r.classNamePrefix,
          o = r.isMulti,
          c = r.isRtl,
          i = r.options,
          s = this.state.selectValue,
          u = this.hasValue(),
          f = l;
      return {
        cx: classNames.bind(null, f),
        clearValue: e,
        getStyles: t,
        getValue: function getValue() {
          return s;
        },
        hasValue: u,
        isMulti: o,
        isRtl: c,
        options: i,
        selectOption: n,
        setValue: a,
        selectProps: r,
        theme: this.getTheme()
      };
    }
  }, {
    key: "getNextFocusedValue",
    value: function value(e) {
      if (this.clearFocusValueOnUpdate) return this.clearFocusValueOnUpdate = !1, null;
      var t = this.state,
          a = t.focusedValue,
          n = t.selectValue.indexOf(a);

      if (n > -1) {
        if (e.indexOf(a) > -1) return a;
        if (n < e.length) return e[n];
      }

      return null;
    }
  }, {
    key: "getNextFocusedOption",
    value: function value(e) {
      var t = this.state.focusedOption;
      return t && e.indexOf(t) > -1 ? t : e[0];
    }
  }, {
    key: "hasValue",
    value: function value() {
      return this.state.selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function value() {
      return !!this.state.menuOptions.render.length;
    }
  }, {
    key: "countOptions",
    value: function value() {
      return this.state.menuOptions.focusable.length;
    }
  }, {
    key: "isClearable",
    value: function value() {
      var e = this.props,
          t = e.isClearable,
          a = e.isMulti;
      return void 0 === t ? a : t;
    }
  }, {
    key: "isOptionDisabled",
    value: function value(e, t) {
      return "function" == typeof this.props.isOptionDisabled && this.props.isOptionDisabled(e, t);
    }
  }, {
    key: "isOptionSelected",
    value: function value(e, t) {
      var a = this;
      if (t.indexOf(e) > -1) return !0;
      if ("function" == typeof this.props.isOptionSelected) return this.props.isOptionSelected(e, t);
      var n = this.getOptionValue(e);
      return t.some(function (e) {
        return a.getOptionValue(e) === n;
      });
    }
  }, {
    key: "filterOption",
    value: function value(e, t) {
      return !this.props.filterOption || this.props.filterOption(e, t);
    }
  }, {
    key: "formatOptionLabel",
    value: function value(e, t) {
      if ("function" == typeof this.props.formatOptionLabel) {
        var a = this.props.inputValue,
            n = this.state.selectValue;
        return this.props.formatOptionLabel(e, {
          context: t,
          inputValue: a,
          selectValue: n
        });
      }

      return this.getOptionLabel(e);
    }
  }, {
    key: "formatGroupLabel",
    value: function value(e) {
      return this.props.formatGroupLabel(e);
    }
  }, {
    key: "startListeningComposition",
    value: function value() {
      document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
    }
  }, {
    key: "stopListeningComposition",
    value: function value() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: function value() {
      document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
    }
  }, {
    key: "stopListeningToTouch",
    value: function value() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "buildMenuOptions",
    value: function value(e, t) {
      var a = this,
          n = e.inputValue,
          r = void 0 === n ? "" : n,
          l = function l(e, n) {
        var l = a.isOptionDisabled(e, t),
            o = a.isOptionSelected(e, t),
            c = a.getOptionLabel(e),
            i = a.getOptionValue(e);

        if (!(a.shouldHideSelectedOptions() && o || !a.filterOption({
          label: c,
          value: i,
          data: e
        }, r))) {
          var s = l ? void 0 : function () {
            return a.onOptionHover(e);
          },
              u = l ? void 0 : function () {
            return a.selectOption(e);
          },
              f = a.getElementId("option") + "-" + n;
          return {
            innerProps: {
              id: f,
              onClick: u,
              onMouseMove: s,
              onMouseOver: s,
              role: "option",
              tabIndex: -1
            },
            data: e,
            isDisabled: l,
            isSelected: o,
            key: f,
            label: c,
            type: "option",
            value: i
          };
        }
      };

      return e.options.reduce(function (e, t, n) {
        if (t.options) {
          a.hasGroups || (a.hasGroups = !0);
          var r = t.options.map(function (t, a) {
            var r = l(t, n + "-" + a);
            return r && !r.isDisabled && e.focusable.push(t), r;
          }).filter(Boolean);

          if (r.length) {
            var o = a.getElementId("group") + "-" + n;
            e.render.push({
              type: "group",
              key: o,
              data: t,
              options: r
            });
          }
        } else {
          var c = l(t, "" + n);
          c && (e.render.push(c), c.isDisabled || e.focusable.push(t));
        }

        return e;
      }, {
        render: [],
        focusable: []
      });
    }
  }, {
    key: "constructAriaLiveMessage",
    value: function value() {
      var e = this.state,
          t = e.ariaLiveContext,
          a = e.selectValue,
          n = e.focusedValue,
          r = e.focusedOption,
          l = this.props,
          o = l.options,
          c = l.menuIsOpen,
          i = l.inputValue,
          s = l.screenReaderStatus;
      return (n ? valueFocusAriaMessage({
        focusedValue: n,
        getOptionLabel: this.getOptionLabel,
        selectValue: a
      }) : "") + " " + (r && c ? optionFocusAriaMessage({
        focusedOption: r,
        getOptionLabel: this.getOptionLabel,
        options: o
      }) : "") + " " + resultsAriaMessage({
        inputValue: i,
        screenReaderMessage: s({
          count: this.countOptions()
        })
      }) + " " + t;
    }
  }, {
    key: "renderInput",
    value: function value() {
      var e = this.props,
          t = e.isDisabled,
          a = e.isSearchable,
          n = e.inputId,
          r = e.inputValue,
          l = e.tabIndex,
          o = this.components.Input,
          c = this.state.inputIsHidden,
          i = n || this.getElementId("input");
      if (!a) return React__default.createElement(DummyInput, {
        id: i,
        innerRef: this.getInputRef,
        onBlur: this.onInputBlur,
        onChange: noop,
        onFocus: this.onInputFocus,
        readOnly: !0,
        disabled: t,
        tabIndex: l,
        value: ""
      });
      var s = {
        "aria-autocomplete": "list",
        "aria-label": this.props["aria-label"],
        "aria-labelledby": this.props["aria-labelledby"]
      },
          u = this.commonProps,
          f = u.cx,
          d = u.theme;
      return React__default.createElement(o, _extends$108({
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        cx: f,
        getStyles: this.getStyles,
        id: i,
        innerRef: this.getInputRef,
        isDisabled: t,
        isHidden: c,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: "false",
        tabIndex: l,
        theme: d,
        type: "text",
        value: r
      }, s));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function value() {
      var e = this,
          t = this.components,
          a = t.MultiValue,
          n = t.MultiValueContainer,
          r = t.MultiValueLabel,
          l = t.MultiValueRemove,
          o = t.SingleValue,
          c = t.Placeholder,
          i = this.commonProps,
          s = this.props,
          u = s.controlShouldRenderValue,
          f = s.isDisabled,
          d = s.isMulti,
          p = s.inputValue,
          h = s.placeholder,
          m = this.state,
          _ = m.selectValue,
          v = m.focusedValue,
          y = m.isFocused;
      if (!this.hasValue() || !u) return p ? null : React__default.createElement(c, _extends$108({}, i, {
        key: "placeholder",
        isDisabled: f,
        isFocused: y
      }), h);
      if (d) return _.map(function (t) {
        var o = t === v;
        return React__default.createElement(a, _extends$108({}, i, {
          components: {
            Container: n,
            Label: r,
            Remove: l
          },
          isFocused: o,
          isDisabled: f,
          key: e.getOptionValue(t),
          removeProps: {
            onClick: function onClick() {
              return e.removeValue(t);
            },
            onTouchEnd: function onTouchEnd() {
              return e.removeValue(t);
            },
            onMouseDown: function onMouseDown(e) {
              e.preventDefault(), e.stopPropagation();
            }
          },
          data: t
        }), e.formatOptionLabel(t, "value"));
      });
      if (p) return null;
      var g = _[0];
      return React__default.createElement(o, _extends$108({}, i, {
        data: g,
        isDisabled: f
      }), this.formatOptionLabel(g, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function value() {
      var e = this.components.ClearIndicator,
          t = this.commonProps,
          a = this.props,
          n = a.isDisabled,
          r = a.isLoading,
          l = this.state.isFocused;
      if (!this.isClearable() || !e || n || !this.hasValue() || r) return null;
      var o = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return React__default.createElement(e, _extends$108({}, t, {
        innerProps: o,
        isFocused: l
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function value() {
      var e = this.components.LoadingIndicator,
          t = this.commonProps,
          a = this.props,
          n = a.isDisabled,
          r = a.isLoading,
          l = this.state.isFocused;
      if (!e || !r) return null;
      return React__default.createElement(e, _extends$108({}, t, {
        innerProps: {
          "aria-hidden": "true"
        },
        isDisabled: n,
        isFocused: l
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function value() {
      var e = this.components,
          t = e.DropdownIndicator,
          a = e.IndicatorSeparator;
      if (!t || !a) return null;
      var n = this.commonProps,
          r = this.props.isDisabled,
          l = this.state.isFocused;
      return React__default.createElement(a, _extends$108({}, n, {
        isDisabled: r,
        isFocused: l
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function value() {
      var e = this.components.DropdownIndicator;
      if (!e) return null;
      var t = this.commonProps,
          a = this.props.isDisabled,
          n = this.state.isFocused,
          r = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return React__default.createElement(e, _extends$108({}, t, {
        innerProps: r,
        isDisabled: a,
        isFocused: n
      }));
    }
  }, {
    key: "renderMenu",
    value: function value() {
      var e = this,
          t = this.components,
          a = t.Group,
          n = t.GroupHeading,
          r = t.Menu,
          l = t.MenuList,
          o = t.MenuPortal,
          c = t.LoadingMessage,
          i = t.NoOptionsMessage,
          s = t.Option,
          u = this.commonProps,
          f = this.state,
          d = f.focusedOption,
          p = f.menuOptions,
          h = this.props,
          m = h.captureMenuScroll,
          _ = h.inputValue,
          v = h.isLoading,
          y = h.loadingMessage,
          g = h.minMenuHeight,
          E = h.maxMenuHeight,
          b = h.menuIsOpen,
          z = h.menuPlacement,
          R = h.menuPosition,
          M = h.menuPortalTarget,
          w = h.menuShouldBlockScroll,
          O = h.menuShouldScrollIntoView,
          C = h.noOptionsMessage,
          x = h.onMenuScrollToTop,
          P = h.onMenuScrollToBottom;
      if (!b) return null;

      var T = function T(t) {
        var a = d === t.data;
        return t.innerRef = a ? e.getFocusedOptionRef : void 0, React__default.createElement(s, _extends$108({}, u, t, {
          isFocused: a
        }), e.formatOptionLabel(t.data, "menu"));
      },
          j = void 0;

      if (this.hasOptions()) j = p.render.map(function (t) {
        if ("group" === t.type) {
          t.type;
          var r = objectWithoutProperties$1(t, ["type"]),
              l = t.key + "-heading";
          return React__default.createElement(a, _extends$108({}, u, r, {
            Heading: n,
            headingProps: {
              id: l
            },
            label: e.formatGroupLabel(t.data)
          }), t.options.map(function (e) {
            return T(e);
          }));
        }

        if ("option" === t.type) return T(t);
      });else if (v) {
        var S = y({
          inputValue: _
        });
        if (null === S) return null;
        j = React__default.createElement(c, u, S);
      } else {
        var D = C({
          inputValue: _
        });
        if (null === D) return null;
        j = React__default.createElement(i, u, D);
      }
      var k = {
        minMenuHeight: g,
        maxMenuHeight: E,
        menuPlacement: z,
        menuPosition: R,
        menuShouldScrollIntoView: O
      },
          F = React__default.createElement(MenuPlacer, _extends$108({}, u, k), function (t) {
        var a = t.ref,
            n = t.placerProps,
            o = n.placement,
            c = n.maxHeight;
        return React__default.createElement(r, _extends$108({}, u, k, {
          innerRef: a,
          innerProps: {
            onMouseDown: e.onMenuMouseDown,
            onMouseMove: e.onMenuMouseMove
          },
          isLoading: v,
          placement: o
        }), React__default.createElement(ScrollCaptorSwitch, {
          isEnabled: m,
          onTopArrive: x,
          onBottomArrive: P
        }, React__default.createElement(ScrollBlock, {
          isEnabled: w
        }, React__default.createElement(l, _extends$108({}, u, {
          innerRef: e.getMenuListRef,
          isLoading: v,
          maxHeight: c
        }), j))));
      });
      return M || "fixed" === R ? React__default.createElement(o, _extends$108({}, u, {
        appendTo: M,
        controlElement: this.controlRef,
        menuPlacement: z,
        menuPosition: R
      }), F) : F;
    }
  }, {
    key: "renderFormField",
    value: function value() {
      var e = this,
          t = this.props,
          a = t.delimiter,
          n = t.isDisabled,
          r = t.isMulti,
          l = t.name,
          o = this.state.selectValue;

      if (l && !n) {
        if (r) {
          if (a) {
            var c = o.map(function (t) {
              return e.getOptionValue(t);
            }).join(a);
            return React__default.createElement("input", {
              name: l,
              type: "hidden",
              value: c
            });
          }

          var i = o.length > 0 ? o.map(function (t, a) {
            return React__default.createElement("input", {
              key: "i-" + a,
              name: l,
              type: "hidden",
              value: e.getOptionValue(t)
            });
          }) : React__default.createElement("input", {
            name: l,
            type: "hidden"
          });
          return React__default.createElement("div", null, i);
        }

        var s = o[0] ? this.getOptionValue(o[0]) : "";
        return React__default.createElement("input", {
          name: l,
          type: "hidden",
          value: s
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function value() {
      return this.state.isFocused ? React__default.createElement(A11yText, {
        "aria-live": "assertive"
      }, React__default.createElement("p", {
        id: "aria-selection-event"
      }, " ", this.state.ariaLiveSelection), React__default.createElement("p", {
        id: "aria-context"
      }, " ", this.constructAriaLiveMessage())) : null;
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.components,
          t = e.Control,
          a = e.IndicatorsContainer,
          n = e.SelectContainer,
          r = e.ValueContainer,
          l = this.props,
          o = l.className,
          c = l.id,
          i = l.isDisabled,
          s = this.state.isFocused,
          u = this.commonProps = this.getCommonProps();
      return React__default.createElement(n, _extends$108({}, u, {
        className: o,
        innerProps: {
          id: c,
          onKeyDown: this.onKeyDown
        },
        isDisabled: i,
        isFocused: s
      }), this.renderLiveRegion(), React__default.createElement(t, _extends$108({}, u, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: i,
        isFocused: s
      }), React__default.createElement(r, _extends$108({}, u, {
        isDisabled: i
      }), this.renderPlaceholderOrValue(), this.renderInput()), React__default.createElement(a, _extends$108({}, u, {
        isDisabled: i
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }]), t;
}(React.Component);

Select.defaultProps = defaultProps;

var _initialiseProps = function _initialiseProps() {
  var e = this;
  this.state = {
    ariaLiveSelection: "",
    ariaLiveContext: "",
    focusedOption: null,
    focusedValue: null,
    inputIsHidden: !1,
    isFocused: !1,
    isComposing: !1,
    menuOptions: {
      render: [],
      focusable: []
    },
    selectValue: []
  }, this.blockOptionHover = !1, this.clearFocusValueOnUpdate = !1, this.hasGroups = !1, this.initialTouchX = 0, this.initialTouchY = 0, this.instancePrefix = "", this.openAfterFocus = !1, this.scrollToFocusedOptionOnUpdate = !1, this.controlRef = null, this.getControlRef = function (t) {
    e.controlRef = t;
  }, this.focusedOptionRef = null, this.getFocusedOptionRef = function (t) {
    e.focusedOptionRef = t;
  }, this.menuListRef = null, this.getMenuListRef = function (t) {
    e.menuListRef = t;
  }, this.inputRef = null, this.getInputRef = function (t) {
    e.inputRef = t;
  }, this.cacheComponents = function (t) {
    e.components = defaultComponents({
      components: t
    });
  }, this.focus = this.focusInput, this.blur = this.blurInput, this.setValue = function (t) {
    var a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "set-value",
        n = arguments[2],
        r = e.props,
        l = r.closeMenuOnSelect,
        o = r.isMulti,
        c = r.onChange;
    e.onInputChange("", {
      action: "set-value"
    }), l && (e.inputIsHiddenAfterUpdate = !o, e.onMenuClose()), e.clearFocusValueOnUpdate = !0, c(t, {
      action: a,
      option: n
    });
  }, this.selectOption = function (t) {
    var a = e.props,
        n = a.blurInputOnSelect;

    if (a.isMulti) {
      var r = e.state.selectValue;

      if (e.isOptionSelected(t, r)) {
        var l = e.getOptionValue(t);
        e.setValue(r.filter(function (t) {
          return e.getOptionValue(t) !== l;
        }), "deselect-option", t), e.announceAriaLiveSelection({
          event: "deselect-option",
          context: {
            value: e.getOptionLabel(t)
          }
        });
      } else e.setValue([].concat(toConsumableArray$1(r), [t]), "select-option", t), e.announceAriaLiveSelection({
        event: "select-option",
        context: {
          value: e.getOptionLabel(t)
        }
      });
    } else e.setValue(t, "select-option"), e.announceAriaLiveSelection({
      event: "select-option",
      context: {
        value: e.getOptionLabel(t)
      }
    });

    n && e.blurInput();
  }, this.removeValue = function (t) {
    var a = e.props.onChange,
        n = e.state.selectValue,
        r = e.getOptionValue(t);
    a(n.filter(function (t) {
      return e.getOptionValue(t) !== r;
    }), {
      action: "remove-value",
      removedValue: t
    }), e.announceAriaLiveSelection({
      event: "remove-value",
      context: {
        value: t ? e.getOptionLabel(t) : void 0
      }
    }), e.focusInput();
  }, this.clearValue = function () {
    var t = e.props,
        a = t.isMulti;
    (0, t.onChange)(a ? [] : null, {
      action: "clear"
    });
  }, this.popValue = function () {
    var t = e.props.onChange,
        a = e.state.selectValue,
        n = a[a.length - 1];
    e.announceAriaLiveSelection({
      event: "pop-value",
      context: {
        value: n ? e.getOptionLabel(n) : void 0
      }
    }), t(a.slice(0, a.length - 1), {
      action: "pop-value",
      removedValue: n
    });
  }, this.getOptionLabel = function (t) {
    return e.props.getOptionLabel(t);
  }, this.getOptionValue = function (t) {
    return e.props.getOptionValue(t);
  }, this.getStyles = function (t, a) {
    var n = defaultStyles[t](a);
    n.boxSizing = "border-box";
    var r = e.props.styles[t];
    return r ? r(n, a) : n;
  }, this.getElementId = function (t) {
    return e.instancePrefix + "-" + t;
  }, this.getActiveDescendentId = function () {
    var t = e.props.menuIsOpen,
        a = e.state,
        n = a.menuOptions,
        r = a.focusedOption;

    if (r && t) {
      var l = n.focusable.indexOf(r),
          o = n.render[l];
      return o && o.key;
    }
  }, this.announceAriaLiveSelection = function (t) {
    var a = t.event,
        n = t.context;
    e.setState({
      ariaLiveSelection: valueEventAriaMessage(a, n)
    });
  }, this.announceAriaLiveContext = function (t) {
    var a = t.event,
        n = t.context;
    e.setState({
      ariaLiveContext: instructionsAriaMessage(a, _extends$108({}, n, {
        label: e.props["aria-label"]
      }))
    });
  }, this.onMenuMouseDown = function (t) {
    0 === t.button && (t.stopPropagation(), t.preventDefault(), e.focusInput());
  }, this.onMenuMouseMove = function (t) {
    e.blockOptionHover = !1;
  }, this.onControlMouseDown = function (t) {
    var a = e.props.openMenuOnClick;
    e.state.isFocused ? e.props.menuIsOpen ? "INPUT" !== t.target.tagName && e.onMenuClose() : e.openMenu("first") : (a && (e.openAfterFocus = !0), e.focusInput()), "INPUT" !== t.target.tagName && t.preventDefault();
  }, this.onDropdownIndicatorMouseDown = function (t) {
    if (!(t && "mousedown" === t.type && 0 !== t.button || e.props.isDisabled)) {
      var a = e.props,
          n = a.isMulti,
          r = a.menuIsOpen;
      e.focusInput(), r ? (e.inputIsHiddenAfterUpdate = !n, e.onMenuClose()) : e.openMenu("first"), t.preventDefault(), t.stopPropagation();
    }
  }, this.onClearIndicatorMouseDown = function (t) {
    t && "mousedown" === t.type && 0 !== t.button || (e.clearValue(), t.stopPropagation(), e.openAfterFocus = !1, setTimeout(function () {
      return e.focusInput();
    }));
  }, this.onScroll = function (t) {
    "boolean" == typeof e.props.closeMenuOnScroll ? t.target instanceof HTMLElement && isDocumentElement(t.target) && e.props.onMenuClose() : "function" == typeof e.props.closeMenuOnScroll && e.props.closeMenuOnScroll(t) && e.props.onMenuClose();
  }, this.onCompositionStart = function () {
    e.setState({
      isComposing: !0
    });
  }, this.onCompositionEnd = function () {
    e.setState({
      isComposing: !1
    });
  }, this.onTouchStart = function (t) {
    var a = slicedToArray$1(t.touches, 1)[0];
    e.initialTouchX = a.clientX, e.initialTouchY = a.clientY, e.userIsDragging = !1;
  }, this.onTouchMove = function (t) {
    var a = slicedToArray$1(t.touches, 1)[0],
        n = Math.abs(a.clientX - e.initialTouchX),
        r = Math.abs(a.clientY - e.initialTouchY);
    e.userIsDragging = n > 5 || r > 5;
  }, this.onTouchEnd = function (t) {
    if (!e.userIsDragging) {
      var a = t.target;
      e.controlRef && !e.controlRef.contains(a) && e.menuListRef && !e.menuListRef.contains(a) && e.blurInput(), e.initialTouchX = 0, e.initialTouchY = 0;
    }
  }, this.onControlTouchEnd = function (t) {
    e.userIsDragging || e.onControlMouseDown(t);
  }, this.onClearIndicatorTouchEnd = function (t) {
    e.userIsDragging || e.onClearIndicatorMouseDown(t);
  }, this.onDropdownIndicatorTouchEnd = function (t) {
    e.userIsDragging || e.onDropdownIndicatorMouseDown(t);
  }, this.handleInputChange = function (t) {
    var a = t.currentTarget.value;
    e.inputIsHiddenAfterUpdate = !1, e.onInputChange(a, {
      action: "input-change"
    }), e.onMenuOpen();
  }, this.onInputFocus = function (t) {
    var a = e.props,
        n = a.isSearchable,
        r = a.isMulti;
    e.props.onFocus && e.props.onFocus(t), e.inputIsHiddenAfterUpdate = !1, e.announceAriaLiveContext({
      event: "input",
      context: {
        isSearchable: n,
        isMulti: r
      }
    }), e.setState({
      isFocused: !0
    }), (e.openAfterFocus || e.props.openMenuOnFocus) && e.openMenu("first"), e.openAfterFocus = !1;
  }, this.onInputBlur = function (t) {
    e.menuListRef && e.menuListRef.contains(document.activeElement) ? e.inputRef.focus() : (e.props.onBlur && e.props.onBlur(t), e.onInputChange("", {
      action: "input-blur"
    }), e.onMenuClose(), e.setState({
      focusedValue: null,
      isFocused: !1
    }));
  }, this.onOptionHover = function (t) {
    e.blockOptionHover || e.state.focusedOption === t || e.setState({
      focusedOption: t
    });
  }, this.shouldHideSelectedOptions = function () {
    var t = e.props,
        a = t.hideSelectedOptions,
        n = t.isMulti;
    return void 0 === a ? n : a;
  }, this.onKeyDown = function (t) {
    var a = e.props,
        n = a.isMulti,
        r = a.backspaceRemovesValue,
        l = a.escapeClearsValue,
        o = a.inputValue,
        c = a.isClearable,
        i = a.isDisabled,
        s = a.menuIsOpen,
        u = a.onKeyDown,
        f = a.tabSelectsValue,
        d = a.openMenuOnFocus,
        p = e.state,
        h = p.isComposing,
        m = p.focusedOption,
        _ = p.focusedValue,
        v = p.selectValue;

    if (!(i || "function" == typeof u && (u(t), t.defaultPrevented))) {
      switch (e.blockOptionHover = !0, t.key) {
        case "ArrowLeft":
          if (!n || o) return;
          e.focusValue("previous");
          break;

        case "ArrowRight":
          if (!n || o) return;
          e.focusValue("next");
          break;

        case "Delete":
        case "Backspace":
          if (o) return;
          if (_) e.removeValue(_);else {
            if (!r) return;
            n ? e.popValue() : c && e.clearValue();
          }
          break;

        case "Tab":
          if (t.shiftKey || !s || !f || !m || d && e.isOptionSelected(m, v)) return;
          e.selectOption(m);
          break;

        case "Enter":
          if (s) {
            if (!m) return;
            if (h) return;
            e.selectOption(m);
          } else e.focusOption("first");

          break;

        case "Escape":
          s ? (e.inputIsHiddenAfterUpdate = !1, e.onInputChange("", {
            action: "menu-close"
          }), e.onMenuClose()) : c && l && e.clearValue();
          break;

        case " ":
          if (o) return;

          if (!s) {
            e.openMenu("first");
            break;
          }

          if (!m) return;
          e.selectOption(m);
          break;

        case "ArrowUp":
          s ? e.focusOption("up") : e.openMenu("last");
          break;

        case "ArrowDown":
          s ? e.focusOption("down") : e.openMenu("first");
          break;

        case "PageUp":
          if (!s) return;
          e.focusOption("pageup");
          break;

        case "PageDown":
          if (!s) return;
          e.focusOption("pagedown");
          break;

        case "Home":
          if (!s) return;
          e.focusOption("first");
          break;

        case "End":
          if (!s) return;
          e.focusOption("last");
          break;

        default:
          return;
      }

      t.preventDefault();
    }
  };
},
    manageState = function manageState(e) {
  var t, a;
  return a = t = function (t) {
    function a() {
      var e, t, n;
      classCallCheck$1(this, a);

      for (var r = arguments.length, l = Array(r), o = 0; o < r; o++) {
        l[o] = arguments[o];
      }

      return t = n = possibleConstructorReturn$1(this, (e = a.__proto__ || Object.getPrototypeOf(a)).call.apply(e, [this].concat(l))), n.state = {
        inputValue: void 0 !== n.props.inputValue ? n.props.inputValue : n.props.defaultInputValue,
        menuIsOpen: void 0 !== n.props.menuIsOpen ? n.props.menuIsOpen : n.props.defaultMenuIsOpen,
        value: void 0 !== n.props.value ? n.props.value : n.props.defaultValue
      }, n.onChange = function (e, t) {
        n.callProp("onChange", e, t), n.setState({
          value: e
        });
      }, n.onInputChange = function (e, t) {
        var a = n.callProp("onInputChange", e, t);
        n.setState({
          inputValue: void 0 !== a ? a : e
        });
      }, n.onMenuOpen = function () {
        n.callProp("onMenuOpen"), n.setState({
          menuIsOpen: !0
        });
      }, n.onMenuClose = function () {
        n.callProp("onMenuClose"), n.setState({
          menuIsOpen: !1
        });
      }, possibleConstructorReturn$1(n, t);
    }

    return inherits$1(a, t), createClass$1(a, [{
      key: "focus",
      value: function value() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function value() {
        this.select.blur();
      }
    }, {
      key: "getProp",
      value: function value(e) {
        return void 0 !== this.props[e] ? this.props[e] : this.state[e];
      }
    }, {
      key: "callProp",
      value: function value(e) {
        if ("function" == typeof this.props[e]) {
          for (var t, a = arguments.length, n = Array(a > 1 ? a - 1 : 0), r = 1; r < a; r++) {
            n[r - 1] = arguments[r];
          }

          return (t = this.props)[e].apply(t, toConsumableArray$1(n));
        }
      }
    }, {
      key: "render",
      value: function value() {
        var t = this;
        return React__default.createElement(e, _extends$108({}, this.props, {
          ref: function ref(e) {
            t.select = e;
          },
          inputValue: this.getProp("inputValue"),
          menuIsOpen: this.getProp("menuIsOpen"),
          onChange: this.onChange,
          onInputChange: this.onInputChange,
          onMenuClose: this.onMenuClose,
          onMenuOpen: this.onMenuOpen,
          value: this.getProp("value")
        }));
      }
    }]), a;
  }(React.Component), t.defaultProps = {
    defaultInputValue: "",
    defaultMenuIsOpen: !1,
    defaultValue: null
  }, a;
},
    defaultProps$1 = {
  cacheOptions: !1,
  defaultOptions: !1
},
    makeAsyncSelect = function makeAsyncSelect(e) {
  var t, a;
  return a = t = function (t) {
    function a(e) {
      classCallCheck$1(this, a);
      var t = possibleConstructorReturn$1(this, (a.__proto__ || Object.getPrototypeOf(a)).call(this));
      return t.mounted = !1, t.optionsCache = {}, t.handleInputChange = function (e, a) {
        var n = t.props,
            r = n.cacheOptions,
            l = handleInputChange(e, a, n.onInputChange);
        if (!l) return delete t.lastRequest, void t.setState({
          inputValue: "",
          loadedInputValue: "",
          loadedOptions: [],
          isLoading: !1,
          passEmptyOptions: !1
        });
        if (r && t.optionsCache[l]) t.setState({
          inputValue: l,
          loadedInputValue: l,
          loadedOptions: t.optionsCache[l],
          isLoading: !1,
          passEmptyOptions: !1
        });else {
          var o = t.lastRequest = {};
          t.setState({
            inputValue: l,
            isLoading: !0,
            passEmptyOptions: !t.state.loadedInputValue
          }, function () {
            t.loadOptions(l, function (e) {
              t.mounted && (e && (t.optionsCache[l] = e), o === t.lastRequest && (delete t.lastRequest, t.setState({
                isLoading: !1,
                loadedInputValue: l,
                loadedOptions: e || [],
                passEmptyOptions: !1
              })));
            });
          });
        }
        return l;
      }, t.state = {
        defaultOptions: Array.isArray(e.defaultOptions) ? e.defaultOptions : void 0,
        inputValue: e.inputValue,
        isLoading: !0 === e.defaultOptions,
        loadedOptions: [],
        passEmptyOptions: !1
      }, t;
    }

    return inherits$1(a, t), createClass$1(a, [{
      key: "componentDidMount",
      value: function value() {
        var e = this;
        this.mounted = !0;
        var t = this.props.defaultOptions,
            a = this.state.inputValue;
        !0 === t && this.loadOptions(a, function (t) {
          if (e.mounted) {
            var a = !!e.lastRequest;
            e.setState({
              defaultOptions: t || [],
              isLoading: a
            });
          }
        });
      }
    }, {
      key: "componentWillReceiveProps",
      value: function value(e) {
        e.cacheOptions !== this.props.cacheOptions && (this.optionsCache = {}), e.defaultOptions !== this.props.defaultOptions && this.setState({
          defaultOptions: Array.isArray(e.defaultOptions) ? e.defaultOptions : void 0
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.mounted = !1;
      }
    }, {
      key: "focus",
      value: function value() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function value() {
        this.select.blur();
      }
    }, {
      key: "loadOptions",
      value: function value(e, t) {
        var a = this.props.loadOptions;
        if (!a) return t();
        var n = a(e, t);
        n && "function" == typeof n.then && n.then(t, function () {
          return t();
        });
      }
    }, {
      key: "render",
      value: function value() {
        var t = this,
            a = this.props,
            n = (a.loadOptions, objectWithoutProperties$1(a, ["loadOptions"])),
            r = this.state,
            l = r.defaultOptions,
            o = r.inputValue,
            c = r.isLoading,
            i = r.loadedInputValue,
            s = r.loadedOptions,
            u = r.passEmptyOptions ? [] : o && i ? s : l || [];
        return React__default.createElement(e, _extends$108({}, n, {
          filterOption: this.props.filterOption || null,
          ref: function ref(e) {
            t.select = e;
          },
          options: u,
          isLoading: c,
          onInputChange: this.handleInputChange
        }));
      }
    }]), a;
  }(React.Component), t.defaultProps = defaultProps$1, a;
},
    Async = makeAsyncSelect(manageState(Select)),
    compareOption = function compareOption(e, t) {
  var a = e.toLowerCase();
  return t.value.toLowerCase() === a || t.label.toLowerCase() === a;
},
    builtins = {
  formatCreateLabel: function formatCreateLabel(e) {
    return 'Create "' + e + '"';
  },
  isValidNewOption: function isValidNewOption(e, t, a) {
    return !(!e || t.some(function (t) {
      return compareOption(e, t);
    }) || a.some(function (t) {
      return compareOption(e, t);
    }));
  },
  getNewOptionData: function getNewOptionData(e, t) {
    return {
      label: t,
      value: e,
      __isNew__: !0
    };
  }
},
    defaultProps$2 = _extends$108({
  allowCreateWhileLoading: !1,
  createOptionPosition: "last"
}, builtins),
    makeCreatableSelect = function makeCreatableSelect(e) {
  var t, a;
  return a = t = function (t) {
    function a(e) {
      classCallCheck$1(this, a);
      var t = possibleConstructorReturn$1(this, (a.__proto__ || Object.getPrototypeOf(a)).call(this, e));

      t.onChange = function (e, a) {
        var n = t.props,
            r = n.getNewOptionData,
            l = n.inputValue,
            o = n.isMulti,
            c = n.onChange,
            i = n.onCreateOption,
            s = n.value;
        if ("select-option" !== a.action) return c(e, a);
        var u = t.state.newOption,
            f = Array.isArray(e) ? e : [e];
        if (f[f.length - 1] !== u) c(e, a);else if (i) i(l);else {
          var d = r(l, l),
              p = {
            action: "create-option"
          };
          c(o ? [].concat(toConsumableArray$1(cleanValue(s)), [d]) : d, p);
        }
      };

      var n = e.options || [];
      return t.state = {
        newOption: void 0,
        options: n
      }, t;
    }

    return inherits$1(a, t), createClass$1(a, [{
      key: "componentWillReceiveProps",
      value: function value(e) {
        var t = e.allowCreateWhileLoading,
            a = e.createOptionPosition,
            n = e.formatCreateLabel,
            r = e.getNewOptionData,
            l = e.inputValue,
            o = e.isLoading,
            c = e.isValidNewOption,
            i = e.value,
            s = e.options || [],
            u = this.state.newOption;
        u = c(l, cleanValue(i), s) ? r(l, n(l)) : void 0, this.setState({
          newOption: u,
          options: !t && o || !u ? s : "first" === a ? [u].concat(toConsumableArray$1(s)) : [].concat(toConsumableArray$1(s), [u])
        });
      }
    }, {
      key: "focus",
      value: function value() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function value() {
        this.select.blur();
      }
    }, {
      key: "render",
      value: function value() {
        var t = this,
            a = objectWithoutProperties$1(this.props, []),
            n = this.state.options;
        return React__default.createElement(e, _extends$108({}, a, {
          ref: function ref(e) {
            t.select = e;
          },
          options: n,
          onChange: this.onChange
        }));
      }
    }]), a;
  }(React.Component), t.defaultProps = defaultProps$2, a;
},
    Creatable = manageState(makeCreatableSelect(Select)),
    AsyncCreatable = makeAsyncSelect(manageState(makeCreatableSelect(Select))),
    Fade = function Fade(e) {
  var t = e.component,
      a = e.duration,
      n = void 0 === a ? 1 : a,
      r = e.in,
      l = (e.onExited, objectWithoutProperties$1(e, ["component", "duration", "in", "onExited"])),
      o = {
    entering: {
      opacity: 0
    },
    entered: {
      opacity: 1,
      transition: "opacity " + n + "ms"
    },
    exiting: {
      opacity: 0
    },
    exited: {
      opacity: 0
    }
  };
  return React__default.createElement(reactTransitionGroup_1, {
    mountOnEnter: !0,
    unmountOnExit: !0,
    in: r,
    timeout: n
  }, function (e) {
    var a = {
      style: _extends$108({}, o[e])
    };
    return React__default.createElement(t, _extends$108({
      innerProps: a
    }, l));
  });
},
    collapseDuration = 260,
    Collapse = function (e) {
  function t() {
    var e, a, n;
    classCallCheck$1(this, t);

    for (var r = arguments.length, l = Array(r), o = 0; o < r; o++) {
      l[o] = arguments[o];
    }

    return a = n = possibleConstructorReturn$1(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), n.duration = collapseDuration, n.state = {
      width: "auto"
    }, n.transition = {
      exiting: {
        width: 0,
        transition: "width " + n.duration + "ms ease-out"
      },
      exited: {
        width: 0
      }
    }, n.getWidth = function (e) {
      if (e && isNaN(n.state.width)) {
        var t = e.getBoundingClientRect().width;
        n.setState({
          width: t
        });
      }
    }, n.getStyle = function (e) {
      return {
        overflow: "hidden",
        whiteSpace: "nowrap",
        width: e
      };
    }, n.getTransition = function (e) {
      return n.transition[e];
    }, possibleConstructorReturn$1(n, a);
  }

  return inherits$1(t, e), createClass$1(t, [{
    key: "render",
    value: function value() {
      var e = this,
          t = this.props,
          a = t.children,
          n = t.in,
          r = this.state.width;
      return React__default.createElement(reactTransitionGroup_1, {
        enter: !1,
        mountOnEnter: !0,
        unmountOnExit: !0,
        in: n,
        timeout: this.duration
      }, function (t) {
        var n = _extends$108({}, e.getStyle(r), e.getTransition(t));

        return React__default.createElement("div", {
          ref: e.getWidth,
          style: n
        }, a);
      });
    }
  }]), t;
}(React.Component),
    AnimatedInput = function AnimatedInput(e) {
  return function (t) {
    t.in, t.onExited, t.appear, t.enter, t.exit;
    var a = t.innerRef,
        n = objectWithoutProperties$1(t, ["in", "onExited", "appear", "enter", "exit", "innerRef"]);
    return React__default.createElement(e, _extends$108({
      innerRef: a
    }, n));
  };
},
    AnimatedMultiValue = function AnimatedMultiValue(e) {
  return function (t) {
    var a = t.in,
        n = t.onExited,
        r = objectWithoutProperties$1(t, ["in", "onExited"]);
    return React__default.createElement(Collapse, {
      in: a,
      onExited: n
    }, React__default.createElement(e, _extends$108({
      cropWithEllipsis: a
    }, r)));
  };
},
    AnimatedPlaceholder = function AnimatedPlaceholder(e) {
  return function (t) {
    return React__default.createElement(Fade, _extends$108({
      component: e,
      duration: t.isMulti ? collapseDuration : 1
    }, t));
  };
},
    AnimatedSingleValue = function AnimatedSingleValue(e) {
  return function (t) {
    return React__default.createElement(Fade, _extends$108({
      component: e
    }, t));
  };
},
    AnimatedValueContainer = function AnimatedValueContainer(e) {
  return function (t) {
    return React__default.createElement(reactTransitionGroup_2, _extends$108({
      component: e
    }, t));
  };
},
    makeAnimated = function makeAnimated(e) {
  var t = defaultComponents({
    components: e
  }),
      a = t.Input,
      n = t.MultiValue,
      r = t.Placeholder,
      l = t.SingleValue,
      o = t.ValueContainer,
      c = objectWithoutProperties$1(t, ["Input", "MultiValue", "Placeholder", "SingleValue", "ValueContainer"]);
  return _extends$108({
    Input: AnimatedInput(a),
    MultiValue: AnimatedMultiValue(n),
    Placeholder: AnimatedPlaceholder(r),
    SingleValue: AnimatedSingleValue(l),
    ValueContainer: AnimatedValueContainer(o)
  }, c);
},
    AnimatedComponents = makeAnimated(),
    Input$1 = AnimatedComponents.Input,
    MultiValue$1 = AnimatedComponents.MultiValue,
    Placeholder$1 = AnimatedComponents.Placeholder,
    SingleValue$1 = AnimatedComponents.SingleValue,
    ValueContainer$1 = AnimatedComponents.ValueContainer,
    index$1$1 = manageState(Select),
    _templateObject$11 = taggedTemplateLiteral(["\n\tmargin-right: 0.75em;\n\t> svg {\n\t\tfont-size: 0.7em;\n\t\theight: 1em;\n\t\twidth: 1em;\n\t\ttransition: transform 0.375s cubic-bezier(0.23, 1, 0.32, 1);\n\t\ttransform: ", ";\n\t\toverflow: visible;\n\t}\n"], ["\n\tmargin-right: 0.75em;\n\t> svg {\n\t\tfont-size: 0.7em;\n\t\theight: 1em;\n\t\twidth: 1em;\n\t\ttransition: transform 0.375s cubic-bezier(0.23, 1, 0.32, 1);\n\t\ttransform: ", ";\n\t\toverflow: visible;\n\t}\n"]),
    _templateObject2$6 = taggedTemplateLiteral([""], [""]),
    StyledCaret$1 = styled__default.span(_templateObject$11, function (e) {
  return e.menuIsOpen ? "rotate(180deg)" : "rotate(360deg)";
}),
    StyledSelect = styled__default(index$1$1)(_templateObject2$6),
    DropdownIndicator$1 = function DropdownIndicator$1(e) {
  var t = e.menuIsOpen;
  return React__default.createElement(StyledCaret$1, {
    menuIsOpen: t
  }, React__default.createElement(Caret, null));
},
    Select$1 = function Select$1(e) {
  var t = e.components,
      a = void 0 === t ? {} : t,
      n = e.styles,
      r = void 0 === n ? {} : n,
      l = e.invalid,
      o = objectWithoutProperties(e, ["components", "styles", "invalid"]);
  return React__default.createElement(StyledSelect, _extends$107({
    styles: _extends$107({}, r, {
      indicatorSeparator: function indicatorSeparator() {
        return {
          display: "none"
        };
      },
      control: function control(e) {
        return l ? _extends$107({}, e, {
          boxShadow: "0 0 0 2px #f76e5c",
          borderColor: "transparent"
        }) : e;
      }
    }),
    components: _extends$107({
      DropdownIndicator: DropdownIndicator$1
    }, a)
  }, o));
},
    getOwnPropertySymbols = Object.getOwnPropertySymbols,
    hasOwnProperty = Object.prototype.hasOwnProperty,
    propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(e) {
  if (null === e || void 0 === e) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}

function shouldUseNative() {
  try {
    if (!Object.assign) return !1;
    var e = new String("abc");
    if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

    for (var t = {}, a = 0; a < 10; a++) {
      t["_" + String.fromCharCode(a)] = a;
    }

    if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
      return t[e];
    }).join("")) return !1;
    var n = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (e) {
      n[e] = e;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
  } catch (e) {
    return !1;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (e, t) {
  for (var a, n, r = toObject(e), l = 1; l < arguments.length; l++) {
    for (var o in a = Object(arguments[l])) {
      hasOwnProperty.call(a, o) && (r[o] = a[o]);
    }

    if (getOwnPropertySymbols) {
      n = getOwnPropertySymbols(a);

      for (var c = 0; c < n.length; c++) {
        propIsEnumerable.call(a, n[c]) && (r[n[c]] = a[n[c]]);
      }
    }
  }

  return r;
},
    emptyObject = {};
"production" !== process.env.NODE_ENV && Object.freeze(emptyObject);

var emptyObject_1 = emptyObject,
    validateFormat = function validateFormat(e) {};

function invariant(e, t, a, n, r, l, o, c) {
  if (validateFormat(t), !e) {
    var i;
    if (void 0 === t) i = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
      var s = [a, n, r, l, o, c],
          u = 0;
      (i = new Error(t.replace(/%s/g, function () {
        return s[u++];
      }))).name = "Invariant Violation";
    }
    throw i.framesToPop = 1, i;
  }
}

"production" !== process.env.NODE_ENV && (validateFormat = function validateFormat(e) {
  if (void 0 === e) throw new Error("invariant requires an error message argument");
});
var invariant_1 = invariant;

function makeEmptyFunction(e) {
  return function () {
    return e;
  };
}

var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction, emptyFunction.thatReturnsFalse = makeEmptyFunction(!1), emptyFunction.thatReturnsTrue = makeEmptyFunction(!0), emptyFunction.thatReturnsNull = makeEmptyFunction(null), emptyFunction.thatReturnsThis = function () {
  return this;
}, emptyFunction.thatReturnsArgument = function (e) {
  return e;
};
var emptyFunction_1 = emptyFunction,
    warning = emptyFunction_1;

if ("production" !== process.env.NODE_ENV) {
  var printWarning = function printWarning(e) {
    for (var t = arguments.length, a = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
      a[n - 1] = arguments[n];
    }

    var r = 0,
        l = "Warning: " + e.replace(/%s/g, function () {
      return a[r++];
    });
    "undefined" != typeof console && console.error(l);

    try {
      throw new Error(l);
    } catch (e) {}
  };

  warning = function warning(e, t) {
    if (void 0 === t) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");

    if (0 !== t.indexOf("Failed Composite propType: ") && !e) {
      for (var a = arguments.length, n = Array(a > 2 ? a - 2 : 0), r = 2; r < a; r++) {
        n[r - 2] = arguments[r];
      }

      printWarning.apply(void 0, [t].concat(n));
    }
  };
}

var warning_1 = warning;
if ("production" !== process.env.NODE_ENV) var warning$1 = warning_1;
var ReactPropTypeLocationNames,
    MIXINS_KEY = "mixins";

function identity(e) {
  return e;
}

function factory(e, t, a) {
  var n = [],
      r = {
    mixins: "DEFINE_MANY",
    statics: "DEFINE_MANY",
    propTypes: "DEFINE_MANY",
    contextTypes: "DEFINE_MANY",
    childContextTypes: "DEFINE_MANY",
    getDefaultProps: "DEFINE_MANY_MERGED",
    getInitialState: "DEFINE_MANY_MERGED",
    getChildContext: "DEFINE_MANY_MERGED",
    render: "DEFINE_ONCE",
    componentWillMount: "DEFINE_MANY",
    componentDidMount: "DEFINE_MANY",
    componentWillReceiveProps: "DEFINE_MANY",
    shouldComponentUpdate: "DEFINE_ONCE",
    componentWillUpdate: "DEFINE_MANY",
    componentDidUpdate: "DEFINE_MANY",
    componentWillUnmount: "DEFINE_MANY",
    UNSAFE_componentWillMount: "DEFINE_MANY",
    UNSAFE_componentWillReceiveProps: "DEFINE_MANY",
    UNSAFE_componentWillUpdate: "DEFINE_MANY",
    updateComponent: "OVERRIDE_BASE"
  },
      l = {
    getDerivedStateFromProps: "DEFINE_MANY_MERGED"
  },
      o = {
    displayName: function displayName(e, t) {
      e.displayName = t;
    },
    mixins: function mixins(e, t) {
      if (t) for (var a = 0; a < t.length; a++) {
        s(e, t[a]);
      }
    },
    childContextTypes: function childContextTypes(e, t) {
      "production" !== process.env.NODE_ENV && c(e, t, "childContext"), e.childContextTypes = objectAssign({}, e.childContextTypes, t);
    },
    contextTypes: function contextTypes(e, t) {
      "production" !== process.env.NODE_ENV && c(e, t, "context"), e.contextTypes = objectAssign({}, e.contextTypes, t);
    },
    getDefaultProps: function getDefaultProps(e, t) {
      e.getDefaultProps ? e.getDefaultProps = f(e.getDefaultProps, t) : e.getDefaultProps = t;
    },
    propTypes: function propTypes(e, t) {
      "production" !== process.env.NODE_ENV && c(e, t, "prop"), e.propTypes = objectAssign({}, e.propTypes, t);
    },
    statics: function statics(e, t) {
      !function (e, t) {
        if (!t) return;

        for (var a in t) {
          var n = t[a];

          if (t.hasOwnProperty(a)) {
            var r = a in o;
            invariant_1(!r, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', a);
            var c = a in e;

            if (c) {
              var i = l.hasOwnProperty(a) ? l[a] : null;
              return invariant_1("DEFINE_MANY_MERGED" === i, "ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.", a), void (e[a] = f(e[a], n));
            }

            e[a] = n;
          }
        }
      }(e, t);
    },
    autobind: function autobind() {}
  };

  function c(e, t, a) {
    for (var n in t) {
      t.hasOwnProperty(n) && "production" !== process.env.NODE_ENV && warning$1("function" == typeof t[n], "%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.", e.displayName || "ReactClass", ReactPropTypeLocationNames[a], n);
    }
  }

  function i(e, t) {
    var a = r.hasOwnProperty(t) ? r[t] : null;
    _.hasOwnProperty(t) && invariant_1("OVERRIDE_BASE" === a, "ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.", t), e && invariant_1("DEFINE_MANY" === a || "DEFINE_MANY_MERGED" === a, "ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.", t);
  }

  function s(e, a) {
    if (a) {
      invariant_1("function" != typeof a, "ReactClass: You're attempting to use a component class or function as a mixin. Instead, just use a regular object."), invariant_1(!t(a), "ReactClass: You're attempting to use a component as a mixin. Instead, just use a regular object.");
      var n = e.prototype,
          l = n.__reactAutoBindPairs;

      for (var c in a.hasOwnProperty(MIXINS_KEY) && o.mixins(e, a.mixins), a) {
        if (a.hasOwnProperty(c) && c !== MIXINS_KEY) {
          var s = a[c],
              u = n.hasOwnProperty(c);
          if (i(u, c), o.hasOwnProperty(c)) o[c](e, s);else {
            var p = r.hasOwnProperty(c);
            if ("function" == typeof s && !p && !u && !1 !== a.autobind) l.push(c, s), n[c] = s;else if (u) {
              var h = r[c];
              invariant_1(p && ("DEFINE_MANY_MERGED" === h || "DEFINE_MANY" === h), "ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.", h, c), "DEFINE_MANY_MERGED" === h ? n[c] = f(n[c], s) : "DEFINE_MANY" === h && (n[c] = d(n[c], s));
            } else n[c] = s, "production" !== process.env.NODE_ENV && "function" == typeof s && a.displayName && (n[c].displayName = a.displayName + "_" + c);
          }
        }
      }
    } else if ("production" !== process.env.NODE_ENV) {
      var m = typeof a,
          _ = "object" === m && null !== a;

      "production" !== process.env.NODE_ENV && warning$1(_, "%s: You're attempting to include a mixin that is either null or not an object. Check the mixins included by the component, as well as any mixins they include themselves. Expected object but got %s.", e.displayName || "ReactClass", null === a ? null : m);
    }
  }

  function u(e, t) {
    for (var a in invariant_1(e && t && "object" == typeof e && "object" == typeof t, "mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects."), t) {
      t.hasOwnProperty(a) && (invariant_1(void 0 === e[a], "mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.", a), e[a] = t[a]);
    }

    return e;
  }

  function f(e, t) {
    return function () {
      var a = e.apply(this, arguments),
          n = t.apply(this, arguments);
      if (null == a) return n;
      if (null == n) return a;
      var r = {};
      return u(r, a), u(r, n), r;
    };
  }

  function d(e, t) {
    return function () {
      e.apply(this, arguments), t.apply(this, arguments);
    };
  }

  function p(e, t) {
    var a = t.bind(e);

    if ("production" !== process.env.NODE_ENV) {
      a.__reactBoundContext = e, a.__reactBoundMethod = t, a.__reactBoundArguments = null;
      var n = e.constructor.displayName,
          r = a.bind;

      a.bind = function (l) {
        for (var o = arguments.length, c = Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++) {
          c[i - 1] = arguments[i];
        }

        if (l !== e && null !== l) "production" !== process.env.NODE_ENV && warning$1(!1, "bind(): React component methods may only be bound to the component instance. See %s", n);else if (!c.length) return "production" !== process.env.NODE_ENV && warning$1(!1, "bind(): You are binding a component method to the component. React does this for you automatically in a high-performance way, so you can safely remove this call. See %s", n), a;
        var s = r.apply(a, arguments);
        return s.__reactBoundContext = e, s.__reactBoundMethod = t, s.__reactBoundArguments = c, s;
      };
    }

    return a;
  }

  var h = {
    componentDidMount: function componentDidMount() {
      this.__isMounted = !0;
    }
  },
      m = {
    componentWillUnmount: function componentWillUnmount() {
      this.__isMounted = !1;
    }
  },
      _ = {
    replaceState: function replaceState(e, t) {
      this.updater.enqueueReplaceState(this, e, t);
    },
    isMounted: function isMounted() {
      return "production" !== process.env.NODE_ENV && (warning$1(this.__didWarnIsMounted, "%s: isMounted is deprecated. Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks.", this.constructor && this.constructor.displayName || this.name || "Component"), this.__didWarnIsMounted = !0), !!this.__isMounted;
    }
  },
      v = function v() {};

  return objectAssign(v.prototype, e.prototype, _), function (e) {
    var t = identity(function (e, n, r) {
      "production" !== process.env.NODE_ENV && warning$1(this instanceof t, "Something is calling a React component directly. Use a factory or JSX instead. See: https://fb.me/react-legacyfactory"), this.__reactAutoBindPairs.length && function (e) {
        for (var t = e.__reactAutoBindPairs, a = 0; a < t.length; a += 2) {
          var n = t[a],
              r = t[a + 1];
          e[n] = p(e, r);
        }
      }(this), this.props = e, this.context = n, this.refs = emptyObject_1, this.updater = r || a, this.state = null;
      var l = this.getInitialState ? this.getInitialState() : null;
      "production" !== process.env.NODE_ENV && void 0 === l && this.getInitialState._isMockFunction && (l = null), invariant_1("object" == typeof l && !Array.isArray(l), "%s.getInitialState(): must return an object or null", t.displayName || "ReactCompositeComponent"), this.state = l;
    });

    for (var l in t.prototype = new v(), t.prototype.constructor = t, t.prototype.__reactAutoBindPairs = [], n.forEach(s.bind(null, t)), s(t, h), s(t, e), s(t, m), t.getDefaultProps && (t.defaultProps = t.getDefaultProps()), "production" !== process.env.NODE_ENV && (t.getDefaultProps && (t.getDefaultProps.isReactClassApproved = {}), t.prototype.getInitialState && (t.prototype.getInitialState.isReactClassApproved = {})), invariant_1(t.prototype.render, "createClass(...): Class specification must implement a `render` method."), "production" !== process.env.NODE_ENV && (warning$1(!t.prototype.componentShouldUpdate, "%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", e.displayName || "A component"), warning$1(!t.prototype.componentWillRecieveProps, "%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", e.displayName || "A component"), warning$1(!t.prototype.UNSAFE_componentWillRecieveProps, "%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", e.displayName || "A component")), r) {
      t.prototype[l] || (t.prototype[l] = null);
    }

    return t;
  };
}

ReactPropTypeLocationNames = "production" !== process.env.NODE_ENV ? {
  prop: "prop",
  context: "context",
  childContext: "child context"
} : {};
var factory_1 = factory;
if (void 0 === React__default) throw Error("create-react-class could not find the React object. If you are using script tags, make sure that React is being loaded before create-react-class.");

var ReactNoopUpdateQueue = new React__default.Component().updater,
    createReactClass = factory_1(React__default.Component, React__default.isValidElement, ReactNoopUpdateQueue),
    reactSlider = createCommonjsModule(function (e, t) {
  var a;
  a = function a(e, t, _a) {
    function n(e) {
      return e.stopPropagation && e.stopPropagation(), e.preventDefault && e.preventDefault(), !1;
    }

    function r(e) {
      return null == e ? [] : Array.isArray(e) ? e : [e];
    }

    function l(e) {
      return null != e && 1 === e.length ? e[0] : e;
    }

    return _a({
      displayName: "ReactSlider",
      propTypes: {
        min: t.number,
        max: t.number,
        step: t.number,
        minDistance: t.number,
        defaultValue: t.oneOfType([t.number, t.arrayOf(t.number)]),
        value: t.oneOfType([t.number, t.arrayOf(t.number)]),
        orientation: t.oneOf(["horizontal", "vertical"]),
        className: t.string,
        handleClassName: t.string,
        handleActiveClassName: t.string,
        withBars: t.bool,
        barClassName: t.string,
        pearling: t.bool,
        disabled: t.bool,
        snapDragDisabled: t.bool,
        invert: t.bool,
        onBeforeChange: t.func,
        onChange: t.func,
        onAfterChange: t.func,
        onSliderClick: t.func
      },
      getDefaultProps: function getDefaultProps() {
        return {
          min: 0,
          max: 100,
          step: 1,
          minDistance: 0,
          defaultValue: 0,
          orientation: "horizontal",
          className: "slider",
          handleClassName: "handle",
          handleActiveClassName: "active",
          barClassName: "bar",
          withBars: !1,
          pearling: !1,
          disabled: !1,
          snapDragDisabled: !1,
          invert: !1
        };
      },
      getInitialState: function getInitialState() {
        var e = this._or(r(this.props.value), r(this.props.defaultValue));

        this.tempArray = e.slice(), this.pendingResizeTimeouts = [];

        for (var t = [], a = 0; a < e.length; a++) {
          e[a] = this._trimAlignValue(e[a], this.props), t.push(a);
        }

        return {
          index: -1,
          upperBound: 0,
          sliderLength: 0,
          value: e,
          zIndices: t
        };
      },
      componentWillReceiveProps: function componentWillReceiveProps(e) {
        var t = this._or(r(e.value), this.state.value);

        this.tempArray = t.slice();

        for (var a = 0; a < t.length; a++) {
          this.state.value[a] = this._trimAlignValue(t[a], e);
        }

        this.state.value.length > t.length && (this.state.value.length = t.length), 0 === this.state.upperBound && this._handleResize();
      },
      _or: function _or(t, a) {
        var n = e.Children.count(this.props.children);

        switch (n) {
          case 0:
            return t.length > 0 ? t : a;

          case t.length:
            return t;

          case a.length:
            return a;

          default:
            return t.length === n && a.length === n || console.warn(this.constructor.displayName + ": Number of values does not match number of children."), function (e, t, a) {
              for (var n = (t - e) / (a - 1), r = [], l = 0; l < a; l++) {
                r.push(e + n * l);
              }

              return r;
            }(this.props.min, this.props.max, n);
        }
      },
      componentDidMount: function componentDidMount() {
        window.addEventListener("resize", this._handleResize), this._handleResize();
      },
      componentWillUnmount: function componentWillUnmount() {
        this._clearPendingResizeTimeouts(), window.removeEventListener("resize", this._handleResize);
      },
      getValue: function getValue() {
        return l(this.state.value);
      },
      _handleResize: function _handleResize() {
        var e = window.setTimeout(function () {
          this.pendingResizeTimeouts.shift();

          var e = this.refs.slider,
              t = this.refs.handle0,
              a = e.getBoundingClientRect(),
              n = this._sizeKey(),
              r = a[this._posMaxKey()],
              l = a[this._posMinKey()];

          this.setState({
            upperBound: e[n] - t[n],
            sliderLength: Math.abs(r - l),
            handleSize: t[n],
            sliderStart: this.props.invert ? r : l
          });
        }.bind(this), 0);
        this.pendingResizeTimeouts.push(e);
      },
      _clearPendingResizeTimeouts: function _clearPendingResizeTimeouts() {
        do {
          var e = this.pendingResizeTimeouts.shift();
          clearTimeout(e);
        } while (this.pendingResizeTimeouts.length);
      },
      _calcOffset: function _calcOffset(e) {
        var t = this.props.max - this.props.min;
        return 0 === t ? 0 : (e - this.props.min) / t * this.state.upperBound;
      },
      _calcValue: function _calcValue(e) {
        return e / this.state.upperBound * (this.props.max - this.props.min) + this.props.min;
      },
      _buildHandleStyle: function _buildHandleStyle(e, t) {
        var a = {
          position: "absolute",
          willChange: this.state.index >= 0 ? this._posMinKey() : "",
          zIndex: this.state.zIndices.indexOf(t) + 1
        };
        return a[this._posMinKey()] = e + "px", a;
      },
      _buildBarStyle: function _buildBarStyle(e, t) {
        var a = {
          position: "absolute",
          willChange: this.state.index >= 0 ? this._posMinKey() + "," + this._posMaxKey() : ""
        };
        return a[this._posMinKey()] = e, a[this._posMaxKey()] = t, a;
      },
      _getClosestIndex: function _getClosestIndex(e) {
        for (var t = Number.MAX_VALUE, a = -1, n = this.state.value, r = n.length, l = 0; l < r; l++) {
          var o = this._calcOffset(n[l]),
              c = Math.abs(e - o);

          c < t && (t = c, a = l);
        }

        return a;
      },
      _calcOffsetFromPosition: function _calcOffsetFromPosition(e) {
        var t = e - this.state.sliderStart;
        return this.props.invert && (t = this.state.sliderLength - t), t -= this.state.handleSize / 2;
      },
      _forceValueFromPosition: function _forceValueFromPosition(e, t) {
        var a = this._calcOffsetFromPosition(e),
            n = this._getClosestIndex(a),
            r = this._trimAlignValue(this._calcValue(a)),
            l = this.state.value.slice();

        l[n] = r;

        for (var o = 0; o < l.length - 1; o += 1) {
          if (l[o + 1] - l[o] < this.props.minDistance) return;
        }

        this.setState({
          value: l
        }, t.bind(this, n));
      },
      _getMousePosition: function _getMousePosition(e) {
        return [e["page" + this._axisKey()], e["page" + this._orthogonalAxisKey()]];
      },
      _getTouchPosition: function _getTouchPosition(e) {
        var t = e.touches[0];
        return [t["page" + this._axisKey()], t["page" + this._orthogonalAxisKey()]];
      },
      _getKeyDownEventMap: function _getKeyDownEventMap() {
        return {
          keydown: this._onKeyDown,
          focusout: this._onBlur
        };
      },
      _getMouseEventMap: function _getMouseEventMap() {
        return {
          mousemove: this._onMouseMove,
          mouseup: this._onMouseUp
        };
      },
      _getTouchEventMap: function _getTouchEventMap() {
        return {
          touchmove: this._onTouchMove,
          touchend: this._onTouchEnd
        };
      },
      _createOnKeyDown: function _createOnKeyDown(e) {
        return function (t) {
          this.props.disabled || (this._start(e), this._addHandlers(this._getKeyDownEventMap()), n(t));
        }.bind(this);
      },
      _createOnMouseDown: function _createOnMouseDown(e) {
        return function (t) {
          if (!this.props.disabled) {
            var a = this._getMousePosition(t);

            this._start(e, a[0]), this._addHandlers(this._getMouseEventMap()), n(t);
          }
        }.bind(this);
      },
      _createOnTouchStart: function _createOnTouchStart(e) {
        return function (t) {
          if (!(this.props.disabled || t.touches.length > 1)) {
            var a = this._getTouchPosition(t);

            this.startPosition = a, this.isScrolling = void 0, this._start(e, a[0]), this._addHandlers(this._getTouchEventMap()), function (e) {
              e.stopPropagation && e.stopPropagation();
            }(t);
          }
        }.bind(this);
      },
      _addHandlers: function _addHandlers(e) {
        for (var t in e) {
          document.addEventListener(t, e[t], !1);
        }
      },
      _removeHandlers: function _removeHandlers(e) {
        for (var t in e) {
          document.removeEventListener(t, e[t], !1);
        }
      },
      _start: function _start(e, t) {
        var a = document.activeElement,
            n = this.refs["handle" + e];
        a && a != document.body && a != n && a.blur && a.blur(), this.hasMoved = !1, this._fireChangeEvent("onBeforeChange");
        var r = this.state.zIndices;
        r.splice(r.indexOf(e), 1), r.push(e), this.setState({
          startValue: this.state.value[e],
          startPosition: t,
          index: e,
          zIndices: r
        });
      },
      _onMouseUp: function _onMouseUp() {
        this._onEnd(this._getMouseEventMap());
      },
      _onTouchEnd: function _onTouchEnd() {
        this._onEnd(this._getTouchEventMap());
      },
      _onBlur: function _onBlur() {
        this._onEnd(this._getKeyDownEventMap());
      },
      _onEnd: function _onEnd(e) {
        this._removeHandlers(e), this.setState({
          index: -1
        }, this._fireChangeEvent.bind(this, "onAfterChange"));
      },
      _onMouseMove: function _onMouseMove(e) {
        var t = this._getMousePosition(e),
            a = this._getDiffPosition(t[0]),
            n = this._getValueFromPosition(a);

        this._move(n);
      },
      _onTouchMove: function _onTouchMove(e) {
        if (!(e.touches.length > 1)) {
          var t = this._getTouchPosition(e);

          if (void 0 === this.isScrolling) {
            var a = t[0] - this.startPosition[0],
                r = t[1] - this.startPosition[1];
            this.isScrolling = Math.abs(r) > Math.abs(a);
          }

          if (this.isScrolling) this.setState({
            index: -1
          });else {
            n(e);

            var l = this._getDiffPosition(t[0]),
                o = this._getValueFromPosition(l);

            this._move(o);
          }
        }
      },
      _onKeyDown: function _onKeyDown(e) {
        if (!(e.ctrlKey || e.shiftKey || e.altKey)) switch (e.key) {
          case "ArrowLeft":
          case "ArrowUp":
            return this._moveDownOneStep();

          case "ArrowRight":
          case "ArrowDown":
            return this._moveUpOneStep();

          case "Home":
            return this._move(this.props.min);

          case "End":
            return this._move(this.props.max);

          default:
            return;
        }
      },
      _moveUpOneStep: function _moveUpOneStep() {
        var e = this.state.value[this.state.index] + this.props.step;

        this._move(Math.min(e, this.props.max));
      },
      _moveDownOneStep: function _moveDownOneStep() {
        var e = this.state.value[this.state.index] - this.props.step;

        this._move(Math.max(e, this.props.min));
      },
      _getValueFromPosition: function _getValueFromPosition(e) {
        var t = e / (this.state.sliderLength - this.state.handleSize) * (this.props.max - this.props.min);
        return this._trimAlignValue(this.state.startValue + t);
      },
      _getDiffPosition: function _getDiffPosition(e) {
        var t = e - this.state.startPosition;
        return this.props.invert && (t *= -1), t;
      },
      _move: function _move(e) {
        this.hasMoved = !0;
        var t = this.props,
            a = this.state,
            n = a.index,
            r = a.value,
            l = r.length,
            o = r[n],
            c = t.minDistance;

        if (!t.pearling) {
          if (n > 0) {
            var i = r[n - 1];
            e < i + c && (e = i + c);
          }

          if (n < l - 1) {
            var s = r[n + 1];
            e > s - c && (e = s - c);
          }
        }

        r[n] = e, t.pearling && l > 1 && (e > o ? (this._pushSucceeding(r, c, n), this._trimSucceeding(l, r, c, t.max)) : e < o && (this._pushPreceding(r, c, n), this._trimPreceding(l, r, c, t.min))), e !== o && this.setState({
          value: r
        }, this._fireChangeEvent.bind(this, "onChange"));
      },
      _pushSucceeding: function _pushSucceeding(e, t, a) {
        var n, r;

        for (r = e[n = a] + t; null != e[n + 1] && r > e[n + 1]; r = e[++n] + t) {
          e[n + 1] = this._alignValue(r);
        }
      },
      _trimSucceeding: function _trimSucceeding(e, t, a, n) {
        for (var r = 0; r < e; r++) {
          var l = n - r * a;
          t[e - 1 - r] > l && (t[e - 1 - r] = l);
        }
      },
      _pushPreceding: function _pushPreceding(e, t, a) {
        var n, r;

        for (r = e[n = a] - t; null != e[n - 1] && r < e[n - 1]; r = e[--n] - t) {
          e[n - 1] = this._alignValue(r);
        }
      },
      _trimPreceding: function _trimPreceding(e, t, a, n) {
        for (var r = 0; r < e; r++) {
          var l = n + r * a;
          t[r] < l && (t[r] = l);
        }
      },
      _axisKey: function _axisKey() {
        var e = this.props.orientation;
        return "horizontal" === e ? "X" : "vertical" === e ? "Y" : void 0;
      },
      _orthogonalAxisKey: function _orthogonalAxisKey() {
        var e = this.props.orientation;
        return "horizontal" === e ? "Y" : "vertical" === e ? "X" : void 0;
      },
      _posMinKey: function _posMinKey() {
        var e = this.props.orientation;
        return "horizontal" === e ? this.props.invert ? "right" : "left" : "vertical" === e ? this.props.invert ? "bottom" : "top" : void 0;
      },
      _posMaxKey: function _posMaxKey() {
        var e = this.props.orientation;
        return "horizontal" === e ? this.props.invert ? "left" : "right" : "vertical" === e ? this.props.invert ? "top" : "bottom" : void 0;
      },
      _sizeKey: function _sizeKey() {
        var e = this.props.orientation;
        return "horizontal" === e ? "clientWidth" : "vertical" === e ? "clientHeight" : void 0;
      },
      _trimAlignValue: function _trimAlignValue(e, t) {
        return this._alignValue(this._trimValue(e, t), t);
      },
      _trimValue: function _trimValue(e, t) {
        return e <= (t = t || this.props).min && (e = t.min), e >= t.max && (e = t.max), e;
      },
      _alignValue: function _alignValue(e, t) {
        var a = (e - (t = t || this.props).min) % t.step,
            n = e - a;
        return 2 * Math.abs(a) >= t.step && (n += a > 0 ? t.step : -t.step), parseFloat(n.toFixed(5));
      },
      _renderHandle: function _renderHandle(t, a, n) {
        var r = this.props.handleClassName + " " + this.props.handleClassName + "-" + n + " " + (this.state.index === n ? this.props.handleActiveClassName : "");
        return e.createElement("div", {
          ref: "handle" + n,
          key: "handle" + n,
          className: r,
          style: t,
          onMouseDown: this._createOnMouseDown(n),
          onTouchStart: this._createOnTouchStart(n),
          onFocus: this._createOnKeyDown(n),
          tabIndex: 0,
          role: "slider",
          "aria-valuenow": this.state.value[n],
          "aria-valuemin": this.props.min,
          "aria-valuemax": this.props.max
        }, a);
      },
      _renderHandles: function _renderHandles(t) {
        for (var a = t.length, n = this.tempArray, r = 0; r < a; r++) {
          n[r] = this._buildHandleStyle(t[r], r);
        }

        var l = this.tempArray,
            o = this._renderHandle;
        if (e.Children.count(this.props.children) > 0) e.Children.forEach(this.props.children, function (e, t) {
          l[t] = o(n[t], e, t);
        });else for (r = 0; r < a; r++) {
          l[r] = o(n[r], null, r);
        }
        return l;
      },
      _renderBar: function _renderBar(t, a, n) {
        return e.createElement("div", {
          key: "bar" + t,
          ref: "bar" + t,
          className: this.props.barClassName + " " + this.props.barClassName + "-" + t,
          style: this._buildBarStyle(a, this.state.upperBound - n)
        });
      },
      _renderBars: function _renderBars(e) {
        var t = [],
            a = e.length - 1;
        t.push(this._renderBar(0, 0, e[0]));

        for (var n = 0; n < a; n++) {
          t.push(this._renderBar(n + 1, e[n], e[n + 1]));
        }

        return t.push(this._renderBar(a + 1, e[a], this.state.upperBound)), t;
      },
      _onSliderMouseDown: function _onSliderMouseDown(e) {
        if (!this.props.disabled) {
          if (this.hasMoved = !1, !this.props.snapDragDisabled) {
            var t = this._getMousePosition(e);

            this._forceValueFromPosition(t[0], function (e) {
              this._fireChangeEvent("onChange"), this._start(e, t[0]), this._addHandlers(this._getMouseEventMap());
            }.bind(this));
          }

          n(e);
        }
      },
      _onSliderClick: function _onSliderClick(e) {
        if (!this.props.disabled && this.props.onSliderClick && !this.hasMoved) {
          var t = this._getMousePosition(e),
              a = this._trimAlignValue(this._calcValue(this._calcOffsetFromPosition(t[0])));

          this.props.onSliderClick(a);
        }
      },
      _fireChangeEvent: function _fireChangeEvent(e) {
        this.props[e] && this.props[e](l(this.state.value));
      },
      render: function render() {
        for (var t = this.state, a = this.props, n = this.tempArray, r = t.value, l = r.length, o = 0; o < l; o++) {
          n[o] = this._calcOffset(r[o], o);
        }

        var c = a.withBars ? this._renderBars(n) : null,
            i = this._renderHandles(n);

        return e.createElement("div", {
          ref: "slider",
          style: {
            position: "relative"
          },
          className: a.className + (a.disabled ? " disabled" : ""),
          onMouseDown: this._onSliderMouseDown,
          onClick: this._onSliderClick
        }, c, i);
      }
    });
  }, e.exports = a(React__default, PropTypes, createReactClass);
}),
    _templateObject$12 = taggedTemplateLiteral(["\n\tfont-family: ", ";\n\tposition: absolute;\n\ttop: -100%;\n\tfont-size: 0.75em;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\ttext-align: center;\n\tcolor: ", ";\n"], ["\n\tfont-family: ", ";\n\tposition: absolute;\n\ttop: -100%;\n\tfont-size: 0.75em;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\ttext-align: center;\n\tcolor: ", ";\n"]),
    _templateObject2$7 = taggedTemplateLiteral(["\n\theight: 0.5em;\n\tbackground-color: ", ";\n\tborder-radius: 10em;\n\tmax-width: 350px;\n\tcursor: pointer;\n\tmargin: 0 auto;\n\ttransition: background-color 0.3s ease;\n\t.bar {\n\t\t&:first-child {\n\t\t\tborder-top-left-radius: inherit;\n\t\t\tborder-bottom-left-radius: inherit;\n\t\t}\n\t\theight: 100%;\n\t}\n\t.bar-0 {\n\t\tbackground-color: ", ";\n\t}\n\t.handle {\n\t\theight: 1em;\n\t\twidth: 1em;\n\t\tborder-radius: 50%;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%) scale(1.1);\n\t\tbackground-color: ", ";\n\t\ttransition: background-color 0.3s ease,\n\t\t\ttransform 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);\n\t\t&:hover,\n\t\t&.active {\n\t\t\tbackground-color: ", ";\n\t\t\ttransform: translateY(-50%) scale(1.25);\n\t\t}\n\t\t&:focus {\n\t\t\toutline: none;\n\t\t\tbox-shadow: ", ";\n\t\t}\n\t}\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n"], ["\n\theight: 0.5em;\n\tbackground-color: ", ";\n\tborder-radius: 10em;\n\tmax-width: 350px;\n\tcursor: pointer;\n\tmargin: 0 auto;\n\ttransition: background-color 0.3s ease;\n\t.bar {\n\t\t&:first-child {\n\t\t\tborder-top-left-radius: inherit;\n\t\t\tborder-bottom-left-radius: inherit;\n\t\t}\n\t\theight: 100%;\n\t}\n\t.bar-0 {\n\t\tbackground-color: ", ";\n\t}\n\t.handle {\n\t\theight: 1em;\n\t\twidth: 1em;\n\t\tborder-radius: 50%;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%) scale(1.1);\n\t\tbackground-color: ", ";\n\t\ttransition: background-color 0.3s ease,\n\t\t\ttransform 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);\n\t\t&:hover,\n\t\t&.active {\n\t\t\tbackground-color: ", ";\n\t\t\ttransform: translateY(-50%) scale(1.25);\n\t\t}\n\t\t&:focus {\n\t\t\toutline: none;\n\t\t\tbox-shadow: ", ";\n\t\t}\n\t}\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n"]),
    SliderHandleLabel = styled__default.span(_templateObject$12, function (e) {
  return e.theme.fontFamily;
}, function (e) {
  return e.theme.primary[2];
}),
    Slider$1 = styled__default(reactSlider).attrs({
  withBars: !0
})(_templateObject2$7, function (e) {
  return e.theme.neutralLight[4];
}, function (e) {
  return e.theme.primary[3];
}, function (e) {
  return e.theme.primary[2];
}, function (e) {
  return e.theme.primary[1];
}, function (e) {
  return e.theme.focusShadowA;
}, function (e) {
  return e.theme.neutralLight[3];
}),
    _templateObject$13 = taggedTemplateLiteral(["\n\theight: 1.45em;\n\tline-height: 1.45em;\n\tborder-radius: 0.72em;\n\tpadding: 0 1em;\n\tbackground-color: ", ";\n\tcolor: ", ";\n"], ["\n\theight: 1.45em;\n\tline-height: 1.45em;\n\tborder-radius: 0.72em;\n\tpadding: 0 1em;\n\tbackground-color: ", ";\n\tcolor: ", ";\n"]),
    Chip = styled__default.div(_templateObject$13, function (e) {
  return e.theme.primary[2];
}, function (e) {
  return e.theme.neutralLight[7];
}),
    _templateObject$14 = taggedTemplateLiteral(["\n\tfont-size: 5px;\n\ttouch-action: pan-x;\n\tdisplay: inline-block;\n\tposition: relative;\n\tcursor: pointer;\n\tbackground-color: transparent;\n\tborder: 0;\n\tpadding: 0;\n\tuser-select: none;\n\t-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n\t-webkit-tap-highlight-color: transparent;\n\t&.react-toggle--checked .react-toggle-track-x {\n\t\topacity: 0;\n\t}\n\t&.react-toggle--checked .react-toggle-thumb {\n\t\tleft: 4.3em;\n\t\tbackground-color: ", ";\n\t}\n\t&.react-toggle--disabled {\n\t\tcursor: not-allowed;\n\t\topacity: 0.5;\n\t\ttransition: opacity 0.25s;\n\t}\n\t&.react-toggle--focus .react-toggle-track {\n\t\tbox-shadow: inset 0 0 0 0.5em rgba(3, 102, 214, 0.3);\n\t}\n\t.react-toggle-screenreader-only {\n\t\tborder: 0;\n\t\tclip: rect(0 0 0 0);\n\t\theight: 1px;\n\t\tmargin: -1px;\n\t\toverflow: hidden;\n\t\tpadding: 0;\n\t\tposition: absolute;\n\t\twidth: 1px;\n\t}\n\t.react-toggle-thumb {\n\t\ttransition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 2.8em;\n\t\theight: 2.8em;\n\t\tborder-radius: 50%;\n\t\tbackground-color: ", ";\n\t\tbox-sizing: border-box;\n\t\ttransition: all 0.25s ease;\n\t}\n\t.react-toggle-track {\n\t\twidth: 7em;\n\t\theight: 2.8em;\n\t\tpadding: 0;\n\t\tborder-radius: 3em;\n\t\tbackground-color: ", ";\n\t\ttransition: all 0.2s ease;\n\t}\n\t.react-toggle--checked .react-toggle-track-check {\n\t\topacity: 1;\n\t\ttransition: opacity 0.25s ease;\n\t}\n"], ["\n\tfont-size: 5px;\n\ttouch-action: pan-x;\n\tdisplay: inline-block;\n\tposition: relative;\n\tcursor: pointer;\n\tbackground-color: transparent;\n\tborder: 0;\n\tpadding: 0;\n\tuser-select: none;\n\t-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n\t-webkit-tap-highlight-color: transparent;\n\t&.react-toggle--checked .react-toggle-track-x {\n\t\topacity: 0;\n\t}\n\t&.react-toggle--checked .react-toggle-thumb {\n\t\tleft: 4.3em;\n\t\tbackground-color: ", ";\n\t}\n\t&.react-toggle--disabled {\n\t\tcursor: not-allowed;\n\t\topacity: 0.5;\n\t\ttransition: opacity 0.25s;\n\t}\n\t&.react-toggle--focus .react-toggle-track {\n\t\tbox-shadow: inset 0 0 0 0.5em rgba(3, 102, 214, 0.3);\n\t}\n\t.react-toggle-screenreader-only {\n\t\tborder: 0;\n\t\tclip: rect(0 0 0 0);\n\t\theight: 1px;\n\t\tmargin: -1px;\n\t\toverflow: hidden;\n\t\tpadding: 0;\n\t\tposition: absolute;\n\t\twidth: 1px;\n\t}\n\t.react-toggle-thumb {\n\t\ttransition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 2.8em;\n\t\theight: 2.8em;\n\t\tborder-radius: 50%;\n\t\tbackground-color: ", ";\n\t\tbox-sizing: border-box;\n\t\ttransition: all 0.25s ease;\n\t}\n\t.react-toggle-track {\n\t\twidth: 7em;\n\t\theight: 2.8em;\n\t\tpadding: 0;\n\t\tborder-radius: 3em;\n\t\tbackground-color: ", ";\n\t\ttransition: all 0.2s ease;\n\t}\n\t.react-toggle--checked .react-toggle-track-check {\n\t\topacity: 1;\n\t\ttransition: opacity 0.25s ease;\n\t}\n"]),
    MiniToggle = styled__default(Toggle).attrs({
  icons: !1
})(_templateObject$14, function (e) {
  return e.theme.primary[2];
}, function (e) {
  return e.theme.neutralLight[2];
}, function (e) {
  return e.theme.neutralLight[4];
}),
    _templateObject$15 = taggedTemplateLiteral(["\n\tposition: absolute;\n\topacity: 0;\n\theight: 0;\n\twidth: 0;\n\tmargin: 0;\n"], ["\n\tposition: absolute;\n\topacity: 0;\n\theight: 0;\n\twidth: 0;\n\tmargin: 0;\n"]),
    HiddenInput = styled__default.input(_templateObject$15),
    _templateObject$16 = taggedTemplateLiteral(["\n\tfont-size: 1em;\n\tdisplay: inline-block;\n\tposition: relative;\n\ttop: -0.1em;\n\t> ", ":first-child {\n\t\t&:active + svg circle.sd-radio-outer-circle {\n\t\t\tfill: ", ";\n\t\t}\n\t\t&:focus + svg circle.sd-radio-focus-circle {\n\t\t\tdisplay: initial;\n\t\t}\n\t}\n\t> ", ":checked + svg circle.sd-radio-inner-circle {\n\t\ttransform: scale(1);\n\t}\n\t> svg {\n\t\tfont-size: 1em;\n\t\theight: 1.5em;\n\t\twidth: 1.5em;\n\t\tvertical-align: middle;\n\t\t&:not(:last-child) {\n\t\t\tmargin-right: 0.5em;\n\t\t}\n\t\tcircle.sd-radio-focus-circle {\n\t\t\tdisplay: none;\n\t\t\tfill: ", ";\n\t\t}\n\t\tcircle.sd-radio-outer-circle {\n\t\t\tfill: ", ";\n\t\t\tstroke: ", ";\n\t\t}\n\t\tcircle.sd-radio-inner-circle {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\ttransform: scale(0);\n\t\t\ttransform-origin: center;\n\t\t\ttransition: transform 0.125s;\n\t\t\tfill: ", ";\n\t\t}\n\t}\n"], ["\n\tfont-size: 1em;\n\tdisplay: inline-block;\n\tposition: relative;\n\ttop: -0.1em;\n\t> ", ":first-child {\n\t\t&:active + svg circle.sd-radio-outer-circle {\n\t\t\tfill: ", ";\n\t\t}\n\t\t&:focus + svg circle.sd-radio-focus-circle {\n\t\t\tdisplay: initial;\n\t\t}\n\t}\n\t> ", ":checked + svg circle.sd-radio-inner-circle {\n\t\ttransform: scale(1);\n\t}\n\t> svg {\n\t\tfont-size: 1em;\n\t\theight: 1.5em;\n\t\twidth: 1.5em;\n\t\tvertical-align: middle;\n\t\t&:not(:last-child) {\n\t\t\tmargin-right: 0.5em;\n\t\t}\n\t\tcircle.sd-radio-focus-circle {\n\t\t\tdisplay: none;\n\t\t\tfill: ", ";\n\t\t}\n\t\tcircle.sd-radio-outer-circle {\n\t\t\tfill: ", ";\n\t\t\tstroke: ", ";\n\t\t}\n\t\tcircle.sd-radio-inner-circle {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\ttransform: scale(0);\n\t\t\ttransform-origin: center;\n\t\t\ttransition: transform 0.125s;\n\t\t\tfill: ", ";\n\t\t}\n\t}\n"]),
    BaseRadio = function BaseRadio(e) {
  var t = e.children,
      a = e.className,
      n = objectWithoutProperties(e, ["children", "className"]);
  return React.createElement("label", {
    className: a
  }, React.createElement(HiddenInput, _extends$107({
    type: "radio"
  }, n)), React.createElement("svg", {
    viewBox: "0 0 2 2",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("circle", {
    className: "sd-radio-focus-circle",
    cx: "50%",
    cy: "50%",
    r: "0.88"
  }), React.createElement("circle", {
    className: "sd-radio-outer-circle",
    cx: "50%",
    cy: "50%",
    r: "0.65",
    strokeWidth: "0.13"
  }), React.createElement("circle", {
    className: "sd-radio-inner-circle",
    cx: "50%",
    cy: "50%",
    r: "0.35"
  })), t);
},
    Radio = styled__default(BaseRadio)(_templateObject$16, HiddenInput, function (e) {
  return e.theme.neutralLight[5];
}, HiddenInput, function (e) {
  return e.theme.focusA;
}, function (e) {
  return e.theme.neutralLight[7];
}, function (e) {
  return e.theme.primary[2];
}, function (e) {
  return e.theme.primary[2];
}),
    RadioGroup = function RadioGroup(e) {
  var t = e.name,
      a = e.selectedValue,
      n = e.onChange,
      r = e.children;
  return React.createElement("div", null, React.Children.map(r, function (e) {
    var r = e.props.value;
    return React.cloneElement(e, {
      name: t,
      onChange: n,
      checked: r === a
    });
  }));
},
    _templateObject$17 = taggedTemplateLiteral(["\n\t> ", ":first-child {\n\t\t&:active + svg rect.sd-check-rect {\n\t\t\tfill: ", ";\n\t\t}\n\t\t&:focus + svg rect.sd-check-focus-rect {\n\t\t\ttransform: scale(1);\n\t\t}\n\t}\n\t> ", ":checked + svg polyline {\n\t\ttransform: scale(1);\n\t}\n\t> svg {\n\t\tfont-size: 1em;\n\t\theight: 1.5em;\n\t\twidth: 1.5em;\n\t\tvertical-align: middle;\n\t\t&:not(:last-child) {\n\t\t\tmargin-right: 0.5em;\n\t\t}\n\t\trect.sd-check-rect {\n\t\t\tstroke: ", ";\n\t\t\tfill: ", ";\n\t\t}\n\t\trect.sd-check-focus-rect {\n\t\t\tfill: ", ";\n\t\t\ttransform: scale(0.8);\n\t\t\ttransform-origin: center;\n\t\t\ttransition: transform 0.125s;\n\t\t}\n\t\tpolyline {\n\t\t\tstroke: ", ";\n\t\t\tfill: none;\n\t\t\ttransform: scale(0);\n\t\t\ttransform-origin: center;\n\t\t\ttransition: transform 0.125s;\n\t\t}\n\t}\n"], ["\n\t> ", ":first-child {\n\t\t&:active + svg rect.sd-check-rect {\n\t\t\tfill: ", ";\n\t\t}\n\t\t&:focus + svg rect.sd-check-focus-rect {\n\t\t\ttransform: scale(1);\n\t\t}\n\t}\n\t> ", ":checked + svg polyline {\n\t\ttransform: scale(1);\n\t}\n\t> svg {\n\t\tfont-size: 1em;\n\t\theight: 1.5em;\n\t\twidth: 1.5em;\n\t\tvertical-align: middle;\n\t\t&:not(:last-child) {\n\t\t\tmargin-right: 0.5em;\n\t\t}\n\t\trect.sd-check-rect {\n\t\t\tstroke: ", ";\n\t\t\tfill: ", ";\n\t\t}\n\t\trect.sd-check-focus-rect {\n\t\t\tfill: ", ";\n\t\t\ttransform: scale(0.8);\n\t\t\ttransform-origin: center;\n\t\t\ttransition: transform 0.125s;\n\t\t}\n\t\tpolyline {\n\t\t\tstroke: ", ";\n\t\t\tfill: none;\n\t\t\ttransform: scale(0);\n\t\t\ttransform-origin: center;\n\t\t\ttransition: transform 0.125s;\n\t\t}\n\t}\n"]),
    BaseCheckbox = function BaseCheckbox(e) {
  var t = e.children,
      a = e.className,
      n = objectWithoutProperties(e, ["children", "className"]);
  return React.createElement("label", {
    className: a
  }, React.createElement(HiddenInput, _extends$107({
    type: "checkbox"
  }, n)), React.createElement("svg", {
    viewBox: "0 0 2 2",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("rect", {
    className: "sd-check-focus-rect",
    x: "0.025",
    y: "0.025",
    width: "1.95",
    height: "1.95",
    rx: "0.45",
    ry: "0.45"
  }), React.createElement("rect", {
    className: "sd-check-rect",
    x: "0.25",
    y: "0.25",
    width: "1.5",
    height: "1.5",
    rx: "0.3",
    ry: "0.3",
    strokeWidth: "0.1"
  }), React.createElement("polyline", {
    points: "1.35,0.8 0.85,1.3 0.65,1.1",
    strokeWidth: "0.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), t);
},
    Checkbox = styled__default(BaseCheckbox)(_templateObject$17, HiddenInput, function (e) {
  return e.theme.neutralLight[5];
}, HiddenInput, function (e) {
  return e.theme.neutralLight[3];
}, function (e) {
  return e.theme.neutralLight[7];
}, function (e) {
  return e.theme.focusA;
}, function (e) {
  return e.theme.primary[1];
}),
    CheckboxGroup = function CheckboxGroup(e) {
  var t = e.name,
      a = e.selectedValues,
      n = e.onChange,
      r = e.children;
  return React.createElement("div", null, React.Children.map(r, function (e) {
    var r = e.props.value;
    return React.cloneElement(e, {
      name: t,
      onChange: n,
      checked: -1 < a.indexOf(r)
    });
  }));
},
    mapToZero_1 = createCommonjsModule(function (e, t) {
  t.__esModule = !0, t.default = function (e) {
    var t = {};

    for (var a in e) {
      Object.prototype.hasOwnProperty.call(e, a) && (t[a] = 0);
    }

    return t;
  }, e.exports = t.default;
});

unwrapExports(mapToZero_1);
var stripStyle_1 = createCommonjsModule(function (e, t) {
  t.__esModule = !0, t.default = function (e) {
    var t = {};

    for (var a in e) {
      Object.prototype.hasOwnProperty.call(e, a) && (t[a] = "number" == typeof e[a] ? e[a] : e[a].val);
    }

    return t;
  }, e.exports = t.default;
});
unwrapExports(stripStyle_1);
var stepper_1 = createCommonjsModule(function (e, t) {
  t.__esModule = !0, t.default = function (e, t, n, r, l, o, c) {
    var i = n + (-l * (t - r) + -o * n) * e,
        s = t + i * e;
    if (Math.abs(i) < c && Math.abs(s - r) < c) return a[0] = r, a[1] = 0, a;
    return a[0] = s, a[1] = i, a;
  };
  var a = [0, 0];
  e.exports = t.default;
});
unwrapExports(stepper_1);
var performanceNow$1 = createCommonjsModule(function (e) {
  (function () {
    var t, a, n;
    "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function () {
      return performance.now();
    } : "undefined" != typeof process && null !== process && process.hrtime ? (e.exports = function () {
      return (t() - n) / 1e6;
    }, a = process.hrtime, n = (t = function t() {
      var e;
      return 1e9 * (e = a())[0] + e[1];
    })()) : Date.now ? (e.exports = function () {
      return Date.now() - n;
    }, n = Date.now()) : (e.exports = function () {
      return new Date().getTime() - n;
    }, n = new Date().getTime());
  }).call(commonjsGlobal);
}),
    shouldStopAnimation_1 = createCommonjsModule(function (e, t) {
  t.__esModule = !0, t.default = function (e, t, a) {
    for (var n in t) {
      if (Object.prototype.hasOwnProperty.call(t, n)) {
        if (0 !== a[n]) return !1;
        var r = "number" == typeof t[n] ? t[n] : t[n].val;
        if (e[n] !== r) return !1;
      }
    }

    return !0;
  }, e.exports = t.default;
});
unwrapExports(shouldStopAnimation_1);
var Motion_1 = createCommonjsModule(function (e, t) {
  t.__esModule = !0;

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }();

  function r(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var l = r(mapToZero_1),
      o = r(stripStyle_1),
      c = r(stepper_1),
      i = r(performanceNow$1),
      s = r(raf_1),
      u = r(shouldStopAnimation_1),
      f = r(React__default),
      d = r(PropTypes),
      p = 1e3 / 60,
      h = function (e) {
    function t(n) {
      var r = this;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), e.call(this, n), this.wasAnimating = !1, this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyle = null, this.clearUnreadPropStyle = function (e) {
        var t = !1,
            n = r.state,
            l = n.currentStyle,
            o = n.currentVelocity,
            c = n.lastIdealStyle,
            i = n.lastIdealVelocity;

        for (var s in e) {
          if (Object.prototype.hasOwnProperty.call(e, s)) {
            var u = e[s];
            "number" == typeof u && (t || (t = !0, l = a({}, l), o = a({}, o), c = a({}, c), i = a({}, i)), l[s] = u, o[s] = 0, c[s] = u, i[s] = 0);
          }
        }

        t && r.setState({
          currentStyle: l,
          currentVelocity: o,
          lastIdealStyle: c,
          lastIdealVelocity: i
        });
      }, this.startAnimationIfNecessary = function () {
        r.animationID = s.default(function (e) {
          var t = r.props.style;
          if (u.default(r.state.currentStyle, t, r.state.currentVelocity)) return r.wasAnimating && r.props.onRest && r.props.onRest(), r.animationID = null, r.wasAnimating = !1, void (r.accumulatedTime = 0);
          r.wasAnimating = !0;
          var a = e || i.default(),
              n = a - r.prevTime;
          if (r.prevTime = a, r.accumulatedTime = r.accumulatedTime + n, r.accumulatedTime > 10 * p && (r.accumulatedTime = 0), 0 === r.accumulatedTime) return r.animationID = null, void r.startAnimationIfNecessary();
          var l = (r.accumulatedTime - Math.floor(r.accumulatedTime / p) * p) / p,
              o = Math.floor(r.accumulatedTime / p),
              s = {},
              f = {},
              d = {},
              h = {};

          for (var m in t) {
            if (Object.prototype.hasOwnProperty.call(t, m)) {
              var _ = t[m];
              if ("number" == typeof _) d[m] = _, h[m] = 0, s[m] = _, f[m] = 0;else {
                for (var v = r.state.lastIdealStyle[m], y = r.state.lastIdealVelocity[m], g = 0; g < o; g++) {
                  var E = c.default(p / 1e3, v, y, _.val, _.stiffness, _.damping, _.precision);
                  v = E[0], y = E[1];
                }

                var b = c.default(p / 1e3, v, y, _.val, _.stiffness, _.damping, _.precision),
                    z = b[0],
                    R = b[1];
                d[m] = v + (z - v) * l, h[m] = y + (R - y) * l, s[m] = v, f[m] = y;
              }
            }
          }

          r.animationID = null, r.accumulatedTime -= o * p, r.setState({
            currentStyle: d,
            currentVelocity: h,
            lastIdealStyle: s,
            lastIdealVelocity: f
          }), r.unreadPropStyle = null, r.startAnimationIfNecessary();
        });
      }, this.state = this.defaultState();
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, e), n(t, null, [{
      key: "propTypes",
      value: {
        defaultStyle: d.default.objectOf(d.default.number),
        style: d.default.objectOf(d.default.oneOfType([d.default.number, d.default.object])).isRequired,
        children: d.default.func.isRequired,
        onRest: d.default.func
      },
      enumerable: !0
    }]), t.prototype.defaultState = function () {
      var e = this.props,
          t = e.defaultStyle,
          a = e.style,
          n = t || o.default(a),
          r = l.default(n);
      return {
        currentStyle: n,
        currentVelocity: r,
        lastIdealStyle: n,
        lastIdealVelocity: r
      };
    }, t.prototype.componentDidMount = function () {
      this.prevTime = i.default(), this.startAnimationIfNecessary();
    }, t.prototype.componentWillReceiveProps = function (e) {
      null != this.unreadPropStyle && this.clearUnreadPropStyle(this.unreadPropStyle), this.unreadPropStyle = e.style, null == this.animationID && (this.prevTime = i.default(), this.startAnimationIfNecessary());
    }, t.prototype.componentWillUnmount = function () {
      null != this.animationID && (s.default.cancel(this.animationID), this.animationID = null);
    }, t.prototype.render = function () {
      var e = this.props.children(this.state.currentStyle);
      return e && f.default.Children.only(e);
    }, t;
  }(f.default.Component);

  t.default = h, e.exports = t.default;
});
unwrapExports(Motion_1);
var StaggeredMotion_1 = createCommonjsModule(function (e, t) {
  t.__esModule = !0;

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }();

  function r(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var l = r(mapToZero_1),
      o = r(stripStyle_1),
      c = r(stepper_1),
      i = r(performanceNow$1),
      s = r(raf_1),
      u = r(shouldStopAnimation_1),
      f = r(React__default),
      d = r(PropTypes),
      p = 1e3 / 60;

  var h = function (e) {
    function t(n) {
      var r = this;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), e.call(this, n), this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyles = null, this.clearUnreadPropStyle = function (e) {
        for (var t = r.state, n = t.currentStyles, l = t.currentVelocities, o = t.lastIdealStyles, c = t.lastIdealVelocities, i = !1, s = 0; s < e.length; s++) {
          var u = e[s],
              f = !1;

          for (var d in u) {
            if (Object.prototype.hasOwnProperty.call(u, d)) {
              var p = u[d];
              "number" == typeof p && (f || (f = !0, i = !0, n[s] = a({}, n[s]), l[s] = a({}, l[s]), o[s] = a({}, o[s]), c[s] = a({}, c[s])), n[s][d] = p, l[s][d] = 0, o[s][d] = p, c[s][d] = 0);
            }
          }
        }

        i && r.setState({
          currentStyles: n,
          currentVelocities: l,
          lastIdealStyles: o,
          lastIdealVelocities: c
        });
      }, this.startAnimationIfNecessary = function () {
        r.animationID = s.default(function (e) {
          var t = r.props.styles(r.state.lastIdealStyles);
          if (function (e, t, a) {
            for (var n = 0; n < e.length; n++) {
              if (!u.default(e[n], t[n], a[n])) return !1;
            }

            return !0;
          }(r.state.currentStyles, t, r.state.currentVelocities)) return r.animationID = null, void (r.accumulatedTime = 0);
          var a = e || i.default(),
              n = a - r.prevTime;
          if (r.prevTime = a, r.accumulatedTime = r.accumulatedTime + n, r.accumulatedTime > 10 * p && (r.accumulatedTime = 0), 0 === r.accumulatedTime) return r.animationID = null, void r.startAnimationIfNecessary();

          for (var l = (r.accumulatedTime - Math.floor(r.accumulatedTime / p) * p) / p, o = Math.floor(r.accumulatedTime / p), s = [], f = [], d = [], h = [], m = 0; m < t.length; m++) {
            var _ = t[m],
                v = {},
                y = {},
                g = {},
                E = {};

            for (var b in _) {
              if (Object.prototype.hasOwnProperty.call(_, b)) {
                var z = _[b];
                if ("number" == typeof z) v[b] = z, y[b] = 0, g[b] = z, E[b] = 0;else {
                  for (var R = r.state.lastIdealStyles[m][b], M = r.state.lastIdealVelocities[m][b], w = 0; w < o; w++) {
                    var O = c.default(p / 1e3, R, M, z.val, z.stiffness, z.damping, z.precision);
                    R = O[0], M = O[1];
                  }

                  var C = c.default(p / 1e3, R, M, z.val, z.stiffness, z.damping, z.precision),
                      x = C[0],
                      P = C[1];
                  v[b] = R + (x - R) * l, y[b] = M + (P - M) * l, g[b] = R, E[b] = M;
                }
              }
            }

            d[m] = v, h[m] = y, s[m] = g, f[m] = E;
          }

          r.animationID = null, r.accumulatedTime -= o * p, r.setState({
            currentStyles: d,
            currentVelocities: h,
            lastIdealStyles: s,
            lastIdealVelocities: f
          }), r.unreadPropStyles = null, r.startAnimationIfNecessary();
        });
      }, this.state = this.defaultState();
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, e), n(t, null, [{
      key: "propTypes",
      value: {
        defaultStyles: d.default.arrayOf(d.default.objectOf(d.default.number)),
        styles: d.default.func.isRequired,
        children: d.default.func.isRequired
      },
      enumerable: !0
    }]), t.prototype.defaultState = function () {
      var e = this.props,
          t = e.defaultStyles,
          a = e.styles,
          n = t || a().map(o.default),
          r = n.map(function (e) {
        return l.default(e);
      });
      return {
        currentStyles: n,
        currentVelocities: r,
        lastIdealStyles: n,
        lastIdealVelocities: r
      };
    }, t.prototype.componentDidMount = function () {
      this.prevTime = i.default(), this.startAnimationIfNecessary();
    }, t.prototype.componentWillReceiveProps = function (e) {
      null != this.unreadPropStyles && this.clearUnreadPropStyle(this.unreadPropStyles), this.unreadPropStyles = e.styles(this.state.lastIdealStyles), null == this.animationID && (this.prevTime = i.default(), this.startAnimationIfNecessary());
    }, t.prototype.componentWillUnmount = function () {
      null != this.animationID && (s.default.cancel(this.animationID), this.animationID = null);
    }, t.prototype.render = function () {
      var e = this.props.children(this.state.currentStyles);
      return e && f.default.Children.only(e);
    }, t;
  }(f.default.Component);

  t.default = h, e.exports = t.default;
});
unwrapExports(StaggeredMotion_1);
var mergeDiff_1 = createCommonjsModule(function (e, t) {
  t.__esModule = !0, t.default = function (e, t, a) {
    for (var n = {}, r = 0; r < e.length; r++) {
      n[e[r].key] = r;
    }

    for (var l = {}, r = 0; r < t.length; r++) {
      l[t[r].key] = r;
    }

    for (var o = [], r = 0; r < t.length; r++) {
      o[r] = t[r];
    }

    for (var r = 0; r < e.length; r++) {
      if (!Object.prototype.hasOwnProperty.call(l, e[r].key)) {
        var c = a(r, e[r]);
        null != c && o.push(c);
      }
    }

    return o.sort(function (e, a) {
      var r = l[e.key],
          o = l[a.key],
          c = n[e.key],
          i = n[a.key];
      if (null != r && null != o) return l[e.key] - l[a.key];
      if (null != c && null != i) return n[e.key] - n[a.key];

      if (null != r) {
        for (var s = 0; s < t.length; s++) {
          var u = t[s].key;

          if (Object.prototype.hasOwnProperty.call(n, u)) {
            if (r < l[u] && i > n[u]) return -1;
            if (r > l[u] && i < n[u]) return 1;
          }
        }

        return 1;
      }

      for (var s = 0; s < t.length; s++) {
        var u = t[s].key;

        if (Object.prototype.hasOwnProperty.call(n, u)) {
          if (o < l[u] && c > n[u]) return 1;
          if (o > l[u] && c < n[u]) return -1;
        }
      }

      return -1;
    });
  }, e.exports = t.default;
});
unwrapExports(mergeDiff_1);
var TransitionMotion_1 = createCommonjsModule(function (e, t) {
  t.__esModule = !0;

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }();

  function r(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var l = r(mapToZero_1),
      o = r(stripStyle_1),
      c = r(stepper_1),
      i = r(mergeDiff_1),
      s = r(performanceNow$1),
      u = r(raf_1),
      f = r(shouldStopAnimation_1),
      d = r(React__default),
      p = r(PropTypes),
      h = 1e3 / 60;

  function m(e, t, a) {
    var n = t;
    return null == n ? e.map(function (e, t) {
      return {
        key: e.key,
        data: e.data,
        style: a[t]
      };
    }) : e.map(function (e, t) {
      for (var r = 0; r < n.length; r++) {
        if (n[r].key === e.key) return {
          key: n[r].key,
          data: n[r].data,
          style: a[t]
        };
      }

      return {
        key: e.key,
        data: e.data,
        style: a[t]
      };
    });
  }

  function _(e, t, a, n, r, o, c, s, u) {
    for (var d = i.default(n, r, function (e, n) {
      var r = t(n);
      return null == r ? (a({
        key: n.key,
        data: n.data
      }), null) : f.default(o[e], r, c[e]) ? (a({
        key: n.key,
        data: n.data
      }), null) : {
        key: n.key,
        data: n.data,
        style: r
      };
    }), p = [], h = [], m = [], _ = [], v = 0; v < d.length; v++) {
      for (var y = d[v], g = null, E = 0; E < n.length; E++) {
        if (n[E].key === y.key) {
          g = E;
          break;
        }
      }

      if (null == g) {
        var b = e(y);
        p[v] = b, m[v] = b;
        var z = l.default(y.style);
        h[v] = z, _[v] = z;
      } else p[v] = o[g], m[v] = s[g], h[v] = c[g], _[v] = u[g];
    }

    return [d, p, h, m, _];
  }

  var v = function (e) {
    function t(n) {
      var r = this;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), e.call(this, n), this.unmounting = !1, this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyles = null, this.clearUnreadPropStyle = function (e) {
        for (var t = _(r.props.willEnter, r.props.willLeave, r.props.didLeave, r.state.mergedPropsStyles, e, r.state.currentStyles, r.state.currentVelocities, r.state.lastIdealStyles, r.state.lastIdealVelocities), n = t[0], l = t[1], o = t[2], c = t[3], i = t[4], s = 0; s < e.length; s++) {
          var u = e[s].style,
              f = !1;

          for (var d in u) {
            if (Object.prototype.hasOwnProperty.call(u, d)) {
              var p = u[d];
              "number" == typeof p && (f || (f = !0, l[s] = a({}, l[s]), o[s] = a({}, o[s]), c[s] = a({}, c[s]), i[s] = a({}, i[s]), n[s] = {
                key: n[s].key,
                data: n[s].data,
                style: a({}, n[s].style)
              }), l[s][d] = p, o[s][d] = 0, c[s][d] = p, i[s][d] = 0, n[s].style[d] = p);
            }
          }
        }

        r.setState({
          currentStyles: l,
          currentVelocities: o,
          mergedPropsStyles: n,
          lastIdealStyles: c,
          lastIdealVelocities: i
        });
      }, this.startAnimationIfNecessary = function () {
        r.unmounting || (r.animationID = u.default(function (e) {
          if (!r.unmounting) {
            var t = r.props.styles,
                a = "function" == typeof t ? t(m(r.state.mergedPropsStyles, r.unreadPropStyles, r.state.lastIdealStyles)) : t;
            if (function (e, t, a, n) {
              if (n.length !== t.length) return !1;

              for (var r = 0; r < n.length; r++) {
                if (n[r].key !== t[r].key) return !1;
              }

              for (r = 0; r < n.length; r++) {
                if (!f.default(e[r], t[r].style, a[r])) return !1;
              }

              return !0;
            }(r.state.currentStyles, a, r.state.currentVelocities, r.state.mergedPropsStyles)) return r.animationID = null, void (r.accumulatedTime = 0);
            var n = e || s.default(),
                l = n - r.prevTime;
            if (r.prevTime = n, r.accumulatedTime = r.accumulatedTime + l, r.accumulatedTime > 10 * h && (r.accumulatedTime = 0), 0 === r.accumulatedTime) return r.animationID = null, void r.startAnimationIfNecessary();

            for (var o = (r.accumulatedTime - Math.floor(r.accumulatedTime / h) * h) / h, i = Math.floor(r.accumulatedTime / h), u = _(r.props.willEnter, r.props.willLeave, r.props.didLeave, r.state.mergedPropsStyles, a, r.state.currentStyles, r.state.currentVelocities, r.state.lastIdealStyles, r.state.lastIdealVelocities), d = u[0], p = u[1], v = u[2], y = u[3], g = u[4], E = 0; E < d.length; E++) {
              var b = d[E].style,
                  z = {},
                  R = {},
                  M = {},
                  w = {};

              for (var O in b) {
                if (Object.prototype.hasOwnProperty.call(b, O)) {
                  var C = b[O];
                  if ("number" == typeof C) z[O] = C, R[O] = 0, M[O] = C, w[O] = 0;else {
                    for (var x = y[E][O], P = g[E][O], T = 0; T < i; T++) {
                      var j = c.default(h / 1e3, x, P, C.val, C.stiffness, C.damping, C.precision);
                      x = j[0], P = j[1];
                    }

                    var S = c.default(h / 1e3, x, P, C.val, C.stiffness, C.damping, C.precision),
                        D = S[0],
                        k = S[1];
                    z[O] = x + (D - x) * o, R[O] = P + (k - P) * o, M[O] = x, w[O] = P;
                  }
                }
              }

              y[E] = M, g[E] = w, p[E] = z, v[E] = R;
            }

            r.animationID = null, r.accumulatedTime -= i * h, r.setState({
              currentStyles: p,
              currentVelocities: v,
              lastIdealStyles: y,
              lastIdealVelocities: g,
              mergedPropsStyles: d
            }), r.unreadPropStyles = null, r.startAnimationIfNecessary();
          }
        }));
      }, this.state = this.defaultState();
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, e), n(t, null, [{
      key: "propTypes",
      value: {
        defaultStyles: p.default.arrayOf(p.default.shape({
          key: p.default.string.isRequired,
          data: p.default.any,
          style: p.default.objectOf(p.default.number).isRequired
        })),
        styles: p.default.oneOfType([p.default.func, p.default.arrayOf(p.default.shape({
          key: p.default.string.isRequired,
          data: p.default.any,
          style: p.default.objectOf(p.default.oneOfType([p.default.number, p.default.object])).isRequired
        }))]).isRequired,
        children: p.default.func.isRequired,
        willEnter: p.default.func,
        willLeave: p.default.func,
        didLeave: p.default.func
      },
      enumerable: !0
    }, {
      key: "defaultProps",
      value: {
        willEnter: function willEnter(e) {
          return o.default(e.style);
        },
        willLeave: function willLeave() {
          return null;
        },
        didLeave: function didLeave() {}
      },
      enumerable: !0
    }]), t.prototype.defaultState = function () {
      var e = this.props,
          t = e.defaultStyles,
          a = e.styles,
          n = e.willEnter,
          r = e.willLeave,
          c = e.didLeave,
          i = "function" == typeof a ? a(t) : a,
          s = void 0;
      s = null == t ? i : t.map(function (e) {
        for (var t = 0; t < i.length; t++) {
          if (i[t].key === e.key) return i[t];
        }

        return e;
      });

      var u = null == t ? i.map(function (e) {
        return o.default(e.style);
      }) : t.map(function (e) {
        return o.default(e.style);
      }),
          f = null == t ? i.map(function (e) {
        return l.default(e.style);
      }) : t.map(function (e) {
        return l.default(e.style);
      }),
          d = _(n, r, c, s, i, u, f, u, f),
          p = d[0];

      return {
        currentStyles: d[1],
        currentVelocities: d[2],
        lastIdealStyles: d[3],
        lastIdealVelocities: d[4],
        mergedPropsStyles: p
      };
    }, t.prototype.componentDidMount = function () {
      this.prevTime = s.default(), this.startAnimationIfNecessary();
    }, t.prototype.componentWillReceiveProps = function (e) {
      this.unreadPropStyles && this.clearUnreadPropStyle(this.unreadPropStyles);
      var t = e.styles;
      this.unreadPropStyles = "function" == typeof t ? t(m(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles)) : t, null == this.animationID && (this.prevTime = s.default(), this.startAnimationIfNecessary());
    }, t.prototype.componentWillUnmount = function () {
      this.unmounting = !0, null != this.animationID && (u.default.cancel(this.animationID), this.animationID = null);
    }, t.prototype.render = function () {
      var e = m(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles),
          t = this.props.children(e);
      return t && d.default.Children.only(t);
    }, t;
  }(d.default.Component);

  t.default = v, e.exports = t.default;
});
unwrapExports(TransitionMotion_1);
var presets = createCommonjsModule(function (e, t) {
  t.__esModule = !0, t.default = {
    noWobble: {
      stiffness: 170,
      damping: 26
    },
    gentle: {
      stiffness: 120,
      damping: 14
    },
    wobbly: {
      stiffness: 180,
      damping: 12
    },
    stiff: {
      stiffness: 210,
      damping: 20
    }
  }, e.exports = t.default;
});
unwrapExports(presets);
var spring_1 = createCommonjsModule(function (e, t) {
  t.__esModule = !0;

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  };

  t.default = function (e, t) {
    return a({}, l, t, {
      val: e
    });
  };

  var n,
      r = (n = presets) && n.__esModule ? n : {
    default: n
  },
      l = a({}, r.default.noWobble, {
    precision: 0.01
  });
  e.exports = t.default;
});
unwrapExports(spring_1);
var reorderKeys_1 = createCommonjsModule(function (e, t) {
  t.__esModule = !0, t.default = function () {
    "development" === process.env.NODE_ENV && (a || (a = !0, console.error("`reorderKeys` has been removed, since it is no longer needed for TransitionMotion's new styles array API.")));
  };
  var a = !1;
  e.exports = t.default;
});
unwrapExports(reorderKeys_1);
var reactMotion = createCommonjsModule(function (e, t) {
  function a(e) {
    return e && e.__esModule ? e.default : e;
  }

  t.__esModule = !0, t.Motion = a(Motion_1), t.StaggeredMotion = a(StaggeredMotion_1), t.TransitionMotion = a(TransitionMotion_1), t.spring = a(spring_1), t.presets = a(presets), t.stripStyle = a(stripStyle_1), t.reorderKeys = a(reorderKeys_1);
});
unwrapExports(reactMotion);
var reactMotion_1 = reactMotion.Motion,
    reactMotion_2 = reactMotion.StaggeredMotion,
    reactMotion_3 = reactMotion.TransitionMotion,
    reactMotion_4 = reactMotion.spring,
    reactMotion_5 = reactMotion.presets,
    reactMotion_6 = reactMotion.stripStyle,
    reactMotion_7 = reactMotion.reorderKeys,
    tabbable_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return [].slice.call(e.querySelectorAll("*"), 0).filter(l);
  };
  var a = /input|select|textarea|button|object/;

  function n(e) {
    var t = e.offsetWidth <= 0 && e.offsetHeight <= 0;
    if (t && !e.innerHTML) return !0;
    var a = window.getComputedStyle(e);
    return t ? "visible" !== a.getPropertyValue("overflow") : "none" == a.getPropertyValue("display");
  }

  function r(e, t) {
    var r = e.nodeName.toLowerCase();
    return (a.test(r) && !e.disabled || "a" === r && e.href || t) && function (e) {
      for (var t = e; t && t !== document.body;) {
        if (n(t)) return !1;
        t = t.parentNode;
      }

      return !0;
    }(e);
  }

  function l(e) {
    var t = e.getAttribute("tabindex");
    null === t && (t = void 0);
    var a = isNaN(t);
    return (a || t >= 0) && r(e, !a);
  }

  e.exports = t.default;
});
unwrapExports(tabbable_1);
var focusManager = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.handleBlur = c, t.handleFocus = i, t.markForFocusLater = function () {
    r.push(document.activeElement);
  }, t.returnFocus = function () {
    var e = null;

    try {
      return void (0 !== r.length && (e = r.pop()).focus());
    } catch (t) {
      console.warn(["You tried to return focus to", e, "but it is not in the DOM anymore"].join(" "));
    }
  }, t.popWithoutFocus = function () {
    r.length > 0 && r.pop();
  }, t.setupScopedFocus = function (e) {
    l = e, window.addEventListener ? (window.addEventListener("blur", c, !1), document.addEventListener("focus", i, !0)) : (window.attachEvent("onBlur", c), document.attachEvent("onFocus", i));
  }, t.teardownScopedFocus = function () {
    l = null, window.addEventListener ? (window.removeEventListener("blur", c), document.removeEventListener("focus", i)) : (window.detachEvent("onBlur", c), document.detachEvent("onFocus", i));
  };
  var a,
      n = (a = tabbable_1) && a.__esModule ? a : {
    default: a
  };
  var r = [],
      l = null,
      o = !1;

  function c() {
    o = !0;
  }

  function i() {
    if (o) {
      if (o = !1, !l) return;
      setTimeout(function () {
        l.contains(document.activeElement) || ((0, n.default)(l)[0] || l).focus();
      }, 0);
    }
  }
});
unwrapExports(focusManager);
var focusManager_1 = focusManager.handleBlur,
    focusManager_2 = focusManager.handleFocus,
    focusManager_3 = focusManager.markForFocusLater,
    focusManager_4 = focusManager.returnFocus,
    focusManager_5 = focusManager.popWithoutFocus,
    focusManager_6 = focusManager.setupScopedFocus,
    focusManager_7 = focusManager.teardownScopedFocus,
    scopeTab_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e, t) {
    var a = (0, n.default)(e);
    if (!a.length) return void t.preventDefault();
    var r,
        l = t.shiftKey,
        o = a[0],
        c = a[a.length - 1];

    if (e === document.activeElement) {
      if (!l) return;
      r = c;
    }

    c !== document.activeElement || l || (r = o);
    o === document.activeElement && l && (r = c);
    if (r) return t.preventDefault(), void r.focus();
    var i = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    if (null == i || "Chrome" == i[1] || null != /\biPod\b|\biPad\b/g.exec(navigator.userAgent)) return;
    var s = a.indexOf(document.activeElement);
    s > -1 && (s += l ? -1 : 1);
    t.preventDefault(), a[s].focus();
  };
  var a,
      n = (a = tabbable_1) && a.__esModule ? a : {
    default: a
  };
  e.exports = t.default;
});
unwrapExports(scopeTab_1);

var __DEV__ = "production" !== process.env.NODE_ENV,
    warning$2 = function warning$2() {};

__DEV__ && (warning$2 = function warning$2(e, t, a) {
  var n = arguments.length;
  a = new Array(n > 2 ? n - 2 : 0);

  for (var r = 2; r < n; r++) {
    a[r - 2] = arguments[r];
  }

  if (void 0 === t) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
  if (t.length < 10 || /^[s\W]*$/.test(t)) throw new Error("The warning format should be able to uniquely identify this warning. Please, use a more descriptive format than: " + t);

  if (!e) {
    var l = 0,
        o = "Warning: " + t.replace(/%s/g, function () {
      return a[l++];
    });
    "undefined" != typeof console && console.error(o);

    try {
      throw new Error(o);
    } catch (e) {}
  }
});
var warning_1$1 = warning$2,
    ariaAppHider = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.assertNodeList = l, t.setElement = function (e) {
    var t = e;

    if ("string" == typeof t) {
      var a = document.querySelectorAll(t);
      l(a, t), t = "length" in a ? a[0] : a;
    }

    return r = t || r;
  }, t.validateElement = o, t.hide = function (e) {
    o(e) && (e || r).setAttribute("aria-hidden", "true");
  }, t.show = function (e) {
    o(e) && (e || r).removeAttribute("aria-hidden");
  }, t.documentNotReadyOrSSRTesting = function () {
    r = null;
  }, t.resetForTesting = function () {
    r = null;
  };
  var a,
      n = (a = warning_1$1) && a.__esModule ? a : {
    default: a
  };
  var r = null;

  function l(e, t) {
    if (!e || !e.length) throw new Error("react-modal: No elements were found for selector " + t + ".");
  }

  function o(e) {
    return !(!e && !r) || ((0, n.default)(!1, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" ")), !1);
  }
});
unwrapExports(ariaAppHider);
var ariaAppHider_1 = ariaAppHider.assertNodeList,
    ariaAppHider_2 = ariaAppHider.setElement,
    ariaAppHider_3 = ariaAppHider.validateElement,
    ariaAppHider_4 = ariaAppHider.hide,
    ariaAppHider_5 = ariaAppHider.show,
    ariaAppHider_6 = ariaAppHider.documentNotReadyOrSSRTesting,
    ariaAppHider_7 = ariaAppHider.resetForTesting,
    classList = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.dumpClassLists = function () {
    if ("production" !== process.env.NODE_ENV) {
      var e = document.getElementsByTagName("html")[0].className,
          t = "Show tracked classes:\n\n";

      for (var r in t += "<html /> (" + e + "):\n", a) {
        t += "  " + r + " " + a[r] + "\n";
      }

      for (var l in e = document.body.className, t += "\n\ndoc.body (" + e + "):\n", n) {
        t += "  " + l + " " + n[l] + "\n";
      }

      t += "\n", console.log(t);
    }
  };
  var a = {},
      n = {};
  t.add = function (e, t) {
    return r = e.classList, l = "html" == e.nodeName.toLowerCase() ? a : n, void t.split(" ").forEach(function (e) {
      !function (e, t) {
        e[t] || (e[t] = 0), e[t] += 1;
      }(l, e), r.add(e);
    });
    var r, l;
  }, t.remove = function (e, t) {
    return r = e.classList, l = "html" == e.nodeName.toLowerCase() ? a : n, void t.split(" ").forEach(function (e) {
      !function (e, t) {
        e[t] && (e[t] -= 1);
      }(l, e), 0 === l[e] && r.remove(e);
    });
    var r, l;
  };
});
unwrapExports(classList);
var classList_1 = classList.dumpClassLists,
    classList_2 = classList.add,
    classList_3 = classList.remove,
    exenv = createCommonjsModule(function (e) {
  var t, a;
  t = !("undefined" == typeof window || !window.document || !window.document.createElement), a = {
    canUseDOM: t,
    canUseWorkers: "undefined" != typeof Worker,
    canUseEventListeners: t && !(!window.addEventListener && !window.attachEvent),
    canUseViewport: t && !!window.screen
  }, e.exports ? e.exports = a : window.ExecutionEnvironment = a;
}),
    safeHTMLElement = createCommonjsModule(function (e, t) {
  var a;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.canUseDOM = void 0;
  var n = ((a = exenv) && a.__esModule ? a : {
    default: a
  }).default,
      r = n.canUseDOM ? window.HTMLElement : {};
  t.canUseDOM = n.canUseDOM;
  t.default = r;
});
unwrapExports(safeHTMLElement);
var safeHTMLElement_1 = safeHTMLElement.canUseDOM,
    ModalPortal_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      r = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }(),
      l = p(React__default),
      o = p(PropTypes),
      c = d(focusManager),
      i = p(scopeTab_1),
      s = d(ariaAppHider),
      u = d(classList),
      f = p(safeHTMLElement);

  function d(e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  }

  function p(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var h = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
  },
      m = 9,
      _ = 27,
      v = 0,
      y = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var a = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

      return a.setOverlayRef = function (e) {
        a.overlay = e, a.props.overlayRef && a.props.overlayRef(e);
      }, a.setContentRef = function (e) {
        a.content = e, a.props.contentRef && a.props.contentRef(e);
      }, a.afterClose = function () {
        var e = a.props,
            t = e.appElement,
            n = e.ariaHideApp,
            r = e.htmlOpenClassName,
            l = e.bodyOpenClassName;
        u.remove(document.body, l), r && u.remove(document.getElementsByTagName("html")[0], r), n && v > 0 && 0 === (v -= 1) && s.show(t), a.props.shouldFocusAfterRender && (a.props.shouldReturnFocusAfterClose ? (c.returnFocus(), c.teardownScopedFocus()) : c.popWithoutFocus());
      }, a.open = function () {
        a.beforeOpen(), a.state.afterOpen && a.state.beforeClose ? (clearTimeout(a.closeTimer), a.setState({
          beforeClose: !1
        })) : (a.props.shouldFocusAfterRender && (c.setupScopedFocus(a.node), c.markForFocusLater()), a.setState({
          isOpen: !0
        }, function () {
          a.setState({
            afterOpen: !0
          }), a.props.isOpen && a.props.onAfterOpen && a.props.onAfterOpen();
        }));
      }, a.close = function () {
        a.props.closeTimeoutMS > 0 ? a.closeWithTimeout() : a.closeWithoutTimeout();
      }, a.focusContent = function () {
        return a.content && !a.contentHasFocus() && a.content.focus();
      }, a.closeWithTimeout = function () {
        var e = Date.now() + a.props.closeTimeoutMS;
        a.setState({
          beforeClose: !0,
          closesAt: e
        }, function () {
          a.closeTimer = setTimeout(a.closeWithoutTimeout, a.state.closesAt - Date.now());
        });
      }, a.closeWithoutTimeout = function () {
        a.setState({
          beforeClose: !1,
          isOpen: !1,
          afterOpen: !1,
          closesAt: null
        }, a.afterClose);
      }, a.handleKeyDown = function (e) {
        e.keyCode === m && (0, i.default)(a.content, e), a.props.shouldCloseOnEsc && e.keyCode === _ && (e.stopPropagation(), a.requestClose(e));
      }, a.handleOverlayOnClick = function (e) {
        null === a.shouldClose && (a.shouldClose = !0), a.shouldClose && a.props.shouldCloseOnOverlayClick && (a.ownerHandlesClose() ? a.requestClose(e) : a.focusContent()), a.shouldClose = null;
      }, a.handleContentOnMouseUp = function () {
        a.shouldClose = !1;
      }, a.handleOverlayOnMouseDown = function (e) {
        a.props.shouldCloseOnOverlayClick || e.target != a.overlay || e.preventDefault();
      }, a.handleContentOnClick = function () {
        a.shouldClose = !1;
      }, a.handleContentOnMouseDown = function () {
        a.shouldClose = !1;
      }, a.requestClose = function (e) {
        return a.ownerHandlesClose() && a.props.onRequestClose(e);
      }, a.ownerHandlesClose = function () {
        return a.props.onRequestClose;
      }, a.shouldBeClosed = function () {
        return !a.state.isOpen && !a.state.beforeClose;
      }, a.contentHasFocus = function () {
        return document.activeElement === a.content || a.content.contains(document.activeElement);
      }, a.buildClassName = function (e, t) {
        var r = "object" === (void 0 === t ? "undefined" : n(t)) ? t : {
          base: h[e],
          afterOpen: h[e] + "--after-open",
          beforeClose: h[e] + "--before-close"
        },
            l = r.base;
        return a.state.afterOpen && (l = l + " " + r.afterOpen), a.state.beforeClose && (l = l + " " + r.beforeClose), "string" == typeof t && t ? l + " " + t : l;
      }, a.ariaAttributes = function (e) {
        return Object.keys(e).reduce(function (t, a) {
          return t["aria-" + a] = e[a], t;
        }, {});
      }, a.state = {
        afterOpen: !1,
        beforeClose: !1
      }, a.shouldClose = null, a.moveFromContentToOverlay = null, a;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, React__default.Component), r(t, [{
      key: "componentDidMount",
      value: function value() {
        this.props.isOpen && this.open();
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e, t) {
        "production" !== process.env.NODE_ENV && (e.bodyOpenClassName !== this.props.bodyOpenClassName && console.warn('React-Modal: "bodyOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.'), e.htmlOpenClassName !== this.props.htmlOpenClassName && console.warn('React-Modal: "htmlOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.')), this.props.isOpen && !e.isOpen ? this.open() : !this.props.isOpen && e.isOpen && this.close(), this.props.shouldFocusAfterRender && this.state.isOpen && !t.isOpen && this.focusContent();
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.afterClose(), clearTimeout(this.closeTimer);
      }
    }, {
      key: "beforeOpen",
      value: function value() {
        var e = this.props,
            t = e.appElement,
            a = e.ariaHideApp,
            n = e.htmlOpenClassName,
            r = e.bodyOpenClassName;
        u.add(document.body, r), n && u.add(document.getElementsByTagName("html")[0], n), a && (v += 1, s.hide(t));
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
            t = e.className,
            n = e.overlayClassName,
            r = e.defaultStyles,
            o = t ? {} : r.content,
            c = n ? {} : r.overlay;
        return this.shouldBeClosed() ? null : l.default.createElement("div", {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", n),
          style: a({}, c, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown,
          "aria-modal": "true"
        }, l.default.createElement("div", a({
          ref: this.setContentRef,
          style: a({}, o, this.props.style.content),
          className: this.buildClassName("content", t),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleContentOnMouseDown,
          onMouseUp: this.handleContentOnMouseUp,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        }, this.ariaAttributes(this.props.aria || {}), {
          "data-testid": this.props.testId
        }), this.props.children));
      }
    }]), t;
  }();

  y.defaultProps = {
    style: {
      overlay: {},
      content: {}
    },
    defaultStyles: {}
  }, y.propTypes = {
    isOpen: o.default.bool.isRequired,
    defaultStyles: o.default.shape({
      content: o.default.object,
      overlay: o.default.object
    }),
    style: o.default.shape({
      content: o.default.object,
      overlay: o.default.object
    }),
    className: o.default.oneOfType([o.default.string, o.default.object]),
    overlayClassName: o.default.oneOfType([o.default.string, o.default.object]),
    bodyOpenClassName: o.default.string,
    htmlOpenClassName: o.default.string,
    ariaHideApp: o.default.bool,
    appElement: o.default.instanceOf(f.default),
    onAfterOpen: o.default.func,
    onRequestClose: o.default.func,
    closeTimeoutMS: o.default.number,
    shouldFocusAfterRender: o.default.bool,
    shouldCloseOnOverlayClick: o.default.bool,
    shouldReturnFocusAfterClose: o.default.bool,
    role: o.default.string,
    contentLabel: o.default.string,
    aria: o.default.object,
    children: o.default.node,
    shouldCloseOnEsc: o.default.bool,
    overlayRef: o.default.func,
    contentRef: o.default.func,
    testId: o.default.string
  }, t.default = y, e.exports = t.default;
});
unwrapExports(ModalPortal_1);
var Modal_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.bodyOpenClassName = t.portalClassName = void 0;

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  },
      n = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var n = t[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }(),
      r = u(React__default),
      l = u(ReactDOM__default),
      o = u(PropTypes),
      c = u(ModalPortal_1),
      i = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  }(ariaAppHider),
      s = u(safeHTMLElement);

  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function f(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  }

  var d = t.portalClassName = "ReactModalPortal",
      p = t.bodyOpenClassName = "ReactModal__Body--open",
      h = void 0 !== l.default.createPortal,
      m = h ? l.default.createPortal : l.default.unstable_renderSubtreeIntoContainer;

  function _(e) {
    return e();
  }

  var v = function (e) {
    function t() {
      var e, n, o;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      for (var i = arguments.length, s = Array(i), u = 0; u < i; u++) {
        s[u] = arguments[u];
      }

      return n = o = f(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(s))), o.removePortal = function () {
        !h && l.default.unmountComponentAtNode(o.node), _(o.props.parentSelector).removeChild(o.node);
      }, o.portalRef = function (e) {
        o.portal = e;
      }, o.renderPortal = function (e) {
        var n = m(o, r.default.createElement(c.default, a({
          defaultStyles: t.defaultStyles
        }, e)), o.node);
        o.portalRef(n);
      }, f(o, n);
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, React__default.Component), n(t, [{
      key: "componentDidMount",
      value: function value() {
        safeHTMLElement.canUseDOM && (h || (this.node = document.createElement("div")), this.node.className = this.props.portalClassName, _(this.props.parentSelector).appendChild(this.node), !h && this.renderPortal(this.props));
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function value(e) {
        return {
          prevParent: _(e.parentSelector),
          nextParent: _(this.props.parentSelector)
        };
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e, t, a) {
        if (safeHTMLElement.canUseDOM) {
          var n = this.props,
              r = n.isOpen,
              l = n.portalClassName;

          if (e.portalClassName !== l && (this.node.className = l), e.isOpen || r) {
            var o = a.prevParent,
                c = a.nextParent;
            c !== o && (o.removeChild(this.node), c.appendChild(this.node)), !h && this.renderPortal(this.props);
          }
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        if (safeHTMLElement.canUseDOM && this.node && this.portal) {
          var e = this.portal.state,
              t = Date.now(),
              a = e.isOpen && this.props.closeTimeoutMS && (e.closesAt || t + this.props.closeTimeoutMS);
          a ? (e.beforeClose || this.portal.closeWithTimeout(), setTimeout(this.removePortal, a - t)) : this.removePortal();
        }
      }
    }, {
      key: "render",
      value: function value() {
        return safeHTMLElement.canUseDOM && h ? (!this.node && h && (this.node = document.createElement("div")), m(r.default.createElement(c.default, a({
          ref: this.portalRef,
          defaultStyles: t.defaultStyles
        }, this.props)), this.node)) : null;
      }
    }], [{
      key: "setAppElement",
      value: function value(e) {
        i.setElement(e);
      }
    }]), t;
  }();

  v.propTypes = {
    isOpen: o.default.bool.isRequired,
    style: o.default.shape({
      content: o.default.object,
      overlay: o.default.object
    }),
    portalClassName: o.default.string,
    bodyOpenClassName: o.default.string,
    htmlOpenClassName: o.default.string,
    className: o.default.oneOfType([o.default.string, o.default.shape({
      base: o.default.string.isRequired,
      afterOpen: o.default.string.isRequired,
      beforeClose: o.default.string.isRequired
    })]),
    overlayClassName: o.default.oneOfType([o.default.string, o.default.shape({
      base: o.default.string.isRequired,
      afterOpen: o.default.string.isRequired,
      beforeClose: o.default.string.isRequired
    })]),
    appElement: o.default.instanceOf(s.default),
    onAfterOpen: o.default.func,
    onRequestClose: o.default.func,
    closeTimeoutMS: o.default.number,
    ariaHideApp: o.default.bool,
    shouldFocusAfterRender: o.default.bool,
    shouldCloseOnOverlayClick: o.default.bool,
    shouldReturnFocusAfterClose: o.default.bool,
    parentSelector: o.default.func,
    aria: o.default.object,
    role: o.default.string,
    contentLabel: o.default.string,
    shouldCloseOnEsc: o.default.bool,
    overlayRef: o.default.func,
    contentRef: o.default.func
  }, v.defaultProps = {
    isOpen: !1,
    portalClassName: d,
    bodyOpenClassName: p,
    ariaHideApp: !0,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: !0,
    shouldCloseOnEsc: !0,
    shouldCloseOnOverlayClick: !0,
    shouldReturnFocusAfterClose: !0,
    parentSelector: function parentSelector() {
      return document.body;
    }
  }, v.defaultStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
      position: "absolute",
      top: "40px",
      left: "40px",
      right: "40px",
      bottom: "40px",
      border: "1px solid #ccc",
      background: "#fff",
      overflow: "auto",
      WebkitOverflowScrolling: "touch",
      borderRadius: "4px",
      outline: "none",
      padding: "20px"
    }
  }, (0, _reactLifecyclesCompat.polyfill)(v), t.default = v;
});
unwrapExports(Modal_1);

var Modal_2 = Modal_1.bodyOpenClassName,
    Modal_3 = Modal_1.portalClassName,
    lib = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
      n = (a = Modal_1) && a.__esModule ? a : {
    default: a
  };
  t.default = n.default, e.exports = t.default;
}),
    Modal$1 = unwrapExports(lib),
    _templateObject$18 = taggedTemplateLiteral(["\n\tdisplay: flex;\n\tfont-size: 14px;\n\tflex-direction: column;\n\tleft: 40px;\n\tright: 40px;\n\ttop: 40px;\n\tbottom: ", ";\n\tmargin: auto;\n\toutline: none;\n\tposition: absolute;\n\toverflow: auto;\n\t", ";\n"], ["\n\tdisplay: flex;\n\tfont-size: 14px;\n\tflex-direction: column;\n\tleft: 40px;\n\tright: 40px;\n\ttop: 40px;\n\tbottom: ", ";\n\tmargin: auto;\n\toutline: none;\n\tposition: absolute;\n\toverflow: auto;\n\t", ";\n"]),
    _templateObject2$8 = taggedTemplateLiteral(["\n\tfont-family: ", ";\n\tfont-size: 13px;\n\tfont-weight: 600;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tborder-top-left-radius: 8px;\n\tborder-top-right-radius: 8px;\n\theight: 40px;\n\tline-height: 40px;\n\ttext-align: center;\n"], ["\n\tfont-family: ", ";\n\tfont-size: 13px;\n\tfont-weight: 600;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tborder-top-left-radius: 8px;\n\tborder-top-right-radius: 8px;\n\theight: 40px;\n\tline-height: 40px;\n\ttext-align: center;\n"]),
    _templateObject3$2 = taggedTemplateLiteral(["\n\tfont-family: ", ";\n\tflex-grow: 1;\n\tpadding: 30px;\n\tbackground-color: ", ";\n\ttext-align: center;\n"], ["\n\tfont-family: ", ";\n\tflex-grow: 1;\n\tpadding: 30px;\n\tbackground-color: ", ";\n\ttext-align: center;\n"]),
    _templateObject4$2 = taggedTemplateLiteral(["\n\tfont-family: ", ";\n\tfont-size: 12px;\n\tbackground-color: ", ";\n\tborder-bottom-left-radius: 8px;\n\tborder-bottom-right-radius: 8px;\n\theight: 60px;\n\tline-height: 60px;\n\ttext-align: right;\n\tpadding: 0 16px;\n"], ["\n\tfont-family: ", ";\n\tfont-size: 12px;\n\tbackground-color: ", ";\n\tborder-bottom-left-radius: 8px;\n\tborder-bottom-right-radius: 8px;\n\theight: 60px;\n\tline-height: 60px;\n\ttext-align: right;\n\tpadding: 0 16px;\n"]),
    _templateObject5$1 = taggedTemplateLiteral(["\n\tcolor: ", ";\n\tfont-weight: 600;\n\tmargin-right: 1em;\n\ttext-decoration: underline;\n\ttext-underline-position: under;\n\tcursor: pointer;\n"], ["\n\tcolor: ", ";\n\tfont-weight: 600;\n\tmargin-right: 1em;\n\ttext-decoration: underline;\n\ttext-underline-position: under;\n\tcursor: pointer;\n"]),
    getSize = function getSize(e) {
  switch (e.size) {
    case "xl":
      return "max-height: 700px; max-width: 700px;";

    case "lg":
      return "max-height: 700px; max-width: 560px;";

    case "sm":
      return "max-height: 300px; max-width: 380px;";

    case "md":
    default:
      return "max-height: 500px; max-width: 460px;";
  }
},
    StyledModal = styled__default(Modal$1)(_templateObject$18, function (e) {
  return "sm" === e.size ? "initial" : "40px";
}, getSize),
    ModalHeader = styled__default.div(_templateObject2$8, function (e) {
  return e.theme.fontFamily;
}, function (e) {
  return e.theme.neutralLight[5];
}, function (e) {
  return e.theme.neutralDark[1];
}),
    ModalBody = styled__default.div(_templateObject3$2, function (e) {
  return e.theme.fontFamily;
}, function (e) {
  return e.theme.neutralLight[7];
}),
    ModalFooter = styled__default.div(_templateObject4$2, function (e) {
  return e.theme.fontFamily;
}, function (e) {
  return e.theme.neutralLight[5];
}),
    ModalCancel = styled__default.a(_templateObject5$1, function (e) {
  return e.theme.neutralDark[4];
}),
    _global = createCommonjsModule(function (e) {
  var t = e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
  "number" == typeof __g && (__g = t);
}),
    _core = createCommonjsModule(function (e) {
  var t = e.exports = {
    version: "2.5.6"
  };
  "number" == typeof __e && (__e = t);
}),
    _core_1 = _core.version,
    _aFunction = function _aFunction(e) {
  if ("function" != typeof e) throw TypeError(e + " is not a function!");
  return e;
},
    _ctx = function _ctx(e, t, a) {
  if (_aFunction(e), void 0 === t) return e;

  switch (a) {
    case 1:
      return function (a) {
        return e.call(t, a);
      };

    case 2:
      return function (a, n) {
        return e.call(t, a, n);
      };

    case 3:
      return function (a, n, r) {
        return e.call(t, a, n, r);
      };
  }

  return function () {
    return e.apply(t, arguments);
  };
},
    _isObject = function _isObject(e) {
  return "object" == typeof e ? null !== e : "function" == typeof e;
},
    _anObject = function _anObject(e) {
  if (!_isObject(e)) throw TypeError(e + " is not an object!");
  return e;
},
    _fails = function _fails(e) {
  try {
    return !!e();
  } catch (e) {
    return !0;
  }
},
    _descriptors = !_fails(function () {
  return 7 != Object.defineProperty({}, "a", {
    get: function get() {
      return 7;
    }
  }).a;
}),
    document$1 = _global.document,
    is = _isObject(document$1) && _isObject(document$1.createElement),
    _domCreate = function _domCreate(e) {
  return is ? document$1.createElement(e) : {};
},
    _ie8DomDefine = !_descriptors && !_fails(function () {
  return 7 != Object.defineProperty(_domCreate("div"), "a", {
    get: function get() {
      return 7;
    }
  }).a;
}),
    _toPrimitive = function _toPrimitive(e, t) {
  if (!_isObject(e)) return e;
  var a, n;
  if (t && "function" == typeof (a = e.toString) && !_isObject(n = a.call(e))) return n;
  if ("function" == typeof (a = e.valueOf) && !_isObject(n = a.call(e))) return n;
  if (!t && "function" == typeof (a = e.toString) && !_isObject(n = a.call(e))) return n;
  throw TypeError("Can't convert object to primitive value");
},
    dP = Object.defineProperty,
    f = _descriptors ? Object.defineProperty : function (e, t, a) {
  if (_anObject(e), t = _toPrimitive(t, !0), _anObject(a), _ie8DomDefine) try {
    return dP(e, t, a);
  } catch (e) {}
  if ("get" in a || "set" in a) throw TypeError("Accessors not supported!");
  return "value" in a && (e[t] = a.value), e;
},
    _objectDp = {
  f: f
},
    _propertyDesc = function _propertyDesc(e, t) {
  return {
    enumerable: !(1 & e),
    configurable: !(2 & e),
    writable: !(4 & e),
    value: t
  };
},
    _hide = _descriptors ? function (e, t, a) {
  return _objectDp.f(e, t, _propertyDesc(1, a));
} : function (e, t, a) {
  return e[t] = a, e;
},
    hasOwnProperty$1 = {}.hasOwnProperty,
    _has = function _has(e, t) {
  return hasOwnProperty$1.call(e, t);
},
    PROTOTYPE = "prototype",
    $export = function $export(e, t, a) {
  var n,
      r,
      l,
      o = e & $export.F,
      c = e & $export.G,
      i = e & $export.S,
      s = e & $export.P,
      u = e & $export.B,
      f = e & $export.W,
      d = c ? _core : _core[t] || (_core[t] = {}),
      p = d[PROTOTYPE],
      h = c ? _global : i ? _global[t] : (_global[t] || {})[PROTOTYPE];

  for (n in c && (a = t), a) {
    (r = !o && h && void 0 !== h[n]) && _has(d, n) || (l = r ? h[n] : a[n], d[n] = c && "function" != typeof h[n] ? a[n] : u && r ? _ctx(l, _global) : f && h[n] == l ? function (e) {
      var t = function t(_t, a, n) {
        if (this instanceof e) {
          switch (arguments.length) {
            case 0:
              return new e();

            case 1:
              return new e(_t);

            case 2:
              return new e(_t, a);
          }

          return new e(_t, a, n);
        }

        return e.apply(this, arguments);
      };

      return t[PROTOTYPE] = e[PROTOTYPE], t;
    }(l) : s && "function" == typeof l ? _ctx(Function.call, l) : l, s && ((d.virtual || (d.virtual = {}))[n] = l, e & $export.R && p && !p[n] && _hide(p, n, l)));
  }
};

$export.F = 1, $export.G = 2, $export.S = 4, $export.P = 8, $export.B = 16, $export.W = 32, $export.U = 64, $export.R = 128;

var _export = $export,
    toString = {}.toString,
    _cof = function _cof(e) {
  return toString.call(e).slice(8, -1);
},
    _iobject = Object("z").propertyIsEnumerable(0) ? Object : function (e) {
  return "String" == _cof(e) ? e.split("") : Object(e);
},
    _defined = function _defined(e) {
  if (void 0 == e) throw TypeError("Can't call method on  " + e);
  return e;
},
    _toIobject = function _toIobject(e) {
  return _iobject(_defined(e));
},
    ceil = Math.ceil,
    floor = Math.floor,
    _toInteger = function _toInteger(e) {
  return isNaN(e = +e) ? 0 : (e > 0 ? floor : ceil)(e);
},
    min = Math.min,
    _toLength = function _toLength(e) {
  return e > 0 ? min(_toInteger(e), 9007199254740991) : 0;
},
    max = Math.max,
    min$1 = Math.min,
    _toAbsoluteIndex = function _toAbsoluteIndex(e, t) {
  return (e = _toInteger(e)) < 0 ? max(e + t, 0) : min$1(e, t);
},
    _arrayIncludes = function _arrayIncludes(e) {
  return function (t, a, n) {
    var r,
        l = _toIobject(t),
        o = _toLength(l.length),
        c = _toAbsoluteIndex(n, o);

    if (e && a != a) {
      for (; o > c;) {
        if ((r = l[c++]) != r) return !0;
      }
    } else for (; o > c; c++) {
      if ((e || c in l) && l[c] === a) return e || c || 0;
    }

    return !e && -1;
  };
},
    _library = !0,
    _shared = createCommonjsModule(function (e) {
  var t = _global["__core-js_shared__"] || (_global["__core-js_shared__"] = {});
  (e.exports = function (e, a) {
    return t[e] || (t[e] = void 0 !== a ? a : {});
  })("versions", []).push({
    version: _core.version,
    mode: _library ? "pure" : "global",
    copyright: "© 2018 Denis Pushkarev (zloirock.ru)"
  });
}),
    id$1 = 0,
    px = Math.random(),
    _uid = function _uid(e) {
  return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++id$1 + px).toString(36));
},
    shared = _shared("keys"),
    _sharedKey = function _sharedKey(e) {
  return shared[e] || (shared[e] = _uid(e));
},
    arrayIndexOf = _arrayIncludes(!1),
    IE_PROTO = _sharedKey("IE_PROTO"),
    _objectKeysInternal = function _objectKeysInternal(e, t) {
  var a,
      n = _toIobject(e),
      r = 0,
      l = [];

  for (a in n) {
    a != IE_PROTO && _has(n, a) && l.push(a);
  }

  for (; t.length > r;) {
    _has(n, a = t[r++]) && (~arrayIndexOf(l, a) || l.push(a));
  }

  return l;
},
    _enumBugKeys = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","),
    _objectKeys = Object.keys || function (e) {
  return _objectKeysInternal(e, _enumBugKeys);
},
    f$1 = Object.getOwnPropertySymbols,
    _objectGops = {
  f: f$1
},
    f$2 = {}.propertyIsEnumerable,
    _objectPie = {
  f: f$2
},
    _toObject = function _toObject(e) {
  return Object(_defined(e));
},
    $assign = Object.assign,
    _objectAssign = !$assign || _fails(function () {
  var e = {},
      t = {},
      a = Symbol(),
      n = "abcdefghijklmnopqrst";
  return e[a] = 7, n.split("").forEach(function (e) {
    t[e] = e;
  }), 7 != $assign({}, e)[a] || Object.keys($assign({}, t)).join("") != n;
}) ? function (e, t) {
  for (var a = _toObject(e), n = arguments.length, r = 1, l = _objectGops.f, o = _objectPie.f; n > r;) {
    for (var c, i = _iobject(arguments[r++]), s = l ? _objectKeys(i).concat(l(i)) : _objectKeys(i), u = s.length, f = 0; u > f;) {
      o.call(i, c = s[f++]) && (a[c] = i[c]);
    }
  }

  return a;
} : $assign;

_export(_export.S + _export.F, "Object", {
  assign: _objectAssign
});

var assign = _core.Object.assign,
    assign$1 = createCommonjsModule(function (e) {
  e.exports = {
    default: assign,
    __esModule: !0
  };
});
unwrapExports(assign$1);

var _extends$109 = createCommonjsModule(function (e, t) {
  t.__esModule = !0;
  var a,
      n = (a = assign$1) && a.__esModule ? a : {
    default: a
  };

  t.default = n.default || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  };
}),
    _extends$110 = unwrapExports(_extends$109),
    objectWithoutProperties$2 = createCommonjsModule(function (e, t) {
  t.__esModule = !0, t.default = function (e, t) {
    var a = {};

    for (var n in e) {
      t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
    }

    return a;
  };
}),
    _objectWithoutProperties$107 = unwrapExports(objectWithoutProperties$2),
    classCallCheck$2 = createCommonjsModule(function (e, t) {
  t.__esModule = !0, t.default = function (e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  };
}),
    _classCallCheck = unwrapExports(classCallCheck$2),
    _stringAt = function _stringAt(e) {
  return function (t, a) {
    var n,
        r,
        l = String(_defined(t)),
        o = _toInteger(a),
        c = l.length;

    return o < 0 || o >= c ? e ? "" : void 0 : (n = l.charCodeAt(o)) < 55296 || n > 56319 || o + 1 === c || (r = l.charCodeAt(o + 1)) < 56320 || r > 57343 ? e ? l.charAt(o) : n : e ? l.slice(o, o + 2) : r - 56320 + (n - 55296 << 10) + 65536;
  };
},
    _redefine = _hide,
    _objectDps = _descriptors ? Object.defineProperties : function (e, t) {
  _anObject(e);

  for (var a, n = _objectKeys(t), r = n.length, l = 0; r > l;) {
    _objectDp.f(e, a = n[l++], t[a]);
  }

  return e;
},
    document$2 = _global.document,
    _html = document$2 && document$2.documentElement,
    IE_PROTO$1 = _sharedKey("IE_PROTO"),
    Empty = function Empty() {},
    PROTOTYPE$1 = "prototype",
    _createDict = function createDict() {
  var e,
      t = _domCreate("iframe"),
      a = _enumBugKeys.length;

  for (t.style.display = "none", _html.appendChild(t), t.src = "javascript:", (e = t.contentWindow.document).open(), e.write("<script>document.F=Object</script>"), e.close(), _createDict = e.F; a--;) {
    delete _createDict[PROTOTYPE$1][_enumBugKeys[a]];
  }

  return _createDict();
},
    _objectCreate = Object.create || function (e, t) {
  var a;
  return null !== e ? (Empty[PROTOTYPE$1] = _anObject(e), a = new Empty(), Empty[PROTOTYPE$1] = null, a[IE_PROTO$1] = e) : a = _createDict(), void 0 === t ? a : _objectDps(a, t);
},
    _wks = createCommonjsModule(function (e) {
  var t = _shared("wks"),
      a = _global.Symbol,
      n = "function" == typeof a;

  (e.exports = function (e) {
    return t[e] || (t[e] = n && a[e] || (n ? a : _uid)("Symbol." + e));
  }).store = t;
}),
    def = _objectDp.f,
    TAG = _wks("toStringTag"),
    _setToStringTag = function _setToStringTag(e, t, a) {
  e && !_has(e = a ? e : e.prototype, TAG) && def(e, TAG, {
    configurable: !0,
    value: t
  });
},
    IteratorPrototype = {};

_hide(IteratorPrototype, _wks("iterator"), function () {
  return this;
});

var _iterCreate = function _iterCreate(e, t, a) {
  e.prototype = _objectCreate(IteratorPrototype, {
    next: _propertyDesc(1, a)
  }), _setToStringTag(e, t + " Iterator");
},
    IE_PROTO$2 = _sharedKey("IE_PROTO"),
    ObjectProto = Object.prototype,
    _objectGpo = Object.getPrototypeOf || function (e) {
  return e = _toObject(e), _has(e, IE_PROTO$2) ? e[IE_PROTO$2] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? ObjectProto : null;
},
    ITERATOR = _wks("iterator"),
    BUGGY = !([].keys && "next" in [].keys()),
    FF_ITERATOR = "@@iterator",
    KEYS = "keys",
    VALUES = "values",
    returnThis = function returnThis() {
  return this;
},
    _iterDefine = function _iterDefine(e, t, a, n, r, l, o) {
  _iterCreate(a, t, n);

  var c,
      i,
      s,
      u = function u(e) {
    if (!BUGGY && e in h) return h[e];

    switch (e) {
      case KEYS:
      case VALUES:
        return function () {
          return new a(this, e);
        };
    }

    return function () {
      return new a(this, e);
    };
  },
      f = t + " Iterator",
      d = r == VALUES,
      p = !1,
      h = e.prototype,
      m = h[ITERATOR] || h[FF_ITERATOR] || r && h[r],
      _ = m || u(r),
      v = r ? d ? u("entries") : _ : void 0,
      y = "Array" == t && h.entries || m;

  if (y && (s = _objectGpo(y.call(new e()))) !== Object.prototype && s.next && (_setToStringTag(s, f, !0), _library || "function" == typeof s[ITERATOR] || _hide(s, ITERATOR, returnThis)), d && m && m.name !== VALUES && (p = !0, _ = function _() {
    return m.call(this);
  }), _library && !o || !BUGGY && !p && h[ITERATOR] || _hide(h, ITERATOR, _), r) if (c = {
    values: d ? _ : u(VALUES),
    keys: l ? _ : u(KEYS),
    entries: v
  }, o) for (i in c) {
    i in h || _redefine(h, i, c[i]);
  } else _export(_export.P + _export.F * (BUGGY || p), t, c);
  return c;
},
    $at = _stringAt(!0);

_iterDefine(String, "String", function (e) {
  this._t = String(e), this._i = 0;
}, function () {
  var e,
      t = this._t,
      a = this._i;
  return a >= t.length ? {
    value: void 0,
    done: !0
  } : (e = $at(t, a), this._i += e.length, {
    value: e,
    done: !1
  });
});

for (var _iterStep = function _iterStep(e, t) {
  return {
    value: t,
    done: !!e
  };
}, es6_array_iterator = _iterDefine(Array, "Array", function (e, t) {
  this._t = _toIobject(e), this._i = 0, this._k = t;
}, function () {
  var e = this._t,
      t = this._k,
      a = this._i++;
  return !e || a >= e.length ? (this._t = void 0, _iterStep(1)) : _iterStep(0, "keys" == t ? a : "values" == t ? e[a] : [a, e[a]]);
}, "values"), TO_STRING_TAG = _wks("toStringTag"), DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), i$1 = 0; i$1 < DOMIterables.length; i$1++) {
  var NAME = DOMIterables[i$1],
      Collection = _global[NAME],
      proto = Collection && Collection.prototype;
  proto && !proto[TO_STRING_TAG] && _hide(proto, TO_STRING_TAG, NAME);
}

var f$3 = _wks,
    _wksExt = {
  f: f$3
},
    iterator = _wksExt.f("iterator"),
    iterator$1 = createCommonjsModule(function (e) {
  e.exports = {
    default: iterator,
    __esModule: !0
  };
});

unwrapExports(iterator$1);

var _meta = createCommonjsModule(function (e) {
  var t = _uid("meta"),
      a = _objectDp.f,
      n = 0,
      r = Object.isExtensible || function () {
    return !0;
  },
      l = !_fails(function () {
    return r(Object.preventExtensions({}));
  }),
      o = function o(e) {
    a(e, t, {
      value: {
        i: "O" + ++n,
        w: {}
      }
    });
  },
      c = e.exports = {
    KEY: t,
    NEED: !1,
    fastKey: function fastKey(e, a) {
      if (!_isObject(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;

      if (!_has(e, t)) {
        if (!r(e)) return "F";
        if (!a) return "E";
        o(e);
      }

      return e[t].i;
    },
    getWeak: function getWeak(e, a) {
      if (!_has(e, t)) {
        if (!r(e)) return !0;
        if (!a) return !1;
        o(e);
      }

      return e[t].w;
    },
    onFreeze: function onFreeze(e) {
      return l && c.NEED && r(e) && !_has(e, t) && o(e), e;
    }
  };
}),
    _meta_1 = _meta.KEY,
    _meta_2 = _meta.NEED,
    _meta_3 = _meta.fastKey,
    _meta_4 = _meta.getWeak,
    _meta_5 = _meta.onFreeze,
    defineProperty$2 = _objectDp.f,
    _wksDefine = function _wksDefine(e) {
  var t = _core.Symbol || (_core.Symbol = _library ? {} : _global.Symbol || {});
  "_" == e.charAt(0) || e in t || defineProperty$2(t, e, {
    value: _wksExt.f(e)
  });
},
    _enumKeys = function _enumKeys(e) {
  var t = _objectKeys(e),
      a = _objectGops.f;

  if (a) for (var n, r = a(e), l = _objectPie.f, o = 0; r.length > o;) {
    l.call(e, n = r[o++]) && t.push(n);
  }
  return t;
},
    _isArray = Array.isArray || function (e) {
  return "Array" == _cof(e);
},
    hiddenKeys = _enumBugKeys.concat("length", "prototype"),
    f$4 = Object.getOwnPropertyNames || function (e) {
  return _objectKeysInternal(e, hiddenKeys);
},
    _objectGopn = {
  f: f$4
},
    gOPN = _objectGopn.f,
    toString$1 = {}.toString,
    windowNames = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
    getWindowNames = function getWindowNames(e) {
  try {
    return gOPN(e);
  } catch (e) {
    return windowNames.slice();
  }
},
    f$5 = function f$5(e) {
  return windowNames && "[object Window]" == toString$1.call(e) ? getWindowNames(e) : gOPN(_toIobject(e));
},
    _objectGopnExt = {
  f: f$5
},
    gOPD = Object.getOwnPropertyDescriptor,
    f$6 = _descriptors ? gOPD : function (e, t) {
  if (e = _toIobject(e), t = _toPrimitive(t, !0), _ie8DomDefine) try {
    return gOPD(e, t);
  } catch (e) {}
  if (_has(e, t)) return _propertyDesc(!_objectPie.f.call(e, t), e[t]);
},
    _objectGopd = {
  f: f$6
},
    META = _meta.KEY,
    gOPD$1 = _objectGopd.f,
    dP$1 = _objectDp.f,
    gOPN$1 = _objectGopnExt.f,
    _$Symbol = _global.Symbol,
    $JSON = _global.JSON,
    _stringify = $JSON && $JSON.stringify,
    PROTOTYPE$2 = "prototype",
    HIDDEN = _wks("_hidden"),
    TO_PRIMITIVE = _wks("toPrimitive"),
    isEnum = {}.propertyIsEnumerable,
    SymbolRegistry = _shared("symbol-registry"),
    AllSymbols = _shared("symbols"),
    OPSymbols = _shared("op-symbols"),
    ObjectProto$1 = Object[PROTOTYPE$2],
    USE_NATIVE = "function" == typeof _$Symbol,
    QObject = _global.QObject,
    setter = !QObject || !QObject[PROTOTYPE$2] || !QObject[PROTOTYPE$2].findChild,
    setSymbolDesc = _descriptors && _fails(function () {
  return 7 != _objectCreate(dP$1({}, "a", {
    get: function get() {
      return dP$1(this, "a", {
        value: 7
      }).a;
    }
  })).a;
}) ? function (e, t, a) {
  var n = gOPD$1(ObjectProto$1, t);
  n && delete ObjectProto$1[t], dP$1(e, t, a), n && e !== ObjectProto$1 && dP$1(ObjectProto$1, t, n);
} : dP$1,
    wrap = function wrap(e) {
  var t = AllSymbols[e] = _objectCreate(_$Symbol[PROTOTYPE$2]);

  return t._k = e, t;
},
    isSymbol$1 = USE_NATIVE && "symbol" == typeof _$Symbol.iterator ? function (e) {
  return "symbol" == typeof e;
} : function (e) {
  return e instanceof _$Symbol;
},
    $defineProperty = function $defineProperty(e, t, a) {
  return e === ObjectProto$1 && $defineProperty(OPSymbols, t, a), _anObject(e), t = _toPrimitive(t, !0), _anObject(a), _has(AllSymbols, t) ? (a.enumerable ? (_has(e, HIDDEN) && e[HIDDEN][t] && (e[HIDDEN][t] = !1), a = _objectCreate(a, {
    enumerable: _propertyDesc(0, !1)
  })) : (_has(e, HIDDEN) || dP$1(e, HIDDEN, _propertyDesc(1, {})), e[HIDDEN][t] = !0), setSymbolDesc(e, t, a)) : dP$1(e, t, a);
},
    $defineProperties = function $defineProperties(e, t) {
  _anObject(e);

  for (var a, n = _enumKeys(t = _toIobject(t)), r = 0, l = n.length; l > r;) {
    $defineProperty(e, a = n[r++], t[a]);
  }

  return e;
},
    $create = function $create(e, t) {
  return void 0 === t ? _objectCreate(e) : $defineProperties(_objectCreate(e), t);
},
    $propertyIsEnumerable = function $propertyIsEnumerable(e) {
  var t = isEnum.call(this, e = _toPrimitive(e, !0));
  return !(this === ObjectProto$1 && _has(AllSymbols, e) && !_has(OPSymbols, e)) && (!(t || !_has(this, e) || !_has(AllSymbols, e) || _has(this, HIDDEN) && this[HIDDEN][e]) || t);
},
    $getOwnPropertyDescriptor = function $getOwnPropertyDescriptor(e, t) {
  if (e = _toIobject(e), t = _toPrimitive(t, !0), e !== ObjectProto$1 || !_has(AllSymbols, t) || _has(OPSymbols, t)) {
    var a = gOPD$1(e, t);
    return !a || !_has(AllSymbols, t) || _has(e, HIDDEN) && e[HIDDEN][t] || (a.enumerable = !0), a;
  }
},
    $getOwnPropertyNames = function $getOwnPropertyNames(e) {
  for (var t, a = gOPN$1(_toIobject(e)), n = [], r = 0; a.length > r;) {
    _has(AllSymbols, t = a[r++]) || t == HIDDEN || t == META || n.push(t);
  }

  return n;
},
    $getOwnPropertySymbols = function $getOwnPropertySymbols(e) {
  for (var t, a = e === ObjectProto$1, n = gOPN$1(a ? OPSymbols : _toIobject(e)), r = [], l = 0; n.length > l;) {
    !_has(AllSymbols, t = n[l++]) || a && !_has(ObjectProto$1, t) || r.push(AllSymbols[t]);
  }

  return r;
};

USE_NATIVE || (_redefine((_$Symbol = function $Symbol() {
  if (this instanceof _$Symbol) throw TypeError("Symbol is not a constructor!");

  var e = _uid(arguments.length > 0 ? arguments[0] : void 0),
      t = function t(a) {
    this === ObjectProto$1 && t.call(OPSymbols, a), _has(this, HIDDEN) && _has(this[HIDDEN], e) && (this[HIDDEN][e] = !1), setSymbolDesc(this, e, _propertyDesc(1, a));
  };

  return _descriptors && setter && setSymbolDesc(ObjectProto$1, e, {
    configurable: !0,
    set: t
  }), wrap(e);
})[PROTOTYPE$2], "toString", function () {
  return this._k;
}), _objectGopd.f = $getOwnPropertyDescriptor, _objectDp.f = $defineProperty, _objectGopn.f = _objectGopnExt.f = $getOwnPropertyNames, _objectPie.f = $propertyIsEnumerable, _objectGops.f = $getOwnPropertySymbols, _descriptors && !_library && _redefine(ObjectProto$1, "propertyIsEnumerable", $propertyIsEnumerable, !0), _wksExt.f = function (e) {
  return wrap(_wks(e));
}), _export(_export.G + _export.W + _export.F * !USE_NATIVE, {
  Symbol: _$Symbol
});

for (var es6Symbols = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), j = 0; es6Symbols.length > j;) {
  _wks(es6Symbols[j++]);
}

for (var wellKnownSymbols = _objectKeys(_wks.store), k = 0; wellKnownSymbols.length > k;) {
  _wksDefine(wellKnownSymbols[k++]);
}

_export(_export.S + _export.F * !USE_NATIVE, "Symbol", {
  for: function _for(e) {
    return _has(SymbolRegistry, e += "") ? SymbolRegistry[e] : SymbolRegistry[e] = _$Symbol(e);
  },
  keyFor: function keyFor(e) {
    if (!isSymbol$1(e)) throw TypeError(e + " is not a symbol!");

    for (var t in SymbolRegistry) {
      if (SymbolRegistry[t] === e) return t;
    }
  },
  useSetter: function useSetter() {
    setter = !0;
  },
  useSimple: function useSimple() {
    setter = !1;
  }
}), _export(_export.S + _export.F * !USE_NATIVE, "Object", {
  create: $create,
  defineProperty: $defineProperty,
  defineProperties: $defineProperties,
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  getOwnPropertyNames: $getOwnPropertyNames,
  getOwnPropertySymbols: $getOwnPropertySymbols
}), $JSON && _export(_export.S + _export.F * (!USE_NATIVE || _fails(function () {
  var e = _$Symbol();

  return "[null]" != _stringify([e]) || "{}" != _stringify({
    a: e
  }) || "{}" != _stringify(Object(e));
})), "JSON", {
  stringify: function stringify(e) {
    for (var t, a, n = [e], r = 1; arguments.length > r;) {
      n.push(arguments[r++]);
    }

    if (a = t = n[1], (_isObject(t) || void 0 !== e) && !isSymbol$1(e)) return _isArray(t) || (t = function t(e, _t2) {
      if ("function" == typeof a && (_t2 = a.call(this, e, _t2)), !isSymbol$1(_t2)) return _t2;
    }), n[1] = t, _stringify.apply($JSON, n);
  }
}), _$Symbol[PROTOTYPE$2][TO_PRIMITIVE] || _hide(_$Symbol[PROTOTYPE$2], TO_PRIMITIVE, _$Symbol[PROTOTYPE$2].valueOf), _setToStringTag(_$Symbol, "Symbol"), _setToStringTag(Math, "Math", !0), _setToStringTag(_global.JSON, "JSON", !0), _wksDefine("asyncIterator"), _wksDefine("observable");
var symbol = _core.Symbol,
    symbol$1 = createCommonjsModule(function (e) {
  e.exports = {
    default: symbol,
    __esModule: !0
  };
});
unwrapExports(symbol$1);

var _typeof_1 = createCommonjsModule(function (e, t) {
  t.__esModule = !0;
  var a = l(iterator$1),
      n = l(symbol$1),
      r = "function" == typeof n.default && "symbol" == typeof a.default ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof n.default && e.constructor === n.default && e !== n.default.prototype ? "symbol" : typeof e;
  };

  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  t.default = "function" == typeof n.default && "symbol" === r(a.default) ? function (e) {
    return void 0 === e ? "undefined" : r(e);
  } : function (e) {
    return e && "function" == typeof n.default && e.constructor === n.default && e !== n.default.prototype ? "symbol" : void 0 === e ? "undefined" : r(e);
  };
}),
    _typeof$2 = unwrapExports(_typeof_1),
    possibleConstructorReturn$2 = createCommonjsModule(function (e, t) {
  t.__esModule = !0;
  var a,
      n = (a = _typeof_1) && a.__esModule ? a : {
    default: a
  };

  t.default = function (e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" !== (void 0 === t ? "undefined" : (0, n.default)(t)) && "function" != typeof t ? e : t;
  };
}),
    _possibleConstructorReturn = unwrapExports(possibleConstructorReturn$2),
    check$2 = function check$2(e, t) {
  if (_anObject(e), !_isObject(t) && null !== t) throw TypeError(t + ": can't set as prototype!");
},
    _setProto = {
  set: Object.setPrototypeOf || ("__proto__" in {} ? function (e, t, a) {
    try {
      (a = _ctx(Function.call, _objectGopd.f(Object.prototype, "__proto__").set, 2))(e, []), t = !(e instanceof Array);
    } catch (e) {
      t = !0;
    }

    return function (e, n) {
      return check$2(e, n), t ? e.__proto__ = n : a(e, n), e;
    };
  }({}, !1) : void 0),
  check: check$2
};

_export(_export.S, "Object", {
  setPrototypeOf: _setProto.set
});

var setPrototypeOf = _core.Object.setPrototypeOf,
    setPrototypeOf$1 = createCommonjsModule(function (e) {
  e.exports = {
    default: setPrototypeOf,
    __esModule: !0
  };
});
unwrapExports(setPrototypeOf$1), _export(_export.S, "Object", {
  create: _objectCreate
});

var $Object = _core.Object,
    create = function create(e, t) {
  return $Object.create(e, t);
},
    create$1 = createCommonjsModule(function (e) {
  e.exports = {
    default: create,
    __esModule: !0
  };
});

unwrapExports(create$1);

var inherits$2 = createCommonjsModule(function (e, t) {
  t.__esModule = !0;
  var a = l(setPrototypeOf$1),
      n = l(create$1),
      r = l(_typeof_1);

  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  t.default = function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + (void 0 === t ? "undefined" : (0, r.default)(t)));
    e.prototype = (0, n.default)(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (a.default ? (0, a.default)(e, t) : e.__proto__ = t);
  };
}),
    _inherits = unwrapExports(inherits$2);

function contains(e, t) {
  for (var a = t; a;) {
    if (a === e) return !0;
    a = a.parentNode;
  }

  return !1;
}

var EventBaseObject_1 = createCommonjsModule(function (e, t) {
  function a() {
    return !1;
  }

  function n() {
    return !0;
  }

  function r() {
    this.timeStamp = Date.now(), this.target = void 0, this.currentTarget = void 0;
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), r.prototype = {
    isEventObject: 1,
    constructor: r,
    isDefaultPrevented: a,
    isPropagationStopped: a,
    isImmediatePropagationStopped: a,
    preventDefault: function preventDefault() {
      this.isDefaultPrevented = n;
    },
    stopPropagation: function stopPropagation() {
      this.isPropagationStopped = n;
    },
    stopImmediatePropagation: function stopImmediatePropagation() {
      this.isImmediatePropagationStopped = n, this.stopPropagation();
    },
    halt: function halt(e) {
      e ? this.stopImmediatePropagation() : this.stopPropagation(), this.preventDefault();
    }
  }, t.default = r, e.exports = t.default;
});
unwrapExports(EventBaseObject_1);
var EventObject = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = r(EventBaseObject_1),
      n = r(objectAssign);

  function r(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var l = !0,
      o = !1,
      c = ["altKey", "bubbles", "cancelable", "ctrlKey", "currentTarget", "eventPhase", "metaKey", "shiftKey", "target", "timeStamp", "view", "type"];

  function i(e) {
    return null === e || void 0 === e;
  }

  var s = [{
    reg: /^key/,
    props: ["char", "charCode", "key", "keyCode", "which"],
    fix: function fix(e, t) {
      i(e.which) && (e.which = i(t.charCode) ? t.keyCode : t.charCode), void 0 === e.metaKey && (e.metaKey = e.ctrlKey);
    }
  }, {
    reg: /^touch/,
    props: ["touches", "changedTouches", "targetTouches"]
  }, {
    reg: /^hashchange$/,
    props: ["newURL", "oldURL"]
  }, {
    reg: /^gesturechange$/i,
    props: ["rotation", "scale"]
  }, {
    reg: /^(mousewheel|DOMMouseScroll)$/,
    props: [],
    fix: function fix(e, t) {
      var a = void 0,
          n = void 0,
          r = void 0,
          l = t.wheelDelta,
          o = t.axis,
          c = t.wheelDeltaY,
          i = t.wheelDeltaX,
          s = t.detail;
      l && (r = l / 120), s && (r = 0 - (s % 3 == 0 ? s / 3 : s)), void 0 !== o && (o === e.HORIZONTAL_AXIS ? (n = 0, a = 0 - r) : o === e.VERTICAL_AXIS && (a = 0, n = r)), void 0 !== c && (n = c / 120), void 0 !== i && (a = -1 * i / 120), a || n || (n = r), void 0 !== a && (e.deltaX = a), void 0 !== n && (e.deltaY = n), void 0 !== r && (e.delta = r);
    }
  }, {
    reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
    props: ["buttons", "clientX", "clientY", "button", "offsetX", "relatedTarget", "which", "fromElement", "toElement", "offsetY", "pageX", "pageY", "screenX", "screenY"],
    fix: function fix(e, t) {
      var a = void 0,
          n = void 0,
          r = void 0,
          l = e.target,
          o = t.button;
      return l && i(e.pageX) && !i(t.clientX) && (n = (a = l.ownerDocument || document).documentElement, r = a.body, e.pageX = t.clientX + (n && n.scrollLeft || r && r.scrollLeft || 0) - (n && n.clientLeft || r && r.clientLeft || 0), e.pageY = t.clientY + (n && n.scrollTop || r && r.scrollTop || 0) - (n && n.clientTop || r && r.clientTop || 0)), e.which || void 0 === o || (e.which = 1 & o ? 1 : 2 & o ? 3 : 4 & o ? 2 : 0), !e.relatedTarget && e.fromElement && (e.relatedTarget = e.fromElement === l ? e.toElement : e.fromElement), e;
    }
  }];

  function u() {
    return l;
  }

  function f() {
    return o;
  }

  function d(e) {
    var t = e.type,
        n = "function" == typeof e.stopPropagation || "boolean" == typeof e.cancelBubble;
    a.default.call(this), this.nativeEvent = e;
    var r = f;
    "defaultPrevented" in e ? r = e.defaultPrevented ? u : f : "getPreventDefault" in e ? r = e.getPreventDefault() ? u : f : "returnValue" in e && (r = e.returnValue === o ? u : f), this.isDefaultPrevented = r;
    var l = [],
        i = void 0,
        d = void 0,
        p = c.concat();

    for (s.forEach(function (e) {
      t.match(e.reg) && (p = p.concat(e.props), e.fix && l.push(e.fix));
    }), i = p.length; i;) {
      this[d = p[--i]] = e[d];
    }

    for (!this.target && n && (this.target = e.srcElement || document), this.target && 3 === this.target.nodeType && (this.target = this.target.parentNode), i = l.length; i;) {
      (0, l[--i])(this, e);
    }

    this.timeStamp = e.timeStamp || Date.now();
  }

  var p = a.default.prototype;
  (0, n.default)(d.prototype, p, {
    constructor: d,
    preventDefault: function preventDefault() {
      var e = this.nativeEvent;
      e.preventDefault ? e.preventDefault() : e.returnValue = o, p.preventDefault.call(this);
    },
    stopPropagation: function stopPropagation() {
      var e = this.nativeEvent;
      e.stopPropagation ? e.stopPropagation() : e.cancelBubble = l, p.stopPropagation.call(this);
    }
  }), t.default = d, e.exports = t.default;
});
unwrapExports(EventObject);
var lib$1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e, t, a) {
    function r(t) {
      var r = new n.default(t);
      a.call(e, r);
    }

    if (e.addEventListener) return e.addEventListener(t, r, !1), {
      remove: function remove() {
        e.removeEventListener(t, r, !1);
      }
    };
    if (e.attachEvent) return e.attachEvent("on" + t, r), {
      remove: function remove() {
        e.detachEvent("on" + t, r);
      }
    };
  };
  var a,
      n = (a = EventObject) && a.__esModule ? a : {
    default: a
  };
  e.exports = t.default;
}),
    addDOMEventListener = unwrapExports(lib$1);

function addEventListenerWrap(e, t, a) {
  var n = ReactDOM__default.unstable_batchedUpdates ? function (e) {
    ReactDOM__default.unstable_batchedUpdates(a, e);
  } : a;
  return addDOMEventListener(e, t, n);
}

var vendorPrefix = void 0,
    jsCssMap = {
  Webkit: "-webkit-",
  Moz: "-moz-",
  ms: "-ms-",
  O: "-o-"
};

function getVendorPrefix() {
  if (void 0 !== vendorPrefix) return vendorPrefix;
  vendorPrefix = "";
  var e = document.createElement("p").style;

  for (var t in jsCssMap) {
    t + "Transform" in e && (vendorPrefix = t);
  }

  return vendorPrefix;
}

function getTransitionName() {
  return getVendorPrefix() ? getVendorPrefix() + "TransitionProperty" : "transitionProperty";
}

function getTransformName() {
  return getVendorPrefix() ? getVendorPrefix() + "Transform" : "transform";
}

function setTransitionProperty(e, t) {
  var a = getTransitionName();
  a && (e.style[a] = t, "transitionProperty" !== a && (e.style.transitionProperty = t));
}

function setTransform(e, t) {
  var a = getTransformName();
  a && (e.style[a] = t, "transform" !== a && (e.style.transform = t));
}

function getTransitionProperty(e) {
  return e.style.transitionProperty || e.style[getTransitionName()];
}

function getTransformXY(e) {
  var t = window.getComputedStyle(e, null),
      a = t.getPropertyValue("transform") || t.getPropertyValue(getTransformName());

  if (a && "none" !== a) {
    var n = a.replace(/[^0-9\-.,]/g, "").split(",");
    return {
      x: parseFloat(n[12] || n[4], 0),
      y: parseFloat(n[13] || n[5], 0)
    };
  }

  return {
    x: 0,
    y: 0
  };
}

var matrix2d = /matrix\((.*)\)/,
    matrix3d = /matrix3d\((.*)\)/;

function setTransformXY(e, t) {
  var a = window.getComputedStyle(e, null),
      n = a.getPropertyValue("transform") || a.getPropertyValue(getTransformName());

  if (n && "none" !== n) {
    var r = void 0,
        l = n.match(matrix2d);
    if (l) (r = (l = l[1]).split(",").map(function (e) {
      return parseFloat(e, 10);
    }))[4] = t.x, r[5] = t.y, setTransform(e, "matrix(" + r.join(",") + ")");else (r = n.match(matrix3d)[1].split(",").map(function (e) {
      return parseFloat(e, 10);
    }))[12] = t.x, r[13] = t.y, setTransform(e, "matrix3d(" + r.join(",") + ")");
  } else setTransform(e, "translateX(" + t.x + "px) translateY(" + t.y + "px) translateZ(0)");
}

var _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
  return typeof e;
} : function (e) {
  return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
},
    RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source,
    getComputedStyleX = void 0;

function forceRelayout(e) {
  var t = e.style.display;
  e.style.display = "none", e.offsetHeight, e.style.display = t;
}

function css$3(e, t, a) {
  var n = a;
  if ("object" !== (void 0 === t ? "undefined" : _typeof$3(t))) return void 0 !== n ? ("number" == typeof n && (n += "px"), void (e.style[t] = n)) : getComputedStyleX(e, t);

  for (var r in t) {
    t.hasOwnProperty(r) && css$3(e, r, t[r]);
  }
}

function getClientPosition(e) {
  var t,
      a = void 0,
      n = void 0,
      r = e.ownerDocument,
      l = r.body,
      o = r && r.documentElement;
  return a = (t = e.getBoundingClientRect()).left, n = t.top, {
    left: a -= o.clientLeft || l.clientLeft || 0,
    top: n -= o.clientTop || l.clientTop || 0
  };
}

function getScroll(e, t) {
  var a = e["page" + (t ? "Y" : "X") + "Offset"],
      n = "scroll" + (t ? "Top" : "Left");

  if ("number" != typeof a) {
    var r = e.document;
    "number" != typeof (a = r.documentElement[n]) && (a = r.body[n]);
  }

  return a;
}

function getScrollLeft(e) {
  return getScroll(e);
}

function getScrollTop$1(e) {
  return getScroll(e, !0);
}

function getOffset(e) {
  var t = getClientPosition(e),
      a = e.ownerDocument,
      n = a.defaultView || a.parentWindow;
  return t.left += getScrollLeft(n), t.top += getScrollTop$1(n), t;
}

function isWindow(e) {
  return null !== e && void 0 !== e && e == e.window;
}

function getDocument(e) {
  return isWindow(e) ? e.document : 9 === e.nodeType ? e : e.ownerDocument;
}

function _getComputedStyle(e, t, a) {
  var n = a,
      r = "",
      l = getDocument(e);
  return (n = n || l.defaultView.getComputedStyle(e, null)) && (r = n.getPropertyValue(t) || n[t]), r;
}

var _RE_NUM_NO_PX = new RegExp("^(" + RE_NUM + ")(?!px)[a-z%]+$", "i"),
    RE_POS = /^(top|right|bottom|left)$/,
    CURRENT_STYLE = "currentStyle",
    RUNTIME_STYLE = "runtimeStyle",
    LEFT = "left",
    PX = "px";

function _getComputedStyleIE(e, t) {
  var a = e[CURRENT_STYLE] && e[CURRENT_STYLE][t];

  if (_RE_NUM_NO_PX.test(a) && !RE_POS.test(t)) {
    var n = e.style,
        r = n[LEFT],
        l = e[RUNTIME_STYLE][LEFT];
    e[RUNTIME_STYLE][LEFT] = e[CURRENT_STYLE][LEFT], n[LEFT] = "fontSize" === t ? "1em" : a || 0, a = n.pixelLeft + PX, n[LEFT] = r, e[RUNTIME_STYLE][LEFT] = l;
  }

  return "" === a ? "auto" : a;
}

function getOffsetDirection(e, t) {
  return "left" === e ? t.useCssRight ? "right" : e : t.useCssBottom ? "bottom" : e;
}

function oppositeOffsetDirection(e) {
  return "left" === e ? "right" : "right" === e ? "left" : "top" === e ? "bottom" : "bottom" === e ? "top" : void 0;
}

function setLeftTop(e, t, a) {
  "static" === css$3(e, "position") && (e.style.position = "relative");
  var n = -999,
      r = -999,
      l = getOffsetDirection("left", a),
      o = getOffsetDirection("top", a),
      c = oppositeOffsetDirection(l),
      i = oppositeOffsetDirection(o);
  "left" !== l && (n = 999), "top" !== o && (r = 999);
  var s = "",
      u = getOffset(e);
  ("left" in t || "top" in t) && (s = getTransitionProperty(e) || "", setTransitionProperty(e, "none")), "left" in t && (e.style[c] = "", e.style[l] = n + "px"), "top" in t && (e.style[i] = "", e.style[o] = r + "px"), forceRelayout(e);
  var f = getOffset(e),
      d = {};

  for (var p in t) {
    if (t.hasOwnProperty(p)) {
      var h = getOffsetDirection(p, a),
          m = "left" === p ? n : r,
          _ = u[p] - f[p];

      d[h] = h === p ? m + _ : m - _;
    }
  }

  css$3(e, d), forceRelayout(e), ("left" in t || "top" in t) && setTransitionProperty(e, s);
  var v = {};

  for (var y in t) {
    if (t.hasOwnProperty(y)) {
      var g = getOffsetDirection(y, a),
          E = t[y] - u[y];
      v[g] = y === g ? d[g] + E : d[g] - E;
    }
  }

  css$3(e, v);
}

function setTransform$1(e, t) {
  var a = getOffset(e),
      n = getTransformXY(e),
      r = {
    x: n.x,
    y: n.y
  };
  "left" in t && (r.x = n.x + t.left - a.left), "top" in t && (r.y = n.y + t.top - a.top), setTransformXY(e, r);
}

function setOffset(e, t, a) {
  a.useCssRight || a.useCssBottom ? setLeftTop(e, t, a) : a.useCssTransform && getTransformName() in document.body.style ? setTransform$1(e, t, a) : setLeftTop(e, t, a);
}

function each(e, t) {
  for (var a = 0; a < e.length; a++) {
    t(e[a]);
  }
}

function isBorderBoxFn(e) {
  return "border-box" === getComputedStyleX(e, "boxSizing");
}

"undefined" != typeof window && (getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE);
var BOX_MODELS = ["margin", "border", "padding"],
    CONTENT_INDEX = -1,
    PADDING_INDEX = 2,
    BORDER_INDEX = 1,
    MARGIN_INDEX = 0;

function swap(e, t, a) {
  var n = {},
      r = e.style,
      l = void 0;

  for (l in t) {
    t.hasOwnProperty(l) && (n[l] = r[l], r[l] = t[l]);
  }

  for (l in a.call(e), t) {
    t.hasOwnProperty(l) && (r[l] = n[l]);
  }
}

function getPBMWidth(e, t, a) {
  var n = 0,
      r = void 0,
      l = void 0,
      o = void 0;

  for (l = 0; l < t.length; l++) {
    if (r = t[l]) for (o = 0; o < a.length; o++) {
      var c = void 0;
      c = "border" === r ? "" + r + a[o] + "Width" : r + a[o], n += parseFloat(getComputedStyleX(e, c)) || 0;
    }
  }

  return n;
}

var domUtils = {};

function getWH(e, t, a) {
  var n = a;
  if (isWindow(e)) return "width" === t ? domUtils.viewportWidth(e) : domUtils.viewportHeight(e);
  if (9 === e.nodeType) return "width" === t ? domUtils.docWidth(e) : domUtils.docHeight(e);
  var r = "width" === t ? ["Left", "Right"] : ["Top", "Bottom"],
      l = "width" === t ? e.getBoundingClientRect().width : e.getBoundingClientRect().height,
      o = getComputedStyleX(e),
      c = isBorderBoxFn(e, o),
      i = 0;
  (null === l || void 0 === l || l <= 0) && (l = void 0, (null === (i = getComputedStyleX(e, t)) || void 0 === i || Number(i) < 0) && (i = e.style[t] || 0), i = parseFloat(i) || 0), void 0 === n && (n = c ? BORDER_INDEX : CONTENT_INDEX);
  var s = void 0 !== l || c,
      u = l || i;
  return n === CONTENT_INDEX ? s ? u - getPBMWidth(e, ["border", "padding"], r, o) : i : s ? n === BORDER_INDEX ? u : u + (n === PADDING_INDEX ? -getPBMWidth(e, ["border"], r, o) : getPBMWidth(e, ["margin"], r, o)) : i + getPBMWidth(e, BOX_MODELS.slice(n), r, o);
}

each(["Width", "Height"], function (e) {
  domUtils["doc" + e] = function (t) {
    var a = t.document;
    return Math.max(a.documentElement["scroll" + e], a.body["scroll" + e], domUtils["viewport" + e](a));
  }, domUtils["viewport" + e] = function (t) {
    var a = "client" + e,
        n = t.document,
        r = n.body,
        l = n.documentElement[a];
    return "CSS1Compat" === n.compatMode && l || r && r[a] || l;
  };
});
var cssShow = {
  position: "absolute",
  visibility: "hidden",
  display: "block"
};

function getWHIgnoreDisplay() {
  for (var e = arguments.length, t = Array(e), a = 0; a < e; a++) {
    t[a] = arguments[a];
  }

  var n = void 0,
      r = t[0];
  return 0 !== r.offsetWidth ? n = getWH.apply(void 0, t) : swap(r, cssShow, function () {
    n = getWH.apply(void 0, t);
  }), n;
}

function mix(e, t) {
  for (var a in t) {
    t.hasOwnProperty(a) && (e[a] = t[a]);
  }

  return e;
}

each(["width", "height"], function (e) {
  var t = e.charAt(0).toUpperCase() + e.slice(1);

  domUtils["outer" + t] = function (t, a) {
    return t && getWHIgnoreDisplay(t, e, a ? MARGIN_INDEX : BORDER_INDEX);
  };

  var a = "width" === e ? ["Left", "Right"] : ["Top", "Bottom"];

  domUtils[e] = function (t, n) {
    var r = n;
    if (void 0 === r) return t && getWHIgnoreDisplay(t, e, CONTENT_INDEX);

    if (t) {
      var l = getComputedStyleX(t);
      return isBorderBoxFn(t) && (r += getPBMWidth(t, ["padding", "border"], a, l)), css$3(t, e, r);
    }
  };
});
var utils$4 = {
  getWindow: function getWindow(e) {
    if (e && e.document && e.setTimeout) return e;
    var t = e.ownerDocument || e;
    return t.defaultView || t.parentWindow;
  },
  getDocument: getDocument,
  offset: function offset(e, t, a) {
    if (void 0 === t) return getOffset(e);
    setOffset(e, t, a || {});
  },
  isWindow: isWindow,
  each: each,
  css: css$3,
  clone: function clone(e) {
    var t = void 0,
        a = {};

    for (t in e) {
      e.hasOwnProperty(t) && (a[t] = e[t]);
    }

    if (e.overflow) for (t in e) {
      e.hasOwnProperty(t) && (a.overflow[t] = e.overflow[t]);
    }
    return a;
  },
  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(e) {
    return getScrollLeft(e);
  },
  getWindowScrollTop: function getWindowScrollTop(e) {
    return getScrollTop$1(e);
  },
  merge: function merge() {
    for (var e = {}, t = arguments.length, a = Array(t), n = 0; n < t; n++) {
      a[n] = arguments[n];
    }

    for (var r = 0; r < a.length; r++) {
      utils$4.mix(e, a[r]);
    }

    return e;
  },
  viewportWidth: 0,
  viewportHeight: 0
};

function getOffsetParent(e) {
  if (utils$4.isWindow(e) || 9 === e.nodeType) return null;
  var t = utils$4.getDocument(e).body,
      a = void 0,
      n = utils$4.css(e, "position");
  if (!("fixed" === n || "absolute" === n)) return "html" === e.nodeName.toLowerCase() ? null : e.parentNode;

  for (a = e.parentNode; a && a !== t; a = a.parentNode) {
    if ("static" !== (n = utils$4.css(a, "position"))) return a;
  }

  return null;
}

function isAncestorFixed(e) {
  if (utils$4.isWindow(e) || 9 === e.nodeType) return !1;
  var t = utils$4.getDocument(e).body,
      a = null;

  for (a = e.parentNode; a && a !== t; a = a.parentNode) {
    if ("fixed" === utils$4.css(a, "position")) return !0;
  }

  return !1;
}

function getVisibleRectForElement(e) {
  for (var t = {
    left: 0,
    right: 1 / 0,
    top: 0,
    bottom: 1 / 0
  }, a = getOffsetParent(e), n = utils$4.getDocument(e), r = n.defaultView || n.parentWindow, l = n.body, o = n.documentElement; a;) {
    if (-1 !== navigator.userAgent.indexOf("MSIE") && 0 === a.clientWidth || a === l || a === o || "visible" === utils$4.css(a, "overflow")) {
      if (a === l || a === o) break;
    } else {
      var c = utils$4.offset(a);
      c.left += a.clientLeft, c.top += a.clientTop, t.top = Math.max(t.top, c.top), t.right = Math.min(t.right, c.left + a.clientWidth), t.bottom = Math.min(t.bottom, c.top + a.clientHeight), t.left = Math.max(t.left, c.left);
    }

    a = getOffsetParent(a);
  }

  var i = null;
  utils$4.isWindow(e) || 9 === e.nodeType || (i = e.style.position, "absolute" === utils$4.css(e, "position") && (e.style.position = "fixed"));
  var s = utils$4.getWindowScrollLeft(r),
      u = utils$4.getWindowScrollTop(r),
      f = utils$4.viewportWidth(r),
      d = utils$4.viewportHeight(r),
      p = o.scrollWidth,
      h = o.scrollHeight;
  if (e.style && (e.style.position = i), isAncestorFixed(e)) t.left = Math.max(t.left, s), t.top = Math.max(t.top, u), t.right = Math.min(t.right, s + f), t.bottom = Math.min(t.bottom, u + d);else {
    var m = Math.max(p, s + f);
    t.right = Math.min(t.right, m);

    var _ = Math.max(h, u + d);

    t.bottom = Math.min(t.bottom, _);
  }
  return t.top >= 0 && t.left >= 0 && t.bottom > t.top && t.right > t.left ? t : null;
}

function adjustForViewport(e, t, a, n) {
  var r = utils$4.clone(e),
      l = {
    width: t.width,
    height: t.height
  };
  return n.adjustX && r.left < a.left && (r.left = a.left), n.resizeWidth && r.left >= a.left && r.left + l.width > a.right && (l.width -= r.left + l.width - a.right), n.adjustX && r.left + l.width > a.right && (r.left = Math.max(a.right - l.width, a.left)), n.adjustY && r.top < a.top && (r.top = a.top), n.resizeHeight && r.top >= a.top && r.top + l.height > a.bottom && (l.height -= r.top + l.height - a.bottom), n.adjustY && r.top + l.height > a.bottom && (r.top = Math.max(a.bottom - l.height, a.top)), utils$4.mix(r, l);
}

function getRegion(e) {
  var t = void 0,
      a = void 0,
      n = void 0;

  if (utils$4.isWindow(e) || 9 === e.nodeType) {
    var r = utils$4.getWindow(e);
    t = {
      left: utils$4.getWindowScrollLeft(r),
      top: utils$4.getWindowScrollTop(r)
    }, a = utils$4.viewportWidth(r), n = utils$4.viewportHeight(r);
  } else t = utils$4.offset(e), a = utils$4.outerWidth(e), n = utils$4.outerHeight(e);

  return t.width = a, t.height = n, t;
}

function getAlignOffset(e, t) {
  var a = t.charAt(0),
      n = t.charAt(1),
      r = e.width,
      l = e.height,
      o = e.left,
      c = e.top;
  return "c" === a ? c += l / 2 : "b" === a && (c += l), "c" === n ? o += r / 2 : "r" === n && (o += r), {
    left: o,
    top: c
  };
}

function getElFuturePos(e, t, a, n, r) {
  var l = getAlignOffset(t, a[1]),
      o = getAlignOffset(e, a[0]),
      c = [o.left - l.left, o.top - l.top];
  return {
    left: e.left - c[0] + n[0] - r[0],
    top: e.top - c[1] + n[1] - r[1]
  };
}

function isFailX(e, t, a) {
  return e.left < a.left || e.left + t.width > a.right;
}

function isFailY(e, t, a) {
  return e.top < a.top || e.top + t.height > a.bottom;
}

function isCompleteFailX(e, t, a) {
  return e.left > a.right || e.left + t.width < a.left;
}

function isCompleteFailY(e, t, a) {
  return e.top > a.bottom || e.top + t.height < a.top;
}

function isOutOfVisibleRect(e) {
  var t = getVisibleRectForElement(e),
      a = getRegion(e);
  return !t || a.left + a.width <= t.left || a.top + a.height <= t.top || a.left >= t.right || a.top >= t.bottom;
}

function flip(e, t, a) {
  var n = [];
  return utils$4.each(e, function (e) {
    n.push(e.replace(t, function (e) {
      return a[e];
    }));
  }), n;
}

function flipOffset(e, t) {
  return e[t] = -e[t], e;
}

function convertOffset(e, t) {
  return (/%$/.test(e) ? parseInt(e.substring(0, e.length - 1), 10) / 100 * t : parseInt(e, 10)) || 0;
}

function normalizeOffset(e, t) {
  e[0] = convertOffset(e[0], t.width), e[1] = convertOffset(e[1], t.height);
}

function domAlign(e, t, a) {
  var n = a.points,
      r = a.offset || [0, 0],
      l = a.targetOffset || [0, 0],
      o = a.overflow,
      c = a.target || t,
      i = a.source || e;
  r = [].concat(r), l = [].concat(l), o = o || {};
  var s = {},
      u = 0,
      f = getVisibleRectForElement(i),
      d = getRegion(i),
      p = getRegion(c);
  normalizeOffset(r, d), normalizeOffset(l, p);

  var h = getElFuturePos(d, p, n, r, l),
      m = utils$4.merge(d, h),
      _ = !isOutOfVisibleRect(c);

  if (f && (o.adjustX || o.adjustY) && _) {
    if (o.adjustX && isFailX(h, d, f)) {
      var v = flip(n, /[lr]/gi, {
        l: "r",
        r: "l"
      }),
          y = flipOffset(r, 0),
          g = flipOffset(l, 0);
      isCompleteFailX(getElFuturePos(d, p, v, y, g), d, f) || (u = 1, n = v, r = y, l = g);
    }

    if (o.adjustY && isFailY(h, d, f)) {
      var E = flip(n, /[tb]/gi, {
        t: "b",
        b: "t"
      }),
          b = flipOffset(r, 1),
          z = flipOffset(l, 1);
      isCompleteFailY(getElFuturePos(d, p, E, b, z), d, f) || (u = 1, n = E, r = b, l = z);
    }

    u && (h = getElFuturePos(d, p, n, r, l), utils$4.mix(m, h));
    var R = isFailX(h, d, f),
        M = isFailY(h, d, f);
    (R || M) && (n = a.points, r = a.offset || [0, 0], l = a.targetOffset || [0, 0]), s.adjustX = o.adjustX && R, s.adjustY = o.adjustY && M, (s.adjustX || s.adjustY) && (m = adjustForViewport(h, d, f, s));
  }

  return m.width !== d.width && utils$4.css(i, "width", utils$4.width(i) + m.width - d.width), m.height !== d.height && utils$4.css(i, "height", utils$4.height(i) + m.height - d.height), utils$4.offset(i, {
    left: m.left,
    top: m.top
  }, {
    useCssRight: a.useCssRight,
    useCssBottom: a.useCssBottom,
    useCssTransform: a.useCssTransform
  }), {
    points: n,
    offset: r,
    targetOffset: l,
    overflow: s
  };
}

mix(utils$4, domUtils), domAlign.__getOffsetParent = getOffsetParent, domAlign.__getVisibleRectForElement = getVisibleRectForElement;

var shallowequal = function shallowequal(e, t, a, n) {
  var r = a ? a.call(n, e, t) : void 0;
  if (void 0 !== r) return !!r;
  if (e === t) return !0;
  if ("object" != typeof e || !e || "object" != typeof t || !t) return !1;
  var l = Object.keys(e),
      o = Object.keys(t);
  if (l.length !== o.length) return !1;

  for (var c = Object.prototype.hasOwnProperty.bind(t), i = 0; i < l.length; i++) {
    var s = l[i];
    if (!c(s)) return !1;
    var u = e[s],
        f = t[s];
    if (!1 === (r = a ? a.call(n, u, f, s) : void 0) || void 0 === r && u !== f) return !1;
  }

  return !0;
};

function isWindow$1(e) {
  return null != e && e == e.window;
}

function buffer(e, t) {
  var a = void 0;

  function n() {
    a && (clearTimeout(a), a = null);
  }

  function r() {
    n(), a = setTimeout(e, t);
  }

  return r.clear = n, r;
}

var Align = function (e) {
  function t() {
    var a, n;

    _classCallCheck(this, t);

    for (var r = arguments.length, l = Array(r), o = 0; o < r; o++) {
      l[o] = arguments[o];
    }

    return a = n = _possibleConstructorReturn(this, e.call.apply(e, [this].concat(l))), n.forceAlign = function () {
      var e = n.props;

      if (!e.disabled) {
        var t = ReactDOM__default.findDOMNode(n);
        e.onAlign(t, domAlign(t, e.target(), e.align));
      }
    }, _possibleConstructorReturn(n, a);
  }

  return _inherits(t, e), t.prototype.componentDidMount = function () {
    var e = this.props;
    this.forceAlign(), !e.disabled && e.monitorWindowResize && this.startMonitorWindowResize();
  }, t.prototype.componentDidUpdate = function (e) {
    var t = !1,
        a = this.props;
    if (!a.disabled) if (e.disabled || !shallowequal(e.align, a.align)) t = !0;else {
      var n = e.target(),
          r = a.target();
      isWindow$1(n) && isWindow$1(r) ? t = !1 : n !== r && (t = !0);
    }
    t && this.forceAlign(), a.monitorWindowResize && !a.disabled ? this.startMonitorWindowResize() : this.stopMonitorWindowResize();
  }, t.prototype.componentWillUnmount = function () {
    this.stopMonitorWindowResize();
  }, t.prototype.startMonitorWindowResize = function () {
    this.resizeHandler || (this.bufferMonitor = buffer(this.forceAlign, this.props.monitorBufferTime), this.resizeHandler = addEventListenerWrap(window, "resize", this.bufferMonitor));
  }, t.prototype.stopMonitorWindowResize = function () {
    this.resizeHandler && (this.bufferMonitor.clear(), this.resizeHandler.remove(), this.resizeHandler = null);
  }, t.prototype.render = function () {
    var e = this.props,
        t = e.childrenProps,
        a = e.children,
        n = React__default.Children.only(a);

    if (t) {
      var r = {};

      for (var l in t) {
        t.hasOwnProperty(l) && (r[l] = this.props[t[l]]);
      }

      return React__default.cloneElement(n, r);
    }

    return n;
  }, t;
}(React.Component);

Align.propTypes = {
  childrenProps: PropTypes.object,
  align: PropTypes.object.isRequired,
  target: PropTypes.func,
  onAlign: PropTypes.func,
  monitorBufferTime: PropTypes.number,
  monitorWindowResize: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.any
}, Align.defaultProps = {
  target: function target() {
    return window;
  },
  onAlign: function onAlign() {},
  monitorBufferTime: 50,
  monitorWindowResize: !1,
  disabled: !1
}, _export(_export.S + _export.F * !_descriptors, "Object", {
  defineProperty: _objectDp.f
});

var $Object$1 = _core.Object,
    defineProperty$3 = function defineProperty$3(e, t, a) {
  return $Object$1.defineProperty(e, t, a);
},
    defineProperty$4 = createCommonjsModule(function (e) {
  e.exports = {
    default: defineProperty$3,
    __esModule: !0
  };
});

unwrapExports(defineProperty$4);

var defineProperty$6 = createCommonjsModule(function (e, t) {
  t.__esModule = !0;
  var a,
      n = (a = defineProperty$4) && a.__esModule ? a : {
    default: a
  };

  t.default = function (e, t, a) {
    return t in e ? (0, n.default)(e, t, {
      value: a,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = a, e;
  };
}),
    _defineProperty = unwrapExports(defineProperty$6),
    createClass$2 = createCommonjsModule(function (e, t) {
  t.__esModule = !0;
  var a,
      n = (a = defineProperty$4) && a.__esModule ? a : {
    default: a
  };

  t.default = function () {
    function e(e, t) {
      for (var a = 0; a < t.length; a++) {
        var r = t[a];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), (0, n.default)(e, r.key, r);
      }
    }

    return function (t, a, n) {
      return a && e(t.prototype, a), n && e(t, n), t;
    };
  }();
}),
    _createClass = unwrapExports(createClass$2);

function toArrayChildren(e) {
  var t = [];
  return React__default.Children.forEach(e, function (e) {
    t.push(e);
  }), t;
}

function findChildInChildrenByKey(e, t) {
  var a = null;
  return e && e.forEach(function (e) {
    a || e && e.key === t && (a = e);
  }), a;
}

function findShownChildInChildrenByKey(e, t, a) {
  var n = null;
  return e && e.forEach(function (e) {
    if (e && e.key === t && e.props[a]) {
      if (n) throw new Error("two child with same key for <rc-animate> children");
      n = e;
    }
  }), n;
}

function isSameChildren(e, t, a) {
  var n = e.length === t.length;
  return n && e.forEach(function (e, r) {
    var l = t[r];
    e && l && (e && !l || !e && l ? n = !1 : e.key !== l.key ? n = !1 : a && e.props[a] !== l.props[a] && (n = !1));
  }), n;
}

function mergeChildren(e, t) {
  var a = [],
      n = {},
      r = [];
  return e.forEach(function (e) {
    e && findChildInChildrenByKey(t, e.key) ? r.length && (n[e.key] = r, r = []) : r.push(e);
  }), t.forEach(function (e) {
    e && n.hasOwnProperty(e.key) && (a = a.concat(n[e.key])), a.push(e);
  }), a = a.concat(r);
}

var EVENT_NAME_MAP = {
  transitionend: {
    transition: "transitionend",
    WebkitTransition: "webkitTransitionEnd",
    MozTransition: "mozTransitionEnd",
    OTransition: "oTransitionEnd",
    msTransition: "MSTransitionEnd"
  },
  animationend: {
    animation: "animationend",
    WebkitAnimation: "webkitAnimationEnd",
    MozAnimation: "mozAnimationEnd",
    OAnimation: "oAnimationEnd",
    msAnimation: "MSAnimationEnd"
  }
},
    endEvents = [];

function detectEvents() {
  var e = document.createElement("div").style;

  for (var t in "AnimationEvent" in window || delete EVENT_NAME_MAP.animationend.animation, "TransitionEvent" in window || delete EVENT_NAME_MAP.transitionend.transition, EVENT_NAME_MAP) {
    if (EVENT_NAME_MAP.hasOwnProperty(t)) {
      var a = EVENT_NAME_MAP[t];

      for (var n in a) {
        if (n in e) {
          endEvents.push(a[n]);
          break;
        }
      }
    }
  }
}

function addEventListener(e, t, a) {
  e.addEventListener(t, a, !1);
}

function removeEventListener(e, t, a) {
  e.removeEventListener(t, a, !1);
}

"undefined" != typeof window && "undefined" != typeof document && detectEvents();

var TransitionEvents = {
  addEndEventListener: function addEndEventListener(e, t) {
    0 !== endEvents.length ? endEvents.forEach(function (a) {
      addEventListener(e, a, t);
    }) : window.setTimeout(t, 0);
  },
  endEvents: endEvents,
  removeEndEventListener: function removeEndEventListener(e, t) {
    0 !== endEvents.length && endEvents.forEach(function (a) {
      removeEventListener(e, a, t);
    });
  }
},
    indexOf = [].indexOf,
    indexof = function indexof(e, t) {
  if (indexOf) return e.indexOf(t);

  for (var a = 0; a < e.length; ++a) {
    if (e[a] === t) return a;
  }

  return -1;
},
    componentIndexof = function componentIndexof(e, t) {
  if (e.indexOf) return e.indexOf(t);

  for (var a = 0; a < e.length; ++a) {
    if (e[a] === t) return a;
  }

  return -1;
};

try {
  var index$3 = indexof;
} catch (e) {
  index$3 = componentIndexof;
}

var re = /\s+/,
    toString$2 = Object.prototype.toString,
    componentClasses = function componentClasses(e) {
  return new ClassList(e);
};

function ClassList(e) {
  if (!e || !e.nodeType) throw new Error("A DOM element reference is required");
  this.el = e, this.list = e.classList;
}

ClassList.prototype.add = function (e) {
  if (this.list) return this.list.add(e), this;
  var t = this.array();
  return ~index$3(t, e) || t.push(e), this.el.className = t.join(" "), this;
}, ClassList.prototype.remove = function (e) {
  if ("[object RegExp]" == toString$2.call(e)) return this.removeMatching(e);
  if (this.list) return this.list.remove(e), this;
  var t = this.array(),
      a = index$3(t, e);
  return ~a && t.splice(a, 1), this.el.className = t.join(" "), this;
}, ClassList.prototype.removeMatching = function (e) {
  for (var t = this.array(), a = 0; a < t.length; a++) {
    e.test(t[a]) && this.remove(t[a]);
  }

  return this;
}, ClassList.prototype.toggle = function (e, t) {
  return this.list ? (void 0 !== t ? t !== this.list.toggle(e, t) && this.list.toggle(e) : this.list.toggle(e), this) : (void 0 !== t ? t ? this.add(e) : this.remove(e) : this.has(e) ? this.remove(e) : this.add(e), this);
}, ClassList.prototype.array = function () {
  var e = (this.el.getAttribute("class") || "").replace(/^\s+|\s+$/g, "").split(re);
  return "" === e[0] && e.shift(), e;
}, ClassList.prototype.has = ClassList.prototype.contains = function (e) {
  return this.list ? this.list.contains(e) : !!~index$3(this.array(), e);
};
var isCssAnimationSupported = 0 !== TransitionEvents.endEvents.length,
    capitalPrefixes = ["Webkit", "Moz", "O", "ms"],
    prefixes = ["-webkit-", "-moz-", "-o-", "ms-", ""];

function getStyleProperty(e, t) {
  for (var a = window.getComputedStyle(e, null), n = "", r = 0; r < prefixes.length && !(n = a.getPropertyValue(prefixes[r] + t)); r++) {
    ;
  }

  return n;
}

function fixBrowserByTimeout(e) {
  if (isCssAnimationSupported) {
    var t = parseFloat(getStyleProperty(e, "transition-delay")) || 0,
        a = parseFloat(getStyleProperty(e, "transition-duration")) || 0,
        n = parseFloat(getStyleProperty(e, "animation-delay")) || 0,
        r = parseFloat(getStyleProperty(e, "animation-duration")) || 0,
        l = Math.max(a + t, r + n);
    e.rcEndAnimTimeout = setTimeout(function () {
      e.rcEndAnimTimeout = null, e.rcEndListener && e.rcEndListener();
    }, 1e3 * l + 200);
  }
}

function clearBrowserBugTimeout(e) {
  e.rcEndAnimTimeout && (clearTimeout(e.rcEndAnimTimeout), e.rcEndAnimTimeout = null);
}

var cssAnimation = function cssAnimation(e, t, a) {
  var n = "object" === (void 0 === t ? "undefined" : _typeof$2(t)),
      r = n ? t.name : t,
      l = n ? t.active : t + "-active",
      o = a,
      c = void 0,
      i = void 0,
      s = componentClasses(e);
  return a && "[object Object]" === Object.prototype.toString.call(a) && (o = a.end, c = a.start, i = a.active), e.rcEndListener && e.rcEndListener(), e.rcEndListener = function (t) {
    t && t.target !== e || (e.rcAnimTimeout && (clearTimeout(e.rcAnimTimeout), e.rcAnimTimeout = null), clearBrowserBugTimeout(e), s.remove(r), s.remove(l), TransitionEvents.removeEndEventListener(e, e.rcEndListener), e.rcEndListener = null, o && o());
  }, TransitionEvents.addEndEventListener(e, e.rcEndListener), c && c(), s.add(r), e.rcAnimTimeout = setTimeout(function () {
    e.rcAnimTimeout = null, s.add(l), i && setTimeout(i, 0), fixBrowserByTimeout(e);
  }, 30), {
    stop: function stop() {
      e.rcEndListener && e.rcEndListener();
    }
  };
};

cssAnimation.style = function (e, t, a) {
  e.rcEndListener && e.rcEndListener(), e.rcEndListener = function (t) {
    t && t.target !== e || (e.rcAnimTimeout && (clearTimeout(e.rcAnimTimeout), e.rcAnimTimeout = null), clearBrowserBugTimeout(e), TransitionEvents.removeEndEventListener(e, e.rcEndListener), e.rcEndListener = null, a && a());
  }, TransitionEvents.addEndEventListener(e, e.rcEndListener), e.rcAnimTimeout = setTimeout(function () {
    for (var a in t) {
      t.hasOwnProperty(a) && (e.style[a] = t[a]);
    }

    e.rcAnimTimeout = null, fixBrowserByTimeout(e);
  }, 0);
}, cssAnimation.setTransition = function (e, t, a) {
  var n = t,
      r = a;
  void 0 === a && (r = n, n = ""), n = n || "", capitalPrefixes.forEach(function (t) {
    e.style[t + "Transition" + n] = r;
  });
}, cssAnimation.isCssAnimationSupported = isCssAnimationSupported;

var util$2 = {
  isAppearSupported: function isAppearSupported(e) {
    return e.transitionName && e.transitionAppear || e.animation.appear;
  },
  isEnterSupported: function isEnterSupported(e) {
    return e.transitionName && e.transitionEnter || e.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(e) {
    return e.transitionName && e.transitionLeave || e.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(e) {
    return e.transitionAppear || e.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(e) {
    return e.transitionEnter || e.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(e) {
    return e.transitionLeave || e.animation.leave;
  }
},
    transitionMap = {
  enter: "transitionEnter",
  appear: "transitionAppear",
  leave: "transitionLeave"
},
    AnimateChild = function (e) {
  function t() {
    return _classCallCheck(this, t), _possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
  }

  return _inherits(t, e), _createClass(t, [{
    key: "componentWillUnmount",
    value: function value() {
      this.stop();
    }
  }, {
    key: "componentWillEnter",
    value: function value(e) {
      util$2.isEnterSupported(this.props) ? this.transition("enter", e) : e();
    }
  }, {
    key: "componentWillAppear",
    value: function value(e) {
      util$2.isAppearSupported(this.props) ? this.transition("appear", e) : e();
    }
  }, {
    key: "componentWillLeave",
    value: function value(e) {
      util$2.isLeaveSupported(this.props) ? this.transition("leave", e) : e();
    }
  }, {
    key: "transition",
    value: function value(e, t) {
      var a = this,
          n = ReactDOM__default.findDOMNode(this),
          r = this.props,
          l = r.transitionName,
          o = "object" === (void 0 === l ? "undefined" : _typeof$2(l));
      this.stop();

      var c = function c() {
        a.stopper = null, t();
      };

      if ((isCssAnimationSupported || !r.animation[e]) && l && r[transitionMap[e]]) {
        var i = o ? l[e] : l + "-" + e,
            s = i + "-active";
        o && l[e + "Active"] && (s = l[e + "Active"]), this.stopper = cssAnimation(n, {
          name: i,
          active: s
        }, c);
      } else this.stopper = r.animation[e](n, c);
    }
  }, {
    key: "stop",
    value: function value() {
      var e = this.stopper;
      e && (this.stopper = null, e.stop());
    }
  }, {
    key: "render",
    value: function value() {
      return this.props.children;
    }
  }]), t;
}(React__default.Component);

AnimateChild.propTypes = {
  children: PropTypes.any
};
var defaultKey = "rc_animate_" + Date.now();

function getChildrenFromProps(e) {
  var t = e.children;
  return React__default.isValidElement(t) && !t.key ? React__default.cloneElement(t, {
    key: defaultKey
  }) : t;
}

function noop$1() {}

var Animate = function (e) {
  function t(e) {
    _classCallCheck(this, t);

    var a = _possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

    return _initialiseProps$1.call(a), a.currentlyAnimatingKeys = {}, a.keysToEnter = [], a.keysToLeave = [], a.state = {
      children: toArrayChildren(getChildrenFromProps(e))
    }, a.childrenRefs = {}, a;
  }

  return _inherits(t, e), _createClass(t, [{
    key: "componentDidMount",
    value: function value() {
      var e = this,
          t = this.props.showProp,
          a = this.state.children;
      t && (a = a.filter(function (e) {
        return !!e.props[t];
      })), a.forEach(function (t) {
        t && e.performAppear(t.key);
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function value(e) {
      var t = this;
      this.nextProps = e;
      var a = toArrayChildren(getChildrenFromProps(e)),
          n = this.props;
      n.exclusive && Object.keys(this.currentlyAnimatingKeys).forEach(function (e) {
        t.stop(e);
      });
      var r = n.showProp,
          l = this.currentlyAnimatingKeys,
          o = n.exclusive ? toArrayChildren(getChildrenFromProps(n)) : this.state.children,
          c = [];
      r ? (o.forEach(function (e) {
        var t = e && findChildInChildrenByKey(a, e.key),
            n = void 0;
        (n = t && t.props[r] || !e.props[r] ? t : React__default.cloneElement(t || e, _defineProperty({}, r, !0))) && c.push(n);
      }), a.forEach(function (e) {
        e && findChildInChildrenByKey(o, e.key) || c.push(e);
      })) : c = mergeChildren(o, a), this.setState({
        children: c
      }), a.forEach(function (e) {
        var a = e && e.key;

        if (!e || !l[a]) {
          var n = e && findChildInChildrenByKey(o, a);

          if (r) {
            var c = e.props[r];
            if (n) !findShownChildInChildrenByKey(o, a, r) && c && t.keysToEnter.push(a);else c && t.keysToEnter.push(a);
          } else n || t.keysToEnter.push(a);
        }
      }), o.forEach(function (e) {
        var n = e && e.key;

        if (!e || !l[n]) {
          var o = e && findChildInChildrenByKey(a, n);

          if (r) {
            var c = e.props[r];
            if (o) !findShownChildInChildrenByKey(a, n, r) && c && t.keysToLeave.push(n);else c && t.keysToLeave.push(n);
          } else o || t.keysToLeave.push(n);
        }
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function value() {
      var e = this.keysToEnter;
      this.keysToEnter = [], e.forEach(this.performEnter);
      var t = this.keysToLeave;
      this.keysToLeave = [], t.forEach(this.performLeave);
    }
  }, {
    key: "isValidChildByKey",
    value: function value(e, t) {
      var a = this.props.showProp;
      return a ? findShownChildInChildrenByKey(e, t, a) : findChildInChildrenByKey(e, t);
    }
  }, {
    key: "stop",
    value: function value(e) {
      delete this.currentlyAnimatingKeys[e];
      var t = this.childrenRefs[e];
      t && t.stop();
    }
  }, {
    key: "render",
    value: function value() {
      var e = this,
          t = this.props;
      this.nextProps = t;
      var a = this.state.children,
          n = null;
      a && (n = a.map(function (a) {
        if (null === a || void 0 === a) return a;
        if (!a.key) throw new Error("must set key for <rc-animate> children");
        return React__default.createElement(AnimateChild, {
          key: a.key,
          ref: function ref(t) {
            return e.childrenRefs[a.key] = t;
          },
          animation: t.animation,
          transitionName: t.transitionName,
          transitionEnter: t.transitionEnter,
          transitionAppear: t.transitionAppear,
          transitionLeave: t.transitionLeave
        }, a);
      }));
      var r = t.component;

      if (r) {
        var l = t;
        return "string" == typeof r && (l = _extends$110({
          className: t.className,
          style: t.style
        }, t.componentProps)), React__default.createElement(r, l, n);
      }

      return n[0] || null;
    }
  }]), t;
}(React__default.Component);

Animate.isAnimate = !0, Animate.propTypes = {
  component: PropTypes.any,
  componentProps: PropTypes.object,
  animation: PropTypes.object,
  transitionName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  transitionEnter: PropTypes.bool,
  transitionAppear: PropTypes.bool,
  exclusive: PropTypes.bool,
  transitionLeave: PropTypes.bool,
  onEnd: PropTypes.func,
  onEnter: PropTypes.func,
  onLeave: PropTypes.func,
  onAppear: PropTypes.func,
  showProp: PropTypes.string
}, Animate.defaultProps = {
  animation: {},
  component: "span",
  componentProps: {},
  transitionEnter: !0,
  transitionLeave: !0,
  transitionAppear: !1,
  onEnd: noop$1,
  onEnter: noop$1,
  onLeave: noop$1,
  onAppear: noop$1
};

var _initialiseProps$1 = function _initialiseProps$1() {
  var e = this;
  this.performEnter = function (t) {
    e.childrenRefs[t] && (e.currentlyAnimatingKeys[t] = !0, e.childrenRefs[t].componentWillEnter(e.handleDoneAdding.bind(e, t, "enter")));
  }, this.performAppear = function (t) {
    e.childrenRefs[t] && (e.currentlyAnimatingKeys[t] = !0, e.childrenRefs[t].componentWillAppear(e.handleDoneAdding.bind(e, t, "appear")));
  }, this.handleDoneAdding = function (t, a) {
    var n = e.props;

    if (delete e.currentlyAnimatingKeys[t], !n.exclusive || n === e.nextProps) {
      var r = toArrayChildren(getChildrenFromProps(n));
      e.isValidChildByKey(r, t) ? "appear" === a ? util$2.allowAppearCallback(n) && (n.onAppear(t), n.onEnd(t, !0)) : util$2.allowEnterCallback(n) && (n.onEnter(t), n.onEnd(t, !0)) : e.performLeave(t);
    }
  }, this.performLeave = function (t) {
    e.childrenRefs[t] && (e.currentlyAnimatingKeys[t] = !0, e.childrenRefs[t].componentWillLeave(e.handleDoneLeaving.bind(e, t)));
  }, this.handleDoneLeaving = function (t) {
    var a = e.props;

    if (delete e.currentlyAnimatingKeys[t], !a.exclusive || a === e.nextProps) {
      var n = toArrayChildren(getChildrenFromProps(a));
      if (e.isValidChildByKey(n, t)) e.performEnter(t);else {
        var r = function r() {
          util$2.allowLeaveCallback(a) && (a.onLeave(t), a.onEnd(t, !1));
        };

        isSameChildren(e.state.children, n, a.showProp) ? r() : e.setState({
          children: n
        }, r);
      }
    }
  };
},
    LazyRenderBox = function (e) {
  function t() {
    return _classCallCheck(this, t), _possibleConstructorReturn(this, e.apply(this, arguments));
  }

  return _inherits(t, e), t.prototype.shouldComponentUpdate = function (e) {
    return e.hiddenClassName || e.visible;
  }, t.prototype.render = function () {
    var e = this.props,
        t = e.hiddenClassName,
        a = e.visible,
        n = _objectWithoutProperties$107(e, ["hiddenClassName", "visible"]);

    return t || React__default.Children.count(n.children) > 1 ? (!a && t && (n.className += " " + t), React__default.createElement("div", n)) : React__default.Children.only(n.children);
  }, t;
}(React.Component);

LazyRenderBox.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  visible: PropTypes.bool,
  hiddenClassName: PropTypes.string
};

var PopupInner = function (e) {
  function t() {
    return _classCallCheck(this, t), _possibleConstructorReturn(this, e.apply(this, arguments));
  }

  return _inherits(t, e), t.prototype.render = function () {
    var e = this.props,
        t = e.className;
    return e.visible || (t += " " + e.hiddenClassName), React__default.createElement("div", {
      className: t,
      onMouseEnter: e.onMouseEnter,
      onMouseLeave: e.onMouseLeave,
      style: e.style
    }, React__default.createElement(LazyRenderBox, {
      className: e.prefixCls + "-content",
      visible: e.visible
    }, e.children));
  }, t;
}(React.Component);

function isPointsEq(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}

function getAlignFromPlacement(e, t, a) {
  var n = e[t] || {};
  return _extends$110({}, n, a);
}

function getPopupClassNameFromAlign(e, t, a) {
  var n = a.points;

  for (var r in e) {
    if (e.hasOwnProperty(r) && isPointsEq(e[r].points, n)) return t + "-placement-" + r;
  }

  return "";
}

function saveRef(e, t) {
  this[e] = t;
}

PopupInner.propTypes = {
  hiddenClassName: PropTypes.string,
  className: PropTypes.string,
  prefixCls: PropTypes.string,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  children: PropTypes.any
};

var Popup = function (e) {
  function t(a) {
    _classCallCheck(this, t);

    var n = _possibleConstructorReturn(this, e.call(this, a));

    return _initialiseProps$2.call(n), n.state = {
      stretchChecked: !1,
      targetWidth: void 0,
      targetHeight: void 0
    }, n.savePopupRef = saveRef.bind(n, "popupInstance"), n.saveAlignRef = saveRef.bind(n, "alignInstance"), n;
  }

  return _inherits(t, e), t.prototype.componentDidMount = function () {
    this.rootNode = this.getPopupDomNode(), this.setStretchSize();
  }, t.prototype.componentDidUpdate = function () {
    this.setStretchSize();
  }, t.prototype.getPopupDomNode = function () {
    return ReactDOM__default.findDOMNode(this.popupInstance);
  }, t.prototype.getMaskTransitionName = function () {
    var e = this.props,
        t = e.maskTransitionName,
        a = e.maskAnimation;
    return !t && a && (t = e.prefixCls + "-" + a), t;
  }, t.prototype.getTransitionName = function () {
    var e = this.props,
        t = e.transitionName;
    return !t && e.animation && (t = e.prefixCls + "-" + e.animation), t;
  }, t.prototype.getClassName = function (e) {
    return this.props.prefixCls + " " + this.props.className + " " + e;
  }, t.prototype.getPopupElement = function () {
    var e = this,
        t = this.savePopupRef,
        a = this.state,
        n = a.stretchChecked,
        r = a.targetHeight,
        l = a.targetWidth,
        o = this.props,
        c = o.align,
        i = o.visible,
        s = o.prefixCls,
        u = o.style,
        f = o.getClassNameFromAlign,
        d = o.destroyPopupOnHide,
        p = o.stretch,
        h = o.children,
        m = o.onMouseEnter,
        _ = o.onMouseLeave,
        v = this.getClassName(this.currentAlignClassName || f(c)),
        y = s + "-hidden";
    i || (this.currentAlignClassName = null);
    var g = {};
    p && (-1 !== p.indexOf("height") ? g.height = r : -1 !== p.indexOf("minHeight") && (g.minHeight = r), -1 !== p.indexOf("width") ? g.width = l : -1 !== p.indexOf("minWidth") && (g.minWidth = l), n || (g.visibility = "hidden", setTimeout(function () {
      e.alignInstance.forceAlign();
    }, 0)));
    var E = {
      className: v,
      prefixCls: s,
      ref: t,
      onMouseEnter: m,
      onMouseLeave: _,
      style: _extends$110({}, g, u, this.getZIndexStyle())
    };
    return d ? React__default.createElement(Animate, {
      component: "",
      exclusive: !0,
      transitionAppear: !0,
      transitionName: this.getTransitionName()
    }, i ? React__default.createElement(Align, {
      target: this.getTarget,
      key: "popup",
      ref: this.saveAlignRef,
      monitorWindowResize: !0,
      align: c,
      onAlign: this.onAlign
    }, React__default.createElement(PopupInner, _extends$110({
      visible: !0
    }, E), h)) : null) : React__default.createElement(Animate, {
      component: "",
      exclusive: !0,
      transitionAppear: !0,
      transitionName: this.getTransitionName(),
      showProp: "xVisible"
    }, React__default.createElement(Align, {
      target: this.getTarget,
      key: "popup",
      ref: this.saveAlignRef,
      monitorWindowResize: !0,
      xVisible: i,
      childrenProps: {
        visible: "xVisible"
      },
      disabled: !i,
      align: c,
      onAlign: this.onAlign
    }, React__default.createElement(PopupInner, _extends$110({
      hiddenClassName: y
    }, E), h)));
  }, t.prototype.getZIndexStyle = function () {
    var e = {},
        t = this.props;
    return void 0 !== t.zIndex && (e.zIndex = t.zIndex), e;
  }, t.prototype.getMaskElement = function () {
    var e = this.props,
        t = void 0;

    if (e.mask) {
      var a = this.getMaskTransitionName();
      t = React__default.createElement(LazyRenderBox, {
        style: this.getZIndexStyle(),
        key: "mask",
        className: e.prefixCls + "-mask",
        hiddenClassName: e.prefixCls + "-mask-hidden",
        visible: e.visible
      }), a && (t = React__default.createElement(Animate, {
        key: "mask",
        showProp: "visible",
        transitionAppear: !0,
        component: "",
        transitionName: a
      }, t));
    }

    return t;
  }, t.prototype.render = function () {
    return React__default.createElement("div", null, this.getMaskElement(), this.getPopupElement());
  }, t;
}(React.Component);

Popup.propTypes = {
  visible: PropTypes.bool,
  style: PropTypes.object,
  getClassNameFromAlign: PropTypes.func,
  onAlign: PropTypes.func,
  getRootDomNode: PropTypes.func,
  onMouseEnter: PropTypes.func,
  align: PropTypes.any,
  destroyPopupOnHide: PropTypes.bool,
  className: PropTypes.string,
  prefixCls: PropTypes.string,
  onMouseLeave: PropTypes.func,
  stretch: PropTypes.string,
  children: PropTypes.node
};

var _initialiseProps$2 = function _initialiseProps$2() {
  var e = this;
  this.onAlign = function (t, a) {
    var n = e.props,
        r = n.getClassNameFromAlign(a);
    e.currentAlignClassName !== r && (e.currentAlignClassName = r, t.className = e.getClassName(r)), n.onAlign(t, a);
  }, this.setStretchSize = function () {
    var t = e.props,
        a = t.stretch,
        n = t.getRootDomNode,
        r = t.visible,
        l = e.state,
        o = l.stretchChecked,
        c = l.targetHeight,
        i = l.targetWidth;

    if (a && r) {
      var s = n();

      if (s) {
        var u = s.offsetHeight,
            f = s.offsetWidth;
        c === u && i === f && o || e.setState({
          stretchChecked: !0,
          targetHeight: u,
          targetWidth: f
        });
      }
    } else o && e.setState({
      stretchChecked: !1
    });
  }, this.getTarget = function () {
    return e.props.getRootDomNode();
  };
},
    ContainerRender = function (e) {
  function t() {
    var e, a, n;

    _classCallCheck(this, t);

    for (var r = arguments.length, l = Array(r), o = 0; o < r; o++) {
      l[o] = arguments[o];
    }

    return a = n = _possibleConstructorReturn(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), n.removeContainer = function () {
      n.container && (ReactDOM__default.unmountComponentAtNode(n.container), n.container.parentNode.removeChild(n.container), n.container = null);
    }, n.renderComponent = function (e, t) {
      var a = n.props,
          r = a.visible,
          l = a.getComponent,
          o = a.forceRender,
          c = a.getContainer,
          i = a.parent;
      (r || i._component || o) && (n.container || (n.container = c()), ReactDOM__default.unstable_renderSubtreeIntoContainer(i, l(e), n.container, function () {
        t && t.call(this);
      }));
    }, _possibleConstructorReturn(n, a);
  }

  return _inherits(t, e), _createClass(t, [{
    key: "componentDidMount",
    value: function value() {
      this.props.autoMount && this.renderComponent();
    }
  }, {
    key: "componentDidUpdate",
    value: function value() {
      this.props.autoMount && this.renderComponent();
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.props.autoDestroy && this.removeContainer();
    }
  }, {
    key: "render",
    value: function value() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]), t;
}(React__default.Component);

ContainerRender.propTypes = {
  autoMount: PropTypes.bool,
  autoDestroy: PropTypes.bool,
  visible: PropTypes.bool,
  forceRender: PropTypes.bool,
  parent: PropTypes.any,
  getComponent: PropTypes.func.isRequired,
  getContainer: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired
}, ContainerRender.defaultProps = {
  autoMount: !0,
  autoDestroy: !0,
  forceRender: !1
};

var Portal = function (e) {
  function t() {
    return _classCallCheck(this, t), _possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
  }

  return _inherits(t, e), _createClass(t, [{
    key: "componentDidMount",
    value: function value() {
      this.createContainer();
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e) {
      var t = this.props.didUpdate;
      t && t(e);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.removeContainer();
    }
  }, {
    key: "createContainer",
    value: function value() {
      this._container = this.props.getContainer(), this.forceUpdate();
    }
  }, {
    key: "removeContainer",
    value: function value() {
      this._container && this._container.parentNode.removeChild(this._container);
    }
  }, {
    key: "render",
    value: function value() {
      return this._container ? ReactDOM__default.createPortal(this.props.children, this._container) : null;
    }
  }]), t;
}(React__default.Component);

function noop$2() {}

function returnEmptyString() {
  return "";
}

function returnDocument() {
  return window.document;
}

Portal.propTypes = {
  getContainer: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  didUpdate: PropTypes.func
};

var ALL_HANDLERS = ["onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur", "onContextMenu"],
    IS_REACT_16 = !!ReactDOM.createPortal,
    Trigger = function (e) {
  function t(a) {
    _classCallCheck(this, t);

    var n = _possibleConstructorReturn(this, e.call(this, a));

    _initialiseProps$3.call(n);

    var r = void 0;
    return r = "popupVisible" in a ? !!a.popupVisible : !!a.defaultPopupVisible, n.prevPopupVisible = r, n.state = {
      popupVisible: r
    }, n;
  }

  return _inherits(t, e), t.prototype.componentWillMount = function () {
    var e = this;
    ALL_HANDLERS.forEach(function (t) {
      e["fire" + t] = function (a) {
        e.fireEvents(t, a);
      };
    });
  }, t.prototype.componentDidMount = function () {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  }, t.prototype.componentWillReceiveProps = function (e) {
    var t = e.popupVisible;
    void 0 !== t && this.setState({
      popupVisible: t
    });
  }, t.prototype.componentDidUpdate = function (e, t) {
    var a = this.props,
        n = this.state;

    if (IS_REACT_16 || this.renderComponent(null, function () {
      t.popupVisible !== n.popupVisible && a.afterPopupVisibleChange(n.popupVisible);
    }), this.prevPopupVisible = t.popupVisible, n.popupVisible) {
      var r = void 0;
      return this.clickOutsideHandler || !this.isClickToHide() && !this.isContextMenuToShow() || (r = a.getDocument(), this.clickOutsideHandler = addEventListenerWrap(r, "mousedown", this.onDocumentClick)), this.touchOutsideHandler || (r = r || a.getDocument(), this.touchOutsideHandler = addEventListenerWrap(r, "touchstart", this.onDocumentClick)), !this.contextMenuOutsideHandler1 && this.isContextMenuToShow() && (r = r || a.getDocument(), this.contextMenuOutsideHandler1 = addEventListenerWrap(r, "scroll", this.onContextMenuClose)), void (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow() && (this.contextMenuOutsideHandler2 = addEventListenerWrap(window, "blur", this.onContextMenuClose)));
    }

    this.clearOutsideHandler();
  }, t.prototype.componentWillUnmount = function () {
    this.clearDelayTimer(), this.clearOutsideHandler();
  }, t.prototype.getPopupDomNode = function () {
    return this._component && this._component.getPopupDomNode ? this._component.getPopupDomNode() : null;
  }, t.prototype.getPopupAlign = function () {
    var e = this.props,
        t = e.popupPlacement,
        a = e.popupAlign,
        n = e.builtinPlacements;
    return t && n ? getAlignFromPlacement(n, t, a) : a;
  }, t.prototype.setPopupVisible = function (e) {
    this.clearDelayTimer(), this.state.popupVisible !== e && ("popupVisible" in this.props || this.setState({
      popupVisible: e
    }), this.props.onPopupVisibleChange(e));
  }, t.prototype.delaySetPopupVisible = function (e, t) {
    var a = this,
        n = 1e3 * t;
    this.clearDelayTimer(), n ? this.delayTimer = setTimeout(function () {
      a.setPopupVisible(e), a.clearDelayTimer();
    }, n) : this.setPopupVisible(e);
  }, t.prototype.clearDelayTimer = function () {
    this.delayTimer && (clearTimeout(this.delayTimer), this.delayTimer = null);
  }, t.prototype.clearOutsideHandler = function () {
    this.clickOutsideHandler && (this.clickOutsideHandler.remove(), this.clickOutsideHandler = null), this.contextMenuOutsideHandler1 && (this.contextMenuOutsideHandler1.remove(), this.contextMenuOutsideHandler1 = null), this.contextMenuOutsideHandler2 && (this.contextMenuOutsideHandler2.remove(), this.contextMenuOutsideHandler2 = null), this.touchOutsideHandler && (this.touchOutsideHandler.remove(), this.touchOutsideHandler = null);
  }, t.prototype.createTwoChains = function (e) {
    var t = this.props.children.props,
        a = this.props;
    return t[e] && a[e] ? this["fire" + e] : t[e] || a[e];
  }, t.prototype.isClickToShow = function () {
    var e = this.props,
        t = e.action,
        a = e.showAction;
    return -1 !== t.indexOf("click") || -1 !== a.indexOf("click");
  }, t.prototype.isContextMenuToShow = function () {
    var e = this.props,
        t = e.action,
        a = e.showAction;
    return -1 !== t.indexOf("contextMenu") || -1 !== a.indexOf("contextMenu");
  }, t.prototype.isClickToHide = function () {
    var e = this.props,
        t = e.action,
        a = e.hideAction;
    return -1 !== t.indexOf("click") || -1 !== a.indexOf("click");
  }, t.prototype.isMouseEnterToShow = function () {
    var e = this.props,
        t = e.action,
        a = e.showAction;
    return -1 !== t.indexOf("hover") || -1 !== a.indexOf("mouseEnter");
  }, t.prototype.isMouseLeaveToHide = function () {
    var e = this.props,
        t = e.action,
        a = e.hideAction;
    return -1 !== t.indexOf("hover") || -1 !== a.indexOf("mouseLeave");
  }, t.prototype.isFocusToShow = function () {
    var e = this.props,
        t = e.action,
        a = e.showAction;
    return -1 !== t.indexOf("focus") || -1 !== a.indexOf("focus");
  }, t.prototype.isBlurToHide = function () {
    var e = this.props,
        t = e.action,
        a = e.hideAction;
    return -1 !== t.indexOf("focus") || -1 !== a.indexOf("blur");
  }, t.prototype.forcePopupAlign = function () {
    this.state.popupVisible && this._component && this._component.alignInstance && this._component.alignInstance.forceAlign();
  }, t.prototype.fireEvents = function (e, t) {
    var a = this.props.children.props[e];
    a && a(t);
    var n = this.props[e];
    n && n(t);
  }, t.prototype.close = function () {
    this.setPopupVisible(!1);
  }, t.prototype.render = function () {
    var e = this,
        t = this.state.popupVisible,
        a = this.props,
        n = a.children,
        r = React__default.Children.only(n),
        l = {
      key: "trigger"
    };
    this.isContextMenuToShow() ? l.onContextMenu = this.onContextMenu : l.onContextMenu = this.createTwoChains("onContextMenu"), this.isClickToHide() || this.isClickToShow() ? (l.onClick = this.onClick, l.onMouseDown = this.onMouseDown, l.onTouchStart = this.onTouchStart) : (l.onClick = this.createTwoChains("onClick"), l.onMouseDown = this.createTwoChains("onMouseDown"), l.onTouchStart = this.createTwoChains("onTouchStart")), this.isMouseEnterToShow() ? l.onMouseEnter = this.onMouseEnter : l.onMouseEnter = this.createTwoChains("onMouseEnter"), this.isMouseLeaveToHide() ? l.onMouseLeave = this.onMouseLeave : l.onMouseLeave = this.createTwoChains("onMouseLeave"), this.isFocusToShow() || this.isBlurToHide() ? (l.onFocus = this.onFocus, l.onBlur = this.onBlur) : (l.onFocus = this.createTwoChains("onFocus"), l.onBlur = this.createTwoChains("onBlur"));
    var o = React__default.cloneElement(r, l);
    if (!IS_REACT_16) return React__default.createElement(ContainerRender, {
      parent: this,
      visible: t,
      autoMount: !1,
      forceRender: a.forceRender,
      getComponent: this.getComponent,
      getContainer: this.getContainer
    }, function (t) {
      var a = t.renderComponent;
      return e.renderComponent = a, o;
    });
    var c = void 0;
    return (t || this._component || a.forceRender) && (c = React__default.createElement(Portal, {
      key: "portal",
      getContainer: this.getContainer,
      didUpdate: this.handlePortalUpdate
    }, this.getComponent())), [o, c];
  }, t;
}(React__default.Component);

Trigger.propTypes = {
  children: PropTypes.any,
  action: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  showAction: PropTypes.any,
  hideAction: PropTypes.any,
  getPopupClassNameFromAlign: PropTypes.any,
  onPopupVisibleChange: PropTypes.func,
  afterPopupVisibleChange: PropTypes.func,
  popup: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  popupStyle: PropTypes.object,
  prefixCls: PropTypes.string,
  popupClassName: PropTypes.string,
  popupPlacement: PropTypes.string,
  builtinPlacements: PropTypes.object,
  popupTransitionName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  popupAnimation: PropTypes.any,
  mouseEnterDelay: PropTypes.number,
  mouseLeaveDelay: PropTypes.number,
  zIndex: PropTypes.number,
  focusDelay: PropTypes.number,
  blurDelay: PropTypes.number,
  getPopupContainer: PropTypes.func,
  getDocument: PropTypes.func,
  forceRender: PropTypes.bool,
  destroyPopupOnHide: PropTypes.bool,
  mask: PropTypes.bool,
  maskClosable: PropTypes.bool,
  onPopupAlign: PropTypes.func,
  popupAlign: PropTypes.object,
  popupVisible: PropTypes.bool,
  defaultPopupVisible: PropTypes.bool,
  maskTransitionName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  maskAnimation: PropTypes.string,
  stretch: PropTypes.string
}, Trigger.defaultProps = {
  prefixCls: "rc-trigger-popup",
  getPopupClassNameFromAlign: returnEmptyString,
  getDocument: returnDocument,
  onPopupVisibleChange: noop$2,
  afterPopupVisibleChange: noop$2,
  onPopupAlign: noop$2,
  popupClassName: "",
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: !1,
  popupAlign: {},
  defaultPopupVisible: !1,
  mask: !1,
  maskClosable: !0,
  action: [],
  showAction: [],
  hideAction: []
};

var _initialiseProps$3 = function _initialiseProps$3() {
  var e = this;
  this.onMouseEnter = function (t) {
    e.fireEvents("onMouseEnter", t), e.delaySetPopupVisible(!0, e.props.mouseEnterDelay);
  }, this.onMouseLeave = function (t) {
    e.fireEvents("onMouseLeave", t), e.delaySetPopupVisible(!1, e.props.mouseLeaveDelay);
  }, this.onPopupMouseEnter = function () {
    e.clearDelayTimer();
  }, this.onPopupMouseLeave = function (t) {
    t.relatedTarget && !t.relatedTarget.setTimeout && e._component && e._component.getPopupDomNode && contains(e._component.getPopupDomNode(), t.relatedTarget) || e.delaySetPopupVisible(!1, e.props.mouseLeaveDelay);
  }, this.onFocus = function (t) {
    e.fireEvents("onFocus", t), e.clearDelayTimer(), e.isFocusToShow() && (e.focusTime = Date.now(), e.delaySetPopupVisible(!0, e.props.focusDelay));
  }, this.onMouseDown = function (t) {
    e.fireEvents("onMouseDown", t), e.preClickTime = Date.now();
  }, this.onTouchStart = function (t) {
    e.fireEvents("onTouchStart", t), e.preTouchTime = Date.now();
  }, this.onBlur = function (t) {
    e.fireEvents("onBlur", t), e.clearDelayTimer(), e.isBlurToHide() && e.delaySetPopupVisible(!1, e.props.blurDelay);
  }, this.onContextMenu = function (t) {
    t.preventDefault(), e.fireEvents("onContextMenu", t), e.setPopupVisible(!0);
  }, this.onContextMenuClose = function () {
    e.isContextMenuToShow() && e.close();
  }, this.onClick = function (t) {
    if (e.fireEvents("onClick", t), e.focusTime) {
      var a = void 0;
      if (e.preClickTime && e.preTouchTime ? a = Math.min(e.preClickTime, e.preTouchTime) : e.preClickTime ? a = e.preClickTime : e.preTouchTime && (a = e.preTouchTime), Math.abs(a - e.focusTime) < 20) return;
      e.focusTime = 0;
    }

    e.preClickTime = 0, e.preTouchTime = 0, t.preventDefault();
    var n = !e.state.popupVisible;
    (e.isClickToHide() && !n || n && e.isClickToShow()) && e.setPopupVisible(!e.state.popupVisible);
  }, this.onDocumentClick = function (t) {
    if (!e.props.mask || e.props.maskClosable) {
      var a = t.target,
          n = ReactDOM.findDOMNode(e),
          r = e.getPopupDomNode();
      contains(n, a) || contains(r, a) || e.close();
    }
  }, this.getRootDomNode = function () {
    return ReactDOM.findDOMNode(e);
  }, this.getPopupClassNameFromAlign = function (t) {
    var a = [],
        n = e.props,
        r = n.popupPlacement,
        l = n.builtinPlacements,
        o = n.prefixCls;
    return r && l && a.push(getPopupClassNameFromAlign(l, o, t)), n.getPopupClassNameFromAlign && a.push(n.getPopupClassNameFromAlign(t)), a.join(" ");
  }, this.getComponent = function () {
    var t = e.props,
        a = t.prefixCls,
        n = t.destroyPopupOnHide,
        r = t.popupClassName,
        l = t.action,
        o = t.onPopupAlign,
        c = t.popupAnimation,
        i = t.popupTransitionName,
        s = t.popupStyle,
        u = t.mask,
        f = t.maskAnimation,
        d = t.maskTransitionName,
        p = t.zIndex,
        h = t.popup,
        m = t.stretch,
        _ = e.state,
        v = e.getPopupAlign(),
        y = {};
    return e.isMouseEnterToShow() && (y.onMouseEnter = e.onPopupMouseEnter), e.isMouseLeaveToHide() && (y.onMouseLeave = e.onPopupMouseLeave), React__default.createElement(Popup, _extends$110({
      prefixCls: a,
      destroyPopupOnHide: n,
      visible: _.popupVisible,
      className: r,
      action: l,
      align: v,
      onAlign: o,
      animation: c,
      getClassNameFromAlign: e.getPopupClassNameFromAlign
    }, y, {
      stretch: m,
      getRootDomNode: e.getRootDomNode,
      style: s,
      mask: u,
      zIndex: p,
      transitionName: i,
      maskAnimation: f,
      maskTransitionName: d,
      ref: e.savePopup
    }), "function" == typeof h ? h() : h);
  }, this.getContainer = function () {
    var t = e.props,
        a = document.createElement("div");
    return a.style.position = "absolute", a.style.top = "0", a.style.left = "0", a.style.width = "100%", (t.getPopupContainer ? t.getPopupContainer(ReactDOM.findDOMNode(e)) : t.getDocument().body).appendChild(a), a;
  }, this.handlePortalUpdate = function () {
    e.prevPopupVisible !== e.state.popupVisible && e.props.afterPopupVisibleChange(e.state.popupVisible);
  }, this.savePopup = function (t) {
    e._component = t;
  };
},
    autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
},
    targetOffset = [0, 0],
    placements = {
  left: {
    points: ["cr", "cl"],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ["cl", "cr"],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ["bc", "tc"],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
},
    Content = function (e) {
  function t() {
    return _classCallCheck(this, t), _possibleConstructorReturn(this, e.apply(this, arguments));
  }

  return _inherits(t, e), t.prototype.componentDidUpdate = function () {
    var e = this.props.trigger;
    e && e.forcePopupAlign();
  }, t.prototype.render = function () {
    var e = this.props,
        t = e.overlay,
        a = e.prefixCls,
        n = e.id;
    return React__default.createElement("div", {
      className: a + "-inner",
      id: n
    }, "function" == typeof t ? t() : t);
  }, t;
}(React__default.Component);

Content.propTypes = {
  prefixCls: PropTypes.string,
  overlay: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  id: PropTypes.string,
  trigger: PropTypes.any
};

var Tooltip = function (e) {
  function t() {
    var a, n;

    _classCallCheck(this, t);

    for (var r = arguments.length, l = Array(r), o = 0; o < r; o++) {
      l[o] = arguments[o];
    }

    return a = n = _possibleConstructorReturn(this, e.call.apply(e, [this].concat(l))), n.getPopupElement = function () {
      var e = n.props,
          t = e.arrowContent,
          a = e.overlay,
          r = e.prefixCls,
          l = e.id;
      return [React__default.createElement("div", {
        className: r + "-arrow",
        key: "arrow"
      }, t), React__default.createElement(Content, {
        key: "content",
        trigger: n.trigger,
        prefixCls: r,
        id: l,
        overlay: a
      })];
    }, n.saveTrigger = function (e) {
      n.trigger = e;
    }, _possibleConstructorReturn(n, a);
  }

  return _inherits(t, e), t.prototype.getPopupDomNode = function () {
    return this.trigger.getPopupDomNode();
  }, t.prototype.render = function () {
    var e = this.props,
        t = e.overlayClassName,
        a = e.trigger,
        n = e.mouseEnterDelay,
        r = e.mouseLeaveDelay,
        l = e.overlayStyle,
        o = e.prefixCls,
        c = e.children,
        i = e.onVisibleChange,
        s = e.afterVisibleChange,
        u = e.transitionName,
        f = e.animation,
        d = e.placement,
        p = e.align,
        h = e.destroyTooltipOnHide,
        m = e.defaultVisible,
        _ = e.getTooltipContainer,
        v = _objectWithoutProperties$107(e, ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer"]),
        y = _extends$110({}, v);

    return "visible" in this.props && (y.popupVisible = this.props.visible), React__default.createElement(Trigger, _extends$110({
      popupClassName: t,
      ref: this.saveTrigger,
      prefixCls: o,
      popup: this.getPopupElement,
      action: a,
      builtinPlacements: placements,
      popupPlacement: d,
      popupAlign: p,
      getPopupContainer: _,
      onPopupVisibleChange: i,
      afterPopupVisibleChange: s,
      popupTransitionName: u,
      popupAnimation: f,
      defaultPopupVisible: m,
      destroyPopupOnHide: h,
      mouseLeaveDelay: r,
      popupStyle: l,
      mouseEnterDelay: n
    }, y), c);
  }, t;
}(React.Component);

Tooltip.propTypes = {
  trigger: PropTypes.any,
  children: PropTypes.any,
  defaultVisible: PropTypes.bool,
  visible: PropTypes.bool,
  placement: PropTypes.string,
  transitionName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  animation: PropTypes.any,
  onVisibleChange: PropTypes.func,
  afterVisibleChange: PropTypes.func,
  overlay: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  overlayStyle: PropTypes.object,
  overlayClassName: PropTypes.string,
  prefixCls: PropTypes.string,
  mouseEnterDelay: PropTypes.number,
  mouseLeaveDelay: PropTypes.number,
  getTooltipContainer: PropTypes.func,
  destroyTooltipOnHide: PropTypes.bool,
  align: PropTypes.object,
  arrowContent: PropTypes.any,
  id: PropTypes.string
}, Tooltip.defaultProps = {
  prefixCls: "rc-tooltip",
  mouseEnterDelay: 0,
  destroyTooltipOnHide: !1,
  mouseLeaveDelay: 0.1,
  align: {},
  placement: "right",
  trigger: ["hover"],
  arrowContent: null
};

var _templateObject$19 = taggedTemplateLiteral(["\n\tposition: absolute;\n\tz-index: 1070;\n\tdisplay: block;\n\tvisibility: visible;\n\tline-height: 1.5;\n\tfont-size: 12px;\n\tpadding: 1px;\n\t&.rc-tooltip-hidden {\n\t\tdisplay: none;\n\t}\n\t.rc-tooltip-arrow,\n\t.rc-tooltip-arrow-inner {\n\t\tposition: absolute;\n\t}\n\t.rc-tooltip-inner {\n\t\tcolor: ", ";\n\t\tbackground-color: ", ";\n\t\tpadding: 8px 10px;\n\t\ttext-align: left;\n\t\ttext-decoration: none;\n\t\tborder-radius: 4px;\n\t\tborder-width: 1px;\n\t\tborder-style: solid;\n\t\tborder-color: ", ";\n\t\tbox-shadow: 0 2px 0 0 rgba(0, 10, 30, 0.06);\n\t}\n\t.rc-tooltip-arrow {\n\t\tborder: 0 none;\n\t\tbottom: 0;\n\t\ttransform: translate(-50%, 100%) scaleX(1.5);\n\t\tline-height: 0.4;\n\t\tleft: 50%;\n\t\ttext-shadow: ", ' 0 2px,\n\t\t\trgba(0, 10, 30, 0.06) 0 4px 0px;\n\t\tpointer-events: none;\n\t\t&:after {\n\t\t\tcontent: "▼";\n\t\t\tcolor: white;\n\t\t\tuser-select: none;\n\t\t}\n\t}\n\t.rc-tooltip-arrow-inner {\n\t\tbottom: ', "px;\n\t\tmargin-left: ", "px;\n\t\tborder-width: ", "px ", "px 0;\n\t\tborder-top-color: ", ";\n\t}\n"], ["\n\tposition: absolute;\n\tz-index: 1070;\n\tdisplay: block;\n\tvisibility: visible;\n\tline-height: 1.5;\n\tfont-size: 12px;\n\tpadding: 1px;\n\t&.rc-tooltip-hidden {\n\t\tdisplay: none;\n\t}\n\t.rc-tooltip-arrow,\n\t.rc-tooltip-arrow-inner {\n\t\tposition: absolute;\n\t}\n\t.rc-tooltip-inner {\n\t\tcolor: ", ";\n\t\tbackground-color: ", ";\n\t\tpadding: 8px 10px;\n\t\ttext-align: left;\n\t\ttext-decoration: none;\n\t\tborder-radius: 4px;\n\t\tborder-width: 1px;\n\t\tborder-style: solid;\n\t\tborder-color: ", ";\n\t\tbox-shadow: 0 2px 0 0 rgba(0, 10, 30, 0.06);\n\t}\n\t.rc-tooltip-arrow {\n\t\tborder: 0 none;\n\t\tbottom: 0;\n\t\ttransform: translate(-50%, 100%) scaleX(1.5);\n\t\tline-height: 0.4;\n\t\tleft: 50%;\n\t\ttext-shadow: ", ' 0 2px,\n\t\t\trgba(0, 10, 30, 0.06) 0 4px 0px;\n\t\tpointer-events: none;\n\t\t&:after {\n\t\t\tcontent: "▼";\n\t\t\tcolor: white;\n\t\t\tuser-select: none;\n\t\t}\n\t}\n\t.rc-tooltip-arrow-inner {\n\t\tbottom: ', "px;\n\t\tmargin-left: ", "px;\n\t\tborder-width: ", "px ", "px 0;\n\t\tborder-top-color: ", ";\n\t}\n"]),
    TooltipStyleWrapper = function TooltipStyleWrapper(e) {
  var t = e.className,
      a = objectWithoutProperties(e, ["className"]);
  return React__default.createElement(Tooltip, _extends$107({
    overlayClassName: t
  }, a));
},
    options = {
  arrowWidth: 6,
  shadowWidth: 1,
  borderWidth: 1
},
    StyledTooltip = styled__default(TooltipStyleWrapper)(_templateObject$19, function (e) {
  return e.theme.neutralDark[4];
}, function (e) {
  return e.theme.neutralLight[7];
}, function (e) {
  return e.theme.neutralLight[4];
}, function (e) {
  return e.theme.neutralLight[4];
}, options.borderWidth, -options.arrowWidth, options.arrowWidth, options.arrowWidth, function (e) {
  return e.theme.neutralLight[7];
}),
    StyledTooltipSuppressed = function StyledTooltipSuppressed(e) {
  return React__default.createElement(StyledTooltip, _extends$107({
    suppressClassNameWarning: !0
  }, e));
},
    spring$1 = function spring$1(e) {
  return reactMotion_4(e, {
    stiffness: 250,
    damping: 25
  });
},
    styleToCSS = function styleToCSS(e) {
  var t = e.opacity;
  return {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, " + t / 2 + ")",
      zIndex: 1e4
    },
    content: {
      opacity: t,
      transform: "translateY(" + e.translateY + "%)"
    }
  };
},
    willEnter = function willEnter() {
  return {
    opacity: 0,
    translateY: -50
  };
},
    willLeave = function willLeave(e) {
  var t = e.key;
  return {
    opacity: "false" === t ? 0 : spring$1(0),
    translateY: "false" === t ? 0 : spring$1(-50)
  };
},
    MotionModal = function (e) {
  function t(e) {
    classCallCheck(this, t);
    var a = possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e)),
        n = e.isOpen ? "open" : "closed";
    return a.state = {
      key: n
    }, a;
  }

  return inherits(t, e), createClass(t, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.children,
          a = e.isOpen,
          n = e.size,
          r = objectWithoutProperties(e, ["children", "isOpen", "size"]),
          l = a.toString(),
          o = {
        isOpen: a,
        children: t,
        size: n
      };
      return React.createElement(reactMotion_3, {
        defaultStyles: [{
          key: l,
          data: o,
          style: {
            opacity: 0,
            translateY: -50
          }
        }],
        styles: [{
          key: l,
          data: o,
          style: {
            opacity: spring$1(1),
            translateY: spring$1(0)
          }
        }],
        willEnter: willEnter,
        willLeave: willLeave
      }, function (e) {
        return React.createElement("div", null, e.map(function (e) {
          var t = e.key,
              a = e.data,
              n = e.style;
          return React.createElement(StyledModal, _extends$107({
            key: t,
            style: styleToCSS(n)
          }, a, r));
        }));
      });
    }
  }]), t;
}(React.Component);

function ErrorSplash(e) {
  return React__default.createElement("svg", _extends$107({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1684.9 1078.6",
    width: "1684.9",
    height: "1078.6"
  }, e), React__default.createElement("defs", null, React__default.createElement("radialGradient", {
    id: "radial-gradient",
    cx: "827.97",
    cy: "175.68",
    r: "461.68",
    gradientTransform: "translate(0 286)",
    gradientUnits: "userSpaceOnUse"
  }, React__default.createElement("stop", {
    offset: 0,
    stopColor: "#fca360"
  }), React__default.createElement("stop", {
    offset: "0.02",
    stopColor: "#fca060"
  }), React__default.createElement("stop", {
    offset: "0.21",
    stopColor: "#f9855e"
  }), React__default.createElement("stop", {
    offset: "0.39",
    stopColor: "#f8745c"
  }), React__default.createElement("stop", {
    offset: "0.52",
    stopColor: "#f76e5c"
  })), React__default.createElement("linearGradient", {
    id: "linear-gradient",
    x1: "1374.77",
    y1: "197.84",
    x2: "1083.61",
    y2: "197.84",
    gradientTransform: "translate(-188.6 203.8)",
    gradientUnits: "userSpaceOnUse"
  }, React__default.createElement("stop", {
    offset: 0,
    stopColor: "#fb903f"
  }), React__default.createElement("stop", {
    offset: "0.18",
    stopColor: "#fb913f",
    stopOpacity: "0.99"
  }), React__default.createElement("stop", {
    offset: "0.31",
    stopColor: "#fb933f",
    stopOpacity: "0.95"
  }), React__default.createElement("stop", {
    offset: "0.44",
    stopColor: "#fb9640",
    stopOpacity: "0.88"
  }), React__default.createElement("stop", {
    offset: "0.55",
    stopColor: "#fa9b41",
    stopOpacity: "0.79"
  }), React__default.createElement("stop", {
    offset: "0.67",
    stopColor: "#faa242",
    stopOpacity: "0.67"
  }), React__default.createElement("stop", {
    offset: "0.77",
    stopColor: "#f9aa43",
    stopOpacity: "0.52"
  }), React__default.createElement("stop", {
    offset: "0.88",
    stopColor: "#f9b444",
    stopOpacity: "0.34"
  }), React__default.createElement("stop", {
    offset: "0.98",
    stopColor: "#f8be46",
    stopOpacity: "0.15"
  }), React__default.createElement("stop", {
    offset: 1,
    stopColor: "#f8c146",
    stopOpacity: "0.1"
  })), React__default.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: "8806.57",
    y1: "-6945.03",
    x2: "8542.03",
    y2: "-6945.03",
    gradientTransform: "translate(9385.7 -6587.5) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, React__default.createElement("stop", {
    offset: 0,
    stopColor: "#fb903f"
  }), React__default.createElement("stop", {
    offset: "0.15",
    stopColor: "#fb913f",
    stopOpacity: "0.99"
  }), React__default.createElement("stop", {
    offset: "0.29",
    stopColor: "#fb933f",
    stopOpacity: "0.94"
  }), React__default.createElement("stop", {
    offset: "0.42",
    stopColor: "#fb9740",
    stopOpacity: "0.87"
  }), React__default.createElement("stop", {
    offset: "0.54",
    stopColor: "#fa9d41",
    stopOpacity: "0.77"
  }), React__default.createElement("stop", {
    offset: "0.66",
    stopColor: "#faa442",
    stopOpacity: "0.64"
  }), React__default.createElement("stop", {
    offset: "0.78",
    stopColor: "#f9ac43",
    stopOpacity: "0.48"
  }), React__default.createElement("stop", {
    offset: "0.9",
    stopColor: "#f9b745",
    stopOpacity: "0.29"
  }), React__default.createElement("stop", {
    offset: 1,
    stopColor: "#f8c146",
    stopOpacity: "0.1"
  })), React__default.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1031,
    y1: "107.62",
    x2: 1031,
    y2: "311.76",
    gradientTransform: "translate(-188.6 203.8)",
    gradientUnits: "userSpaceOnUse"
  }, React__default.createElement("stop", {
    offset: 0,
    stopColor: "#696e7b"
  }), React__default.createElement("stop", {
    offset: "0.21",
    stopColor: "#6c6d7a"
  }), React__default.createElement("stop", {
    offset: "0.38",
    stopColor: "#766b75"
  }), React__default.createElement("stop", {
    offset: "0.53",
    stopColor: "#87686e"
  }), React__default.createElement("stop", {
    offset: "0.67",
    stopColor: "#9e6363"
  }), React__default.createElement("stop", {
    offset: "0.81",
    stopColor: "#bc5d55"
  }), React__default.createElement("stop", {
    offset: "0.94",
    stopColor: "#e15545"
  }), React__default.createElement("stop", {
    offset: 1,
    stopColor: "#f5513c"
  })), React__default.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: "8903.68",
    y1: "-7001.43",
    x2: "8657.93",
    y2: "-7001.43",
    gradientTransform: "translate(9385.7 -6587.5) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, React__default.createElement("stop", {
    offset: 0,
    stopColor: "#fb903f"
  }), React__default.createElement("stop", {
    offset: "0.17",
    stopColor: "#fb913f",
    stopOpacity: "0.99"
  }), React__default.createElement("stop", {
    offset: "0.31",
    stopColor: "#fb933f",
    stopOpacity: "0.95"
  }), React__default.createElement("stop", {
    offset: "0.44",
    stopColor: "#fb9640",
    stopOpacity: "0.88"
  }), React__default.createElement("stop", {
    offset: "0.55",
    stopColor: "#fa9c41",
    stopOpacity: "0.79"
  }), React__default.createElement("stop", {
    offset: "0.67",
    stopColor: "#faa242",
    stopOpacity: "0.67"
  }), React__default.createElement("stop", {
    offset: "0.77",
    stopColor: "#f9aa43",
    stopOpacity: "0.52"
  }), React__default.createElement("stop", {
    offset: "0.88",
    stopColor: "#f9b444",
    stopOpacity: "0.34"
  }), React__default.createElement("stop", {
    offset: "0.98",
    stopColor: "#f8bf46",
    stopOpacity: "0.14"
  }), React__default.createElement("stop", {
    offset: 1,
    stopColor: "#f8c146",
    stopOpacity: "0.1"
  })), React__default.createElement("clipPath", {
    id: "clip-path"
  }, React__default.createElement("path", {
    d: "M495.8,515.6c27.4-24.3,76.3-44,106.3-64.9q65.3-45.3,131-89.9c13-8.9,27.1-17.1,39.7-26.5a107.5,107.5,0,0,0,14.5-13,38.6,38.6,0,0,1,5-4.8c10.2-7.6,26.4-4.5,38.3-4.5h10.9c18.7,0,30.5,13,45,23.4q35.8,25.7,72.2,50.6c61.3,42,123.8,83.4,189.8,117.5,5.8,3,33.9,11.9,40.4,11.9H495.8Z",
    fill: "none"
  })), React__default.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: "9136.8",
    y1: "246.36",
    x2: "9552.62",
    y2: "246.36",
    gradientTransform: "matrix(-1, 0, 0, 1, 10370.12, 203.82)",
    gradientUnits: "userSpaceOnUse"
  }, React__default.createElement("stop", {
    offset: 0,
    stopColor: "#fb903f"
  }), React__default.createElement("stop", {
    offset: "0.19",
    stopColor: "#fb913f",
    stopOpacity: "0.99"
  }), React__default.createElement("stop", {
    offset: "0.33",
    stopColor: "#fb933f",
    stopOpacity: "0.95"
  }), React__default.createElement("stop", {
    offset: "0.45",
    stopColor: "#fb9640",
    stopOpacity: "0.89"
  }), React__default.createElement("stop", {
    offset: "0.56",
    stopColor: "#fa9b41",
    stopOpacity: "0.8"
  }), React__default.createElement("stop", {
    offset: "0.67",
    stopColor: "#faa141",
    stopOpacity: "0.68"
  }), React__default.createElement("stop", {
    offset: "0.77",
    stopColor: "#f9a943",
    stopOpacity: "0.54"
  }), React__default.createElement("stop", {
    offset: "0.87",
    stopColor: "#f9b244",
    stopOpacity: "0.37"
  }), React__default.createElement("stop", {
    offset: "0.97",
    stopColor: "#f8bd45",
    stopOpacity: "0.18"
  }), React__default.createElement("stop", {
    offset: 1,
    stopColor: "#f8c146",
    stopOpacity: "0.1"
  })), React__default.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: "1081.82",
    y1: "322.38",
    x2: "1081.82",
    y2: "442.25",
    gradientTransform: "translate(-188.6 203.8)",
    gradientUnits: "userSpaceOnUse"
  }, React__default.createElement("stop", {
    offset: 0,
    stopColor: "#f76e5c",
    stopOpacity: "0.6"
  }), React__default.createElement("stop", {
    offset: "0.83",
    stopColor: "#ddf0f9",
    stopOpacity: 0
  })), React__default.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: "615.96",
    y1: 494,
    x2: "615.96",
    y2: "663.16",
    gradientTransform: "translate(-188.6 203.8)",
    gradientUnits: "userSpaceOnUse"
  }, React__default.createElement("stop", {
    offset: 0,
    stopColor: "#f67362",
    stopOpacity: "0.7"
  }), React__default.createElement("stop", {
    offset: "0.07",
    stopColor: "#f18c80",
    stopOpacity: "0.56"
  }), React__default.createElement("stop", {
    offset: "0.15",
    stopColor: "#eca7a0",
    stopOpacity: "0.41"
  }), React__default.createElement("stop", {
    offset: "0.24",
    stopColor: "#e7bdbc",
    stopOpacity: "0.28"
  }), React__default.createElement("stop", {
    offset: "0.34",
    stopColor: "#e3d0d2",
    stopOpacity: "0.18"
  }), React__default.createElement("stop", {
    offset: "0.45",
    stopColor: "#e1dee4",
    stopOpacity: "0.1"
  }), React__default.createElement("stop", {
    offset: "0.57",
    stopColor: "#dfe8f0",
    stopOpacity: "0.04"
  }), React__default.createElement("stop", {
    offset: "0.73",
    stopColor: "#ddeef7",
    stopOpacity: "0.01"
  }), React__default.createElement("stop", {
    offset: 1,
    stopColor: "#ddf0f9",
    stopOpacity: 0
  })), React__default.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: "326.42",
    y1: 494,
    x2: "326.42",
    y2: "579.36",
    xlinkHref: "#linear-gradient-7"
  }), React__default.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: "8613.92",
    y1: "626.11",
    x2: "8613.92",
    y2: "665.45",
    gradientTransform: "matrix(-1, 0, 0, 1, 9116.86, 203.82)",
    gradientUnits: "userSpaceOnUse"
  }, React__default.createElement("stop", {
    offset: 0,
    stopColor: "#f67362",
    stopOpacity: "0.67"
  }), React__default.createElement("stop", {
    offset: 0,
    stopColor: "#f67160",
    stopOpacity: "0.6"
  }), React__default.createElement("stop", {
    offset: "0.01",
    stopColor: "#f76e5c",
    stopOpacity: "0.5"
  }), React__default.createElement("stop", {
    offset: 1,
    stopColor: "#ddf0f9",
    stopOpacity: 0
  })), React__default.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: "1297.57",
    y1: "495.3",
    x2: "1297.57",
    y2: "525.43",
    gradientTransform: "translate(-188.6 203.8)",
    gradientUnits: "userSpaceOnUse"
  }, React__default.createElement("stop", {
    offset: 0,
    stopColor: "#f76e5c",
    stopOpacity: "0.5"
  }), React__default.createElement("stop", {
    offset: 1,
    stopColor: "#ddf0f9",
    stopOpacity: 0
  })), React__default.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: "1519.47",
    y1: "17.22",
    x2: "1145.84",
    y2: "17.22",
    gradientTransform: "translate(-188.6 203.8)",
    gradientUnits: "userSpaceOnUse"
  }, React__default.createElement("stop", {
    offset: 0,
    stopColor: "#fb903f",
    stopOpacity: "0.8"
  }), React__default.createElement("stop", {
    offset: "0.19",
    stopColor: "#fb913f",
    stopOpacity: "0.79"
  }), React__default.createElement("stop", {
    offset: "0.35",
    stopColor: "#fb9440",
    stopOpacity: "0.75"
  }), React__default.createElement("stop", {
    offset: "0.48",
    stopColor: "#fa9840",
    stopOpacity: "0.68"
  }), React__default.createElement("stop", {
    offset: "0.61",
    stopColor: "#fa9f41",
    stopOpacity: "0.59"
  }), React__default.createElement("stop", {
    offset: "0.74",
    stopColor: "#faa742",
    stopOpacity: "0.47"
  }), React__default.createElement("stop", {
    offset: "0.86",
    stopColor: "#f9b244",
    stopOpacity: "0.32"
  }), React__default.createElement("stop", {
    offset: "0.97",
    stopColor: "#f8be46",
    stopOpacity: "0.15"
  }), React__default.createElement("stop", {
    offset: 1,
    stopColor: "#f8c146",
    stopOpacity: "0.1"
  })), React__default.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: "638.54",
    y1: "-87.13",
    x2: "926.8",
    y2: "-87.13",
    gradientTransform: "translate(-188.6 203.8)",
    gradientUnits: "userSpaceOnUse"
  }, React__default.createElement("stop", {
    offset: 0,
    stopColor: "#fb903f",
    stopOpacity: "0.6"
  }), React__default.createElement("stop", {
    offset: "0.24",
    stopColor: "#fb913f",
    stopOpacity: "0.59"
  }), React__default.createElement("stop", {
    offset: "0.41",
    stopColor: "#fb9540",
    stopOpacity: "0.55"
  }), React__default.createElement("stop", {
    offset: "0.56",
    stopColor: "#fa9b41",
    stopOpacity: "0.49"
  }), React__default.createElement("stop", {
    offset: "0.71",
    stopColor: "#faa442",
    stopOpacity: "0.4"
  }), React__default.createElement("stop", {
    offset: "0.84",
    stopColor: "#f9af43",
    stopOpacity: "0.28"
  }), React__default.createElement("stop", {
    offset: "0.97",
    stopColor: "#f8bd45",
    stopOpacity: "0.14"
  }), React__default.createElement("stop", {
    offset: 1,
    stopColor: "#f8c146",
    stopOpacity: "0.1"
  })), React__default.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: "1684.89",
    y1: "253.28",
    x2: "917.23",
    y2: "253.28",
    gradientTransform: "translate(0 286)",
    gradientUnits: "userSpaceOnUse"
  }, React__default.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), React__default.createElement("stop", {
    offset: "0.22",
    stopColor: "#fff",
    stopOpacity: "0.76"
  }), React__default.createElement("stop", {
    offset: "0.6",
    stopColor: "#fff",
    stopOpacity: "0.36"
  }), React__default.createElement("stop", {
    offset: "0.87",
    stopColor: "#fff",
    stopOpacity: "0.1"
  }), React__default.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), React__default.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: "9520.42",
    y1: "-6852.26",
    x2: "8789.08",
    y2: "-6852.26",
    gradientTransform: "translate(9520.4 -6312.2) rotate(180)",
    xlinkHref: "#linear-gradient-13"
  })), React__default.createElement("circle", {
    cx: 828,
    cy: "461.7",
    r: "461.7",
    fill: "url(#radial-gradient)"
  }), React__default.createElement("path", {
    d: "M1171,375.2H910.3a15.2,15.2,0,0,0-15.2,15.2h0a15.2,15.2,0,0,0,15.2,15.2h106.4a11.1,11.1,0,0,1,11,11.3h0a11.1,11.1,0,0,1-11,11.3h140.1a11.1,11.1,0,0,1-11-11.3h0a11.1,11.1,0,0,1,11-11.3H1171a15.2,15.2,0,0,0,15.2-15.2h0A15.2,15.2,0,0,0,1171,375.2Z",
    fill: "url(#linear-gradient)"
  }), React__default.createElement("rect", {
    x: "579.1",
    y: "337.8",
    width: "264.5",
    height: "39.48",
    rx: "19.7",
    ry: "19.7",
    fill: "url(#linear-gradient-2)"
  }), React__default.createElement("circle", {
    cx: 828,
    cy: "306.5",
    r: "120.8",
    fill: "#f5513c"
  }), React__default.createElement("path", {
    d: "M495.8,515.6c27.4-24.3,76.3-44,106.3-64.9q65.3-45.3,131-89.9c13-8.9,27.1-17.1,39.7-26.5a107.5,107.5,0,0,0,14.5-13,38.6,38.6,0,0,1,5-4.8c10.2-7.6,26.4-4.5,38.3-4.5h10.9c18.7,0,30.5,13,45,23.4q35.8,25.7,72.2,50.6c61.3,42,123.8,83.4,189.8,117.5,5.8,3,33.9,11.9,40.4,11.9H495.8Z",
    fill: "url(#linear-gradient-3)"
  }), React__default.createElement("path", {
    d: "M703.5,438.1H506.2A24.2,24.2,0,0,1,482,413.9h0a24.2,24.2,0,0,1,24.2-24.2H703.5a24.2,24.2,0,0,1,24.2,24.2h0a24.2,24.2,0,0,1-24.2,24.2Z",
    fill: "url(#linear-gradient-4)"
  }), React__default.createElement("g", {
    clipPath: "url(#clip-path)"
  }, React__default.createElement("path", {
    d: "M789.3,301.2c-10.7,2.1-21.3,6.5-29.2,14.1-5.3,5.1-9.2,11.6-14.1,17.1s-9.4,8-12.4,12.9-3.2,9.4-7,13.7-6.5,7.2-7.2,11.8a25.2,25.2,0,0,0,16.5-2.7l3.6-1.9c2.6-1.1,5.6-1.1,8.3-1.9s6.3-3.3,9.7-3.3,7.1,3,9.3,6.1,2.2,7.5,5.3,8.5,9.5-3.9,14.4-3.3,7.8,3.5,11.1,6.2a32.2,32.2,0,0,1,4.6,4.4,31.2,31.2,0,0,0,3.4,4.2,10.4,10.4,0,0,0,8.3,2.1,25.6,25.6,0,0,0,8.3-3.1,99.2,99.2,0,0,0,10.9-6.7c2.3-1.6,5.4-6.3,7.9-7s4,.9,5.5,2.3l5.5,4.9a7.1,7.1,0,0,0,3.6,2.1c2.6.3,4.6-2.2,6.9-3.5s8.4-1.1,12.4.6,7.7,4,12,4.4,9.2-2.2,9.6-6.5c.2-1.7-.5-3.5-.1-5.2s4-4.4,7-4.1,5.6,1.7,8.3,2.7a31,31,0,0,0,15.5,1.7,9.1,9.1,0,0,0,4.7-1.8c2-1.8,2.5-4.8,2.3-7.5-.5-10-6.3-19.2-13.9-25.9s-16.7-11.2-25.7-15.7l-23.3-11.5c-4.9-2.4-9.9-4.9-15.2-6.2-11.2-2.9-23.3-1.6-34.8-3.3A94.6,94.6,0,0,0,789.3,301.2Z",
    fill: "#e7e8eb"
  })), React__default.createElement("path", {
    d: "M1211.1,472.4H839.7a22.2,22.2,0,0,1-22.2-22.2h0A22.2,22.2,0,0,1,839.7,428h371.4a22.2,22.2,0,0,1,22.2,22.2h0A22.2,22.2,0,0,1,1211.1,472.4Z",
    fill: "url(#linear-gradient-5)"
  }), React__default.createElement("path", {
    d: "M1604.1,618.8H1422.3c-14.2-1.8-25.1-12.3-25.1-25h0c0-14,13.2-25.2,29.5-25.2H1470c11.8,0,21.5-8.2,21.5-18.4h0c0-10.2-9.6-18.4-21.5-18.4H233.3c-10.4,0-18.8,7.2-18.8,16.1h0c0,8.9,8.4,16.1,18.8,16.1h0c11.6,0,21,8,21,18s-9.4,18-21,18H173.9c-12.7,0-23,8.8-23,19.8h0c0,10.9,10.3,19.8,23,19.8h16c19.1,0,34.5,13.2,34.5,29.6h0c0,16.3-15.5,29.6-34.5,29.6H155c-14.2,0-25.7,9.9-25.7,22h0c0,12.2,11.5,22,25.7,22h44.4c17,2,30.1,14.4,30.1,29.5h0c0,15.5-13.7,28.2-31.4,29.7h-5.9c-20.3,0-36.7,14.1-36.7,31.5h0c0,17.4,16.4,31.5,36.8,31.5H379.1c11.6,0,21,8,21,18h0c0,9.9-9.4,18-21,18H364.4c-14.2,0-25.7,9.9-25.7,22h0c0,12.2,11.5,22,25.7,22H683.2a15.2,15.2,0,0,0-6.3,12h0c0,8.9,8.4,16.1,18.8,16.1h431c10.4,0,18.8-7.2,18.8-16.1h0c0-8.9-8.4-16.1-18.8-16.1H1112c-11.6,0-21-8-21-18h0c0-9.1,8-16.7,18.3-17.8h125.2c20.3,0,36.8-14.1,36.8-31.5h0c0-17.4-16.4-31.5-36.7-31.5h-8.9c-18.2-1-32.7-13.9-32.7-29.8h0c0-15.2,13.3-27.8,30.6-29.6h348c20.3,0,36.8-14.1,36.8-31.5h0c0-17.4-16.4-31.5-36.7-31.5h-19.3c-11.4-.8-20.3-9-20.3-19h0c0-10.1,9.1-18.3,20.7-19h51.5c20.3,0,36.8-14.1,36.8-31.5h0C1640.9,632.8,1624.4,618.8,1604.1,618.8Z",
    fill: "#e7e8eb"
  }), React__default.createElement("circle", {
    cx: "1398.5",
    cy: "667.3",
    r: "9.9",
    fill: "#9599a4"
  }), React__default.createElement("path", {
    d: "M1151.6,532.4c9.3-2.2,31.6-6.2,37.4-6.2H495.8c4.1,2.1,8.6,4.2,13.5,6.2H396.1a351.5,351.5,0,0,1,52.9,9c5.7,1.4,11.7,2.9,17.1,4.7s6.9,3.5,11.3,4.6c1.7.4,3.4.8,5,1.3s2.8,1.3,4.2,1.9c8.3,3.8,14.4,2.2,22.4-.4a53.7,53.7,0,0,1,23.2-2c4.5.6,9,1.5,13.4,2.2s7.5,2.1,11.6,2.7c7.4,1.2,15.3.6,22.8-.2,8,2.7,15.6,5.3,22.2,8q65.3,26.6,131,52.8c13,5.2,27.1,10.1,39.7,15.5a109,109,0,0,1,14.5,7.7,37,37,0,0,0,5,2.8c10.2,4.5,26.4,2.6,38.3,2.6h10.9c18.7,0,30.5-7.7,45-13.8q35.8-15.1,72.2-29.7c43.4-17.5,87.4-34.7,132.9-50.5a53.3,53.3,0,0,1,16.9,1.4c12,3.2,20.2,12,33.3,12.1,9.9.1,17.8-5,27.3-6.8s22.2-2.4,33.1-4.4,24.9-3.5,37.6-2.3c10.8,1.1,21.2,3.8,32.1,3.8,7.5,0,15.4-.5,22.1-2.5,66.7-20,62.9-17.7,96.3-20.5H1151.6Z",
    fill: "url(#linear-gradient-6)"
  }), React__default.createElement("path", {
    d: "M324.3,533.6a306.6,306.6,0,0,0,56.4-12.1c6.1-1.9,12.5-3.9,18.3-6.3s7.4-4.7,12.1-6.2a49,49,0,0,0,5.4-1.7,49,49,0,0,0,4.5-2.5c8.9-5,15.4-3,24,.6a46.7,46.7,0,0,0,24.9,2.7c4.8-.8,9.6-2,14.3-3s8-2.8,12.4-3.6c9.6-1.9,19.8-.4,29.3,1l26,3.9c6.8,1,13.7,2.1,20.7,1.8,8.7-.4,17.3-2.9,26-1.8,5.3.6,10.1,2.6,15.1,3.9,11.5,2.9,23.3,1.4,34.5-1.5s22.9-5.3,33.4-9A307,307,0,0,1,725.7,488c1.5-.3.6-.5,2.2-.3a41.5,41.5,0,0,1,6,1.2c8.7,3.7,19,4.1,28.5,6.1,7.3,1.5,14.1,4,21.3,5.9a140,140,0,0,0,40.2,4.6c13.8-.4,25.2-5.2,38.5-7.3,9.9-1.5,20.6-1,30.7-1.2a142.7,142.7,0,0,1,32.3,3.2c28.1,6.1,54.2,8.7,83.3,4.9,7.9-1,15.8-2.3,23.7-2.2,18.4.4,37.5,8.5,54.4,2.9,12.9-4.3,21.7-16,35.7-16.1,10.6-.1,19.1,6.6,29.2,9.1s23.8,3.2,35.4,5.9,26.7,4.7,40.3,3.1c11.5-1.4,22.6-5.1,34.3-5.1,8.1,0,16.4.7,23.7,3.4,71.3,26.7,71.1,24.1,103.1,26.7L324,533.6",
    fill: "#696e7b",
    stroke: "#696e7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), React__default.createElement("path", {
    d: "M588.5,838.6c2-61.2.6-79.7-4.3-140.8H327.8l.6,1H309.2s8.1,2.1,7,3.8c-3.3,5.4-31.7,1.3-31.7,1.3s4.3,5.9,4.1,9.5l-3.5-1.1s1.2,1.3,2.5,3.2c-3.9,3.7-17.4.7-17.4.7s8.2,5.7,11.3,10.6a75,75,0,0,1-8.1-.8,78.4,78.4,0,0,1,8.3,6.2c-2.5,2.3-9.8,6.1-9.8,6.1s10.2.9,12.8,3.7l.5.5c-3.8,2.9-11.8,5.4-11.8,5.4s21,1.9,23.9,7.4c1.4,2.7-3.5,11.5-3.5,11.5a48.1,48.1,0,0,0,15.9-2.8c6.8-2.5,13.9-8.6,16.9-6.1s-1.1,10.9-1.1,10.9,7.1-2.5,9.5-3.5,3.2,0,5.2.6a60.5,60.5,0,0,1,.2,7.6c-2.8-3.7-5-7.2-5-7.2s-.3,10.8-1.5,12.4-4,1.4-5.6,1.5c-3.7.1-13.5-4.6-13.5-4.6s-7.7,8.4-11.3,10.2-16,3.5-16,3.5-2.6,9.7-5,12.6-17,11.8-17,11.8,9.7,4,12,5.6l.4.4c-4.7,3.2-10.3,6.4-10.3,6.4s8.7,5.8,10.6,8.3,2.4,7.8,2.4,7.8,11.4,2.2,14.5,4.3,5.2,6.7,5.2,6.7,11.1-1.5,14.5,0,7,7.8,7,7.8l9.3-5.6c2.9-1.6,9.6-3.9,12.8-3.2s7.4,4.8,7.4,4.8,5.8-3.9,8.4-4l2.3,11-9.2-5.5s-8.9,7.1-12.8,8.2-19.6-.6-19.6-.6",
    fill: "url(#linear-gradient-7)"
  }), React__default.createElement("path", {
    d: "M148.7,697.8c-19.7,9.6-38.7,20.7-58.6,29.9a237.7,237.7,0,0,1-29.9,11.7c-5.1,1.6-10.4,2.5-15.6,4-1.7.5-10.3,3.2-5.7,5.1l2,.8c0,.9.1,1.8.1,2.4a23,23,0,0,0,.6,6.6,40.5,40.5,0,0,0,2.5,6.1c.2.4,2,4,1.8,4.3s6.5-8.6,9.2-10.6a8.5,8.5,0,0,1,5.1-1.1l.7.3c1.1.7,1.7,4.9,1.7,4.9a50.9,50.9,0,0,1,6-2.9l1.5.3a14,14,0,0,1,3.4,2.9c3.2,4.6,2.2,20.7,2.2,20.7S83,767,88.2,766c2.2-.4,7.6,4.7,7.6,4.7a60,60,0,0,1-.6-11.7l1.4-.3c.8,2.1.8,7.5.8,7.5s4.8-1.8,6.4-1.6,6.6,3.9,6.6,3.9,2-6.9,3.6-8.6,5.6-3,5.6-3-.1-2.7-.5-5.6l1.9-.8c.2,1.8.4,3.1.4,3.1s5.6-3.8,7.6-3.3c4.2,1,11,13.4,11,13.4s-.9-10.6,1.9-11.3,9.1,11.5,9.1,11.5,1.9-11.4,3.8-14.6c.9-1.5,5.5-3.7,5.5-3.7a50,50,0,0,0,.1-9.4l.8-.2c1.6,3.1,2.6,10.2,2.6,10.2l4.1-3.2a1.1,1.1,0,0,1,1.5.2v.2l5.9,12.4,2.8-5.3a1.1,1.1,0,0,1,2,0l5.3,10.9s13.5-29.4,11.7-37.7c14.3-8,25.9-17.9,40.9-24.7Z",
    fill: "url(#linear-gradient-8)"
  }), React__default.createElement("path", {
    d: "M452.2,279.4c-1.9,5.2-18.8-2-18.8-2s-4.8,3.3-6.7,3.1c-3.7-.3-12.2-8.3-12.2-8.3s-10.6,2-14.1,1.2-16.3-8.2-16.3-8.2.8,8,3,10.7,14,9.7,14,9.7-6.6.8-8.8.1-8.2-5.6-8.2-5.6,2.1,9.7,4.3,12.4,10.8,5.5,13.5,8,3.1,4.9,3,6.7-7,9.3-4.4,9.3c9.6,0,14.1.8,22.2,12.2S460.3,256.8,452.2,279.4Z",
    fill: "#232429"
  }), React__default.createElement("polygon", {
    points: "679.7 244.3 654.5 225.2 652.9 230.9 644.9 219.4 636 215.2 636 221.2 619.7 210 607.1 203.4 609.3 210.8 599.7 205.6 601.6 213 597.1 213 599.3 219.5 679.7 244.3",
    fill: "#232429"
  }), React__default.createElement("path", {
    d: "M597.1,219.7l-17-21.1v10.6l-7.4-7.6V206l-13.3-9.6,4.4,9.3-12.6-7.4,4.4,7.8-8.5-6.3V208l-8.5-6.5v4.8l-13-5.9,5.2,7.6-12.6-4.6s14.1,20.5,13.7,28.4C531.1,247.2,597.1,219.7,597.1,219.7Z",
    fill: "#232429"
  }), React__default.createElement("path", {
    d: "M541.2,230.8c-8.9-.7-15.9-10.7-15.9-10.7l-7-.6-24.5-18.6,3.3,9.3-13-9.3,10,24.8h-7.4l7.4,6.1h-5.9s8.3,8.1,8.4,12.6C496.8,253.4,552.8,231.7,541.2,230.8Z",
    fill: "#232429"
  }), React__default.createElement("path", {
    d: "M494.3,246.5c-2,0-3.9-8-3.9-8s-5,.9-6.3,0-3.3-7.8-3.3-7.8-3.9,5.4-5.9,5.7c-4,.6-14.5-7.5-14.5-7.5s1.7,6.7,0,7.5-9-7.5-9-7.5,0,11.5,5,17.6c1.5,1.8-7.5-5.4-7.5-5.4s-.4,8.5,2.5,11.5c1.1,1.1-6.2,0-6.2,0s4.6,4.5,6.2,5.9,3.5,2.2,3.5,3.7-8.9,5-8.9,5,3.7,10.9,1.1,14C428.3,303.3,507.2,246.5,494.3,246.5Z",
    fill: "#232429"
  }), React__default.createElement("path", {
    d: "M423.2,340.8c-2.4,2.6-15.9-5.2-15.9-5.2s-.9,6.5-2.6,7.5-7.1-.1-8.9-1.4c-4.1-3-14.1-16.2-14.1-16.2s-1.4,12.9-4.8,14.8c-8.4,4.6-35.6-9.6-35.6-9.6s4,12.2,8.5,17c2.5,2.6,14.1,7.6,16.3,11.5,1.3,2.3,1.5,15.2,1.5,15.2s15.6-2,19.5-.9c6.3,1.7,12.2,1.1,15.9,7C409.9,391.5,431,332.5,423.2,340.8Z",
    fill: "#1a1c1e"
  }), React__default.createElement("path", {
    d: "M424.1,327.1c-2.4,2.6-15.9-5.2-15.9-5.2s-.9,6.5-2.6,7.5-7.1-.1-8.9-1.4c-4.1-3-14.1-16.2-14.1-16.2s-1.4,12.9-4.8,14.8c-8.4,4.6-35.6-9.6-35.6-9.6s4,12.2,8.5,17c2.5,2.6,17.1,9.1,19.3,13,1.3,2.3,0,10.7,0,10.7s12.3,1.4,15.9,3c5.9,2.6,13.7,11.5,17.4,17.4C410.3,389.1,431.9,318.8,424.1,327.1Z",
    fill: "#232429"
  }), React__default.createElement("path", {
    d: "M398.5,409.1c-2.7,1.1-7.8-9.4-7.8-9.4s-5.7,2-7.5,1.3c-3.5-1.5-8.8-12.6-8.8-12.6s-10.6,5.8-13.9,5.8c-5.7-.1-18.1-10.6-18.1-10.6s2.1,8.4,0,10.6c-4.9,5.3-28.7,5.1-28.7,5.1s19.3,8.8,22.4,15.7c1.6,3.5.7,15.2.7,15.2s13.1,1.9,16.1,4.8,2.6,12.1,2.6,12.1,14.3-2.8,18.9-.7,7,8.4,7,8.4S409.3,404.5,398.5,409.1Z",
    fill: "#1a1c1e"
  }), React__default.createElement("path", {
    d: "M398.5,395.3c-2.7,1.1-7.8-9.4-7.8-9.4s-5.7,2-7.5,1.3c-3.5-1.5-8.8-12.6-8.8-12.6s-10.6,5.8-13.9,5.8c-5.7-.1-18.1-10.6-18.1-10.6s2.1,9.9,0,12.1c-4.9,5.3-28.7,2.2-28.7,2.2s19.3,10.3,22.4,17.2c1.6,3.5.7,15.2.7,15.2s13.1,1.9,16.1,4.8,3.5,10.7,3.5,10.7,15.4.3,20,2.4,7.8,6.7,7.8,6.7S409.3,390.7,398.5,395.3Z",
    fill: "#232429"
  }), React__default.createElement("path", {
    d: "M308.6,482.8s-8.9,3.3-12,3.7-15.2-.9-15.2-.9,12.8,7.2,15.2,11.7,2.2,19.4,2.2,19.4,11.7.8,14.8,2.8,7.2,11.1,7.2,11.1,14.9-1.9,19.6-.6,12.8,8.2,12.8,8.2l11.1-6.7,8.5-23.3Z",
    fill: "#1a1c1e"
  }), React__default.createElement("path", {
    d: "M272.3,568.2s8.9,7.2,5.7,9.3-12,5.5-12,5.5,13.9,8,17,11.8,5,12.6,5,12.6,12.3,1.7,15.9,3.5,11.3,10.2,11.3,10.2,9.8-4.7,13.5-4.6c1.6,0,4.7.3,5.6,1.5s1.5,12.4,1.5,12.4,6.4-10.2,11.1-13.7c8-5.8,0-42.6,0-42.6Z",
    fill: "#1a1c1e"
  }), React__default.createElement("path", {
    d: "M361.2,543.4c-1.5,1.7-9.5-3.7-9.5-3.7s-5,4.3-7.4,4.8-9.9-1.5-12.8-3.2l-9.3-5.6s-4.4,6.6-7,7.8-14.5,0-14.5,0-3.2,5.3-5.2,6.7-14.5,4.3-14.5,4.3-1,5.8-2.4,7.8-10.6,8.3-10.6,8.3,12.7,7.2,15.7,10.9,5.9,13.3,5.9,13.3,11.3,1.9,14.6,3.7,12.4,11.3,12.4,11.3,10.7-5.1,15-5.4c2.6-.2.6,12,.6,12s5.6.1,7.2,1.8.6,15.7.6,15.7,5.6-7.4,6.7-7C366.5,633.6,374.9,528,361.2,543.4Z",
    fill: "#232429"
  }), React__default.createElement("path", {
    d: "M378.5,468.6c-1.9,2-5.5,1.5-6.9.4s-2.6-8.5-2.6-8.5-7.9,4.2-10.7,3.5c-5.8-1.4-14.5-17.4-14.5-17.4s-9,10.2-13.5,10.6-16.7-9.3-16.7-9.3-4,14.7-7.2,18.5c-1.8,2.1-6.9,3.7-9.6,4.3s-15.4,1.5-15.4,1.5,15.9,6.2,18,11.1c.5,1.1-1.1,4.8-1.1,4.8s5.2,3.6,5.6,5.6-3,6.7-3,6.7,11.1,3,14.1,5.4,7.2,10.7,7.2,10.7,12-2.7,15.9-1.7,17,11.8,17,11.8,7.8-7.6,12-7.2C380,520.4,387.1,459,378.5,468.6Z",
    fill: "#232429"
  }), React__default.createElement("path", {
    d: "M285.3,654.7c-2.6,2.8-12.8,3.7-12.8,3.7s8.2,4.2,10.2,6.5c3.9,4.5-11.9,15.6-11.9,15.6s15.1-3.4,18,1.5c1.8,3.2-3.7,10.7-3.7,10.7s28.3-4.1,31.7,1.3c1,1.7-7,3.8-7,3.8h24l14.6-53.1S296.1,643,285.3,654.7Z",
    fill: "#1a1c1e"
  }), React__default.createElement("path", {
    d: "M345.5,628.8s-7.5,3.7-10,2.6-9.5-3.5-9.5-3.5,3.2,9.2,1.1,10.9-10-3.6-16.9-6.1a48.1,48.1,0,0,0-15.9-2.8s4.9,8.8,3.5,11.5c-2.9,5.5-23.9,7.4-23.9,7.4s13.2,4,13.7,8S274,670.7,274,670.7s15.9-2.7,18.1,1.3-6.5,12.4-6.5,12.4,26.8-9.3,31.1-2.8c1.3,2-4.6,8.5-4.6,8.5s16.7-1.1,21.1,3.2C345,704.7,345.5,628.8,345.5,628.8Z",
    fill: "#232429"
  }), React__default.createElement("path", {
    d: "M584.7,698.8c4.8-61,6.3-79.6,4.3-140.8-1-31.4,2.3-61.8,6.2-93.1,2.8-22.2,4.9-45.8,12.2-67.2,6.6-19.4,11.6-41.8,27.1-56.3,6.8-6.3,15.3-9.5,24-12.3,4.1-1.4,8.2-3.3,12.4-4s9.6-.8,14.1-2.6,8.1-5.4,11.6-8.7,7.3-7.5,12.1-7.5a1.5,1.5,0,0,0,1.5-1.5v-.3c-1.4-8-9.1-41.2-16.6-49.9-16.3-18.8-68.2-36.9-93-35.2-38.7,2.6-119.5,24.2-145.7,52.7-43.8,47.8-75.6,180.2-89.1,243.6C356.8,559,329.2,696,328.9,697.8l-.6,1",
    fill: "#2a2d32"
  }), React__default.createElement("circle", {
    cx: "614.3",
    cy: "258.1",
    r: "5.8",
    fill: "#e7e8ea"
  }), React__default.createElement("circle", {
    cx: "683.3",
    cy: "261.9",
    r: "5.8",
    fill: "#e7e8ea"
  }), React__default.createElement("circle", {
    cx: "614.3",
    cy: "258.1",
    r: "2.9",
    fill: "#1a1c1e"
  }), React__default.createElement("circle", {
    cx: "683.3",
    cy: "261.9",
    r: "2.9",
    fill: "#1a1c1e"
  }), React__default.createElement("path", {
    d: "M458.5,659.9l-.8-8.6-5.5,7,11.2-78.2c-.3-2.8-5.9-52.1-5.9-68.9h1.8c0,17,5.9,68.3,5.9,68.8h0l-10.3,71.7,4.1-5.2.6,6.6,3-6.3,1.8,7,3-6.6,1.5,6.6c3.1-6.3,11.7-23.9,14.2-31,3.6-10.4,9-43.4,9-43.7l7.4-71.6,5.6-31.2.2-.2c.2-.2,17.9-21.2,17.9-29.6h1.8c0,8.7-16.3,28.3-18.2,30.6l-5.5,30.8L494,579.4c-.2,1.4-5.4,33.6-9.1,44.1-3,8.8-14.9,32.5-15.4,33.5l-1.1,2.2-1.5-6.4-2.9,6.4-1.9-7.1Z",
    fill: "#191b1d"
  }), React__default.createElement("polygon", {
    points: "666.2 305.5 667.7 305.2 667.5 308.8 667.3 312.3 666 309 664.7 305.7 666.2 305.5",
    fill: "#e7e8ea"
  }), React__default.createElement("polygon", {
    points: "622.8 305 623.8 305 623.3 306.6 622.8 308.1 622.3 306.6 621.8 305 622.8 305",
    fill: "#e7e8ea"
  }), React__default.createElement("polygon", {
    points: "653.9 305 654.9 305 654.4 306.6 653.9 308.1 653.4 306.6 652.9 305 653.9 305",
    fill: "#e7e8ea"
  }), React__default.createElement("polygon", {
    points: "646.1 305 647.1 305 646.6 306.6 646.1 308.1 645.6 306.6 645.1 305 646.1 305",
    fill: "#e7e8ea"
  }), React__default.createElement("polygon", {
    points: "638.4 305 639.5 305 639 306.6 638.4 308.1 637.9 306.6 637.4 305 638.4 305",
    fill: "#e7e8ea"
  }), React__default.createElement("polygon", {
    points: "630.5 305 631.4 305 631 306.6 630.5 308.1 630 306.6 629.5 305 630.5 305",
    fill: "#e7e8ea"
  }), React__default.createElement("polygon", {
    points: "676.3 305.1 677.9 305.8 676.3 307.3 674.8 308.9 674.7 306.7 674.7 304.5 676.3 305.1",
    fill: "#e7e8ea"
  }), React__default.createElement("polygon", {
    points: "683.6 305.6 685.3 305.6 684.5 307.6 683.6 309.6 682.8 307.6 681.9 305.6 683.6 305.6",
    fill: "#e7e8ea"
  }), React__default.createElement("polygon", {
    points: "690.8 304.7 692 304.7 691.4 306.1 690.8 307.4 690.2 306.1 689.6 304.7 690.8 304.7",
    fill: "#e7e8ea"
  }), React__default.createElement("polygon", {
    points: "696.6 305.2 697.8 305.2 697.2 306.1 696.6 306.9 696 306.1 695.4 305.2 696.6 305.2",
    fill: "#e7e8ea"
  }), React__default.createElement("polygon", {
    points: "701.3 305 702.5 305 701.9 305.8 701.3 306.7 700.7 305.8 700.1 305 701.3 305",
    fill: "#e7e8ea"
  }), React__default.createElement("path", {
    d: "M705.9,305l-3.8.2-10.1.3-14.3.3H645l-14.3-.3-10.1-.3-3.8-.2,3.8-.2,10.1-.3,14.3-.3h32.7l14.3.3,10.1.3Z",
    fill: "#191b1d"
  }), React__default.createElement("path", {
    d: "M157.4,667c5.1-.7,3.3-15.8,3.3-15.8s-4.6-2.2-5.5-3.7c-1.9-3.2-3.8-14.7-3.8-14.7s-5.6,12.5-9.1,11.5-1.9-11.3-1.9-11.3-6.8,12.4-11,13.4c-2,.5-7.6-3.3-7.6-3.3s-1.2,10.1-2,10.9C113,660.9,147.9,668.3,157.4,667Z",
    fill: "#232429"
  }), React__default.createElement("path", {
    d: "M197.7,673.3c2-8-11.7-37.8-11.7-37.8l-5.2,10.8a1.1,1.1,0,0,1-2,0L176,641l-6,12.4a1.1,1.1,0,0,1-1.5.5h-.2l-4.1-3.2s-1.2,9.1-3.3,11.2C155.2,667.6,195.4,682,197.7,673.3Z",
    fill: "#232429"
  }), React__default.createElement("path", {
    d: "M117.1,652.6c2.4-1.2,2.8-12.8,2.8-12.8s-4.6-1.8-5.6-3-3.6-8.6-3.6-8.6-4.7,3.6-6.6,3.9-6.4-1.6-6.4-1.6,0,6.1-.9,7.8-4.8,5.6-7.5,5.8C82.1,644.8,111.2,655.6,117.1,652.6Z",
    fill: "#232429"
  }), React__default.createElement("path", {
    d: "M105.4,648s-7.7-4.4-9-6.5c-2.2-3.6-.3-15.5-.3-15.5s-5.4,5.1-7.6,4.7c-5.2-1-12.4-17.2-12.4-17.2s1,16-2.2,20.7c-1.6,2.3-9.2,6.3-9.2,6.3",
    fill: "#232429"
  }), React__default.createElement("path", {
    d: "M63.2,634.5s-.6,4.3-1.7,5-4.6,0-5.8-.9c-2.7-2-9.2-10.6-9.2-10.6s-1.6,3.9-1.8,4.3a40.5,40.5,0,0,0-2.5,6.1,23,23,0,0,0-.6,6.6c0,1.1-.3,3.7.3,4.7s9-1.3,9-1.3L73,638.2C70.4,638.7,63.2,634.5,63.2,634.5Z",
    fill: "#232429"
  }), React__default.createElement("path", {
    d: "M72.9,638.2l.6-.3Z",
    fill: "#232429"
  }), React__default.createElement("path", {
    d: "M238.6,697.7c-17.2-7.8-30-19.7-47.6-28.1-8.6-4.1-18.2-5.7-27.4-8.3a279,279,0,0,1-29.3-9.7c-15.8-6.4-31.6-14.1-48.8-15.4s-30.5,5.6-46,11.9c-4.6,1.9,4,4.6,5.7,5.1,5.1,1.5,10.4,2.4,15.6,4a237.7,237.7,0,0,1,29.9,11.7c19.9,9.2,38.9,20.3,58.6,29.9",
    fill: "#2a2d32"
  }), React__default.createElement("rect", {
    x: "289.5",
    y: "739.1",
    width: "36.5",
    height: "20.26",
    fill: "#696e7b"
  }), React__default.createElement("polygon", {
    points: "310.4 729.3 305.2 729.3 285.6 739.1 330 739.1 310.4 729.3",
    fill: "#696e7b"
  }), React__default.createElement("path", {
    d: "M330,739.5H285.6a.4.4,0,0,1-.2-.7l19.7-9.8h5.4l19.7,9.8a.4.4,0,0,1,.2.5l-.3.2Zm-42.9-.7h41.3l-18.2-9.1h-5Z",
    fill: "#696e7b"
  }), React__default.createElement("path", {
    d: "M330.5,739.5l-1-.2a.4.4,0,0,1,.3-.7,1.7,1.7,0,0,0,2.2-.8.4.4,0,1,1,.7.2h0A2.4,2.4,0,0,1,330.5,739.5Z",
    fill: "#696e7b"
  }), React__default.createElement("path", {
    d: "M285.2,739.5a2.4,2.4,0,0,1-2.2-1.4.4.4,0,1,1,.6-.4h0a1.7,1.7,0,0,0,2.2.8.4.4,0,0,1,.3.7Z",
    fill: "#696e7b"
  }), React__default.createElement("rect", {
    x: "305.2",
    y: "727.3",
    width: "5.2",
    height: "1.57",
    fill: "#696e7b"
  }), React__default.createElement("path", {
    d: "M310.4,729h-5.2l-.2-.2v-1.6l.2-.2h5.2l.2.2v1.6Zm-5-.4h4.8v-1.2h-4.8Z",
    fill: "#696e7b"
  }), React__default.createElement("path", {
    d: "M306.6,726.7a1.4,1.4,0,1,1,2.2.1l-1.1,1.5Z",
    fill: "#696e7b"
  }), React__default.createElement("path", {
    d: "M307.8,724.2a1.6,1.6,0,0,1,1.2,2.7l-1.1,1.5h-.3l-1.2-1.5a1.6,1.6,0,0,1-.3-1A1.6,1.6,0,0,1,307.8,724.2Zm0,3.7,1-1.3a1.3,1.3,0,1,0-1.9-.1h0Z",
    fill: "#696e7b"
  }), React__default.createElement("rect", {
    x: "296.2",
    y: "743.8",
    width: "8.6",
    height: "16.14",
    rx: "4.3",
    ry: "4.3",
    fill: "#696e7b"
  }), React__default.createElement("rect", {
    x: "309.9",
    y: "743.8",
    width: "8.6",
    height: "16.14",
    rx: "4.3",
    ry: "4.3",
    fill: "#696e7b"
  }), React__default.createElement("path", {
    d: "M259.3,759.1h-4v-6.3a6.7,6.7,0,0,1,6.7-6.7h2.4a2.7,2.7,0,0,0,2.7-2.7v-3.8h4v3.8a6.7,6.7,0,0,1-6.7,6.7h-2.4a2.7,2.7,0,0,0-2.7,2.7v6.3Z",
    fill: "#696e7b"
  }), React__default.createElement("path", {
    d: "M259.4,752.3h-4V746a2.7,2.7,0,0,0-2.7-2.7h-8.5a6.7,6.7,0,0,1-6.7-6.7v-3.8h4v3.8a2.7,2.7,0,0,0,2.7,2.7h8.5a6.7,6.7,0,0,1,6.7,6.7Z",
    fill: "#696e7b"
  }), React__default.createElement("rect", {
    x: "229.5",
    y: "727.8",
    width: "16.5",
    height: "7.17",
    rx: "3.6",
    ry: "3.6",
    fill: "#696e7b"
  }), React__default.createElement("rect", {
    x: "254.7",
    y: "734.7",
    width: "22.3",
    height: "7.17",
    rx: "3.6",
    ry: "3.6",
    fill: "#696e7b"
  }), React__default.createElement("path", {
    d: "M277.3,732.2H255.1a4.8,4.8,0,0,1-4.8-4.8h0a4.8,4.8,0,0,1,4.8-4.8h22.2a4.8,4.8,0,0,1,4.8,4.8h0a4.8,4.8,0,0,1-4.8,4.8Z",
    fill: "#696e7b"
  }), React__default.createElement("path", {
    d: "M260.7,720.3H247a4.8,4.8,0,0,1-4.8-4.8h0a4.8,4.8,0,0,1,4.8-4.8h13.7a4.8,4.8,0,0,1,4.8,4.8h0A4.8,4.8,0,0,1,260.7,720.3Z",
    fill: "#696e7b"
  }), React__default.createElement("rect", {
    x: "1129.2",
    y: "652.8",
    width: "31.5",
    height: "1.89",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1160.7,654.8h-31.6v-1.9h31.7v1.9Zm-31.4-.2h31.2v-1.7h-31.2Z",
    fill: "#999"
  }), React__default.createElement("polygon", {
    points: "1156 673.5 1153.2 673.5 1153.4 649.2 1155.8 649.2 1156 673.5",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1156,673.6h-3l.2-24.4h2.6l.2,24.4Zm-2.7-.2h2.6l-.2-24.1h-2.1Z",
    fill: "#999"
  }), React__default.createElement("polygon", {
    points: "1136.8 673.5 1133.9 673.5 1134.2 649.2 1136.5 649.2 1136.8 673.5",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1136.8,673.6h-3l.2-24.4h2.6l.2,24.4Zm-2.7-.2h2.6l-.2-24.1h-2.1Z",
    fill: "#999"
  }), React__default.createElement("rect", {
    x: "1144.2",
    y: "649.2",
    width: "1.7",
    height: "3.85",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1145.8,653.1H1144v-3.8h1.9V653h-.1Zm-1.5-.2h1.4v-3.6h-1.4Z",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1145.3,650.8a165,165,0,0,1-16.6-.7l-.3-1.9a167.7,167.7,0,0,0,33.2,0l-.3,1.9C1155.4,650.7,1150.3,650.8,1145.3,650.8Z",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1145.3,651c-9.4,0-15.9-.7-16.6-.7h-.1l-.3-1.9a.1.1,0,0,1,0-.1h.1a165.9,165.9,0,0,0,33.1,0h.1l-.3,1.9h-.1C1156,650.7,1150.9,651,1145.3,651Zm-16.5-1c1.1.1,7.4.7,16.5.7,5.6,0,10.6-.2,15.8-.7l.3-1.6a166.4,166.4,0,0,1-32.9,0Z",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1145.3,649.2a178.6,178.6,0,0,1-18.1-.8l-.5-2.2c.2,0,18.6,3,36.4,0l-.5,2.2C1156.3,649,1150.8,649.2,1145.3,649.2Z",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1145.3,649.3a174.6,174.6,0,0,1-18-.8h-.1l-.5-2.2h.2c3.2.5,19.9,2.8,36.3,0h.1l-.5,2.2h-.1C1156.9,649.1,1151.4,649.3,1145.3,649.3Zm-18-1c1,.1,7.9.8,18,.8,6,0,11.4-.2,17.2-.8l.5-2c-16.2,2.7-32.7.5-36.1,0Z",
    fill: "#999"
  }), React__default.createElement("rect", {
    x: "1133.6",
    y: "669.2",
    width: "3.4",
    height: "4.34",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1137.1,673.6h-3.6v-4.3h3.7v4.3Zm-3.3-.2h3.2v-4.1h-3.2Z",
    fill: "#999"
  }), React__default.createElement("rect", {
    x: "1152.9",
    y: "669.2",
    width: "3.4",
    height: "4.34",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1156.3,673.6h-3.6v-4.3h3.7v4.3Zm-3.3-.2h3.2v-4.1H1153Z",
    fill: "#999"
  }), React__default.createElement("rect", {
    x: "1181.5",
    y: 651,
    width: "18.9",
    height: "8.64",
    fill: "#999"
  }), React__default.createElement("rect", {
    x: "1175.8",
    y: "663.8",
    width: "30.4",
    height: "17.58",
    fill: "#999"
  }), React__default.createElement("polygon", {
    points: "1192.3 646 1189.6 646 1179.4 651 1202.4 651 1192.3 646",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1202.4,651.2h-23a.2.2,0,0,1-.2-.2v-.2l10.2-5.1h2.8l10.2,5.1a.2.2,0,0,1,.1.3h-.2Zm-22.2-.4h21.4l-9.4-4.7h-2.6Z",
    fill: "#999"
  }), React__default.createElement("polygon", {
    points: "1202 659.7 1179.9 659.7 1173.3 663.7 1208.6 663.7 1202 659.7",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1208.6,663.9h-35.3a.2.2,0,0,1-.2-.2v-.2l6.6-4h22.3l6.6,4a.2.2,0,0,1,.1.3h-.2Zm-34.6-.4h34l-6-3.7h-22Z",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1202.7,651.2h-.5a.2.2,0,0,1-.1-.3h.3a.9.9,0,0,0,1.2-.4h.3a.2.2,0,0,1,.1.3A1.3,1.3,0,0,1,1202.7,651.2Z",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1208.8,663.9h-.5a.2.2,0,0,1-.1-.3h.3a.9.9,0,0,0,1.2-.4h.3a.2.2,0,0,1,.1.3A1.3,1.3,0,0,1,1208.8,663.9Z",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1179.2,651.2a1.3,1.3,0,0,1-1.1-.7.2.2,0,0,1,.1-.3h.3a.9.9,0,0,0,1.2.4h.3a.2.2,0,0,1-.1.3h-.5Z",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1173,663.9a1.3,1.3,0,0,1-1.1-.7.2.2,0,0,1,.1-.3h.3a.9.9,0,0,0,1.2.4h.3a.2.2,0,0,1-.1.3h-.5Z",
    fill: "#999"
  }), React__default.createElement("rect", {
    x: "1189.6",
    y: "644.9",
    width: "2.7",
    height: "0.81",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1192.3,645.8h-2.8v-.8h2.9v.8Zm-2.6-.2h2.5V645h-2.5Z",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1191.5,643.9a.7.7,0,1,1-1.2,0l.6-.8Z",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1190.9,645.2a.8.8,0,0,1-.6-1.4l.6-.7h.2l.6.8a.8.8,0,0,1,.2.5.8.8,0,0,1-.8.8Zm0-1.9-.5.7a.7.7,0,1,0,1.1.4.6.6,0,0,0-.1-.4h0Z",
    fill: "#999"
  }), React__default.createElement("rect", {
    x: "792.8",
    y: "669.8",
    width: "18.9",
    height: "20.37",
    fill: "#9599a4"
  }), React__default.createElement("polygon", {
    points: "803.6 664.8 800.9 664.8 790.7 669.8 813.7 669.8 803.6 664.8",
    fill: "#9599a4"
  }), React__default.createElement("path", {
    d: "M813.7,670h-23a.2.2,0,0,1-.2-.2v-.2l11.6-6,11.6,6a.2.2,0,0,1,.1.3Zm-22.2-.4h21.4l-9.4-4.7H801Z",
    fill: "#9599a4"
  }), React__default.createElement("path", {
    d: "M814,670h-.5a.2.2,0,0,1-.1-.3h.3a.9.9,0,0,0,1.2-.4h.3a.2.2,0,0,1,.1.3A1.3,1.3,0,0,1,814,670Z",
    fill: "#9599a4"
  }), React__default.createElement("path", {
    d: "M790.5,670a1.2,1.2,0,0,1-1.1-.7.2.2,0,0,1,.1-.3h.3a.9.9,0,0,0,1.2.4h.3a.2.2,0,0,1-.1.3h-.5Z",
    fill: "#9599a4"
  }), React__default.createElement("rect", {
    x: "849.6",
    y: "669.5",
    width: "20.1",
    height: "9.19",
    fill: "#9599a4"
  }), React__default.createElement("polygon", {
    points: "861.1 664.1 858.2 664.1 847.4 669.5 871.9 669.5 861.1 664.1",
    fill: "#9599a4"
  }), React__default.createElement("path", {
    d: "M871.9,669.7H847.5a.2.2,0,0,1-.2-.2v-.2l12.3-6.4,12.3,6.4a.2.2,0,0,1,.1.3Zm-23.6-.4H871l-10-5h-2.7Z",
    fill: "#9599a4"
  }), React__default.createElement("path", {
    d: "M872.1,669.7h-.6a.2.2,0,0,1-.1-.3h.3a.9.9,0,0,0,1.2-.5h.3a.2.2,0,0,1,.1.3h0A1.3,1.3,0,0,1,872.1,669.7Z",
    fill: "#9599a4"
  }), React__default.createElement("path", {
    d: "M847.2,669.7a1.3,1.3,0,0,1-1.2-.8.2.2,0,0,1,.1-.3h.3a.9.9,0,0,0,1.2.5h.3a.2.2,0,0,1-.1.3Z",
    fill: "#9599a4"
  }), React__default.createElement("rect", {
    x: "821.7",
    y: "665.9",
    width: "18.9",
    height: "8.64",
    fill: "#9599a4"
  }), React__default.createElement("polygon", {
    points: "832.4 660.8 829.8 660.8 819.6 665.9 842.6 665.9 832.4 660.8",
    fill: "#9599a4"
  }), React__default.createElement("path", {
    d: "M842.6,666.1h-23a.2.2,0,0,1-.2-.2v-.2l11.6-6,11.6,6a.2.2,0,0,1,.1.3Zm-22.2-.4h21.4l-9.4-4.7h-2.6Z",
    fill: "#9599a4"
  }), React__default.createElement("path", {
    d: "M842.8,666.1h-.5a.2.2,0,0,1-.1-.3h.3a.9.9,0,0,0,1.2-.4h.3a.2.2,0,0,1,.1.3h0A1.3,1.3,0,0,1,842.8,666.1Z",
    fill: "#9599a4"
  }), React__default.createElement("path", {
    d: "M819.4,666.1a1.2,1.2,0,0,1-1.1-.7.2.2,0,0,1,.1-.3h.3a.9.9,0,0,0,1.2.4h.3a.2.2,0,0,1-.1.3Z",
    fill: "#9599a4"
  }), React__default.createElement("path", {
    d: "M1105.9,645.9a.2.2,0,0,1-.2-.2V635a.2.2,0,0,1,.3-.2l.2.2v10.7a.2.2,0,0,1-.2.2Z",
    fill: "#999"
  }), React__default.createElement("polygon", {
    points: "1107.7 646.7 1106.3 644.9 1105.4 644.9 1104 646.7 1102.9 677.1 1108.9 677.1 1107.7 646.7",
    fill: "#999"
  }), React__default.createElement("polygon", {
    points: "1107.5 646.5 1104.3 646.5 1099.2 648.6 1112.6 648.6 1107.5 646.5",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1112.6,648.8h-13.4a.2.2,0,0,1-.1-.4l5.1-2.1h3.4l5.1,2.1a.2.2,0,0,1,.1.3Zm-12.3-.4h11.3l-4-1.7h-3.2Z",
    fill: "#999"
  }), React__default.createElement("polygon", {
    points: "1107.9 652.2 1103.9 652.2 1098.8 654.3 1113 654.3 1107.9 652.2",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1113,654.5h-14.2a.2.2,0,0,1-.1-.4l5.1-2.1h4.2l5.1,2.1a.2.2,0,0,1,.2.3l-.2.2Zm-13.1-.4h12l-4-1.7h-4Z",
    fill: "#999"
  }), React__default.createElement("polygon", {
    points: "1108.1 657.8 1103.7 657.8 1098.4 659.9 1113.4 659.9 1108.1 657.8",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1113.4,660.2h-15a.2.2,0,0,1-.1-.4l5.3-2.1h4.6l5.3,2.1a.2.2,0,0,1,.1.3Zm-13.9-.4h12.7l-4.2-1.7h-4.4Z",
    fill: "#999"
  }), React__default.createElement("polygon", {
    points: "1108.3 663.5 1103.5 663.5 1098 665.6 1113.8 665.6 1108.3 663.5",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1113.8,665.8H1098a.2.2,0,0,1-.1-.4l5.5-2.1h5l5.5,2.1a.2.2,0,0,1,.1.3h-.2Zm-14.6-.4h13.4l-4.3-1.7h-4.7Z",
    fill: "#999"
  }), React__default.createElement("polygon", {
    points: "1108.5 669.2 1103.3 669.2 1097.2 671.3 1114.5 671.3 1108.5 669.2",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1114.6,671.5h-17.3a.2.2,0,1,1-.1-.4l6.1-2.1h5.4l6.1,2.1a.2.2,0,1,1-.1.4Zm-16-.4h14.8l-4.8-1.7h-5.2Z",
    fill: "#999"
  }), React__default.createElement("rect", {
    x: "1098.4",
    y: "677.1",
    width: 15,
    height: "1.58",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1113.4,678.9h-15a.2.2,0,0,1-.2-.2v-1.6a.2.2,0,0,1,.2-.2h15a.2.2,0,0,1,.2.2v1.6A.2.2,0,0,1,1113.4,678.9Zm-14.8-.4h14.6v-1.2h-14.6Z",
    fill: "#999"
  }), React__default.createElement("rect", {
    x: "1097.5",
    y: "678.7",
    width: "16.8",
    height: "1.58",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1114.3,680.5h-16.8a.2.2,0,0,1-.2-.2v-1.6a.2.2,0,0,1,.2-.2h16.8a.2.2,0,0,1,.2.2v1.6A.2.2,0,0,1,1114.3,680.5Zm-16.6-.4H1114v-1.2h-16.3Z",
    fill: "#999"
  }), React__default.createElement("circle", {
    cx: "1105.9",
    cy: "634.5",
    r: 1,
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M953.9,829.9a454.3,454.3,0,0,0-47.9,5.6c-5.2.9-10.6,1.8-15.5,2.9s-6.2,2.2-10.2,2.9c-1.5.3-3.1.5-4.5.8l-3.8,1.2c-7.6,2.3-13.1,1.4-20.3-.3a70.2,70.2,0,0,0-21.1-1.3l-12.1,1.4c-3.7.4-6.8,1.3-10.5,1.7-8.1.9-16.8.2-24.8-.5l-22-1.8a163.5,163.5,0,0,0-17.5-.8c-7.4.2-14.7,1.3-22,.8-4.5-.3-8.5-1.2-12.8-1.8-11.7-1.6-21.8-.2-32.7,1.9s-24,3.9-35.9,5.9c-10.2,1.7-20.7,3.3-31.3,2.8a141.6,141.6,0,0,1-14.2-1.7c-8.4-1.3-16.7-2.7-25.1-3.9-69.4-9.9-136.4,9.7-202.6,17.8-54.5,6.7-114.3,9.5-165.2-2.1S109.7,833.3,52,830",
    fill: "url(#linear-gradient-9)"
  }), React__default.createElement("path", {
    d: "M678.7,699.5a253.1,253.1,0,0,0,46.3-9.9c5-1.6,10.2-3.2,15-5.2s6-3.8,9.9-5.1l4.4-1.4c1.3-.6,2.4-1.4,3.7-2.1,7.3-4.1,12.6-2.4,19.6.5a38.2,38.2,0,0,0,20.4,2.2c3.9-.7,7.8-1.6,11.7-2.4s6.6-2.3,10.2-3c7.8-1.5,16.2-.3,24,.8l21.3,3.2c5.6.8,11.3,1.7,16.9,1.5s14.2-2.3,21.3-1.5c4.3.5,8.2,2.1,12.4,3.2,9.5,2.4,19.1,1.1,28.3-1.2s18.7-4.3,27.4-7.3a251.6,251.6,0,0,1,36.2-9.5,11.3,11.3,0,0,1,3.8-.3,12.5,12.5,0,0,1,2.9,1c7.1,3,15.6,3.3,23.4,5,6,1.3,11.6,3.3,17.4,4.8a114.8,114.8,0,0,0,33,3.8c11.3-.3,20.6-4.3,31.5-6,8.1-1.3,16.9-.9,25.1-1a117,117,0,0,1,26.4,2.6c23,5,44.4,7.2,68.2,4,6.4-.8,12.9-1.9,19.4-1.8,15.1.3,30.7,7,44.6,2.3,10.5-3.5,17.7-13.1,29.2-13.2,8.7-.1,15.6,5.4,23.9,7.5s19.5,2.6,29,4.9,21.8,3.9,33,2.5c9.4-1.2,18.6-4.2,28.1-4.2,6.6,0,13.5.6,19.4,2.8,58.5,21.9,55.2,19.3,84.5,22.5",
    fill: "#9599a4"
  }), React__default.createElement("path", {
    d: "M1072.1,832.2H44.6a1.5,1.5,0,0,1,0-3H1072.1a1.5,1.5,0,0,1,0,3Z",
    fill: "#9599a4"
  }), React__default.createElement("path", {
    d: "M964.8,830a251.3,251.3,0,0,1-47.9-10.7c-5.2-1.7-10.6-3.4-15.5-5.6s-6.2-4.2-10.2-5.5a40.2,40.2,0,0,1-4.5-1.6c-1.3-.6-2.5-1.5-3.8-2.3-7.6-4.5-13.1-2.6-20.3.5a37.8,37.8,0,0,1-21.1,2.4c-4.1-.7-8.1-1.7-12.1-2.6s-6.8-2.5-10.5-3.2c-8.1-1.7-16.8-.4-24.8.9l-22,3.5c-5.8.9-11.6,1.8-17.5,1.6s-14.7-2.5-22-1.6c-4.5.6-8.5,2.3-12.8,3.4-11.7,3.1-21.8.3-32.7-3.6s-24-7.5-35.9-11.2c-10.2-3.2-20.7-6.4-31.3-5.3a78.6,78.6,0,0,0-14.2,3.3c-8.4,2.5-16.7,5.2-25.1,7.5C511,818.7,444.1,781.5,377.9,766c-54.5-12.8-114.3-18.1-165.3,4.1S120.7,823.5,63,830",
    fill: "#696e7b"
  }), React__default.createElement("circle", {
    cx: "1056.4",
    cy: "660.8",
    r: "13.6",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M1279.6,683.4a2,2,0,0,1-2-2V666.6a2,2,0,0,1,4,0v14.8A2,2,0,0,1,1279.6,683.4Z",
    fill: "#9599a4"
  }), React__default.createElement("circle", {
    cx: "1279.5",
    cy: "658.4",
    r: "13.6",
    fill: "#9599a4"
  }), React__default.createElement("path", {
    d: "M1354.9,675.8a2,2,0,0,1-2-2V663a2,2,0,0,1,4,0v10.8a2,2,0,0,1-2,2Z",
    fill: "#9599a4"
  }), React__default.createElement("circle", {
    cx: "1354.9",
    cy: "656.9",
    r: "9.9",
    fill: "#9599a4"
  }), React__default.createElement("path", {
    d: "M1415.3,684.7a2,2,0,0,1-2-2V669.1a2,2,0,0,1,4,0v13.6A2,2,0,0,1,1415.3,684.7Z",
    fill: "#9599a4"
  }), React__default.createElement("circle", {
    cx: "1415.3",
    cy: "661.5",
    r: "12.5",
    fill: "#9599a4"
  }), React__default.createElement("circle", {
    cx: "976.5",
    cy: "665.3",
    r: "9.9",
    fill: "#9599a4"
  }), React__default.createElement("circle", {
    cx: 502,
    cy: "792.5",
    r: "10.8",
    fill: "#696e7b"
  }), React__default.createElement("circle", {
    cx: "164.3",
    cy: "786.2",
    r: "10.8",
    fill: "#696e7b"
  }), React__default.createElement("path", {
    d: "M958.9,681a2,2,0,0,1-2-2V665.4a2,2,0,1,1,4,0V679A2,2,0,0,1,958.9,681Z",
    fill: "#9599a4"
  }), React__default.createElement("circle", {
    cx: "958.9",
    cy: "657.8",
    r: "12.5",
    fill: "#9599a4"
  }), React__default.createElement("path", {
    d: "M477.6,802.7a2,2,0,0,1-2-2V785.9a2,2,0,0,1,4,0v14.8A2,2,0,0,1,477.6,802.7Z",
    fill: "#696e7b"
  }), React__default.createElement("circle", {
    cx: "477.6",
    cy: "777.7",
    r: "13.6",
    fill: "#696e7b"
  }), React__default.createElement("path", {
    d: "M1299.5,683.8a2,2,0,0,1-2-2V670.9a2,2,0,0,1,4,0v10.8A2,2,0,0,1,1299.5,683.8Z",
    fill: "#9599a4"
  }), React__default.createElement("circle", {
    cx: "1299.5",
    cy: "664.9",
    r: "9.9",
    fill: "#9599a4"
  }), React__default.createElement("rect", {
    x: "1229.5",
    y: "669.6",
    width: 4,
    height: "10.81",
    fill: "#9599a4"
  }), React__default.createElement("circle", {
    cx: "1231.5",
    cy: "663.5",
    r: "9.9",
    fill: "#9599a4"
  }), React__default.createElement("rect", {
    x: "1075.2",
    y: "669.3",
    width: 4,
    height: "10.81",
    fill: "#9599a4"
  }), React__default.createElement("circle", {
    cx: "1077.2",
    cy: "663.3",
    r: "9.9",
    fill: "#999"
  }), React__default.createElement("path", {
    d: "M899.6,681.7a2,2,0,0,1-2-2V668.8a2,2,0,0,1,4,0v10.8a2,2,0,0,1-2,2Z",
    fill: "#9599a4"
  }), React__default.createElement("circle", {
    cx: "899.6",
    cy: "662.8",
    r: "9.9",
    fill: "#9599a4"
  }), React__default.createElement("path", {
    d: "M420.5,786.8a2,2,0,0,1-2-2v-16a2,2,0,0,1,4,0v16A2,2,0,0,1,420.5,786.8Z",
    fill: "#696e7b"
  }), React__default.createElement("circle", {
    cx: "420.4",
    cy: "759.9",
    r: "14.7",
    fill: "#696e7b"
  }), React__default.createElement("path", {
    d: "M673.1,699.1a308.2,308.2,0,0,1,46.4,7.9c5,1.3,10.2,2.5,15,4.1s6,3.1,9.9,4c1.5.4,3,.7,4.4,1.2s2.4,1.1,3.7,1.7c7.3,3.3,12.6,1.9,19.6-.4a47.1,47.1,0,0,1,20.4-1.8c3.9.5,7.8,1.3,11.7,2s6.6,1.8,10.2,2.4c7.8,1.2,16.2.3,24-.7l21.3-2.5a108.9,108.9,0,0,1,16.9-1.2c7.1.3,14.2,1.9,21.3,1.2,4.3-.4,8.2-1.7,12.4-2.5,9.5-1.9,19.1-.9,28.3,1s18.7,3.5,27.4,5.9A302.9,302.9,0,0,0,1002,729a14,14,0,0,0,3.8.2,14.7,14.7,0,0,0,2.9-.8c7.1-2.4,15.6-2.7,23.4-4,6-1,11.6-2.6,17.4-3.9a141.9,141.9,0,0,1,33-3c11.3.3,20.6,3.4,31.5,4.8,8.1,1,16.9.7,25.1.8a145,145,0,0,0,26.4-2.1c23-4,44.4-5.7,68.2-3.2,6.4.7,12.9,1.5,19.4,1.4,15.1-.3,30.7-5.6,44.6-1.9,10.5,2.8,17.7,10.5,29.2,10.6,8.7.1,15.6-4.4,23.9-6s19.5-2.1,29-3.9,21.8-3.1,33-2c9.4.9,18.6,3.3,28.1,3.4,6.6,0,13.5-.5,19.4-2.2,58.5-17.5,55.2-15.5,84.5-18",
    fill: "url(#linear-gradient-10)"
  }), React__default.createElement("line", {
    x1: "645.8",
    y1: "697.9",
    x2: "1525.2",
    y2: "697.9",
    fill: "none",
    stroke: "#9599a4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), React__default.createElement("path", {
    d: "M189.8,788.2a2,2,0,0,1-2-2v-16a2,2,0,0,1,4,0v16A2,2,0,0,1,189.8,788.2Z",
    fill: "#696e7b"
  }), React__default.createElement("circle", {
    cx: "189.8",
    cy: "761.3",
    r: "14.7",
    fill: "#696e7b"
  }), React__default.createElement("path", {
    d: "M1251.6,173.5H975.7a18.4,18.4,0,0,0-18.4,18.3h0a18.4,18.4,0,0,0,18.4,18.4h175.4a13.6,13.6,0,0,1,1.6,27.1H1002.8a15.7,15.7,0,0,0-15.7,15.7h0a15.7,15.7,0,0,0,15.7,15.7h312.4a15.7,15.7,0,0,0,15.7-15.7h0a15.7,15.7,0,0,0-13.9-15.6h-74.4a13.6,13.6,0,0,1,1.4-27.1h7.5a18.4,18.4,0,0,0,18.3-18.4h0A18.4,18.4,0,0,0,1251.6,173.5Z",
    fill: "url(#linear-gradient-11)"
  }), React__default.createElement("path", {
    d: "M722.9,119.6h-124a7.8,7.8,0,0,1,1.3-15.5h73.8a10.6,10.6,0,0,0,10.5-10.6h0A10.5,10.5,0,0,0,673.9,83H517.7a10.6,10.6,0,0,0-10.5,10.6h0a10.6,10.6,0,0,0,10.5,10.6H523a7.8,7.8,0,0,1,1.3,15.5H465.4a15.4,15.4,0,0,0,0,30.8H722.9a15.4,15.4,0,1,0,.9-30.8h-.9Z",
    fill: "url(#linear-gradient-12)"
  }), React__default.createElement("rect", {
    x: "917.2",
    width: "767.7",
    height: "1078.55",
    fill: "url(#linear-gradient-13)"
  }), React__default.createElement("rect", {
    y: "1.6",
    width: "731.3",
    height: "1076.91",
    fill: "url(#linear-gradient-14)"
  }));
}

var defaultFontFamily = "'Open Sans', sans-serif",
    defaultTheme$1 = {
  fontFamily: defaultFontFamily,
  primary: {
    0: "#0090c7",
    1: "#259ad4",
    2: "#3ea8dd",
    3: "#95cfec",
    4: "#ddf0f9",
    5: "#f3fafd"
  },
  accent: {
    0: "#22a589",
    1: "#40b193",
    2: "#52c1a3",
    3: "#9ddccb",
    4: "#dcf2ec"
  },
  danger: {
    0: "#f41d0c",
    1: "#f5513c",
    2: "#f76e5c",
    3: "#fbb6ad",
    4: "#fef0ee"
  },
  neutralDark: {
    1: "#3a3d44",
    2: "#565656",
    3: "#595E69",
    4: "#696e7a"
  },
  neutralLight: {
    1: "#b0b3bc",
    2: "#c0c3c9",
    3: "#cccccc",
    4: "#d5d7db",
    5: "#eeeeee",
    6: "#f2f9fc",
    7: "#ffffff"
  },
  focusA: "rgba(3,102,214,0.3)",
  focusB: "#259ad4",
  focusShadowA: "0 0 0 0.15em rgba(3,102,214,0.3)",
  focusShadowB: "0 0 0 0.15em #259ad4",
  panelShadowA: "0px 3px 0px 0px rgba(0, 0, 0, 0.1)"
},
    DefaultThemeProvider = function DefaultThemeProvider(e) {
  return React__default.createElement(styled.ThemeProvider, _extends$107({
    theme: defaultTheme$1
  }, e));
};

exports.icons = icons, exports.flags = flags, exports.Alert = Alert$$1, exports.Button = Button, exports.Upload = StyledUpload, exports.ButtonGroup = ButtonGroup, exports.GroupedButton = GroupedButton, exports.TableHeader = TableHeader, exports.TableRow = TableRow, exports.ProgressBar = ProgressBar, exports.Datepicker = StyledDatepicker, exports.Toggle = StyledToggle, exports.Spinner = StyledSpinner, exports.TextInput = TextInput, exports.TextInputLine = TextInputLine, exports.Select = Select$1, exports.Slider = Slider$1, exports.SliderHandleLabel = SliderHandleLabel, exports.Chip = Chip, exports.MiniToggle = MiniToggle, exports.Radio = Radio, exports.RadioGroup = RadioGroup, exports.Checkbox = Checkbox, exports.CheckboxGroup = CheckboxGroup, exports.ModalHeader = ModalHeader, exports.ModalBody = ModalBody, exports.ModalFooter = ModalFooter, exports.ModalCancel = ModalCancel, exports.Tooltip = StyledTooltipSuppressed, exports.Modal = MotionModal, exports.ErrorSplash = ErrorSplash, exports.DefaultThemeProvider = DefaultThemeProvider, exports.defaultTheme = defaultTheme$1;